
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("krHYB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AtlassianNavigation", () => $041dc69d9ed0f77a$export$f66ccb39f60980e5);
$parcel$export(module.exports, "default", () => $041dc69d9ed0f77a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3VeBC = parcelRequire("3VeBC");

var $1E7cT = parcelRequire("1E7cT");

var $8fxTv = parcelRequire("8fxTv");

var $7webZ = parcelRequire("7webZ");

var $1NbhG = parcelRequire("1NbhG");

var $hvTyt = parcelRequire("hvTyt");

var $b6Cd2 = parcelRequire("b6Cd2");

var $arAkG = parcelRequire("arAkG");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jB5IB = parcelRequire("jB5IB");

var $1YbJP = parcelRequire("1YbJP");

var $bkDs8 = parcelRequire("bkDs8");

var $7K4zM = parcelRequire("7K4zM");

var $6FP8W = parcelRequire("6FP8W");

var $10fdS = parcelRequire("10fdS");

var $bNe1g = parcelRequire("bNe1g");

var $gGJaE = parcelRequire("gGJaE");

var $fz8wa = parcelRequire("fz8wa");

var $dWLk9 = parcelRequire("dWLk9");

var $6yplV = parcelRequire("6yplV");

var $1R3n5 = parcelRequire("1R3n5");

var $4mk0R = parcelRequire("4mk0R");

var $lStiz = parcelRequire("lStiz");

var $a5xQG = parcelRequire("a5xQG");

var $9Z519 = parcelRequire("9Z519");

var $1jLSB = parcelRequire("1jLSB");

var $5JiCQ = parcelRequire("5JiCQ");

var $9CrZ4 = parcelRequire("9CrZ4");

var $9BFwJ = parcelRequire("9BFwJ");

var $d6qhr = parcelRequire("d6qhr");

var $cExDy = parcelRequire("cExDy");

var $cMiL9 = parcelRequire("cMiL9");

var $2kyZF = parcelRequire("2kyZF");

var $hsLTt = parcelRequire("hsLTt");

var $1kNcY = parcelRequire("1kNcY");

var $4l7on = parcelRequire("4l7on");

var $h3RP9 = parcelRequire("h3RP9");

var $6jYFH = parcelRequire("6jYFH");

var $4nWiP = parcelRequire("4nWiP");

var $BS0xO = parcelRequire("BS0xO");

var $9bisd = parcelRequire("9bisd");

var $barSP = parcelRequire("barSP");

var $01wSx = parcelRequire("01wSx");

var $7fuB7 = parcelRequire("7fuB7");

var $jKLMK = parcelRequire("jKLMK");

var $8XL09 = parcelRequire("8XL09");
const $041dc69d9ed0f77a$var$RenderNotificationsWithConversationAssistant = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jLSB.ConversationAssistant), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1kNcY.Notifications), null));
const $041dc69d9ed0f77a$var$SearchWithoutProps = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01wSx.Search), null);
const $041dc69d9ed0f77a$var$EditionAwarenessAndSearch = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($041dc69d9ed0f77a$var$EditionAwarenessWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bkDs8.EditionAwareness), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($041dc69d9ed0f77a$var$SearchWithoutProps, null));
const $041dc69d9ed0f77a$var$isSPA = ()=>{
    if (false) return false;
    if (typeof window !== 'undefined') return window.__SPA__;
    return false;
}; // @ts-expect-error - TS2555 - Expected at least 1 arguments, but got 0.
const $041dc69d9ed0f77a$var$testIdPrefix = (0, $1YbJP.testIdGenerate)();
const $041dc69d9ed0f77a$export$f66ccb39f60980e5 = ()=>{
    const topNavSegment = (0, $8fxTv.useNavPerformanceMetrics)();
    topNavSegment.mark((0, $7webZ.NAVIGATION_TOP_MARKS).renderStart);
    const theme = (0, $lStiz.useTheme)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const applicationPermissions = (0, $fz8wa.useApplicationPermissions)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isScreenLocked = (0, $jB5IB.useIsScreenLocked)();
    const showAssets = (0, $cMiL9.useShowAssets)();
    const showRoadmaps = (0, $9bisd.useShowRoadmaps)();
    const PrimaryMenuItemsNav3 = (0, $eUqFw.useMemo)(()=>[
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h3RP9.OpenOverflowMenuForPlansSpotlightObserver), {
                key: "arj-open-overflow-menu-for-plans-spotlight-observer"
            }),
            !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8XL09.YourWorkDropdown), {
                key: "yourWorkDropdown"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $BS0xO.Projects), {
                key: "projects"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9BFwJ.Filters), {
                key: "filters"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9CrZ4.Dashboards), {
                key: "dashboards"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4l7on.People), {
                key: "people"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h3RP9.Plans), {
                key: "plans"
            }),
            showRoadmaps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9bisd.Roadmaps), {
                key: "roadmaps"
            }),
            showAssets && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cMiL9.Insight), {
                key: "insight"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a5xQG.Addons), {
                key: "addons"
            })
        ].filter(Boolean), [
        isAnonymous,
        showAssets,
        showRoadmaps
    ]);
    const renderNavigation = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1E7cT.default), {
            label: formatMessage((0, $hsLTt.default).topNav),
            renderAppSwitcher: (0, $9Z519.AppSwitcher),
            renderProductHome: (0, $6jYFH.ProductHome),
            renderSearch: $041dc69d9ed0f77a$var$SearchWithoutProps,
            renderCreate: (0, $5JiCQ.Create),
            renderEditionAwareness: (0, $bkDs8.EditionAwareness),
            renderHelp: (0, $d6qhr.Help),
            renderNotifications: (0, $1kNcY.Notifications),
            renderConversationAssistant: (0, $1jLSB.ConversationAssistant),
            renderSettings: (0, $7fuB7.Settings),
            renderProfile: (0, $4nWiP.Profile),
            renderSignIn: (0, $jKLMK.SignIn),
            theme: theme
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3VeBC.AtlassianNavigation), {
            primaryItems: PrimaryMenuItemsNav3,
            label: formatMessage((0, $hsLTt.default).topNav),
            moreLabel: formatMessage((0, $hsLTt.default).more),
            renderAppSwitcher: (0, $9Z519.AppSwitcher),
            renderCreate: (0, $5JiCQ.Create),
            renderHelp: (0, $d6qhr.Help),
            renderNotifications: $041dc69d9ed0f77a$var$RenderNotificationsWithConversationAssistant,
            renderProductHome: (0, $6jYFH.ProductHome),
            renderProfile: (0, $4nWiP.Profile),
            renderSearch: $041dc69d9ed0f77a$var$EditionAwarenessAndSearch,
            renderSettings: (0, $7fuB7.Settings),
            renderSignIn: (0, $jKLMK.SignIn),
            theme: theme,
            testId: $041dc69d9ed0f77a$var$testIdPrefix
        }), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !isAnonymous && !(0, $1ybV0.ff)('navigation.disable.prefetched.data.for.dropdowns') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cExDy.InitialDataLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hvTyt.RecommendationLoader), {
            recommendations: (0, $1NbhG.recommendations)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2kyZF.Integrations), null))), [
        PrimaryMenuItemsNav3,
        formatMessage,
        isAnonymous,
        theme
    ]);
    const route = (0, $10fdS.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const projectContext = (0, $bNe1g.useProjectContext)();
    const customData = (0, $eUqFw.useMemo)(()=>{
        if ((0, $eI5EY.fg)('blu-2183_navtopperformancereport_custom_data')) return {
            route: routeName,
            projectType: projectContext?.data?.projectType ?? 'UNKNOWN',
            isSPA: $041dc69d9ed0f77a$var$isSPA()
        };
        return undefined;
    }, [
        routeName,
        projectContext
    ]);
    if (isScreenLocked) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4mk0R.NavigationSuccessTracker), null, isAnonymous ? renderNavigation() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGJaE.RecentsContainer), {
        isGlobal: true,
        cloudId: cloudId,
        applicationPermissions: applicationPermissions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $arAkG.FavoritesContainer), {
        isGlobal: true,
        applicationPermissions: applicationPermissions
    }, renderNavigation()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $barSP.NavigationRouterListener), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopPerformanceMark), {
        metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopPerformanceReport), {
        customData: customData
    }), isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b6Cd2.default), null), (0, $eI5EY.fg)('jira_nav4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7K4zM.default), null));
};
var $041dc69d9ed0f77a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $041dc69d9ed0f77a$export$f66ccb39f60980e5;
const $041dc69d9ed0f77a$var$EditionAwarenessWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxpxbi _j2s1glyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1E7cT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0477cba3b9056c1d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

const $0477cba3b9056c1d$var$LazyAtlaskitAtlassianNavigationNav4 = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("hX1YA")).then(({ AtlaskitAtlassianNavigationNav4: AtlaskitAtlassianNavigationNav4 })=>AtlaskitAtlassianNavigationNav4), {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation-nav4/src/index.tsx"
});
const $0477cba3b9056c1d$var$AsyncAtlaskitAtlassianNavigationNav4 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncAtlaskitAtlassianNavigationNav4",
        packageName: "jiraAtlassianNavigationNav4",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "nav4.topNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazyAtlaskitAtlassianNavigationNav4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0477cba3b9056c1d$var$LazyAtlaskitAtlassianNavigationNav4, props)))));
$0477cba3b9056c1d$var$AsyncAtlaskitAtlassianNavigationNav4.displayName = 'AsyncAtlaskitAtlassianNavigationNav4';
var $0477cba3b9056c1d$export$2e2bcd8739ae039 = $0477cba3b9056c1d$var$AsyncAtlaskitAtlassianNavigationNav4;

});
parcelRegister("hX1YA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("3eLkY")
]).then(()=>parcelRequire('7op3B'));

});


parcelRegister("1NbhG", function(module, exports) {

$parcel$export(module.exports, "recommendations", () => $cc11e188927c7b52$export$b7e5cef71fa42514);

var $8fywv = parcelRequire("8fywv");

var $kGeZa = parcelRequire("kGeZa");


const $cc11e188927c7b52$var$createRecommendationsList = ()=>{
    const recommendationsList = [];
    recommendationsList.push((0, $8fywv.default));
    recommendationsList.push((0, $kGeZa.default));
    // Add your own templates
    return recommendationsList;
};
const $cc11e188927c7b52$export$b7e5cef71fa42514 = $cc11e188927c7b52$var$createRecommendationsList();

});
parcelRegister("8fywv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c109c56af0186e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l3nfS = parcelRequire("l3nfS");

var $fbeIa = parcelRequire("fbeIa");

var $7u4fN = parcelRequire("7u4fN");

var $d3fGG = parcelRequire("d3fGG");

var $ffiyv = parcelRequire("ffiyv");

var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dxcfv = parcelRequire("dxcfv");

var $3e9vj = parcelRequire("3e9vj");

var $a0eNT = parcelRequire("a0eNT");

var $gQgs0 = parcelRequire("gQgs0");

var $8PDmJ = parcelRequire("8PDmJ");

var $6CO3R = parcelRequire("6CO3R");

var $8tyzM = parcelRequire("8tyzM");

var $kh69L = parcelRequire("kh69L");

var $aYr7q = parcelRequire("aYr7q");

var $1HUWn = parcelRequire("1HUWn");

var $4xkjz = parcelRequire("4xkjz");

var $QUGYQ = parcelRequire("QUGYQ");

var $iUJbb = parcelRequire("iUJbb");
const $c109c56af0186e50$export$da956fe610b96f73 = ()=>{
    const [moreInformationModal, setMoreInformationModal] = (0, $eUqFw.useState)(false);
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $a0eNT.useFireCrossFlowAnalyticsEvents)();
    const [, { setRecommendationDismissal: setRecommendationDismissal }] = (0, $kh69L.useProjectMenuRecommendations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const accountId = (0, $dxcfv.useAccountId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const crossFlow = (0, $fbeIa.useCrossFlow)();
    const environment = (0, $3e9vj.useEnvironment)();
    const jpdCloudCCPProductID = (0, $4xkjz.getProductTypeCcpReferenceIdMapForEnv)(environment).PRODUCT_DISCOVERY;
    (0, $eUqFw.useEffect)(()=>{
        if (crossFlow.isEnabled) fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsMenu'
        }, {
            recommendedProductIds: [
                jpdCloudCCPProductID
            ],
            source: 'projectsMenuSection'
        });
        else (0, $guiFP.default)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraAtlassianNavigationRecommendations'
            }
        });
    }, [
        createAnalyticsEvent,
        crossFlow,
        fireViewedUIEvent,
        jpdCloudCCPProductID
    ]);
    const openCrossFlow = (0, $eUqFw.useCallback)(async (templateId)=>{
        const extensions = (0, $l3nfS.createProvisioningPageExtensions)({
            actions: {
                primary: {
                    behaviour: (0, $l3nfS.Behaviours).LAND,
                    prompt: (0, $l3nfS.Prompts).NEXT,
                    options: {
                        targetTab: (0, $l3nfS.TargetTabs).SAME,
                        urlParams: {
                            templateId: templateId
                        }
                    }
                }
            }
        });
        if (crossFlow.isEnabled) crossFlow.api.open({
            journey: (0, $fbeIa.Journeys).GET_STARTED,
            targetProduct: (0, $fbeIa.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'projectsMenuSection',
            sourceContext: 'tryThisRecommendation',
            extensions: extensions
        });
    }, [
        crossFlow
    ]);
    const onRecommendationClicked = (0, $eUqFw.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryThisRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        openCrossFlow((0, $4xkjz.JPD_KEY));
    }, [
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        openCrossFlow
    ]);
    const onLearnMoreClicked = (0, $eUqFw.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        setMoreInformationModal(true);
    }, [
        fireInteractedUIEvent,
        jpdCloudCCPProductID
    ]);
    const onLearnMoreClosed = (0, $eUqFw.useCallback)(()=>{
        setMoreInformationModal(false);
    }, []);
    const onDismissClicked = (0, $eUqFw.useCallback)(()=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'dismissRecommendation'
        }, {
            source: 'projectsMenuSection',
            targetProductId: jpdCloudCCPProductID,
            recommendedProductIds: [
                jpdCloudCCPProductID
            ]
        });
        setRecommendationDismissal();
        if (accountId) (0, $48bs8.setUserProperties)(accountId, (0, $4xkjz.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY), 'true').catch((error)=>(0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'dismissJpdRecommendation',
                    packageName: 'jiraAtlassianNavigationRecommendations',
                    teamName: 'navigation'
                }
            }));
    }, [
        accountId,
        fireInteractedUIEvent,
        jpdCloudCCPProductID,
        setRecommendationDismissal
    ]);
    const onClickPrivacyPolicy = (0, $eUqFw.useCallback)(()=>{
        const clickedLinkBaseEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $jMP2a.fireUIAnalytics)(clickedLinkBaseEvent, 'adControlsPrivacyPolicy');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQgs0.RecommendationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PDmJ.RecommendationHeader), {
        title: formatMessage((0, $QUGYQ.default).recommendedText),
        onDismissClicked: onDismissClicked,
        onLearnMoreClicked: onLearnMoreClicked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6CO3R.RecommendationMenuItem), {
        title: formatMessage((0, $QUGYQ.default).projectTitle),
        description: formatMessage((0, $QUGYQ.default).projectDescription),
        onClick: onRecommendationClicked,
        lozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new",
            isBold: false
        }, formatMessage((0, $QUGYQ.default).lozengeText)),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            xcss: $c109c56af0186e50$var$logoStyles,
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d3fGG.JiraProductDiscoveryIcon), {
            appearance: "brand",
            size: "small"
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8tyzM.RecommendationModal), {
        isOpen: moreInformationModal,
        onClose: onLearnMoreClosed,
        title: formatMessage((0, $QUGYQ.default).reasonsModalTitle),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $QUGYQ.default).reasonsModalExplanation, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                    as: "strong"
                }, chunks)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, formatMessage((0, $QUGYQ.default).reasonsModalBulletOneSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, formatMessage((0, $QUGYQ.default).reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            spacing: "none",
            href: (0, $4xkjz.DATA_PRIVACY_LINK),
            target: "_blank",
            onClick: onClickPrivacyPolicy
        }, formatMessage((0, $QUGYQ.default).privacyPolicy))),
        primaryCta: formatMessage((0, $QUGYQ.default).reasonsModalButtonOk)
    }));
};
const $c109c56af0186e50$var$logoStyles = (0, $1ZAYh.xcss)({
    width: '28px',
    height: '28px',
    borderRadius: 'border.radius.100',
    backgroundColor: 'color.background.neutral'
});
const $c109c56af0186e50$var$checkEligibility = async (recommendationContext, analyticsEvent)=>{
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled, licensedProducts: licensedProducts, canCreateProject: canCreateProject, accountId: accountId, cloudId: cloudId, environment: environment } = recommendationContext;
    if (!areProductSuggestionsEnabled) return {
        isEligible: false,
        reason: 'Product suggestions are disabled'
    };
    if ((0, $iUJbb.hasJpdLicense)(licensedProducts)) return {
        isEligible: false,
        reason: 'Instance has JPD license'
    };
    if (!canCreateProject) return {
        isEligible: false,
        reason: 'User cannot create projects'
    };
    const [dismissed, appRecommendations] = await Promise.all([
        (0, $48bs8.getUserProperty)(accountId, (0, $4xkjz.JPD_RECOMMENDATION_DISMISS_USER_PROPERTY)).catch((error)=>{
            if (error.statusCode === 404) return false;
            throw Error(`${error.statusCode}, JPD recommendation dismissal failed. ${error.name}: ${error.message}`, error);
        }),
        (0, $1HUWn.fetchAppRecommendations)(cloudId, environment, analyticsEvent)
    ]);
    if (dismissed) return {
        isEligible: false,
        reason: 'JPD recommendation dismissed'
    };
    if (!appRecommendations?.some((recommendation)=>recommendation?.entityId === (0, $4xkjz.JPD_ENTITY_ID))) return {
        isEligible: false,
        reason: 'JPD was not in the recommend apps'
    };
    return {
        isEligible: true,
        reason: 'Pass all checks'
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c109c56af0186e50$export$2e2bcd8739ae039 = {
    key: (0, $4xkjz.JPD_RECOMMENDATION_KEY),
    shouldRender: async (recommendationContext, analyticsEvent)=>{
        (0, $aYr7q.projectsMenuDropdownLoadJpdRecommendation).start();
        const { isEligible: isEligible, reason: reason } = await $c109c56af0186e50$var$checkEligibility(recommendationContext, analyticsEvent);
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJpdRecommendation succeeded', {
            reason: reason,
            isEligible: isEligible
        });
        (0, $aYr7q.projectsMenuDropdownLoadJpdRecommendation).success();
        return isEligible;
    },
    onLoadError: (error)=>{
        (0, $aYr7q.projectsMenuDropdownLoadJpdRecommendation).failure();
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'loadJpdRecommendation',
                packageName: 'jiraAtlassianNavigationRecommendations',
                teamName: 'navigation'
            }
        });
    },
    Component: $c109c56af0186e50$export$da956fe610b96f73
};

});
parcelRegister("gQgs0", function(module, exports) {

$parcel$export(module.exports, "RecommendationContainer", () => $5d64138590550fce$export$97f31f44c68c1d5);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");

var $8WuJm = parcelRequire("8WuJm");
const $5d64138590550fce$export$97f31f44c68c1d5 = ({ children: children, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: true
    }, children));

});

parcelRegister("8PDmJ", function(module, exports) {

$parcel$export(module.exports, "RecommendationHeader", () => $29878caa9d991517$export$3beeaceb068c75b1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $jG1wZ = parcelRequire("jG1wZ");

var $bULPy = parcelRequire("bULPy");
var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4IRKS = parcelRequire("4IRKS");
const $29878caa9d991517$export$3beeaceb068c75b1 = ({ title: title, onDismissClicked: onDismissClicked, onLearnMoreClicked: onLearnMoreClicked })=>{
    const [isActionsMenuOpen, setIsActionsMenuOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $29878caa9d991517$var$HeadingItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h100" // @ts-expect-error Property 'css' does not exist on type 'IntrinsicAttributes & HeadingPropsBase & { color?: "default" | "inverse" | undefined; level: "h900" | "h800" | "h700" | "h600" | "h500" | "h400" | "h300" | "h200" | "h100"; size?: undefined; }'.ts(2322)
        ,
        className: (0, $7JEyt.default)([
            "_syaz1kw7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $29878caa9d991517$var$TitleItemStyles
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isActionsMenuOpen,
        placement: "bottom-start",
        onClose: ()=>setIsActionsMenuOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), {
                onClick: (e)=>e.stopPropagation()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
                onClick: onDismissClicked
            }, formatMessage((0, $4IRKS.default).dismissButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
                onClick: onLearnMoreClicked
            }, formatMessage((0, $4IRKS.default).learnMoreButtonText)))),
        shouldUseCaptureOnOutsideClick: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29878caa9d991517$var$MeatballMenuTrigger, {
                ...triggerProps,
                appearance: "subtle",
                onClick: ()=>setIsActionsMenuOpen(()=>!isActionsMenuOpen),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    size: "medium",
                    label: "more"
                })
            })
    }));
};
const $29878caa9d991517$var$styles = null;
const $29878caa9d991517$var$HeadingItemStyles = (0, $1ZAYh.xcss)({
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    marginTop: 'space.050'
});
const $29878caa9d991517$var$TitleItemStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.gray',
    textTransform: 'uppercase'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $29878caa9d991517$var$MeatballMenuTrigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbzwfg _4t3izwfg _1di67btw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4IRKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bfe8faac40b99$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cf8bfe8faac40b99$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    learnMoreButtonText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.learn-more-button-text",
        "defaultMessage": "Why am I seeing this?"
    },
    dismissButtonText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    dismissConfirmationText: {
        "id": "atlassian-navigation-recommendations.common.recommendation-section.recommendation-header.dismiss-confirmation-text",
        "defaultMessage": "You won't be seeing this here anymore"
    }
});

});


parcelRegister("6CO3R", function(module, exports) {

$parcel$export(module.exports, "RecommendationMenuItem", () => $52eab1bfb6a90010$export$aab9ce3de285230c);

var $eUqFw = parcelRequire("eUqFw");

var $bo4OB = parcelRequire("bo4OB");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
const $52eab1bfb6a90010$export$aab9ce3de285230c = ({ iconBefore: iconBefore, onClick: onClick, title: title, lozenge: lozenge = null, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        iconBefore: iconBefore,
        onClick: onClick,
        description: description,
        href: "#"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100"
    }, title, lozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, lozenge)));

});

parcelRegister("8tyzM", function(module, exports) {

$parcel$export(module.exports, "RecommendationModal", () => $be90114e25c7d7c3$export$d5c06ba24e862b67);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $1Yimi = parcelRequire("1Yimi");
const $be90114e25c7d7c3$export$d5c06ba24e862b67 = ({ isOpen: isOpen, onClose: onClose, title: title, body: body, primaryCta: primaryCta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        shouldCloseOnEscapePress: true,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onClose
    }, primaryCta))));

});

parcelRegister("kh69L", function(module, exports) {

$parcel$export(module.exports, "useProjectMenuRecommendations", () => $9e0dff99537b6ae1$export$d4048a5b8ab1acff);

var $WBLbN = parcelRequire("WBLbN");

var $2XJc3 = parcelRequire("2XJc3");
const $9e0dff99537b6ae1$var$initialState = {
    status: 'idle'
};
const $9e0dff99537b6ae1$var$store = (0, $WBLbN.createStore)({
    actions: $2XJc3.actions,
    initialState: $9e0dff99537b6ae1$var$initialState,
    name: 'atlassian-navigation-recommendation'
});
const $9e0dff99537b6ae1$export$d4048a5b8ab1acff = (0, $WBLbN.createHook)($9e0dff99537b6ae1$var$store);

});
parcelRegister("2XJc3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $aadb5cf357ae73a9$export$e324594224ef24da);

var $aqjZk = parcelRequire("aqjZk");
const $aadb5cf357ae73a9$export$e95368803793838f = (recommendations, recommendationContext, analyticsEvent)=>async ({ getState: getState, setState: setState })=>{
        const { status: status } = getState();
        if (status !== 'idle') return;
        setState({
            status: 'loading'
        });
        const shuffledRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($aqjZk)))(recommendations);
        try {
            const recommendationStatus = await Promise.all(shuffledRecommendations.map(async (recommendation)=>{
                let isEnabled = false;
                try {
                    isEnabled = await recommendation.shouldRender(recommendationContext, analyticsEvent);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    recommendation.onLoadError(error);
                }
                return {
                    key: recommendation.key,
                    isEnabled: isEnabled
                };
            }));
            const selectedRecommendation = recommendationStatus.find((result)=>result.isEnabled);
            setState({
                status: 'success',
                recommendationKey: selectedRecommendation?.key || null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                status: 'error',
                error: error
            });
        }
    };
const $aadb5cf357ae73a9$var$setRecommendationDismissal = ()=>({ setState: setState })=>{
        setState({
            recommendationKey: null
        });
    };
const $aadb5cf357ae73a9$export$e324594224ef24da = {
    loadRecommendations: $aadb5cf357ae73a9$export$e95368803793838f,
    setRecommendationDismissal: $aadb5cf357ae73a9$var$setRecommendationDismissal
};

});


parcelRegister("aYr7q", function(module, exports) {

$parcel$export(module.exports, "projectsMenuDropdownRecommendationSelector", () => $ab831842235d3342$export$2b83859c1548ffb5);
$parcel$export(module.exports, "projectsMenuDropdownLoadJpdRecommendation", () => $ab831842235d3342$export$a784c5bbb21ea554);
$parcel$export(module.exports, "projectsMenuDropdownLoadJwmSampleProjectRecommendation", () => $ab831842235d3342$export$901fa2452d4f9051);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $ab831842235d3342$export$2b83859c1548ffb5 = new (0, $kDfSL.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $ab831842235d3342$export$a784c5bbb21ea554 = new (0, $kDfSL.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $ab831842235d3342$export$901fa2452d4f9051 = new (0, $kDfSL.UFOExperience)('projects-menu-dropdown.load-jwm-sample-project-recommendation', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("1HUWn", function(module, exports) {

$parcel$export(module.exports, "fetchAppRecommendations", () => $fbfbededde88b419$export$8665956217263d00);

var $47Gvp = parcelRequire("47Gvp");

var $iWLL0 = parcelRequire("iWLL0");

var $jMP2a = parcelRequire("jMP2a");


var $7Kcij = parcelRequire("7Kcij");
const $fbfbededde88b419$export$f2d50cdc12f57d0b = (0, $47Gvp.default);
const $fbfbededde88b419$export$8665956217263d00 = async (cloudId, environment, analyticsEvent)=>{
    const appRecommendationState = (0, $7Kcij.getCachedAppRecommendationState)();
    if (appRecommendationState !== null && Date.now() - appRecommendationState.fetchRecommendationTimeStamp < (0, $cefbd5c410474f76$export$424ba99fce04562)) return appRecommendationState.appRecommendations ?? [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const data = await (0, $iWLL0.fetchQuery)(environment, $fbfbededde88b419$export$f2d50cdc12f57d0b, {
        cloudId: cloudId
    }).toPromise().catch((err)=>{
        throw Error(`App recommendation ${err.name} error: ${err.message}`, {
            cause: err
        });
    });
    const appRecommendations = data?.growthRecommendations?.recommendations?.data;
    if (!appRecommendations) (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.fetchAppRecommendations empty', {
        response: `${JSON.stringify(data)}`
    });
    (0, $7Kcij.setCachedAppRecommendationState)({
        appRecommendations: appRecommendations,
        fetchRecommendationTimeStamp: Date.now()
    });
    return appRecommendations ?? [];
};

});
parcelRegister("47Gvp", function(module, exports) {

$parcel$export(module.exports, "default", () => $36177bf032cbf4e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63d29fc2e4b7b13b5431ad6d77aafb97>>
 * @relayHash e631e61cba47acbda6811ed1a287d9f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86
const $36177bf032cbf4e8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "product",
                    "value": "jira"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "jiraProjectMenuRecommendations"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchAppRecommendationsV2Query",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v2 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "growthRecommendations.recommendations.data.entityId"
                                                        }
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchAppRecommendationsV2Query",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ],
                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "GrowthRecRecommendations"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "620b7134d06fa893e7db6526963c4d8afbe3dc9c5b0428d93f35a2c73fa2ea86",
            "metadata": {},
            "name": "fetchAppRecommendationsV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$36177bf032cbf4e8$var$node.hash = "eaaab66d3f41b01ce8e8a969a422ff60";
var $36177bf032cbf4e8$export$2e2bcd8739ae039 = $36177bf032cbf4e8$var$node;

});

const $cefbd5c410474f76$export$424ba99fce04562 = 600000;

parcelRegister("7Kcij", function(module, exports) {

$parcel$export(module.exports, "setCachedAppRecommendationState", () => $dd1491895f239057$export$4bb2da71ae03947f);
$parcel$export(module.exports, "getCachedAppRecommendationState", () => $dd1491895f239057$export$951c5f8396f4dcb);

var $aZaPn = parcelRequire("aZaPn");
const $dd1491895f239057$var$store = (0, $aZaPn.createLocalStorageProvider)('projects-menu-jpd-recommendation');
const $dd1491895f239057$var$APP_RECOMMENDATION_STATE = 'app-recommendation-state';
function $dd1491895f239057$export$4bb2da71ae03947f(appRecommendationState) {
    $dd1491895f239057$var$store.set($dd1491895f239057$var$APP_RECOMMENDATION_STATE, JSON.stringify(appRecommendationState));
}
function $dd1491895f239057$export$951c5f8396f4dcb() {
    const state = $dd1491895f239057$var$store.get($dd1491895f239057$var$APP_RECOMMENDATION_STATE);
    return state ? JSON.parse(state) : null;
}
function $dd1491895f239057$export$a73955031198b1b8() {
    $dd1491895f239057$var$store.remove($dd1491895f239057$var$APP_RECOMMENDATION_STATE);
}

});


parcelRegister("4xkjz", function(module, exports) {

$parcel$export(module.exports, "JPD_RECOMMENDATION_KEY", () => $6fcb06fcbb9f7c97$export$3e6ff24c4f517c4f);
$parcel$export(module.exports, "JPD_KEY", () => $6fcb06fcbb9f7c97$export$a9c4e38d8a74acd2);
$parcel$export(module.exports, "JPD_RECOMMENDATION_DISMISS_USER_PROPERTY", () => $6fcb06fcbb9f7c97$export$52b9dedc0088f8);
$parcel$export(module.exports, "DATA_PRIVACY_LINK", () => $6fcb06fcbb9f7c97$export$aefe1c8741b24a28);
$parcel$export(module.exports, "JPD_ENTITY_ID", () => $6fcb06fcbb9f7c97$export$909712ccf16883d);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $6fcb06fcbb9f7c97$export$29629758934356a6);

var $8fAH0 = parcelRequire("8fAH0");
const $6fcb06fcbb9f7c97$export$3e6ff24c4f517c4f = 'jpd-recommendation';
const $6fcb06fcbb9f7c97$export$a9c4e38d8a74acd2 = 'jpd.product-discovery';
const $6fcb06fcbb9f7c97$export$52b9dedc0088f8 = 'JpdRecommendationDismissed';
const $6fcb06fcbb9f7c97$export$24de1334acd05ac2 = 'RecommendJpdInProjectsMenuKey';
const $6fcb06fcbb9f7c97$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
const $6fcb06fcbb9f7c97$export$32601d21b6bdcb50 = 'recommending_jpd_in_projects_menu';
const $6fcb06fcbb9f7c97$export$909712ccf16883d = 'jira.polaris:discovery';
const $6fcb06fcbb9f7c97$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $8fAH0.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("QUGYQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa9d831448b3dd17$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fa9d831448b3dd17$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    learnMoreButtonText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.learn-more-button-text",
        "defaultMessage": "Why am I seeing this?"
    },
    projectDescription: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-description",
        "defaultMessage": "Capture ideas with Jira Product Discovery"
    },
    lozengeText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.lozenge-text",
        "defaultMessage": "try"
    },
    dismissButtonText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-button-text",
        "defaultMessage": "Not interested"
    },
    recommendedText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.recommended-text",
        "defaultMessage": "Recommended"
    },
    dismissConfirmationTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-title",
        "defaultMessage": "Got it, thanks for letting us know"
    },
    dismissConfirmationText: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.dismiss-confirmation-text",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    projectTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.project-title",
        "defaultMessage": "New discovery project"
    },
    reasonsModalTitle: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOneSpork: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-one-spork",
        "defaultMessage": "the tools you use (Jira)"
    },
    reasonsModalBulletTwo: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-bullet-two",
        "defaultMessage": "the way you use your existing tools and products"
    },
    privacyPolicy: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    reasonsModalButtonOk: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok",
        "defaultMessage": "Ok"
    },
    reasonsModalButtonOkCapitalised: {
        "id": "atlassian-navigation-recommendations.jpd-recommendation.reasons-modal-button-ok-capitalised",
        "defaultMessage": "OK"
    }
});

});

parcelRegister("iUJbb", function(module, exports) {

$parcel$export(module.exports, "hasJpdLicense", () => $bdae8aa60a4ee1cb$export$2ea69a0925803655);
const $bdae8aa60a4ee1cb$export$2ea69a0925803655 = (licensedProducts)=>licensedProducts['jira-product-discovery'] === true;

});


parcelRegister("kGeZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8484da1c5476c658$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $d2wNG = parcelRequire("d2wNG");

var $ffiyv = parcelRequire("ffiyv");

var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $e91YZ = parcelRequire("e91YZ");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6WXNs = parcelRequire("6WXNs");

var $l2o0I = parcelRequire("l2o0I");

var $gQgs0 = parcelRequire("gQgs0");

var $8PDmJ = parcelRequire("8PDmJ");

var $6CO3R = parcelRequire("6CO3R");

var $8tyzM = parcelRequire("8tyzM");

var $kh69L = parcelRequire("kh69L");

var $aYr7q = parcelRequire("aYr7q");

var $iomcV = parcelRequire("iomcV");


var $4Okch = parcelRequire("4Okch");
const $8484da1c5476c658$export$1a4d033f2094f608 = ()=>{
    const [moreInformationModal, setMoreInformationModal] = (0, $eUqFw.useState)(false);
    const [, { setRecommendationDismissal: setRecommendationDismissal }] = (0, $kh69L.useProjectMenuRecommendations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown viewed', 'projectsMenuRecommendationDropdown');
    }, [
        createAnalyticsEvent
    ]);
    const createSampleProjectClicked = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), 'jwmSampleProjectExperimentCreateProjectButton');
        $8484da1c5476c658$var$createJwmSampleProject(showFlag);
    }, [
        createAnalyticsEvent,
        showFlag
    ]);
    const onLearnMoreClicked = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), 'explainButton');
        setMoreInformationModal(true);
    }, [
        createAnalyticsEvent
    ]);
    const onLearnMoreLinkClicked = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'link',
            action: 'clicked'
        }), 'jwmSampleProjectLink');
    }, [
        createAnalyticsEvent
    ]);
    const onLearnMoreClosed = (0, $eUqFw.useCallback)(()=>{
        setMoreInformationModal(false);
    }, []);
    const onDismissClicked = (0, $eUqFw.useCallback)(()=>{
        setRecommendationDismissal();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), 'jwmSampleProjectExperimentDismissButton');
        showFlag({
            type: 'success',
            isAutoDismiss: true,
            title: formatMessage((0, $4Okch.default).dismissConfirmationTitle),
            description: formatMessage((0, $4Okch.default).dismissConfirmationText)
        });
    }, [
        createAnalyticsEvent,
        setRecommendationDismissal,
        showFlag,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gQgs0.RecommendationContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PDmJ.RecommendationHeader), {
        title: formatMessage((0, $4Okch.default).trySampleSectionHeader),
        onDismissClicked: onDismissClicked,
        onLearnMoreClicked: onLearnMoreClicked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6CO3R.RecommendationMenuItem), {
        title: formatMessage((0, $4Okch.default).ctaHeadingText),
        description: formatMessage((0, $4Okch.default).ctaDescriptionText),
        onClick: createSampleProjectClicked,
        lozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new",
            isBold: false
        }, formatMessage((0, $4Okch.default).lozengeText)),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            xcss: $8484da1c5476c658$var$logoStyles,
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2o0I.SampleProjectAvatar), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8tyzM.RecommendationModal), {
        isOpen: moreInformationModal,
        onClose: onLearnMoreClosed,
        title: formatMessage((0, $4Okch.default).modalTitle),
        body: formatMessage((0, $4Okch.default).modalBodySpork, {
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null),
            link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "https://www.atlassian.com/software/jira/work-management",
                target: "_blank",
                onClick: onLearnMoreLinkClicked
            }, formatMessage((0, $4Okch.default).learnMoreLinkSpork))
        }),
        primaryCta: formatMessage((0, $4Okch.default).modalCta)
    }));
};
const $8484da1c5476c658$var$logoStyles = (0, $1ZAYh.xcss)({
    width: '28px',
    height: '28px'
});
const $8484da1c5476c658$var$checkEligibility = async (recommendationContext)=>{
    const { licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, edition: edition, canCreateProject: canCreateProject, accountId: accountId, cloudId: cloudId } = recommendationContext;
    if (!licensedProducts?.[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE]) return {
        isEligible: false,
        reason: 'User does not have jira software'
    };
    if (edition === (0, $6WXNs.UNLICENSED)) return {
        isEligible: false,
        reason: 'User is unlicensed'
    };
    if (!canCreateProject) return {
        isEligible: false,
        reason: 'User cannot create projects'
    };
    const [userTraits, siteTraits] = await Promise.all([
        (0, $iomcV.fetchUserTraits)(cloudId, accountId),
        (0, $iomcV.fetchSiteTraits)(cloudId)
    ]);
    if (userTraits.some((trait)=>trait.name === (0, $6ccfb4ac3724893c$export$ce71307e913afd12) && trait.value)) return {
        isEligible: false,
        reason: `User has trait ${0, $6ccfb4ac3724893c$export$ce71307e913afd12}`
    };
    if (userTraits.some((trait)=>trait.name === (0, $6ccfb4ac3724893c$export$fc53f723f5163588) && trait.value)) return {
        isEligible: false,
        reason: `User has trait ${0, $6ccfb4ac3724893c$export$fc53f723f5163588}`
    };
    if (userTraits.some((trait)=>trait.name === (0, $6ccfb4ac3724893c$export$a1a2e9d60f36ed80) && trait.value)) return {
        isEligible: false,
        reason: `User has trait ${0, $6ccfb4ac3724893c$export$a1a2e9d60f36ed80}`
    };
    if (!firstActivationDateMs) return {
        isEligible: false,
        reason: 'firstActivationDateMs is undefined'
    };
    if ((0, $d2wNG.default)(new Date(), firstActivationDateMs) > 28 && userTraits.some((trait)=>trait.name === (0, $6ccfb4ac3724893c$export$a92ddfff80995acf) && (0, $d2wNG.default)(new Date(), new Date(trait.value)) > 28)) return {
        isEligible: false,
        reason: 'Experiment dropdown date trait is older than 28 days'
    };
    if ((0, $d2wNG.default)(new Date(), firstActivationDateMs) > 28 && !siteTraits.some(({ name: name, value: value })=>name === (0, $6ccfb4ac3724893c$export$9365f74cb008dc7c) && value)) return {
        isEligible: false,
        reason: 'User activation date is greater than 28 days and JSW to JWM ML trait is not set'
    };
    return {
        isEligible: true,
        reason: 'Pass all checks'
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8484da1c5476c658$export$2e2bcd8739ae039 = {
    key: (0, $6ccfb4ac3724893c$export$4e0e125b835dc0d),
    shouldRender: async (recommendationContext, analyticsEvent)=>{
        (0, $aYr7q.projectsMenuDropdownLoadJwmSampleProjectRecommendation).start();
        const { isEligible: isEligible, reason: reason } = await $8484da1c5476c658$var$checkEligibility(recommendationContext);
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'jiraAtlassianNavigation.loadJwmSampleProjectRecommendation succeeded', {
            isEligible: isEligible,
            reason: reason
        });
        (0, $aYr7q.projectsMenuDropdownLoadJwmSampleProjectRecommendation).success();
        return isEligible;
    },
    onLoadError: (error)=>{
        (0, $aYr7q.projectsMenuDropdownLoadJwmSampleProjectRecommendation).failure();
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'loadJwmSampleProjectRecommendation',
                packageName: 'jiraAtlassianNavigationRecommendations',
                teamName: 'navigation'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    },
    Component: $8484da1c5476c658$export$1a4d033f2094f608
};
const $8484da1c5476c658$var$jwmSampleProjectUrlWithOriginSource = (taskId, originSource)=>`/jira/core/sample/onboarding/${taskId}?originSource=moon-${originSource}`;
const $8484da1c5476c658$var$createJwmSampleProject = async (showFlag)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)((0, $6ccfb4ac3724893c$export$7b412f30d02cee13));
        if (response?.taskId) window.open($8484da1c5476c658$var$jwmSampleProjectUrlWithOriginSource(response.taskId, (0, $6ccfb4ac3724893c$export$63fbd2796586b8eb)));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'createJwmSampleProjectService',
                packageName: (0, $6ccfb4ac3724893c$export$b8b9d90f9e5bd72b),
                teamName: 'navigation'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        showFlag({
            key: (0, $eo17r.toFlagId)((0, $6ccfb4ac3724893c$export$529244c5c5612bf2)),
            type: 'error',
            title: (0, $4Okch.default).errorFlagTitle,
            description: (0, $4Okch.default).errorFlagText
        });
        return error;
    }
};

});
parcelRegister("l2o0I", function(module, exports) {

$parcel$export(module.exports, "SampleProjectAvatar", () => $b52ef74d72874ae5$export$b8d1b0731803f79e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");
const $b52ef74d72874ae5$export$b8d1b0731803f79e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        primaryColor: "#00C7E6",
        size: "medium",
        label: "test"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Page-1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        transform: "matrix(0.254436, 0, 0, 0.252786, -5.761572, 0.007035)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "project_avatar_plane"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "plane"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        id: "Rectangle",
        x: "0",
        y: "0",
        width: "128",
        height: "128",
        transform: "matrix(1, 0, 0, 1, 0, 0)",
        fill: "#00C7E6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M68.101,74.324 L44.671,97.754 L73.279,130.588 C73.279,130.588 92.075,138.572 96.55,136.575 L68.101,74.324 Z",
        id: "Shape",
        fill: "#2A5083",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M84.991,80.553 L92.112,87.674 C93.444,89.006 93.444,91.186 92.112,92.518 L75.49,109.141 C72.199,112.432 66.815,112.432 63.525,109.141 L63.525,109.141 C60.234,105.85 60.234,100.466 63.525,97.176 L80.147,80.554 C81.479,79.221 83.659,79.221 84.991,80.553 Z",
        id: "Shape",
        fill: "#DEEBFF",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M84.991,80.553 L88.552,84.114 L63.525,109.141 C60.234,105.85 60.234,100.466 63.525,97.176 L80.147,80.554 C81.479,79.221 83.659,79.221 84.991,80.553 Z",
        id: "Shape",
        fill: "#194063",
        fillRule: "nonzero",
        opacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M-0.498,55.283 L28.325,80.937 L51.755,57.507 L-3.36,33.539 C-3.36,33.539 0.359,49.035 -0.498,55.283 Z",
        id: "Shape",
        fill: "#2A5083",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M101.639,24.782 C95.065,18.207 79.54,23.071 66.966,35.646 L-3.8,104.412 C-0.71,109.906 -7.835,125.894 -3.324,130.231 L102.759,26.148 C102.431,25.659 102.059,25.201 101.639,24.782 Z",
        id: "Shape",
        fill: "#FFFFFF",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M-2.536,128.037 C1.44,132.069 9.95,132.567 14.874,135.437 L90.856,59.455 C103.431,46.88 108.295,31.356 101.721,24.781 L-2.536,128.037 Z",
        id: "Shape",
        fill: "#DEEBFF",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M45.639,41.201 L38.518,34.08 C37.186,32.748 35.006,32.748 33.674,34.08 L17.051,50.702 C13.76,53.993 13.76,59.377 17.051,62.667 L17.051,62.667 C20.342,65.958 25.726,65.958 29.016,62.667 L45.638,46.045 C46.971,44.713 46.971,42.533 45.639,41.201 Z",
        id: "Shape",
        fill: "#FFFFFF",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M45.639,41.201 L42.078,37.64 L17.051,62.667 C20.342,65.958 25.726,65.958 29.016,62.667 L45.638,46.045 C46.971,44.713 46.971,42.533 45.639,41.201 Z",
        id: "Shape",
        fill: "#DEEBFF",
        fillRule: "nonzero",
        opacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M71.965,63.574 L63.024,54.633 C61.318,52.927 61.318,50.137 63.024,48.431 L65.099,46.356 C66.805,44.65 69.595,44.65 71.301,46.356 L80.242,55.297 C81.948,57.003 81.948,59.793 80.242,61.499 L78.167,63.574 C76.461,65.28 73.67,65.28 71.965,63.574 Z",
        id: "Shape",
        fill: "#194063",
        fillRule: "nonzero",
        opacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M71.905,60.107 L71.193,59.395 C70.607,58.809 70.607,57.851 71.193,57.266 L73.946,54.513 C74.532,53.927 75.49,53.927 76.075,54.513 L76.788,55.225 C77.374,55.811 77.374,56.769 76.788,57.354 L74.035,60.107 C73.449,60.693 72.491,60.693 71.905,60.107 Z",
        id: "Shape",
        fill: "#194063",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M66.965,55.167 L66.252,54.455 C65.666,53.869 65.666,52.911 66.252,52.326 L69.005,49.573 C69.591,48.987 70.549,48.987 71.134,49.573 L71.846,50.285 C72.432,50.871 72.432,51.829 71.846,52.414 L69.093,55.167 C68.509,55.752 67.55,55.752 66.965,55.167 Z",
        id: "Shape",
        fill: "#194063",
        fillRule: "nonzero"
    }))))));

});

parcelRegister("iomcV", function(module, exports) {

$parcel$export(module.exports, "fetchUserTraits", () => $3b02900ab60ea961$export$2a353ada541e501f);
$parcel$export(module.exports, "fetchSiteTraits", () => $3b02900ab60ea961$export$954f05a5dfd487e4);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $3b02900ab60ea961$export$2a353ada541e501f = async (cloudId, accountId)=>{
    try {
        const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const response = await (0, $lRmyA.performGetRequest)(url);
        if (response?.attributes) return response.attributes;
        throw Error('response is not defined or null');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'jwmSampleProjectService',
                packageName: 'jiraAtlassianNavigationRecommendations',
                teamName: 'navigation'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return [];
};
const $3b02900ab60ea961$export$954f05a5dfd487e4 = async (cloudId)=>{
    try {
        const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
        const response = await (0, $lRmyA.performGetRequest)(url);
        if (response?.attributes) return response.attributes;
        throw Error('response is not defined or null');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'jwmSampleProjectService',
                packageName: 'jiraAtlassianNavigationRecommendations',
                teamName: 'navigation'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return [];
};

});

const $6ccfb4ac3724893c$export$b8b9d90f9e5bd72b = 'jira-business.sample-project';
const $6ccfb4ac3724893c$export$4e0e125b835dc0d = 'create-jwm-sample-project';
const $6ccfb4ac3724893c$export$a1a2e9d60f36ed80 = 'jira_software_ui_moon_experiment_create_jwm_sample_experiment_project_dismissed_first';
const $6ccfb4ac3724893c$export$fc53f723f5163588 = 'jira_software_ui_moon_experiment_create_jwm_sample_experiment_project_created_first';
const $6ccfb4ac3724893c$export$ce71307e913afd12 = 'jira-core_business_project_created_first';
const $6ccfb4ac3724893c$export$7b412f30d02cee13 = '/rest/internal/latest/jwm/sample-project';
const $6ccfb4ac3724893c$export$529244c5c5612bf2 = 'jwmSampleProjectCreateFailure';
const $6ccfb4ac3724893c$export$63fbd2796586b8eb = 'projects-menu-existing-users';
const $6ccfb4ac3724893c$export$a92ddfff80995acf = 'jira_screen_viewed_jwmsampleprojectexperimentdropdown_first';
const $6ccfb4ac3724893c$export$9365f74cb008dc7c = 'brain_jsw_to_jwm_implicit_site_boolean';

parcelRegister("4Okch", function(module, exports) {

$parcel$export(module.exports, "default", () => $df60316c0182e931$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $df60316c0182e931$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    ctaDescriptionText: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.cta-description-text",
        "defaultMessage": "Business project"
    },
    lozengeText: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.lozenge-text",
        "defaultMessage": "TRY NOW"
    },
    trySampleSectionHeader: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.try-sample-section-header",
        "defaultMessage": "INCLUDED FREE WITH YOUR PLAN"
    },
    dismissConfirmationTitle: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.dismiss-confirmation-title",
        "defaultMessage": "Got it, thanks for letting us know"
    },
    dismissConfirmationText: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.dismiss-confirmation-text",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    ctaHeadingText: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.cta-heading-text",
        "defaultMessage": "Go-to-market sample"
    },
    modalTitle: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.modal-title",
        "defaultMessage": "Why am I seeing sample projects?"
    },
    modalBodySpork: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.modal-body-spork",
        "defaultMessage": "Jira is a powerful project management tool with two project types built for software and business teams. {br} {br}\n        The best part is, since you\u2019re using a software project, you already have access to business projects! {br} {br}\n        Create a sample business project to get set up quickly and start exploring. {br} {br}\n        {link}"
    },
    modalCta: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.modal-cta",
        "defaultMessage": "Ok"
    },
    modalCtaCapitalised: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.modal-cta-capitalised",
        "defaultMessage": "OK"
    },
    learnMoreLinkSpork: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.learn-more-link-spork",
        "defaultMessage": "Learn more about business projects in Jira"
    },
    errorFlagTitle: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.error-flag-title",
        "defaultMessage": "Something went wrong"
    },
    errorFlagText: {
        "id": "atlassian-navigation-recommendations.jwm-sample-project-recommendation.error-flag-text",
        "defaultMessage": "Please reload the page to try again. If you\u2019re still having trouble, please contact Atlassian support to resolve this."
    }
});

});



parcelRegister("hvTyt", function(module, exports) {

$parcel$export(module.exports, "RecommendationLoader", () => $2fed29c8a201d1b4$export$f17bc1d33db805f2);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $bFzGY = parcelRequire("bFzGY");

var $b8yDh = parcelRequire("b8yDh");

var $dxcfv = parcelRequire("dxcfv");

var $ab6rA = parcelRequire("ab6rA");

var $dWLk9 = parcelRequire("dWLk9");

var $21Sgb = parcelRequire("21Sgb");

var $j3FUN = parcelRequire("j3FUN");

var $4xHig = parcelRequire("4xHig");

var $gd0Sp = parcelRequire("gd0Sp");

var $kh69L = parcelRequire("kh69L");
const $2fed29c8a201d1b4$export$f17bc1d33db805f2 = ({ recommendations: recommendations })=>{
    const [, { loadRecommendations: loadRecommendations }] = (0, $kh69L.useProjectMenuRecommendations)();
    const accountId = (0, $dxcfv.useAccountId)();
    const locale = (0, $4xHig.useLocale)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const firstActivationDateMs = (0, $21Sgb.useFirstActivationDateMs)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const { software: edition } = (0, $ab6rA.useAppEditions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ hasSuccessOnce: hasSuccessOnce, canCreateProject: canCreateProject }] = (0, $b8yDh.useCreateProjectPermission)();
    const { areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $gd0Sp.useTenantContext)();
    (0, $eUqFw.useEffect)(()=>{
        if (hasSuccessOnce && accountId) loadRecommendations(recommendations, {
            locale: locale,
            accountId: accountId,
            cloudId: cloudId,
            licensedProducts: licensedProducts,
            firstActivationDateMs: firstActivationDateMs,
            areProductSuggestionsEnabled: areProductSuggestionsEnabled,
            edition: edition,
            environment: environment,
            canCreateProject: canCreateProject
        }, createAnalyticsEvent({}));
    }, [
        hasSuccessOnce,
        canCreateProject,
        accountId,
        loadRecommendations,
        createAnalyticsEvent,
        locale,
        cloudId,
        licensedProducts,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        edition,
        environment,
        recommendations
    ]);
    return null;
};

});
parcelRegister("b8yDh", function(module, exports) {

$parcel$export(module.exports, "useCreateProjectPermission", () => $d02ede3d6aa64bb9$export$c92733e8f8c1640f);
$parcel$export(module.exports, "useCreateProjectPermissionActions", () => $d02ede3d6aa64bb9$export$d2b8d6f60fe99e2a);

var $WBLbN = parcelRequire("WBLbN");

var $lki5t = parcelRequire("lki5t");
const $d02ede3d6aa64bb9$var$Store = (0, $WBLbN.createStore)({
    name: 'create-project-permissions',
    initialState: {
        canCreateProject: false,
        canCreateClassicProject: false,
        canCreateNextGenProject: false,
        isFetching: false,
        fetchError: null,
        promise: null,
        hasFetchedOnce: false,
        hasSuccessOnce: false
    },
    actions: $lki5t.actions
});
const $d02ede3d6aa64bb9$export$5a47fbae725b8f2 = (0, $WBLbN.createContainer)($d02ede3d6aa64bb9$var$Store);
const $d02ede3d6aa64bb9$export$c92733e8f8c1640f = (0, $WBLbN.createHook)($d02ede3d6aa64bb9$var$Store);
const $d02ede3d6aa64bb9$export$d2b8d6f60fe99e2a = (0, $WBLbN.createHook)($d02ede3d6aa64bb9$var$Store, {
    selector: null
});

});
parcelRegister("lki5t", function(module, exports) {

$parcel$export(module.exports, "actions", () => $3c3028a101022f12$export$e324594224ef24da);

var $2OdyW = parcelRequire("2OdyW");
const $3c3028a101022f12$export$963556ef97965f0b = async ()=>{
    const url = '/rest/internal/2/projectpermissions';
    const result = await (0, $2OdyW.default)(url);
    return result;
};
const $3c3028a101022f12$var$handleFetch = ()=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            const result = await $3c3028a101022f12$export$963556ef97965f0b();
            setState({
                ...result,
                isFetching: false,
                fetchError: null,
                hasFetchedOnce: true,
                hasSuccessOnce: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                canCreateProject: false,
                canCreateClassicProject: false,
                canCreateNextGenProject: false,
                isFetching: false,
                fetchError: error,
                hasFetchedOnce: true
            });
        }
    };
const $3c3028a101022f12$export$e324594224ef24da = {
    fetchCreateProjectPermission: ()=>async ({ setState: setState, dispatch: dispatch })=>{
            const promise = dispatch($3c3028a101022f12$var$handleFetch());
            setState({
                isFetching: true,
                promise: // @ts-expect-error - TS2322 - Type 'Promise<void>' is not assignable to type 'Promise<undefined>'.
                promise
            });
        }
};

});


parcelRegister("21Sgb", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $080756a4d87be123$export$9df3a539e50a284b);

var $gd0Sp = parcelRequire("gd0Sp");
const $080756a4d87be123$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});


parcelRegister("b6Cd2", function(module, exports) {

$parcel$export(module.exports, "default", () => $df0e91b2d068c01f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $df0e91b2d068c01f$var$LazyCustomThemeAdminFlag = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hI2JT")), {
    ssr: false,
    moduleId: "./src/packages/theme/custom-theme-admin-flag/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df0e91b2d068c01f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async.jira.custom-theme-admin-flag",
        packageName: "customThemeAdminFlag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-theme-admin-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df0e91b2d068c01f$var$LazyCustomThemeAdminFlag, null)));

});
parcelRegister("hI2JT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3HFgD").then(()=>parcelRequire('hIyMe'));

});


parcelRegister("arAkG", function(module, exports) {

$parcel$export(module.exports, "useFavoriteActions", () => $789d4e09cb76b2a2$export$e17993c41bc4dc38);
$parcel$export(module.exports, "useFavoriteBoards", () => $789d4e09cb76b2a2$export$896ce0ae2b68d03a);
$parcel$export(module.exports, "useFavoriteDashboards", () => $789d4e09cb76b2a2$export$7f929adce53e9217);
$parcel$export(module.exports, "useFavoriteProjects", () => $789d4e09cb76b2a2$export$e92f6fc9e0c6d135);
$parcel$export(module.exports, "useFavoriteFilters", () => $789d4e09cb76b2a2$export$49e6afd92506d2b4);
$parcel$export(module.exports, "useFavoriteQueues", () => $789d4e09cb76b2a2$export$b09f7ee747d8bc9);
$parcel$export(module.exports, "useFavoritePlans", () => $789d4e09cb76b2a2$export$56f40dc3d5e1af94);
$parcel$export(module.exports, "FavoritesContainer", () => $789d4e09cb76b2a2$export$878515009e0790e0);


var $2knNp = parcelRequire("2knNp");

var $WBLbN = parcelRequire("WBLbN");

const $789d4e09cb76b2a2$var$emptyItemState = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false
};
const $789d4e09cb76b2a2$export$d4c72bab9d6cc13a = {
    [(0, $0e036566397b8f78$export$f95f1a684a17f189)]: {
        ...$789d4e09cb76b2a2$var$emptyItemState
    },
    [(0, $0e036566397b8f78$export$6e58b6b0aa48a271)]: {
        ...$789d4e09cb76b2a2$var$emptyItemState
    },
    [(0, $0e036566397b8f78$export$6737b9227f60f39d)]: {
        ...$789d4e09cb76b2a2$var$emptyItemState
    },
    [(0, $0e036566397b8f78$export$91a9dba2d38d9a6f)]: {
        ...$789d4e09cb76b2a2$var$emptyItemState
    },
    [(0, $0e036566397b8f78$export$20f1031cc9fdf29e)]: {
        ...$789d4e09cb76b2a2$var$emptyItemState
    },
    [(0, $0e036566397b8f78$export$eebccb886b064713)]: {
        ...$789d4e09cb76b2a2$var$emptyItemState
    }
};
const $789d4e09cb76b2a2$var$transformItems = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, itemResponse)=>{
        if (itemResponse.id === 'favourite-boards') acc[0, $0e036566397b8f78$export$f95f1a684a17f189] = itemResponse.items;
        if (itemResponse.id === 'favourite-filters') acc[0, $0e036566397b8f78$export$6737b9227f60f39d] = itemResponse.items;
        if (itemResponse.id === 'favourite-dashboards') acc[0, $0e036566397b8f78$export$6e58b6b0aa48a271] = itemResponse.items;
        if (itemResponse.id === 'favourite-projects') acc[0, $0e036566397b8f78$export$91a9dba2d38d9a6f] = itemResponse.items;
        if (itemResponse.id === 'favourite-queues') acc[0, $0e036566397b8f78$export$20f1031cc9fdf29e] = itemResponse.items;
        if (itemResponse.id === 'favourite-plans') acc[0, $0e036566397b8f78$export$eebccb886b064713] = itemResponse.items;
        return acc;
    }, {});
const $789d4e09cb76b2a2$var$loadFavoriteItems = (amount = (0, $f611712f945be48f$export$ea341e6cc435ed40), types)=>async ({ setState: setState, getState: getState })=>{
        const typesToFetch = types.filter((type)=>!getState()[type].isFetching);
        if (typesToFetch.length) try {
            const promise = (0, $2knNp.fetchFavoriteItems)({
                count: amount,
                types: typesToFetch
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const loadingState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                };
                return acc;
            }, {});
            setState(loadingState);
            const itemResponse = await promise;
            const transformed = $789d4e09cb76b2a2$var$transformItems(itemResponse);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const responseState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    items: transformed[type],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                };
                return acc;
            }, {});
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                };
                return acc;
            }, {});
            setState(errorState);
        }
    };
const $789d4e09cb76b2a2$export$e324594224ef24da = {
    loadFavoriteAll: (amount)=>async (actions2, props)=>{
            $789d4e09cb76b2a2$var$loadFavoriteItems(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $0e036566397b8f78$export$f95f1a684a17f189) : undefined,
                (0, $0e036566397b8f78$export$6e58b6b0aa48a271),
                (0, $0e036566397b8f78$export$91a9dba2d38d9a6f),
                (0, $0e036566397b8f78$export$6737b9227f60f39d),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $0e036566397b8f78$export$20f1031cc9fdf29e) : undefined,
                props.applicationPermissions.hasSoftwareAccess ? (0, $0e036566397b8f78$export$eebccb886b064713) : undefined
            ].filter(Boolean))(actions2);
        },
    loadFavouriteBoards: (amount)=>$789d4e09cb76b2a2$var$loadFavoriteItems(amount, [
            (0, $0e036566397b8f78$export$f95f1a684a17f189)
        ]),
    loadFavoriteProjects: (amount)=>$789d4e09cb76b2a2$var$loadFavoriteItems(amount, [
            (0, $0e036566397b8f78$export$91a9dba2d38d9a6f)
        ]),
    loadFavoriteDashboards: (amount)=>$789d4e09cb76b2a2$var$loadFavoriteItems(amount, [
            (0, $0e036566397b8f78$export$6e58b6b0aa48a271)
        ]),
    loadFavoriteFilters: (amount)=>$789d4e09cb76b2a2$var$loadFavoriteItems(amount, [
            (0, $0e036566397b8f78$export$6737b9227f60f39d)
        ]),
    loadFavouriteQueues: (amount)=>$789d4e09cb76b2a2$var$loadFavoriteItems(amount, [
            (0, $0e036566397b8f78$export$20f1031cc9fdf29e)
        ]),
    loadFavoritePlans: (amount)=>$789d4e09cb76b2a2$var$loadFavoriteItems(amount, [
            (0, $0e036566397b8f78$export$eebccb886b064713)
        ])
};
const $789d4e09cb76b2a2$var$store = (0, $WBLbN.createStore)({
    name: (0, $f611712f945be48f$export$7a3d0824e907e616),
    actions: $789d4e09cb76b2a2$export$e324594224ef24da,
    initialState: $789d4e09cb76b2a2$export$d4c72bab9d6cc13a
});
const $789d4e09cb76b2a2$export$e17993c41bc4dc38 = (0, $WBLbN.createHook)($789d4e09cb76b2a2$var$store, {
    selector: null
});
const $789d4e09cb76b2a2$export$896ce0ae2b68d03a = (0, $WBLbN.createHook)($789d4e09cb76b2a2$var$store, {
    selector: (state)=>state[0, $0e036566397b8f78$export$f95f1a684a17f189]
});
const $789d4e09cb76b2a2$export$7f929adce53e9217 = (0, $WBLbN.createHook)($789d4e09cb76b2a2$var$store, {
    selector: (state)=>state[0, $0e036566397b8f78$export$6e58b6b0aa48a271]
});
const $789d4e09cb76b2a2$export$e92f6fc9e0c6d135 = (0, $WBLbN.createHook)($789d4e09cb76b2a2$var$store, {
    selector: (state)=>state[0, $0e036566397b8f78$export$91a9dba2d38d9a6f]
});
const $789d4e09cb76b2a2$export$49e6afd92506d2b4 = (0, $WBLbN.createHook)($789d4e09cb76b2a2$var$store, {
    selector: (state)=>state[0, $0e036566397b8f78$export$6737b9227f60f39d]
});
const $789d4e09cb76b2a2$export$b09f7ee747d8bc9 = (0, $WBLbN.createHook)($789d4e09cb76b2a2$var$store, {
    selector: (state)=>state[0, $0e036566397b8f78$export$20f1031cc9fdf29e]
});
const $789d4e09cb76b2a2$export$56f40dc3d5e1af94 = (0, $WBLbN.createHook)($789d4e09cb76b2a2$var$store, {
    selector: (state)=>state[0, $0e036566397b8f78$export$eebccb886b064713]
});
const $789d4e09cb76b2a2$export$878515009e0790e0 = (0, $WBLbN.createContainer)($789d4e09cb76b2a2$var$store);

});
const $0e036566397b8f78$export$91a9dba2d38d9a6f = 'projects';
const $0e036566397b8f78$export$ebb48b08205007c5 = 'issues';
const $0e036566397b8f78$export$6737b9227f60f39d = 'filters';
const $0e036566397b8f78$export$6e58b6b0aa48a271 = 'dashboards';
const $0e036566397b8f78$export$20f1031cc9fdf29e = 'queues';
const $0e036566397b8f78$export$f95f1a684a17f189 = 'boards';
const $0e036566397b8f78$export$3c11110d46d67e8c = 'jwmBoards';
const $0e036566397b8f78$export$5e2cc09b58170ca2 = 'addons';
const $0e036566397b8f78$export$eebccb886b064713 = 'plans';
const $0e036566397b8f78$export$1c2ea36059c73937 = 'alerts';

parcelRegister("2knNp", function(module, exports) {

$parcel$export(module.exports, "fetchFavoriteItems", () => $e281ee86cebd87d2$export$ba7e2966560509a6);

var $hgFNe = parcelRequire("hgFNe");

var $53ciZ = parcelRequire("53ciZ");

var $fVqUX = parcelRequire("fVqUX");

var $4X5wI = parcelRequire("4X5wI");

const $e281ee86cebd87d2$var$handleError = (error)=>{
    throw error;
};
// This is horrible but the API is wrong: the type returned is singular while
// everywhere else (even in add/remove) is plural
// @ts-expect-error - TS7031 - Binding element 'items' implicitly has an 'any' type.
const $e281ee86cebd87d2$var$convertTypeToPlural = ({ items: items, ...rest })=>({
        ...rest,
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        items: items.filter(Boolean).map((item)=>({
                ...item,
                type: `${item.type}s`
            }))
    });
const $e281ee86cebd87d2$export$ba7e2966560509a6 = async ({ count: count, types: types = [
    (0, $0e036566397b8f78$export$91a9dba2d38d9a6f),
    (0, $0e036566397b8f78$export$6e58b6b0aa48a271),
    (0, $0e036566397b8f78$export$6737b9227f60f39d),
    (0, $0e036566397b8f78$export$eebccb886b064713)
] })=>{
    const query = (0, $53ciZ.stringify)((0, (/*@__PURE__*/$parcel$interopDefault($hgFNe)))(types.map((type)=>[
            type,
            count
        ])));
    const url = `/rest/internal/2/favourites?${query}`;
    try {
        const response = await fetch(url, (0, $fVqUX.default));
        if (!response.ok) {
            const errorCode = response.status;
            if (errorCode === 401) return $e281ee86cebd87d2$var$handleError(new (0, $4X5wI.AuthenticationError)(`${errorCode}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $e281ee86cebd87d2$var$handleError(new Error(errorCode));
        }
        const resp = await response.json();
        return resp.map($e281ee86cebd87d2$var$convertTypeToPlural);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $e281ee86cebd87d2$var$handleError(error);
    }
};
const $e281ee86cebd87d2$export$77fc2acdef452939 = async (item)=>{
    const url = '/rest/internal/2/favourites';
    try {
        const response = await fetch(url, {
            ...(0, $fVqUX.default),
            method: 'POST',
            body: JSON.stringify({
                entity: {
                    id: item.id,
                    type: item.type
                },
                beforeEntityPosition: null
            })
        });
        if (!response.ok) {
            const errorCode = response.status;
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $e281ee86cebd87d2$var$handleError(new Error(errorCode));
        }
        const result = await response.json();
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $e281ee86cebd87d2$var$handleError(error);
    }
};
const $e281ee86cebd87d2$export$acbe6ca9570854bd = async (item)=>{
    const url = `/rest/internal/2/favourites/${item.type}/${item.id}`;
    try {
        const response = await fetch(url, {
            ...(0, $fVqUX.default),
            method: 'DELETE'
        });
        if (!response.ok) {
            const errorCode = response.status;
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $e281ee86cebd87d2$var$handleError(new Error(errorCode));
        }
        const result = await response.json();
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $e281ee86cebd87d2$var$handleError(error);
    }
};

});
parcelRegister("4X5wI", function(module, exports) {

$parcel$export(module.exports, "AuthenticationError", () => $9c4d4fc947b6f0a7$export$cf0c46b07324e9c5);
class $9c4d4fc947b6f0a7$export$cf0c46b07324e9c5 extends Error {
    constructor(message){
        super(message);
        this.name = 'AuthenticationError';
        this.skipSentry = true;
        this.statusCode = 401;
    }
}

});


const $f611712f945be48f$export$ea341e6cc435ed40 = 15;
const $f611712f945be48f$export$7a3d0824e907e616 = 'navigation-favourite-store';


parcelRegister("jB5IB", function(module, exports) {

$parcel$export(module.exports, "useLockScreenController", () => $843e8034a8f1654e$export$e035a0795b3eefc0);
$parcel$export(module.exports, "useIsScreenLocked", () => $843e8034a8f1654e$export$8a9d757ad1774a77);

var $cPEpP = parcelRequire("cPEpP");

var $ab6rA = parcelRequire("ab6rA");

var $WBLbN = parcelRequire("WBLbN");

var $9CJ0P = parcelRequire("9CJ0P");
const $843e8034a8f1654e$export$111f5c5aa8d2ad30 = (0, $WBLbN.createStore)({
    initialState: {
        isLocked: false
    },
    actions: {
        lockScreen: ()=>({ setState: setState })=>setState({
                    isLocked: true
                }),
        unlockScreen: ()=>({ setState: setState })=>setState({
                    isLocked: false
                })
    },
    name: 'LockScreenExperiment'
});
const $843e8034a8f1654e$export$e035a0795b3eefc0 = (0, $WBLbN.createHook)($843e8034a8f1654e$export$111f5c5aa8d2ad30);
const $843e8034a8f1654e$export$8a9d757ad1774a77 = ()=>{
    const [lockScreenState] = $843e8034a8f1654e$export$e035a0795b3eefc0();
    const { loading: loadingProject, data: project } = (0, $cPEpP.useProject)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $9CJ0P.isTrialEndLockScreenEnabledForAnyProjectType)(appEditions) && !loadingProject && (0, $9CJ0P.isSupportedProjectType)(project?.type) && lockScreenState.isLocked;
};

});
parcelRegister("9CJ0P", function(module, exports) {

$parcel$export(module.exports, "getStatSigCohortAndExposureFunction", () => $5fd6ec1c86252c53$export$dcea8823e3724239);
$parcel$export(module.exports, "isSupportedProjectType", () => $5fd6ec1c86252c53$export$fa630a47d84fb39a);
$parcel$export(module.exports, "isTrialEndLockScreenEnabledForProject", () => $5fd6ec1c86252c53$export$cd0c634567b0c255);
$parcel$export(module.exports, "isTrialEndLockScreenEnabledForAnyProjectType", () => $5fd6ec1c86252c53$export$26a64e0070bbd19d);
$parcel$export(module.exports, "getShowForUserUsageUnderLimit", () => $5fd6ec1c86252c53$export$8d52cd5130a1ee4e);

var $jG2Eu = parcelRequire("jG2Eu");

var $7ZZxN = parcelRequire("7ZZxN");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $6WXNs = parcelRequire("6WXNs");
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSM_STATSIG_FLAG = 'jsm_trial_end_lock_screen_experiment';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JPD_STATSIG_FLAG = 'jpd_trial_end_lock_screen_experiment';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSW_STATSIG_FLAG = 'jsw_trial_end_lock_screen_experiment';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSM_FF = 'jsm-trial-end-lock-screen-experiment_nowmr';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JPD_FF = 'jpd-trial-end-lock-screen-experiment';
const $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSW_FF = 'jsw-trial-end-lock-screen-experiment_ieq79';
const $5fd6ec1c86252c53$export$37f449592e04a567 = [
    (0, $7ZZxN.SERVICE_DESK_PROJECT),
    (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT),
    (0, $7ZZxN.SOFTWARE_PROJECT)
];
const $5fd6ec1c86252c53$var$PROJECT_FLAGS = {
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: {
        [(0, $6WXNs.STANDARD_EDITION)]: {
            gatingFlagType: 'ff',
            gatingFlag: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSM_FF,
            statsig: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSM_STATSIG_FLAG
        }
    },
    [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: {
        [(0, $6WXNs.STANDARD_EDITION)]: {
            gatingFlagType: 'ff',
            gatingFlag: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JPD_FF,
            statsig: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JPD_STATSIG_FLAG
        }
    },
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: {
        [(0, $6WXNs.STANDARD_EDITION)]: {
            gatingFlagType: 'ff',
            gatingFlag: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSW_FF,
            statsig: $5fd6ec1c86252c53$var$TRIAL_END_LOCK_SCREEN_JSW_STATSIG_FLAG
        }
    }
};
const $5fd6ec1c86252c53$export$dcea8823e3724239 = ({ projectType: projectType, edition: edition })=>{
    let expConfig;
    let fireExpExperimentExposure;
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) [expConfig, fireExpExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsm_trial_end_lock_screen_experiment');
            break;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) [expConfig, fireExpExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jpd_trial_end_lock_screen_experiment');
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) [expConfig, fireExpExperimentExposure] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_trial_end_lock_screen_experiment');
            break;
        default:
            break;
    }
    return {
        cohort: expConfig ? expConfig.get('cohort', 'not-enrolled') : 'not-enrolled',
        fireExpExperimentExposure: fireExpExperimentExposure ?? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    };
};
const $5fd6ec1c86252c53$export$fa630a47d84fb39a = (value)=>{
    const projectType = (0, $7ZZxN.toProjectType)(value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!projectType && $5fd6ec1c86252c53$export$37f449592e04a567.includes(projectType);
};
const $5fd6ec1c86252c53$export$cd0c634567b0c255 = ({ projectType: projectType, edition: edition })=>{
    const { cohort: cohort } = $5fd6ec1c86252c53$export$dcea8823e3724239({
        projectType: projectType,
        edition: edition
    });
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) return (0, $1ybV0.ff)('jsm-trial-end-lock-screen-experiment_nowmr') && cohort !== 'not-enrolled';
            break;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) return (0, $1ybV0.ff)('jpd-trial-end-lock-screen-experiment') && cohort !== 'not-enrolled';
            break;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (edition === (0, $6WXNs.STANDARD_EDITION)) return (0, $1ybV0.ff)('jsw-trial-end-lock-screen-experiment_ieq79') && cohort !== 'not-enrolled';
            break;
        default:
            return false;
    }
    return false;
};
const $5fd6ec1c86252c53$export$26a64e0070bbd19d = (appEditions)=>$5fd6ec1c86252c53$export$37f449592e04a567.some((projectType)=>{
        const edition = projectType && appEditions && (0, $6WXNs.getEditionForProject)(projectType, appEditions);
        return $5fd6ec1c86252c53$export$cd0c634567b0c255({
            projectType: projectType,
            edition: edition
        });
    });
const $5fd6ec1c86252c53$export$8d52cd5130a1ee4e = ({ projectType: projectType, edition: edition })=>!!edition && !!$5fd6ec1c86252c53$var$PROJECT_FLAGS[projectType][edition]?.showForUserUsageUnderLimit;

});


parcelRegister("1YbJP", function(module, exports) {

$parcel$export(module.exports, "testIdConcat", () => $b2302c46c1861a6c$export$794609946480f79c);
$parcel$export(module.exports, "testIdGenerate", () => $b2302c46c1861a6c$export$3b86b974ae586844);

var $1ybV0 = parcelRequire("1ybV0");
const $b2302c46c1861a6c$var$PREFIX = 'atlassian-navigation-';
const $b2302c46c1861a6c$var$SEPARATOR = '--';
const $b2302c46c1861a6c$var$isValid = (value)=>value != null && value !== '';
const $b2302c46c1861a6c$export$794609946480f79c = (id, ...items)=>(0, $1ybV0.ff)('navigation.disable-test-ids') ? undefined : [
        id,
        ...items
    ].filter(Boolean).join($b2302c46c1861a6c$var$SEPARATOR).toLowerCase();
const $b2302c46c1861a6c$export$3b86b974ae586844 = (first, ...rest)=>(0, $1ybV0.ff)('navigation.disable-test-ids') ? undefined // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string | undefined'.
     : $b2302c46c1861a6c$export$794609946480f79c($b2302c46c1861a6c$var$PREFIX + ($b2302c46c1861a6c$var$isValid(first) ? `-${first}` : ''), ...rest);

});

parcelRegister("bkDs8", function(module, exports) {

$parcel$export(module.exports, "EditionAwareness", () => $599190316e0dd546$export$a55b02efe3d62583);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $0cdA8 = parcelRequire("0cdA8");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $cPEpP = parcelRequire("cPEpP");

var $gGtKh = parcelRequire("gGtKh");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");

var $jK1pm = parcelRequire("jK1pm");


var $5rszV = parcelRequire("5rszV");

var $15Ybe = parcelRequire("15Ybe");

var $8yZhu = parcelRequire("8yZhu");

var $aqRlR = parcelRequire("aqRlR");

var $iwzQE = parcelRequire("iwzQE");
// Experiment specific code to be removed during cleanup
const $599190316e0dd546$var$isEnrolledInJSMFreeToStandard = ()=>{
    const [config] = (0, $79xbN.UNSAFE_noExposureExp)('jsm-auto-upgrade-awareness');
    const cohort = config.get('cohort', 'not-enrolled');
    return cohort !== 'not-enrolled';
};
// Experiment specific code to be removed during cleanup
const $599190316e0dd546$var$isEnrolledInJPDFreeToStandard = ()=>{
    const [config] = (0, $79xbN.UNSAFE_noExposureExp)('jpd-free-to-upgrade-pill-au-awareness');
    const cohort = config.get('cohort', 'not-enrolled');
    return cohort !== 'not-enrolled';
};
const $599190316e0dd546$var$ImplicitJWMTrialPill = (props)=>{
    const isImplicitJWMLicense = (0, $15Ybe.useIsImplicitJWMLicense)();
    if (!isImplicitJWMLicense) return null;
    // productKey is set to "jira-software", because it only has an entitlement with JSW, not with JWM.
    // projectType is the real value ("business").
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "edition-awareness-implicit-jwm-premium-trial"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwzQE.TrialPill), {
        ...props,
        productKey: (0, $7ZZxN.projectTypeToCanonicalId)((0, $7ZZxN.SOFTWARE_PROJECT)),
        projectType: (0, $7ZZxN.CORE_PROJECT)
    }));
};
const $599190316e0dd546$var$ProductAndEditionChecker = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    const { loading: loading, data: project } = (0, $cPEpP.useProject)();
    const userMeetsJswTopNavRequisites = (0, $5rszV.useMeetsJswEATopNavRequisites)();
    // TODO I'll enable this change separately to test it correctly
    // const siteHasJiraOnly = useSiteHasJiraOnly();
    const siteHasJswOnly = userMeetsJswTopNavRequisites;
    // If the JSW EA top nav relocation is active, we want to default the project type to JSW
    // so that the pill can show even on product-agnostic pages (e.g. "Your work")
    const defaultProjectType = siteHasJswOnly ? (0, $7ZZxN.SOFTWARE_PROJECT) : undefined;
    const projectType = (0, $7ZZxN.toProjectType)(project?.type) || defaultProjectType;
    if (loading || !projectType) return null;
    const edition = (0, $6WXNs.getEditionForProject)(projectType, appEditions);
    const productKey = (0, $7ZZxN.projectTypeToCanonicalId)(projectType);
    if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) switch(edition){
        case 0, $6WXNs.FREE_EDITION:
            if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) && $599190316e0dd546$var$isEnrolledInJSMFreeToStandard()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
                name: "edition-awareness-jsm-free-to-standard"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
                name: "edition-awareness-button-placeholder",
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yZhu.EditionAwarenessButton), {
                applicationEdition: "FREE_EDITION",
                applicationKey: "jira-servicedesk",
                projectType: projectType
            })));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
                name: "edition-awareness-jsw-jsm-free"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqRlR.FreePill), {
                projectType: projectType,
                siteHasJswOnly: siteHasJswOnly
            }));
        case 0, $6WXNs.STANDARD_EDITION:
        case 0, $6WXNs.PREMIUM_EDITION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
                name: "edition-awareness-jsw-jsm-standard-premium-trial"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwzQE.TrialPill), {
                productKey: productKey,
                projectType: projectType,
                edition: edition
            }));
        default:
            return null;
    }
    else if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) {
        if ((0, $eI5EY.fg)('jpd_disable_edition_awareness')) return null;
        switch(edition){
            case 0, $6WXNs.FREE_EDITION:
                if ($599190316e0dd546$var$isEnrolledInJPDFreeToStandard()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
                    name: "edition-awareness-jpd-free-to-standard"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
                    name: "edition-awareness-button-placeholder",
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yZhu.EditionAwarenessButton), {
                    applicationEdition: "FREE_EDITION",
                    applicationKey: "jira-product-discovery",
                    projectType: projectType
                })));
                return null;
            case 0, $6WXNs.STANDARD_EDITION:
            case 0, $6WXNs.PREMIUM_EDITION:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
                    name: "edition-awareness-jpd-standard-premium-trial"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwzQE.TrialPill), {
                    productKey: productKey,
                    projectType: projectType,
                    edition: edition
                }));
            default:
                return null;
        }
    } else if (projectType === (0, $7ZZxN.CORE_PROJECT)) // We are supporting only JWM implicit licensing when the parent license is JSW
    switch(edition){
        case 0, $6WXNs.FREE_EDITION:
            if (siteHasJswOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
                name: "edition-awareness-jsw-jsm-free"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqRlR.FreePill), {
                projectType: (0, $7ZZxN.CORE_PROJECT),
                siteHasJswOnly: siteHasJswOnly
            }));
            return null;
        case 0, $6WXNs.STANDARD_EDITION:
            if (siteHasJswOnly) // productKey is set to "jira-software", because it only has an entitlement with JSW, not with JWM.
            // projectType is the real value ("business").
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
                name: "edition-awareness-implicit-jwm-standard-trial"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iwzQE.TrialPill), {
                edition: edition,
                productKey: "jira-software",
                projectType: (0, $7ZZxN.CORE_PROJECT)
            }));
            return null;
        case 0, $6WXNs.PREMIUM_EDITION:
            // Core projects are partially supported - only for implicit JWM, on premium, on the top nav
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($599190316e0dd546$var$ImplicitJWMTrialPill, {
                edition: edition
            });
        default:
            return null;
    }
    return null;
};
const $599190316e0dd546$export$a55b02efe3d62583 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $0a36f00f767f9fa2$export$f19f2573d2fc7010),
        packageName: (0, $0a36f00f767f9fa2$export$b8b9d90f9e5bd72b),
        fallback: "unmount",
        teamName: "growth-tako"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "edition-awareness"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($599190316e0dd546$var$ProductAndEditionChecker, null)));

});
const $0a36f00f767f9fa2$export$f19f2573d2fc7010 = 'EditionAwareness';
const $0a36f00f767f9fa2$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarEditionAwareness';
const $0a36f00f767f9fa2$export$37efcda5d411f9dc = 10;
const $0a36f00f767f9fa2$export$71bbf33843c4812a = 7;

parcelRegister("5rszV", function(module, exports) {

$parcel$export(module.exports, "useMeetsJswEATopNavRequisites", () => $4e36b95345859790$export$51b8bea2d17f2b55);

var $3svxt = parcelRequire("3svxt");


var $gd0Sp = parcelRequire("gd0Sp");
function $4e36b95345859790$export$51b8bea2d17f2b55() {
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    try {
        const explicitlyLicensedProducts = (0, $3svxt.default)(tenantContext);
        const firstExplicitlyLicensedProduct = explicitlyLicensedProducts[0];
        return explicitlyLicensedProducts.length === 1 && firstExplicitlyLicensedProduct === (0, $2edfd53057852e41$export$1346c9aa3cbb477d);
    } catch  {
        return false;
    }
}

});
parcelRegister("3svxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e55bb6ee669ca6d$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1e55bb6ee669ca6d$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $2edfd53057852e41$export$db515c8cec1e6f79] && result.push((0, $2edfd53057852e41$export$db515c8cec1e6f79));
    licensedProducts[0, $2edfd53057852e41$export$c8c1c8c3f8ddba61] && result.push((0, $2edfd53057852e41$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $2edfd53057852e41$export$1346c9aa3cbb477d] && result.push((0, $2edfd53057852e41$export$1346c9aa3cbb477d));
    licensedProducts[0, $2edfd53057852e41$export$202f50ee62667e32] && result.push((0, $2edfd53057852e41$export$202f50ee62667e32));
    return result;
};

});
const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';



parcelRegister("15Ybe", function(module, exports) {

$parcel$export(module.exports, "useIsImplicitJWMLicense", () => $4429a6c60af21a2e$export$c6283efc3e1cfce);

var $e91YZ = parcelRequire("e91YZ");

var $7HKaW = parcelRequire("7HKaW");

var $jBTMs = parcelRequire("jBTMs");

var $j3FUN = parcelRequire("j3FUN");
const $4429a6c60af21a2e$export$c6283efc3e1cfce = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const licenseStates = (0, $jBTMs.useLicenseStates)();
    // Implicit JWM, means having JSW explicitly licensed, without JWM explicitly licensed, but still with access to JWM.
    return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && !licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_CORE] && licenseStates.core === (0, $7HKaW.LICENSE_STATE_ACTIVE) && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
};

});

parcelRegister("8yZhu", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessButton", () => $f8722f55dc44d6d4$export$57ddd9301662f8e4);

var $7D6DB = parcelRequire("7D6DB");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $2LOJ0 = parcelRequire("2LOJ0");

var $7ZZxN = parcelRequire("7ZZxN");

var $kBVSc = parcelRequire("kBVSc");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6g2XI = parcelRequire("6g2XI");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eIp1n = parcelRequire("eIp1n");


var $6WXNs = parcelRequire("6WXNs");

var $dWLk9 = parcelRequire("dWLk9");

var $g4G5S = parcelRequire("g4G5S");

var $kI9bU = parcelRequire("kI9bU");

var $aqRlR = parcelRequire("aqRlR");

var $54gZT = parcelRequire("54gZT");

var $cW8rl = parcelRequire("cW8rl");
const $f8722f55dc44d6d4$var$ApplicationChargeElement = {
    [(0, $2edfd53057852e41$export$202f50ee62667e32)]: 'user',
    [(0, $2edfd53057852e41$export$c8c1c8c3f8ddba61)]: 'agent'
};
const $f8722f55dc44d6d4$var$TargetOfferings = {
    [(0, $6WXNs.FREE_EDITION)]: (0, $6WXNs.STANDARD_EDITION)
};
const $f8722f55dc44d6d4$export$57ddd9301662f8e4 = ({ applicationEdition: applicationEdition, applicationKey: applicationKey, projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const productKey = (0, $7ZZxN.projectTypeToCanonicalId)(projectType);
    const chargeElement = $f8722f55dc44d6d4$var$ApplicationChargeElement[applicationKey];
    const offeringKey = (0, $kBVSc.getProductOfferingKey)(applicationKey, $f8722f55dc44d6d4$var$TargetOfferings[applicationEdition]);
    const data = (0, $iWLL0.useLazyLoadQuery)((0, $7D6DB.default), {
        cloudId: cloudId,
        hamsProductKey: productKey,
        chargeElement: chargeElement,
        offeringKey: offeringKey
    });
    const productEntitlementDetails = (0, $g4G5S.useProductEntitlementDetails)();
    const entitlement = data.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const licensedUsers = entitlement?.latestUsageForChargeElement;
    const licensedUserLimit = productEntitlementDetails?.[applicationKey]?.unitCount;
    const canUpgrade = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser && entitlement?.experienceCapabilities?.changeOfferingV2.experienceUrl;
    const { text: text, status: status } = (0, $eUqFw.useMemo)(()=>{
        if (!licensedUsers || !licensedUserLimit) return {
            text: formatMessage((0, $cW8rl.default).upgrade),
            status: 'default'
        };
        if (applicationKey === (0, $2edfd53057852e41$export$202f50ee62667e32) && licensedUsers >= licensedUserLimit) return {
            text: formatMessage((0, $cW8rl.default).noCreatorsLeft),
            status: 'danger'
        };
        if (applicationKey === (0, $2edfd53057852e41$export$202f50ee62667e32) && licensedUsers > 1) return {
            text: formatMessage((0, $cW8rl.default).limitedCreatorsLeft),
            status: 'warning'
        };
        if (applicationKey === (0, $2edfd53057852e41$export$c8c1c8c3f8ddba61) && licensedUsers >= licensedUserLimit) return {
            text: formatMessage((0, $cW8rl.default).noAgentsLeft),
            status: 'danger'
        };
        if (applicationKey === (0, $2edfd53057852e41$export$c8c1c8c3f8ddba61) && licensedUsers > 1) return {
            text: formatMessage((0, $cW8rl.default).limitedAgentsLeft),
            status: 'warning'
        };
        return {
            text: formatMessage((0, $cW8rl.default).upgrade),
            status: 'default'
        };
    }, [
        applicationKey,
        licensedUsers,
        licensedUserLimit,
        formatMessage
    ]);
    const shouldSeeButton = (0, $kI9bU.useShouldSeeButton)({
        applicationEdition: applicationEdition,
        applicationKey: applicationKey,
        canUpgrade: Boolean(canUpgrade)
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const buttonAnalyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            applicationEdition: applicationEdition,
            applicationKey: applicationKey,
            appearance: status,
            licensedUsers: licensedUsers,
            licensedUserLimit: licensedUserLimit
        }), [
        applicationEdition,
        applicationKey,
        status,
        licensedUsers,
        licensedUserLimit
    ]);
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editionAwarenessButton', buttonAnalyticsAttributes);
    }, [
        createAnalyticsEvent,
        buttonAnalyticsAttributes
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!shouldSeeButton || !offeringKey) return;
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'button'
        }), 'editionAwarenessButton', buttonAnalyticsAttributes);
    }, [
        buttonAnalyticsAttributes,
        createAnalyticsEvent,
        offeringKey,
        shouldSeeButton
    ]);
    const modalProps = (0, $eUqFw.useMemo)(()=>({
            width: 968
        }), []);
    const entryPointProps = (0, $eUqFw.useMemo)(()=>({
            applicationEdition: applicationEdition,
            applicationKey: applicationKey
        }), [
        applicationEdition,
        applicationKey
    ]);
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            jiraApplicationKey: (0, $eIp1n.getApplicationKeyForProject)(projectType),
            cloudId: cloudId,
            productKey: productKey,
            offeringKey: offeringKey ?? '',
            chargeElement: $f8722f55dc44d6d4$var$ApplicationChargeElement[applicationKey]
        }), [
        applicationKey,
        cloudId,
        offeringKey,
        productKey,
        projectType
    ]);
    if (applicationKey === 'jira-servicedesk' && !shouldSeeButton) // This is so that anyone in control still sees the current `free pill` experience
    // we're keeping only the top nav version of the button, ignoring the classic sidebar experience
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aqRlR.FreePill), {
        projectType: "service_desk",
        siteHasJswOnly: false
    });
    if (!shouldSeeButton || !offeringKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6g2XI.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $54gZT.editionAwarenessModalEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        modalProps: modalProps,
        interactionName: "edition-awareness-modal",
        useInternalModal: false
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2LOJ0.EditionAwarenessButton), {
            status: status,
            // This is how the examples in and tests are setup
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            onClick: handleOnClick
        }, text));
};

});
parcelRegister("7D6DB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7afceb858439031$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06009df7f7acf8e7f0a120a7250e92f5>>
 * @relayHash 963e5e9f322344149636f5c579643e95
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1feba7d011b8326c5b311fec396ac9bfe8057f79358ce35fe89f18f579dcad11
const $e7afceb858439031$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "chargeElement"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hamsProductKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offeringKey"
    }, v4 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v6 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v8 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v9 = {
        "args": [
            {
                "kind": "Variable",
                "name": "chargeElement",
                "variableName": "chargeElement"
            }
        ],
        "kind": "ScalarField",
        "name": "latestUsageForChargeElement"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editionAwarenessNextQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editionAwarenessNextQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1feba7d011b8326c5b311fec396ac9bfe8057f79358ce35fe89f18f579dcad11",
            "metadata": {},
            "name": "editionAwarenessNextQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e7afceb858439031$var$node.hash = "470a189e90dc4df1cb98da57e70731aa";
var $e7afceb858439031$export$2e2bcd8739ae039 = $e7afceb858439031$var$node;

});

parcelRegister("kBVSc", function(module, exports) {

$parcel$export(module.exports, "getProductOfferingKey", () => $be42b0ac3d2a5c45$export$581b2a05d59c1826);
$parcel$export(module.exports, "getProductOfferingKeyForProject", () => $be42b0ac3d2a5c45$export$3ad43d25ded909ee);
$parcel$export(module.exports, "getProductOfferingKeyOrThrow", () => $be42b0ac3d2a5c45$export$92c311d982d129d5);


var $34FZy = parcelRequire("34FZy");
// Please don't use access these directly, try to implement these using common platform types such as below
const $be42b0ac3d2a5c45$var$JSW_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed',
    STANDARD_EDITION: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526',
    PREMIUM_EDITION: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
    UNLICENSED: null
};
const $be42b0ac3d2a5c45$var$JPD_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: 'd843dd9e-23c5-4d27-af44-5009d568cb6e',
    STANDARD_EDITION: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
    PREMIUM_EDITION: 'f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd',
    UNLICENSED: null
};
const $be42b0ac3d2a5c45$var$JSM_PRODUCT_OFFERING_KEYS = {
    FREE_EDITION: '24656f1f-5c14-45ea-88ea-142b9c633661',
    STANDARD_EDITION: '396efb16-749b-41fa-9cd1-ad10cfefa1d0',
    PREMIUM_EDITION: '0c6683b4-4633-4673-beca-690d171de6a5',
    UNLICENSED: null
};
const $be42b0ac3d2a5c45$export$581b2a05d59c1826 = (applicationKey, applicationEdition)=>{
    switch(applicationKey){
        case 0, $2edfd53057852e41$export$1346c9aa3cbb477d:
            return $be42b0ac3d2a5c45$var$JSW_PRODUCT_OFFERING_KEYS[applicationEdition];
        case 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61:
            return $be42b0ac3d2a5c45$var$JSM_PRODUCT_OFFERING_KEYS[applicationEdition];
        case 0, $2edfd53057852e41$export$202f50ee62667e32:
            return $be42b0ac3d2a5c45$var$JPD_PRODUCT_OFFERING_KEYS[applicationEdition];
        // can support more products if implemented in future
        default:
            return null;
    }
};
const $be42b0ac3d2a5c45$export$3ad43d25ded909ee = (project, edition)=>{
    const application = (0, $34FZy.projectToApplicationKey)(project);
    const offeringKey = $be42b0ac3d2a5c45$export$581b2a05d59c1826(application, edition);
    if (offeringKey === null) throw new Error(`Missing offering key for: ${application} ${edition}`);
    return offeringKey;
};
const $be42b0ac3d2a5c45$export$92c311d982d129d5 = (applicationKey, applicationEdition)=>{
    const offeringKey = $be42b0ac3d2a5c45$export$581b2a05d59c1826(applicationKey, applicationEdition);
    if (offeringKey === null) throw new Error(`Missing offering key for: ${applicationKey} ${applicationEdition}`);
    return offeringKey;
};

});
parcelRegister("34FZy", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $060274e6e50e467d$export$954628993bf3188e);
$parcel$export(module.exports, "projectToApplicationKey", () => $060274e6e50e467d$export$1af4fd6f5c543149);

var $7ZZxN = parcelRequire("7ZZxN");

const $060274e6e50e467d$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $060274e6e50e467d$export$954628993bf3188e = (trialEndTime)=>trialEndTime && Math.ceil(($060274e6e50e467d$export$9dbbf537dffaafc7(trialEndTime) - Date.now()) / 86400000);
const $060274e6e50e467d$export$271517afaa0c15eb = (trialEndTime)=>{
    const trialDaysLeft = $060274e6e50e467d$export$954628993bf3188e(trialEndTime);
    // Technically we do not know whether user is in grace period or not, but if user is able to access the Jira with no payment details
    // and is trialEndTime is missing or over we assume that site is in grace period
    return !trialDaysLeft || trialDaysLeft < 0;
};
const $060274e6e50e467d$export$1af4fd6f5c543149 = (project)=>{
    switch(project){
        // With spork, we should update core projects as it they were Software projects
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        case 0, $7ZZxN.CORE_PROJECT:
            return 0, $2edfd53057852e41$export$1346c9aa3cbb477d;
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return 0, $2edfd53057852e41$export$202f50ee62667e32;
        default:
            throw new Error(`Unsupported project: ${project}`);
    }
};

});


parcelRegister("6g2XI", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointPressableTrigger", () => $0e824343798e0aa9$export$defad645fcc21c0a);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $aVkzK = parcelRequire("aVkzK");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $1zbEq = parcelRequire("1zbEq");

var $kGQen = parcelRequire("kGQen");

var $ioLN0 = parcelRequire("ioLN0");

var $3qf87 = parcelRequire("3qf87");

var $ln3W8 = parcelRequire("ln3W8");

var $5s6G4 = parcelRequire("5s6G4");

var $2tNPJ = parcelRequire("2tNPJ");
const $0e824343798e0aa9$var$emptyObject = {};
function $0e824343798e0aa9$export$defad645fcc21c0a({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal = false }) {
    const { openModal: openModal } = (0, $eUqFw.useContext)((0, $3qf87.ModalContext));
    const environmentProvider = (0, $ln3W8.useJiraRelayEnvironmentProvider)();
    // eslint-disable-next-line jira/ufo/valid-labels
    const pressTracing = (0, $5s6G4.default)(interactionName ?? '');
    const load = (0, $eUqFw.useCallback)(()=>(0, $iWLL0.loadEntryPoint)(environmentProvider, entryPoint, // @ts-expect-error TS cannot infer that emptyObject is the correct params
        // type for TEntryPoint even when performing an explicit undefined check
        entryPointParams ?? $0e824343798e0aa9$var$emptyObject), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onBeforeLoad = (0, $eUqFw.useCallback)(()=>{
        if (interactionName) pressTracing();
    }, [
        interactionName,
        pressTracing
    ]);
    const onLoad = (0, $eUqFw.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallbackInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null));
            const defaultFallback = useInternalModal ? defaultFallbackInner : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
                onClose: closeModal,
                width: modalProps?.width,
                height: modalProps?.height
            }, defaultFallbackInner);
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorAttributes: errorAttributes,
                errorFallback: "flag",
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                // @ts-expect-error Need to fix the types on this
                id: entryPoint.root.getModuleName?.() ?? 'unknown',
                placeholderName: "modal-entry-point-pressable-trigger-container",
                // @ts-expect-error Some type mismatch, should fix it one day
                runtimeProps: {
                    ...entryPointProps ?? $0e824343798e0aa9$var$emptyObject,
                    onClose: onClose
                }
            });
            return useInternalModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
                ...modalProps,
                onClose: onClose
            }, container)) : container;
        });
    }, [
        entryPoint,
        entryPointProps,
        errorAttributes,
        Fallback,
        openModal,
        title,
        modalProps,
        useInternalModal
    ]);
    const triggerRef = (0, $2tNPJ.usePressablePreloadRef)({
        load: load,
        onBeforeLoad: onBeforeLoad,
        onLoad: onLoad
    });
    return children({
        ref: triggerRef
    });
}

});
parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("2tNPJ", function(module, exports) {

$parcel$export(module.exports, "usePressablePreloadRef", () => $a271f016a6ca8b83$export$1ff47f24e06a5d2d);

var $eUqFw = parcelRequire("eUqFw");
const $a271f016a6ca8b83$var$PRELOAD_MAX_AGE = 2000;
const $a271f016a6ca8b83$var$TIME_TO_INTENT = 200;
function $a271f016a6ca8b83$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $a271f016a6ca8b83$var$PRELOAD_MAX_AGE);
            }, $a271f016a6ca8b83$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});


parcelRegister("g4G5S", function(module, exports) {

$parcel$export(module.exports, "useProductEntitlementDetails", () => $c8efb20e27e18352$export$e02d6385b5d47f5d);

var $gd0Sp = parcelRequire("gd0Sp");
const $c8efb20e27e18352$export$e02d6385b5d47f5d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.productEntitlementDetails || null;
};

});

parcelRegister("kI9bU", function(module, exports) {

$parcel$export(module.exports, "useShouldSeeButton", () => $d1a7977354b9e1b2$export$dc0322901b5ae67b);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
/**
 * Experiment specific code to be removed during cleanup
 */ const $d1a7977354b9e1b2$var$trackJDPFreeToStandardExposure = ({ createAnalyticsEvent: createAnalyticsEvent, applicationKey: applicationKey, applicationEdition: applicationEdition })=>{
    const cohort = (0, $79xbN.expVal)('jpd-free-to-upgrade-pill-au-awareness', 'cohort', 'not-enrolled');
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
        type: 'sendTrackEvent',
        action: 'exposed',
        actionSubject: 'feature'
    }), 'feature exposed', 'editionAwarenessButton', {
        flagKey: 'jpd-free-to-upgrade-pill-au-awareness',
        value: cohort,
        growthInitiative: 'transmuters',
        applicationKey: applicationKey,
        applicationEdition: applicationEdition
    });
};
/**
 * Experiment specific code to be removed during cleanup
 */ const $d1a7977354b9e1b2$var$useShouldSeeJPDFreeToStandardExperiment = ({ applicationKey: applicationKey, applicationEdition: applicationEdition, canUpgrade: canUpgrade })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [config] = (0, $79xbN.UNSAFE_noExposureExp)('jpd-free-to-upgrade-pill-au-awareness');
    const cohort = config.get('cohort', 'not-enrolled');
    const isEnrolled = cohort !== 'not-enrolled';
    const shouldSeeButton = canUpgrade && applicationKey === 'jira-product-discovery' && applicationEdition === 'FREE_EDITION';
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnrolled) return;
        if (!shouldSeeButton) return;
        $d1a7977354b9e1b2$var$trackJDPFreeToStandardExposure({
            createAnalyticsEvent: createAnalyticsEvent,
            applicationEdition: applicationEdition,
            applicationKey: applicationKey
        });
    }, [
        isEnrolled,
        createAnalyticsEvent,
        applicationEdition,
        applicationKey,
        shouldSeeButton
    ]);
    return cohort === 'variation' && shouldSeeButton;
};
/**
 * Experiment specific code to be removed during cleanup
 */ const $d1a7977354b9e1b2$var$trackJSMFreeToStandardExposure = ({ createAnalyticsEvent: createAnalyticsEvent, applicationKey: applicationKey, applicationEdition: applicationEdition })=>{
    const cohort = (0, $79xbN.expVal)('jsm-auto-upgrade-awareness', 'cohort', 'not-enrolled');
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
        type: 'sendTrackEvent',
        action: 'exposed',
        actionSubject: 'feature'
    }), 'feature exposed', 'editionAwarenessButton', {
        flagKey: 'jsm-auto-upgrade-awareness',
        value: cohort,
        growthInitiative: 'transmuters',
        applicationKey: applicationKey,
        applicationEdition: applicationEdition
    });
};
/**
 * Experiment specific code to be removed during cleanup
 */ const $d1a7977354b9e1b2$var$useShouldSeeJSMFreeToStandardExperiment = ({ applicationKey: applicationKey, applicationEdition: applicationEdition, canUpgrade: canUpgrade })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [config] = (0, $79xbN.UNSAFE_noExposureExp)('jsm-auto-upgrade-awareness');
    const cohort = config.get('cohort', 'not-enrolled');
    const isEnrolled = cohort !== 'not-enrolled';
    const shouldSeeButton = canUpgrade && applicationKey === 'jira-servicedesk' && applicationEdition === 'FREE_EDITION';
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnrolled) return;
        if (!shouldSeeButton) return;
        $d1a7977354b9e1b2$var$trackJSMFreeToStandardExposure({
            createAnalyticsEvent: createAnalyticsEvent,
            applicationEdition: applicationEdition,
            applicationKey: applicationKey
        });
    }, [
        isEnrolled,
        createAnalyticsEvent,
        applicationEdition,
        applicationKey,
        shouldSeeButton
    ]);
    return cohort === 'variation' && shouldSeeButton;
};
const $d1a7977354b9e1b2$export$dc0322901b5ae67b = ({ applicationKey: applicationKey, applicationEdition: applicationEdition, canUpgrade: canUpgrade })=>{
    const shouldSeeJPDFreeToStandardExperiment = $d1a7977354b9e1b2$var$useShouldSeeJPDFreeToStandardExperiment({
        applicationEdition: applicationEdition,
        applicationKey: applicationKey,
        canUpgrade: canUpgrade
    });
    const shouldSeeJSMFreeToStandardExperiment = $d1a7977354b9e1b2$var$useShouldSeeJSMFreeToStandardExperiment({
        applicationEdition: applicationEdition,
        applicationKey: applicationKey,
        canUpgrade: canUpgrade
    });
    if (shouldSeeJPDFreeToStandardExperiment || shouldSeeJSMFreeToStandardExperiment) return true;
    return false;
};

});

parcelRegister("aqRlR", function(module, exports) {

$parcel$export(module.exports, "FreePill", () => $bc3384b1e209a21b$export$517557a682bf3d22);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $79xbN = parcelRequire("79xbN");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $1R3n5 = parcelRequire("1R3n5");

var $apShl = parcelRequire("apShl");

var $dv4eA = parcelRequire("dv4eA");

var $6ZNt9 = parcelRequire("6ZNt9");

var $4g1cY = parcelRequire("4g1cY");

var $aaZm6 = parcelRequire("aaZm6");
function $bc3384b1e209a21b$export$517557a682bf3d22(props) {
    const { projectType: projectType, siteHasJswOnly: siteHasJswOnly } = props;
    if (projectType === (0, $7ZZxN.CORE_PROJECT) && !siteHasJswOnly) throw new Error('CORE_PROJECT is only supported for Jira Software only sites');
    const projectTypeToUpgrade = projectType === (0, $7ZZxN.CORE_PROJECT) ? (0, $7ZZxN.SOFTWARE_PROJECT) : projectType;
    const { userCanView: userCanView, billingSourceSystem: billingSourceSystem, isBillingAdmin: isBillingAdmin } = (0, $aaZm6.useCheckEditionAwarenessRequisites)({
        projectType: projectTypeToUpgrade
    });
    if (userCanView === undefined || isBillingAdmin === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "edition-awareness-requisites-loading"
    });
    if (userCanView) {
        if (projectType === (0, $7ZZxN.CORE_PROJECT)) {
            // For CONTROL and NOT-ENROLLED we are not showing the pill, but using the funtion to fire the exposure
            if (!(0, $79xbN.expValEquals)('edition_awareness_on_jwm', 'isEnabled', true)) return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc3384b1e209a21b$var$EditionAwarenessFreePill, {
            projectType: projectTypeToUpgrade,
            billingSourceSystem: billingSourceSystem,
            isBillingAdmin: isBillingAdmin,
            siteHasJswOnly: siteHasJswOnly
        });
    }
    return null;
}
function $bc3384b1e209a21b$var$EditionAwarenessFreePill(props) {
    const { projectType: projectType, billingSourceSystem: billingSourceSystem, isBillingAdmin: isBillingAdmin, siteHasJswOnly: siteHasJswOnly } = props;
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            billingSourceSystem: billingSourceSystem,
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: isBillingAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv4eA.EditionAwarenessContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc3384b1e209a21b$var$ButtonForProduct, {
        projectType: projectType,
        siteHasJswOnly: siteHasJswOnly
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "editionAwarenessFreePill"
    })));
}
function $bc3384b1e209a21b$var$ButtonForProduct(props) {
    const { projectType: projectType, siteHasJswOnly: siteHasJswOnly } = props;
    return projectType === (0, $7ZZxN.SOFTWARE_PROJECT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4g1cY.UsersRemainingCtaButton), {
        projectType: projectType,
        siteHasJswOnly: siteHasJswOnly
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ZNt9.EditionAwarenessCtaButton), null);
}

});
parcelRegister("dv4eA", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessContainer", () => $d3de0093151a4469$export$cf82788c7ae9c400);
$parcel$export(module.exports, "EATopNavAnimatedButtonContainer", () => $d3de0093151a4469$export$9dd5ec29fa7b42c5);
$parcel$export(module.exports, "EATopNavPillCss", () => $d3de0093151a4469$export$ab6aa6c8d30bef15);
$parcel$export(module.exports, "EATopNavPillTheme", () => $d3de0093151a4469$export$1ec138ad4719cfee);
$parcel$export(module.exports, "IconWrapper", () => $d3de0093151a4469$export$be58b4326e23250f);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $d3de0093151a4469$export$cf82788c7ae9c400 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1y6m _zulpu2gc _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $d3de0093151a4469$export$71b6aed4f8256b2 = "var(--ds-background-discovery-bold-pressed, #352C63)";
const $d3de0093151a4469$export$c9d89eb8e0b59a5a = "var(--ds-background-selected-bold-pressed, #09326C)";
const $d3de0093151a4469$export$d4accc94291dcf84 = "var(--ds-chart-purple-boldest, #5E4DB2)";
const $d3de0093151a4469$export$16a15d5a9b73591b = "var(--ds-chart-blue-boldest, #0055CC)";
const $d3de0093151a4469$export$6836610752de4c9b = 16;
const $d3de0093151a4469$var$EATopNavExperimentGradientBorderStyles = {
    borderRadius: '3px',
    border: `1px solid ${`var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$export$147899de772240ec)})`}`,
    // 1px padding needed to show a gradient border
    padding: '1px',
    display: 'inline-flex',
    height: '30px',
    '&:hover': {
        background: `linear-gradient(45deg,
              ${$d3de0093151a4469$export$d4accc94291dcf84} 0%,
              ${$d3de0093151a4469$export$16a15d5a9b73591b} 100%)`
    },
    '&:active': {
        background: `linear-gradient(45deg,
              ${$d3de0093151a4469$export$71b6aed4f8256b2} 0%,
              ${$d3de0093151a4469$export$c9d89eb8e0b59a5a} 100%)`
    }
};
const $d3de0093151a4469$var$sparkleAnimation = null;
const $d3de0093151a4469$var$sparkleAnimationProperties = {
    animationName: $d3de0093151a4469$var$sparkleAnimation,
    animationDuration: '2s',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite',
    transformOrigin: 'center',
    transformBox: 'fill-box'
};
const $d3de0093151a4469$export$9dd5ec29fa7b42c5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _19it97ho _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y _4t3i1ul9 _19lc1nic _kqwlk6ij _nrflymdr _1yzo1ytf _1g1e12c5 _e03k1h6o _tjnb1spj _bd4yk6ij _1t38ymdr _117t1ytf _wasv12c5 _158u1h6o _mgxm1spj _ddpz1bs3 _13wwidpf _j6xte2ew",
            __cmplp.className
        ])
    });
});
const $d3de0093151a4469$export$ab6aa6c8d30bef15 = {
    display: 'inline-flex',
    alignItems: 'center',
    border: 'none',
    gap: "var(--ds-space-050, 4px)",
    borderRadius: '3px',
    transition: 'all 0.3s ease-in-out 0s',
    backgroundColor: `${`var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`}`,
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    color: `${"var(--ds-background-accent-purple-bolder, #6E5DC6)"}`,
    '> span': {
        margin: '0px'
    },
    '&:hover': {
        cursor: 'pointer',
        '& span': {
            color: `${`var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`}`
        },
        background: `linear-gradient(45deg,
              ${$d3de0093151a4469$export$d4accc94291dcf84} 0%,
              ${$d3de0093151a4469$export$16a15d5a9b73591b} 100%)`,
        textDecoration: 'none'
    },
    '&:active': {
        cursor: 'pointer',
        color: `${`var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`}`,
        '& span': {
            color: `${`var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`}`
        },
        background: `linear-gradient(45deg,
              ${$d3de0093151a4469$export$71b6aed4f8256b2} 0%,
              ${$d3de0093151a4469$export$c9d89eb8e0b59a5a} 100%)`
    }
};
const $d3de0093151a4469$export$1ec138ad4719cfee = (currentTheme, themeProps)=>{
    const theme = currentTheme(themeProps);
    return {
        ...theme,
        buttonStyles: {
            ...$d3de0093151a4469$export$ab6aa6c8d30bef15
        }
    };
};
const $d3de0093151a4469$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1b66",
            __cmplp.className
        ])
    });
});

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';


parcelRegister("6ZNt9", function(module, exports) {

$parcel$export(module.exports, "EditionAwarenessCtaButton", () => $c2f48189def32433$export$ebccf7539146cc49);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $l3Qg0 = parcelRequire("l3Qg0");

var $3q7Yq = parcelRequire("3q7Yq");

var $6j4bv = parcelRequire("6j4bv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4pZMA = parcelRequire("4pZMA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eibfs = parcelRequire("eibfs");

var $dWLk9 = parcelRequire("dWLk9");

var $dv4eA = parcelRequire("dv4eA");

var $hUkPA = parcelRequire("hUkPA");
function $c2f48189def32433$export$ebccf7539146cc49() {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const entryPoint = (0, $6j4bv.useEntryPoint)((0, $4pZMA.jsmUpsellModalEntryPoint), {
        cloudIds: [
            cloudId
        ]
    });
    const triggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPoint.entryPointActions);
    const fireButtonAnalytics = (0, $eUqFw.useCallback)((action)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: action,
            actionSubject: 'button'
        }), 'editionAwarenessFreePill', {});
    }, [
        createAnalyticsEvent
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        fireButtonAnalytics('clicked');
    }, [
        fireButtonAnalytics
    ]);
    const onHoverButton = (0, $eUqFw.useCallback)(()=>{
        fireButtonAnalytics('hovered');
    }, [
        fireButtonAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv4eA.EATopNavAnimatedButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv4eA.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eibfs.default), {
            label: ""
        })),
        onClick: onClick,
        theme: (0, $dv4eA.EATopNavPillTheme),
        onMouseEnter: onHoverButton,
        ref: triggerRef,
        interactionName: "edition-awareness-free-pill",
        testId: "navigation-apps-sidebar-edition-awareness.ui.free-pill.edition-awareness-cta-button.edition-awareness-free-pill-cta-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $c2f48189def32433$var$eaTopNavButtonTextStyles
    }, formatMessage((0, $hUkPA.default).upgradeToStandardCtaLabel)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPoint.entryPointReferenceSubject,
        id: "jsm-upsell-modal",
        packageName: "edition-awareness",
        teamName: "growth-tako",
        runtimeProps: {},
        entryPointActions: entryPoint.entryPointActions
    }));
}
const $c2f48189def32433$var$eaTopNavButtonTextStyles = (0, $1ZAYh.xcss)({
    font: 'font.body',
    color: 'color.text.accent.blue'
});

});
parcelRegister("l3Qg0", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $c6e813dbc513f02a$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $c6e813dbc513f02a$export$5f13515bd3a35325);

var $eUqFw = parcelRequire("eUqFw");

var $a9frS = parcelRequire("a9frS");
const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions))=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $a9frS.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        eventMap,
        isActive
    ]);
};
const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("a9frS", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $592b51d0c18fde03$export$15257a36a7e3f9d6);
function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("3q7Yq", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $79aee538140aeba6$export$4d67c6ee49f3d14d);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $P6D7Q = parcelRequire("P6D7Q");

var $ioLN0 = parcelRequire("ioLN0");
const $79aee538140aeba6$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("4pZMA", function(module, exports) {

$parcel$export(module.exports, "jsmUpsellModalEntryPoint", () => $565398a9973a09ce$export$744f919e2acd7bff);

var $kUZPe = parcelRequire("kUZPe");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $565398a9973a09ce$export$744f919e2acd7bff = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("bezdB")), {
        moduleId: "5c4ccabb"
    }),
    getPreloadProps: ({ cloudIds: cloudIds })=>({
            queries: {
                getStartStandardTrialUrlQuery: {
                    parameters: (0, $kUZPe.default),
                    variables: {
                        cloudIds: cloudIds
                    }
                }
            }
        })
});

});
parcelRegister("kUZPe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6a24befaa415255$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e255cf3013a7ce8250a609ddf75552a7>>
 * @relayHash d544cdd2979e6cb27ef690146df66d84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fdb5a6382858635ab5da13fa22046a4f68383872329b6a08688ec6a38e4922d
const $b6a24befaa415255$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2fdb5a6382858635ab5da13fa22046a4f68383872329b6a08688ec6a38e4922d",
        "metadata": {},
        "name": "uiGrowthJsmUpsellModal_GetStartStandardTrialUrlQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b6a24befaa415255$export$2e2bcd8739ae039 = $b6a24befaa415255$var$node;

});

parcelRegister("bezdB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("flFso")
]).then(()=>parcelRequire('dwKIb'));

});


parcelRegister("eibfs", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1484f3cbec2be4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $fb1484f3cbec2be4$var$SparkleGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "starMain",
        fillRule: "evenodd",
        d: "m5.184 1.921-1.28 3.244L.664 6.443a.52.52 0 0 0 0 .966l3.242 1.279 1.279 3.242a.52.52 0 0 0 .967 0l1.278-3.242 3.242-1.28a.52.52 0 0 0 0-.966L7.43 5.165 6.15 1.92a.517.517 0 0 0-.69-.285.519.519 0 0 0-.276.285Z",
        clipRule: "evenodd",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "starBottomRight",
        fillRule: "evenodd",
        d: "m10.246 9.237-.496 1.255-1.255.496a.37.37 0 0 0-.205.494c.04.09.113.162.205.198l1.255.495.496 1.256a.373.373 0 0 0 .692 0l.496-1.256 1.255-.495a.371.371 0 0 0 0-.692l-1.255-.496-.496-1.255a.369.369 0 0 0-.494-.205.373.373 0 0 0-.198.205Z",
        clipRule: "evenodd",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "starTopRight",
        fillRule: "evenodd",
        d: "m10.715.568-.495 1.257-1.256.496a.373.373 0 0 0 0 .692l1.256.495.495 1.257a.372.372 0 0 0 .692 0l.497-1.257 1.255-.495a.371.371 0 0 0 0-.692l-1.255-.496L11.407.57a.367.367 0 0 0-.209-.21.375.375 0 0 0-.483.209Z",
        clipRule: "evenodd",
        fill: "currentColor"
    }));
const $fb1484f3cbec2be4$var$SparkleIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $fb1484f3cbec2be4$var$SparkleGlyph,
        ...props
    });
var $fb1484f3cbec2be4$export$2e2bcd8739ae039 = $fb1484f3cbec2be4$var$SparkleIcon;

});

parcelRegister("hUkPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5150f22f4863525$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a5150f22f4863525$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    upgradeToStandardCtaLabel: {
        "id": "navigation-apps-sidebar-edition-awareness.free-pill.edition-awareness-cta-button.upgrade-to-standard-cta-label",
        "defaultMessage": "Upgrade"
    }
});

});


parcelRegister("4g1cY", function(module, exports) {

$parcel$export(module.exports, "UsersRemainingCtaButton", () => $6d8e1c59092088cd$export$426d5e998fcc59ac);

var $eUqFw = parcelRequire("eUqFw");

var $l3Qg0 = parcelRequire("l3Qg0");

var $3q7Yq = parcelRequire("3q7Yq");

var $6j4bv = parcelRequire("6j4bv");

var $79xbN = parcelRequire("79xbN");

var $2xUB7 = parcelRequire("2xUB7");

var $fegKV = parcelRequire("fegKV");

var $lz30I = parcelRequire("lz30I");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $dWLk9 = parcelRequire("dWLk9");

var $1R3n5 = parcelRequire("1R3n5");


var $g3rId = parcelRequire("g3rId");
function $6d8e1c59092088cd$export$426d5e998fcc59ac(props) {
    const { projectType: projectType, siteHasJswOnly: siteHasJswOnly } = props;
    const isUsingCcp = (0, $lz30I.useIsProductUsingCcp)(projectType);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const shouldUseCache = (0, $eUqFw.useCallback)((userCountData)=>userCountData.unitCount < (0, $0a36f00f767f9fa2$export$37efcda5d411f9dc), []);
    const { data: data } = (0, $2xUB7.useGetJswUserCount)({
        cloudId: cloudId,
        shouldUseCache: shouldUseCache,
        skip: !isSiteAdmin
    });
    const userCount = data?.unitCount;
    // Fire viewed analytics once on initial render
    (0, $eUqFw.useEffect)(()=>{
        if (userCount !== undefined) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'button'
        }), 'usersRemainingFreePill', {
            userCount: userCount
        });
    }, [
        createAnalyticsEvent,
        userCount
    ]);
    const fireButtonAnalytics = (0, $eUqFw.useCallback)((action)=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: action,
            actionSubject: 'button'
        }), 'editionAwarenessFreePill', {
            userCount: userCount
        }), [
        createAnalyticsEvent,
        userCount
    ]);
    const onButtonClick = ()=>fireButtonAnalytics('clicked');
    const onHoverButton = ()=>fireButtonAnalytics('hovered');
    const [mustBnConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_upgrade_skip_trial_buy_now');
    const jswBuyNowExperimentCohort = (0, $eUqFw.useMemo)(()=>mustBnConfig.get('cohort', 'not-enrolled'), [
        mustBnConfig
    ]);
    const isCcpJswOnlySite = isUsingCcp && siteHasJswOnly;
    const shouldRequestSkipTrialFields = isCcpJswOnlySite && jswBuyNowExperimentCohort !== 'not-enrolled';
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $fegKV.jswUpsellModalEntryPoint), {
        cloudIds: [
            cloudId
        ],
        shouldRequestSkipTrialFields: shouldRequestSkipTrialFields
    });
    const triggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    const Button = $6d8e1c59092088cd$var$getUsersRemainingButton(userCount);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Button, {
        triggerRef: triggerRef,
        onButtonClick: onButtonClick,
        onHoverButton: onHoverButton
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jsw-upsell-modal",
        packageName: "edition-awareness",
        teamName: "growth-tako",
        runtimeProps: {
            shouldRequestSkipTrialFields: shouldRequestSkipTrialFields
        },
        entryPointActions: entryPointActions
    }));
}
const $6d8e1c59092088cd$var$getUsersRemainingButton = (userCount)=>{
    if (userCount === undefined) return 0, $g3rId.UpgradeButton;
    // 10 user limit, show "No Users Left" button
    if (userCount >= (0, $0a36f00f767f9fa2$export$37efcda5d411f9dc)) return 0, $g3rId.NoUsersLeftButton;
    // 7-9 users show "Limited Users Left" button
    if (userCount >= (0, $0a36f00f767f9fa2$export$71bbf33843c4812a) && userCount < (0, $0a36f00f767f9fa2$export$37efcda5d411f9dc)) return 0, $g3rId.LimitedUsersLeftButton;
    return 0, $g3rId.UpgradeButton;
};

});
parcelRegister("2xUB7", function(module, exports) {

$parcel$export(module.exports, "useGetJswUserCount", () => $73f6bd88062821ef$export$69ca982bc6a05f52);

var $eUqFw = parcelRequire("eUqFw");

var $aZaPn = parcelRequire("aZaPn");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $g4G5S = parcelRequire("g4G5S");

const $73f6bd88062821ef$var$jiraEntitlementFilter = (entitlement)=>entitlement.productKey === 'jira-software.ondemand' || entitlement.productKey === 'jira-software.ondemand.billedinccp';
const $73f6bd88062821ef$var$userUsageFilter = (usages)=>usages.unitType === 'USER';
const $73f6bd88062821ef$var$jswUserCountLocalStorage = (0, $aZaPn.createLocalExpirableStorageProvider)('jsw-user-count');
const $73f6bd88062821ef$var$JSW_USER_COUNT_CACHE_KEY = 'jswUserCount';
const $73f6bd88062821ef$var$JSW_USER_COUNT_CACHE_EXPIRY_MS = 86400000; // One day
function $73f6bd88062821ef$export$9f4725d8995b98a0() {
    const cachedValue = $73f6bd88062821ef$var$jswUserCountLocalStorage.get($73f6bd88062821ef$var$JSW_USER_COUNT_CACHE_KEY);
    if (cachedValue?.unitCount !== undefined && cachedValue?.unitLimit !== undefined) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return cachedValue;
    return undefined;
}
function $73f6bd88062821ef$var$setCachedUserCountData(data) {
    $73f6bd88062821ef$var$jswUserCountLocalStorage.set($73f6bd88062821ef$var$JSW_USER_COUNT_CACHE_KEY, data, Date.now() + $73f6bd88062821ef$var$JSW_USER_COUNT_CACHE_EXPIRY_MS);
}
const $73f6bd88062821ef$export$69ca982bc6a05f52 = ({ cloudId: cloudId, shouldUseCache: shouldUseCache, skip: skip = false })=>{
    const productEntitlementDetails = (0, $g4G5S.useProductEntitlementDetails)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)();
    const [data, setData] = (0, $eUqFw.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (skip) return;
        const jswProductEntitlementDetails = productEntitlementDetails?.['jira-software'];
        // Return data = undefined if the site does not have JSW enabled
        if (!jswProductEntitlementDetails) return;
        setLoading(true);
        const cachedData = $73f6bd88062821ef$export$9f4725d8995b98a0();
        if (cachedData && shouldUseCache?.(cachedData)) {
            setData(cachedData);
            setLoading(false);
            return;
        }
        (0, $2OdyW.default)(`/gateway/api/billing-ux/cloud/${cloudId}/billing/entitlement-group-detail`).then((response)=>{
            // TAKO-1035 Temp operational event to help debug unitCount/unitLimit error
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useGetJswUserCount called', {
                entitlementGroupDetail: JSON.stringify(response),
                productEntitlementDetails: JSON.stringify(productEntitlementDetails)
            });
            let unitCount = 0;
            let unitLimit = 0;
            // On CCP, we don't have the unit count on the rest response so use the one from tenantContext (useProductEntitlementDetails)
            // Note: unitCount from tenantContext is defined as "Number of users allowed on site under current edition"
            // Do not confuse this with the unitCount returned in the API response, as that is the current number of users added to the site
            unitLimit = jswProductEntitlementDetails?.unitCount ?? 0;
            const jiraEntitlement = response.entitlements.find($73f6bd88062821ef$var$jiraEntitlementFilter);
            if (jiraEntitlement) {
                const usage = jiraEntitlement.usages.find($73f6bd88062821ef$var$userUsageFilter);
                if (usage) unitCount = usage.unitCount;
            }
            if (unitCount === 0 || unitLimit === 0) // unitCount and unitLimit should not be 0
            (0, $guiFP.default)({
                error: new Error(`unitCount or unitLimit is 0. unitCount: ${unitCount}, unitLimit: ${unitLimit}`),
                meta: {
                    id: 'useGetJswUserCount-zero-unitCount-or-unitLimit',
                    packageName: (0, $556d3824e23bb4a1$export$b8b9d90f9e5bd72b),
                    teamName: 'growth-tako'
                }
            });
            const userCountData = {
                unitCount: unitCount,
                unitLimit: unitLimit
            };
            setData(userCountData);
            $73f6bd88062821ef$var$setCachedUserCountData(userCountData);
        }).catch((e)=>{
            setError(e);
            (0, $guiFP.default)({
                error: e,
                meta: {
                    id: 'useGetJswUserCount',
                    packageName: (0, $556d3824e23bb4a1$export$b8b9d90f9e5bd72b),
                    teamName: 'growth-tako'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }).finally(()=>{
            setLoading(false);
        });
    }, [
        cloudId,
        createAnalyticsEvent,
        productEntitlementDetails,
        shouldUseCache,
        skip
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};

});
const $556d3824e23bb4a1$export$b8b9d90f9e5bd72b = 'jiraGrowthUtils';


parcelRegister("fegKV", function(module, exports) {

$parcel$export(module.exports, "jswUpsellModalEntryPoint", () => $7348d2c6a63cedcf$export$482106168ab726c5);

var $55a18 = parcelRequire("55a18");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $7348d2c6a63cedcf$export$482106168ab726c5 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("6Thvs")), {
        moduleId: "bc88d891"
    }),
    getPreloadProps: ({ cloudIds: cloudIds, shouldRequestSkipTrialFields: shouldRequestSkipTrialFields })=>({
            queries: {
                getStartStandardTrialUrlQuery: {
                    parameters: (0, $55a18.default),
                    variables: {
                        cloudIds: cloudIds,
                        shouldRequestSkipTrialFields: shouldRequestSkipTrialFields
                    }
                }
            }
        })
});

});
parcelRegister("55a18", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b6e6a8d7eacdd79$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2daf3618f696f43e5e1f2e4fa119ae7c>>
 * @relayHash 953459768600cdd3b7d57605eca95700
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe1f7ce057d6ef9e8a31dfb04c8b8966c1233f4666bdb972e6dc959a9cd84e8b
const $5b6e6a8d7eacdd79$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fe1f7ce057d6ef9e8a31dfb04c8b8966c1233f4666bdb972e6dc959a9cd84e8b",
        "metadata": {},
        "name": "uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery",
        "operationKind": "query",
        "text": null
    }
};
var $5b6e6a8d7eacdd79$export$2e2bcd8739ae039 = $5b6e6a8d7eacdd79$var$node;

});

parcelRegister("6Thvs", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("68ppp")
]).then(()=>parcelRequire('2n4xK'));

});


parcelRegister("lz30I", function(module, exports) {

$parcel$export(module.exports, "useIsJswUsingCcp", () => $28864e7243af65fc$export$f8e1c288fefa6e7d);
$parcel$export(module.exports, "useIsProductUsingCcp", () => $28864e7243af65fc$export$b367e04990bbb76d);
$parcel$export(module.exports, "useLoggedInPage", () => $28864e7243af65fc$export$a7ca0608784708a1);
$parcel$export(module.exports, "getTrialDaysLeft", () => $28864e7243af65fc$export$954628993bf3188e);
$parcel$export(module.exports, "isInGracePeriod", () => $28864e7243af65fc$export$271517afaa0c15eb);

var $bW292 = parcelRequire("bW292");

var $7ZZxN = parcelRequire("7ZZxN");

var $cWiVr = parcelRequire("cWiVr");


var $gd0Sp = parcelRequire("gd0Sp");
function $28864e7243af65fc$export$f8e1c288fefa6e7d() {
    const { productEntitlementDetails: productEntitlementDetails } = (0, $gd0Sp.useTenantContext)();
    const jswEntitlement = productEntitlementDetails?.[0, $2edfd53057852e41$export$1346c9aa3cbb477d];
    return jswEntitlement?.billingSourceSystem === 'CCP';
}
function $28864e7243af65fc$export$b367e04990bbb76d(projectType) {
    const { productEntitlementDetails: productEntitlementDetails } = (0, $gd0Sp.useTenantContext)();
    const productKey = (0, $7ZZxN.projectTypeToCanonicalId)(projectType);
    const productEntitlement = productEntitlementDetails?.[productKey];
    return productEntitlement?.billingSourceSystem === 'CCP';
}
function $28864e7243af65fc$export$a7ca0608784708a1({ pageUrl: pageUrl }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { data: currentUserData } = (0, $cWiVr.useCurrentUser)();
    const encodedPageUrl = encodeURIComponent(pageUrl);
    // The user email should always be available unless the user is anonymous, in which case they won't see the edition awareness pill anyway
    const encodedUserEmail = encodeURIComponent(currentUserData.user.emailAddress ?? '');
    // This URL will take them through the login flow (if necessary) then redirect them to the given (encoded) `pageUrl`.
    return `https://${(0, $bW292.getATLContextDomain)('id')}/login?continue=${encodedPageUrl}&login_hint=${encodedUserEmail}&prompt=none`;
}
const $28864e7243af65fc$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $28864e7243af65fc$export$954628993bf3188e = (currentDate, trialEndTime)=>trialEndTime ? Math.ceil(($28864e7243af65fc$export$9dbbf537dffaafc7(trialEndTime) - currentDate) / 86400000) : undefined;
const $28864e7243af65fc$export$271517afaa0c15eb = (currentDate, trialEndTime)=>{
    const trialDaysLeft = $28864e7243af65fc$export$954628993bf3188e(currentDate, trialEndTime);
    // Technically we do not know whether user is in grace period or not, but if user is able to access the Jira with no payment details
    // and is trialEndTime is missing or over we assume that site is in grace period
    return !trialDaysLeft || trialDaysLeft < 0;
};

});

parcelRegister("g3rId", function(module, exports) {

$parcel$export(module.exports, "UpgradeButton", () => $bc17e8b1f4c081bd$export$5f79cadb3a637092);
$parcel$export(module.exports, "LimitedUsersLeftButton", () => $bc17e8b1f4c081bd$export$60952751aac2977b);
$parcel$export(module.exports, "NoUsersLeftButton", () => $bc17e8b1f4c081bd$export$170587001f205989);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $5YsMl = parcelRequire("5YsMl");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $5JgJ2 = parcelRequire("5JgJ2");

var $eibfs = parcelRequire("eibfs");

var $dv4eA = parcelRequire("dv4eA");

var $bz6qa = parcelRequire("bz6qa");
const $bc17e8b1f4c081bd$export$5f79cadb3a637092 = (props)=>{
    const { triggerRef: triggerRef, onButtonClick: onButtonClick, onHoverButton: onHoverButton } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv4eA.EATopNavAnimatedButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv4eA.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eibfs.default), {
            label: ""
        })),
        onClick: onButtonClick,
        theme: (0, $dv4eA.EATopNavPillTheme),
        onMouseEnter: onHoverButton,
        ref: triggerRef,
        interactionName: "edition-awareness-users-remaining-free-pill",
        testId: "navigation-apps-sidebar-edition-awareness.ui.free-pill.users-remaining-free-pill.buttons.upgrade"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $bc17e8b1f4c081bd$var$eaTopNavButtonTextStyles
    }, formatMessage((0, $bz6qa.default).upgrade))));
};
const $bc17e8b1f4c081bd$export$60952751aac2977b = (props)=>{
    const { triggerRef: triggerRef, onButtonClick: onButtonClick, onHoverButton: onHoverButton } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc17e8b1f4c081bd$var$TopNavWarningButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc17e8b1f4c081bd$var$TopNavDoritoIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            size: "small"
        })),
        onClick: onButtonClick,
        theme: $bc17e8b1f4c081bd$var$TopNavWarningButtonTheme,
        onMouseEnter: onHoverButton,
        ref: triggerRef,
        interactionName: "edition-awareness-users-remaining-free-pill",
        testId: "navigation-apps-sidebar-edition-awareness.ui.free-pill.users-remaining-free-pill.buttons.limited-users-left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $bc17e8b1f4c081bd$var$topNavWarningButtonTextStyles
    }, formatMessage((0, $bz6qa.default).limitedUsersLeft))));
};
const $bc17e8b1f4c081bd$export$170587001f205989 = (props)=>{
    const { triggerRef: triggerRef, onButtonClick: onButtonClick, onHoverButton: onHoverButton } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc17e8b1f4c081bd$var$TopNavWarningButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc17e8b1f4c081bd$var$TopNavDoritoIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            size: "small"
        })),
        onClick: onButtonClick,
        theme: $bc17e8b1f4c081bd$var$TopNavWarningButtonTheme,
        onMouseEnter: onHoverButton,
        ref: triggerRef,
        interactionName: "edition-awareness-users-remaining-free-pill",
        testId: "navigation-apps-sidebar-edition-awareness.ui.free-pill.users-remaining-free-pill.buttons.no-users-left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $bc17e8b1f4c081bd$var$topNavWarningButtonTextStyles
    }, formatMessage((0, $bz6qa.default).noUsersLeft))));
};
const $bc17e8b1f4c081bd$var$TopNavDoritoIconWrapper = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
const $bc17e8b1f4c081bd$var$WarningButtonStyles = {
    color: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
    '&:hover': {
        cursor: 'pointer',
        background: `linear-gradient(79.51deg, ${`var(--ds-background-accent-orange-subtler-pressed, ${(0, $73a5c9d720aa66e1$exports).Y300})`} 0%, ${`var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y500})`} 98.15%)`,
        color: "var(--ds-text-inverse, #FFFFFF)",
        svg: {
            // Fix the exclamation mark not being visible when the SVG icon's primary color is white
            fill: `var(--ds-chart-orange-bold, ${(0, $73a5c9d720aa66e1$exports).Y400})`
        }
    },
    '&:active': {
        background: `linear-gradient(79.51deg,
                ${`var(--ds-chart-orange-bold, ${(0, $73a5c9d720aa66e1$exports).Y400})`} 0%,
                ${`var(--ds-chart-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y500})`} 100%)`
    }
};
const $bc17e8b1f4c081bd$var$TopNavWarningButtonTheme = (currentTheme, themeProps)=>{
    const theme = currentTheme(themeProps);
    return {
        ...theme,
        buttonStyles: {
            ...(0, $dv4eA.EATopNavPillCss),
            ...$bc17e8b1f4c081bd$var$WarningButtonStyles,
            transition: 'all 0.3s ease-in-out 0s, color 0s'
        }
    };
};
const $bc17e8b1f4c081bd$var$topNavWarningButtonTextStyles = (0, $1ZAYh.xcss)({
    font: 'font.body'
});
const $bc17e8b1f4c081bd$var$eaTopNavButtonTextStyles = (0, $1ZAYh.xcss)({
    font: 'font.body',
    color: 'color.text.accent.blue'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bc17e8b1f4c081bd$var$TopNavWarningButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _19it1qx2 _4t3i1ul9 _1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bz6qa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c46f86ac4c7ddc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d9c46f86ac4c7ddc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    limitedUsersLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.free-pill.users-remaining-free-pill.buttons.limited-users-left",
        "defaultMessage": "Limited users left"
    },
    noUsersLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.free-pill.users-remaining-free-pill.buttons.no-users-left",
        "defaultMessage": "No users left"
    },
    upgrade: {
        "id": "navigation-apps-sidebar-edition-awareness.free-pill.users-remaining-free-pill.buttons.upgrade",
        "defaultMessage": "Upgrade"
    }
});

});



parcelRegister("aaZm6", function(module, exports) {

$parcel$export(module.exports, "useCheckEditionAwarenessRequisites", () => $a7d56d9f19e7bb86$export$e574f2d2bec618b6);

var $eUqFw = parcelRequire("eUqFw");

var $3HPSR = parcelRequire("3HPSR");

var $7ZZxN = parcelRequire("7ZZxN");

var $guiFP = parcelRequire("guiFP");

var $lz30I = parcelRequire("lz30I");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

const $a7d56d9f19e7bb86$var$getProductKeyForProductUsersCanUpgradeAndPay = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 'jira-software.ondemand';
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 'jira-servicedesk.ondemand';
        default:
            // All other project types are not supported
            return undefined;
    }
};
function $a7d56d9f19e7bb86$export$e574f2d2bec618b6(props) {
    const { projectType: projectType } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const isUsingCcp = (0, $lz30I.useIsProductUsingCcp)(projectType);
    const billingSourceSystem = isUsingCcp ? 'CCP' : 'HAMS';
    // ineligibilityReason is set after the check is completed
    const { canUpgradeAndPay: canUpgradeAndPayForJswFree, loading: isCanUpgradeAndPayForJswFreeLoading, ineligibilityReason: jswIneligibilityReason } = (0, $3HPSR.useCanUpgradeAndPayForJswFree)({
        caller: (0, $0a36f00f767f9fa2$export$b8b9d90f9e5bd72b),
        skip: projectType !== (0, $7ZZxN.SOFTWARE_PROJECT),
        billingAdminCheckMethod: 'ccpApi'
    });
    /**
	 * We DO NOT perform checks for product users if:
	 * - The site is not on CCP billing system (reduce load) OR
	 * - The project is not JSW or JSM (we only support these two flavours of Jira) OR
	 * - The user is on JSW and is a site and billing admin already (these users will be covered by userCanView)
	 * - The user is on JSM and is a site admin already (these users will be covered by userCanView)
	 */ const canUpgradeAndPayForJsmFree = isSiteAdmin;
    const shouldSkipProductUserChecks = !isUsingCcp || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) && canUpgradeAndPayForJsmFree || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && (canUpgradeAndPayForJswFree || canUpgradeAndPayForJswFree === undefined) || projectType !== (0, $7ZZxN.SOFTWARE_PROJECT) && projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT);
    // Will always return false at the moment since the experiment has not begun.
    // Any product user who touches this code will receive 'not-enrolled' as their cohort.
    const { canProductUserUpgradeAndPay: canProductUserUpgradeAndPay, isProductUserBillingAdmin: isProductUserBillingAdmin, isLoading: isUseCanProductUserUpgradeAndPayLoading, error: useCanProductUserUpgradeAndPayError } = (0, $3HPSR.useCanProductUserUpgradeAndPay)({
        skip: shouldSkipProductUserChecks,
        productKey: $a7d56d9f19e7bb86$var$getProductKeyForProductUsersCanUpgradeAndPay(projectType)
    });
    const sendEligibilityCriteria = (0, $eUqFw.useCallback)((ineligibilityReason)=>(0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'eligibilityCriteria checked', 'editionAwarenessFreePill', {
            ...ineligibilityReason && {
                ineligibilityReason: ineligibilityReason !== '' ? ineligibilityReason : undefined
            },
            productKey: (0, $7ZZxN.projectTypeToCanonicalId)(projectType),
            billingSourceSystem: billingSourceSystem,
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: Boolean(isProductUserBillingAdmin || canUpgradeAndPayForJswFree),
            edition: (0, $6WXNs.FREE_EDITION)
        }), [
        billingSourceSystem,
        canUpgradeAndPayForJswFree,
        createAnalyticsEvent,
        isProductUserBillingAdmin,
        isSiteAdmin,
        projectType
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Exit early if useCanProductUserUpgradeAndPay has not finished
        if (!shouldSkipProductUserChecks && isUseCanProductUserUpgradeAndPayLoading) return;
        // Exit early if useCanUpgradeAndPayForJswFree has not finished
        if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && isCanUpgradeAndPayForJswFreeLoading) return;
        if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) {
            if (shouldSkipProductUserChecks) // If we skip product user checks, use the jswIneligibilityReason
            sendEligibilityCriteria(jswIneligibilityReason);
            else if (!jswIneligibilityReason || canProductUserUpgradeAndPay) // If we aren't skipping product user checks, but they're eligible
            sendEligibilityCriteria(undefined);
            else // If they are not eligible, send an event with reason
            sendEligibilityCriteria(!canProductUserUpgradeAndPay ? 'cannot upgrade and pay' : jswIneligibilityReason);
        } else if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) {
            if (shouldSkipProductUserChecks) // If we skip product user checks, user is only eligible if they are site admin
            sendEligibilityCriteria(!canUpgradeAndPayForJsmFree ? 'not a site admin' : undefined);
            else // Otherwise, check if the product user can upgrade and pay
            sendEligibilityCriteria(canProductUserUpgradeAndPay === false ? 'cannot upgrade and pay' : undefined);
        }
    }, [
        billingSourceSystem,
        canProductUserUpgradeAndPay,
        canUpgradeAndPayForJsmFree,
        createAnalyticsEvent,
        isCanUpgradeAndPayForJswFreeLoading,
        isSiteAdmin,
        isUseCanProductUserUpgradeAndPayLoading,
        jswIneligibilityReason,
        projectType,
        sendEligibilityCriteria,
        shouldSkipProductUserChecks
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (useCanProductUserUpgradeAndPayError) (0, $guiFP.default)({
            meta: {
                id: 'useCheckEditionAwarenessRequisites',
                packageName: (0, $0a36f00f767f9fa2$export$b8b9d90f9e5bd72b)
            },
            error: useCanProductUserUpgradeAndPayError,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                isSiteAdmin: isSiteAdmin,
                isBillingAdmin: Boolean(isProductUserBillingAdmin || canUpgradeAndPayForJswFree),
                edition: (0, $6WXNs.FREE_EDITION)
            }
        });
    }, [
        canUpgradeAndPayForJswFree,
        isProductUserBillingAdmin,
        isSiteAdmin,
        projectType,
        useCanProductUserUpgradeAndPayError
    ]);
    const userCanView = Boolean(projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && (canUpgradeAndPayForJswFree || canProductUserUpgradeAndPay) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) && (canUpgradeAndPayForJsmFree || canProductUserUpgradeAndPay));
    return {
        userCanView: isCanUpgradeAndPayForJswFreeLoading || isUseCanProductUserUpgradeAndPayLoading ? undefined : userCanView,
        billingSourceSystem: billingSourceSystem,
        isBillingAdmin: isCanUpgradeAndPayForJswFreeLoading || isUseCanProductUserUpgradeAndPayLoading ? undefined : Boolean(isProductUserBillingAdmin || canUpgradeAndPayForJswFree)
    };
}

});
parcelRegister("3HPSR", function(module, exports) {

$parcel$export(module.exports, "useCanUpgradeAndPayForJswFree", () => $ec9ec1014fe81092$export$f4f07d855739fba1);
$parcel$export(module.exports, "useCanUpgradeAndPayForCurrentProduct", () => $ec9ec1014fe81092$export$2e34435b19772971);
$parcel$export(module.exports, "useCanProductUserUpgradeAndPay", () => $ec9ec1014fe81092$export$53827a0ff095f14b);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $3svxt = parcelRequire("3svxt");

var $guiFP = parcelRequire("guiFP");

var $a6wc8 = parcelRequire("a6wc8");

var $lRmyA = parcelRequire("lRmyA");

var $jRj3P = parcelRequire("jRj3P");


var $dWlsy = parcelRequire("dWlsy");

var $gd0Sp = parcelRequire("gd0Sp");


var $553IO = parcelRequire("553IO");
const $ec9ec1014fe81092$var$fetchEntitlementDetails = (entitlementId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $ec9ec1014fe81092$var$fetchBillingAdmins = (transactionAccountId)=>(0, $lRmyA.performGetRequest)('/gateway/api/ccp/api/v1/billing-admins', {
        headers: {
            'Content-Type': 'application/json',
            'X-transaction-account': transactionAccountId
        }
    });
const $ec9ec1014fe81092$export$2abcbc88aea6e581 = (0, $5iWql.default)($ec9ec1014fe81092$var$fetchEntitlementDetails);
const $ec9ec1014fe81092$export$294eed4c864e0f71 = (0, $5iWql.default)($ec9ec1014fe81092$var$fetchBillingAdmins);
const $ec9ec1014fe81092$export$f4f07d855739fba1 = ({ caller: caller, skip: skip = false, billingAdminCheckMethod: billingAdminCheckMethod = 'traits' })=>{
    const [canUpgradeAndPay, setCanUpgradeAndPay] = (0, $eUqFw.useState)(undefined);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const [ineligibilityReason, setIneligibilityReason] = (0, $eUqFw.useState)(undefined);
    const { isSiteAdmin: isSiteAdmin, cloudId: cloudId, atlassianAccountId: atlassianAccountId, productEntitlementDetails: productEntitlementDetails } = (0, $gd0Sp.useTenantContext)();
    const { fetch: fetch, error: personalizationApiError } = (0, $jRj3P.useSiteUserPersonalization)();
    const isBillingSystemCcp = productEntitlementDetails?.[0, $2edfd53057852e41$export$1346c9aa3cbb477d]?.billingSourceSystem === 'CCP';
    const entitlementId = productEntitlementDetails?.[0, $2edfd53057852e41$export$1346c9aa3cbb477d]?.entitlementId;
    const checkIsCcpBillingAdmin = (0, $eUqFw.useCallback)(async ()=>{
        if (!entitlementId) throw new Error('Empty entitlementId');
        if (!atlassianAccountId) throw new Error('Empty atlassianAccountId');
        // CCP API approach
        if (billingAdminCheckMethod === 'ccpApi') {
            const entitlementDetails = await $ec9ec1014fe81092$export$2abcbc88aea6e581(entitlementId);
            const transactionAccountId = entitlementDetails?.transactionAccountId;
            const billingAdminsResponse = await $ec9ec1014fe81092$export$294eed4c864e0f71(transactionAccountId);
            const isBillingAdmin = !!billingAdminsResponse?.data?.find(({ id: id = null })=>id === atlassianAccountId);
            return isBillingAdmin;
        }
        // Traits approach
        const personalizationData = await fetch({
            cloudId: cloudId,
            userId: atlassianAccountId
        });
        if (!personalizationData) return undefined;
        const isBillingAdmin = personalizationData.find((trait)=>trait.name === (0, $87ce2dbad94f3492$export$3aad3de2cc377789) && trait.value === true) !== undefined;
        return isBillingAdmin;
    }, [
        atlassianAccountId,
        billingAdminCheckMethod,
        cloudId,
        entitlementId,
        fetch
    ]);
    /**
	 * This `useEffect` performs the permission checks.
	 */ (0, $eUqFw.useEffect)(()=>{
        if (skip) return;
        setLoading(true);
        // Only logged in site admins can upgrade
        if (isSiteAdmin) {
            if (isBillingSystemCcp) // On CCP, only billing admins can manage billing
            checkIsCcpBillingAdmin().then((isBillingAdmin)=>{
                setCanUpgradeAndPay(isBillingAdmin);
                // Empty ineligibilityReason marks that the requisites were checked
                setIneligibilityReason(isBillingAdmin ? '' : 'not a billing admin');
            }).catch((e)=>{
                setError(e);
                setIneligibilityReason('error checking eligibility');
            }).finally(()=>{
                setLoading(false);
            });
            else {
                // On HAMS, site admins can also manage billing
                setCanUpgradeAndPay(true);
                setLoading(false);
                // Empty ineligibilityReason marks that the requisites were checked
                setIneligibilityReason('');
            }
        } else {
            setCanUpgradeAndPay(false);
            setLoading(false);
            setIneligibilityReason('not a site admin');
        }
    }, [
        atlassianAccountId,
        caller,
        checkIsCcpBillingAdmin,
        isBillingSystemCcp,
        isSiteAdmin,
        skip
    ]);
    /**
	 * Errors from the Traits API are not thrown. Instead, they are stored in the `error` field from `useSiteUserPersonalization`.
	 * Since we can't catch those errors, we need to listen for changes to that `error` field and update our own "error" state accordingly.
	 */ (0, $eUqFw.useEffect)(()=>{
        if (personalizationApiError) setError(personalizationApiError);
    }, [
        personalizationApiError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'useCanUpgradeAndPayForJswFree',
                packageName: (0, $87ce2dbad94f3492$export$b8b9d90f9e5bd72b),
                teamName: 'growth-tako'
            },
            attributes: {
                billingSourceSystem: isBillingSystemCcp ? 'CCP' : 'HAMS',
                caller: caller,
                billingAdminCheckMethod: billingAdminCheckMethod
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error,
        isBillingSystemCcp,
        caller,
        billingAdminCheckMethod
    ]);
    return {
        canUpgradeAndPay: canUpgradeAndPay,
        loading: loading,
        error: error,
        ineligibilityReason: ineligibilityReason
    };
};
const $ec9ec1014fe81092$export$2e34435b19772971 = ({ caller: caller, skip: skip = false })=>{
    const [canUpgradeAndPay, setCanUpgradeAndPay] = (0, $eUqFw.useState)(undefined);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const subProduct = (0, $dWlsy.useSubProduct)();
    const explicitlyLicensedProducts = (0, $3svxt.default)(tenantContext);
    const applicationKey = (0, $a6wc8.getProductKey)(subProduct, explicitlyLicensedProducts);
    (0, $eUqFw.useEffect)(()=>{
        if (skip) return;
        if (!applicationKey) {
            setError(new Error('Empty applicationKey'));
            return;
        }
        const isBillingSystemCcp = tenantContext.productEntitlementDetails?.[applicationKey]?.billingSourceSystem === 'CCP';
        const entitlementId = tenantContext.productEntitlementDetails?.[applicationKey]?.entitlementId;
        const checkIsCcpBillingAdmin = async ()=>{
            if (!entitlementId) throw new Error('Empty entitlementId');
            if (!tenantContext.atlassianAccountId) throw new Error('Empty atlassianAccountId');
            const entitlementDetails = await $ec9ec1014fe81092$export$2abcbc88aea6e581(entitlementId);
            const transactionAccountId = entitlementDetails?.transactionAccountId;
            const billingAdminsResponse = await $ec9ec1014fe81092$export$294eed4c864e0f71(transactionAccountId);
            const isBillingAdmin = billingAdminsResponse?.data?.some(({ id: id = null })=>id === tenantContext.atlassianAccountId) ?? false;
            return isBillingAdmin;
        };
        setLoading(true);
        // Only logged in site admins can upgrade
        if (tenantContext.isSiteAdmin && tenantContext.atlassianAccountId) {
            if (isBillingSystemCcp) // On CCP, only billing admins can manage billing
            checkIsCcpBillingAdmin().then((isBillingAdmin)=>{
                setCanUpgradeAndPay(isBillingAdmin);
            }).catch((e)=>{
                setError(e);
                (0, $guiFP.default)({
                    error: e,
                    meta: {
                        id: 'useCanUpgradeAndPayForCurrentProduct',
                        packageName: (0, $87ce2dbad94f3492$export$b8b9d90f9e5bd72b),
                        teamName: 'growth-tako'
                    },
                    attributes: {
                        billingSourceSystem: isBillingSystemCcp ? 'CCP' : 'HAMS',
                        caller: caller,
                        subProduct: subProduct,
                        applicationKey: applicationKey,
                        licensedProducts: tenantContext.licensedProducts,
                        productEntitlementDetails: tenantContext.productEntitlementDetails
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                setLoading(false);
            });
            else {
                // On HAMS, site admins can also manage billing
                setCanUpgradeAndPay(true);
                setLoading(false);
            }
        } else {
            setCanUpgradeAndPay(false);
            setLoading(false);
        }
    }, [
        applicationKey,
        caller,
        skip,
        subProduct,
        tenantContext.atlassianAccountId,
        tenantContext.isSiteAdmin,
        tenantContext.licensedProducts,
        tenantContext.productEntitlementDetails
    ]);
    return {
        canUpgradeAndPay: canUpgradeAndPay,
        loading: loading,
        error: error
    };
};
const $ec9ec1014fe81092$export$422d9ad995b055f = ({ caller: caller, onError: onError })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const subProduct = (0, $dWlsy.useSubProduct)();
    const explicitlyLicensedProducts = (0, $3svxt.default)(tenantContext);
    const applicationKey = (0, $a6wc8.getProductKey)(subProduct, explicitlyLicensedProducts);
    const checkIsCcpBillingAdmin = (0, $eUqFw.useCallback)(async (entitlementId)=>{
        if (!entitlementId) throw new Error('Empty entitlementId');
        if (!tenantContext.atlassianAccountId) throw new Error('Empty atlassianAccountId');
        const entitlementDetails = await $ec9ec1014fe81092$export$2abcbc88aea6e581(entitlementId);
        const transactionAccountId = entitlementDetails?.transactionAccountId;
        const billingAdminsResponse = await $ec9ec1014fe81092$export$294eed4c864e0f71(transactionAccountId);
        const isBillingAdmin = billingAdminsResponse?.data?.some(({ id: id = null })=>id === tenantContext.atlassianAccountId) ?? false;
        return isBillingAdmin;
    }, [
        tenantContext.atlassianAccountId
    ]);
    /**
	 * Checks whether the user has upgrade and billing permission (i.e. is site and billing admin).
	 * Returns `true` if the user has permission for both, `false` if they don't, and `null` if the check failed.
	 */ const hasUpgradeAndBillingPermission = (0, $eUqFw.useCallback)(async ()=>{
        if (!applicationKey) {
            const error = new Error('Empty applicationKey');
            const analyticsAttributes = {
                caller: caller,
                subProduct: subProduct,
                applicationKey: applicationKey,
                licensedProducts: tenantContext.licensedProducts,
                productEntitlementDetails: tenantContext.productEntitlementDetails
            };
            onError?.(error, analyticsAttributes);
            return null;
        }
        // Site admin is required for upgrading products
        if (!tenantContext.isSiteAdmin || !tenantContext.atlassianAccountId) return false;
        const isBillingSystemCcp = tenantContext.productEntitlementDetails?.[applicationKey]?.billingSourceSystem === 'CCP';
        // On CCP, only billing admins can manage billing
        if (isBillingSystemCcp) {
            const entitlementId = tenantContext.productEntitlementDetails?.[applicationKey]?.entitlementId;
            return checkIsCcpBillingAdmin(entitlementId).then((isBillingAdmin)=>isBillingAdmin).catch((e)=>{
                const analyticsAttributes = {
                    billingSourceSystem: isBillingSystemCcp ? 'CCP' : 'HAMS',
                    caller: caller,
                    subProduct: subProduct,
                    applicationKey: applicationKey,
                    licensedProducts: tenantContext.licensedProducts,
                    productEntitlementDetails: tenantContext.productEntitlementDetails
                };
                onError?.(e, analyticsAttributes);
                return null;
            });
        }
        // On HAMS, site admins can manage billing
        return true;
    }, [
        applicationKey,
        caller,
        checkIsCcpBillingAdmin,
        onError,
        subProduct,
        tenantContext.atlassianAccountId,
        tenantContext.isSiteAdmin,
        tenantContext.licensedProducts,
        tenantContext.productEntitlementDetails
    ]);
    return {
        hasUpgradeAndBillingPermission: hasUpgradeAndBillingPermission
    };
};
function $ec9ec1014fe81092$export$53827a0ff095f14b({ skip: skip, productKey: productKey }) {
    const { data: data, isLoading: isLoading, error: error, fetch: fetchCanProductUserUpgradeAndPay } = (0, $553IO.useCanProductUserUpgradeAndPayQuery)();
    (0, $eUqFw.useEffect)(()=>{
        if (skip || !productKey) return;
        fetchCanProductUserUpgradeAndPay(productKey);
    }, [
        fetchCanProductUserUpgradeAndPay,
        productKey,
        skip
    ]);
    const canProductUserUpgradeAndPay = data?.canProductUserUpgradeAndPay;
    const isProductUserBillingAdmin = data?.isBillingAdmin;
    return {
        isProductUserBillingAdmin: isProductUserBillingAdmin,
        canProductUserUpgradeAndPay: canProductUserUpgradeAndPay,
        isLoading: isLoading,
        error: error
    };
}

});
parcelRegister("a6wc8", function(module, exports) {

$parcel$export(module.exports, "getProductKey", () => $9e20cc650e9eaa2c$export$d0b7f02493f85477);

const $9e20cc650e9eaa2c$export$d0b7f02493f85477 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $2edfd53057852e41$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61;
    // useSubProduct currently doesn't support polaris
    // JPD's subproduct currently falls under to 'software'
    // https://hello.atlassian.net/wiki/spaces/STAR/pages/2940457206/Detach+from+JSW+analytics+subproduct
    if (subProduct === 'polaris') return 0, $2edfd53057852e41$export$202f50ee62667e32;
    if (subProduct === 'core') return 0, $2edfd53057852e41$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work".
    // If there is only one licensed product, we can infer what the user is using.
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};

});

parcelRegister("jRj3P", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $4441cad18cc93774$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $4441cad18cc93774$export$8dc79ff315095801);

var $5iWql = parcelRequire("5iWql");

var $eEzyV = parcelRequire("eEzyV");

var $2OdyW = parcelRequire("2OdyW");
const $4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $4441cad18cc93774$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $2OdyW.default)($4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $4441cad18cc93774$export$de93ec54b11be450 = (0, $5iWql.default)($4441cad18cc93774$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $4441cad18cc93774$export$8dc79ff315095801 = ()=>(0, $eEzyV.useService)($4441cad18cc93774$export$de93ec54b11be450);

});
parcelRegister("eEzyV", function(module, exports) {

$parcel$export(module.exports, "useService", () => $cbb15d4da2e9ab10$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $cbb15d4da2e9ab10$export$c963713a27525aaf);

var $eUqFw = parcelRequire("eUqFw");
const $cbb15d4da2e9ab10$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $eUqFw.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $eUqFw.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $cbb15d4da2e9ab10$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $eUqFw.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $cbb15d4da2e9ab10$export$6de4685a6c88b4e9(request, initialState);
    (0, $eUqFw.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


const $87ce2dbad94f3492$export$3aad3de2cc377789 = 'jira_software_free_is_ccp_billing_admins';
const $87ce2dbad94f3492$export$b8b9d90f9e5bd72b = 'jiraBilling';

parcelRegister("553IO", function(module, exports) {

$parcel$export(module.exports, "useCanProductUserUpgradeAndPayQuery", () => $05b6ff197bac8a57$export$44d5ccfd376c6700);

var $1nR1W = parcelRequire("1nR1W");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $dWLk9 = parcelRequire("dWLk9");
const $05b6ff197bac8a57$export$62297b13309008b2 = (0, $1nR1W.default);
const $05b6ff197bac8a57$export$44d5ccfd376c6700 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const relayEnvironment = (0, $iWLL0.useRelayEnvironment)();
    const [data, setData] = (0, $eUqFw.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const fetch = (0, $eUqFw.useCallback)((productKey)=>{
        setIsLoading(true);
        const variables = {
            cloudId: cloudId,
            productKey: productKey
        };
        (0, $iWLL0.fetchQuery)(relayEnvironment, $05b6ff197bac8a57$export$62297b13309008b2, variables, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            complete: ()=>{
                setIsLoading(false);
            },
            next: (response)=>{
                // Endpoint takes in an array of cloudIds, but we never call this with more than one cloudId
                const entitlement = response?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
                const canPay = entitlement?.transactionAccount?.experienceCapabilities?.addPaymentMethodV2?.isAvailableToUser;
                const canUpgrade = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
                const isCurrentUserBillingAdmin = entitlement?.transactionAccount?.isCurrentUserBillingAdmin;
                const canUpgradeAndPay = canUpgrade && canPay;
                setData({
                    canProductUserUpgradeAndPay: canUpgradeAndPay ?? false,
                    isBillingAdmin: isCurrentUserBillingAdmin ?? false
                });
            },
            error: (fetchError)=>{
                setIsLoading(false);
                setError(fetchError);
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    return {
        fetch: fetch,
        data: data,
        isLoading: isLoading,
        error: error
    };
};

});
parcelRegister("1nR1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1fefb3ae3cd7b75$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8d940d3469c4fac7a5777668b0741358>>
 * @relayHash ea92179dc2519e0969d4281dd79d396f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9308b51a7dfc7d956d54b611c603679c467cba651b645e963aac170dd0f5ba0b
const $e1fefb3ae3cd7b75$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        v5 /*: any*/ ,
        v4 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "canProductUserUpgradeAndPayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.isCurrentUserBillingAdmin"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "addPaymentMethodV2",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.experienceCapabilities.addPaymentMethodV2.isAvailableToUser"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "tenantContexts.entitlementInfo.entitlement.experienceCapabilities.changeOfferingV2.isAvailableToUser"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "canProductUserUpgradeAndPayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "addPaymentMethodV2",
                                                            "plural": false,
                                                            "selections": v6 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "CcpTransactionAccount"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": v6 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9308b51a7dfc7d956d54b611c603679c467cba651b645e963aac170dd0f5ba0b",
            "metadata": {},
            "name": "canProductUserUpgradeAndPayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e1fefb3ae3cd7b75$var$node.hash = "018980114a88416ec612e7565b16db6c";
var $e1fefb3ae3cd7b75$export$2e2bcd8739ae039 = $e1fefb3ae3cd7b75$var$node;

});





parcelRegister("54gZT", function(module, exports) {

$parcel$export(module.exports, "editionAwarenessModalEntryPoint", () => $7c232e3c67f62da6$export$dd136db78a637fd0);

var $4Qlzf = parcelRequire("4Qlzf");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $7c232e3c67f62da6$export$dd136db78a637fd0 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("5UtQp")), {
        moduleId: "31852d1c"
    }),
    // @ts-expect-error - JiraApplicationKey in AGG schema does not support CUSTOMER_SERVICE
    getPreloadProps: ({ cloudId: cloudId, jiraApplicationKey: jiraApplicationKey, productKey: productKey, offeringKey: offeringKey, chargeElement: chargeElement })=>({
            entryPoints: {},
            extraProps: {},
            queries: {
                editionAwareness: {
                    parameters: (0, $4Qlzf.default),
                    variables: {
                        cloudId: cloudId,
                        jiraApplicationKey: jiraApplicationKey,
                        hamsProductKey: productKey,
                        offeringKey: offeringKey,
                        chargeElement: chargeElement
                    }
                }
            }
        })
});

});
parcelRegister("4Qlzf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3a98c8bb127bca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<42f802de4a1da468826caa94d14c7b60>>
 * @relayHash f534d878bd59ff7e6ad3efb4b9be7925
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6e79b2358ef819cc93e18973fbceae455694652a34bbda48bb4e1f48055b77ab
const $7c3a98c8bb127bca$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6e79b2358ef819cc93e18973fbceae455694652a34bbda48bb4e1f48055b77ab",
        "metadata": {},
        "name": "wrapperEditionAwarenessModalWrapperQuery",
        "operationKind": "query",
        "text": null
    }
};
var $7c3a98c8bb127bca$export$2e2bcd8739ae039 = $7c3a98c8bb127bca$var$node;

});

parcelRegister("5UtQp", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("5Tlh4")
]).then(()=>parcelRequire('gOTsz'));

});


parcelRegister("cW8rl", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc25f449cebf8677$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fc25f449cebf8677$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noCreatorsLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.no-creators-left",
        "defaultMessage": "No creators left"
    },
    limitedCreatorsLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.limited-creators-left",
        "defaultMessage": "Limited creators left"
    },
    noAgentsLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.no-agents-left",
        "defaultMessage": "No agents left"
    },
    limitedAgentsLeft: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.limited-agents-left",
        "defaultMessage": "Limited agents left"
    },
    upgrade: {
        "id": "navigation-apps-sidebar-edition-awareness.edition-awareness-next.upgrade",
        "defaultMessage": "Upgrade"
    }
});

});


parcelRegister("iwzQE", function(module, exports) {

$parcel$export(module.exports, "TrialPill", () => $ab9f5ce0ddbd439d$export$dd77a69c423022b0);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $7ZZxN = parcelRequire("7ZZxN");

var $eEzyV = parcelRequire("eEzyV");

var $79xbN = parcelRequire("79xbN");

var $lz30I = parcelRequire("lz30I");

var $6WXNs = parcelRequire("6WXNs");

var $dWLk9 = parcelRequire("dWLk9");

var $gd0Sp = parcelRequire("gd0Sp");

var $apShl = parcelRequire("apShl");

var $dv4eA = parcelRequire("dv4eA");

var $5vXCw = parcelRequire("5vXCw");

var $lr0T3 = parcelRequire("lr0T3");

var $dJB6p = parcelRequire("dJB6p");

var $eJPyF = parcelRequire("eJPyF");
const $ab9f5ce0ddbd439d$var$TrialPillComponent = ({ edition: edition, productKey: productKey, projectType: projectType, entitlementDetails: entitlementDetails })=>{
    const { billingSourceSystem: billingSourceSystem } = entitlementDetails;
    const [shouldRenderPill, setShouldRenderPill] = (0, $eUqFw.useState)(null);
    const relayEnvironment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const fireEligibilityCheckEvent = (0, $eJPyF.useEligibilityCheckEvent)({
        productKey: productKey,
        projectType: projectType,
        edition: edition,
        entitlementDetails: entitlementDetails
    });
    const { loading: billingInformationLoading, data: billingInformation, error: billingInformationError, fetch: fetchBillingInformation } = (0, $eEzyV.useService)((0, $lr0T3.getBillingInformation));
    (0, $eUqFw.useEffect)(()=>{
        fetchBillingInformation({
            cloudId: cloudId,
            productKey: productKey,
            relayEnvironment: relayEnvironment
        });
    }, [
        fetchBillingInformation,
        cloudId,
        productKey,
        relayEnvironment
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (billingInformationError) {
            fireEligibilityCheckEvent('error', {
                error: (0, $eJPyF.transformError)(billingInformationError)
            });
            setShouldRenderPill(false);
            return;
        }
        if (billingInformation) {
            const ineligibilityReasons = (0, $eJPyF.getIneligibilityReasons)(billingInformation);
            if (ineligibilityReasons.length > 0) {
                /*
                We are only checking if the product user can pay when the only ineligibility reason is that they are not a billing admin.
                If there are other ineligibility reasons present, they are not eligible for our experiment.
                 */ const shouldPerformProductUserChecks = billingSourceSystem === 'CCP' && billingInformation.isBillingAdmin === false && ineligibilityReasons.length === 1 && ineligibilityReasons[0] === 'notBillingAdmin';
                if (shouldPerformProductUserChecks) try {
                    (0, $5vXCw.canProductUserPay)(cloudId, productKey, relayEnvironment).then((canPay)=>{
                        setShouldRenderPill(canPay);
                        fireEligibilityCheckEvent(canPay ? null : 'productUserCannotPay', {
                            billingInformation: billingInformation,
                            ineligibilityReasons: ineligibilityReasons
                        });
                    });
                } catch (error) {
                    fireEligibilityCheckEvent('canProductUserPayError', {
                        error: (0, $eJPyF.transformError)(error),
                        billingInformation: billingInformation,
                        ineligibilityReasons: ineligibilityReasons
                    });
                    setShouldRenderPill(false);
                }
                else {
                    // Choose only first reason to keep even backward compatible, other reason could be still retrieved from billingInformation
                    fireEligibilityCheckEvent(ineligibilityReasons[0], {
                        billingInformation: billingInformation,
                        ineligibilityReasons: ineligibilityReasons
                    });
                    setShouldRenderPill(false);
                }
            } else {
                fireEligibilityCheckEvent(null, {
                    billingInformation: billingInformation
                });
                setShouldRenderPill(true);
            }
        } else setShouldRenderPill(false);
    }, [
        billingInformation,
        billingInformationError,
        billingSourceSystem,
        cloudId,
        fireEligibilityCheckEvent,
        productKey,
        relayEnvironment
    ]);
    if (billingInformationLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "edition-awareness-billing-information-loading"
    });
    if (!billingInformation) return null;
    if (shouldRenderPill) {
        if (projectType === (0, $7ZZxN.CORE_PROJECT) && edition === (0, $6WXNs.STANDARD_EDITION)) {
            // For CONTROL and NOT-ENROLLED we are not showing the pill, but using the funtion to fire the exposure
            if (!(0, $79xbN.expValEquals)('edition_awareness_on_jwm', 'isEnabled', true)) return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv4eA.EditionAwarenessContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dJB6p.TrialPillButton), {
            productKey: productKey,
            projectType: projectType,
            edition: edition,
            entitlementDetails: entitlementDetails,
            invoiceGroupId: billingInformation.invoiceGroupId,
            transactionAccountId: billingInformation.transactionAccountId,
            isBillingAdmin: billingInformation.isBillingAdmin
        }));
    }
    return null;
};
const $ab9f5ce0ddbd439d$export$dd77a69c423022b0 = ({ productKey: productKey, projectType: projectType, edition: edition })=>{
    const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(null);
    const { productEntitlementDetails: productEntitlementDetails } = (0, $gd0Sp.useTenantContext)();
    const entitlementDetails = productEntitlementDetails?.[productKey];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem || 'HAMS'; // If billingSourceSystem is not set, it is HAMS
    // override the billingSourceSystem to not be null
    const memoizedEntitlementDetails = (0, $eUqFw.useMemo)(()=>({
            ...entitlementDetails,
            billingSourceSystem: billingSourceSystem
        }), [
        billingSourceSystem,
        entitlementDetails
    ]);
    // Checking whether site is in trial or grace period (14 days after trial ends).
    // We can do this for HAMS but not for CCP. CCP has feature called pre-dunning.
    // We do not know how to identify pre-dunning since new subscription is created without trialEndDate
    // so we basically have to check invoiceability or everyone on CCP
    const currentDate = (0, $eUqFw.useMemo)(()=>Date.now(), []);
    const trialDaysLeft = (0, $lz30I.getTrialDaysLeft)(currentDate, entitlementDetails?.trialEndTime);
    const notInTrialOrGracePeriod = billingSourceSystem === 'HAMS' && (!trialDaysLeft || trialDaysLeft < -14);
    const fireEligibilityCheckEvent = (0, $eJPyF.useEligibilityCheckEvent)({
        productKey: productKey,
        projectType: projectType,
        edition: edition,
        entitlementDetails: entitlementDetails
    });
    (0, $eUqFw.useEffect)(()=>{
        // This check should be always false, and it is here to make sure component works even if it would get mounted outside parent EditionAwareness component
        if (edition !== (0, $6WXNs.STANDARD_EDITION) && edition !== (0, $6WXNs.PREMIUM_EDITION)) {
            fireEligibilityCheckEvent('invalidEdition');
            setShouldRender(false);
        } else if (!entitlementDetails) {
            fireEligibilityCheckEvent('missingEntitlementDetails', {
                productEntitlementDetails: productEntitlementDetails
            });
            setShouldRender(false);
        } else if (notInTrialOrGracePeriod) {
            fireEligibilityCheckEvent('notInTrialOrGracePeriod');
            setShouldRender(false);
        } else setShouldRender(true);
    }, [
        edition,
        entitlementDetails,
        fireEligibilityCheckEvent,
        productEntitlementDetails,
        notInTrialOrGracePeriod
    ]);
    if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ab9f5ce0ddbd439d$var$TrialPillComponent, {
        edition: edition,
        productKey: productKey,
        projectType: projectType,
        entitlementDetails: memoizedEntitlementDetails
    });
    return null;
};

});
parcelRegister("5vXCw", function(module, exports) {

$parcel$export(module.exports, "canProductUserPay", () => $ab518c2e3013fabe$export$2559b2eb40941f10);

var $9jWLN = parcelRequire("9jWLN");

var $iWLL0 = parcelRequire("iWLL0");

const $ab518c2e3013fabe$export$62297b13309008b2 = (0, $9jWLN.default);
const $ab518c2e3013fabe$export$2559b2eb40941f10 = async (cloudId, productKey, relayEnvironment)=>{
    // JPD product key as used by Commerce does not include .ondemand
    const commerceProductKey = productKey === (0, $2edfd53057852e41$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
    const variables = {
        cloudId: cloudId,
        productKey: commerceProductKey
    };
    const response = await (0, $iWLL0.fetchQuery)(relayEnvironment, $ab518c2e3013fabe$export$62297b13309008b2, variables, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const entitlementInfo = response?.tenantContexts && response.tenantContexts.length > 0 ? response.tenantContexts[0]?.entitlementInfo : undefined;
    const canPay = entitlementInfo?.entitlement?.subscription?.accountDetails?.invoiceGroup?.experienceCapabilities?.configurePaymentV2?.isAvailableToUser;
    return Boolean(canPay);
};

});
parcelRegister("9jWLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $302b6f8ec54a7bc6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<908c5b7125a328e4906add51c3f599a6>>
 * @relayHash 8a93eccb6a4de8033f8d5f8ad3cd8e40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 214adfa29ea1bab0c1a4893dc453d76b1c749f86c52652514fb64580b5f60ffb
const $302b6f8ec54a7bc6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "canProductUserPayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePaymentV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v3 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "tenantContexts.entitlementInfo.entitlement.subscription.accountDetails.invoiceGroup.experienceCapabilities.configurePaymentV2.isAvailableToUser"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "canProductUserPayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "experienceCapabilities",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "configurePaymentV2",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v6 /*: any*/ ,
                                                                    "type": "CcpInvoiceGroup"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v6 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "214adfa29ea1bab0c1a4893dc453d76b1c749f86c52652514fb64580b5f60ffb",
            "metadata": {},
            "name": "canProductUserPayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$302b6f8ec54a7bc6$var$node.hash = "0064ac2d6628f537533e7f6c91f85010";
var $302b6f8ec54a7bc6$export$2e2bcd8739ae039 = $302b6f8ec54a7bc6$var$node;

});


parcelRegister("lr0T3", function(module, exports) {

$parcel$export(module.exports, "getBillingInformation", () => $721574302e7b1515$export$8299b86bb18aafc1);

var $45DXL = parcelRequire("45DXL");
const $721574302e7b1515$export$8299b86bb18aafc1 = async ({ cloudId: cloudId, productKey: productKey, relayEnvironment: relayEnvironment })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!productKey) throw new Error('empty productKey');
    return (0, $45DXL.getBillingInformationGraphql)(cloudId, productKey, relayEnvironment);
};

});
parcelRegister("45DXL", function(module, exports) {

$parcel$export(module.exports, "getBillingInformationGraphql", () => $68c358e6f78127d5$export$719aff12724d0b22);

var $72sTl = parcelRequire("72sTl");

var $cNy9K = parcelRequire("cNy9K");

const $68c358e6f78127d5$export$62297b13309008b2 = (0, $72sTl.default);
const $68c358e6f78127d5$export$719aff12724d0b22 = async (cloudId, productKey, relayEnvironment)=>{
    // The product key as used by Commerce.
    // JPD product key as used by Commerce does not include .ondemand
    const commerceProductKey = productKey === (0, $2edfd53057852e41$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
    const variables = {
        cloudId: cloudId,
        productKey: commerceProductKey
    };
    const response = await (0, $cNy9K.fetchQuery)(relayEnvironment, $68c358e6f78127d5$export$62297b13309008b2, variables, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const entitlementInfo = response?.tenantContexts && response.tenantContexts.length > 0 ? response.tenantContexts[0]?.entitlementInfo : undefined;
    const entitlement = entitlementInfo?.entitlement;
    const subscription = entitlement?.subscription;
    const invoiceGroup = subscription?.accountDetails?.invoiceGroup;
    const pricingPlan = subscription?.pricingPlan;
    const transactionAccount = entitlement?.transactionAccount;
    return {
        notInTrialOrPredunning: entitlement === null,
        invoiceable: invoiceGroup?.invoiceable ?? null,
        transactionAccountId: transactionAccount?.key ?? null,
        invoiceGroupId: invoiceGroup?.id ?? null,
        isBillingAdmin: transactionAccount?.isCurrentUserBillingAdmin ?? null,
        partnerManaged: transactionAccount?.isManagedByPartner ?? null,
        billingInterval: pricingPlan?.primaryCycle?.interval ?? null,
        pricingPlanType: pricingPlan?.type ?? null,
        overriddenEdition: entitlement?.overriddenEdition ?? null,
        rawResponse: response
    };
};

});
parcelRegister("72sTl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca44656dbb4a3b47$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7009fd96b57d96f3a804cd54cbeff896>>
 * @relayHash 43cd413a33357d1fd66c5d347fbf2d7d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9560265d452dac8e1e384e71f9bf7559c617d3089047cf82d243131a11597fac
const $ca44656dbb4a3b47$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "where",
            "value": {
                "AND": [
                    {
                        "inTrialOrPreDunning": true
                    }
                ]
            }
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "CcpInvoiceGroup"
    }, v8 = {
        "kind": "ScalarField",
        "name": "interval"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "key"
    }, v11 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v12 = {
        "kind": "ScalarField",
        "name": "isManagedByPartner"
    }, v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "overriddenEdition"
            }
        ],
        "type": "HamsEntitlement"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "commerceSharedApiEditionAwarenessTrialQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "tenantContexts.entitlementInfo.entitlement.subscription.accountDetails.invoiceGroup.invoiceable"
                                                                },
                                                                v7 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "pricingPlan",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "primaryCycle",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v8 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "tenantContexts.entitlementInfo.entitlement.subscription.pricingPlan.primaryCycle.interval"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v9 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "tenantContexts.entitlementInfo.entitlement.subscription.pricingPlan.type"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v10 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.key"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v11 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.isCurrentUserBillingAdmin"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v12 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.isManagedByPartner"
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ 
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "commerceSharedApiEditionAwarenessTrialQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "subscription",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "accountDetails",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "invoiceGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v7 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "pricingPlan",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "primaryCycle",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v6 /*: any*/ ,
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v6 /*: any*/ ,
                                                    "type": "CcpSubscription"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v6 /*: any*/ ,
                                                    "type": "CcpTransactionAccount"
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ],
                                    "storageKey": "entitlement(where:{\"AND\":[{\"inTrialOrPreDunning\":true}]})"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9560265d452dac8e1e384e71f9bf7559c617d3089047cf82d243131a11597fac",
            "metadata": {},
            "name": "commerceSharedApiEditionAwarenessTrialQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ca44656dbb4a3b47$var$node.hash = "9bcfaad10316f0f987176038c3666c83";
var $ca44656dbb4a3b47$export$2e2bcd8739ae039 = $ca44656dbb4a3b47$var$node;

});



parcelRegister("dJB6p", function(module, exports) {

$parcel$export(module.exports, "TrialPillButton", () => $d25ed2639e2583ae$export$19063b5b00c8046c);

var $eUqFw = parcelRequire("eUqFw");

var $ltfxy = parcelRequire("ltfxy");

var $2eG9N = parcelRequire("2eG9N");

var $bNPR8 = parcelRequire("bNPR8");

var $67MTZ = parcelRequire("67MTZ");

var $eI5EY = parcelRequire("eI5EY");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $aT2k6 = parcelRequire("aT2k6");

var $lz30I = parcelRequire("lz30I");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $6WXNs = parcelRequire("6WXNs");

var $dWLk9 = parcelRequire("dWLk9");

var $3e9vj = parcelRequire("3e9vj");

var $1R3n5 = parcelRequire("1R3n5");

var $4xHig = parcelRequire("4xHig");

var $dv4eA = parcelRequire("dv4eA");

var $eina8 = parcelRequire("eina8");

var $eDMiO = parcelRequire("eDMiO");

var $31g2G = parcelRequire("31g2G");

var $9pjFJ = parcelRequire("9pjFJ");

var $cTbJf = parcelRequire("cTbJf");

var $hTSHS = parcelRequire("hTSHS");
const $d25ed2639e2583ae$export$19063b5b00c8046c = ({ productKey: productKey, projectType: projectType, edition: edition, entitlementDetails: entitlementDetails, invoiceGroupId: invoiceGroupId, transactionAccountId: transactionAccountId, isBillingAdmin: isBillingAdmin })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const locale = (0, $4xHig.useLocale)();
    const environment = (0, $3e9vj.useEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const { trialEndTime: trialEndTime, billingSourceSystem: billingSourceSystem } = entitlementDetails;
    const currentDate = (0, $eUqFw.useMemo)(()=>Date.now(), []);
    const trialDaysLeft = (0, $lz30I.getTrialDaysLeft)(currentDate, trialEndTime);
    const inGracePeriod = (0, $lz30I.isInGracePeriod)(currentDate, trialEndTime);
    const isEnglishLocale = locale.startsWith('en');
    const isJswStandard = productKey === 'jira-software' && edition === (0, $6WXNs.STANDARD_EDITION);
    const isEligibleForJsmJpdTrialAwarenessV2Experiment = (0, $aT2k6.isEligibleForJsmJpdTrialAwarenessV2)(projectType);
    const isJsmJpdTrialAwarenessV2ExperimentEnabled = isEligibleForJsmJpdTrialAwarenessV2Experiment && (0, $aT2k6.isInVariationForJsmJpdTrialAwarenessV2)();
    const isEligibleForJswTrialAwarenessV2Experiment = (0, $aT2k6.isEligibleForJswTrialAwarenessV2)(projectType, edition);
    const isJswTrialAwarenessV2ExperimentEnabled = isEligibleForJswTrialAwarenessV2Experiment && (0, $aT2k6.isInVariationForJswTrialAwarenessV2)();
    const { cohort: premiumFeaturesCohort } = (0, $9pjFJ.getDemonstratingTheValueofJiraFeaturesExperiment)();
    // I wanted to add a comment to this condition, but comment would be longer then the component itself so I gave up ...
    const jstoTarget = !!isBillingAdmin && !inGracePeriod && isSiteAdmin && isJswStandard && !isJswTrialAwarenessV2ExperimentEnabled;
    const rawJstoUrl = `${(0, $bNPR8.WAC_URL)[environment]}/software/jira?ref=edition_awareness_standard_trial_${billingSourceSystem.toLowerCase()}&cloudSiteId=${cloudId}`;
    const jstoUrl = (0, $lz30I.useLoggedInPage)({
        pageUrl: rawJstoUrl
    });
    const addBillingDetailsUrl = entitlementDetails?.billingSourceSystem === 'CCP' ? `${(0, $67MTZ.getAdminBaseUrl)()}/billing/${transactionAccountId}/${invoiceGroupId}/payment-flow?referrer=${(0, $eDMiO.productAbbreviations)[productKey]}` : `${(0, $67MTZ.getAdminBaseUrl)()}/s/${cloudId}/billing/paymentdetails/add`;
    const tooltipMessage = formatMessage(inGracePeriod ? (0, $cTbJf.default).addPaymentDetailsTooltip : (0, $cTbJf.default).trialButtonTooltip);
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>{
        const attributes = {
            edition: edition,
            productKey: productKey,
            projectType: projectType,
            isEnglishLocale: isEnglishLocale,
            entitlementDetails: entitlementDetails,
            transactionAccountId: transactionAccountId,
            invoiceGroupId: invoiceGroupId,
            isBillingAdmin: isBillingAdmin
        };
        // We don't want to send this attribute if user is not enrolled in the experiment
        if (premiumFeaturesCohort !== (0, $9pjFJ.PREMIUM_FEATURES_COHORT_NOT_ENROLLED)) attributes.premiumFeaturesCohort = premiumFeaturesCohort;
        return attributes;
    }, [
        edition,
        entitlementDetails,
        invoiceGroupId,
        isEnglishLocale,
        productKey,
        projectType,
        transactionAccountId,
        isBillingAdmin,
        premiumFeaturesCohort
    ]);
    const triggerButtonProps = (0, $eUqFw.useMemo)(()=>({
            trialDaysLeft: trialDaysLeft,
            inGracePeriod: inGracePeriod,
            jstoUrl: jstoTarget ? jstoUrl : undefined,
            addBillingDetailsUrl: addBillingDetailsUrl,
            analyticsAttributes: analyticsAttributes,
            productKey: productKey,
            projectType: projectType,
            edition: edition
        }), [
        trialDaysLeft,
        inGracePeriod,
        jstoTarget,
        jstoUrl,
        addBillingDetailsUrl,
        analyticsAttributes,
        productKey,
        projectType,
        edition
    ]);
    let content = null;
    if (jstoTarget || inGracePeriod) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv4eA.EATopNavAnimatedButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: tooltipMessage,
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTSHS.TriggerButton), {
            ...triggerButtonProps,
            triggerProps: tooltipProps,
            // We must ensure isEligibleForJswTrialAwarenessModalV2 will always be false when inGracePeriod
            // but we still need to check it when jstoTarget is true as user might be in control group.
            isEligibleForJswTrialAwarenessModalV2: !inGracePeriod && isEligibleForJswTrialAwarenessV2Experiment
        })));
    else if (isJsmJpdTrialAwarenessV2ExperimentEnabled || isJswTrialAwarenessV2ExperimentEnabled) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv4eA.EATopNavAnimatedButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTSHS.TriggerButton), {
        ...triggerButtonProps,
        isEligibleForJsmJpdTrialAwarenessModalV2: isEligibleForJsmJpdTrialAwarenessV2Experiment,
        isEligibleForJswTrialAwarenessModalV2: isEligibleForJswTrialAwarenessV2Experiment
    }));
    else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv4eA.EATopNavAnimatedButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eina8.BillingDetailsPopup), {
        analyticsAttributes: analyticsAttributes,
        edition: edition,
        inGracePeriod: inGracePeriod,
        addBillingDetailsUrl: addBillingDetailsUrl,
        productKey: productKey
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTSHS.TriggerButton), {
            ...triggerButtonProps,
            ...triggerProps,
            isEligibleForJsmJpdTrialAwarenessModalV2: isEligibleForJsmJpdTrialAwarenessV2Experiment,
            isEligibleForJswTrialAwarenessModalV2: isEligibleForJswTrialAwarenessV2Experiment
        })));
    if ((0, $eI5EY.fg)('demonstrating_value_of_jira_premium_features_gate')) {
        const isSupportedStandard = edition === (0, $6WXNs.STANDARD_EDITION);
        const isSupportedPremium = edition === (0, $6WXNs.PREMIUM_EDITION) && (productKey === 'jira' || productKey === 'jira-core' || productKey === 'jira-software');
        const isSupportedEdition = isSupportedStandard || isSupportedPremium;
        const shouldShowEditionAwarenessDropdown = isSupportedEdition && !inGracePeriod;
        const isTest = premiumFeaturesCohort === (0, $9pjFJ.PREMIUM_FEATURES_COHORT_VARIANT);
        if (shouldShowEditionAwarenessDropdown && isTest) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31g2G.Dropdown), {
            applicationEdition: edition,
            productKey: productKey,
            status: "default",
            analyticsAttributes: analyticsAttributes,
            trialEndTime: trialEndTime
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            id: "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.days-left-button",
            defaultMessage: "{trialDaysLeft, plural, one {# day} other {# days}} left",
            values: {
                trialDaysLeft: trialDaysLeft
            }
        }));
    }
    if (content !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: isBillingAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "edition-awareness-trial-pill"
    }, content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "editionAwarenessTrialPill",
        attributes: analyticsAttributes
    })));
    return null;
};

});
parcelRegister("bNPR8", function(module, exports) {

$parcel$export(module.exports, "WAC_URL", () => $9eebf99356d7dc6e$export$5e8c8041aa206ba5);
const $9eebf99356d7dc6e$export$5e8c8041aa206ba5 = {
    prod: 'https://www.atlassian.com',
    dev: 'https://wac.stg.internal.atlassian.com',
    local: 'https://wac.stg.internal.atlassian.com',
    staging: 'https://wac.stg.internal.atlassian.com'
};

});

parcelRegister("67MTZ", function(module, exports) {

$parcel$export(module.exports, "getAdminBaseUrl", () => $fac65a5b25902587$export$76bb37a926058cca);

var $bW292 = parcelRequire("bW292");
const $fac65a5b25902587$export$76bb37a926058cca = ()=>`https://${(0, $bW292.getATLContextDomain)('admin')}`;

});

parcelRegister("aT2k6", function(module, exports) {

$parcel$export(module.exports, "fireButtonAnalytics", () => $44ad291e48d9c862$export$ac665b9f9662b94a);
$parcel$export(module.exports, "isSupportedProjectType", () => $44ad291e48d9c862$export$fa630a47d84fb39a);
$parcel$export(module.exports, "isInVariationForJsmJpdTrialAwarenessV2", () => $44ad291e48d9c862$export$49b96a7b9c51e733);
$parcel$export(module.exports, "isEligibleForJsmJpdTrialAwarenessV2", () => $44ad291e48d9c862$export$e4cf86ec01cea940);
$parcel$export(module.exports, "isInVariationForJswTrialAwarenessV2", () => $44ad291e48d9c862$export$676c3b3b0b2691ab);
$parcel$export(module.exports, "isEligibleForJswTrialAwarenessV2", () => $44ad291e48d9c862$export$e2725b622be0366d);
$parcel$export(module.exports, "fireJsmJpdAwarenessV2ExperimentExposure", () => $44ad291e48d9c862$export$83d12e5018cf8076);
$parcel$export(module.exports, "fireJswAwarenessV2ExperimentExposure", () => $44ad291e48d9c862$export$8c495302c60b28d7);
$parcel$export(module.exports, "projectTypeToApplicationKey", () => $44ad291e48d9c862$export$83de85c996456cf6);
$parcel$export(module.exports, "getApplicationName", () => $44ad291e48d9c862$export$e248db7c9a3cd59);
$parcel$export(module.exports, "getProductReferrerKey", () => $44ad291e48d9c862$export$b4fb3304d5d8fc5f);

var $7ZZxN = parcelRequire("7ZZxN");

var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $jMP2a = parcelRequire("jMP2a");


var $6WXNs = parcelRequire("6WXNs");
const $44ad291e48d9c862$export$37f449592e04a567 = [
    (0, $7ZZxN.SERVICE_DESK_PROJECT),
    (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT),
    (0, $7ZZxN.SOFTWARE_PROJECT),
    (0, $7ZZxN.CORE_PROJECT)
];
const $44ad291e48d9c862$export$ac665b9f9662b94a = (createAnalyticsEvent, actionSubjectId, attributes)=>{
    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    }), actionSubjectId, {
        ...attributes
    });
};
const $44ad291e48d9c862$export$fa630a47d84fb39a = (value)=>{
    const projectType = (0, $7ZZxN.toProjectType)(value);
    return !!projectType && $44ad291e48d9c862$export$37f449592e04a567.includes(projectType);
};
const $44ad291e48d9c862$export$a60a9471714b18b2 = ()=>{
    const [config] = (0, $79xbN.UNSAFE_noExposureExp)('jsm_jpd_trial_modal_improvement');
    return config.get((0, $1Iui1.COHORT), (0, $1Iui1.NOT_ENROLLED));
};
const $44ad291e48d9c862$export$49b96a7b9c51e733 = ()=>$44ad291e48d9c862$export$a60a9471714b18b2() === (0, $1Iui1.VARIATION);
const $44ad291e48d9c862$export$2bb971a90e8ca4b8 = ()=>$44ad291e48d9c862$export$a60a9471714b18b2() !== (0, $1Iui1.NOT_ENROLLED);
const $44ad291e48d9c862$export$e4cf86ec01cea940 = (projectType)=>$44ad291e48d9c862$export$2bb971a90e8ca4b8() && ((0, $7ZZxN.toProjectType)(projectType) === (0, $7ZZxN.SERVICE_DESK_PROJECT) || (0, $7ZZxN.toProjectType)(projectType) === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT));
const $44ad291e48d9c862$export$fecb69fc0291e39f = ()=>{
    const [config] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_trial_modal_improvement');
    return config.get((0, $1Iui1.COHORT), (0, $1Iui1.NOT_ENROLLED));
};
const $44ad291e48d9c862$export$676c3b3b0b2691ab = ()=>$44ad291e48d9c862$export$fecb69fc0291e39f() === (0, $1Iui1.VARIATION);
const $44ad291e48d9c862$export$13851f84f8b0eb97 = ()=>$44ad291e48d9c862$export$fecb69fc0291e39f() !== (0, $1Iui1.NOT_ENROLLED);
const $44ad291e48d9c862$export$e2725b622be0366d = (projectType, edition)=>$44ad291e48d9c862$export$13851f84f8b0eb97() && (0, $7ZZxN.toProjectType)(projectType) === (0, $7ZZxN.SOFTWARE_PROJECT) && edition === (0, $6WXNs.STANDARD_EDITION);
const $44ad291e48d9c862$export$83d12e5018cf8076 = (createAnalyticsEvent, attributes)=>{
    const cohort = (0, $79xbN.expVal)('jsm_jpd_trial_modal_improvement', 'cohort', 'not-enrolled');
    // send GAS event
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'jsm_jpd_trial_modal_improvement',
        value: cohort,
        growthInitiative: 'transmuters',
        ...attributes
    });
};
const $44ad291e48d9c862$export$8c495302c60b28d7 = (createAnalyticsEvent, attributes)=>{
    const cohort = (0, $79xbN.expVal)('jsw_trial_modal_improvement', 'cohort', 'not-enrolled');
    // send GAS event
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'jsw_trial_modal_improvement',
        value: cohort,
        growthInitiative: 'transmuters',
        ...attributes
    });
};
const $44ad291e48d9c862$export$83de85c996456cf6 = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 0, $2edfd53057852e41$export$1346c9aa3cbb477d;
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61;
        case 0, $7ZZxN.CORE_PROJECT:
            return 0, $2edfd53057852e41$export$db515c8cec1e6f79;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return 0, $2edfd53057852e41$export$202f50ee62667e32;
        default:
            return 0, $2edfd53057852e41$export$db515c8cec1e6f79;
    }
};
const $44ad291e48d9c862$var$JIRA_SERVICE_MANAGEMENT_APP_NAME = 'Jira Service Management';
const $44ad291e48d9c862$var$JIRA_PRODUCT_DISCOVERY_APP_NAME = 'Jira Product Discovery';
const $44ad291e48d9c862$export$e248db7c9a3cd59 = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 'Jira';
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $44ad291e48d9c862$var$JIRA_SERVICE_MANAGEMENT_APP_NAME;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return $44ad291e48d9c862$var$JIRA_PRODUCT_DISCOVERY_APP_NAME;
        default:
            throw new Error(`Unknown project type: ${projectType}`);
    }
};
const $44ad291e48d9c862$export$b4fb3304d5d8fc5f = (projectType)=>{
    if (projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) return 'jsw';
    if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) return 'jsm';
    if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return 'jpd';
    if (projectType === (0, $7ZZxN.CORE_PROJECT)) return 'jwm';
    return null;
};

});
parcelRegister("1Iui1", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $1524157debf2fd00$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $1524157debf2fd00$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $1524157debf2fd00$export$43f367b3e957f219);
$parcel$export(module.exports, "EXPERIMENT", () => $1524157debf2fd00$export$9ba2bc3b1bdc1519);
$parcel$export(module.exports, "VARIATION", () => $1524157debf2fd00$export$fa04ad826acc90da);

var $1ybV0 = parcelRequire("1ybV0");
const $1524157debf2fd00$export$3d370c33621572df = 'cohort';
const $1524157debf2fd00$export$5b7423264d48ab04 = 'not-enrolled';
const $1524157debf2fd00$export$43f367b3e957f219 = 'control';
const $1524157debf2fd00$export$9ba2bc3b1bdc1519 = 'experiment';
const $1524157debf2fd00$export$fa04ad826acc90da = 'variation';
const $1524157debf2fd00$export$6486974e39493fa6 = 'variation-1';
const $1524157debf2fd00$export$7d994996134ad562 = 'variation-2';
const $1524157debf2fd00$export$795e7d69b248dcd0 = 'variation-3';
const $1524157debf2fd00$export$c9c947c57470b787 = 'variation-4';
const $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $1524157debf2fd00$export$5b7423264d48ab04,
    $1524157debf2fd00$export$43f367b3e957f219,
    $1524157debf2fd00$export$9ba2bc3b1bdc1519,
    $1524157debf2fd00$export$fa04ad826acc90da,
    $1524157debf2fd00$export$6486974e39493fa6,
    $1524157debf2fd00$export$7d994996134ad562,
    $1524157debf2fd00$export$795e7d69b248dcd0,
    $1524157debf2fd00$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1524157debf2fd00$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $1ybV0.getMultivariateFeatureFlag)(experimentFeatureFlag, $1524157debf2fd00$export$5b7423264d48ab04, validExperimentGroups);

});


parcelRegister("eina8", function(module, exports) {

$parcel$export(module.exports, "BillingDetailsPopup", () => $8f5cf5fc6bda596a$export$9ba9c2a8da5fd7c5);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jkH4Q = parcelRequire("jkH4Q");

var $7u4fN = parcelRequire("7u4fN");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $0cdA8 = parcelRequire("0cdA8");

var $eI5EY = parcelRequire("eI5EY");

var $g6Osl = parcelRequire("g6Osl");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6UHYb = parcelRequire("6UHYb");

var $eU3Nk = parcelRequire("eU3Nk");

var $beWT5 = parcelRequire("beWT5");

var $6WXNs = parcelRequire("6WXNs");


var $9pjFJ = parcelRequire("9pjFJ");

var $l2kix = parcelRequire("l2kix");
const $8f5cf5fc6bda596a$var$ReverseTrialExperimentErrorBoundary = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $0a36f00f767f9fa2$export$f19f2573d2fc7010),
        packageName: (0, $0a36f00f767f9fa2$export$b8b9d90f9e5bd72b),
        fallback: "unmount",
        teamName: "growth-tako"
    }, children);
const $8f5cf5fc6bda596a$var$PopupInner = ({ url: url, defaultPopupInner: defaultPopupInner, onFireUiAnalyticsEvent: onFireUiAnalyticsEvent })=>{
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $6UHYb.useFetchOnboardingReverseTrial)();
    if (!isReady) return null;
    if (isReady && premiumTrialOnSignup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $beWT5.ReverseTrialExperimentPopupContent), {
        billingPageUrl: url,
        onFireUiAnalyticsEvent: onFireUiAnalyticsEvent
    });
    return defaultPopupInner;
};
const $8f5cf5fc6bda596a$var$ReverseTrialExperimentForceOpen = ({ onPopupToggle: onPopupToggle })=>{
    const { premiumTrialOnSignup: premiumTrialOnSignup } = (0, $6UHYb.useFetchOnboardingReverseTrial)();
    (0, $eU3Nk.useForceOpenPremiumPopupOnDay3)({
        shouldRun: premiumTrialOnSignup,
        onPopupToggle: onPopupToggle
    });
    return null;
};
const $8f5cf5fc6bda596a$var$PopupBackground = ({ defaultBackground: defaultBackground })=>{
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $6UHYb.useFetchOnboardingReverseTrial)();
    if (!isReady || premiumTrialOnSignup) return null;
    return defaultBackground;
};
const $8f5cf5fc6bda596a$export$9ba9c2a8da5fd7c5 = (props)=>{
    const { initialOpenState: initialOpenState = false, edition: edition, addBillingDetailsUrl: addBillingDetailsUrl, analyticsAttributes: analyticsAttributes, inGracePeriod: inGracePeriod, productKey: productKey, children: children } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(initialOpenState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $6UHYb.useFetchOnboardingReverseTrial)();
    const popupTitle = formatMessage(edition === (0, $6WXNs.STANDARD_EDITION) ? (0, $l2kix.default).addPaymentDetailsPopupStandardTitle : (0, $l2kix.default).addPaymentDetailsPopupPremiumTitle);
    const popupContent = formatMessage(edition === (0, $6WXNs.STANDARD_EDITION) ? (0, $l2kix.default).addPaymentDetailsPopupStandardContent : (0, $l2kix.default).addPaymentDetailsPopupPremiumContent);
    const atlOrigin = (0, $eUqFw.useMemo)(()=>new (0, $jkH4Q.default)({
            product: 'jira'
        }), []);
    const url = atlOrigin.addToUrl(addBillingDetailsUrl);
    const hasFiredPvExposured = (0, $eUqFw.useRef)(false);
    const fireUIAnalyticsEvent = (0, $eUqFw.useCallback)((action, actionSubject, actionSubjectId, attributes = {})=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        }), actionSubjectId, {
            ...analyticsAttributes,
            ...attributes
        });
    }, [
        analyticsAttributes,
        createAnalyticsEvent
    ]);
    const onClickButton = (0, $eUqFw.useCallback)(()=>{
        fireUIAnalyticsEvent('clicked', 'button', 'paymentDetailsPopupItem', {
            ...atlOrigin.toAnalyticsAttributes({
                hasGeneratedId: true
            })
        });
        setIsOpen(false);
    }, [
        atlOrigin,
        fireUIAnalyticsEvent
    ]);
    const onPopupToggle = (0, $eUqFw.useCallback)(// autoOpened is temporary for monitoring jsw_reverse_trials_feature_gate
    (show, autoOpened)=>{
        const { cohort: premiumFeaturesCohort } = (0, $9pjFJ.firePremiumFeaturesExperimentExposure)({
            productKey: productKey,
            edition: edition,
            inGracePeriod: inGracePeriod,
            createAnalyticsEvent: createAnalyticsEvent,
            shouldFire: !hasFiredPvExposured.current
        });
        hasFiredPvExposured.current = true;
        fireUIAnalyticsEvent('toggled', 'popup', 'editionAwarenessTrialPillPopup', {
            show: show,
            ...autoOpened !== undefined && {
                autoOpened: autoOpened
            },
            ...premiumFeaturesCohort !== (0, $9pjFJ.PREMIUM_FEATURES_COHORT_NOT_ENROLLED) && {
                premiumFeaturesCohort: premiumFeaturesCohort
            }
        });
        setIsOpen(show);
    }, [
        createAnalyticsEvent,
        edition,
        fireUIAnalyticsEvent,
        inGracePeriod,
        productKey
    ]);
    const onTriggerClick = (0, $eUqFw.useCallback)(()=>{
        onPopupToggle(!isOpen);
    }, [
        onPopupToggle,
        isOpen
    ]);
    const getPopupPlacement = ()=>{
        if (isReady && premiumTrialOnSignup) return 'bottom-end';
        return 'bottom-start';
    };
    const defaultPopupInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "h3",
        xcss: $8f5cf5fc6bda596a$var$popupHeadingStyles
    }, popupTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "p",
        xcss: $8f5cf5fc6bda596a$var$popupContentStyles
    }, popupContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        href: url,
        target: "_blank",
        onClick: onClickButton
    }, formatMessage((0, $l2kix.default).addPaymentDetailsPopupButton)));
    const defaultBackground = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f5cf5fc6bda596a$var$Background, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6Osl.default), {
        alt: "premium-trial-banner"
    }));
    const adjustAnalyticsAttributes = ()=>{
        // Checking for undefined specifically because if the user is not targeted, the value will be undefined
        if (isReady && premiumTrialOnSignup !== undefined) return {
            ...analyticsAttributes,
            isPremiumTrialOnSignup: premiumTrialOnSignup
        };
        return analyticsAttributes;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f5cf5fc6bda596a$var$ReverseTrialExperimentErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f5cf5fc6bda596a$var$ReverseTrialExperimentForceOpen, {
        onPopupToggle: onPopupToggle
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>onPopupToggle(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
                sourceName: "trialPillPopup",
                sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
                attributes: adjustAnalyticsAttributes()
            }), (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f5cf5fc6bda596a$var$ReverseTrialExperimentErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f5cf5fc6bda596a$var$PopupBackground, {
                defaultBackground: defaultBackground
            })) : defaultBackground, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f5cf5fc6bda596a$var$PopupWrapper, null, (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f5cf5fc6bda596a$var$ReverseTrialExperimentErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f5cf5fc6bda596a$var$PopupInner, {
                url: url,
                defaultPopupInner: defaultPopupInner,
                onFireUiAnalyticsEvent: fireUIAnalyticsEvent
            })) : defaultPopupInner)),
        placement: getPopupPlacement(),
        trigger: (triggerProps)=>children({
                triggerProps: triggerProps,
                onClick: onTriggerClick
            })
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f5cf5fc6bda596a$var$PopupWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ogy _1yt4v47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f5cf5fc6bda596a$var$Background = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _11q71osb",
            __cmplp.className
        ])
    });
});
const $8f5cf5fc6bda596a$var$popupHeadingStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    font: 'font.heading.medium',
    fontWeight: '700'
});
const $8f5cf5fc6bda596a$var$popupContentStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.150',
    color: 'color.text.subtle',
    font: 'font.body.small',
    lineHeight: '14px'
});

});
parcelRegister("g6Osl", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc2e798aa81e74f5$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $keZNJ = parcelRequire("keZNJ");
const $dc2e798aa81e74f5$export$abdf1e325e38b834 = (0, (/*@__PURE__*/$parcel$interopDefault($keZNJ)));
const $dc2e798aa81e74f5$export$87ec2877821a8f12 = (0, (/*@__PURE__*/$parcel$interopDefault($keZNJ)));
const $dc2e798aa81e74f5$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: $dc2e798aa81e74f5$export$abdf1e325e38b834,
    srcDark: $dc2e798aa81e74f5$export$87ec2877821a8f12,
    autoDark: false
});
var $dc2e798aa81e74f5$export$2e2bcd8739ae039 = $dc2e798aa81e74f5$var$Illustration;
// for advanced use only
const $dc2e798aa81e74f5$export$a179c88182cb9d56 = [
    0,
    0,
    241,
    107
];

});
parcelRegister("keZNJ", function(module, exports) {
module.exports = new URL("premium-trial.bdfe4386.svg", import.meta.url).toString();

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("6UHYb", function(module, exports) {

$parcel$export(module.exports, "useFetchOnboardingReverseTrial", () => $b872f119bb939011$export$349fbee95cd03b58);

var $eUqFw = parcelRequire("eUqFw");

var $3dMdu = parcelRequire("3dMdu");

var $WBLbN = parcelRequire("WBLbN");

var $kGBLN = parcelRequire("kGBLN");

var $eqi1A = parcelRequire("eqi1A");
const $b872f119bb939011$var$store = (0, $WBLbN.createStore)({
    name: 'jsw-onboarding-reverse-trial',
    initialState: (0, $3dMdu.initialCachedEndpointState),
    actions: $eqi1A.actions
});
const $b872f119bb939011$export$6758b294795e1644 = (0, $WBLbN.createHook)($b872f119bb939011$var$store);
const $b872f119bb939011$export$349fbee95cd03b58 = ()=>{
    const isTargetedForReverseTrials = (0, $kGBLN.useIsTargetedForReverseTrials)();
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { getPremiumTrialOnSignup: getPremiumTrialOnSignup }] = $b872f119bb939011$export$6758b294795e1644();
    (0, $eUqFw.useEffect)(()=>{
        if (isTargetedForReverseTrials && !fetchedOnce && !isFetching && data === undefined) // @ts-expect-error Arguments for the rest parameter 'args' were not provided.
        getPremiumTrialOnSignup();
    }, [
        data,
        fetchedOnce,
        getPremiumTrialOnSignup,
        isFetching,
        isTargetedForReverseTrials
    ]);
    if (!isTargetedForReverseTrials) // If not targeted, no fetching is done. Data is ready to be read
    return {
        premiumTrialOnSignup: undefined,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: true
    };
    return {
        premiumTrialOnSignup: data?.premiumTrialOnSignup,
        reverseTrialCohort: data?.reverseTrialCohort,
        isReady: fetchedOnce && !isFetching
    };
};

});
parcelRegister("3dMdu", function(module, exports) {

$parcel$export(module.exports, "initialCachedEndpointState", () => $38ffeb975058cb36$export$aaed2d023c5dc2c);
const $38ffeb975058cb36$export$aaed2d023c5dc2c = {
    isFetching: false,
    wasFetched: false,
    fetchedOnce: false,
    fetchError: null
};

});

parcelRegister("kGBLN", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForReverseTrials", () => $eb0c94e7b9053e0a$export$897219a3ca9649b9);

var $7ZZxN = parcelRequire("7ZZxN");

var $eI5EY = parcelRequire("eI5EY");

var $bNe1g = parcelRequire("bNe1g");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
const $eb0c94e7b9053e0a$export$897219a3ca9649b9 = ()=>{
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const jswEdition = (0, $ab6rA.useAppEditions)().software;
    if ((0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) {
        const isCurrentProjectJSW = projectContextData?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
        if (jswEdition === (0, $6WXNs.PREMIUM_EDITION) && isCurrentProjectJSW) return true;
        return false;
    }
    return false;
};

});

parcelRegister("eqi1A", function(module, exports) {

$parcel$export(module.exports, "actions", () => $8ab1d92bbb3896f3$export$e324594224ef24da);

var $879e1 = parcelRequire("879e1");

var $4sxuP = parcelRequire("4sxuP");
const $8ab1d92bbb3896f3$var$getPremiumTrialOnSignup = (0, $879e1.cachedEndpointCall)((0, $4sxuP.getOnboardingPremiumTrialWithRethrow));
const $8ab1d92bbb3896f3$export$e324594224ef24da = {
    getPremiumTrialOnSignup: $8ab1d92bbb3896f3$var$getPremiumTrialOnSignup
};

});
parcelRegister("879e1", function(module, exports) {

$parcel$export(module.exports, "cachedEndpointCall", () => $08a4c99d11c890ab$export$9ab04ab45a9b99da);
const $08a4c99d11c890ab$export$9ab04ab45a9b99da = (call)=>(params)=>async ({ getState: getState, setState: setState })=>{
            const { isFetching: isFetching, wasFetched: wasFetched, fetchedOnce: fetchedOnce } = getState();
            if (isFetching || wasFetched) return;
            setState({
                isFetching: true
            });
            try {
                const data = await call(params);
                if (data !== null) setState({
                    data: data,
                    wasFetched: true
                });
                else setState({
                    wasFetched: fetchedOnce
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    fetchError: error
                });
            } finally{
                setState({
                    isFetching: false,
                    fetchedOnce: true
                });
            }
        };

});

parcelRegister("4sxuP", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $1907cbeebd30077d$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $1907cbeebd30077d$export$ef676f7f369f74fe);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $1lUvF = parcelRequire("1lUvF");
const $1907cbeebd30077d$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $1907cbeebd30077d$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $1lUvF.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $1lUvF.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $lRmyA.performGetRequestWithRetry)($1907cbeebd30077d$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $1lUvF.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $1lUvF.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $1907cbeebd30077d$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $1907cbeebd30077d$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("1lUvF", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $d5d23c94342aad01$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $d5d23c94342aad01$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $d5d23c94342aad01$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $d5d23c94342aad01$export$f389f8ca168b4a3a);

var $aZaPn = parcelRequire("aZaPn");

var $guiFP = parcelRequire("guiFP");
const $d5d23c94342aad01$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $d5d23c94342aad01$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $d5d23c94342aad01$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $d5d23c94342aad01$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $d5d23c94342aad01$var$localStorage.get($d5d23c94342aad01$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $d5d23c94342aad01$export$c3378895d06b5528 = ()=>{
    try {
        const value = $d5d23c94342aad01$var$localStorage.get($d5d23c94342aad01$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $d5d23c94342aad01$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $d5d23c94342aad01$var$localStorage.set($d5d23c94342aad01$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $d5d23c94342aad01$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $d5d23c94342aad01$var$localStorage.set($d5d23c94342aad01$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});




parcelRegister("eU3Nk", function(module, exports) {

$parcel$export(module.exports, "useForceOpenPremiumPopupOnDay3", () => $2054c97f0d157d54$export$6cc86e1de6373a57);

var $eUqFw = parcelRequire("eUqFw");


var $lkBAJ = parcelRequire("lkBAJ");
const $2054c97f0d157d54$export$6cc86e1de6373a57 = ({ shouldRun: shouldRun, onPopupToggle: onPopupToggle })=>{
    (0, $eUqFw.useEffect)(()=>{
        if (shouldRun) {
            const onboardingStartedTimestamp = Number((0, $lkBAJ.localStorage).get((0, $8379f5d78bf6fb5a$export$69fe8832c4f79a32)));
            if (onboardingStartedTimestamp) {
                const threeDays = 259200000;
                // If the user has onboarded 3 or more days ago, force open the premium popup
                if (Date.now() - onboardingStartedTimestamp > threeDays) {
                    onPopupToggle(true, true);
                    (0, $lkBAJ.localStorage).remove((0, $8379f5d78bf6fb5a$export$69fe8832c4f79a32));
                }
            }
        }
    }, [
        shouldRun,
        onPopupToggle
    ]);
};

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $8379f5d78bf6fb5a$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $8379f5d78bf6fb5a$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $8379f5d78bf6fb5a$export$e3884212029f7bef = 'should-show-welcome-modal';
const $8379f5d78bf6fb5a$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $8379f5d78bf6fb5a$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $8379f5d78bf6fb5a$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $8379f5d78bf6fb5a$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $8379f5d78bf6fb5a$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $8379f5d78bf6fb5a$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $8379f5d78bf6fb5a$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $8379f5d78bf6fb5a$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $8379f5d78bf6fb5a$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $8379f5d78bf6fb5a$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $8379f5d78bf6fb5a$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $8379f5d78bf6fb5a$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $8379f5d78bf6fb5a$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $8379f5d78bf6fb5a$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $8379f5d78bf6fb5a$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $8379f5d78bf6fb5a$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $8379f5d78bf6fb5a$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $8379f5d78bf6fb5a$export$468488291ccd988 = 'timelineAddItemNudge';
const $8379f5d78bf6fb5a$export$7a33548109ac931d = 'createFormNudge';
const $8379f5d78bf6fb5a$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $8379f5d78bf6fb5a$export$594d3436316492be = 'summaryViewNudge';
const $8379f5d78bf6fb5a$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $8379f5d78bf6fb5a$export$73278890f736ee6f = 'manageProjectsNudge';

parcelRegister("lkBAJ", function(module, exports) {

$parcel$export(module.exports, "sessionStorage", () => $38ca6466cf2419a3$export$f119d83aa936d634);
$parcel$export(module.exports, "sessionStorageProvider", () => $38ca6466cf2419a3$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorage", () => $38ca6466cf2419a3$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");

var $89bO2 = parcelRequire("89bO2");




const $38ca6466cf2419a3$export$f119d83aa936d634 = (0, $89bO2.createSessionExpirableStorageProvider)('onboarding-core');
const $38ca6466cf2419a3$export$5a24cb3021127ff7 = (0, $89bO2.createSessionExpirableStorageProvider)('onboarding-core');
const $38ca6466cf2419a3$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalExpirableStorageProvider)('onboarding-core');

});


parcelRegister("beWT5", function(module, exports) {

$parcel$export(module.exports, "ReverseTrialExperimentPopupContent", () => $b67b7803aa316956$export$2409664383bedc18);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $2KhVf = parcelRequire("2KhVf");

var $1n6uL = parcelRequire("1n6uL");

var $k6W9R = parcelRequire("k6W9R");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7dRgX = parcelRequire("7dRgX");

var $5cLMB = parcelRequire("5cLMB");

var $bwxKQ = parcelRequire("bwxKQ");

var $8XiHP = parcelRequire("8XiHP");

var $eXZ8X = parcelRequire("eXZ8X");

var $kj4XM = parcelRequire("kj4XM");
const $b67b7803aa316956$export$2409664383bedc18 = ({ billingPageUrl: billingPageUrl, onFireUiAnalyticsEvent: onFireUiAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const openChecklist = (0, $bwxKQ.useOpenChecklist)();
    const [{ currentTaskGroupParent: currentTaskGroupParent }, { changeTaskGroupParent: changeTaskGroupParent, nextOpenTask: nextOpenTask }] = (0, $5cLMB.useJswOnboarding)();
    const onClickExplorePremiumFeatures = (0, $eUqFw.useCallback)(()=>{
        onFireUiAnalyticsEvent('clicked', 'button', 'trialPillExplorePremium');
        const taskGroupToEnter = (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK);
        if (currentTaskGroupParent !== taskGroupToEnter) changeTaskGroupParent(taskGroupToEnter);
        openChecklist({
            trigger: 'ReverseTrialPopup'
        });
        nextOpenTask((0, $7dRgX.ADVANCED_ROADMAPS_TASK), {
            closeNudge: true
        });
    }, [
        onFireUiAnalyticsEvent,
        currentTaskGroupParent,
        openChecklist,
        nextOpenTask,
        changeTaskGroupParent
    ]);
    const onLinkClick = (0, $eUqFw.useCallback)((title)=>{
        onFireUiAnalyticsEvent('clicked', 'button', title);
    }, [
        onFireUiAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small"
    }, formatMessage((0, $kj4XM.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        as: "ul",
        xcss: $b67b7803aa316956$var$listContainerStyles,
        alignInline: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eXZ8X.ListItem), {
        title: formatMessage((0, $kj4XM.default).explorePremiumFeaturesLink),
        onClick: onClickExplorePremiumFeatures,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1n6uL))), {
            label: "",
            size: "small"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eXZ8X.ListItem), {
        title: formatMessage((0, $kj4XM.default).addPaymentDetailsLink),
        link: billingPageUrl,
        onClick: ()=>onLinkClick('trialPillAddPaymentDetails'),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2KhVf))), {
            label: "",
            size: "small"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8XiHP.ChangePlansUrlProvider), null, (changePlansUrl)=>changePlansUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eXZ8X.ListItem), {
            title: formatMessage((0, $kj4XM.default).endTrialAndChangePlansLink),
            link: changePlansUrl,
            onClick: ()=>onLinkClick('trialPillChangePlans'),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k6W9R))), {
                label: "",
                size: "small"
            })
        }) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "p",
        xcss: $b67b7803aa316956$var$downgradeTextStyles
    }, formatMessage((0, $kj4XM.default).afterTrial)));
};
const $b67b7803aa316956$var$listContainerStyles = (0, $1ZAYh.xcss)({
    listStyle: 'none',
    marginTop: 'space.100',
    padding: 'space.0'
});
const $b67b7803aa316956$var$downgradeTextStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle'
});

});
parcelRegister("7dRgX", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $3913ca223572f8d7$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $3913ca223572f8d7$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $3913ca223572f8d7$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $3913ca223572f8d7$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $3913ca223572f8d7$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $3913ca223572f8d7$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $3913ca223572f8d7$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $3913ca223572f8d7$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $3913ca223572f8d7$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $3913ca223572f8d7$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $3913ca223572f8d7$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $3913ca223572f8d7$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $3913ca223572f8d7$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", () => $3913ca223572f8d7$export$e5b557e3bbb7ec52);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $3913ca223572f8d7$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $3913ca223572f8d7$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $3913ca223572f8d7$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $3913ca223572f8d7$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $3913ca223572f8d7$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $3913ca223572f8d7$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $3913ca223572f8d7$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $3913ca223572f8d7$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $3913ca223572f8d7$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $3913ca223572f8d7$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $3913ca223572f8d7$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $3913ca223572f8d7$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $3913ca223572f8d7$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $3913ca223572f8d7$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $3913ca223572f8d7$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $3913ca223572f8d7$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $3913ca223572f8d7$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $3913ca223572f8d7$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $3913ca223572f8d7$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $3913ca223572f8d7$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $3913ca223572f8d7$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $3913ca223572f8d7$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $3913ca223572f8d7$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $3913ca223572f8d7$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $3913ca223572f8d7$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $3913ca223572f8d7$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $3913ca223572f8d7$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $3913ca223572f8d7$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $3913ca223572f8d7$export$9048315f2c03fd9d);
$parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", () => $3913ca223572f8d7$export$a333714599f14a6);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $3913ca223572f8d7$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $3913ca223572f8d7$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $3913ca223572f8d7$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $3913ca223572f8d7$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $3913ca223572f8d7$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $3913ca223572f8d7$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $3913ca223572f8d7$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $3913ca223572f8d7$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $3913ca223572f8d7$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $3913ca223572f8d7$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $3913ca223572f8d7$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $3913ca223572f8d7$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $3913ca223572f8d7$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $3913ca223572f8d7$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $3913ca223572f8d7$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $3913ca223572f8d7$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $3913ca223572f8d7$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $3913ca223572f8d7$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $3913ca223572f8d7$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $3913ca223572f8d7$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $3913ca223572f8d7$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $3913ca223572f8d7$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $3913ca223572f8d7$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $3913ca223572f8d7$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $3913ca223572f8d7$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $3913ca223572f8d7$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $3913ca223572f8d7$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $3913ca223572f8d7$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $3913ca223572f8d7$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $3913ca223572f8d7$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $3913ca223572f8d7$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $3913ca223572f8d7$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $3913ca223572f8d7$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $3913ca223572f8d7$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $3913ca223572f8d7$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $3913ca223572f8d7$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $3913ca223572f8d7$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $3913ca223572f8d7$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $3913ca223572f8d7$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $3913ca223572f8d7$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $3913ca223572f8d7$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $3913ca223572f8d7$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $3913ca223572f8d7$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $3913ca223572f8d7$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $3913ca223572f8d7$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $3913ca223572f8d7$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $3913ca223572f8d7$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $3913ca223572f8d7$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $3913ca223572f8d7$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $3913ca223572f8d7$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $3913ca223572f8d7$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $3913ca223572f8d7$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $3913ca223572f8d7$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $3913ca223572f8d7$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $3913ca223572f8d7$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $3913ca223572f8d7$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $3913ca223572f8d7$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $3913ca223572f8d7$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $3913ca223572f8d7$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $3913ca223572f8d7$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $3913ca223572f8d7$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $3913ca223572f8d7$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $3913ca223572f8d7$export$736b40db8701ba6c);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $3913ca223572f8d7$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $3913ca223572f8d7$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $3913ca223572f8d7$export$1de5766b7e640d6b);
$parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", () => $3913ca223572f8d7$export$8ab0859f5b30b013);
$parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", () => $3913ca223572f8d7$export$d1f6d18c6698104c);
$parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", () => $3913ca223572f8d7$export$e6ee159eee7adc1c);
$parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", () => $3913ca223572f8d7$export$dd267ca1e3cd3bad);
$parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", () => $3913ca223572f8d7$export$f14c8bffc35200d3);
$parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", () => $3913ca223572f8d7$export$36cc22c9997d92a);
$parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", () => $3913ca223572f8d7$export$d651cc94a46ff383);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $3913ca223572f8d7$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $3913ca223572f8d7$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $3913ca223572f8d7$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $3913ca223572f8d7$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $3913ca223572f8d7$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $3913ca223572f8d7$export$f779bbfe667acddc);
$parcel$export(module.exports, "JWM_BOARD_TASK", () => $3913ca223572f8d7$export$42a8341e3c94a2be);
$parcel$export(module.exports, "JWM_SUMMARY_TASK", () => $3913ca223572f8d7$export$e29c6a916affb308);
$parcel$export(module.exports, "JWM_INVITE_TEAM_TASK", () => $3913ca223572f8d7$export$bc193be3ff1dd519);
$parcel$export(module.exports, "JWM_PAGES_TASK", () => $3913ca223572f8d7$export$73a289f194001f88);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $3913ca223572f8d7$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $3913ca223572f8d7$export$7578902c7f420a3);

var $exb0h = parcelRequire("exb0h");

var $6vrw7 = parcelRequire("6vrw7");
const $3913ca223572f8d7$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
const $3913ca223572f8d7$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $3913ca223572f8d7$export$2b3151a089bc8780 = 'jlove-makkuro';
const $3913ca223572f8d7$export$6826d33e9a2c0119 = 320;
const $3913ca223572f8d7$export$b580da85daad7757 = 'root';
const $3913ca223572f8d7$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $3913ca223572f8d7$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $3913ca223572f8d7$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $3913ca223572f8d7$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $3913ca223572f8d7$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $3913ca223572f8d7$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $3913ca223572f8d7$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $3913ca223572f8d7$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $3913ca223572f8d7$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $3913ca223572f8d7$export$e5b557e3bbb7ec52 = 'isDevopsProject';
const $3913ca223572f8d7$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $3913ca223572f8d7$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $3913ca223572f8d7$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $3913ca223572f8d7$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $3913ca223572f8d7$export$cbeb719208f32c8a = $3913ca223572f8d7$var$completeJswTaskName('add-columns-task');
const $3913ca223572f8d7$export$88c918f2cfaff86 = $3913ca223572f8d7$var$completeJswTaskName('create-project-task');
const $3913ca223572f8d7$export$abbbea7c37c93cb5 = $3913ca223572f8d7$var$completeJswTaskName('create-issue-task');
const $3913ca223572f8d7$export$2a0253cb20f48a8 = $3913ca223572f8d7$var$completeJswTaskName('create-issue-task-simplified');
const $3913ca223572f8d7$export$f97428bb4b1991ec = $3913ca223572f8d7$var$completeJswTaskName('invite-teammates-task');
const $3913ca223572f8d7$export$45eaf4204fcc7 = $3913ca223572f8d7$var$completeJswTaskName('invite-teammates-video-task');
const $3913ca223572f8d7$export$af57685e201438e8 = $3913ca223572f8d7$var$completeJswTaskName('capture-integrations-task');
const $3913ca223572f8d7$export$d6c67e9aab4e2b26 = $3913ca223572f8d7$var$completeJswTaskName('find-help-task');
const $3913ca223572f8d7$export$3de8c242d2b82f26 = $3913ca223572f8d7$var$completeJswTaskName('set-up-board-task');
const $3913ca223572f8d7$export$a01fa44f793dbfac = $3913ca223572f8d7$var$completeJswTaskName('get-mobile-app-task');
const $3913ca223572f8d7$export$6a4507e462fd41da = $3913ca223572f8d7$var$completeJswTaskName('map-out-your-project-goals');
const $3913ca223572f8d7$export$e64c1dced6ac4458 = $3913ca223572f8d7$var$completeJswTaskName('identify-small-chunks-of-work');
const $3913ca223572f8d7$export$63b0e55f9c6454ac = $3913ca223572f8d7$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $3913ca223572f8d7$export$c1effb1c8979fe22 = $3913ca223572f8d7$var$completeJswTaskName('monitor-manage-risk');
const $3913ca223572f8d7$export$d97d31d934dbb194 = $3913ca223572f8d7$var$completeJswTaskName('premium-reverse-trial-task');
const $3913ca223572f8d7$export$cafb5bd13b02056b = $3913ca223572f8d7$var$completeJswTaskName('premium-edition-overview-task');
const $3913ca223572f8d7$export$e55c18b809946e72 = $3913ca223572f8d7$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $3913ca223572f8d7$export$de5640b9ae8140a7 = $3913ca223572f8d7$var$completeJswTaskName('standard-edition-overview-task');
const $3913ca223572f8d7$export$540b5c3c4b6ce459 = $3913ca223572f8d7$var$completeJswTaskName('advanced-roadmaps-task');
const $3913ca223572f8d7$export$6f71dff531ff592 = $3913ca223572f8d7$var$completeJswTaskName('change-control-task');
const $3913ca223572f8d7$export$83255ab79e45f34f = $3913ca223572f8d7$var$completeJswTaskName('automations-task');
const $3913ca223572f8d7$export$b57d172af9ad7647 = $3913ca223572f8d7$var$completeJswTaskName('site-administrations-task');
const $3913ca223572f8d7$export$ff4c933c1fe90b68 = $3913ca223572f8d7$var$completeJswTaskName('user-management-task');
const $3913ca223572f8d7$export$3e2776d61f3662dc = $3913ca223572f8d7$var$completeJswTaskName('scrum-onboarding-task');
const $3913ca223572f8d7$export$9048315f2c03fd9d = $3913ca223572f8d7$var$completeJswTaskName('customize-site-name-task');
const $3913ca223572f8d7$export$a333714599f14a6 = $3913ca223572f8d7$var$completeJswTaskName('get-to-know-your-template-task');
const $3913ca223572f8d7$export$4145c2cec2da6f9b = $3913ca223572f8d7$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $3913ca223572f8d7$export$4957a1ad203cf6dd = $3913ca223572f8d7$var$completeJswTaskName('try-atlassian-university-task');
const $3913ca223572f8d7$export$190b5dd0a1322552 = $3913ca223572f8d7$var$completeJswTaskName('calendar-view-task');
const $3913ca223572f8d7$export$501166b25f254aab = $3913ca223572f8d7$var$completeJwmTaskName('jwm-project-summary-task');
const $3913ca223572f8d7$export$94ad6507a703f4eb = $3913ca223572f8d7$var$completeJwmTaskName('jwm-create-sample-project-task');
const $3913ca223572f8d7$export$be1c522400a1bd7c = $3913ca223572f8d7$var$completeJwmTaskName('background-color-task');
const $3913ca223572f8d7$export$2aa6e7b6e24a04f5 = $3913ca223572f8d7$var$completeJwmTaskName('calendar-task');
const $3913ca223572f8d7$export$f3b53199b07af2a1 = $3913ca223572f8d7$var$completeJwmTaskName('timeline-task');
const $3913ca223572f8d7$export$d37415ffddcf2142 = $3913ca223572f8d7$var$completeJwmTaskName('build-form-task');
const $3913ca223572f8d7$export$2ae00586da7cb606 = $3913ca223572f8d7$var$completeJwmTaskName('feedback-task');
const $3913ca223572f8d7$export$b86266e6594a97bb = $3913ca223572f8d7$var$completeJwmTaskName('feedback-sample-project-task');
const $3913ca223572f8d7$export$20bc3dc137ac1c38 = $3913ca223572f8d7$var$completeJwmTaskName('create-your-own-project-task');
const $3913ca223572f8d7$export$77071b77e2801b18 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-create-project-task');
const $3913ca223572f8d7$export$9c89f946f05d884a = $3913ca223572f8d7$var$completeJwmTaskName('share-project-task');
const $3913ca223572f8d7$export$ce8b25442735839a = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-boards');
const $3913ca223572f8d7$export$31015cf4e430c94d = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-cards');
const $3913ca223572f8d7$export$b52a7c936684cfc5 = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-import');
const $3913ca223572f8d7$export$b5555f24061f9fb = $3913ca223572f8d7$var$completeJwmTaskName('summary-and-reports-task');
const $3913ca223572f8d7$export$ff25449f34b8abf = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $3913ca223572f8d7$export$3380e677209260fe = $3913ca223572f8d7$var$completeJwmTaskName('trello-crossflow-key-differences');
const $3913ca223572f8d7$export$7a2fcaad1564e6b7 = $3913ca223572f8d7$var$completeJwmTaskName('get-started-list-task');
const $3913ca223572f8d7$export$da23b72d32bfad9e = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $3913ca223572f8d7$export$4b064659282e0238 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $3913ca223572f8d7$export$3ab51851f6d823e = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $3913ca223572f8d7$export$e4a1a37a9a1350ad = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $3913ca223572f8d7$export$b7f7da5e795f0327 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $3913ca223572f8d7$export$80a401c1aa47a377 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $3913ca223572f8d7$export$934ac7a251b26dc7 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $3913ca223572f8d7$export$4634f6395df3ebbe = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $3913ca223572f8d7$export$768fb41107a1e8d7 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $3913ca223572f8d7$export$d797a81bace17184 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $3913ca223572f8d7$export$746102c94db9df1f = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $3913ca223572f8d7$export$5f1efd797d65e349 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $3913ca223572f8d7$export$cccc812ccafbf11f = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $3913ca223572f8d7$export$64822db87abd8a47 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $3913ca223572f8d7$export$64f764d8be495c82 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $3913ca223572f8d7$export$24eae23dc1c68bbd = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $3913ca223572f8d7$export$50fa92eba6f82feb = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $3913ca223572f8d7$export$4155d22fe3f14cd6 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $3913ca223572f8d7$export$76813cbead887191 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $3913ca223572f8d7$export$90aab2ff89daf770 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $3913ca223572f8d7$export$a2bc0cbad2e6e605 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $3913ca223572f8d7$export$f90872a1280728bb = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $3913ca223572f8d7$export$bce644e96518cbd2 = $3913ca223572f8d7$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $3913ca223572f8d7$export$241aaebffac0a3e5 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $3913ca223572f8d7$export$f9dfc43b5b31c4b7 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $3913ca223572f8d7$export$79759e9e62fb9312 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $3913ca223572f8d7$export$992d1e0dce255d19 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $3913ca223572f8d7$export$d28c1b0e5b3e768 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $3913ca223572f8d7$export$ca714ee197bed4ec = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $3913ca223572f8d7$export$faae55ceea4b6073 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $3913ca223572f8d7$export$200bc24cd120667e = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $3913ca223572f8d7$export$a0d784a48b4e886c = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $3913ca223572f8d7$export$baf5bd09b4b33b8a = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $3913ca223572f8d7$export$4702007eedbca8ab = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $3913ca223572f8d7$export$aa9d2d635ea63898 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $3913ca223572f8d7$export$2ea449225c1f6cac = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $3913ca223572f8d7$export$deb8b557e735e26a = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $3913ca223572f8d7$export$d45754df44e4c309 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $3913ca223572f8d7$export$78b2913b550edbb = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $3913ca223572f8d7$export$71243272608c58ab = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $3913ca223572f8d7$export$39a08f215c33bc39 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $3913ca223572f8d7$export$d2377f6a6fa3b49c = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $3913ca223572f8d7$export$befa8f6533309779 = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $3913ca223572f8d7$export$736b40db8701ba6c = $3913ca223572f8d7$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $3913ca223572f8d7$export$99b0e09ff6f00490 = $3913ca223572f8d7$var$completeJsmTaskName('customize-your-request-types-task');
const $3913ca223572f8d7$export$2a82344eb273eeff = $3913ca223572f8d7$var$completeJsmTaskName('review-your-channels-task');
const $3913ca223572f8d7$export$1de5766b7e640d6b = $3913ca223572f8d7$var$completeJsmTaskName('invite-your-team-task');
const $3913ca223572f8d7$export$8ab0859f5b30b013 = $3913ca223572f8d7$var$completeDevopsTaskName('welcome-to-your-project-task');
const $3913ca223572f8d7$export$d1f6d18c6698104c = $3913ca223572f8d7$var$completeDevopsTaskName('get-to-know-jira-task');
const $3913ca223572f8d7$export$e6ee159eee7adc1c = $3913ca223572f8d7$var$completeDevopsTaskName('navigate-your-tools-task');
const $3913ca223572f8d7$export$dd267ca1e3cd3bad = $3913ca223572f8d7$var$completeDevopsTaskName('capture-integrations-task');
const $3913ca223572f8d7$export$f14c8bffc35200d3 = $3913ca223572f8d7$var$completeDevopsTaskName('create-automation-rules-task');
const $3913ca223572f8d7$export$36cc22c9997d92a = $3913ca223572f8d7$var$completeDevopsTaskName('invite-teammates-task');
const $3913ca223572f8d7$export$d651cc94a46ff383 = $3913ca223572f8d7$var$completeDevopsTaskName('find-help-task');
const $3913ca223572f8d7$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $3913ca223572f8d7$export$c8ab6996f562d0db = (0, $6vrw7.toAccountId)('accountId');
const $3913ca223572f8d7$export$2b5f951ad8e70cfe = $3913ca223572f8d7$var$completeJswTaskName('kanban-onboarding-task');
const $3913ca223572f8d7$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $3913ca223572f8d7$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $3913ca223572f8d7$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $3913ca223572f8d7$export$f779bbfe667acddc = [
    (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
    (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS)
];
const $3913ca223572f8d7$export$42a8341e3c94a2be = $3913ca223572f8d7$var$completeJwmTaskName('jwm-board-task');
const $3913ca223572f8d7$export$e29c6a916affb308 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-summary-task');
const $3913ca223572f8d7$export$bc193be3ff1dd519 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-invite-team-task');
const $3913ca223572f8d7$export$73a289f194001f88 = $3913ca223572f8d7$var$completeJwmTaskName('jwm-pages-task');
const $3913ca223572f8d7$export$38fbac7a5bf4aa33 = [
    $3913ca223572f8d7$export$2a82344eb273eeff,
    $3913ca223572f8d7$export$99b0e09ff6f00490,
    $3913ca223572f8d7$export$1de5766b7e640d6b
];
const $3913ca223572f8d7$export$7578902c7f420a3 = [
    $3913ca223572f8d7$export$88c918f2cfaff86,
    $3913ca223572f8d7$export$6a4507e462fd41da,
    $3913ca223572f8d7$export$e64c1dced6ac4458,
    $3913ca223572f8d7$export$63b0e55f9c6454ac,
    $3913ca223572f8d7$export$c1effb1c8979fe22,
    $3913ca223572f8d7$export$cbeb719208f32c8a,
    $3913ca223572f8d7$export$abbbea7c37c93cb5,
    $3913ca223572f8d7$export$2a0253cb20f48a8,
    $3913ca223572f8d7$export$f97428bb4b1991ec,
    $3913ca223572f8d7$export$d6c67e9aab4e2b26,
    $3913ca223572f8d7$export$3de8c242d2b82f26,
    $3913ca223572f8d7$export$a01fa44f793dbfac,
    $3913ca223572f8d7$export$45eaf4204fcc7,
    $3913ca223572f8d7$export$af57685e201438e8,
    $3913ca223572f8d7$export$d97d31d934dbb194,
    $3913ca223572f8d7$export$cafb5bd13b02056b,
    $3913ca223572f8d7$export$e55c18b809946e72,
    $3913ca223572f8d7$export$de5640b9ae8140a7,
    $3913ca223572f8d7$export$540b5c3c4b6ce459,
    $3913ca223572f8d7$export$6f71dff531ff592,
    $3913ca223572f8d7$export$83255ab79e45f34f,
    $3913ca223572f8d7$export$b57d172af9ad7647,
    $3913ca223572f8d7$export$ff4c933c1fe90b68,
    $3913ca223572f8d7$export$77071b77e2801b18,
    $3913ca223572f8d7$export$94ad6507a703f4eb,
    $3913ca223572f8d7$export$501166b25f254aab,
    $3913ca223572f8d7$export$be1c522400a1bd7c,
    $3913ca223572f8d7$export$2aa6e7b6e24a04f5,
    $3913ca223572f8d7$export$f3b53199b07af2a1,
    $3913ca223572f8d7$export$d37415ffddcf2142,
    $3913ca223572f8d7$export$2ae00586da7cb606,
    $3913ca223572f8d7$export$9c89f946f05d884a,
    $3913ca223572f8d7$export$20bc3dc137ac1c38,
    $3913ca223572f8d7$export$b52a7c936684cfc5,
    $3913ca223572f8d7$export$b5555f24061f9fb,
    $3913ca223572f8d7$export$ff25449f34b8abf,
    $3913ca223572f8d7$export$3380e677209260fe,
    $3913ca223572f8d7$export$b86266e6594a97bb,
    $3913ca223572f8d7$export$8ab0859f5b30b013,
    $3913ca223572f8d7$export$d1f6d18c6698104c,
    $3913ca223572f8d7$export$e6ee159eee7adc1c,
    $3913ca223572f8d7$export$dd267ca1e3cd3bad,
    $3913ca223572f8d7$export$f14c8bffc35200d3,
    $3913ca223572f8d7$export$36cc22c9997d92a,
    $3913ca223572f8d7$export$d651cc94a46ff383,
    $3913ca223572f8d7$export$3e2776d61f3662dc,
    $3913ca223572f8d7$export$2b5f951ad8e70cfe,
    $3913ca223572f8d7$export$9048315f2c03fd9d,
    $3913ca223572f8d7$export$a333714599f14a6,
    $3913ca223572f8d7$export$4145c2cec2da6f9b,
    $3913ca223572f8d7$export$4957a1ad203cf6dd,
    $3913ca223572f8d7$export$7a2fcaad1564e6b7,
    $3913ca223572f8d7$export$42a8341e3c94a2be,
    $3913ca223572f8d7$export$e29c6a916affb308,
    $3913ca223572f8d7$export$bc193be3ff1dd519,
    $3913ca223572f8d7$export$73a289f194001f88,
    $3913ca223572f8d7$export$190b5dd0a1322552,
    $3913ca223572f8d7$export$da23b72d32bfad9e,
    $3913ca223572f8d7$export$4b064659282e0238,
    $3913ca223572f8d7$export$3ab51851f6d823e,
    $3913ca223572f8d7$export$e4a1a37a9a1350ad,
    $3913ca223572f8d7$export$b7f7da5e795f0327,
    $3913ca223572f8d7$export$80a401c1aa47a377,
    $3913ca223572f8d7$export$934ac7a251b26dc7,
    $3913ca223572f8d7$export$4634f6395df3ebbe,
    $3913ca223572f8d7$export$768fb41107a1e8d7,
    $3913ca223572f8d7$export$d797a81bace17184,
    $3913ca223572f8d7$export$746102c94db9df1f,
    $3913ca223572f8d7$export$5f1efd797d65e349,
    $3913ca223572f8d7$export$cccc812ccafbf11f,
    $3913ca223572f8d7$export$64822db87abd8a47,
    $3913ca223572f8d7$export$64f764d8be495c82,
    $3913ca223572f8d7$export$24eae23dc1c68bbd,
    $3913ca223572f8d7$export$50fa92eba6f82feb,
    $3913ca223572f8d7$export$4155d22fe3f14cd6,
    $3913ca223572f8d7$export$76813cbead887191,
    $3913ca223572f8d7$export$90aab2ff89daf770,
    $3913ca223572f8d7$export$a2bc0cbad2e6e605,
    $3913ca223572f8d7$export$f90872a1280728bb,
    $3913ca223572f8d7$export$bce644e96518cbd2,
    $3913ca223572f8d7$export$241aaebffac0a3e5,
    $3913ca223572f8d7$export$f9dfc43b5b31c4b7,
    $3913ca223572f8d7$export$79759e9e62fb9312,
    $3913ca223572f8d7$export$992d1e0dce255d19,
    $3913ca223572f8d7$export$d28c1b0e5b3e768,
    $3913ca223572f8d7$export$ca714ee197bed4ec,
    $3913ca223572f8d7$export$faae55ceea4b6073,
    $3913ca223572f8d7$export$200bc24cd120667e,
    $3913ca223572f8d7$export$a0d784a48b4e886c,
    $3913ca223572f8d7$export$baf5bd09b4b33b8a,
    $3913ca223572f8d7$export$4702007eedbca8ab,
    $3913ca223572f8d7$export$aa9d2d635ea63898,
    $3913ca223572f8d7$export$2ea449225c1f6cac,
    $3913ca223572f8d7$export$deb8b557e735e26a,
    $3913ca223572f8d7$export$d45754df44e4c309,
    $3913ca223572f8d7$export$78b2913b550edbb,
    $3913ca223572f8d7$export$71243272608c58ab,
    $3913ca223572f8d7$export$39a08f215c33bc39,
    $3913ca223572f8d7$export$d2377f6a6fa3b49c,
    $3913ca223572f8d7$export$befa8f6533309779,
    $3913ca223572f8d7$export$736b40db8701ba6c
];

});

parcelRegister("5cLMB", function(module, exports) {

$parcel$export(module.exports, "useJswOnboarding", () => $502e2dc73b97f226$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $502e2dc73b97f226$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $502e2dc73b97f226$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $502e2dc73b97f226$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $502e2dc73b97f226$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useShouldShowOpenMenuItem", () => $502e2dc73b97f226$export$d994ff8c0341aba1);
$parcel$export(module.exports, "useInviteToProject", () => $502e2dc73b97f226$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $502e2dc73b97f226$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $502e2dc73b97f226$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $502e2dc73b97f226$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $502e2dc73b97f226$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $502e2dc73b97f226$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $502e2dc73b97f226$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $502e2dc73b97f226$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $502e2dc73b97f226$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $502e2dc73b97f226$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $502e2dc73b97f226$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $502e2dc73b97f226$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $502e2dc73b97f226$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $502e2dc73b97f226$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $502e2dc73b97f226$export$521909e3dc7ab811);
$parcel$export(module.exports, "usePersonaExperience", () => $502e2dc73b97f226$export$8e98a1e4d2dbf1b9);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("7dRgX")).QUICKSTART_UI_STATUS);

var $9CmwD = parcelRequire("9CmwD");

var $eI5EY = parcelRequire("eI5EY");

var $WBLbN = parcelRequire("WBLbN");

var $7dRgX = parcelRequire("7dRgX");

var $c8ave = parcelRequire("c8ave");

var $lCsoa = parcelRequire("lCsoa");

var $fricC = parcelRequire("fricC");

var $5OjXh = parcelRequire("5OjXh");

var $egHFE = parcelRequire("egHFE");

const $502e2dc73b97f226$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $lCsoa.initialState,
    actions: $c8ave
});
const $502e2dc73b97f226$export$1cbc60d8dd921852 = (0, $WBLbN.createSubscriber)($502e2dc73b97f226$export$390f32400eaf98c9);
const $502e2dc73b97f226$export$7d91c0af4772787a = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9);
const $502e2dc73b97f226$export$638bfcfce1254bb8 = (0, $WBLbN.createContainer)($502e2dc73b97f226$export$390f32400eaf98c9, {});
const $502e2dc73b97f226$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $502e2dc73b97f226$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $502e2dc73b97f226$export$594f006fa6a1b2e5 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$ea14030920a5d8e6
});
const $502e2dc73b97f226$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $502e2dc73b97f226$export$c5e63e44ad178ae8 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$a943afa434e9487a
});
const $502e2dc73b97f226$export$2c3cd14fff9d6e43 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: null
});
const $502e2dc73b97f226$export$b0db7e46e369e1d9 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: $502e2dc73b97f226$export$9d731f44f82af09f
});
// TODO: KURO-1678, delete - The function can be removed during jsw_feedback_account_id cleanup
const $502e2dc73b97f226$var$useShouldShowOpenMenuItemHook = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.shouldRenderComponent && state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED
});
const $502e2dc73b97f226$export$d994ff8c0341aba1 = ()=>{
    const [shouldShow, { nextSetChecklistIsDismissed: nextSetChecklistIsDismissed }] = $502e2dc73b97f226$var$useShouldShowOpenMenuItemHook();
    return {
        shouldShow: shouldShow,
        setIsDismissed: nextSetChecklistIsDismissed
    };
};
const $502e2dc73b97f226$export$71de79653346a1ea = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $502e2dc73b97f226$export$61185a9266f1f57a = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN || userRole === (0, $fricC.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $502e2dc73b97f226$export$ef4747ba36826d6a = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $502e2dc73b97f226$export$522993b46d9f8266 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $eI5EY.fg)('jsw_onboarding_reactufo_qs') ? (0, $egHFE.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED : (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $502e2dc73b97f226$export$aa4ba29241532382 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $502e2dc73b97f226$export$ed5c755b733bf2b1 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $502e2dc73b97f226$export$35fe0366802512dd = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $5OjXh.getQuickstartTypeSelector)(state)];
        return visibility === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED && (0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load');
    }
});
const $502e2dc73b97f226$export$a41ee0d3b6938099 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $502e2dc73b97f226$export$4ae7b465b076be9 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $502e2dc73b97f226$export$bf6e646c0476acad = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $502e2dc73b97f226$export$6b706bff94798d11 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $502e2dc73b97f226$export$c98db656edc5b3e1 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $502e2dc73b97f226$export$a823278ac9d1112b = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $9CmwD.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN)
});
const $502e2dc73b97f226$export$cb9e0e8fe4df8490 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, $9CmwD.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $7dRgX.KANBAN_ONBOARDING_TASK)))
});
const $502e2dc73b97f226$export$521909e3dc7ab811 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $502e2dc73b97f226$export$f4a2be940259bf95 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});
const $502e2dc73b97f226$export$8e98a1e4d2dbf1b9 = (0, $WBLbN.createHook)($502e2dc73b97f226$export$390f32400eaf98c9, {
    selector: (state)=>state.personaExperience
});

});
parcelRegister("c8ave", function(module, exports) {

$parcel$export(module.exports, "changeTaskGroupParent", () => (parcelRequire("ah9g7")).nextChangeTaskGroupParent);
$parcel$export(module.exports, "goBackToPreviousTaskGroup", () => (parcelRequire("ah9g7")).nextGoBackToPreviousTaskGroup);
$parcel$export(module.exports, "setIsOpen", () => (parcelRequire("3TtLb")).setIsOpen);
$parcel$export(module.exports, "refreshAppState", () => (parcelRequire("agwlB")).refreshAppState);
$parcel$export(module.exports, "setNudgeStep", () => (parcelRequire("aI5eR")).setNudgeStep);
$parcel$export(module.exports, "addMountedNudge", () => (parcelRequire("1jaP6")).addMountedNudge);
$parcel$export(module.exports, "removeMountedNudge", () => (parcelRequire("1jaP6")).removeMountedNudge);
$parcel$export(module.exports, "setShouldRenderComponent", () => (parcelRequire("lCKeP")).setShouldRenderComponent);
$parcel$export(module.exports, "setProjectState", () => (parcelRequire("9FTSc")).setProjectState);
$parcel$export(module.exports, "setHasNudgeActive", () => (parcelRequire("iq74h")).setHasNudgeActive);
$parcel$export(module.exports, "forceHideNudge", () => (parcelRequire("cKB0H")).forceHideNudge);
$parcel$export(module.exports, "setHasEverSeenRoute", () => (parcelRequire("8n1zQ")).setHasEverSeenRoute);
$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => (parcelRequire("ioWKV")).setRoadmapIsCreateEnabled);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => (parcelRequire("ioWKV")).setRoadmapIsListEmpty);
$parcel$export(module.exports, "openNextTask", () => (parcelRequire("P9NN5")).openNextTask);
$parcel$export(module.exports, "resetIsQuickstartLoaded", () => (parcelRequire("6GDwI")).resetIsQuickstartLoaded);
$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => (parcelRequire("N3EY7")).refreshAppStateUiStatusOnly);
$parcel$export(module.exports, "nextMarkAsCompletedTask", () => (parcelRequire("g1Zgk")).nextMarkAsCompletedTask);
$parcel$export(module.exports, "nextSetChecklistItemSeen", () => (parcelRequire("dn2YB")).nextSetChecklistItemSeen);
$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => (parcelRequire("jssF8")).nextSetChecklistIsDismissed);
$parcel$export(module.exports, "nextSetChecklistIsOpen", () => (parcelRequire("ahbtR")).nextSetChecklistIsOpen);
$parcel$export(module.exports, "nextOpenTask", () => (parcelRequire("gn07r")).nextOpenTask);
$parcel$export(module.exports, "nextAutoExpand", () => (parcelRequire("7I9OF")).nextAutoExpand);
$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => (parcelRequire("cDYe7")).nextShouldShowNudgeAfterNavigation);
$parcel$export(module.exports, "nextGetTasks", () => (parcelRequire("kDmv4")).nextGetTasks);
$parcel$export(module.exports, "syncVisibilityWithLocal", () => (parcelRequire("hmvAh")).syncVisibilityWithLocal);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $ah9g7 = parcelRequire("ah9g7");

var $3TtLb = parcelRequire("3TtLb");

var $agwlB = parcelRequire("agwlB");

var $aI5eR = parcelRequire("aI5eR");

var $1jaP6 = parcelRequire("1jaP6");

var $lCKeP = parcelRequire("lCKeP");

var $9FTSc = parcelRequire("9FTSc");

var $iq74h = parcelRequire("iq74h");

var $cKB0H = parcelRequire("cKB0H");

var $8n1zQ = parcelRequire("8n1zQ");

var $ioWKV = parcelRequire("ioWKV");

var $P9NN5 = parcelRequire("P9NN5");

var $6GDwI = parcelRequire("6GDwI");

var $N3EY7 = parcelRequire("N3EY7");

var $g1Zgk = parcelRequire("g1Zgk");

var $dn2YB = parcelRequire("dn2YB");

var $jssF8 = parcelRequire("jssF8");

var $ahbtR = parcelRequire("ahbtR");

var $gn07r = parcelRequire("gn07r");

var $7I9OF = parcelRequire("7I9OF");

var $cDYe7 = parcelRequire("cDYe7");

var $kDmv4 = parcelRequire("kDmv4");

var $hmvAh = parcelRequire("hmvAh");

});
parcelRegister("ah9g7", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $2484e60819053729$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $2484e60819053729$export$57534cbc400a434c);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $2484e60819053729$var$setTaskGroup = (taskGroup)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: ''
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $2484e60819053729$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($2484e60819053729$var$setTaskGroup(taskGroup));
    };
const $2484e60819053729$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        const { previousTaskGroupParents: previousTaskGroupParents } = getState();
        const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $7dRgX.ROOT_TASK) : previousTaskGroupParents.pop();
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newTaskGroupParent
        };
        // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
        dispatch($2484e60819053729$var$setTaskGroup(taskGroup));
    };

});
parcelRegister("8ppHd", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $1733f663faa18bb1$export$583b2d2422a6757f);

var $48bs8 = parcelRequire("48bs8");

var $e91YZ = parcelRequire("e91YZ");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
const $1733f663faa18bb1$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $1733f663faa18bb1$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $48bs8.setUserProperties)($1733f663faa18bb1$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $7byHA.default)(response.status, response.statusText);
    });
const $1733f663faa18bb1$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $1733f663faa18bb1$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $1733f663faa18bb1$export$583b2d2422a6757f = async (props)=>{
    const success = await $1733f663faa18bb1$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $1733f663faa18bb1$var$trySetUserProperties(props, 2);
};

});


parcelRegister("3TtLb", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $e2436d4b85647276$export$dcf23146e0a40195);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");
const $e2436d4b85647276$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: isOpen
        });
    };
var $e2436d4b85647276$export$2e2bcd8739ae039 = $e2436d4b85647276$export$dcf23146e0a40195;

});
parcelRegister("5OjXh", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $6278fa6778740945$export$eae834ce0286017a);

var $7ZZxN = parcelRequire("7ZZxN");

var $7dRgX = parcelRequire("7dRgX");
const $6278fa6778740945$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
const $6278fa6778740945$export$eae834ce0286017a = (state)=>{
    if ($6278fa6778740945$export$6f17f2cb816105eb(state)) return (0, $7dRgX.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $7dRgX.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("agwlB", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $8d23b98670e25122$export$797c35e2e1d0d014);

var $7ZZxN = parcelRequire("7ZZxN");

var $eI5EY = parcelRequire("eI5EY");


var $9z6Oy = parcelRequire("9z6Oy");

var $jMP2a = parcelRequire("jMP2a");

var $4sxuP = parcelRequire("4sxuP");

var $6WXNs = parcelRequire("6WXNs");

var $7dRgX = parcelRequire("7dRgX");

var $6kCnW = parcelRequire("6kCnW");

var $8ppHd = parcelRequire("8ppHd");

var $lIoQU = parcelRequire("lIoQU");

var $71CzX = parcelRequire("71CzX");

var $kL6gJ = parcelRequire("kL6gJ");

var $74z6M = parcelRequire("74z6M");

var $9vuWT = parcelRequire("9vuWT");

var $egHFE = parcelRequire("egHFE");

var $jssF8 = parcelRequire("jssF8");

var $ahbtR = parcelRequire("ahbtR");

var $g1Zgk = parcelRequire("g1Zgk");

var $ah9g7 = parcelRequire("ah9g7");

var $fzDyP = parcelRequire("fzDyP");
const $8d23b98670e25122$var$allTasks = [
    ...(0, $7dRgX.allTasksExcludingJSMBusinessTasks),
    ...(0, $7dRgX.JSM_BUSINESS_TASKS)
];
const $8d23b98670e25122$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $7dRgX.convertToHaveSeenItTask)((0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $7dRgX.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $7dRgX.QUICKSTART_TYPE)).map((type)=>(0, $7dRgX.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $7dRgX.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $6kCnW.pollBackend)({
            keys: [
                (0, $7dRgX.KEY_OPEN),
                (0, $7dRgX.KEY_DISMISSED),
                (0, $7dRgX.KEY_OPEN_TASK),
                (0, $7dRgX.KEY_TASK_GROUP),
                (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $7dRgX.KEY_JSW_ONBOARDING),
                (0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED),
                ...$8d23b98670e25122$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        if (projectState && projectState.projectKey) updatedState.isDevOpsProject = await (0, $74z6M.getIsDevOpsProject)(projectState.projectKey);
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $7dRgX.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $7dRgX.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $7dRgX.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $7dRgX.getBackendVisibilityKey)(type)];
                else if ((0, $7dRgX.KEY_DISMISSED) in backendState && backendState[0, $7dRgX.KEY_DISMISSED]) updatedState.visibility[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $7dRgX.KEY_OPEN] ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
                if ((0, $eI5EY.fg)('jsw_onboarding_reactufo_qs')) (0, $egHFE.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $7dRgX.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $7dRgX.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $7dRgX.KEY_OPEN];
            if ((0, $7dRgX.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $7dRgX.KEY_OPEN_TASK];
            if ((0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $7dRgX.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $7dRgX.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $7dRgX.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $7dRgX.KEY_JSW_ONBOARDING] !== null && (0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe) in backendState[0, $7dRgX.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $7dRgX.KEY_JSW_ONBOARDING][0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe];
            }
        }
        if (atlassianAccountId && projectType === (0, $7ZZxN.CORE_PROJECT) && (0, $71CzX.isUserEnrolledInTailoredOnboardingExperiment)()) try {
            const analyticsEvent = createAnalyticsEvent({});
            const personaExperience = await (0, $fzDyP.getPersonaExperience)(cloudId, atlassianAccountId, (data)=>(0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState settingPersonaExperienceFromTraits', data));
            if (personaExperience) updatedState.personaExperience = personaExperience;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'fetchSiteUserPersonalization');
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $6WXNs.PREMIUM_EDITION)) {
            dispatch((0, $ah9g7.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $7dRgX.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $9vuWT.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $jssF8.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $9z6Oy.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $7dRgX.PACKAGE_NAME),
            teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $kL6gJ.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $6WXNs.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials && (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) {
            const isOnboardingPremiumTrial = await (0, $4sxuP.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!isReverseTrialForJSW && appEditions.software === (0, $6WXNs.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $ahbtR.nextSetChecklistIsOpen)(true));
            dispatch((0, $jssF8.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $g1Zgk.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $ah9g7.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $8ppHd.pushToBackend)({
                key: (0, $7dRgX.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
parcelRegister("9z6Oy", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $d04aec276ef38a16$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $d04aec276ef38a16$export$6da79f996c267010);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $d04aec276ef38a16$var$SITE_PERSONALIZATION_ENDPOINT = `${$d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT}/site/`;
const $d04aec276ef38a16$var$USER_PERSONALIZATION_ENDPOINT = `${$d04aec276ef38a16$var$PERSONALIZATION_ENDPOINT}/user/`;
const $d04aec276ef38a16$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $d04aec276ef38a16$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $d04aec276ef38a16$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $lRmyA.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $d04aec276ef38a16$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes?.find((att)=>att.name === traitName);
    };
const $d04aec276ef38a16$export$686752df505238be = $d04aec276ef38a16$var$getTraits($d04aec276ef38a16$var$fetchPersonalization($d04aec276ef38a16$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $d04aec276ef38a16$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $d04aec276ef38a16$export$6da79f996c267010 = $d04aec276ef38a16$var$getTraits($d04aec276ef38a16$var$fetchPersonalization($d04aec276ef38a16$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $d04aec276ef38a16$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

parcelRegister("6kCnW", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $72b53773fb858e3c$export$8420ef0cee98de);

var $95f8K = parcelRequire("95f8K");

var $6vrw7 = parcelRequire("6vrw7");

var $7dRgX = parcelRequire("7dRgX");
const $72b53773fb858e3c$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $95f8K.get)((0, $6vrw7.toBaseUrl)(''), {
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $7dRgX.PACKAGE_NAME),
            teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("95f8K", function(module, exports) {

$parcel$export(module.exports, "get", () => $4b3de6acfae5f7c4$export$3988ae62b71be9a3);

var $fUTZC = parcelRequire("fUTZC");

var $4vTMF = parcelRequire("4vTMF");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $JRB5w = parcelRequire("JRB5w");

var $lRmyA = parcelRequire("lRmyA");

var $3FyZ4 = parcelRequire("3FyZ4");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
let $4b3de6acfae5f7c4$var$ufoExperiencesMap = {};
const $4b3de6acfae5f7c4$var$getUfoExperience = (key)=>{
    if (!$4b3de6acfae5f7c4$var$ufoExperiencesMap[key]) $4b3de6acfae5f7c4$var$ufoExperiencesMap[key] = new (0, $kDfSL.UFOExperience)(key, {
        type: (0, $12kyE.ExperienceTypes).Operation,
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
    });
    return $4b3de6acfae5f7c4$var$ufoExperiencesMap[key];
};
const $4b3de6acfae5f7c4$export$c907f169d33b2e25 = ()=>{
    $4b3de6acfae5f7c4$var$ufoExperiencesMap = {};
};
const $4b3de6acfae5f7c4$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4b3de6acfae5f7c4$var$patchProperties = (response, propertiesPath)=>((0, $eI5EY.fg)('handle_null_response_for_fe_config_properties_call') ? response : true) && (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $4b3de6acfae5f7c4$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
    const ufoExperience = $4b3de6acfae5f7c4$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $4b3de6acfae5f7c4$export$a5b7a8c3b1c6e775(baseUrl, options);
        const response = await (0, $lRmyA.performGetRequest)(url);
        $4b3de6acfae5f7c4$var$patchProperties(response, 'user');
        $4b3de6acfae5f7c4$var$patchProperties(response, 'instance');
        $4b3de6acfae5f7c4$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return (0, $eI5EY.fg)('handle_null_response_for_fe_config_properties_call') ? response || {
            user: {},
            instance: {},
            project: {}
        } : response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $JRB5w.isClientFetchError)(error) && (0, $guiFP.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("lIoQU", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $d6df15178ffe1f85$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $d6df15178ffe1f85$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $d6df15178ffe1f85$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $d6df15178ffe1f85$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $d6df15178ffe1f85$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $d6df15178ffe1f85$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $d6df15178ffe1f85$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $d6df15178ffe1f85$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $d6df15178ffe1f85$export$6c39ca65ca354e59);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $7dRgX = parcelRequire("7dRgX");

var $eVkIs = parcelRequire("eVkIs");
const $d6df15178ffe1f85$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $7dRgX.ACTION_SUBJECT_ID), attributes);
};
const $d6df15178ffe1f85$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $d6df15178ffe1f85$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $d6df15178ffe1f85$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $eVkIs.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $d6df15178ffe1f85$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $d6df15178ffe1f85$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $d6df15178ffe1f85$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $7dRgX.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("eVkIs", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $0947b77be3ed825c$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $0947b77be3ed825c$export$3b914201960fa7a6);

var $jh2R9 = parcelRequire("jh2R9");

var $7ZZxN = parcelRequire("7ZZxN");
const $0947b77be3ed825c$export$d64a7dd8c7cd80e0 = {
    [(0, $7ZZxN.CORE_PROJECT)]: 'workManagement',
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $0947b77be3ed825c$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $0947b77be3ed825c$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(projectType);
    return null;
};
const $0947b77be3ed825c$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(taskId.split('.').pop());
};

});


parcelRegister("71CzX", function(module, exports) {

$parcel$export(module.exports, "getTailoredOnboardingExperimentCohort", () => $d959c0b35b8f3323$export$fcb264347c366122);
$parcel$export(module.exports, "isUserEnrolledInTailoredOnboardingExperiment", () => $d959c0b35b8f3323$export$7b8159a372d92686);
$parcel$export(module.exports, "isTailoredQuickstartEnabled", () => $d959c0b35b8f3323$export$65a9481ea376f1be);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $4vWp2 = parcelRequire("4vWp2");
const $d959c0b35b8f3323$export$fcb264347c366122 = ()=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_tailored_onboarding');
    return expConfig.get('cohort', 'not-enrolled');
};
const $d959c0b35b8f3323$export$7b8159a372d92686 = ()=>{
    if ((0, $eI5EY.fg)('jwm_tailored_onboarding_gate')) {
        const userCohort = $d959c0b35b8f3323$export$fcb264347c366122();
        return userCohort !== 'not-enrolled';
    }
    return false;
};
const $d959c0b35b8f3323$export$65a9481ea376f1be = (personaExperience)=>Boolean(personaExperience && (0, $4vWp2.SUPPORTED_PERSONA_EXPERIENCES).includes(personaExperience) && (0, $79xbN.expValEquals)('jwm_tailored_onboarding', 'cohort', 'variation'));

});
parcelRegister("4vWp2", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCE_TYPE", () => $9d1a089e61b3d8e4$export$19cb56bee281315d);
$parcel$export(module.exports, "PERSONA_TYPE", () => $9d1a089e61b3d8e4$export$4fea3380347f1b0);
$parcel$export(module.exports, "PERSONA_TRAIT_NAME", () => $9d1a089e61b3d8e4$export$8cfac46d1cf13d0d);
$parcel$export(module.exports, "SUPPORTED_PERSONA_EXPERIENCES", () => $9d1a089e61b3d8e4$export$cbc64427de2881a9);
const $9d1a089e61b3d8e4$export$19cb56bee281315d = {
    MARKETER_LEAD: 'Campaign Management Marketing Lead',
    MARKETER_PROJECT: 'Project Management Marketing Lead',
    MARKETER_CONTENT: 'Content Management Content Marketer',
    MARKETER_PMM: 'Project Management PMM'
};
const $9d1a089e61b3d8e4$export$4fea3380347f1b0 = {
    MARKETING_GENERIC: 'Marketing Generic',
    PROJECT_MARKETING_LEAD: 'Project Management Marketing Lead',
    CAMPAIGN_MARKETING_LEAD: 'Campaign Management Marketing Lead',
    CONTENT_MARKETING_LEAD: 'Content Management Content Marketer',
    PMM: 'Project Management PMM'
};
const $9d1a089e61b3d8e4$export$8cfac46d1cf13d0d = 'marketing_track_tailored_onboarding_initialized_wacprovisioningscreen_changed';
const $9d1a089e61b3d8e4$export$cbc64427de2881a9 = [
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_LEAD,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_PROJECT,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_CONTENT,
    $9d1a089e61b3d8e4$export$19cb56bee281315d.MARKETER_PMM
];

});


parcelRegister("kL6gJ", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $2a787116be621779$export$7f2186c37a3d095d);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $7dRgX = parcelRequire("7dRgX");

var $lmEST = parcelRequire("lmEST");
const $2a787116be621779$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $2a787116be621779$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $2a787116be621779$var$ONE_DAY = 86400000;
const $2a787116be621779$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$2a787116be621779$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $lRmyA.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $7dRgX.PACKAGE_NAME),
                teamName: (0, $7dRgX.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $2a787116be621779$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $lmEST.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $2a787116be621779$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $1ybV0.ff)('jsw.pollinator.tenants')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $2a787116be621779$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $2a787116be621779$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("lmEST", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $6d7ad5c5e3880914$export$99f3e48748c2a8c3);

var $89bO2 = parcelRequire("89bO2");

const $6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider = (0, $89bO2.createSessionExpirableStorageProvider)((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a));
const $6d7ad5c5e3880914$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider.set((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$6d7ad5c5e3880914$var$crossProjectBoardTraitSessionProvider.get((0, $e2fa640244aa9949$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
const $e2fa640244aa9949$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("74z6M", function(module, exports) {

$parcel$export(module.exports, "getIsDevOpsProject", () => $22fff37650eaf366$export$88ee873472aa9bb7);

var $7dRgX = parcelRequire("7dRgX");
const $22fff37650eaf366$var$projectPropertyUrl = (projectKey)=>`/rest/api/2/project/${projectKey}/properties/${0, $7dRgX.KEY_IS_DEVOPS_PROJECT}`;
const $22fff37650eaf366$export$88ee873472aa9bb7 = async (projectKey)=>{
    const url = $22fff37650eaf366$var$projectPropertyUrl(projectKey);
    const response = await fetch(url);
    if (response.ok) {
        const result = await response.json();
        return result.value;
    }
    return false;
};

});

parcelRegister("9vuWT", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $c73311db2e118d57$export$980c26b6f100081d);

var $lRmyA = parcelRequire("lRmyA");
const $c73311db2e118d57$export$980c26b6f100081d = ()=>(0, $lRmyA.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("egHFE", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $e5132247b337604d$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $e5132247b337604d$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $e5132247b337604d$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $e5132247b337604d$export$93d719890ad66653);

var $aZaPn = parcelRequire("aZaPn");

var $bnszi = parcelRequire("bnszi");
const $e5132247b337604d$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $bnszi.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $e5132247b337604d$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $bnszi.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $e5132247b337604d$var$store = (0, $aZaPn.createLocalStorageProvider)('quickstart');
const $e5132247b337604d$export$5aa524d86254b4f = (key, value)=>{
    $e5132247b337604d$var$store.set(key, value);
};
const $e5132247b337604d$export$93d719890ad66653 = (key)=>$e5132247b337604d$var$store.get(key);

});
parcelRegister("bnszi", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $1a376c852d3b72fa$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $1a376c852d3b72fa$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $1a376c852d3b72fa$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $1a376c852d3b72fa$export$293f6b2affa6ea5a);

var $eVkIs = parcelRequire("eVkIs");






const $1a376c852d3b72fa$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $1a376c852d3b72fa$export$9711f11998d5795c = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $1a376c852d3b72fa$export$995248f3b43d8505 = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $1a376c852d3b72fa$export$293f6b2affa6ea5a = (taskId)=>`${(0, $eVkIs.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("jssF8", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $ad333f190549603d$export$f24c05f83b880547);

var $eI5EY = parcelRequire("eI5EY");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");

var $egHFE = parcelRequire("egHFE");
const $ad333f190549603d$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED : (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        if ((0, $eI5EY.fg)('jsw_onboarding_reactufo_qs')) (0, $egHFE.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: false
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_DISMISSED),
            value: isDismissed
        });
    };

});

parcelRegister("ahbtR", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $42c7858c3f713220$export$4249eabbb34e2e69);

var $eI5EY = parcelRequire("eI5EY");

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $5OjXh = parcelRequire("5OjXh");

var $egHFE = parcelRequire("egHFE");
const $42c7858c3f713220$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        if ((0, $eI5EY.fg)('jsw_onboarding_reactufo_qs')) (0, $egHFE.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("g1Zgk", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $13a2c09b85cecff0$export$d6628d41a3bec42d);

var $8ppHd = parcelRequire("8ppHd");
const $13a2c09b85cecff0$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $8ppHd.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});

parcelRegister("fzDyP", function(module, exports) {

$parcel$export(module.exports, "getPersonaExperience", () => $b7c30df71a7183dd$export$f1d14f0838d6ea4f);

var $jRj3P = parcelRequire("jRj3P");

var $71CzX = parcelRequire("71CzX");

var $4vWp2 = parcelRequire("4vWp2");
const $b7c30df71a7183dd$var$getTrait = async (cloudId, userId)=>{
    const userTraits = await (0, $jRj3P.memoizedFetchSiteUserPersonalization)({
        cloudId: cloudId,
        userId: userId
    });
    const userTraitsPersona = userTraits?.find((trait)=>trait.name === (0, $4vWp2.PERSONA_TRAIT_NAME));
    return userTraitsPersona;
};
const $b7c30df71a7183dd$export$f1d14f0838d6ea4f = async (cloudId, userId, fireEvent)=>{
    const userTraitsPersona = await $b7c30df71a7183dd$var$getTrait(cloudId, userId);
    const personaExperience = $b7c30df71a7183dd$var$mapPersonaTraitsToExperienceOld(userTraitsPersona);
    fireEvent({
        personaExperience: personaExperience,
        persona: userTraitsPersona?.value,
        tailoredOnboardingExperiment1: (0, $71CzX.getTailoredOnboardingExperimentCohort)()
    });
    return personaExperience;
};
const $b7c30df71a7183dd$var$mapPersonaTraitsToExperienceOld = (userTraitsPersona)=>{
    switch(userTraitsPersona?.value){
        case (0, $4vWp2.PERSONA_TYPE).MARKETING_GENERIC:
        case (0, $4vWp2.PERSONA_TYPE).CAMPAIGN_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_LEAD;
        case (0, $4vWp2.PERSONA_TYPE).PROJECT_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PROJECT;
        case (0, $4vWp2.PERSONA_TYPE).CONTENT_MARKETING_LEAD:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_CONTENT;
        case (0, $4vWp2.PERSONA_TYPE).PMM:
            return (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PMM;
        default:
            return undefined;
    }
};

});


parcelRegister("aI5eR", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $970ae6c28ea9ba56$export$4debc323813b6997);
const $970ae6c28ea9ba56$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $970ae6c28ea9ba56$export$2e2bcd8739ae039 = $970ae6c28ea9ba56$export$4debc323813b6997;

});

parcelRegister("1jaP6", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $d76ba5c46e283800$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $d76ba5c46e283800$export$748f4cda8ab98c91);
const $d76ba5c46e283800$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $d76ba5c46e283800$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("lCKeP", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $3e69fb4a25487c6b$export$1f9c6770ed938b6e);
const $3e69fb4a25487c6b$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $3e69fb4a25487c6b$export$2e2bcd8739ae039 = $3e69fb4a25487c6b$export$1f9c6770ed938b6e;

});

parcelRegister("9FTSc", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $e8f28a5d91b40a98$export$1ba498e440c0a1e4);
const $e8f28a5d91b40a98$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $e8f28a5d91b40a98$export$2e2bcd8739ae039 = $e8f28a5d91b40a98$export$1ba498e440c0a1e4;

});

parcelRegister("iq74h", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $d5d9f3bbfe59a243$export$497c281e6eb0786e);
const $d5d9f3bbfe59a243$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $d5d9f3bbfe59a243$export$2e2bcd8739ae039 = $d5d9f3bbfe59a243$export$497c281e6eb0786e;

});

parcelRegister("cKB0H", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $395e6590b72e7adc$export$6d1ed97b83a62e8e);
// We use this action in cases where we want to hide the nudge no matter what.
const $395e6590b72e7adc$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("8n1zQ", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $9526def4b4979224$export$28e0a4314a1ce52f);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $9526def4b4979224$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $9526def4b4979224$export$2e2bcd8739ae039 = $9526def4b4979224$export$28e0a4314a1ce52f;

});

parcelRegister("ioWKV", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $3aa7d72125406d8f$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $3aa7d72125406d8f$export$932967764e7a0b31);
const $3aa7d72125406d8f$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $3aa7d72125406d8f$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("P9NN5", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $cc1aff9593d14250$export$867dbb6d61569ae9);

var $egHFE = parcelRequire("egHFE");

var $gn07r = parcelRequire("gn07r");
const $cc1aff9593d14250$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $egHFE.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $gn07r.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("gn07r", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $4f8f6eacc80982cf$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $4f8f6eacc80982cf$export$cc5f3544a6cb2922);


var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");

var $aI5eR = parcelRequire("aI5eR");

var $iq74h = parcelRequire("iq74h");
const $4f8f6eacc80982cf$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $4f8f6eacc80982cf$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($4f8f6eacc80982cf$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $iq74h.setHasNudgeActive)(false, taskId));
        else dispatch((0, $iq74h.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.SCRUM_ONBOARDING_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.KANBAN_ONBOARDING_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $7dRgX.ADD_COLUMNS_TASK)) dispatch((0, $aI5eR.setNudgeStep)((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112)));
        else dispatch((0, $aI5eR.setNudgeStep)(''));
    };
const $4f8f6eacc80982cf$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($4f8f6eacc80982cf$var$openTask(taskId));
        dispatch((0, $iq74h.setHasNudgeActive)(false, taskId));
        dispatch((0, $aI5eR.setNudgeStep)(''));
    };

});


parcelRegister("6GDwI", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $cf59d5b51193e99b$export$bda085a823763e5a);

var $7dRgX = parcelRequire("7dRgX");

var $5OjXh = parcelRequire("5OjXh");
const $cf59d5b51193e99b$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("N3EY7", function(module, exports) {

$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $0d6d286e80d61b67$export$87fe8079a4ed9766);


var $7dRgX = parcelRequire("7dRgX");

var $6kCnW = parcelRequire("6kCnW");

var $lIoQU = parcelRequire("lIoQU");

var $9vuWT = parcelRequire("9vuWT");

var $jssF8 = parcelRequire("jssF8");
const $0d6d286e80d61b67$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $7dRgX.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $7dRgX.QUICKSTART_TYPE)).map((type)=>(0, $7dRgX.getBackendVisibilityKey)(type));
        const backendState = await (0, $6kCnW.pollBackend)({
            keys: [
                (0, $7dRgX.KEY_OPEN),
                (0, $7dRgX.KEY_DISMISSED),
                (0, $7dRgX.KEY_OPEN_TASK),
                (0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $7dRgX.KEY_JSW_ONBOARDING),
                ...(0, $7dRgX.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $7dRgX.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $7dRgX.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $7dRgX.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $7dRgX.getBackendVisibilityKey)(type)];
                else if ((0, $7dRgX.KEY_DISMISSED) in backendState && backendState[0, $7dRgX.KEY_DISMISSED]) updatedState.visibility[type] = (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $7dRgX.KEY_OPEN] ? (0, $7dRgX.QUICKSTART_UI_STATUS).OPEN : (0, $7dRgX.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $7dRgX.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $7dRgX.KEY_DISMISSED];
            if ((0, $7dRgX.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $7dRgX.KEY_OPEN];
            if ((0, $7dRgX.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $7dRgX.KEY_OPEN_TASK];
            if ((0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $7dRgX.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $7dRgX.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $7dRgX.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $7dRgX.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $7dRgX.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $7dRgX.KEY_JSW_ONBOARDING] !== null && (0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe) in backendState[0, $7dRgX.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $7dRgX.KEY_JSW_ONBOARDING][0, $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $7dRgX.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $9vuWT.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $jssF8.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lIoQU.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("dn2YB", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $ae4dc9d92cd110b5$export$4eac017dcde0be8f);

var $7dRgX = parcelRequire("7dRgX");

var $8ppHd = parcelRequire("8ppHd");
const $ae4dc9d92cd110b5$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $7dRgX.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $8ppHd.pushToBackend)({
            key: (0, $7dRgX.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("7I9OF", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $8c8cecc90fef13d0$export$3d24e97d30cfd09e);

var $7dRgX = parcelRequire("7dRgX");

var $cY793 = parcelRequire("cY793");

var $egHFE = parcelRequire("egHFE");

var $gn07r = parcelRequire("gn07r");
const $8c8cecc90fef13d0$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $cY793.localStorageProvider)().get({
            accountId: (0, $7dRgX.ACCOUNT_ID),
            key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $egHFE.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $gn07r.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("cY793", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $f403f41047806be6$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $f403f41047806be6$export$f2666fae743fa5f);

var $89bO2 = parcelRequire("89bO2");

var $guiFP = parcelRequire("guiFP");

var $7dRgX = parcelRequire("7dRgX");
const $f403f41047806be6$var$DAYS_BEFORE_EXPIRY = 1;
const $f403f41047806be6$var$DAY = 86400000;
const $f403f41047806be6$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $f403f41047806be6$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $f403f41047806be6$var$DAYS_BEFORE_EXPIRY * $f403f41047806be6$var$DAY;
};
let $f403f41047806be6$var$localStorage;
const $f403f41047806be6$export$aa821bfb3308a1f5 = ()=>{
    if ($f403f41047806be6$var$localStorage) return $f403f41047806be6$var$localStorage;
    const provider = (0, $89bO2.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }), value, $f403f41047806be6$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($f403f41047806be6$var$getKey({
            accountId: accountId,
            key: key
        }));
    $f403f41047806be6$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $f403f41047806be6$var$localStorage;
};
const $f403f41047806be6$export$f2666fae743fa5f = (value)=>{
    $f403f41047806be6$export$aa821bfb3308a1f5().set({
        accountId: (0, $7dRgX.ACCOUNT_ID),
        key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("cDYe7", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $3949917718560fd8$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.

var $7dRgX = parcelRequire("7dRgX");

var $cY793 = parcelRequire("cY793");

var $iq74h = parcelRequire("iq74h");
const $3949917718560fd8$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $7dRgX.ACCOUNT_ID),
            key: (0, $7dRgX.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $cY793.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $iq74h.setHasNudgeActive)(true));
            (0, $cY793.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("kDmv4", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $2cffb9be55c6d345$export$15d877e1f3abf489);

var $a0vMn = parcelRequire("a0vMn");
const $2cffb9be55c6d345$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
        const { taskList: taskList } = getState();
        const tasks = (0, $a0vMn.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("a0vMn", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $62ef3d093ab58a52$export$d1f442602a91e7cc);

var $dfBCt = parcelRequire("dfBCt");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");


var $6WXNs = parcelRequire("6WXNs");

var $7dRgX = parcelRequire("7dRgX");

var $jTgI9 = parcelRequire("jTgI9");

var $71CzX = parcelRequire("71CzX");

var $fricC = parcelRequire("fricC");

var $4vWp2 = parcelRequire("4vWp2");

var $kxycg = parcelRequire("kxycg");

var $3sCLn = parcelRequire("3sCLn");

var $2UWYK = parcelRequire("2UWYK");

var $c2fmF = parcelRequire("c2fmF");

var $2hhuw = parcelRequire("2hhuw");

var $5f5jN = parcelRequire("5f5jN");
const $62ef3d093ab58a52$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    if (variants.includes((0, $2UWYK.JSW).experiment.jswReverseTrial)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $7dRgX.ROOT_TASK) ? (0, $7dRgX.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $7dRgX.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $2hhuw.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $7dRgX.ROOT_TASK];
    return {
        title: title,
        items: (0, $2hhuw.getTasks)(variants, taskVariants, items)
    };
};
const $62ef3d093ab58a52$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $7dRgX.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $8379f5d78bf6fb5a$export$3366ddefe77d5112));
    if ((0, $dfBCt.isFedRamp)()) variants.add((0, $2UWYK.JSW).experience.fedRamp);
    if (premiumTrialOnSignup && (0, $eI5EY.fg)('jsw_reverse_trials_feature_gate')) variants.add((0, $2UWYK.JSW).experiment.jswReverseTrial);
    if ((0, $1ybV0.ff)('jsw.onboarding.rollout.kuro-2250') && isCustomerTemplateProject) variants.add((0, $2UWYK.JSW).projectProperties.isCreatedFromCustomerTemplate);
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $2UWYK.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $2UWYK.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $2UWYK.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS)) variants.add((0, $2UWYK.JSW).experience.kanbanOnboarding);
    if (canCreateProject === false) variants.add((0, $2UWYK.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $2UWYK.JSW).projectStyle.teamManaged);
    else variants.add((0, $2UWYK.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $2UWYK.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $2UWYK.JSW).userRole.jiraAdmin);
        variants.add((0, $2UWYK.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $2UWYK.JSW).userRole.siteAdmin);
        variants.add((0, $2UWYK.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $6WXNs.FREE_EDITION)) variants.add((0, $2UWYK.JSW).edition.free);
    else if (projectState?.edition === (0, $6WXNs.STANDARD_EDITION)) variants.add((0, $2UWYK.JSW).edition.standard);
    else if (projectState?.edition === (0, $6WXNs.PREMIUM_EDITION)) variants.add((0, $2UWYK.JSW).edition.premium);
    if ((0, $jTgI9.isRoadmapRoute)(routeName)) variants.add((0, $2UWYK.JSW).route.softwareRoadmap);
    else if (routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG)) variants.add((0, $2UWYK.JSW).route.softwareBacklog);
    else if (routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS)) variants.add((0, $2UWYK.JSW).route.softwareBoard);
    else if (routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST) || routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC)) variants.add((0, $2UWYK.JSW).route.softwareList);
    else if (routeName === (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS)) variants.add((0, $2UWYK.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === (0, $exb0h.ROUTE_NAMES_ISSUE)) variants.add((0, $2UWYK.JSW).route.issue);
    else if ((0, $1ybV0.ff)('jsw-calendar-view-onboarding_q3bvy') && (routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR) || routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC))) variants.add((0, $2UWYK.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $2UWYK.JSW).experiment.customizeSiteName);
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $2UWYK.JSW).taskVariants,
        taskList: (0, $2UWYK.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createJwmTasks = (projectState, taskGroupParent, personaExperience, taskList = (0, $c2fmF.JWM).taskList)=>{
    const variants = [];
    variants.push((0, $c2fmF.JWM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $c2fmF.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) variants.push((0, $c2fmF.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) variants.push((0, $c2fmF.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $c2fmF.JWM).experiments.isSampleProject);
    else variants.push((0, $c2fmF.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $c2fmF.JWM).experiments.trelloCrossflow);
    if ((0, $71CzX.isTailoredQuickstartEnabled)(personaExperience)) {
        variants.push((0, $c2fmF.JWM).experiments.personalizedExperience);
        switch(personaExperience){
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_LEAD:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.marketingLeader);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PROJECT:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.projectMarketer);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_CONTENT:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.contentMarketer);
                break;
            case (0, $4vWp2.EXPERIENCE_TYPE).MARKETER_PMM:
                variants.push((0, $c2fmF.JWM).personalizedExperienceExperiments.productMarketingManager);
                break;
            default:
                break;
        }
    }
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $c2fmF.JWM).taskVariants,
        taskList: taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $3sCLn.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $3sCLn.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).JIRA_ADMIN) variants.push((0, $3sCLn.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $fricC.USER_ROLE).SITE_ADMIN) variants.push((0, $3sCLn.JSM).userRole.siteAdmin);
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $3sCLn.JSM).taskVariants,
        taskList: (0, $3sCLn.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$var$createDevopsTasks = (taskGroupParent)=>{
    const variants = [];
    return $62ef3d093ab58a52$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $kxycg.DEVOPS).taskVariants,
        taskList: (0, $kxycg.DEVOPS).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $62ef3d093ab58a52$export$d1f442602a91e7cc = ({ projectState: projectState, isDevOpsProject: isDevOpsProject, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCustomerTemplateProject: isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, personaExperience: personaExperience, taskList: taskList })=>{
    if ((0, $5f5jN.isJwmProject)(projectState)) return $62ef3d093ab58a52$var$createJwmTasks(projectState, taskGroupParent, personaExperience, taskList);
    if ((0, $5f5jN.isJsmProject)(projectState)) return $62ef3d093ab58a52$var$createJsmTasks(projectState, taskGroupParent);
    if (isDevOpsProject) return $62ef3d093ab58a52$var$createDevopsTasks(taskGroupParent);
    return $62ef3d093ab58a52$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("jTgI9", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $2e4ffaed7bae8e69$export$d1fa67c1ffb68871);

var $exb0h = parcelRequire("exb0h");
const $2e4ffaed7bae8e69$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE) || routeName === (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC);
};

});

parcelRegister("fricC", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $3def7289adf5e608$export$8eeb199b23203523);
const $3def7289adf5e608$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("kxycg", function(module, exports) {

$parcel$export(module.exports, "DEVOPS", () => $503385b7e39437c3$export$bb75b6064c92010c);

var $bxltp = parcelRequire("bxltp");
const $503385b7e39437c3$export$bb75b6064c92010c = {
    taskList: (0, $bxltp.TASK_LIST),
    taskVariants: (0, $bxltp.TASK_VARIANTS),
    experiment: (0, $bxltp.Experiment)
};

});
parcelRegister("bxltp", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7cc3b723e4b7a76f$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "TASK_LIST", () => $7cc3b723e4b7a76f$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7cc3b723e4b7a76f$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $ePWG3 = parcelRequire("ePWG3");
const $7cc3b723e4b7a76f$export$4e0ab25c8a7e4009 = {};
const $7cc3b723e4b7a76f$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $ePWG3.messages).rootTitle,
        items: [
            (0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
            (0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK),
            (0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
            (0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK),
            (0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK),
            (0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK),
            (0, $7dRgX.DEVOPS_FIND_HELP_TASK)
        ]
    }
});
const $7cc3b723e4b7a76f$export$36f4d47dfe11b613 = {
    [(0, $7dRgX.DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_GET_TO_KNOW_JIRA_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_NAVIGATE_YOUR_TOOLS_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_CREATE_AUTOMATION_RULES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.DEVOPS_FIND_HELP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("ePWG3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8c9ac3fc1eb167f1$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8c9ac3fc1eb167f1$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.devops.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("3sCLn", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $9ce9aa4e7fe0438e$export$63f289f2da861d35);

var $4Euci = parcelRequire("4Euci");
const $9ce9aa4e7fe0438e$export$63f289f2da861d35 = {
    taskList: (0, $4Euci.JSM_TASK_LIST),
    taskVariants: (0, $4Euci.JSM_TASK_VARIANTS),
    userRole: (0, $4Euci.UserRole),
    experiments: (0, $4Euci.Experiments)
};

});
parcelRegister("4Euci", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $fb74ace10b289ae1$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $fb74ace10b289ae1$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $fb74ace10b289ae1$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $fb74ace10b289ae1$export$5b68aef408c932d9);

var $7dRgX = parcelRequire("7dRgX");

var $aC2eo = parcelRequire("aC2eo");
const $fb74ace10b289ae1$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $aC2eo.messages).rootTitle,
        items: [
            (0, $7dRgX.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $7dRgX.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $7dRgX.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $fb74ace10b289ae1$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $fb74ace10b289ae1$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $fb74ace10b289ae1$export$5b68aef408c932d9 = {
    [(0, $7dRgX.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $7dRgX.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("aC2eo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c73088a9cd2645bf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c73088a9cd2645bf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("2UWYK", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $bddfc54f60451b1f$export$4cfe6e52f2e72a54);

var $8nR1z = parcelRequire("8nR1z");
const $bddfc54f60451b1f$export$4cfe6e52f2e72a54 = {
    taskList: (0, $8nR1z.TASK_LIST),
    taskVariants: (0, $8nR1z.TASK_VARIANTS),
    experiment: (0, $8nR1z.Experiment),
    experience: (0, $8nR1z.Experience),
    projectStyle: (0, $8nR1z.ProjectStyle),
    projectProperties: (0, $8nR1z.ProjectProperties),
    userRole: (0, $8nR1z.UserRole),
    edition: (0, $8nR1z.Edition),
    route: (0, $8nR1z.Route),
    permissions: (0, $8nR1z.Permissions),
    trait: (0, $8nR1z.Trait)
};

});
parcelRegister("8nR1z", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $7a9145b1fc208f16$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $7a9145b1fc208f16$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $7a9145b1fc208f16$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectProperties", () => $7a9145b1fc208f16$export$543c19ee8dba9252);
$parcel$export(module.exports, "UserRole", () => $7a9145b1fc208f16$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $7a9145b1fc208f16$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $7a9145b1fc208f16$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $7a9145b1fc208f16$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $7a9145b1fc208f16$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $7a9145b1fc208f16$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $7a9145b1fc208f16$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $inMFY = parcelRequire("inMFY");
const $7a9145b1fc208f16$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial'
};
const $7a9145b1fc208f16$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $7a9145b1fc208f16$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $7a9145b1fc208f16$export$543c19ee8dba9252 = {
    isCreatedFromCustomerTemplate: 'projectProperties.isCreatedFromCustomerTemplate'
};
const $7a9145b1fc208f16$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $7a9145b1fc208f16$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $7a9145b1fc208f16$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $7a9145b1fc208f16$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $7a9145b1fc208f16$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $7a9145b1fc208f16$var$DEFAULT_TASK_LIST = [
    (0, $7dRgX.ADD_COLUMNS_TASK),
    (0, $7dRgX.CREATE_PROJECT_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK),
    (0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_TASK),
    (0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $7dRgX.CAPTURE_INTEGRATIONS_TASK),
    (0, $7dRgX.FIND_HELP_TASK),
    (0, $7dRgX.SET_UP_BOARD_TASK),
    (0, $7dRgX.GET_MOBILE_APP_TASK),
    (0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $7dRgX.MONITOR_MANAGE_RISK_TASK),
    (0, $7dRgX.SCRUM_ONBOARDING_TASK),
    (0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK),
    (0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK),
    (0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $7dRgX.GET_STARTED_LIST_TASK),
    (0, $7dRgX.CALENDAR_VIEW_TASK)
];
const $7a9145b1fc208f16$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $inMFY.messages).rootTitle,
        items: $7a9145b1fc208f16$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $inMFY.messages).reverseTrialRootTitle,
        items: $7a9145b1fc208f16$var$DEFAULT_TASK_LIST
    },
    [(0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $inMFY.messages).reverseTrialCardTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.CHANGE_CONTROL_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $inMFY.messages).premiumPlanTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.CHANGE_CONTROL_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $inMFY.messages).premiumPlanTitle,
        items: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK),
            (0, $7dRgX.AUTOMATIONS_TASK)
        ]
    },
    [(0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $inMFY.messages).standardPlanTitle,
        items: [
            (0, $7dRgX.AUTOMATIONS_TASK),
            (0, $7dRgX.USER_MANAGEMENT_TASK),
            (0, $7dRgX.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $7a9145b1fc208f16$var$PLAN_ONBOARDING_TASKS = {
    [(0, $7dRgX.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $7a9145b1fc208f16$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.premium,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$6f4a0f769e61929.standard,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $7a9145b1fc208f16$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS = {
    [(0, $7dRgX.GET_TO_KNOW_YOUR_TEMPLATE_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$543c19ee8dba9252.isCreatedFromCustomerTemplate,
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $7a9145b1fc208f16$export$36f4d47dfe11b613 = {
    ...$7a9145b1fc208f16$var$PLAN_ONBOARDING_TASKS,
    ...$7a9145b1fc208f16$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS,
    [(0, $7dRgX.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$543c19ee8dba9252.isCreatedFromCustomerTemplate
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin,
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $7dRgX.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.siteAdmin,
                        $7a9145b1fc208f16$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.projectAdmin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$eb3485a690c2f0b8.admin,
                        $7a9145b1fc208f16$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $7a9145b1fc208f16$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $7a9145b1fc208f16$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $7a9145b1fc208f16$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("inMFY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $52d99860e7a60493$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $52d99860e7a60493$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("c2fmF", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $562f552a719c049d$export$3ff26c80cb588e12);

var $l40o4 = parcelRequire("l40o4");

var $hBhFD = parcelRequire("hBhFD");

var $kN5DK = parcelRequire("kN5DK");
const $562f552a719c049d$export$3ff26c80cb588e12 = {
    taskList: (0, $l40o4.TASK_LIST),
    taskVariants: (0, $l40o4.TASK_VARIANTS),
    userRole: (0, $kN5DK.UserRole),
    experiments: (0, $hBhFD.Experiments),
    personalizedExperienceExperiments: (0, $hBhFD.PersonalizedExperienceExperiments)
};

});
parcelRegister("l40o4", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $0a485b7af0b81750$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $0a485b7af0b81750$export$36f4d47dfe11b613);

var $7dRgX = parcelRequire("7dRgX");

var $hBhFD = parcelRequire("hBhFD");

var $1deRh = parcelRequire("1deRh");

var $kN5DK = parcelRequire("kN5DK");
const $0a485b7af0b81750$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $1deRh.messages).rootTitle,
        items: [
            (0, $7dRgX.JWM_CREATE_PROJECT_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $7dRgX.JWM_PROJECT_SUMMARY_TASK),
            (0, $7dRgX.GET_STARTED_LIST_TASK),
            (0, $7dRgX.JWM_CALENDAR_TASK),
            (0, $7dRgX.JWM_BOARD_TASK),
            (0, $7dRgX.JWM_TIMELINE_TASK),
            (0, $7dRgX.JWM_BUILD_FORM_TASK),
            (0, $7dRgX.JWM_BACKGROUND_COLOR_TASK),
            (0, $7dRgX.JWM_FEEDBACK_TASK),
            (0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $7dRgX.JWM_SHARE_PROJECT_TASK),
            (0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK),
            (0, $7dRgX.JWM_SUMMARY_TASK),
            (0, $7dRgX.JWM_INVITE_TEAM_TASK),
            (0, $7dRgX.JWM_PAGES_TASK)
        ]
    }
});
const $0a485b7af0b81750$export$db06b8e338ba9c65 = {
    [(0, $7dRgX.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $7dRgX.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $7dRgX.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $7dRgX.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $7dRgX.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $7dRgX.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $7dRgX.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $7dRgX.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $7dRgX.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $7dRgX.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $7dRgX.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $7dRgX.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $7dRgX.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $7dRgX.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $7dRgX.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $7dRgX.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $7dRgX.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $7dRgX.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $7dRgX.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $7dRgX.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $7dRgX.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $7dRgX.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $7dRgX.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $0a485b7af0b81750$export$bda7075f98246874 = {
    [(0, $7dRgX.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $7dRgX.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $7dRgX.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $7dRgX.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $7dRgX.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $7dRgX.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $7dRgX.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $7dRgX.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $7dRgX.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $7dRgX.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $7dRgX.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $7dRgX.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $7dRgX.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $7dRgX.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $7dRgX.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $7dRgX.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $7dRgX.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $7dRgX.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $7dRgX.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $7dRgX.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $7dRgX.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $0a485b7af0b81750$export$36f4d47dfe11b613 = {
    ...$0a485b7af0b81750$export$db06b8e338ba9c65,
    ...$0a485b7af0b81750$export$bda7075f98246874,
    [(0, $7dRgX.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: 60
                }
            ]
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).projectMarketer
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BOARD_TASK)]: {
        position: {
            default: 250
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_PAGES_TASK)]: {
        position: {
            default: 375,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).projectMarketer
                    ],
                    value: 325
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).marketingLeader
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SUMMARY_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience,
                        (0, $hBhFD.PersonalizedExperienceExperiments).contentMarketer
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).projectTheming,
                        (0, $kN5DK.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_INVITE_TEAM_TASK)]: {
        position: {
            default: 550
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isNotSampleProject,
                        (0, $hBhFD.Experiments).trelloCrossflow,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).trelloCrossflow
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).personalizedExperience
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $7dRgX.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $hBhFD.Experiments).isSampleProject,
                        (0, $kN5DK.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("hBhFD", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $602d627ebd2e1820$export$c8d6ffd15214553a);
$parcel$export(module.exports, "PersonalizedExperienceExperiments", () => $602d627ebd2e1820$export$ce14e6ba2f059143);
const $602d627ebd2e1820$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow',
    personalizedExperience: 'personalizedExperience'
};
const $602d627ebd2e1820$export$ce14e6ba2f059143 = {
    marketingLeader: 'personalizedExperience.marketing-leader',
    contentMarketer: 'personalizedExperience.content-marketer',
    projectMarketer: 'personalizedExperience.project-marketer',
    productMarketingManager: 'personalizedExperience.pmm'
};

});

parcelRegister("1deRh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9c87cc11a21af694$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9c87cc11a21af694$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("kN5DK", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $c7f18eb8f889bc31$export$eb3485a690c2f0b8);
const $c7f18eb8f889bc31$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("2hhuw", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $1a771609d4c77a5c$export$20b82b4a32771893);

var $kfb7k = parcelRequire("kfb7k");
const $1a771609d4c77a5c$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $kfb7k.getConditional)(visibility, variants) : true;
const $1a771609d4c77a5c$var$getTaskPosition = (variants, position)=>(0, $kfb7k.getConditional)(position, variants);
const $1a771609d4c77a5c$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$1a771609d4c77a5c$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$1a771609d4c77a5c$var$getTaskPosition(variants, taskVariants[taskA].position) - $1a771609d4c77a5c$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("kfb7k", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $75b9324579affeba$export$fe3161cde0106bba);
const $75b9324579affeba$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("5f5jN", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $4c12cc14f77b8d26$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $4c12cc14f77b8d26$export$a972ed853ed1d469);

var $7ZZxN = parcelRequire("7ZZxN");
const $4c12cc14f77b8d26$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $7ZZxN.CORE_PROJECT);
const $4c12cc14f77b8d26$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);

});



parcelRegister("hmvAh", function(module, exports) {

$parcel$export(module.exports, "syncVisibilityWithLocal", () => $9f06cd693ed8e2c1$export$4aab9a98fc53b894);

var $5OjXh = parcelRequire("5OjXh");

var $egHFE = parcelRequire("egHFE");
const $9f06cd693ed8e2c1$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $5OjXh.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $egHFE.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});


parcelRegister("lCsoa", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $eba3eaa3fc426760$export$d4c72bab9d6cc13a);

var $7dRgX = parcelRequire("7dRgX");
const $eba3eaa3fc426760$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    isDevOpsProject: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $7dRgX.ROOT_TASK),
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $7dRgX.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $7dRgX.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $7dRgX.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});


parcelRegister("bwxKQ", function(module, exports) {

$parcel$export(module.exports, "useOpenChecklist", () => $b3983669c6511c14$export$318fa8576ad8aa73);

var $bFzGY = parcelRequire("bFzGY");

var $bUi2Q = parcelRequire("bUi2Q");

var $2cb5E = parcelRequire("2cb5E");

var $7dRgX = parcelRequire("7dRgX");

var $5cLMB = parcelRequire("5cLMB");

var $lIoQU = parcelRequire("lIoQU");
const $b3983669c6511c14$export$318fa8576ad8aa73 = ()=>{
    const [{ openTask: currentOpenTask }, { nextSetChecklistIsOpen: nextSetChecklistIsOpen, nextSetChecklistIsDismissed: nextSetChecklistIsDismissed, nextOpenTask: nextOpenTask }] = (0, $5cLMB.useJswOnboarding)();
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [quickstartStatus] = (0, $5cLMB.useQuickstartUiStatus)();
    const currentRightSidebarState = (0, $bUi2Q.useActiveRightSidebarState)();
    const currentPanelId = currentRightSidebarState?.panelId;
    const openChecklist = ({ trigger: trigger, openTask: openTask })=>{
        if (openTask && openTask !== currentOpenTask) nextOpenTask(openTask);
        openRightSidebar((0, $2cb5E.PANEL_ID), (0, $2cb5E.PANEL_WIDTH), false, true);
        (0, $lIoQU.fireAnalyticsOnOpenRightHandSidebar)(createAnalyticsEvent, {
            quickstartStatus: quickstartStatus,
            currentRightSidebarPanelId: currentPanelId || '',
            openRightSidebarToTop: true,
            trigger: trigger
        });
        if (quickstartStatus === (0, $7dRgX.QUICKSTART_UI_STATUS).DISMISSED) nextSetChecklistIsDismissed(false);
        else nextSetChecklistIsOpen(true);
    };
    return openChecklist;
};

});
parcelRegister("2cb5E", function(module, exports) {

$parcel$export(module.exports, "PANEL_ID", () => $3bcc87ab011a4870$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PANEL_WIDTH", () => $3bcc87ab011a4870$export$e05cfff20e9274e6);
$parcel$export(module.exports, "PERFORMANCE_METRIC_PREFIX", () => $3bcc87ab011a4870$export$495d0560d6ea05d0);
$parcel$export(module.exports, "PERFORMANCE_MARK", () => $3bcc87ab011a4870$export$5da8d06749e84d86);
const $3bcc87ab011a4870$export$e1d562d81d0e502d = 'jsw-nux-onboarding-checklist';
const $3bcc87ab011a4870$export$e05cfff20e9274e6 = 360;
const $3bcc87ab011a4870$export$495d0560d6ea05d0 = 'onboarding-quickstart';
const $3bcc87ab011a4870$export$5da8d06749e84d86 = {
    BUNDLE_LOAD_START: 'bundleLoaded',
    BUNDLE_LOAD_END: 'bundleLoadedEnd'
};

});


parcelRegister("8XiHP", function(module, exports) {

$parcel$export(module.exports, "ChangePlansUrlProvider", () => $94044eb34b2753ff$export$9ff771dc2e9e202f);

var $9AjcL = parcelRequire("9AjcL");

var $eUqFw = parcelRequire("eUqFw");

var $jkH4Q = parcelRequire("jkH4Q");

var $iWLL0 = parcelRequire("iWLL0");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $eI5EY = parcelRequire("eI5EY");

var $gGtKh = parcelRequire("gGtKh");

var $dWLk9 = parcelRequire("dWLk9");
const $94044eb34b2753ff$var$Query = (0, $9AjcL.default);
const $94044eb34b2753ff$var$ChangePlansUrlProviderInner = ({ children: children, queryReference: queryReference })=>{
    const data = (0, $iWLL0.usePreloadedQuery)($94044eb34b2753ff$var$Query, queryReference);
    const changeOfferingCapability = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.experienceCapabilities?.changeOffering;
    const changeOfferingUrl = changeOfferingCapability?.experienceUrl;
    const origin = new (0, $jkH4Q.default)({
        product: 'jira'
    });
    const changeOfferingUrlWithAtlOrigin = changeOfferingUrl ? origin.addToUrl(changeOfferingUrl) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children(changeOfferingUrlWithAtlOrigin));
};
const $94044eb34b2753ff$export$9ff771dc2e9e202f = ({ children: children })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)($94044eb34b2753ff$var$Query);
    (0, $eUqFw.useEffect)(()=>{
        if (queryReference === null) loadQuery({
            cloudId: cloudId,
            productKey: 'jira-software.ondemand',
            offeringKey: 'de2887c9-8a55-41d5-b5cf-ad6a5589ebed'
        });
    }, [
        cloudId,
        loadQuery,
        queryReference
    ]);
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "reverse-trials-popup-change-plans",
        fallback: (0, $eI5EY.fg)('jira_kuro_6557_reverse_trial_popup_a11y_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "li",
            xcss: $94044eb34b2753ff$var$skeletonStylesNew
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $94044eb34b2753ff$var$skeletonStylesOld
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94044eb34b2753ff$var$ChangePlansUrlProviderInner, {
        queryReference: queryReference
    }, children));
};
const $94044eb34b2753ff$var$skeletonStylesOld = (0, $1ZAYh.xcss)({
    height: '20px',
    backgroundColor: 'elevation.surface.hovered'
});
const $94044eb34b2753ff$var$skeletonStylesNew = (0, $1ZAYh.xcss)({
    height: '20px',
    marginTop: 'space.0',
    backgroundColor: 'elevation.surface.hovered'
});

});
parcelRegister("9AjcL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f0ede644ef2b925$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e58941af1d1bdd65e58a2d14853219a>>
 * @relayHash 0f2fcd3025e057b4d4b8841160775500
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5cc154205f88b37c4f3711723d2c2d442e6c0cc8b52d51ac23970adce7e18d56
const $9f0ede644ef2b925$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offeringKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "productKey"
    }, v3 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "changePlansUrlProviderQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "changePlansUrlProviderQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5cc154205f88b37c4f3711723d2c2d442e6c0cc8b52d51ac23970adce7e18d56",
            "metadata": {},
            "name": "changePlansUrlProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9f0ede644ef2b925$var$node.hash = "1760b2a2f58cf86916d00a388c2bff98";
var $9f0ede644ef2b925$export$2e2bcd8739ae039 = $9f0ede644ef2b925$var$node;

});


parcelRegister("eXZ8X", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $09fbc365b740260c$export$a7b06bfba60a8a78);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $8GAdb = parcelRequire("8GAdb");

var $23NQ5 = parcelRequire("23NQ5");

var $4kMup = parcelRequire("4kMup");
var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $27KYr = parcelRequire("27KYr");
var $1ZAYh = parcelRequire("1ZAYh");
const $09fbc365b740260c$var$ListItemContent = ({ title: title, icon: icon, hasLink: hasLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27KYr.default), {
        templateColumns: "16px 1fr 16px",
        columnGap: "space.200",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, hasLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
        label: "",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8GAdb))), {
        label: "",
        size: "small"
    })));
const $09fbc365b740260c$export$a7b06bfba60a8a78 = ({ title: title, link: link, icon: icon, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        as: "li",
        xcss: $09fbc365b740260c$var$listItemStyles,
        direction: "column"
    }, link ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        href: link,
        target: "_blank",
        xcss: $09fbc365b740260c$var$linkStyles,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($09fbc365b740260c$var$ListItemContent, {
        title: title,
        icon: icon,
        hasLink: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        onClick: onClick,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    padding: 0,
                    height: 'auto',
                    width: '100%',
                    background: 'none',
                    fontWeight: 400,
                    textAlign: 'left',
                    lineHeight: '18px'
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($09fbc365b740260c$var$ListItemContent, {
        title: title,
        icon: icon
    })));
const $09fbc365b740260c$var$listItemStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.0',
    paddingBlock: 'space.100'
});
const $09fbc365b740260c$var$linkStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    fontWeight: 400,
    lineHeight: '18px',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});

});

parcelRegister("kj4XM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8a3773b18ec9698$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d8a3773b18ec9698$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "reverse-trial.reverse-trial-popup.title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    explorePremiumFeaturesLink: {
        "id": "reverse-trial.reverse-trial-popup.explore-premium-features-link",
        "defaultMessage": "Explore Premium features"
    },
    addPaymentDetailsLink: {
        "id": "reverse-trial.reverse-trial-popup.add-payment-details-link",
        "defaultMessage": "Add payment details to stay on Premium"
    },
    endTrialAndChangePlansLink: {
        "id": "reverse-trial.reverse-trial-popup.end-trial-and-change-plans-link",
        "defaultMessage": "End trial and change plans"
    },
    afterTrial: {
        "id": "reverse-trial.reverse-trial-popup.after-trial",
        "defaultMessage": "After your trial, we\u2019ll downgrade you to Free."
    }
});

});


parcelRegister("9pjFJ", function(module, exports) {

$parcel$export(module.exports, "PREMIUM_FEATURES_COHORT_VARIANT", () => $b9d0c62a116ac033$export$3ca3221d1387581f);
$parcel$export(module.exports, "PREMIUM_FEATURES_COHORT_NOT_ENROLLED", () => $b9d0c62a116ac033$export$5ba04107d00ba4b3);
$parcel$export(module.exports, "getDemonstratingTheValueofJiraFeaturesExperiment", () => $b9d0c62a116ac033$export$c97ff2409b8f93b6);
$parcel$export(module.exports, "firePremiumFeaturesExperimentExposure", () => $b9d0c62a116ac033$export$b63b014dacf001a6);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");

var $6WXNs = parcelRequire("6WXNs");
const $b9d0c62a116ac033$export$3ca3221d1387581f = 'variant';
const $b9d0c62a116ac033$export$931fa98e3493cab7 = 'control';
const $b9d0c62a116ac033$export$5ba04107d00ba4b3 = 'not-enrolled';
function $b9d0c62a116ac033$export$c97ff2409b8f93b6() {
    const [config, fire] = (0, $79xbN.UNSAFE_noExposureExp)('demonstrating_the_value_of_jira_premium_features');
    const cohort = config.get('cohort', $b9d0c62a116ac033$export$5ba04107d00ba4b3);
    return {
        cohort: cohort,
        fire: fire
    };
}
function $b9d0c62a116ac033$export$ed966ad83a3749a2({ edition: edition, productKey: productKey, inGracePeriod: inGracePeriod }) {
    if (!(0, $eI5EY.fg)('demonstrating_value_of_jira_premium_features_gate')) return false;
    const isSupportedStandard = edition === (0, $6WXNs.STANDARD_EDITION);
    const isSupportedPremium = edition === (0, $6WXNs.PREMIUM_EDITION) && (productKey === 'jira' || productKey === 'jira-core' || productKey === 'jira-software');
    const isSupportedEdition = isSupportedStandard || isSupportedPremium;
    const isEligible = isSupportedEdition && !inGracePeriod;
    return isEligible;
}
const $b9d0c62a116ac033$export$7919f8d75a7caaef = (args)=>{
    if (!$b9d0c62a116ac033$export$ed966ad83a3749a2(args)) return $b9d0c62a116ac033$export$5ba04107d00ba4b3;
    const cohort = (0, $79xbN.expVal)('demonstrating_the_value_of_jira_premium_features', 'cohort', 'not-enrolled');
    // This should always be either `not-enrolled` or `control` as variant should
    // not be running this code
    return cohort;
};
const $b9d0c62a116ac033$export$b63b014dacf001a6 = ({ productKey: productKey, edition: edition, inGracePeriod: inGracePeriod, createAnalyticsEvent: createAnalyticsEvent, shouldFire: shouldFire })=>{
    const cohort = $b9d0c62a116ac033$export$7919f8d75a7caaef({
        productKey: productKey,
        edition: edition,
        inGracePeriod: inGracePeriod
    });
    // send GAS event
    if (cohort !== $b9d0c62a116ac033$export$5ba04107d00ba4b3 && shouldFire) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'demonstrating_the_value_of_jira_premium_features',
        value: cohort,
        growthInitiative: 'buy'
    });
    return {
        cohort: cohort
    };
};

});

parcelRegister("l2kix", function(module, exports) {

$parcel$export(module.exports, "default", () => $65c3e314bc1152cf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $65c3e314bc1152cf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addPaymentDetailsPopupStandardTitle: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-standard-title",
        "defaultMessage": "Standard trial"
    },
    addPaymentDetailsPopupPremiumTitle: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-premium-title",
        "defaultMessage": "Premium trial"
    },
    addPaymentDetailsPopupStandardContent: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-standard-content",
        "defaultMessage": "To stay on the Standard plan after your trial, add your payment details."
    },
    addPaymentDetailsPopupPremiumContent: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-premium-content",
        "defaultMessage": "To stay on the Premium plan after your trial, add your payment details."
    },
    addPaymentDetailsPopupButton: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.billing-details-popup.add-payment-details-popup-button",
        "defaultMessage": "Add payment details"
    }
});

});


parcelRegister("eDMiO", function(module, exports) {

$parcel$export(module.exports, "productAbbreviations", () => $9470cce58183fe12$export$80fc9257f50a9ad4);
const $9470cce58183fe12$export$80fc9257f50a9ad4 = {
    'jira-software': 'jsw',
    'jira-servicedesk': 'jsm',
    'jira-product-discovery': 'jpd',
    'jira-customer-service': 'jcs',
    'jira-core': 'jwm',
    jira: 'jira'
};

});

parcelRegister("31g2G", function(module, exports) {

$parcel$export(module.exports, "Dropdown", () => $8d0b31ade69ff2a8$export$931cbfb6bfb85fc);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $2LOJ0 = parcelRequire("2LOJ0");

var $7ZwLV = parcelRequire("7ZwLV");

var $auLUE = parcelRequire("auLUE");


var $l3Qg0 = parcelRequire("l3Qg0");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $2KzVh = parcelRequire("2KzVh");

var $cPEpP = parcelRequire("cPEpP");

var $lvWQw = parcelRequire("lvWQw");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6UHYb = parcelRequire("6UHYb");

var $eU3Nk = parcelRequire("eU3Nk");

var $dWLk9 = parcelRequire("dWLk9");

var $9pjFJ = parcelRequire("9pjFJ");
const $8d0b31ade69ff2a8$var$useFireGasv3ExposureOnce = ()=>{
    const hasFired = (0, $eUqFw.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (cohort)=>{
        if (!hasFired.current && cohort === 'variant') {
            hasFired.current = true;
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                action: 'exposed',
                actionSubject: 'feature'
            }), 'feature exposed', {
                flagKey: 'demonstrating_the_value_of_jira_premium_features',
                value: cohort,
                growthInitiative: 'buy'
            });
        }
    };
};
const $8d0b31ade69ff2a8$var$fireExposure = (fireExposureEventOnce)=>{
    const { cohort: cohort, fire: fire } = (0, $9pjFJ.getDemonstratingTheValueofJiraFeaturesExperiment)();
    fireExposureEventOnce(cohort);
    fire();
};
/**
 * This was a capability developed during reverse trials where we automatically open the dialog after
 * 3 days of being on the trial. This happens for all customers that have a premium trial on sign up.
 */ const $8d0b31ade69ff2a8$var$useAutoOpenPopover = (openDialog, analyticsAttributes)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireExposureEventOnce = $8d0b31ade69ff2a8$var$useFireGasv3ExposureOnce();
    const onPopupToggle = (0, $eUqFw.useCallback)(()=>{
        // this is just used when we are opening the dialog 3 days after the customer
        // has started their trial, to force it open without the customers interaction
        openDialog();
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'popup'
        }), 'editionAwarenessTrialPillPopup', {
            ...analyticsAttributes,
            flagKey: 'demonstrating_the_value_of_jira_premium_features',
            autoOpened: true,
            premiumFeaturesCohort: (0, $9pjFJ.PREMIUM_FEATURES_COHORT_VARIANT)
        });
        $8d0b31ade69ff2a8$var$fireExposure(fireExposureEventOnce);
    }, [
        openDialog,
        createAnalyticsEvent,
        analyticsAttributes,
        fireExposureEventOnce
    ]);
    const { premiumTrialOnSignup: premiumTrialOnSignup, isReady: isReady } = (0, $6UHYb.useFetchOnboardingReverseTrial)();
    (0, $eU3Nk.useForceOpenPremiumPopupOnDay3)({
        shouldRun: Boolean(isReady && premiumTrialOnSignup),
        onPopupToggle: onPopupToggle
    });
};
const $8d0b31ade69ff2a8$export$931cbfb6bfb85fc = ({ productKey: productKey, applicationEdition: applicationEdition, children: children, status: status, analyticsAttributes: analyticsAttributes, trialEndTime: trialEndTime })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    // While rendering this component, the project loading is already done
    // so we can skip the check for loading state
    const { data: project } = (0, $cPEpP.useProject)();
    const fireExposureEventOnce = $8d0b31ade69ff2a8$var$useFireGasv3ExposureOnce();
    const [dialogOpen, { on: openDialog, toggle: toggleDialog, off: closeDialog }] = (0, $lvWQw.useBoolean)(false);
    const handleTogglePopup = (0, $eUqFw.useCallback)((_event, analyticsEvent)=>{
        const updatedEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'toggled',
                actionSubject: 'popup'
            }));
        (0, $jMP2a.fireUIAnalytics)(updatedEvent, 'editionAwarenessTrialPillPopup', {
            ...analyticsAttributes,
            show: !dialogOpen,
            flagKey: 'demonstrating_the_value_of_jira_premium_features',
            premiumFeaturesCohort: (0, $9pjFJ.PREMIUM_FEATURES_COHORT_VARIANT)
        });
        toggleDialog();
        $8d0b31ade69ff2a8$var$fireExposure(fireExposureEventOnce);
    }, [
        analyticsAttributes,
        dialogOpen,
        fireExposureEventOnce,
        toggleDialog
    ]);
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            cloudId: cloudId,
            productKey: productKey,
            projectKey: project?.key
        }), [
        cloudId,
        productKey,
        project?.key
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $auLUE.editionAwarenessDropdownEntryPoint), entryPointParams);
    const loadEntryPoint = entryPointActions.load;
    const onAutoOpen = (0, $eUqFw.useCallback)(()=>{
        loadEntryPoint();
        openDialog();
    }, [
        loadEntryPoint,
        openDialog
    ]);
    $8d0b31ade69ff2a8$var$useAutoOpenPopover(onAutoOpen, analyticsAttributes);
    const triggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions, true);
    const onFeatureClick = (0, $eUqFw.useCallback)((e, analyticsEvent, featureId)=>{
        // We only want to close the dropdown if the user clicked on the invite people feature
        if (featureId === (0, $7cae58c17c3a3b40$export$7d1e0ac6dfe346c1)) handleTogglePopup(e, analyticsEvent);
    }, [
        handleTogglePopup
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            productKey: productKey,
            applicationEdition: applicationEdition,
            onFeatureClick: onFeatureClick,
            trialEndTime: trialEndTime
        }), [
        productKey,
        applicationEdition,
        onFeatureClick,
        trialEndTime
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "editionAwareness",
        sourceType: (0, $41ea3621645e2acc$export$d1123261ca8831d2)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZwLV.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: dialogOpen,
        onClose: closeDialog,
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "editionAwarenessDropdown",
                packageName: "@atlassian/jira-navigation-apps-sidebar-edition-awareness",
                teamName: "growth-tako",
                runtimeProps: runtimeProps,
                fallback: null
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2LOJ0.EditionAwarenessButton), {
                ...triggerProps,
                onClick: handleTogglePopup,
                ref: (0, $2KzVh.mergeRefs)(triggerProps.ref, triggerRef),
                status: status
            }, children)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};

});
parcelRegister("auLUE", function(module, exports) {

$parcel$export(module.exports, "editionAwarenessDropdownEntryPoint", () => $146c883b5825366d$export$6174a9b4a39703f0);

var $5verF = parcelRequire("5verF");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $146c883b5825366d$export$6174a9b4a39703f0 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("hLRnX")), {
        moduleId: "23d579fa"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey, projectKey: projectKey })=>({
            entryPoints: {},
            extraProps: {
                projectKey: projectKey
            },
            queries: {
                editionAwareness: {
                    parameters: (0, $5verF.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: productKey,
                        projectKey: projectKey ?? '',
                        hasProjectKey: (projectKey ?? '').trim().length > 0
                    }
                }
            }
        })
});

});
parcelRegister("5verF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a808687b453a231e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70f6d71040252741bf3c076f2afde8cf>>
 * @relayHash 37e8ba7434b976190a64f1deb0262db4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e0bf19b8bde0f657198dc98794f5826367d59a6251a3875392c30f8d6c4d3cb9
const $a808687b453a231e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e0bf19b8bde0f657198dc98794f5826367d59a6251a3875392c30f8d6c4d3cb9",
        "metadata": {},
        "name": "uiWrapperEditionAwarenessDropdownWrapperQuery",
        "operationKind": "query",
        "text": null
    }
};
var $a808687b453a231e$export$2e2bcd8739ae039 = $a808687b453a231e$var$node;

});

parcelRegister("hLRnX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2aV2a").then(()=>parcelRequire('eoVWs'));

});


const $7cae58c17c3a3b40$export$7d1e0ac6dfe346c1 = 'invite-people';
const $7cae58c17c3a3b40$export$abfb3fcc6de06e8 = 'automations';
const $7cae58c17c3a3b40$export$512ef3af712e0daf = 'user-activity-logs';
const $7cae58c17c3a3b40$export$ce2cd9308980f6d = 'atlassian-intelligence';
const $7cae58c17c3a3b40$export$423cb3369ffa713 = 'issue-permissions';
const $7cae58c17c3a3b40$export$5e1287b9e6d3c46a = 'custom-project-roles';
const $7cae58c17c3a3b40$export$82c25e7c6c8c0a93 = 'data-residency';
const $7cae58c17c3a3b40$export$1466466c54b5d969 = 'audit-logs';
const $7cae58c17c3a3b40$export$b6970527fbedd427 = 'custom-branding';

parcelRegister("2KzVh", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $0be6a57b715845c4$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $0be6a57b715845c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0be6a57b715845c4$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $0be6a57b715845c4$export$2e2bcd8739ae039(...refs) {
    return (0, $eUqFw.useMemo)(()=>$0be6a57b715845c4$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});

parcelRegister("lvWQw", function(module, exports) {

$parcel$export(module.exports, "useBoolean", () => $35ca89b15f87762a$export$c32275ecbd12948f);

var $eUqFw = parcelRequire("eUqFw");
function $35ca89b15f87762a$export$c32275ecbd12948f(initialValue = false) {
    if (typeof initialValue !== 'boolean') throw new Error('initialValue must be `true` or `false`');
    const [value, setValue] = (0, $eUqFw.useState)(initialValue);
    const handlers = (0, $eUqFw.useMemo)(()=>({
            toggle: ()=>setValue((prevValue)=>!prevValue),
            on: ()=>setValue(true),
            off: ()=>setValue(false),
            setValue: setValue
        }), []);
    return [
        value,
        handlers
    ];
}

});


parcelRegister("cTbJf", function(module, exports) {

$parcel$export(module.exports, "default", () => $418b00af29138e1f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $418b00af29138e1f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    trialButtonTooltip: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.trial-button-tooltip",
        "defaultMessage": "More about your trial and how to pay"
    },
    addPaymentDetailsTooltip: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.add-payment-details-tooltip",
        "defaultMessage": "Add payment details to keep your subscription"
    }
});

});

parcelRegister("hTSHS", function(module, exports) {

$parcel$export(module.exports, "TriggerButton", () => $a28d35f0398dd816$export$4129321aecd13375);

var $eUqFw = parcelRequire("eUqFw");

var $jkH4Q = parcelRequire("jkH4Q");

var $bbaTG = parcelRequire("bbaTG");

var $fjIJG = parcelRequire("fjIJG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6g2XI = parcelRequire("6g2XI");

var $1JlVa = parcelRequire("1JlVa");

var $aT2k6 = parcelRequire("aT2k6");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eibfs = parcelRequire("eibfs");

var $eIp1n = parcelRequire("eIp1n");

var $dWLk9 = parcelRequire("dWLk9");

var $dv4eA = parcelRequire("dv4eA");

var $9pjFJ = parcelRequire("9pjFJ");

var $cPZXm = parcelRequire("cPZXm");
const $a28d35f0398dd816$export$4129321aecd13375 = ({ trialDaysLeft: trialDaysLeft, inGracePeriod: inGracePeriod, onClick: onClick, analyticsAttributes: analyticsAttributes, jstoUrl: jstoUrl, addBillingDetailsUrl: addBillingDetailsUrl, isEligibleForJsmJpdTrialAwarenessModalV2: isEligibleForJsmJpdTrialAwarenessModalV2, isEligibleForJswTrialAwarenessModalV2: isEligibleForJswTrialAwarenessModalV2, triggerProps: triggerProps = {}, productKey: productKey, projectType: projectType, edition: edition })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const hasFiredPvExposured = (0, $eUqFw.useRef)(false);
    const atlOrigin = (0, $eUqFw.useMemo)(()=>new (0, $jkH4Q.default)({
            product: 'jira'
        }), []);
    const url = jstoUrl || inGracePeriod ? atlOrigin.addToUrl(jstoUrl ?? addBillingDetailsUrl) : undefined;
    const shouldShowJsmJpdTrialAwarenessModalV2 = isEligibleForJsmJpdTrialAwarenessModalV2 && (0, $aT2k6.isInVariationForJsmJpdTrialAwarenessV2)();
    const shouldShowJswTrialAwarenessModalV2 = isEligibleForJswTrialAwarenessModalV2 && (0, $aT2k6.isInVariationForJswTrialAwarenessV2)();
    const onClickButton = (0, $eUqFw.useCallback)((...args)=>{
        if (isEligibleForJsmJpdTrialAwarenessModalV2) (0, $aT2k6.fireJsmJpdAwarenessV2ExperimentExposure)(createAnalyticsEvent, analyticsAttributes);
        else if (isEligibleForJswTrialAwarenessModalV2) (0, $aT2k6.fireJswAwarenessV2ExperimentExposure)(createAnalyticsEvent, analyticsAttributes);
        const { cohort: premiumFeaturesCohort } = (0, $9pjFJ.firePremiumFeaturesExperimentExposure)({
            productKey: productKey,
            edition: edition,
            inGracePeriod: inGracePeriod,
            createAnalyticsEvent: createAnalyticsEvent,
            shouldFire: !hasFiredPvExposured.current
        });
        hasFiredPvExposured.current = true;
        const target = jstoUrl ? 'JSTO' : 'BillingScreen';
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editionAwarenessTrialPill', {
            ...premiumFeaturesCohort !== (0, $9pjFJ.PREMIUM_FEATURES_COHORT_NOT_ENROLLED) ? {
                premiumFeaturesCohort: premiumFeaturesCohort
            } : {},
            ...analyticsAttributes,
            ...jstoUrl || inGracePeriod ? {
                target: target,
                ...atlOrigin.toAnalyticsAttributes({
                    hasGeneratedId: true
                })
            } : {},
            ...isEligibleForJsmJpdTrialAwarenessModalV2 ? {
                jsmJpdTrialAwarenessModalV2: {
                    shouldShowJsmJpdTrialAwarenessModalV2: shouldShowJsmJpdTrialAwarenessModalV2
                }
            } : {},
            ...isEligibleForJswTrialAwarenessModalV2 ? {
                jswTrialAwarenessModalV2: {
                    shouldShowJswTrialAwarenessModalV2: shouldShowJswTrialAwarenessModalV2
                }
            } : {}
        });
        return onClick && onClick(...args);
    }, [
        isEligibleForJsmJpdTrialAwarenessModalV2,
        isEligibleForJswTrialAwarenessModalV2,
        jstoUrl,
        createAnalyticsEvent,
        analyticsAttributes,
        inGracePeriod,
        productKey,
        edition,
        atlOrigin,
        onClick,
        shouldShowJsmJpdTrialAwarenessModalV2,
        shouldShowJswTrialAwarenessModalV2
    ]);
    const buttonText = inGracePeriod ? formatMessage((0, $cPZXm.default).addPaymentDetailsSentenceCase) : formatMessage((0, $cPZXm.default).daysLeftOnTrialButtonSentenceCase, {
        trialDaysLeft: trialDaysLeft
    });
    const shouldLinkToJstoPage = !shouldShowJsmJpdTrialAwarenessModalV2 && !shouldShowJswTrialAwarenessModalV2;
    const triggerButton = ({ ref: ref })=>// Ensures Tooltip positioned correctly on the button and is not lost
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            ref: triggerProps.ref,
            xcss: $a28d35f0398dd816$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
            ...triggerProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv4eA.IconWrapper), null, !inGracePeriod && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eibfs.default), {
                label: ""
            }), inGracePeriod && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fjIJG))), {
                label: "",
                color: "currentColor",
                LEGACY_size: "small"
            })),
            onClick: onClickButton,
            theme: (0, $dv4eA.EATopNavPillTheme),
            href: shouldLinkToJstoPage ? url : undefined,
            ref: !shouldLinkToJstoPage ? ref : undefined,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "span",
            xcss: $a28d35f0398dd816$var$eaTopNavButtonTextStyles
        }, buttonText)));
    const trialModalEntryPointParams = (0, $eUqFw.useMemo)(()=>({
            cloudId: cloudId,
            productKey: productKey,
            jiraProjectType: (0, $7ZZxN.convertToJiraProjectType)(projectType),
            jiraApplicationKey: (0, $eIp1n.getApplicationKeyForProject)(projectType)
        }), [
        cloudId,
        productKey,
        projectType
    ]);
    const trialModalEntryPointProps = (0, $eUqFw.useMemo)(()=>({
            projectType: projectType,
            edition: edition
        }), [
        projectType,
        edition
    ]);
    if (shouldShowJsmJpdTrialAwarenessModalV2 || shouldShowJswTrialAwarenessModalV2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6g2XI.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $1JlVa.editionAwarenessTrialModalEntryPoint),
        entryPointParams: trialModalEntryPointParams,
        entryPointProps: trialModalEntryPointProps,
        interactionName: "edition-awareness-trial-modal",
        useInternalModal: false
    }, triggerButton);
    return triggerButton({
        ref: undefined
    });
};
const $a28d35f0398dd816$var$buttonWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex'
});
const $a28d35f0398dd816$var$eaTopNavButtonTextStyles = (0, $1ZAYh.xcss)({
    font: 'font.body',
    color: 'color.text.accent.blue'
});

});
parcelRegister("1JlVa", function(module, exports) {

$parcel$export(module.exports, "editionAwarenessTrialModalEntryPoint", () => $a8110d5cf72f3ec9$export$de2f955c8fd39788);

var $hsi1O = parcelRequire("hsi1O");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $a8110d5cf72f3ec9$export$de2f955c8fd39788 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("jawyL")), {
        moduleId: "3928dd3c"
    }),
    // @ts-expect-error - JiraApplicationKey in AGG schema does not support CUSTOMER_SERVICE
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey, jiraProjectType: jiraProjectType, jiraApplicationKey: jiraApplicationKey })=>({
            extraProps: {
                productKey: productKey
            },
            entryPoints: {},
            queries: {
                editionAwarenessTrialModalQueryRef: {
                    parameters: (0, $hsi1O.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: productKey,
                        projectType: jiraProjectType,
                        jiraApplicationKey: jiraApplicationKey
                    }
                }
            }
        })
});

});
parcelRegister("hsi1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b3391d5882a6fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ff1eb35d4b1573d74dea54c4862ab3d5>>
 * @relayHash 1a171caa1697d948acf3d32b1588f8b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d5369007f52fd194926961741affa5e9d1f74ecb8db80b62bdc3e99df454ac10
const $72b3391d5882a6fe$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "d5369007f52fd194926961741affa5e9d1f74ecb8db80b62bdc3e99df454ac10",
        "metadata": {},
        "name": "main_EditionAwarenessTrialModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $72b3391d5882a6fe$export$2e2bcd8739ae039 = $72b3391d5882a6fe$var$node;

});

parcelRegister("jawyL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("c9VNC")
]).then(()=>parcelRequire('579gd'));

});


parcelRegister("cPZXm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ee802baa83e94bf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9ee802baa83e94bf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    daysLeftOnTrialButtonSentenceCase: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.trigger-button.days-left-on-trial-button-sentence-case",
        "defaultMessage": "{trialDaysLeft, plural, one {# day} other {# days}} left"
    },
    addPaymentDetailsSentenceCase: {
        "id": "navigation-apps-sidebar-edition-awareness.trial-pill.trial-pill-button.trigger-button.add-payment-details-sentence-case",
        "defaultMessage": "Add payment details"
    }
});

});



parcelRegister("eJPyF", function(module, exports) {

$parcel$export(module.exports, "useEligibilityCheckEvent", () => $23258835053a4226$export$a49d52669a91865e);
$parcel$export(module.exports, "getIneligibilityReasons", () => $23258835053a4226$export$3a5909afc297b5c6);
$parcel$export(module.exports, "transformError", () => $23258835053a4226$export$78c6267359db7e73);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $1R3n5 = parcelRequire("1R3n5");
const $23258835053a4226$export$a49d52669a91865e = ({ productKey: productKey, edition: edition, entitlementDetails: entitlementDetails, projectType: projectType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    return (0, $eUqFw.useCallback)((ineligibilityReason, attributes = {})=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'eligibilityCriteria checked', 'editionAwarenessTrialPill', {
            ineligibilityReason: ineligibilityReason,
            isSiteAdmin: isSiteAdmin,
            productKey: productKey,
            projectType: projectType,
            edition: edition,
            entitlementDetails: entitlementDetails,
            ...attributes
        });
    }, [
        createAnalyticsEvent,
        edition,
        entitlementDetails,
        isSiteAdmin,
        productKey,
        projectType
    ]);
};
const $23258835053a4226$export$3a5909afc297b5c6 = (billingInformation)=>{
    const ineligibilityReasons = [];
    if (billingInformation.rawResponse) {
        if (billingInformation.rawResponse?.tenantContexts == null) {
            ineligibilityReasons.push('missingTenantContexts');
            return ineligibilityReasons;
        }
        if (billingInformation.rawResponse?.tenantContexts[0] == null) {
            ineligibilityReasons.push('missingTenantContext');
            return ineligibilityReasons;
        }
        if (billingInformation.rawResponse?.tenantContexts[0]?.entitlementInfo == null) {
            ineligibilityReasons.push('missingEntitlementInfo');
            return ineligibilityReasons;
        }
    }
    if (billingInformation.notInTrialOrPredunning) {
        ineligibilityReasons.push('notInTrialOrPredunning');
        // Return early, as other reasons could not be determined as data are missing in the query
        return ineligibilityReasons;
    }
    // Billing admin explicitly checks false value excluding null/undefined to make sure we use it as reason only if it was intentionally populated
    if (billingInformation.isBillingAdmin !== true) {
        if (billingInformation.isBillingAdmin === false) ineligibilityReasons.push('notBillingAdmin');
        else ineligibilityReasons.push('billingAdminIsNull');
    }
    // Invoiceability is also explicitly checked for not being false since we are showing pill only to sites which were explicitly marked as not invoiceable
    // it is safer not to show pill in case the value comes as null or undefined then show it to ineligible user
    if (billingInformation.invoiceable !== false) {
        if (billingInformation.invoiceable === null) ineligibilityReasons.push('invoiceableIsNull');
        else ineligibilityReasons.push('invoiceable');
    }
    if (!(0, $eI5EY.fg)('trial_edition_awareness_extra_eligibility_check')) return ineligibilityReasons;
    if (billingInformation.partnerManaged === true) ineligibilityReasons.push('partnerManaged');
    if (billingInformation?.billingInterval === 'YEAR') ineligibilityReasons.push('annualBillingCycle');
    if (billingInformation.pricingPlanType && ![
        'COMMERCIAL',
        'COMMUNITY'
    ].includes(billingInformation.pricingPlanType)) ineligibilityReasons.push(`pricingType:${billingInformation.pricingPlanType}`);
    if ([
        'enterprise',
        'atlassian-together'
    ].includes(billingInformation.overriddenEdition || '')) ineligibilityReasons.push(`overriddenEdition:${billingInformation.overriddenEdition}`);
    return ineligibilityReasons;
};
const $23258835053a4226$export$78c6267359db7e73 = (error)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const errorObject = {};
    Object.getOwnPropertyNames(error).filter((name)=>name !== 'stack').forEach((name)=>{
        if (name === 'cause') errorObject[name] = error[name]?.message;
        else errorObject[name] = error[name];
    });
    return errorObject;
};

});



parcelRegister("7K4zM", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbe29f65de979cd4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $dbe29f65de979cd4$var$LazyNav4RolloutAnalytics = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("jtw2b")).then(({ Nav4RolloutAnalytics: Nav4RolloutAnalytics })=>Nav4RolloutAnalytics), {
    moduleId: "./src/packages/navigation-apps/sidebar-nav4/rollout/analytics/src/index.tsx"
});
const $dbe29f65de979cd4$var$AsyncNav4RolloutAnalytics = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-nav4-rollout-analytics",
        fallback: "unmount",
        packageName: "jiraNavigationAppsSidebarNav4RolloutAnalytics",
        teamName: "jira-cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy-nav4-rollout-analytics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dbe29f65de979cd4$var$LazyNav4RolloutAnalytics, null)));
$dbe29f65de979cd4$var$AsyncNav4RolloutAnalytics.displayName = 'AsyncNav4RolloutAnalytics';
var $dbe29f65de979cd4$export$2e2bcd8739ae039 = $dbe29f65de979cd4$var$AsyncNav4RolloutAnalytics;

});
parcelRegister("jtw2b", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9lpcJ").then(()=>parcelRequire('7H2NH'));

});


parcelRegister("gGJaE", function(module, exports) {

$parcel$export(module.exports, "useRecentActions", () => $44ead70d12d9cb4e$export$5c0647984dfa7d27);
$parcel$export(module.exports, "useRecentAllSingleList", () => $44ead70d12d9cb4e$export$9a54f46f5b7734c);
$parcel$export(module.exports, "useWorkedOnAllSingleList", () => $44ead70d12d9cb4e$export$e8278a7bcff1ec98);
$parcel$export(module.exports, "useRecentBoards", () => $44ead70d12d9cb4e$export$3731bd023be4f71);
$parcel$export(module.exports, "useRecentDashboards", () => $44ead70d12d9cb4e$export$81cb5beef51d43ca);
$parcel$export(module.exports, "useRecentProjects", () => $44ead70d12d9cb4e$export$f6b9a13c4ec08b45);
$parcel$export(module.exports, "useRecentFilters", () => $44ead70d12d9cb4e$export$8d2bfb6d3657bae2);
$parcel$export(module.exports, "useRecentQueues", () => $44ead70d12d9cb4e$export$8756abb0bb90a56e);
$parcel$export(module.exports, "RecentsContainer", () => $44ead70d12d9cb4e$export$5de14a1c1400859e);


var $cmI9f = parcelRequire("cmI9f");

var $WBLbN = parcelRequire("WBLbN");

const $44ead70d12d9cb4e$var$emptyItemState = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false
};
const $44ead70d12d9cb4e$export$d4c72bab9d6cc13a = {
    [(0, $0e036566397b8f78$export$f95f1a684a17f189)]: {
        ...$44ead70d12d9cb4e$var$emptyItemState
    },
    [(0, $0e036566397b8f78$export$6e58b6b0aa48a271)]: {
        ...$44ead70d12d9cb4e$var$emptyItemState
    },
    [(0, $0e036566397b8f78$export$6737b9227f60f39d)]: {
        ...$44ead70d12d9cb4e$var$emptyItemState
    },
    [(0, $0e036566397b8f78$export$91a9dba2d38d9a6f)]: {
        ...$44ead70d12d9cb4e$var$emptyItemState
    },
    [(0, $0e036566397b8f78$export$20f1031cc9fdf29e)]: {
        ...$44ead70d12d9cb4e$var$emptyItemState
    },
    workedOn: {
        ...$44ead70d12d9cb4e$var$emptyItemState
    },
    all: {
        ...$44ead70d12d9cb4e$var$emptyItemState
    }
};
const $44ead70d12d9cb4e$var$transformItems = (items)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    items.reduce((acc, itemResponse)=>{
        if (itemResponse.id === 'quick-search-boards') acc[0, $0e036566397b8f78$export$f95f1a684a17f189] = itemResponse.items;
        if (itemResponse.id === 'quick-search-filters') acc[0, $0e036566397b8f78$export$6737b9227f60f39d] = itemResponse.items;
        if (itemResponse.id === 'quick-search-dashboards') acc[0, $0e036566397b8f78$export$6e58b6b0aa48a271] = itemResponse.items;
        if (itemResponse.id === 'quick-search-projects') acc[0, $0e036566397b8f78$export$91a9dba2d38d9a6f] = itemResponse.items;
        if (itemResponse.id === 'quick-search-queues') acc[0, $0e036566397b8f78$export$20f1031cc9fdf29e] = itemResponse.items;
        return acc;
    }, {});
const $44ead70d12d9cb4e$var$transformWorkedOnItems = (response)=>// select the right data and rename it
    response.data.activities.myActivities.workedOn.nodes.map(({ object: { id: id, localResourceId: localResourceId, name: name, extension: extension, iconUrl: iconUrl, url: url, containers: containers, type: type } })=>({
            id: id,
            localResourceId: localResourceId,
            title: name,
            metadata: extension.issueKey,
            avatarUrl: iconUrl,
            url: url,
            attributes: {
                containerName: containers.find((container)=>container.type === 'PROJECT')?.name
            },
            type: `${type.toLowerCase()}s`
        }));
const $44ead70d12d9cb4e$var$getQueryConfig = (amount, types)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    types.reduce((acc, type)=>{
        acc[type] = amount;
        return acc;
    }, {});
const $44ead70d12d9cb4e$var$loadRecentItems = (amount = (0, $708ef86fd90d2755$export$22ea57e66775a6b2), types)=>async ({ setState: setState, getState: getState })=>{
        const typesToFetch = types.filter((type)=>!getState()[type].isFetching);
        if (typesToFetch.length) try {
            const promise = (0, $cmI9f.fetchRecentItems)({
                counts: $44ead70d12d9cb4e$var$getQueryConfig(amount, typesToFetch)
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const loadingState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                };
                return acc;
            }, {});
            setState(loadingState);
            const itemResponse = await promise;
            const transformed = $44ead70d12d9cb4e$var$transformItems(itemResponse || []);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const responseState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    items: transformed[type],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                };
                return acc;
            }, {});
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorState = typesToFetch.reduce((acc, type)=>{
                acc[type] = {
                    ...getState()[type],
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                };
                return acc;
            }, {});
            setState(errorState);
        }
    };
const $44ead70d12d9cb4e$var$loadRecentItemsSingleList = (amount = (0, $708ef86fd90d2755$export$5f1b6c5e9d257e5e), types)=>async ({ setState: setState, getState: getState })=>{
        if (types.length) try {
            const promise = (0, $cmI9f.fetchRecentItemsSingleList)({
                types: types,
                limit: amount
            });
            const loadingState = {
                all: {
                    ...getState().all,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const responseState = {
                all: {
                    items: itemResponse != null ? itemResponse[0].items : [],
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                all: {
                    ...getState().all,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $44ead70d12d9cb4e$var$loadWorkedOnItems = (amount = (0, $708ef86fd90d2755$export$8666f31c8873bff))=>async ({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        try {
            const promise = (0, $cmI9f.fetchWorkedOnItems)({
                cloudId: cloudId,
                amount: amount
            });
            const loadingState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            };
            setState(loadingState);
            const itemResponse = await promise;
            const transformedItems = $44ead70d12d9cb4e$var$transformWorkedOnItems(itemResponse);
            const responseState = {
                workedOn: {
                    items: transformedItems,
                    isFetching: false,
                    promise: null,
                    fetchError: null,
                    hasFetchedOnce: true,
                    hasSuccessOnce: true
                }
            };
            // @ts-expect-error - TS2345 - Argument of type '{ workedOn: { items: { id: string | number; localResourceId: string; title: string; metadata: string; avatarUrl: string; url: string; attributes: { containerName: string | null | undefined; }; type: string; }[]; ... 4 more ...; hasSuccessOnce: boolean; }; }' is not assignable to parameter of type 'Partial<State>'.
            setState(responseState);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            const errorState = {
                workedOn: {
                    ...getState().workedOn,
                    isFetching: false,
                    promise: null,
                    fetchError: fetchError,
                    hasFetchedOnce: true
                }
            };
            setState(errorState);
        }
    };
const $44ead70d12d9cb4e$export$e324594224ef24da = {
    loadRecentAll: (amount)=>async (actions2, props)=>{
            $44ead70d12d9cb4e$var$loadRecentItems(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $0e036566397b8f78$export$f95f1a684a17f189) : undefined,
                (0, $0e036566397b8f78$export$6e58b6b0aa48a271),
                (0, $0e036566397b8f78$export$91a9dba2d38d9a6f),
                (0, $0e036566397b8f78$export$6737b9227f60f39d),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $0e036566397b8f78$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadRecentAllSingleList: (amount)=>async (actions2, props)=>{
            $44ead70d12d9cb4e$var$loadRecentItemsSingleList(amount, [
                props.applicationPermissions.hasSoftwareAccess ? (0, $0e036566397b8f78$export$f95f1a684a17f189) : undefined,
                (0, $0e036566397b8f78$export$6e58b6b0aa48a271),
                (0, $0e036566397b8f78$export$91a9dba2d38d9a6f),
                (0, $0e036566397b8f78$export$6737b9227f60f39d),
                (0, $0e036566397b8f78$export$ebb48b08205007c5),
                props.applicationPermissions.hasServiceDeskAccess ? (0, $0e036566397b8f78$export$20f1031cc9fdf29e) : undefined
            ].filter(Boolean))(actions2);
        },
    loadWorkedOnAllSingleList: $44ead70d12d9cb4e$var$loadWorkedOnItems,
    loadRecentBoards: (amount)=>$44ead70d12d9cb4e$var$loadRecentItems(amount, [
            (0, $0e036566397b8f78$export$f95f1a684a17f189)
        ]),
    loadRecentProjects: (amount)=>$44ead70d12d9cb4e$var$loadRecentItems(amount, [
            (0, $0e036566397b8f78$export$91a9dba2d38d9a6f)
        ]),
    loadRecentDashboards: (amount)=>$44ead70d12d9cb4e$var$loadRecentItems(amount, [
            (0, $0e036566397b8f78$export$6e58b6b0aa48a271)
        ]),
    loadRecentFilters: (amount)=>$44ead70d12d9cb4e$var$loadRecentItems(amount, [
            (0, $0e036566397b8f78$export$6737b9227f60f39d)
        ]),
    loadRecentQueues: (amount)=>$44ead70d12d9cb4e$var$loadRecentItems(amount, [
            (0, $0e036566397b8f78$export$20f1031cc9fdf29e)
        ])
};
const $44ead70d12d9cb4e$var$store = (0, $WBLbN.createStore)({
    name: (0, $708ef86fd90d2755$export$eb2b39783d051b9),
    actions: $44ead70d12d9cb4e$export$e324594224ef24da,
    initialState: $44ead70d12d9cb4e$export$d4c72bab9d6cc13a
});
const $44ead70d12d9cb4e$export$5c0647984dfa7d27 = (0, $WBLbN.createHook)($44ead70d12d9cb4e$var$store, {
    selector: null
});
const $44ead70d12d9cb4e$export$9a54f46f5b7734c = (0, $WBLbN.createHook)($44ead70d12d9cb4e$var$store, {
    selector: (state)=>state.all
});
const $44ead70d12d9cb4e$export$e8278a7bcff1ec98 = (0, $WBLbN.createHook)($44ead70d12d9cb4e$var$store, {
    selector: (state)=>state.workedOn
});
const $44ead70d12d9cb4e$export$3731bd023be4f71 = (0, $WBLbN.createHook)($44ead70d12d9cb4e$var$store, {
    selector: (state)=>state[0, $0e036566397b8f78$export$f95f1a684a17f189]
});
const $44ead70d12d9cb4e$export$81cb5beef51d43ca = (0, $WBLbN.createHook)($44ead70d12d9cb4e$var$store, {
    selector: (state)=>state[0, $0e036566397b8f78$export$6e58b6b0aa48a271]
});
const $44ead70d12d9cb4e$export$f6b9a13c4ec08b45 = (0, $WBLbN.createHook)($44ead70d12d9cb4e$var$store, {
    selector: (state)=>state[0, $0e036566397b8f78$export$91a9dba2d38d9a6f]
});
const $44ead70d12d9cb4e$export$8d2bfb6d3657bae2 = (0, $WBLbN.createHook)($44ead70d12d9cb4e$var$store, {
    selector: (state)=>state[0, $0e036566397b8f78$export$6737b9227f60f39d]
});
const $44ead70d12d9cb4e$export$8756abb0bb90a56e = (0, $WBLbN.createHook)($44ead70d12d9cb4e$var$store, {
    selector: (state)=>state[0, $0e036566397b8f78$export$20f1031cc9fdf29e]
});
const $44ead70d12d9cb4e$export$5de14a1c1400859e = (0, $WBLbN.createContainer)($44ead70d12d9cb4e$var$store);

});
parcelRegister("cmI9f", function(module, exports) {

$parcel$export(module.exports, "fetchRecentItems", () => $76695b03ad22a503$export$20d49db97b653a7b);
$parcel$export(module.exports, "fetchRecentItemsSingleList", () => $76695b03ad22a503$export$a00963dad78984b8);
$parcel$export(module.exports, "fetchWorkedOnItems", () => $76695b03ad22a503$export$f3763cb0ecc90572);

var $53ciZ = parcelRequire("53ciZ");

var $fVqUX = parcelRequire("fVqUX");


var $4X5wI = parcelRequire("4X5wI");

const $76695b03ad22a503$var$PATH_BUCKETED = '/rest/internal/2/productsearch/search';
const $76695b03ad22a503$var$PATH_SINGLE_LIST = '/rest/internal/2/productsearch/singleRecentList';
// dummy handle error
const $76695b03ad22a503$var$handleError = (error)=>{
    throw error;
};
const $76695b03ad22a503$var$toQuery = ({ counts: counts })=>// @ts-expect-error - TS2769 - No overload matches this call.
    Object.keys(counts) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, itemType)=>{
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<ItemType, number>>'.
        result.push(`${itemType}=${counts[itemType]}`);
        return result;
    }, []).join(',');
const $76695b03ad22a503$export$20d49db97b653a7b = async ({ counts: counts })=>{
    const url = `${$76695b03ad22a503$var$PATH_BUCKETED}?${(0, $53ciZ.stringify)({
        counts: $76695b03ad22a503$var$toQuery({
            counts: counts
        }),
        type: Object.keys(counts).join(',')
    })}`;
    try {
        const response = await fetch(url, (0, $fVqUX.default));
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)) return $76695b03ad22a503$var$handleError(new (0, $4X5wI.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $76695b03ad22a503$var$handleError(new Error(status));
        }
        if (status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $76695b03ad22a503$var$handleError(error);
    }
};
const $76695b03ad22a503$export$a00963dad78984b8 = async ({ types: types, limit: limit })=>{
    const url = $76695b03ad22a503$var$PATH_SINGLE_LIST;
    try {
        const response = await fetch(url, {
            ...(0, $fVqUX.default),
            method: 'POST',
            body: JSON.stringify({
                groups: [
                    {
                        types: types,
                        limit: limit
                    }
                ]
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)) return $76695b03ad22a503$var$handleError(new (0, $4X5wI.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $76695b03ad22a503$var$handleError(new Error(status));
        }
        if (status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return null;
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $76695b03ad22a503$var$handleError(error);
    }
};
const $76695b03ad22a503$export$f3763cb0ecc90572 = async ({ cloudId: cloudId, amount: amount })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: 'jira_NavigationActivity',
                query: (0, $1fa52d9602cb9c8d$export$2b91517d6d5b4365),
                variables: {
                    first: amount,
                    cloudID: cloudId
                }
            })
        });
        const { status: status } = response;
        if (!response.ok) {
            if (status === (0, $1c3fbb431a173cc6$export$67d19e9a991baa07)) return $76695b03ad22a503$var$handleError(new (0, $4X5wI.AuthenticationError)(`${status}`));
            // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string | undefined'.
            return $76695b03ad22a503$var$handleError(new Error(status));
        }
        return response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $76695b03ad22a503$var$handleError(error);
    }
};

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;

const $1fa52d9602cb9c8d$export$2b91517d6d5b4365 = `
fragment NavigationActivityItem on ActivitiesItem {
  id
  timestamp
  object {
    id
    name
    localResourceId
    type
    url
    iconUrl
    containers {
      name
      type
    }
    extension {
      ... on ActivitiesJiraIssue {
        issueKey
      }
    }
  }
}

query jira_NavigationActivity($first: Int, $cloudID: ID!) {
  activities {
    myActivities {
      workedOn(
        first: $first,
        filters: [
          {
            type: AND,
            arguments: {
              cloudIds: [$cloudID],
              products: [JIRA, JIRA_BUSINESS, JIRA_SOFTWARE, JIRA_OPS, JIRA_SERVICE_DESK]
            }
          }
        ]
      ) {
        nodes {
          ...NavigationActivityItem
        }
      }
    }
  }
}

`;


const $708ef86fd90d2755$export$eb2b39783d051b9 = 'navigation-recents-store';
const $708ef86fd90d2755$export$22ea57e66775a6b2 = 5;
const $708ef86fd90d2755$export$8666f31c8873bff = 10;
const $708ef86fd90d2755$export$5f1b6c5e9d257e5e = 20;


parcelRegister("4mk0R", function(module, exports) {

$parcel$export(module.exports, "NavigationSuccessTracker", () => $960fdef166036cd1$export$9851760ed7c3e83c);

var $eUqFw = parcelRequire("eUqFw");

var $kwMhr = parcelRequire("kwMhr");

var $fDZ6r = parcelRequire("fDZ6r");

var $10fdS = parcelRequire("10fdS");

var $5kDtB = parcelRequire("5kDtB");
const $960fdef166036cd1$var$EmptyFragment = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
const $960fdef166036cd1$export$9851760ed7c3e83c = ({ children: children })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const ViewExperienceSuccessTrackerComponent = route.isRedirect === true ? $960fdef166036cd1$var$EmptyFragment : (0, $kwMhr.ExperienceSuccessTracker);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewExperienceSuccessTrackerComponent, {
        location: "atlassian-navigation-main",
        parentProviders: null,
        failureEventAttributes: null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MAIN)
    }));
};

});

parcelRegister("a5xQG", function(module, exports) {

$parcel$export(module.exports, "Addons", () => $80a9e3557a41e00d$export$a97e6a0578b4c83);

var $eUqFw = parcelRequire("eUqFw");

var $cTgSO = parcelRequire("cTgSO");

var $5VB9J = parcelRequire("5VB9J");

var $8fxTv = parcelRequire("8fxTv");

var $bDhRl = parcelRequire("bDhRl");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $3UtNf = parcelRequire("3UtNf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7vTKl = parcelRequire("7vTKl");

var $8WuJm = parcelRequire("8WuJm");

var $bNe1g = parcelRequire("bNe1g");

var $j0fl7 = parcelRequire("j0fl7");

var $gNXC6 = parcelRequire("gNXC6");

var $gd0Sp = parcelRequire("gd0Sp");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $5ZWbT = parcelRequire("5ZWbT");

var $bAd0L = parcelRequire("bAd0L");

var $ry2Jr = parcelRequire("ry2Jr");

var $awmrT = parcelRequire("awmrT");

var $2xkfr = parcelRequire("2xkfr");
const $80a9e3557a41e00d$var$AddonsView = ()=>{
    const { key: projectIdOrKey } = (0, $bNe1g.useProjectContext)();
    const [, { load: loadItem, setContext: setContext }] = (0, $5VB9J.useAddon)();
    const [, { load: loadForgeItem }] = (0, $3UtNf.useForgeGlobalItems)();
    (0, $eUqFw.useEffect)(()=>{
        setContext({
            projectIdOrKey: projectIdOrKey
        });
    }, [
        projectIdOrKey,
        setContext
    ]);
    const [{ hasSuccessOnce: hasSuccessOnceUserSegmentation }, { loadPersonalisedAppsUserSegmentation: loadPersonalisedAppsUserSegmentation }] = (0, $ry2Jr.usePersonalisedAppsTeamType)();
    const { activationId: activationId, cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { formatMessage: formatMessage, locale: locale } = (0, $5JgJ2.default)();
    const onStart = (0, $bDhRl.useExperienceStart)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $5kDtB.NAVIGATION_ITEM_ID).ADDONS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $eUqFw.useCallback)(()=>{
        onStart();
        loadItem();
        if ((0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x')) loadForgeItem({
            cloudId: cloudId,
            activationId: activationId,
            locale: locale
        });
        else loadForgeItem({
            cloudId: cloudId,
            locale: locale
        });
        !hasSuccessOnceUserSegmentation && loadPersonalisedAppsUserSegmentation();
        (0, $8fxTv.NAVIGATION_TOP_DROPDOWN_MARKS).ADDONS.start();
    }, [
        onStart,
        loadItem,
        hasSuccessOnceUserSegmentation,
        loadPersonalisedAppsUserSegmentation,
        loadForgeItem,
        cloudId,
        activationId,
        locale
    ]);
    const attributes = (0, $eUqFw.useMemo)(()=>({
            isEmbeddedMarketplaceEnabledForEndUsers: (0, $1ybV0.ff)('enduser-emcee-discover'),
            isEmbeddedMarketplaceSpaEnabled: (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable')
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bAd0L.Popup), {
        menuId: (0, $7vTKl.MENU_ID).ADDONS,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).ADDONS,
        Menu: (0, $awmrT.AsyncMenu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $2xkfr.default).apps)
    }, formatMessage((0, $2xkfr.default).apps)));
};
const $80a9e3557a41e00d$export$a97e6a0578b4c83 = ()=>{
    const { isVisible: isVisible } = (0, $cTgSO.useOverflowStatus)();
    const [{ hasOpened: shouldShowNudge }] = (0, $gNXC6.useHasOpened)();
    if ((0, $eI5EY.fg)('ttvc_global_navigation_improvement')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).ADDONS
    }, !false && shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j0fl7.NavigationAppsNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZWbT.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80a9e3557a41e00d$var$AddonsView, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80a9e3557a41e00d$var$AddonsView, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).ADDONS
    }, !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j0fl7.NavigationAppsNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZWbT.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80a9e3557a41e00d$var$AddonsView, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80a9e3557a41e00d$var$AddonsView, null));
};

});
parcelRegister("5VB9J", function(module, exports) {

$parcel$export(module.exports, "useAddon", () => $83ffc29db9b298f5$export$550c6d89b9b85724);

var $fgUG9 = parcelRequire("fgUG9");

var $WBLbN = parcelRequire("WBLbN");
const $83ffc29db9b298f5$var$handleFetch = ()=>async ({ setState: setState, getState: getState })=>{
        const { fetchAddons: fetchAddons, fetchAddonContext: fetchAddonContext, isFetching: isFetching } = getState();
        if (!isFetching) try {
            const promise = fetchAddons(undefined, fetchAddonContext);
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const items = await promise;
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $83ffc29db9b298f5$var$actions = {
    load: ()=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($83ffc29db9b298f5$var$handleFetch());
            await promise;
        },
    setFavourite: (item, isAddon)=>async ({ setState: setState, getState: getState })=>{
            const { items: items, addToFavorite: addToFavorite, removeFromFavorite: removeFromFavorite } = getState();
            const newItemData = {
                ...item,
                favourite: true
            };
            if (isAddon) {
                setState({
                    items: [
                        newItemData,
                        ...items
                    ]
                });
                await addToFavorite(newItemData);
            } else {
                setState({
                    items: items.filter((theItem)=>theItem.id !== item.id)
                });
                await removeFromFavorite(item);
            }
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                fetchAddonContext: context
            });
        }
};
const $83ffc29db9b298f5$export$f350d6bef9972cd3 = (defaults)=>{
    const initialState = {
        fetchAddons: defaults.fetchAddons,
        fetchAddonContext: {},
        addToFavorite: defaults.addToFavorite,
        removeFromFavorite: defaults.removeFromFavorite,
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: [],
        fetchError: null,
        promise: null,
        isFetching: false
    };
    const Store = (0, $WBLbN.createStore)({
        name: 'addon-store',
        actions: $83ffc29db9b298f5$var$actions,
        initialState: initialState
    });
    const AddonContainer = (0, $WBLbN.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState({
                    fetchAddons: props.fetchAddons,
                    addToFavorite: props.addToFavorite,
                    removeFromFavorite: props.removeFromFavorite
                });
            }
    });
    const AddonTestContainer = (0, $WBLbN.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: items, hasFetchedOnce: hasFetchedOnce, fetchError: fetchError, promise: promise, hasSuccessOnce: hasSuccessOnce, isFetching: isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            hasSuccessOnce: hasSuccessOnce,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const AddonSubscriber = (0, $WBLbN.createSubscriber)(Store, {
        displayName: 'AddonSubscriber',
        selector: selector
    }); // Bug with createSubscriber type means that React children end up "never"
    // Deprecated: to be removed
    const useAddonActions = (0, $WBLbN.createHook)(Store, {
        selector: selector
    });
    const useAddon = (0, $WBLbN.createHook)(Store, {
        selector: selector
    });
    return {
        AddonSubscriber: AddonSubscriber,
        useAddonActions: useAddonActions,
        useAddon: useAddon,
        AddonTestContainer: AddonTestContainer,
        AddonContainer: AddonContainer
    };
};
const $83ffc29db9b298f5$var$defaultAddToFavorite = ()=>// TODO: to be implemented when api is ready
    new Promise(()=>null);
const $83ffc29db9b298f5$var$defaultRemoveFromFavorite = ()=>// TODO: to be implemented when api is ready
    new Promise(()=>null);
const { useAddon: $83ffc29db9b298f5$export$550c6d89b9b85724 } = $83ffc29db9b298f5$export$f350d6bef9972cd3({
    fetchAddons: (0, $fgUG9.fetchAddonItems),
    addToFavorite: $83ffc29db9b298f5$var$defaultAddToFavorite,
    removeFromFavorite: $83ffc29db9b298f5$var$defaultRemoveFromFavorite
});

});
parcelRegister("fgUG9", function(module, exports) {

$parcel$export(module.exports, "fetchAddonItems", () => $57246b51858cf67e$export$fe5ef9b24322d3c1);

var $fVqUX = parcelRequire("fVqUX");

var $7byHA = parcelRequire("7byHA");

var $6vrw7 = parcelRequire("6vrw7");

var $4X5wI = parcelRequire("4X5wI");

const $57246b51858cf67e$var$handleError = (error)=>{
    // Temp
    throw error;
};
const $57246b51858cf67e$export$fe5ef9b24322d3c1 = async (baseUrl = (0, $6vrw7.toBaseUrl)(''), context)=>{
    const params = $57246b51858cf67e$var$getContextParams(context);
    const url = `${baseUrl}/rest/navigation/3/global/addons${params ? `?${params}` : ''}`;
    try {
        const response = await fetch(url, (0, $fVqUX.default));
        if (!response.ok) {
            const errorCode = response.status;
            if (errorCode === 401) return $57246b51858cf67e$var$handleError(new (0, $4X5wI.AuthenticationError)(`${errorCode}`));
            return $57246b51858cf67e$var$handleError(new (0, $7byHA.default)(errorCode, response.statusText));
        }
        const addonsItems = await response.json();
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        return addonsItems.map((item)=>({
                id: item.id,
                title: item.name,
                avatarUrl: item.iconUrl,
                type: (0, $0e036566397b8f78$export$5e2cc09b58170ca2),
                url: item.url,
                className: item.styleClass
            }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // network issue
        return $57246b51858cf67e$var$handleError(error);
    }
};
function $57246b51858cf67e$var$getContextParams(context) {
    const filteredParams = Object.fromEntries(Object.entries(context || {}).filter(([, value])=>!!value));
    return new URLSearchParams(filteredParams).toString();
}

});


parcelRegister("3UtNf", function(module, exports) {

$parcel$export(module.exports, "useForgeGlobalItems", () => $fbabbc1df95548ef$export$fa6081acdcc112a0);

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $70ON1 = parcelRequire("70ON1");

var $fTsDx = parcelRequire("fTsDx");

var $fSEqj = parcelRequire("fSEqj");

var $WBLbN = parcelRequire("WBLbN");
const $fbabbc1df95548ef$var$getItemHref = (extension)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $fbabbc1df95548ef$var$transformTitle = (title, environmentType, environmentKey)=>{
    if (environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) && environmentKey !== (0, $2Rqjr.DEFAULT_ENVIRONMENT_KEY)) return `${title} - ${environmentKey}`;
    return title;
};
const $fbabbc1df95548ef$var$transformResponse = (data)=>data ? data.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, {})).map((extension)=>({
            id: extension.id,
            title: $fbabbc1df95548ef$var$transformTitle(extension.properties.title, extension.environmentType, extension.environmentKey),
            avatarUrl: extension.properties.icon,
            url: $fbabbc1df95548ef$var$getItemHref(extension),
            environmentType: extension.environmentType,
            module: (0, $2Rqjr.GLOBAL_PAGE_MODULE)
        })) : null;
const $fbabbc1df95548ef$var$handleFetch = ({ cloudId: cloudId, activationId: activationId, locale: locale })=>// @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    async ({ setState: setState, getState: getState })=>{
        const { fetchForgeModule: fetchForgeModule, isFetching: isFetching } = getState();
        if (!isFetching) try {
            const promise = fetchForgeModule({
                cloudId: cloudId,
                moduleName: (0, $2Rqjr.GLOBAL_PAGE_MODULE),
                dataClassification: null,
                shouldReturnANExtensions: false,
                contextIds: (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x') ? [
                    `ari:cloud:jira:${cloudId}:workspace/${activationId}`
                ] : undefined,
                locale: locale
            });
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const data = await promise;
            const globalPageData = data?.extensions || data;
            const items = $fbabbc1df95548ef$var$transformResponse(globalPageData);
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $fbabbc1df95548ef$var$actions = {
    load: ({ cloudId: cloudId, activationId: activationId = '', locale: locale })=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($fbabbc1df95548ef$var$handleFetch({
                cloudId: cloudId,
                activationId: activationId,
                locale: locale
            }));
            await promise;
        }
};
const $fbabbc1df95548ef$export$a87c2a3d589b7efd = (defaults)=>{
    const initialState = {
        fetchForgeModule: defaults.fetchForgeModule,
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: [],
        promise: null,
        fetchError: null,
        isFetching: false
    };
    const Store = (0, $WBLbN.createStore)({
        name: 'forge-global-items-store',
        actions: // @ts-expect-error - TS2322 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' is not assignable to type 'Record<string, ActionThunk<{ fetchForgeModule: (arg1: { cloudId: string; moduleName: FullPageModule; }) => Promise<FullPage[] | null>; hasFetchedOnce: boolean; ... 4 more ...; isFetching: boolean; }, { ...; }>>'.
        $fbabbc1df95548ef$var$actions,
        initialState: initialState
    });
    // @ts-expect-error - TS2344 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' does not satisfy the constraint 'Record<string, ActionThunk<GenericState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>>'.
    const ForgeGlobalItemsTestContainer = (0, $WBLbN.createContainer)(Store, {
        onInit: ()=>(api, props)=>{
                api.setState(props);
            }
    });
    const selector = ({ items: // @ts-expect-error - TS7031 - Binding element 'items' implicitly has an 'any' type.
    items, hasFetchedOnce: // @ts-expect-error - TS7031 - Binding element 'hasFetchedOnce' implicitly has an 'any' type.
    hasFetchedOnce, fetchError: // @ts-expect-error - TS7031 - Binding element 'fetchError' implicitly has an 'any' type.
    fetchError, promise: // @ts-expect-error - TS7031 - Binding element 'promise' implicitly has an 'any' type.
    promise, hasSuccessOnce: // @ts-expect-error - TS7031 - Binding element 'hasSuccessOnce' implicitly has an 'any' type.
    hasSuccessOnce, isFetching: // @ts-expect-error - TS7031 - Binding element 'isFetching' implicitly has an 'any' type.
    isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            fetchError: fetchError,
            promise: promise,
            hasSuccessOnce: hasSuccessOnce,
            isFetching: isFetching
        });
    // @ts-expect-error - TS2344 - Type '{ readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<void>; }' does not satisfy the constraint 'Record<string, ActionThunk<GenericState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>>'.
    const ForgeGlobalItemsSubscriber = (0, $WBLbN.createSubscriber)(Store, {
        displayName: 'ForgeGlobalItemsSubscriber',
        selector: selector
    });
    const useForgeGlobalItems = (0, $WBLbN.createHook)(Store, {
        selector: selector
    });
    // @ts-expect-error - TS2322 - Type 'HookFunction<{ items: any; hasFetchedOnce: any; fetchError: any; promise: any; hasSuccessOnce: any; isFetching: any; }, BoundActions<{ fetchForgeModule: (arg1: { cloudId: string; moduleName: FullPageModule; }) => Promise<...>; ... 5 more ...; isFetching: boolean; }, Record<...>>, void>' is not assignable to type '() => HookReturnValue<GenericPublicState<I>, { readonly load: (cloudId: string) => ({ dispatch }: StoreActionApi<GenericState<ForgeGlobalMenuItem>>) => Promise<...>; }>'.
    return {
        ForgeGlobalItemsSubscriber: ForgeGlobalItemsSubscriber,
        useForgeGlobalItems: useForgeGlobalItems,
        ForgeGlobalItemsTestContainer: ForgeGlobalItemsTestContainer
    };
};
const { useForgeGlobalItems: $fbabbc1df95548ef$export$fa6081acdcc112a0 } = $fbabbc1df95548ef$export$a87c2a3d589b7efd({
    fetchForgeModule: (0, $fSEqj.fetchForgeModule)
});

});

parcelRegister("j0fl7", function(module, exports) {

$parcel$export(module.exports, "NavigationAppsNavItemWrapperNudgeAsync", () => $c8678541cc59034d$export$c143067f544307f);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c8678541cc59034d$var$NavigationAppsNavItemLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7BLUL")).then((exportedModule)=>exportedModule.NavigationAppsNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-apps/index.tsx"
});
const $c8678541cc59034d$export$c143067f544307f = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $8379f5d78bf6fb5a$export$dd63d0099d95ba4f),
        fallback: children,
        attributes: {
            nudgeId: (0, $8379f5d78bf6fb5a$export$dd63d0099d95ba4f)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "navigation-apps-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c8678541cc59034d$var$NavigationAppsNavItemLazy, {
        nudgeId: (0, $8379f5d78bf6fb5a$export$dd63d0099d95ba4f),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("ewdMq", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $adec59c10c54d3d1$export$3915a8814b99f0b);

var $eUqFw = parcelRequire("eUqFw");

var $kMhLP = parcelRequire("kMhLP");

var $7dRgX = parcelRequire("7dRgX");
const $adec59c10c54d3d1$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kMhLP.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $7dRgX.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("kMhLP", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $5bd50febcd8eec1e$export$9171acf2e93b7d4d);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $7Aqzu = parcelRequire("7Aqzu");
const $5bd50febcd8eec1e$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $7Aqzu.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("7Aqzu", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $eee5ff621608f776$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $eee5ff621608f776$export$807be5f3f1ea996);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");
const $eee5ff621608f776$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $7rh0R.isLoaderError)(error)
    });
const $eee5ff621608f776$export$807be5f3f1ea996 = (attributes = {})=>(0, $eUqFw.useCallback)((error)=>({
            ...attributes,
            ...$eee5ff621608f776$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});



parcelRegister("7BLUL", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cSlOn").then(()=>parcelRequire('cjS4E'));

});


parcelRegister("gNXC6", function(module, exports) {

$parcel$export(module.exports, "useHasOpened", () => $0e43dfae21db11a2$export$cbaabcded53b5c1f);

var $WBLbN = parcelRequire("WBLbN");

var $4O87B = parcelRequire("4O87B");
const $0e43dfae21db11a2$var$actions = {
    setHasOpened: $4O87B.setHasOpened
};
const $0e43dfae21db11a2$var$initialState = {
    hasOpened: false
};
const $0e43dfae21db11a2$var$Store = (0, $WBLbN.createStore)({
    initialState: $0e43dfae21db11a2$var$initialState,
    actions: $0e43dfae21db11a2$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $0e43dfae21db11a2$export$cbaabcded53b5c1f = (0, $WBLbN.createHook)($0e43dfae21db11a2$var$Store);

});
parcelRegister("4O87B", function(module, exports) {

$parcel$export(module.exports, "setHasOpened", () => $9011213d2e2509c3$export$c4743c64a7c42294);
const $9011213d2e2509c3$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $9011213d2e2509c3$export$2e2bcd8739ae039 = $9011213d2e2509c3$export$c4743c64a7c42294;

});


parcelRegister("grCEQ", function(module, exports) {

$parcel$export(module.exports, "TopLevelErrorBoundary", () => $89c52a03de15dd36$export$b70f1d8bd509b358);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $5kDtB = parcelRequire("5kDtB");
const $89c52a03de15dd36$export$b70f1d8bd509b358 = ({ id: id, children: children })=>{
    const EVENT_DATA = (0, $eUqFw.useMemo)(()=>({
            id: id
        }), [
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: `${(0, $5kDtB.TOP_LEVEL_ERROR_BOUNDARY_ID)}.${id}`,
        packageName: (0, $5kDtB.PACKAGE_NAME),
        extraEventData: EVENT_DATA,
        fallback: "unmount"
    }, children);
};

});

parcelRegister("5ZWbT", function(module, exports) {

$parcel$export(module.exports, "FullHeightTextColorWrapper", () => $885783dff53e23bf$export$19a17a164d8e4de3);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $885783dff53e23bf$export$7ac7d6a768c2e9b2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _16jlkb7n _19pnkb7n _13aikb7n _1gqrf1ug",
            __cmplp.className
        ])
    });
});
const $885783dff53e23bf$export$19a17a164d8e4de3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _syaz1fxt _16jlkb7n _19pnkb7n _13aikb7n _1gqrf1ug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bAd0L", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $f5ffc66ec4f04904$export$129a32eedafa97c5);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $cTgSO = parcelRequire("cTgSO");

var $3MV1G = parcelRequire("3MV1G");

var $3BTZc = parcelRequire("3BTZc");

var $1YbJP = parcelRequire("1YbJP");

var $iRTpS = parcelRequire("iRTpS");

var $olGf9 = parcelRequire("olGf9");

var $dxAeX = parcelRequire("dxAeX");
const $f5ffc66ec4f04904$var$OFFSET = [
    12,
    -11
];
const $f5ffc66ec4f04904$export$129a32eedafa97c5 = ({ Menu: Menu, MenuTrigger: MenuTrigger = (0, $olGf9.MenuTrigger), children: children, menuId: menuId, navigationItemId: navigationItemId, onBeforeMenuOpen: onBeforeMenuOpen = ()=>undefined, label: label })=>{
    const [isMenuOpen, { off: closeMenu }] = (0, $3BTZc.useTopMenus)(menuId);
    const [isEventFromSpotlightTour] = (0, $iRTpS.useFromSpotlightTour)('spotlight');
    const { isVisible: isVisible } = (0, $cTgSO.useOverflowStatus)();
    const Trigger = (0, $eUqFw.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuTrigger, {
            ...props,
            onBeforeMenuOpen: onBeforeMenuOpen,
            menuId: menuId,
            navigationItemId: navigationItemId,
            "aria-haspopup": false
        }, children), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        children,
        menuId,
        navigationItemId,
        onBeforeMenuOpen
    ]);
    const testId = (0, $1YbJP.testIdGenerate)('primary-actions', menuId, 'menu-popup');
    const Content = (0, $eUqFw.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            onClick: (0, $dxAeX.stopPropagation),
            "data-testid": testId,
            role: "presentation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Menu, {
            ...props,
            testIdPrefix: testId
        }, children)), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        children,
        testId
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        shouldRenderToParent: true,
        isOpen: isMenuOpen,
        onClose: isEventFromSpotlightTour ? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) : closeMenu,
        content: Content,
        offset: isVisible ? undefined : $f5ffc66ec4f04904$var$OFFSET,
        placement: isVisible ? 'bottom-start' : 'right-start',
        trigger: Trigger,
        label: label,
        role: "menu"
    });
};

});
parcelRegister("3BTZc", function(module, exports) {

$parcel$export(module.exports, "useTopMenus", () => $ceb5039b7e3eba7f$export$6591d6b6c4546423);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $7qgRx = parcelRequire("7qgRx");
const { SwitchContainer: $ceb5039b7e3eba7f$var$SwitchContainer, useSwitch: $ceb5039b7e3eba7f$var$useSwitch } = (0, $7qgRx.createSwitchController)('atlassian-navigation-top-menus');
const $ceb5039b7e3eba7f$export$45ccf7b2695bac19 = $ceb5039b7e3eba7f$var$SwitchContainer;
const $ceb5039b7e3eba7f$var$useTopMenusBase = $ceb5039b7e3eba7f$var$useSwitch;
const $ceb5039b7e3eba7f$export$6591d6b6c4546423 = (props)=>{
    const switcher = $ceb5039b7e3eba7f$var$useTopMenusBase(props);
    const [{ isOpen: isCommandPaletteOpen }] = (0, $gCtL7.useCommandPaletteIsOpen)();
    const [isSwitchOpen, { off: off }] = switcher;
    (0, $eUqFw.useEffect)(()=>{
        if (isSwitchOpen && isCommandPaletteOpen) off();
    }, [
        isCommandPaletteOpen,
        isSwitchOpen,
        off
    ]);
    return switcher;
};

});
parcelRegister("gCtL7", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $9139bfe8dcd2ea64$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $9139bfe8dcd2ea64$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $9139bfe8dcd2ea64$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $9139bfe8dcd2ea64$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $9139bfe8dcd2ea64$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $9139bfe8dcd2ea64$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $9139bfe8dcd2ea64$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $9139bfe8dcd2ea64$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $9139bfe8dcd2ea64$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $9139bfe8dcd2ea64$export$bbc05723eb144e03);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $8FbYY = parcelRequire("8FbYY");

var $li0m0 = parcelRequire("li0m0");
const $9139bfe8dcd2ea64$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $9139bfe8dcd2ea64$var$store = (0, $WBLbN.createStore)({
    initialState: $9139bfe8dcd2ea64$var$initialState,
    actions: $li0m0.actions,
    name: 'commandPalette'
});
const $9139bfe8dcd2ea64$export$6b58f9610017fbb7 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36 = (0, $WBLbN.createActionsHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $9139bfe8dcd2ea64$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $9139bfe8dcd2ea64$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $8FbYY.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $8FbYY.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $8FbYY.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $9139bfe8dcd2ea64$export$1f90c8f89f98110e = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$56f06313122d0aac
});
const $9139bfe8dcd2ea64$export$cc979be9b69236df = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$a18633b655403b12 = (0, $WBLbN.createStateHook)($9139bfe8dcd2ea64$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $9139bfe8dcd2ea64$export$af8fd8cd4b048315 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $9139bfe8dcd2ea64$export$4372697329bd9cbe = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $9139bfe8dcd2ea64$export$7422170a403e909 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $9139bfe8dcd2ea64$export$282aa48e4a3afada = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$96819dfb22ad05d3 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $9139bfe8dcd2ea64$export$a40e8ae3e53feab0 = (0, $WBLbN.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $8FbYY.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $9139bfe8dcd2ea64$export$f893891deedab3c6 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$a40e8ae3e53feab0
});
const $9139bfe8dcd2ea64$export$bbc05723eb144e03 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("8FbYY", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $faf99007a5829b26$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $faf99007a5829b26$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $faf99007a5829b26$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $faf99007a5829b26$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $faf99007a5829b26$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $faf99007a5829b26$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $faf99007a5829b26$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $faf99007a5829b26$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $faf99007a5829b26$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $faf99007a5829b26$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $faf99007a5829b26$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $faf99007a5829b26$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $faf99007a5829b26$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $faf99007a5829b26$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $faf99007a5829b26$export$c3d20e8c1e93a572);

var $eUqFw = parcelRequire("eUqFw");

var $3IRl5 = parcelRequire("3IRl5");

var $igOBb = parcelRequire("igOBb");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");
const $faf99007a5829b26$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $faf99007a5829b26$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $faf99007a5829b26$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $faf99007a5829b26$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $faf99007a5829b26$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $faf99007a5829b26$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $faf99007a5829b26$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $faf99007a5829b26$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $faf99007a5829b26$export$389b0273703d5c48(sections)
    };
};
const $faf99007a5829b26$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $faf99007a5829b26$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$faf99007a5829b26$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$faf99007a5829b26$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$faf99007a5829b26$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $faf99007a5829b26$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $faf99007a5829b26$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $faf99007a5829b26$export$daa5beabdf8d9fc3 = (event)=>(0, $igOBb.isMacOs)() ? event.metaKey : event.ctrlKey;
const $faf99007a5829b26$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $faf99007a5829b26$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $faf99007a5829b26$export$fa1c95a5ffa92036 = (str)=>(0, $3IRl5.createHash)().update(str).digest('hex');
const $faf99007a5829b26$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $faf99007a5829b26$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $faf99007a5829b26$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $faf99007a5829b26$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("igOBb", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $a127768fd887ea5b$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $a127768fd887ea5b$export$fe66dae91c68619b);
const $a127768fd887ea5b$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $a127768fd887ea5b$export$fe66dae91c68619b = ()=>$a127768fd887ea5b$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("ftpwV", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $48b165edb54974f4$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $48b165edb54974f4$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $48b165edb54974f4$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $48b165edb54974f4$export$894e19fc96687503);
// EVENT TYPES
const $48b165edb54974f4$export$a1562d08625f5d7e = 'UI';
const $48b165edb54974f4$export$947dac6c72b26f81 = 'TRACK';
const $48b165edb54974f4$export$f1d537d508d2945a = 'SCREEN';
const $48b165edb54974f4$export$12346a674644c156 = 'OPERATIONAL';
var $48b165edb54974f4$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($48b165edb54974f4$export$1ee9d153576afd13 || ($48b165edb54974f4$export$1ee9d153576afd13 = {}));
const $48b165edb54974f4$export$894e19fc96687503 = 250;

});

parcelRegister("6jiFZ", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $5c36304d2fa4b1a2$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $5c36304d2fa4b1a2$export$904b2a0e38a1bef3);
var $5c36304d2fa4b1a2$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($5c36304d2fa4b1a2$export$f041b1b117ab382f || ($5c36304d2fa4b1a2$export$f041b1b117ab382f = {}));
const $5c36304d2fa4b1a2$export$3e448fd53031e13c = Object.values($5c36304d2fa4b1a2$export$f041b1b117ab382f);
const $5c36304d2fa4b1a2$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("li0m0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $476b965ceb7c28b6$export$e324594224ef24da);

var $MdoH4 = parcelRequire("MdoH4");

var $hompL = parcelRequire("hompL");

var $igOBb = parcelRequire("igOBb");

var $guiFP = parcelRequire("guiFP");

var $8PVSz = parcelRequire("8PVSz");

var $75e8i = parcelRequire("75e8i");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $2fkzb = parcelRequire("2fkzb");
const $476b965ceb7c28b6$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $476b965ceb7c28b6$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $476b965ceb7c28b6$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$476b965ceb7c28b6$var$rootCommands
        });
    };
const $476b965ceb7c28b6$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4() : '',
            ...!isOpen ? $476b965ceb7c28b6$var$rootCommands : {}
        });
    };
const $476b965ceb7c28b6$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $476b965ceb7c28b6$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $476b965ceb7c28b6$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $476b965ceb7c28b6$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $476b965ceb7c28b6$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $476b965ceb7c28b6$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $476b965ceb7c28b6$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $476b965ceb7c28b6$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $8FbYY.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $476b965ceb7c28b6$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $75e8i.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $8PVSz.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $476b965ceb7c28b6$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $gklnd.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $8FbYY.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $8FbYY.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $8FbYY.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $6jiFZ.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $75e8i.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $2fkzb.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $75e8i.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $8PVSz.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $476b965ceb7c28b6$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $476b965ceb7c28b6$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $476b965ceb7c28b6$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $476b965ceb7c28b6$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $476b965ceb7c28b6$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $476b965ceb7c28b6$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $476b965ceb7c28b6$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $476b965ceb7c28b6$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $476b965ceb7c28b6$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $476b965ceb7c28b6$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $476b965ceb7c28b6$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $476b965ceb7c28b6$export$e324594224ef24da = {
    open: $476b965ceb7c28b6$var$open,
    toggle: $476b965ceb7c28b6$var$toggle,
    close: $476b965ceb7c28b6$var$close,
    addCommands: $476b965ceb7c28b6$var$addCommands,
    removeCommands: $476b965ceb7c28b6$var$removeCommands,
    handleSearch: $476b965ceb7c28b6$var$handleSearch,
    forceFocusSearch: $476b965ceb7c28b6$var$forceFocusSearch,
    setActiveIndex: $476b965ceb7c28b6$var$setActiveIndex,
    executeCommand: $476b965ceb7c28b6$var$executeCommand,
    goBackLevel: $476b965ceb7c28b6$var$goBackLevel,
    setChildCommands: $476b965ceb7c28b6$var$setChildCommands,
    setLoadingList: $476b965ceb7c28b6$var$setLoadingList,
    setFocusInput: $476b965ceb7c28b6$var$setFocusInput,
    registerSections: $476b965ceb7c28b6$var$registerSections,
    unregisterSections: $476b965ceb7c28b6$var$unregisterSections,
    markAsLoaded: $476b965ceb7c28b6$var$markAsLoaded,
    getAnalyticsAttributes: $476b965ceb7c28b6$var$getAnalyticsAttributes,
    setIsDisabled: $476b965ceb7c28b6$var$setIsDisabled,
    setRegistry: $476b965ceb7c28b6$var$setRegistry,
    updateActiveRegistry: $476b965ceb7c28b6$var$updateActiveRegistry,
    removeCommandsById: $476b965ceb7c28b6$var$removeCommandsById,
    removeFromActiveRegistry: $476b965ceb7c28b6$var$removeFromActiveRegistry,
    performDialogCloseCommand: $476b965ceb7c28b6$var$performDialogCloseCommand,
    setAnalytics: $476b965ceb7c28b6$var$setAnalytics,
    setFallbackOverride: $476b965ceb7c28b6$var$setFallbackOverride,
    setHasPopupOverlay: $476b965ceb7c28b6$var$setHasPopupOverlay,
    forceSearchValue: $476b965ceb7c28b6$var$forceSearchValue,
    resetShouldForceSearchValue: $476b965ceb7c28b6$var$resetShouldForceSearchValue
};

});
parcelRegister("gklnd", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b93b5138b1f374a6$export$639b7f41b0b47a01);

var $6jiFZ = parcelRequire("6jiFZ");
const $b93b5138b1f374a6$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("2fkzb", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $20c016b992336e05$export$d75616d77443fe4e);

var $6jiFZ = parcelRequire("6jiFZ");
const $20c016b992336e05$export$d75616d77443fe4e = (action)=>action?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});



parcelRegister("7qgRx", function(module, exports) {

$parcel$export(module.exports, "createSwitchController", () => $34198a6b757ea1c3$export$1856548326159ec8);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");
const $34198a6b757ea1c3$export$1856548326159ec8 = (name, activeByDefault)=>{
    const actions = {
        on: (active)=>({ setState: setState })=>setState({
                    active: active
                }),
        off: (active)=>({ setState: setState, getState: getState })=>{
                if (getState().active === active || active === undefined) setState({
                    active: undefined
                });
            },
        toggle: (active)=>({ getState: getState, dispatch: dispatch })=>{
                if (getState().active === active) dispatch(actions.off(active));
                else dispatch(actions.on(active));
            }
    };
    const initialState = {
        active: activeByDefault
    };
    const store = (0, $WBLbN.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    const SwitchContainer = (0, $WBLbN.createContainer)(store);
    const selector = (state, key)=>state.active === key;
    const useSwitchInternal = (0, $WBLbN.createHook)(store, {
        selector: selector
    });
    const useSwitch = (active)=>{
        const [isActive, { on: onSwitch, off: offSwitch, toggle: toggleSwitch }] = useSwitchInternal(active);
        const on = (0, $eUqFw.useCallback)(()=>onSwitch(active), [
            onSwitch,
            active
        ]);
        const off = (0, $eUqFw.useCallback)(()=>offSwitch(active), [
            active,
            offSwitch
        ]);
        const toggle = (0, $eUqFw.useCallback)(()=>toggleSwitch(active), [
            toggleSwitch,
            active
        ]);
        return [
            isActive,
            {
                on: on,
                off: off,
                toggle: toggle
            }
        ];
    };
    return {
        SwitchContainer: SwitchContainer,
        useSwitch: useSwitch
    };
};

});


parcelRegister("iRTpS", function(module, exports) {

$parcel$export(module.exports, "useFromSpotlightTour", () => $d275345f7e0a8daa$export$dc0191efbad6291c);

var $7qgRx = parcelRequire("7qgRx");
const { useSwitch: $d275345f7e0a8daa$var$useSwitch } = (0, $7qgRx.createSwitchController)('spotlight');
const $d275345f7e0a8daa$export$dc0191efbad6291c = $d275345f7e0a8daa$var$useSwitch;

});

parcelRegister("olGf9", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $e2673dd6b34af72d$export$27d2ad3c5815583e);
$parcel$export(module.exports, "ChevronRightIcon", () => $e2673dd6b34af72d$export$b837bd7eac09a33e);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $cTgSO = parcelRequire("cTgSO");

var $dtaN9 = parcelRequire("dtaN9");

var $bULPy = parcelRequire("bULPy");

var $3BTZc = parcelRequire("3BTZc");

var $1YbJP = parcelRequire("1YbJP");

var $lB25E = parcelRequire("lB25E");

var $69xWj = parcelRequire("69xWj");

var $gvn5f = parcelRequire("gvn5f");

var $8EB5v = parcelRequire("8EB5v");

var $k8KeQ = parcelRequire("k8KeQ");

var $foGs0 = parcelRequire("foGs0");

var $btNZp = parcelRequire("btNZp");
const $e2673dd6b34af72d$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ href: href, menuId: menuId, navigationItemId: navigationItemId, onBeforeMenuOpen: onBeforeMenuOpen = ()=>undefined, params: params, query: query, replace: replace, to: to, type: type, analyticsAttributes: analyticsAttributes, ...rest }, ref)=>{
    const [isMenuOpen, { off: closeMenu, toggle: toggleMenu }] = (0, $3BTZc.useTopMenus)(menuId);
    const { isVisible: isVisible } = (0, $cTgSO.useOverflowStatus)();
    const isHighlighted = (0, $69xWj.useMenuHighlighted)(menuId);
    const triggerAnalytics = (0, $gvn5f.useNavigationItemAnalytics)({
        navigationItemId: navigationItemId
    });
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (!isMenuOpen) onBeforeMenuOpen();
        toggleMenu();
        triggerAnalytics(analyticsAttributes);
    }, [
        analyticsAttributes,
        isMenuOpen,
        onBeforeMenuOpen,
        toggleMenu,
        triggerAnalytics
    ]);
    // close menu on unmount
    (0, $eUqFw.useEffect)(()=>closeMenu, [
        closeMenu
    ]);
    const testId = (0, $1YbJP.testIdGenerate)('primary-actions', menuId, 'menu-trigger');
    if (isVisible) return href != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8EB5v.PrimaryButton), {
        ...rest,
        component: (0, $lB25E.Link),
        href: href,
        isHighlighted: isHighlighted,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // @ts-expect-error - Type '"a"' is not assignable to type '"submit" | "reset" | "button" | undefined'
        type: "a"
    }) : // @ts-expect-error - iconBefore types mismatch ReactNode vs ReactChild
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8KeQ.PrimaryDropdownButton), {
        ...rest,
        isHighlighted: isHighlighted,
        isSelected: isMenuOpen,
        onClick: onClick,
        ref: ref,
        testId: testId
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $btNZp.RouteLinkItem), {
        ...rest,
        onClick: onClick,
        params: params,
        query: query,
        replace: replace,
        testId: testId,
        to: to,
        type: type
    });
    return href != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foGs0.LinkItem), {
        ...rest,
        href: href,
        onClick: onClick,
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ...rest,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2673dd6b34af72d$export$b837bd7eac09a33e, null),
        isSelected: isMenuOpen,
        onClick: onClick,
        testId: testId
    }));
});
// re-render regression detection
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'ForwardRefExoticComponent<Pick<any, string | number | symbol> & RefAttributes<MenuTriggerProps>>'.
$e2673dd6b34af72d$export$27d2ad3c5815583e.whyDidYouRender = {
    customName: 'MenuTrigger'
};
const $e2673dd6b34af72d$export$b837bd7eac09a33e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e2673dd6b34af72d$var$ChevronWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: ""
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e2673dd6b34af72d$var$ChevronWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_tzy4105o _2hwxmgjw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("69xWj", function(module, exports) {

$parcel$export(module.exports, "useMenuHighlighted", () => $4f54b27811157738$export$d47286bd4be0870d);

var $1FAd1 = parcelRequire("1FAd1");


var $10fdS = parcelRequire("10fdS");
const $4f54b27811157738$export$d47286bd4be0870d = (menuId)=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const topNavEntryPointReference = (0, $1FAd1.usePageLayoutEntryPoint)((0, $d619e185f38e9ae8$export$bec6dca2e63de4ae));
    if (route.navigation) return route.navigation.menuId === menuId;
    if (topNavEntryPointReference) return topNavEntryPointReference.extraProps.menuId === menuId;
    return false;
};

});
const $d619e185f38e9ae8$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $d619e185f38e9ae8$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $d619e185f38e9ae8$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $d619e185f38e9ae8$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $d619e185f38e9ae8$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';


parcelRegister("gvn5f", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalytics", () => $66272e1b6fb936ad$export$444d136efe970fd3);

var $eUqFw = parcelRequire("eUqFw");

var $cTgSO = parcelRequire("cTgSO");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $66272e1b6fb936ad$export$444d136efe970fd3 = ({ navigationItemId: navigationItemId })=>{
    const { isVisible: isVisible } = (0, $cTgSO.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((attributes = {})=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, navigationItemId, {
            // @ts-expect-error - TS2698 - Spread types may only be created from object types.
            ...attributes,
            isInMore: !isVisible,
            navigationLayer: 'global'
        });
    }, [
        createAnalyticsEvent,
        isVisible,
        navigationItemId
    ]);
};

});

parcelRegister("8EB5v", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $6101de355449f541$export$ac16a6a04d9b7c84);

var $eUqFw = parcelRequire("eUqFw");

var $dA9yl = parcelRequire("dA9yl");

var $eZmzz = parcelRequire("eZmzz");
const $6101de355449f541$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZmzz.SkeletonPrimaryButton), {
        text: props.children === undefined ? '' : props.children,
        isHighlighted: props.isHighlighted
    });
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dA9yl.PrimaryButton), buttonProps);
});

});

parcelRegister("k8KeQ", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $d95584ac612b9ccf$export$bb3af89fb196520d);

var $eUqFw = parcelRequire("eUqFw");

var $hTs14 = parcelRequire("hTs14");

var $eZmzz = parcelRequire("eZmzz");
const $d95584ac612b9ccf$export$bb3af89fb196520d = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZmzz.SkeletonPrimaryButton), {
        isDropdownButton: true,
        isHighlighted: props.isHighlighted,
        text: props.children === undefined ? '' : props.children
    });
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTs14.PrimaryDropdownButton), buttonProps);
});

});

parcelRegister("foGs0", function(module, exports) {

$parcel$export(module.exports, "LinkItem", () => $5a9cd70d984a3728$export$532cb6865ebe8946);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bo4OB = parcelRequire("bo4OB");

var $5kTTX = parcelRequire("5kTTX");
const $5a9cd70d984a3728$export$532cb6865ebe8946 = ({ href: href, target: target, onClick: onClick, ...rest })=>{
    const navigate = (0, $5kTTX.useNavigate)({
        href: href,
        onClick: onClick,
        target: target
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a9cd70d984a3728$export$8c0773eab230d49e, {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : '',
        onClick: navigate,
        ...rest
    });
};
const $5a9cd70d984a3728$export$8c0773eab230d49e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $bo4OB.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_9h8h1kw7 _f8pj1kw7 _30l31kw7 _1nrm18uv _1a3b18uv _9oik18uv _c2wa1kw7 _4fpr1kw7 _1bnx1kw7 _1iohnqa1 _5goinqa1 _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5kTTX", function(module, exports) {

$parcel$export(module.exports, "useNavigate", () => $5c28b621eda01d55$export$9770f232ac06a008);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");
const $5c28b621eda01d55$export$9770f232ac06a008 = ({ href: href, target: target, onClick: onClick, useRouterActions: useRouterActions = (0, $lB25E.useRouterActions), useCallback: useCallback = (0, $eUqFw.useCallback) })=>{
    const { push: push } = useRouterActions();
    return useCallback((event)=>{
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey || event.defaultPrevented || target === '_blank') return;
        event.preventDefault();
        push(href);
    }, [
        push,
        href,
        target,
        onClick
    ]);
};

});


parcelRegister("btNZp", function(module, exports) {

$parcel$export(module.exports, "RouteLinkItem", () => $4131c4e35c4d3a8c$export$5885e1e37551a766);

var $eUqFw = parcelRequire("eUqFw");

var $e7PSD = parcelRequire("e7PSD");

var $lB25E = parcelRequire("lB25E");
const $4131c4e35c4d3a8c$export$5885e1e37551a766 = ({ rel: rel, target: target, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: (0, $lB25E.Link),
        rel: rel ?? target === '_blank' ? 'noopener noreferrer' : '',
        target: target,
        prefetch: "hover",
        ...props
    });

});


parcelRegister("dxAeX", function(module, exports) {

$parcel$export(module.exports, "stopPropagation", () => $a42019e93f5f8c93$export$51134cce184326b9);
const $a42019e93f5f8c93$export$51134cce184326b9 = (e)=>e.stopPropagation();

});


parcelRegister("ry2Jr", function(module, exports) {

$parcel$export(module.exports, "usePersonalisedAppsTeamType", () => $7578b0bd645abf7c$export$952bf3a355bf4d23);

var $WBLbN = parcelRequire("WBLbN");

var $b9LwG = parcelRequire("b9LwG");
const $7578b0bd645abf7c$var$initialState = {
    isLoading: false,
    isSuccess: false,
    error: null,
    promise: null,
    teamType: undefined,
    hasSuccessOnce: false
};
const $7578b0bd645abf7c$var$store = (0, $WBLbN.createStore)({
    actions: $b9LwG.actions,
    initialState: $7578b0bd645abf7c$var$initialState,
    name: 'atlassian-navigation-addons-personalised-apps-team-type'
});
const $7578b0bd645abf7c$export$952bf3a355bf4d23 = (0, $WBLbN.createHook)($7578b0bd645abf7c$var$store);
const $7578b0bd645abf7c$export$202fd798d158e553 = (0, $WBLbN.createHook)($7578b0bd645abf7c$var$store, {
    selector: null
});

});
parcelRegister("b9LwG", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d0b81e605265ab65$export$e324594224ef24da);

var $fnodF = parcelRequire("fnodF");

var $hLW3g = parcelRequire("hLW3g");
const $d0b81e605265ab65$var$loadPersonalisedAppsUserSegmentation = ()=>async ({ setState: setState })=>{
        const promise = (0, $fnodF.getUserSegmentationData)();
        setState({
            error: null,
            isLoading: true,
            isSuccess: false,
            promise: promise
        });
        try {
            const { team: team } = await promise;
            const teamType = (0, $hLW3g.mapUserTeamTypeToTeamType)(team);
            setState({
                teamType: teamType,
                isSuccess: true,
                hasSuccessOnce: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error
            });
        } finally{
            setState({
                isLoading: false
            });
        }
    };
const $d0b81e605265ab65$export$e324594224ef24da = {
    loadPersonalisedAppsUserSegmentation: $d0b81e605265ab65$var$loadPersonalisedAppsUserSegmentation
};

});
parcelRegister("fnodF", function(module, exports) {

$parcel$export(module.exports, "getUserSegmentationData", () => $d56cdcff58d0857e$export$f0a14a7cbbb7397e);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $d56cdcff58d0857e$var$GET_ME_URL = '/gateway/api/me';
const $d56cdcff58d0857e$export$318c25600a19e2ee = ()=>(0, $lRmyA.performGetRequest)($d56cdcff58d0857e$var$GET_ME_URL);
const $d56cdcff58d0857e$export$f0a14a7cbbb7397e = async ()=>{
    let response = {
        jobTitle: undefined,
        team: undefined
    };
    try {
        const { extended_profile: extendedProfile } = await $d56cdcff58d0857e$export$318c25600a19e2ee();
        const { job_title: jobTitle, team_type: team } = extendedProfile;
        response = {
            jobTitle: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'undefined'.
            jobTitle,
            team: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'undefined'.
            team
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // failed to fetch user segmentation data, analytics will be added later
        (0, $guiFP.default)({
            meta: {
                id: 'getUserSegmentationData',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            },
            error: error
        });
    }
    return response;
};

});

parcelRegister("hLW3g", function(module, exports) {

$parcel$export(module.exports, "mapUserTeamTypeToTeamType", () => $712f8ea80132c10b$export$38b9d6b529723f8c);

var $75NPy = parcelRequire("75NPy");
const $712f8ea80132c10b$export$38b9d6b529723f8c = (team)=>{
    switch(team){
        case (0, $75NPy.PERSONALISED_APPS_TEAM_TYPES).softwareDevelopment:
            return (0, $75NPy.PERSONALISED_APPS_TEAM_TYPES).softwareDevelopment;
        case (0, $75NPy.PERSONALISED_APPS_TEAM_TYPES).itSupport:
            return (0, $75NPy.PERSONALISED_APPS_TEAM_TYPES).itSupport;
        default:
            return (0, $75NPy.PERSONALISED_APPS_TEAM_TYPES).marketing;
    }
};

});
parcelRegister("75NPy", function(module, exports) {

$parcel$export(module.exports, "PERSONALISED_APPS_TEAM_TYPES", () => $b10ecf1bc600ac08$export$2bdcfab7823ff30);
const $b10ecf1bc600ac08$export$2bdcfab7823ff30 = {
    marketing: 'Business Management and Operations',
    itSupport: 'IT Support',
    softwareDevelopment: 'Software Development'
};

});




parcelRegister("awmrT", function(module, exports) {

$parcel$export(module.exports, "AsyncMenu", () => $980ee656f8ce5836$export$81adf29ff528dc9c);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $gIh7l = parcelRequire("gIh7l");

var $j5uqN = parcelRequire("j5uqN");

var $cuHLr = parcelRequire("cuHLr");
const $980ee656f8ce5836$var$Skeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIh7l.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cuHLr.AppsSectionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j5uqN.MenuSkeletonContent), null)));

const $980ee656f8ce5836$export$c49a6d699b74b197 = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("cuHLr"))).then((module)=>module.Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/addons/menu/index.tsx"
});
const $980ee656f8ce5836$export$81adf29ff528dc9c = ({ shouldLoad: shouldLoad = true })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazyWait), {
        until: shouldLoad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($980ee656f8ce5836$var$Skeleton, null),
        name: "lazy-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($980ee656f8ce5836$export$c49a6d699b74b197, null)));

});
parcelRegister("gIh7l", function(module, exports) {

$parcel$export(module.exports, "MenuLayout", () => $24fc74f05c1f3cd7$export$dc2a07138b27c65b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $8PFhw = parcelRequire("8PFhw");

var $c9TLT = parcelRequire("c9TLT");
const $24fc74f05c1f3cd7$export$dc2a07138b27c65b = ({ children: children, isWide: isWide = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($24fc74f05c1f3cd7$var$Wrapper, {
        isWide: isWide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), {
        maxHeight: $24fc74f05c1f3cd7$var$maxHeight
    }, children));
const $24fc74f05c1f3cd7$var$starStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $24fc74f05c1f3cd7$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWide: isWide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1d8u6ab": (0, $9t7rW.default)(__cmplp.isWide ? `${(0, $c9TLT.gridSize) * 40}px` : `${(0, $c9TLT.gridSize) * 29.25}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul911kg _p12f1c3h _107nidpf _js70kb7n _nqzgkb7n _ziy7kb7n",
            __cmplp.className
        ])
    });
});
const $24fc74f05c1f3cd7$var$maxHeight = `calc(100vh - ${(0, $c9TLT.gridSize) * 25}px)`;

});

parcelRegister("j5uqN", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonContent", () => $8144c0faa4587be3$export$8db7a6d33c26b25f);

var $eUqFw = parcelRequire("eUqFw");

var $lV9rH = parcelRequire("lV9rH");
var $aVkzK = parcelRequire("aVkzK");

var $1YbJP = parcelRequire("1YbJP");
const $8144c0faa4587be3$export$8db7a6d33c26b25f = ({ testIdPrefix: testIdPrefix })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": (0, $1YbJP.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lV9rH.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasIcon: true,
        width: "50%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasIcon: true,
        width: "62.5%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        hasIcon: true,
        width: "50%"
    }));

});

parcelRegister("cuHLr", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $f8bd12fdb3094956$export$d9b273488cd8ce6f);
$parcel$export(module.exports, "AppsSectionWrapper", () => $f8bd12fdb3094956$export$ff8a83a2de46823a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8BKky = parcelRequire("8BKky");

var $dfBCt = parcelRequire("dfBCt");

var $8fxTv = parcelRequire("8fxTv");

var $jasPp = parcelRequire("jasPp");

var $0cdA8 = parcelRequire("0cdA8");

var $4qhD6 = parcelRequire("4qhD6");

var $6YtCU = parcelRequire("6YtCU");

var $3FBda = parcelRequire("3FBda");

var $2MjDU = parcelRequire("2MjDU");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7vTKl = parcelRequire("7vTKl");

var $1YbJP = parcelRequire("1YbJP");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $1R3n5 = parcelRequire("1R3n5");

var $4xHig = parcelRequire("4xHig");

var $5kDtB = parcelRequire("5kDtB");

var $7VDWq = parcelRequire("7VDWq");

var $gIh7l = parcelRequire("gIh7l");

var $j5uqN = parcelRequire("j5uqN");

var $43NDK = parcelRequire("43NDK");

var $ry2Jr = parcelRequire("ry2Jr");

var $k3wBg = parcelRequire("k3wBg");

var $039YH = parcelRequire("039YH");

var $3n1gg = parcelRequire("3n1gg");

var $bNfZA = parcelRequire("bNfZA");

var $5ZY4v = parcelRequire("5ZY4v");

var $c0qa0 = parcelRequire("c0qa0");

var $8CUCV = parcelRequire("8CUCV");
const $f8bd12fdb3094956$var$EVENT_DATA_ADDONS = {
    id: (0, $7vTKl.MENU_ID).ADDONS
};
const $f8bd12fdb3094956$var$EVENT_DATA_INTEGRATIONS = {
    id: 'integrations-apps-menu'
};
const $f8bd12fdb3094956$var$createIntegrationLink = (// @ts-expect-error - TS7006 - Parameter 'integration' implicitly has an 'any' type.
integration, isSiteAdmin, formatMessage)=>{
    const label = `${integration.label}${integration.categoryMessageKey !== undefined ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ popularApps: MessageDescriptorV2; personalisedAppsTitle: MessageDescriptorV2; personalisedAppsText: MessageDescriptorV2; ... 8 more ...; }'.
    ` (${formatMessage((0, $5ZY4v.default)[integration.categoryMessageKey])})` : ''}`;
    return integration.key === (0, $bNfZA.SLACK) ? {
        url: (0, $3FBda.getSlackConsentUrl)('apps-menu'),
        icon: integration.icon,
        actionSubjectId: integration.actionSubjectId,
        onClick: ()=>{
            (0, $2MjDU.openSlackIntegrationPopup)('apps-menu');
        },
        label: label
    } : {
        url: integration.getUrl(`source=apps-menu&${isSiteAdmin ? 'installDialogOpen=true' : 'requestDialogOpen=true'}`),
        icon: integration.icon,
        actionSubjectId: integration.actionSubjectId,
        label: label
    };
};
const $f8bd12fdb3094956$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isFooterVisible, setIsFooterSeparatorVisible] = (0, $eUqFw.useState)(true);
    const FooterSection = isFooterVisible ? $f8bd12fdb3094956$export$ff8a83a2de46823a : (0, $eUqFw.Fragment);
    const onFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const locale = (0, $4xHig.useLocale)();
    const isFedrampEnvironment = (0, $dfBCt.isFedRamp)();
    const testIdContent = (0, $1YbJP.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $1YbJP.testIdConcat)(testIdPrefix, 'footer');
    const testIdDiscover = (0, $1YbJP.testIdConcat)(testIdPrefix, 'discover');
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const [integrations, setIntegrations] = (0, $eUqFw.useState)([]);
    const [personalisedApps, setPersonalisedApps] = (0, $eUqFw.useState)([]);
    const [isLoadingPersonalisedApps, setIsLoadingPersonalisedApps] = (0, $eUqFw.useState)(true);
    const [{ teamType: teamType, error: teamTypeError, isLoading: isTeamTypeLoading }] = (0, $ry2Jr.usePersonalisedAppsTeamType)();
    const [isAppsMenuFinishedRendering, setIsAppsMenuFinishedRendering] = (0, $eUqFw.useState)(false);
    const [{ isFetching: loadingIntegrations, hasFetchedOnce: hasFetchedIntegrations, fetchError: fetchIntegrationsError, integrations: appsInstalled }, { fetchIntegrations: fetchIntegrations }] = (0, $k3wBg.default)();
    const { isSlackIntegrationEnabled: isSlackIntegrationEnabled, isSlackIntegrationConnected: isSlackIntegrationConnected, isLoading: isLoadingSlackStatus } = (0, $6YtCU.useFetchSlackStatus)();
    const onDiscoverError = (0, $eUqFw.useCallback)((location, error)=>{
        onFail(location, error);
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'appsDiscoverSection failed', 'appsMenuDiscoverSection', {
            error: 'Error loading discover section'
        });
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'loadingPersonalisedAppsExperiment failed', {
            message: error !== null && typeof error.message !== 'undefined' ? error.message : undefined,
            stack: error !== null && typeof error.stack !== 'undefined' ? error.stack : undefined
        });
    }, [
        createAnalyticsEvent,
        onFail
    ]);
    (0, $eUqFw.useEffect)(()=>{
        try {
            const teamAppList = (0, $c0qa0.getTeamAlignedAppList)(teamType);
            setIntegrations(teamAppList);
            if (teamTypeError) setIsLoadingPersonalisedApps(false);
             // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setIsLoadingPersonalisedApps(false);
            onDiscoverError('Getting a potential list of personalised apps failed.', error);
        }
    }, [
        teamType,
        isTeamTypeLoading,
        setIntegrations,
        teamTypeError,
        onDiscoverError,
        locale
    ]);
    (0, $eUqFw.useEffect)(()=>{
        try {
            if (!loadingIntegrations && hasFetchedIntegrations && !isLoadingSlackStatus) {
                const integrationsToShow = integrations.filter(({ key: key })=>key === (0, $bNfZA.SLACK) ? isSlackIntegrationEnabled && !isSlackIntegrationConnected : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
                    Boolean(appsInstalled[key]) === false).sort(()=>0.5 - Math.random()).slice(0, 3).map((integration)=>$f8bd12fdb3094956$var$createIntegrationLink(integration, isSiteAdmin, formatMessage));
                setPersonalisedApps(integrationsToShow);
                setIsLoadingPersonalisedApps(false);
            }
            if (fetchIntegrationsError) setIsLoadingPersonalisedApps(false);
             // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setIsLoadingPersonalisedApps(false);
            onDiscoverError('Preparing personalised apps failed.', error);
        }
    }, [
        integrations,
        appsInstalled,
        isSiteAdmin,
        setPersonalisedApps,
        loadingIntegrations,
        hasFetchedIntegrations,
        fetchIntegrationsError,
        isSlackIntegrationEnabled,
        isSlackIntegrationConnected,
        isLoadingSlackStatus,
        formatMessage,
        onDiscoverError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (integrations.length) fetchIntegrations(integrations.map((app)=>app.key));
    }, [
        integrations,
        fetchIntegrations
    ]);
    const errorFallback = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7VDWq.MenuError), {
            testIdPrefix: testIdContent
        }), [
        testIdContent
    ]);
    const errorFallbackDiscover = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7VDWq.MenuError), {
            testIdPrefix: testIdDiscover
        }), [
        testIdDiscover
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isAppsMenuFinishedRendering) (0, $8fxTv.NAVIGATION_TOP_DROPDOWN_MARKS).ADDONS.stop();
    }, [
        isAppsMenuFinishedRendering
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIh7l.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "personalised-apps",
        packageName: (0, $5kDtB.PACKAGE_NAME),
        fallback: errorFallback,
        extraEventData: $f8bd12fdb3094956$var$EVENT_DATA_ADDONS,
        onError: onFail,
        withExperienceTracker: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jasPp.AuthenticationErrorBoundary), {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8bd12fdb3094956$export$ff8a83a2de46823a, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j5uqN.MenuSkeletonContent), {
            testIdPrefix: testIdContent
        })),
        name: "apps-section-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $039YH.Content), {
        testIdPrefix: testIdContent
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "integrations-apps-menu",
        packageName: (0, $5kDtB.PACKAGE_NAME),
        extraEventData: $f8bd12fdb3094956$var$EVENT_DATA_INTEGRATIONS,
        render: errorFallbackDiscover,
        withExperienceTracker: false,
        onError: onDiscoverError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8bd12fdb3094956$export$ff8a83a2de46823a, {
            hasSeparator: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j5uqN.MenuSkeletonContent), {
            testIdPrefix: testIdDiscover
        })),
        name: "discover-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "appsMenuDiscoverSection",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3n1gg.DiscoverSection), {
        apps: personalisedApps,
        isLoadingApps: isLoadingPersonalisedApps,
        title: (0, $5ZY4v.default).personalisedAppsTitle,
        description: (0, $5ZY4v.default).personalisedAppsText,
        recommendationType: (0, $bNfZA.RECOMMENDATION_TYPE).Personalised,
        setIsAppsMenuFinishedRendering: setIsAppsMenuFinishedRendering,
        isFedrampEnvironment: isFedrampEnvironment
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "personalised-footer",
        packageName: (0, $5kDtB.PACKAGE_NAME),
        extraEventData: $f8bd12fdb3094956$var$EVENT_DATA_INTEGRATIONS,
        render: errorFallbackDiscover,
        withExperienceTracker: false,
        onError: onDiscoverError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FooterSection, {
        hasSeparator: true,
        testId: testIdFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43NDK.MenuSkeletonFooter), {
            testIdPrefix: testIdFooter
        }),
        name: "footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CUCV.Footer), {
        onUpdateIsFooterVisible: setIsFooterSeparatorVisible,
        testIdPrefix: testIdFooter,
        isFedrampEnvironment: isFedrampEnvironment
    })))));
};
const $f8bd12fdb3094956$export$ff8a83a2de46823a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8BKky.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tke12am",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jasPp", function(module, exports) {

$parcel$export(module.exports, "AuthenticationErrorBoundary", () => $f166a39fad510ca7$export$124b2dc1d1aab5e6);

var $eUqFw = parcelRequire("eUqFw");

var $4X5wI = parcelRequire("4X5wI");
class $f166a39fad510ca7$export$124b2dc1d1aab5e6 extends (0, $eUqFw.Component) {
    componentDidCatch(error, info) {
        if (error instanceof (0, $4X5wI.AuthenticationError)) {
            this.setState({
                caughtError: {
                    error: error,
                    info: info
                }
            });
            return;
        }
        throw error;
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback } = this.props;
        if (!caughtError) return children;
        return renderFallback();
    }
    constructor(...args){
        super(...args);
        this.state = {
            caughtError: null
        };
    }
}

});

parcelRegister("6YtCU", function(module, exports) {

$parcel$export(module.exports, "useFetchSlackStatus", () => $b5d5faf07bb9e0fb$export$bc4af53b82736ec2);

var $eUqFw = parcelRequire("eUqFw");

var $2OdyW = parcelRequire("2OdyW");

var $dWLk9 = parcelRequire("dWLk9");
const $b5d5faf07bb9e0fb$export$7ee0516d378ea459 = (cloudId)=>(0, $2OdyW.default)(`/gateway/api/slack/jira/enabled?cloudId=${cloudId}`, {
        method: 'GET'
    }).then((response)=>Boolean(response.enabled)).catch(()=>true);
const $b5d5faf07bb9e0fb$export$71a3c7f7dc819106 = ()=>(0, $2OdyW.default)('/gateway/api/slack/jira/status', {
        method: 'GET'
    }).then((response)=>Boolean(response.connected)).catch(()=>false);
const $b5d5faf07bb9e0fb$export$bc4af53b82736ec2 = (skip = false)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [isSlackIntegrationEnabled, setSlackIntegrationEnabled] = (0, $eUqFw.useState)(true);
    const [isSlackIntegrationConnected, setSlackIntegrationConnected] = (0, $eUqFw.useState)(false);
    const [isLoading, setLoading] = (0, $eUqFw.useState)(true);
    (0, $eUqFw.useEffect)(()=>{
        if (skip || !cloudId) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setSlackIntegrationEnabled(true);
        setSlackIntegrationConnected(false);
        Promise.all([
            $b5d5faf07bb9e0fb$export$7ee0516d378ea459(cloudId),
            $b5d5faf07bb9e0fb$export$71a3c7f7dc819106()
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(([isEnabled, isConnected])=>{
            setSlackIntegrationEnabled(isEnabled);
            setSlackIntegrationConnected(isConnected);
        }) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        .catch(()=>{}).finally(()=>{
            setLoading(false);
        });
    }, [
        skip,
        cloudId
    ]);
    return {
        isLoading: isLoading,
        isSlackIntegrationEnabled: isSlackIntegrationEnabled,
        isSlackIntegrationConnected: isSlackIntegrationConnected
    };
};

});

parcelRegister("3FBda", function(module, exports) {

$parcel$export(module.exports, "getSlackConsentUrl", () => $4f26a62c588a77b4$export$cc6a5a2d00c6e3ad);
const $4f26a62c588a77b4$var$prodConsentUrl = 'https://atlassian-slack-integration.services.atlassian.com/api/slack/login';
const $4f26a62c588a77b4$var$stagingConsentUrl = 'https://atlassian-slack-integration.stg.services.atlassian.com/api/slack/login';
const $4f26a62c588a77b4$export$cc6a5a2d00c6e3ad = (source, w = window)=>{
    const isProd = !(w.location.hostname.endsWith('jira-dev.com') || w.location.hostname === 'localhost');
    const url = isProd ? $4f26a62c588a77b4$var$prodConsentUrl : $4f26a62c588a77b4$var$stagingConsentUrl;
    return `${url}?source=${source}`;
};

});

parcelRegister("2MjDU", function(module, exports) {

$parcel$export(module.exports, "openSlackIntegrationPopup", () => $44caa7e99d5c85d6$export$a4ed879b9981f635);

var $3FBda = parcelRequire("3FBda");
const $44caa7e99d5c85d6$var$WIDTH = 500;
const $44caa7e99d5c85d6$var$HEIGHT = 900;
const $44caa7e99d5c85d6$var$baseParams = {
    toolbar: 0,
    menubar: 0,
    location: 0,
    status: 0,
    scrollbars: 1,
    resizable: 0,
    chrome: 'yes'
};
// @ts-expect-error - TS2322 - Type 'Window & typeof globalThis' is not assignable to type 'Window'.
const $44caa7e99d5c85d6$var$popupWindowParams = (w = window)=>{
    const width = Math.min($44caa7e99d5c85d6$var$WIDTH, w.screen.availWidth);
    const height = Math.min($44caa7e99d5c85d6$var$HEIGHT, w.screen.availHeight);
    const entities = {
        ...$44caa7e99d5c85d6$var$baseParams,
        width: width,
        height: height,
        left: Math.round((w.innerWidth - width) / 2 + w.screenX),
        top: Math.round((w.innerHeight - height) / 3 + w.screenY)
    };
    return Object.keys(entities)// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ width: number; height: number; left: number; top: number; toolbar: 0; menubar: 0; location: 0; status: 0; scrollbars: 1; resizable: 0; chrome: "yes"; }'.
    .map((key)=>`${key}=${entities[key]}`).join(',');
};
const $44caa7e99d5c85d6$export$a4ed879b9981f635 = (source, w = window)=>w.open((0, $3FBda.getSlackConsentUrl)(source), '_blank', $44caa7e99d5c85d6$var$popupWindowParams(w));

});

parcelRegister("7VDWq", function(module, exports) {

$parcel$export(module.exports, "MenuError", () => $e0ff107167613d29$export$b4cb8426191db8b3);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $hhftg = parcelRequire("hhftg");

var $bJFYO = parcelRequire("bJFYO");

var $9Jgu6 = parcelRequire("9Jgu6");
const $e0ff107167613d29$export$b4cb8426191db8b3 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const errorText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e0ff107167613d29$var$TextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e0ff107167613d29$var$Heading, null, formatMessage((0, $9Jgu6.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $9Jgu6.default).errorBody)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhftg.MenuInfo), {
        imgAltText: formatMessage((0, $9Jgu6.default).errorImg),
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($bJFYO))),
        testId: (0, $1YbJP.testIdConcat)(testIdPrefix, 'error'),
        text: errorText,
        useSmallImage: true
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e0ff107167613d29$var$TextWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41e2i",
            __cmplp.className
        ])
    });
});
const $e0ff107167613d29$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "strong", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hhftg", function(module, exports) {

$parcel$export(module.exports, "MenuInfo", () => $ac338ae8daf38ff8$export$14caacd677140cdb);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $ac338ae8daf38ff8$export$14caacd677140cdb = ({ imgAltText: imgAltText, imgHeight: imgHeight, imgSrc: imgSrc, text: text, useSmallImage: useSmallImage = false, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac338ae8daf38ff8$export$895814aa5a1cf38c, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac338ae8daf38ff8$export$e54065c861f556f9, {
        alt: imgAltText || '',
        imgHeight: imgHeight,
        src: imgSrc,
        useSmallImage: useSmallImage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ac338ae8daf38ff8$export$7c3018f441722857, null, text));
const $ac338ae8daf38ff8$export$895814aa5a1cf38c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsbnklw _1e0c1txw _y3gn1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $ac338ae8daf38ff8$export$e54065c861f556f9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { useSmallImage: useSmallImage, imgHeight: imgHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ve50id": (0, $9t7rW.default)(__cmplp.imgHeight, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1yt47e8x _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1osq",
            __cmplp.useSmallImage ? "_1bsb16xz" : "_1bsb1lit",
            __cmplp.imgHeight != null ? "_4t3i1m1g" : "_4t3i1wug",
            __cmplp.className
        ])
    });
});
const $ac338ae8daf38ff8$export$7c3018f441722857 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1yt4yv9d",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bJFYO", function(module, exports) {
module.exports = new URL("generic-error.bc45c66a.svg", import.meta.url).toString();

});

parcelRegister("9Jgu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64f7aecb997e6ea$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d64f7aecb997e6ea$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorHeading: {
        "id": "atlassian-navigation.common.menu.error.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "atlassian-navigation.common.menu.error.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    },
    errorImg: {
        "id": "atlassian-navigation.common.menu.error.error-img",
        "defaultMessage": "An image showing that an error has occurred"
    }
});

});


parcelRegister("43NDK", function(module, exports) {

$parcel$export(module.exports, "MenuSkeletonFooter", () => $d999fa9e23c1f01f$export$efa6bae06cf20a1);

var $eUqFw = parcelRequire("eUqFw");

var $aVkzK = parcelRequire("aVkzK");

var $1YbJP = parcelRequire("1YbJP");
const $d999fa9e23c1f01f$export$efa6bae06cf20a1 = ({ testIdPrefix: testIdPrefix, numItems: numItems = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": (0, $1YbJP.testIdConcat)(testIdPrefix, 'skeleton')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        width: "50%"
    }), numItems >= 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        width: "50%"
    }));

});

parcelRegister("k3wBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6877224a184501f9$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $WBLbN = parcelRequire("WBLbN");
const $6877224a184501f9$var$PLUGINS_URL = '/rest/plugins/1.0/available';
const $6877224a184501f9$var$PLUGINS_INSTALLED_BASE_URL = '/rest/plugins/1.0';
const $6877224a184501f9$var$cachedResult = {};
const $6877224a184501f9$export$761418bfd56d0c76 = (appKeys)=>{
    return appKeys.map((appKey)=>$6877224a184501f9$var$cachedResult[appKey] ? Promise.resolve($6877224a184501f9$var$cachedResult[appKey]) : (0, $lRmyA.performGetRequest)(`${$6877224a184501f9$var$PLUGINS_INSTALLED_BASE_URL}/${appKey}-key`).then(()=>{
            $6877224a184501f9$var$cachedResult[appKey] = {
                key: appKey,
                installed: true
            };
            return $6877224a184501f9$var$cachedResult[appKey];
        }).catch((error)=>{
            if (error.response && error.response.status === 404) {
                $6877224a184501f9$var$cachedResult[appKey] = {
                    key: appKey,
                    installed: false
                };
                return $6877224a184501f9$var$cachedResult[appKey];
            }
            (0, $gUUjF.default).safeErrorWithoutCustomerData('experimental-apps-discover', `failed to load installed app details for ${appKey}`);
        }));
};
const $6877224a184501f9$export$22bc61add701495d = (appKeys)=>// @ts-expect-error - TS2322 - Type 'Promise<void | AppDetail>[]' is not assignable to type 'Promise<AppDetail | undefined>[]'.
    appKeys.map((appKey)=>$6877224a184501f9$var$cachedResult[appKey] ? Promise.resolve($6877224a184501f9$var$cachedResult[appKey]) : (0, $lRmyA.performGetRequest)(`${$6877224a184501f9$var$PLUGINS_URL}/${appKey}-key`).then((detail)=>{
            $6877224a184501f9$var$cachedResult[appKey] = detail;
            return $6877224a184501f9$var$cachedResult[appKey];
        }).catch(()=>(0, $gUUjF.default).safeErrorWithoutCustomerData('experimental-apps-discover', `failed to load app details for ${appKey}`)));
const $6877224a184501f9$var$handleFetch = (appKeys)=>{
    const fetchAppDetailsFn = (0, $eI5EY.fg)('enable_migrate_upm_available_to_plugins') ? $6877224a184501f9$export$761418bfd56d0c76 : $6877224a184501f9$export$22bc61add701495d;
    // @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'getState' implicitly has an 'any' type.
    return async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) try {
            const integrations = (await Promise.all(fetchAppDetailsFn(appKeys))).filter(Boolean) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .reduce((apps, { key: key, installed: installed })=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...apps,
                    [key]: installed
                }), {});
            setState({
                integrations: integrations,
                isFetching: false,
                fetchError: null,
                hasFetchedOnce: true,
                hasSuccessOnce: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetching: false,
                fetchError: error,
                hasFetchedOnce: true
            });
        }
    };
};
const $6877224a184501f9$var$actions = {
    fetchIntegrations: (appKeys)=>async ({ setState: setState, dispatch: dispatch })=>{
            const promise = dispatch($6877224a184501f9$var$handleFetch(appKeys));
            setState({
                isFetching: true,
                promise: // @ts-expect-error - TS2322 - Type 'Promise<void>' is not assignable to type 'Promise<undefined>'.
                promise
            });
        }
};
const $6877224a184501f9$var$Store = (0, $WBLbN.createStore)({
    name: 'fetch-integrations',
    initialState: {
        integrations: {},
        isFetching: false,
        fetchError: null,
        promise: null,
        hasFetchedOnce: false,
        hasSuccessOnce: false
    },
    actions: // @ts-expect-error - TS2322 - Type '{ readonly fetchIntegrations: (appKeys: string[]) => Action<State>; }' is not assignable to type 'Record<string, ActionThunk<{ integrations: {}; isFetching: boolean; fetchError: null; promise: null; hasFetchedOnce: boolean; hasSuccessOnce: boolean; }, { readonly fetchIntegrations: (appKeys: string[]) => Action<State, void, void | Promise<...>>; }>>'.
    $6877224a184501f9$var$actions
});
const $6877224a184501f9$export$bb9a596c8be2a95f = (0, $WBLbN.createHook)($6877224a184501f9$var$Store);
var $6877224a184501f9$export$2e2bcd8739ae039 = $6877224a184501f9$export$bb9a596c8be2a95f;

});

parcelRegister("039YH", function(module, exports) {

$parcel$export(module.exports, "Content", () => $7da1b21435886a55$export$7c6e2c02157bb7d2);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");

var $5VB9J = parcelRequire("5VB9J");

var $fDZ6r = parcelRequire("fDZ6r");

var $3UtNf = parcelRequire("3UtNf");

var $3rqlh = parcelRequire("3rqlh");

var $5kDtB = parcelRequire("5kDtB");

var $c1bKR = parcelRequire("c1bKR");
const $7da1b21435886a55$export$7c6e2c02157bb7d2 = ({ testIdPrefix: testIdPrefix })=>{
    const [{ items: items, fetchError: fetchError, promise: promise, hasSuccessOnce: hasSuccessOnce, isFetching: isFetching }] = (0, $5VB9J.useAddon)();
    const [{ items: forgeItems }] = (0, $3UtNf.useForgeGlobalItems)();
    const onSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    if (fetchError && !hasSuccessOnce) throw fetchError;
    if (isFetching) throw promise;
    (0, $eUqFw.useEffect)(()=>{
        if (hasSuccessOnce) onSuccess();
    }, [
        hasSuccessOnce,
        onSuccess
    ]);
    const forgeGlobalPageItemsCondition = ()=>forgeItems && forgeItems.length > 0;
    return (0, $3rqlh.getUsersApps)(items).length > 0 || forgeGlobalPageItemsCondition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        testId: testIdPrefix
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c1bKR.Items), {
        testIdPrefix: testIdPrefix
    })) : null;
};

});
parcelRegister("3rqlh", function(module, exports) {

$parcel$export(module.exports, "useAtlassianPersonalSettingsLink", () => $52b6ea6dc94a0795$export$8ac70acdad00754b);
$parcel$export(module.exports, "useProfileLink", () => $52b6ea6dc94a0795$export$b8f25e615dd30d7b);
$parcel$export(module.exports, "getBeforeEntity", () => $52b6ea6dc94a0795$export$5b8580d0254a9349);
$parcel$export(module.exports, "getBoardLink", () => $52b6ea6dc94a0795$export$ff5c49b7852aca68);
$parcel$export(module.exports, "getLinkFromProject", () => $52b6ea6dc94a0795$export$dd9458ee44edd0c6);
$parcel$export(module.exports, "getQueueLink", () => $52b6ea6dc94a0795$export$b44363840d1b683e);
$parcel$export(module.exports, "getIsClassicSoftwareProject", () => $52b6ea6dc94a0795$export$286ea82aef1c76e9);
$parcel$export(module.exports, "getUsersApps", () => $52b6ea6dc94a0795$export$ad0fd737fbd4a083);

var $53ciZ = parcelRequire("53ciZ");

var $bW292 = parcelRequire("bW292");

var $fXKgc = parcelRequire("fXKgc");

var $6wsEw = parcelRequire("6wsEw");

var $gcXWF = parcelRequire("gcXWF");

var $1a6Wh = parcelRequire("1a6Wh");

var $eD2UT = parcelRequire("eD2UT");

var $7yAHk = parcelRequire("7yAHk");

var $4PVYj = parcelRequire("4PVYj");

var $eaP1H = parcelRequire("eaP1H");

var $kHK5i = parcelRequire("kHK5i");

var $dxcfv = parcelRequire("dxcfv");

var $7vTKl = parcelRequire("7vTKl");

const $52b6ea6dc94a0795$export$ab902790e443b0ec = ()=>`${(0, $bW292.getATLContextUrl)('id')}/login`;
const $52b6ea6dc94a0795$export$8ac70acdad00754b = (destinationAccountEmail)=>{
    const loginLink = $52b6ea6dc94a0795$export$ab902790e443b0ec();
    const destinationUrl = `${(0, $bW292.getATLContextUrl)('id')}/manage-profile/profile-and-visibility`;
    return destinationAccountEmail ? `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        application: 'jira',
        continue: destinationUrl,
        login_hint: destinationAccountEmail,
        prompt: 'none'
    })}` : destinationUrl;
};
const $52b6ea6dc94a0795$export$b8f25e615dd30d7b = ()=>{
    const accountId = (0, $dxcfv.useAccountId)();
    return `/jira/people/${accountId || ''}`;
};
const $52b6ea6dc94a0795$export$5b8580d0254a9349 = (favoriteItems)=>favoriteItems && favoriteItems.length > 0 ? {
        id: String(favoriteItems[0].id),
        type: favoriteItems[0].type
    } : {
        id: undefined,
        type: undefined
    };
const $52b6ea6dc94a0795$export$ff5c49b7852aca68 = (item)=>{
    const { attributes: attributes, attributes: { parentType: parentType }, id: id } = item;
    const boardId = String(id);
    if (parentType === 'project') {
        // @ts-expect-error - TS2339 - Property 'nextgen' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectKey' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectType' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { nextgen: nextgen, projectKey: projectKey, projectType: projectType } = attributes;
        if (projectType === 'business') return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, $6wsEw.jiraBusinessProjectRedirectRoute)
        };
        if (projectType === 'service_desk') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $gcXWF.jsmBoardRoute)
        };
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7yAHk.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $4PVYj.classicSoftwareBoardRoute)
        };
    }
    if (parentType === 'user') {
        // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { userAccountId: accountId } = attributes;
        return {
            params: {
                boardId: boardId,
                accountId: accountId
            },
            query: {},
            route: (0, $eaP1H.userBoardRoute)
        };
    }
    return {
        params: undefined,
        query: undefined,
        route: undefined
    };
};
const $52b6ea6dc94a0795$export$dd9458ee44edd0c6 = (item)=>{
    const { attributes: { projectType: projectType, boardId: boardId, nextgen: nextgen, projectKey: projectKey } } = item;
    if (projectType === 'business') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $6wsEw.jiraBusinessProjectRedirectRoute)
    };
    if (boardId !== undefined) {
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $7yAHk.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $4PVYj.classicSoftwareBoardRoute)
        };
    }
    if (projectType === 'service_desk') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $1a6Wh.projectServiceDeskRoute)
    };
    return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $fXKgc.browseProjectRedirectRoute)
    };
};
const $52b6ea6dc94a0795$export$b44363840d1b683e = (item)=>{
    const { attributes: { projectKey: projectKey, queuesCategory: queuesCategory }, id: id } = item;
    return {
        params: {
            projectKey: projectKey,
            ...queuesCategory != null && queuesCategory !== '' ? {
                practiceType: (0, $kHK5i.toShortFormItsmPractice)(queuesCategory)
            } : {},
            queueId: String(id)
        },
        route: queuesCategory != null && queuesCategory !== '' ? (0, $eD2UT.customPracticeQueueRoute) : (0, $eD2UT.customQueueRoute)
    };
};
const $52b6ea6dc94a0795$export$286ea82aef1c76e9 = (attributes)=>attributes.parentType === 'user' || attributes.parentType === 'project' && attributes.projectType === 'software' && attributes.nextgen === 'false';
const $52b6ea6dc94a0795$export$ad0fd737fbd4a083 = (items)=>items.filter((item)=>item.id !== (0, $7vTKl.ADDON_ID).DISCOVER);

});
parcelRegister("fXKgc", function(module, exports) {

$parcel$export(module.exports, "browseProjectRedirectRoute", () => $d7a8c211966f4d11$export$f9cac37753487f39);

var $exb0h = parcelRequire("exb0h");
const $d7a8c211966f4d11$export$f9cac37753487f39 = {
    group: (0, $exb0h.ROUTE_GROUPS_REDIRECTS),
    name: (0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
    path: '/browse/:projectKey([^-/]+)',
    exact: true,
    isRedirect: true
};

});

parcelRegister("6wsEw", function(module, exports) {

$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $5fcf01b1512d8afb$export$73b60789ceb8e1eb);
$parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", () => $5fcf01b1512d8afb$export$5ab0e07528c31349);

var $exb0h = parcelRequire("exb0h");
const $5fcf01b1512d8afb$export$73b60789ceb8e1eb = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
    path: '/jira/core/projects/:projectKey',
    exact: true,
    isRedirect: true
};
const $5fcf01b1512d8afb$export$5ab0e07528c31349 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS),
    name: (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
    path: '/jira/core/overviews/:overviewId',
    exact: true,
    isRedirect: true
};

});

parcelRegister("gcXWF", function(module, exports) {

$parcel$export(module.exports, "jsmBoardRoute", () => $2bd2ada1d304a75f$export$a192088aab559fa1);

var $exb0h = parcelRequire("exb0h");
const $2bd2ada1d304a75f$export$a192088aab559fa1 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS)
};

});

parcelRegister("1a6Wh", function(module, exports) {

$parcel$export(module.exports, "projectServiceDeskRoute", () => $48d1c095208636aa$export$1cfc858068dd8718);

var $exb0h = parcelRequire("exb0h");
const $48d1c095208636aa$export$1cfc858068dd8718 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REDIRECT),
    path: '/jira/servicedesk/projects/:projectKey'
};

});

parcelRegister("eD2UT", function(module, exports) {

$parcel$export(module.exports, "customQueueRoute", () => $4782d0a5c5a44372$export$e1fac82ca0b0d637);
$parcel$export(module.exports, "customPracticeQueueRoute", () => $4782d0a5c5a44372$export$59d0bd42aa07faad);

var $exb0h = parcelRequire("exb0h");
const $4782d0a5c5a44372$export$e1fac82ca0b0d637 = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey?'
};
const $4782d0a5c5a44372$export$59d0bd42aa07faad = {
    group: (0, $exb0h.ROUTE_GROUPS_SERVICEDESK),
    name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?'
};

});

parcelRegister("7yAHk", function(module, exports) {

$parcel$export(module.exports, "softwareBoardRoute", () => $650519e8b83fa4a8$export$9ae2c0a566d4e0f6);
$parcel$export(module.exports, "softwareBoardEmbedRoute", () => $650519e8b83fa4a8$export$f55626b64e3fcb4f);

var $exb0h = parcelRequire("exb0h");
const $650519e8b83fa4a8$export$9ae2c0a566d4e0f6 = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS),
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};
const $650519e8b83fa4a8$export$f55626b64e3fcb4f = {
    group: (0, $exb0h.ROUTE_GROUPS_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS_EMBED),
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("4PVYj", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $9f593306e01ca1b5$export$131d51ca54849e97);
$parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", () => $9f593306e01ca1b5$export$122afcef7dfd252);

var $exb0h = parcelRequire("exb0h");
const $9f593306e01ca1b5$export$131d51ca54849e97 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId',
    ufoName: 'classic-board'
};
const $9f593306e01ca1b5$export$122afcef7dfd252 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed',
    ufoName: 'classic-board-embed'
};

});

parcelRegister("eaP1H", function(module, exports) {

$parcel$export(module.exports, "userBoardRoute", () => $f203bcc70ddc17af$export$57a2a0fe739f16);

var $exb0h = parcelRequire("exb0h");

var $bmKiO = parcelRequire("bmKiO");
const $f203bcc70ddc17af$export$57a2a0fe739f16 = {
    group: (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE),
    name: (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
    path: '/jira/people/:accountId/boards/:boardId',
    preloadOptions: {
        earlyChunks: [
            'rapidboard-early-entry'
        ]
    },
    earlyAssets: (0, $bmKiO.AGGRESSIVE_EARLY_ASSET_STRATEGY)
};

});
parcelRegister("bmKiO", function(module, exports) {

$parcel$export(module.exports, "NORMAL_EARLY_ASSET_STRATEGY", () => $3e02e9822ae54785$export$137d6d169f402a59);
$parcel$export(module.exports, "AGGRESSIVE_EARLY_ASSET_STRATEGY", () => $3e02e9822ae54785$export$ad16a91905cefb0a);
const $3e02e9822ae54785$var$COMMON_ASSET_REGEX = /.*\/commons(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $3e02e9822ae54785$var$VENDOR_ASSET_REGEX = /.*\/vendor(-entry|~[0-9a-z]*)?(\.[0-9a-z]*)?(\.[0-9])?\.js/;
const $3e02e9822ae54785$var$PARCEL_COMMON_ASSET_REGEX = /.*\/shared~commons(~ar)?(\.[0-9a-z]*)\.js/;
const $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX = /.*\/shared~vendor(~ar)?(\.[0-9a-z]*)\.js/;
const $3e02e9822ae54785$export$137d6d169f402a59 = [
    $3e02e9822ae54785$var$VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX
];
const $3e02e9822ae54785$export$ad16a91905cefb0a = [
    $3e02e9822ae54785$var$VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$COMMON_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_VENDOR_ASSET_REGEX,
    $3e02e9822ae54785$var$PARCEL_COMMON_ASSET_REGEX
];

});


parcelRegister("kHK5i", function(module, exports) {

$parcel$export(module.exports, "toShortFormItsmPractice", () => $3c2de4d4270495ab$export$db58a56259f511a2);

var $f1lMr = parcelRequire("f1lMr");
const $3c2de4d4270495ab$var$longToShortConversionMap = {
    [(0, $f1lMr.CHANGES)]: (0, $f1lMr.SHORT_FORM_CHANGES),
    [(0, $f1lMr.INCIDENTS)]: (0, $f1lMr.SHORT_FORM_INCIDENTS),
    [(0, $f1lMr.PROBLEMS)]: (0, $f1lMr.SHORT_FORM_PROBLEMS),
    [(0, $f1lMr.SERVICE_REQUEST)]: (0, $f1lMr.SHORT_FORM_SERVICE_REQUEST),
    [(0, $f1lMr.POST_INCIDENT_REVIEWS)]: (0, $f1lMr.SHORT_FORM_POST_INCIDENT_REVIEWS),
    [(0, $f1lMr.DEVELOPER_ESCALATION)]: (0, $f1lMr.SHORT_FORM_DEVELOPER_ESCALATION)
};
function $3c2de4d4270495ab$var$isLongForm(workCategoryKey) {
    return !!workCategoryKey && workCategoryKey in $3c2de4d4270495ab$var$longToShortConversionMap;
}
const $3c2de4d4270495ab$export$db58a56259f511a2 = (workCategoryKey)=>{
    if ($3c2de4d4270495ab$var$isLongForm(workCategoryKey)) return $3c2de4d4270495ab$var$longToShortConversionMap[workCategoryKey];
    return null;
};

});


parcelRegister("c1bKR", function(module, exports) {

$parcel$export(module.exports, "Items", () => $83492f5a652428dc$export$b4399d239416b67f);

var $eUqFw = parcelRequire("eUqFw");

var $iFXD5 = parcelRequire("iFXD5");

var $5wpwq = parcelRequire("5wpwq");

var $5VB9J = parcelRequire("5VB9J");

var $422mK = parcelRequire("422mK");

var $3UtNf = parcelRequire("3UtNf");

var $1boRu = parcelRequire("1boRu");

var $d6g7g = parcelRequire("d6g7g");

var $5eZBP = parcelRequire("5eZBP");

var $2Rqjr = parcelRequire("2Rqjr");

var $7eMp1 = parcelRequire("7eMp1");

var $pMxZ0 = parcelRequire("pMxZ0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7vTKl = parcelRequire("7vTKl");

var $1YbJP = parcelRequire("1YbJP");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $bNe1g = parcelRequire("bNe1g");

var $OBq1v = parcelRequire("OBq1v");

var $cwU5v = parcelRequire("cwU5v");

var $1hAca = parcelRequire("1hAca");

var $4nIB5 = parcelRequire("4nIB5");
const $83492f5a652428dc$var$ContentItems = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { key: projectIdOrKey } = (0, $bNe1g.useProjectContext)();
    const [{ items: connectItems }, { setContext: setContext }] = (0, $5VB9J.useAddon)();
    const [{ items: forgeStoreItems }] = (0, $3UtNf.useForgeGlobalItems)();
    const { addNew: addNew } = (0, $422mK.useConnectItemClickHistory)();
    (0, $eUqFw.useEffect)(()=>{
        setContext({
            projectIdOrKey: projectIdOrKey
        });
    }, [
        projectIdOrKey,
        setContext
    ]);
    const sortedItems = (0, $eUqFw.useMemo)(()=>[
            ...(forgeStoreItems || []).map((item)=>({
                    type: 'forge',
                    item: item
                })),
            ...connectItems.filter((item)=>item.id !== (0, $7vTKl.ADDON_ID).DISCOVER).map((item)=>({
                    type: 'connect',
                    item: item
                }))
        ].sort((a, b)=>a.item.title.localeCompare(b.item.title)), [
        connectItems,
        forgeStoreItems
    ]);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items');
    const getMenuItemProps = ({ item: item, type: type })=>type === 'connect' ? {
            onClick: ()=>item.url != null && addNew(item.url),
            className: item.className
        } : {
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
                environmentType: item.environmentType
            }),
            onClick: ()=>{
                (0, $d6g7g.forgeModulesConcurrentLoadTime)(item.id).start({
                    startTime: performance.now()
                });
            }
        };
    const renderMenuItems = ()=>sortedItems.map((ecosystemItem, idx)=>{
            const { type: type, item: item } = ecosystemItem;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
                key: item.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
                testId: (0, $1YbJP.testIdConcat)(testId, `item-${idx}`),
                href: item.url,
                analytics: {
                    actionSubjectId: 'appsNavigationMenuItem',
                    menuItemId: item.id,
                    menuItemType: 'apps',
                    position: idx,
                    appName: item.title,
                    appType: type
                },
                iconBefore: item.avatarUrl != null && item.avatarUrl.trim().length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $pMxZ0.IconCustom), {
                    url: item.avatarUrl
                }) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
                    primaryColor: (0, $1hAca.PRIMARY_COLOR),
                    label: item.title
                }),
                ...getMenuItemProps(ecosystemItem)
            }, item.title));
        });
    const shouldTriggerForgeScreenEvent = forgeStoreItems && forgeStoreItems.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), null, formatMessage((0, $4nIB5.default).yourAppsText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, renderMenuItems()), shouldTriggerForgeScreenEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $2Rqjr.GLOBAL_PAGE_MODULE)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "appsMenuYourAppsSection",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
const $83492f5a652428dc$export$b4399d239416b67f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5eZBP.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83492f5a652428dc$var$ContentItems, props));

});
parcelRegister("422mK", function(module, exports) {

$parcel$export(module.exports, "useConnectItemClickHistory", () => $e1e0c0027f44f3f6$export$c251e3fda1cce4a3);

var $eUqFw = parcelRequire("eUqFw");
// A single instance for the entire SPA session
const $e1e0c0027f44f3f6$var$history = {
    unique: []
};
const $e1e0c0027f44f3f6$export$c251e3fda1cce4a3 = ()=>{
    const addNew = (0, $eUqFw.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $e1e0c0027f44f3f6$var$history.unique.push(historyItem);
    }, []);
    return (0, $eUqFw.useMemo)(()=>({
            history: $e1e0c0027f44f3f6$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $e1e0c0027f44f3f6$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $e1e0c0027f44f3f6$var$history.unique.length = 0;
};

});

parcelRegister("1boRu", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $e499aee6653ef75f$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $e499aee6653ef75f$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $e499aee6653ef75f$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $e499aee6653ef75f$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $e499aee6653ef75f$export$14e56d7f5d3f917c);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $9x02J = parcelRequire("9x02J");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $2qZHF = parcelRequire("2qZHF");

var $hRcYT = parcelRequire("hRcYT");

var $8XU7c = parcelRequire("8XU7c");

var $bBGpO = parcelRequire("bBGpO");

var $9Z5wa = parcelRequire("9Z5wa");

var $5syGA = parcelRequire("5syGA");

var $d6g7g = parcelRequire("d6g7g");
const $e499aee6653ef75f$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: (0, $bBGpO.createAttributes)(attributes)
    });
const $e499aee6653ef75f$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $9Z5wa.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $e499aee6653ef75f$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $9x02J.useHasForgeAccess)();
    const analyticsAttributes = (0, $bBGpO.createAttributes)({
        ...attributes,
        hasForgeAccess: hasForgeAccess
    });
    const fireEvent = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, (0, $8XU7c.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: fireEvent
    });
};
const $e499aee6653ef75f$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $e499aee6653ef75f$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $eUqFw.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $eUqFw.useCallback)((error)=>(0, $bBGpO.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hRcYT.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $e499aee6653ef75f$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $8XU7c.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>(0, $bBGpO.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $2Rqjr.CUSTOM_FIELD_MODULE) || extensionModule === (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $2Rqjr.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $2Rqjr.GLOBAL_PAGE_MODULE),
        (0, $2Rqjr.ISSUE_ACTION_MODULE),
        (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        (0, $2Rqjr.ISSUE_PANEL_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.PROJECT_PAGE_MODULE),
        (0, $2Rqjr.ADMIN_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $e499aee6653ef75f$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $eUqFw.useRef)(performance.now());
        const isCustomUI = (0, $2vJHJ.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $eUqFw.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $8XU7c.getEventId)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $8XU7c.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $eUqFw.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $5syGA.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!$e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        const onError = (0, $eUqFw.useCallback)(()=>{
            extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $eUqFw.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $9Z5wa.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $eUqFw.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("2vJHJ", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $0071fffa92d48f40$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $0071fffa92d48f40$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $0071fffa92d48f40$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $0071fffa92d48f40$export$42b85bc9b386c977);

var $8blac = parcelRequire("8blac");
const $0071fffa92d48f40$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
        extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $0071fffa92d48f40$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $0071fffa92d48f40$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $0071fffa92d48f40$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(propsToOverride)) return extension;
    const { resource: resource, requiresUserConsent: requiresUserConsent } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        },
        requiresUserConsent: requiresUserConsent
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("9x02J", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2);

var $6yplV = parcelRequire("6yplV");
const $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("2qZHF", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $017cfdc2fc017c3b$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
// eslint-disable-next-line jira/react/no-class-components
class $017cfdc2fc017c3b$var$MountEventComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $017cfdc2fc017c3b$export$2c6963927dbc68f1 = (0, $2jDha.default)()($017cfdc2fc017c3b$var$MountEventComponent);

});

parcelRegister("8XU7c", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $ea56d020133ed4ec$export$5639f6a927500d9);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $ea56d020133ed4ec$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getEventActionName", () => $ea56d020133ed4ec$export$644ccb9a67b9a9c1);

var $2Rqjr = parcelRequire("2Rqjr");

var $TrUS5 = parcelRequire("TrUS5");

var $hRcYT = parcelRequire("hRcYT");



const $ea56d020133ed4ec$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $ea56d020133ed4ec$var$prepareModuleMode = (entryPoint)=>`${$ea56d020133ed4ec$var$capitalizeFirstLetter(entryPoint)}`;
const $ea56d020133ed4ec$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $ea56d020133ed4ec$var$prepareModuleName = (moduleName)=>(0, $2Rqjr.SUPPORTED_MODULES).includes(moduleName) ? $ea56d020133ed4ec$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $ea56d020133ed4ec$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $ea56d020133ed4ec$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
const $ea56d020133ed4ec$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hRcYT.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});

parcelRegister("9Z5wa", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $2660eb080e6928fb$export$add44f896fb31ba3);

var $hRcYT = parcelRequire("hRcYT");

var $cYWDh = parcelRequire("cYWDh");
const $2660eb080e6928fb$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("5syGA", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $05fce0f798595dcf$export$5d3b06ab08af139e);

var $2vJHJ = parcelRequire("2vJHJ");

var $70ON1 = parcelRequire("70ON1");
const $05fce0f798595dcf$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});


parcelRegister("5eZBP", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $e8202959ee66c089$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $e8202959ee66c089$export$e1a79e3d472c925a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");
const $e8202959ee66c089$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.GLOBAL_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $e8202959ee66c089$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.GLOBAL_PAGE_MODULE),
        moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("7eMp1", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $cd44a5efa9c7c2f2$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $cd44a5efa9c7c2f2$export$f9338c21ba7c7334);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $2Rqjr = parcelRequire("2Rqjr");

var $8uD7Y = parcelRequire("8uD7Y");

var $aghg0 = parcelRequire("aghg0");
const $cd44a5efa9c7c2f2$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $2Rqjr.DEVELOPMENT_ENVIRONMENT:
            return (0, $aghg0.messages).developmentEnvironmentLozenge;
        case 0, $2Rqjr.STAGING_ENVIRONMENT:
            return (0, $aghg0.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $cd44a5efa9c7c2f2$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $cd44a5efa9c7c2f2$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), labelKey)) : null;
};
const $cd44a5efa9c7c2f2$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $2Rqjr.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("aghg0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ea116b14fefa1e63$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ea116b14fefa1e63$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});


parcelRegister("pMxZ0", function(module, exports) {

$parcel$export(module.exports, "IconCustom", () => $671169200c6cf887$export$5b6504ec6adf0047);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hhzSj = parcelRequire("hhzSj");
// got this value through trial and error
// in the long term, we should change the color of icon generated for the conntect apps
const $671169200c6cf887$var$colorMatrixValues = '0.08, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 0, 0,0.2, 0, 0, 0, 0, 0, 1, 0';
const $671169200c6cf887$export$5b6504ec6adf0047 = ({ url: url, shouldChangeFillColor: shouldChangeFillColor = true, ariaLabelledBy: ariaLabelledBy })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $671169200c6cf887$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        viewBox: "0 0 20 20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: $671169200c6cf887$var$colorMatrixValues
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "20",
        height: "20",
        x: "0",
        y: "0",
        filter: shouldChangeFillColor && (0, $hhzSj.checkForSvg)(url) ? 'url(#changeFillColor)' : '',
        "aria-labelledby": ariaLabelledBy
    })));
};
const $671169200c6cf887$var$styles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    margin: 'space.025',
    height: "var(--ds-space-250, 20px)",
    width: "var(--ds-space-250, 20px)"
});

});
parcelRegister("hhzSj", function(module, exports) {

$parcel$export(module.exports, "checkForSvg", () => $7c70caac48e2293d$export$9a369805b0fabb72);
const $7c70caac48e2293d$export$9a369805b0fabb72 = (url)=>{
    const fileType = url.split(/#|\?/)[0].split('.').pop();
    // falsey check is for Ts
    return fileType ? fileType.trim() === 'svg' : false;
};

});


parcelRegister("OBq1v", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $a979442c466ae1d9$export$2ce376c2cc3355c8);

var $eUqFw = parcelRequire("eUqFw");

var $bULPy = parcelRequire("bULPy");

var $foGs0 = parcelRequire("foGs0");

var $btNZp = parcelRequire("btNZp");

var $jFlan = parcelRequire("jFlan");
const $a979442c466ae1d9$export$2ce376c2cc3355c8 = ({ analytics: analytics, href: href, onClick: onClick, params: params, query: query, replace: replace, target: target, to: to, type: type, ...rest })=>{
    const onClickHandler = (0, $jFlan.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    if (to != null && __SPA__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $btNZp.RouteLinkItem), {
        onClick: onClickHandler,
        params: params,
        query: query,
        replace: replace,
        target: target,
        to: to,
        type: type,
        ...rest
    });
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foGs0.LinkItem), {
        href: href,
        target: target,
        onClick: onClickHandler,
        ...rest
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        onClick: onClickHandler,
        ...rest
    });
};

});
parcelRegister("jFlan", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $f51ea521b50038ed$export$a81c45382e7253ac);

var $cTgSO = parcelRequire("cTgSO");

var $3BTZc = parcelRequire("3BTZc");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $f51ea521b50038ed$export$a81c45382e7253ac = ({ analytics: analytics, fireUIAnalytics: fireUIAnalytics = (0, $jMP2a.fireUIAnalytics), onClick: onClick, useAnalyticsEvents: useAnalyticsEvents = (0, $bFzGY.useAnalyticsEvents), useOverflowStatus: useOverflowStatus = (0, $cTgSO.useOverflowStatus), useTopMenus: useTopMenus = (0, $3BTZc.useTopMenus) } = {})=>{
    const [, { off: closeMenu }] = useTopMenus();
    const { isVisible: isVisible, closeOverflowMenu: closeOverflowMenu } = useOverflowStatus();
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const { actionSubjectId: actionSubjectId, ...analyticsRest } = analytics;
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationMenuItem'
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fireUIAnalytics(analyticsEvent, actionSubjectId, {
            ...analyticsRest,
            isInMore: !isVisible
        });
        onClick && onClick(event);
        if (event.ctrlKey || event.metaKey) return;
        closeMenu();
        closeOverflowMenu();
    };
};

});


parcelRegister("cwU5v", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $7726c7f125be07c7$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "MenuListItem", () => $7726c7f125be07c7$export$6c2f3257abc4825b);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $7726c7f125be07c7$export$d4c4e98c5044dc8 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "ul",
        xcss: $7726c7f125be07c7$var$removeDefaultListStyles
    }, children);
const $7726c7f125be07c7$export$6c2f3257abc4825b = ({ children: children, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li",
        xcss: $7726c7f125be07c7$var$removeDefaultListStyles,
        "aria-label": ariaLabel
    }, children);
const $7726c7f125be07c7$var$removeDefaultListStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});

});

parcelRegister("1hAca", function(module, exports) {

$parcel$export(module.exports, "PRIMARY_COLOR", () => $f11ce92e0c74be40$export$22791ddad13a5e06);

const $f11ce92e0c74be40$export$22791ddad13a5e06 = `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N500})`;

});

parcelRegister("4nIB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5811630ca9af61$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ $ce5811630ca9af61$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    yourAppsText: {
        "id": "atlassian-navigation.addons.menu.personalised-apps-experiment-enriched-content.personalised-apps-experiment-content.explore-marketplace-text",
        "defaultMessage": "Your apps"
    } /* eslint-enable jira/i18n/id-named-by-package */ 
});

});



parcelRegister("3n1gg", function(module, exports) {

$parcel$export(module.exports, "DiscoverSection", () => $85821c8cc2aca445$export$9fd357037d956606);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cTgSO = parcelRequire("cTgSO");

var $5wpwq = parcelRequire("5wpwq");
var $bo4OB = parcelRequire("bo4OB");
var $8BKky = parcelRequire("8BKky");

var $5VB9J = parcelRequire("5VB9J");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3BTZc = parcelRequire("3BTZc");

var $3rqlh = parcelRequire("3rqlh");

var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $1R3n5 = parcelRequire("1R3n5");

var $cwU5v = parcelRequire("cwU5v");

var $k3wBg = parcelRequire("k3wBg");

var $bNfZA = parcelRequire("bNfZA");
const $85821c8cc2aca445$var$IntegrationLink = ({ url: url, label: label, icon: icon, actionSubjectId: actionSubjectId, onClick: onClick, recommendationType: recommendationType = (0, $bNfZA.RECOMMENDATION_TYPE).Personalised })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { off: closeMenu }] = (0, $3BTZc.useTopMenus)();
    const { closeOverflowMenu: closeOverflowMenu } = (0, $cTgSO.useOverflowStatus)();
    const onLinkClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'navigationMenuItem clicked', actionSubjectId);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'navigationMenuItem clicked', `${recommendationType}AppRecommendedItem`, {
            appName: actionSubjectId
        });
        if (onClick) onClick();
        closeMenu();
        closeOverflowMenu();
    }, [
        actionSubjectId,
        closeMenu,
        closeOverflowMenu,
        createAnalyticsEvent,
        onClick,
        recommendationType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            src: icon,
            width: "24",
            height: "24",
            alt: `${actionSubjectId} logo`
        }),
        href: url,
        target: "_blank",
        onClick: onLinkClick
    }, label);
};
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $85821c8cc2aca445$var$suspensePromise = new Promise(()=>{});
const $85821c8cc2aca445$export$9fd357037d956606 = ({ apps: apps = [], isLoadingApps: isLoadingApps, title: title, description: description, recommendationType: recommendationType, setIsAppsMenuFinishedRendering: setIsAppsMenuFinishedRendering, isFedrampEnvironment: isFedrampEnvironment })=>{
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ items: items }] = (0, $5VB9J.useAddon)();
    const [{ fetchError: fetchIntegrationsError }] = (0, $k3wBg.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isLoadingApps) setIsAppsMenuFinishedRendering(true);
    }, [
        isLoadingApps,
        setIsAppsMenuFinishedRendering
    ]);
    if (isFedrampEnvironment) return null;
    if (fetchIntegrationsError) throw fetchIntegrationsError;
    if (isLoadingApps) throw $85821c8cc2aca445$var$suspensePromise;
    return apps.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: (0, $3rqlh.getUsersApps)(items).length > 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), null, formatMessage(title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85821c8cc2aca445$var$TextWrapper, null, formatMessage(description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, apps.map((props)=>{
        const { url: url } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
            key: url,
            ariaLabel: formatMessage(title)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($85821c8cc2aca445$var$IntegrationLink, {
            ...props,
            recommendationType: recommendationType
        }));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            availableProducts: apps.map(({ actionSubjectId: actionSubjectId })=>actionSubjectId),
            recommendationType: recommendationType,
            isSiteAdmin: isSiteAdmin
        }
    })) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $85821c8cc2aca445$var$TextWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _1yt467l7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1ule _p12f1178",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bNfZA", function(module, exports) {

$parcel$export(module.exports, "SLACK", () => $576addeeea7b0c5e$export$f1d97c73367642d8);
$parcel$export(module.exports, "DEFAULT_TEAM_RECOMMENDED_APPS", () => $576addeeea7b0c5e$export$32b6e4b8e076046);
$parcel$export(module.exports, "IT_SUPPORT_TEAM_RECOMMENDED_APPS", () => $576addeeea7b0c5e$export$9d9f02da5e5767a2);
$parcel$export(module.exports, "SOFTWARE_DEVELOPMENT_TEAM_RECOMMENDED_APPS", () => $576addeeea7b0c5e$export$d80cc7a4899acce7);
$parcel$export(module.exports, "INTEGRATIONS", () => $576addeeea7b0c5e$export$d49fe9e32eb9b9c3);
$parcel$export(module.exports, "RECOMMENDATION_TYPE", () => $576addeeea7b0c5e$export$a94606af1cdee48d);

var $3DCZN = parcelRequire("3DCZN");

var $hNm0w = parcelRequire("hNm0w");

var $4liNK = parcelRequire("4liNK");

var $lVpqG = parcelRequire("lVpqG");

var $ahuxB = parcelRequire("ahuxB");

var $cAZsm = parcelRequire("cAZsm");

var $drfRw = parcelRequire("drfRw");

var $7oOUa = parcelRequire("7oOUa");

var $ca9IK = parcelRequire("ca9IK");

var $e2E0k = parcelRequire("e2E0k");

var $ahIhJ = parcelRequire("ahIhJ");

var $gTCqa = parcelRequire("gTCqa");

var $1Bgy7 = parcelRequire("1Bgy7");

var $iQWdL = parcelRequire("iQWdL");

var $a2vyx = parcelRequire("a2vyx");
const $576addeeea7b0c5e$export$d0c29e989f831684 = 'com.conelike.amfj';
const $576addeeea7b0c5e$export$5e14c7e50550cd77 = 'nl.avisi.jira.plugins.relations-for-jira';
const $576addeeea7b0c5e$export$b41c48f703d0e7eb = 'eu.softwareplant.bigpicture';
const $576addeeea7b0c5e$export$afaf7eb5c500a159 = 'circleci.jira';
const $576addeeea7b0c5e$export$16b14b2256d05dae = 'com.eazybi.jira.plugins.eazybi-jira';
const $576addeeea7b0c5e$export$2d77d9815f2033f5 = 'com.kretar.jira.plugin.user-story-map';
const $576addeeea7b0c5e$export$8326c171e7f444a5 = 'com.riadalabs.jira.plugins.insight-discovery';
const $576addeeea7b0c5e$export$91fa8f2d7e3174cc = 'com.figma.jira-add-on';
const $576addeeea7b0c5e$export$fa619866d542058f = 'msteams-jira';
const $576addeeea7b0c5e$export$40d79efb385eb328 = 'com.alphaserve.powerbi-connector-jira';
const $576addeeea7b0c5e$export$f1d97c73367642d8 = 'com.atlassian.jira.slack';
const $576addeeea7b0c5e$export$3820a933e9f984fc = 'com.tda.timesheet.report';
const $576addeeea7b0c5e$export$658d35071b0831ac = 'zendesk_for_jira';
const $576addeeea7b0c5e$export$6513ebd8de81755b = 'com.thed.zephyr.je';
const $576addeeea7b0c5e$export$b7f71f0aad4dd9c9 = 'com.xpandit.plugins.xray';
const $576addeeea7b0c5e$export$32b6e4b8e076046 = [
    $576addeeea7b0c5e$export$f1d97c73367642d8,
    $576addeeea7b0c5e$export$fa619866d542058f,
    $576addeeea7b0c5e$export$16b14b2256d05dae,
    $576addeeea7b0c5e$export$40d79efb385eb328,
    $576addeeea7b0c5e$export$b41c48f703d0e7eb,
    $576addeeea7b0c5e$export$2d77d9815f2033f5,
    $576addeeea7b0c5e$export$5e14c7e50550cd77
];
const $576addeeea7b0c5e$export$9d9f02da5e5767a2 = [
    $576addeeea7b0c5e$export$f1d97c73367642d8,
    $576addeeea7b0c5e$export$fa619866d542058f,
    $576addeeea7b0c5e$export$658d35071b0831ac,
    $576addeeea7b0c5e$export$d0c29e989f831684,
    $576addeeea7b0c5e$export$8326c171e7f444a5
];
const $576addeeea7b0c5e$export$d80cc7a4899acce7 = [
    $576addeeea7b0c5e$export$f1d97c73367642d8,
    $576addeeea7b0c5e$export$fa619866d542058f,
    $576addeeea7b0c5e$export$afaf7eb5c500a159,
    $576addeeea7b0c5e$export$3820a933e9f984fc,
    $576addeeea7b0c5e$export$6513ebd8de81755b,
    $576addeeea7b0c5e$export$b7f71f0aad4dd9c9,
    $576addeeea7b0c5e$export$91fa8f2d7e3174cc
];
const $576addeeea7b0c5e$export$3bc9b5daa48b1848 = (key)=>(query)=>`/jira/marketplace/discover/app/${key}${query ? `?${query}` : ''}`;
const $576addeeea7b0c5e$export$d49fe9e32eb9b9c3 = [
    {
        key: $576addeeea7b0c5e$export$f1d97c73367642d8,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$f1d97c73367642d8),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ahIhJ))),
        label: 'Slack',
        actionSubjectId: 'slackForAtlassianApp'
    },
    {
        key: $576addeeea7b0c5e$export$fa619866d542058f,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$fa619866d542058f),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ca9IK))),
        label: 'Microsoft Teams',
        actionSubjectId: 'microsoftTeams'
    },
    {
        key: $576addeeea7b0c5e$export$91fa8f2d7e3174cc,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$91fa8f2d7e3174cc),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($drfRw))),
        label: 'Figma',
        actionSubjectId: 'figmaApp',
        categoryMessageKey: 'categoryDesign'
    },
    {
        key: $576addeeea7b0c5e$export$afaf7eb5c500a159,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$afaf7eb5c500a159),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lVpqG))),
        label: 'Circle CI',
        actionSubjectId: 'circleCI',
        categoryMessageKey: 'categoryCicd'
    },
    {
        key: $576addeeea7b0c5e$export$b7f71f0aad4dd9c9,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$b7f71f0aad4dd9c9),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Bgy7))),
        label: 'Xray',
        actionSubjectId: 'xray',
        categoryMessageKey: 'categoryTesting'
    },
    {
        key: $576addeeea7b0c5e$export$6513ebd8de81755b,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$6513ebd8de81755b),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a2vyx))),
        label: 'Zephyr Squad',
        actionSubjectId: 'zephyrSquad',
        categoryMessageKey: 'categoryTesting'
    },
    {
        key: $576addeeea7b0c5e$export$3820a933e9f984fc,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$3820a933e9f984fc),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gTCqa))),
        label: 'Timesheet tracking',
        actionSubjectId: 'timesheetTracking'
    },
    {
        key: $576addeeea7b0c5e$export$658d35071b0831ac,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$658d35071b0831ac),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iQWdL))),
        label: 'Zendesk',
        actionSubjectId: 'zendesk',
        categoryMessageKey: 'categorySupport'
    },
    {
        key: $576addeeea7b0c5e$export$d0c29e989f831684,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$d0c29e989f831684),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3DCZN))),
        label: 'Asset Management',
        actionSubjectId: 'assetManagement',
        categoryMessageKey: 'categoryAssetTracking'
    },
    {
        key: $576addeeea7b0c5e$export$8326c171e7f444a5,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$8326c171e7f444a5),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7oOUa))),
        label: 'Insight Discovery',
        actionSubjectId: 'insightDiscovery',
        categoryMessageKey: 'categoryAssetTracking'
    },
    {
        key: $576addeeea7b0c5e$export$16b14b2256d05dae,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$16b14b2256d05dae),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cAZsm))),
        label: 'eazyBI',
        actionSubjectId: 'eazyBI',
        categoryMessageKey: 'categoryAnalytics'
    },
    {
        key: $576addeeea7b0c5e$export$40d79efb385eb328,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$40d79efb385eb328),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e2E0k))),
        label: 'Power BI',
        actionSubjectId: 'powerBI',
        categoryMessageKey: 'categoryAnalytics'
    },
    {
        key: $576addeeea7b0c5e$export$b41c48f703d0e7eb,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$b41c48f703d0e7eb),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4liNK))),
        label: 'BigPicture',
        actionSubjectId: 'bigPicture',
        categoryMessageKey: 'categoryProjectManagement'
    },
    {
        key: $576addeeea7b0c5e$export$2d77d9815f2033f5,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$2d77d9815f2033f5),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ahuxB))),
        label: 'Easy Agile TeamRhythm',
        actionSubjectId: 'easyAgile'
    },
    {
        key: $576addeeea7b0c5e$export$5e14c7e50550cd77,
        getUrl: $576addeeea7b0c5e$export$3bc9b5daa48b1848($576addeeea7b0c5e$export$5e14c7e50550cd77),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hNm0w))),
        label: 'Atlas CRM',
        actionSubjectId: 'atlasCMR',
        categoryMessageKey: 'categoryProjectManagement'
    }
];
const $576addeeea7b0c5e$export$a94606af1cdee48d = {
    Personalised: 'personalised'
};

});
parcelRegister("3DCZN", function(module, exports) {
module.exports = new URL("assetManagement.2437db0d.png", import.meta.url).toString();

});

parcelRegister("hNm0w", function(module, exports) {
module.exports = new URL("atlasCMR.1b2080b0.png", import.meta.url).toString();

});

parcelRegister("4liNK", function(module, exports) {
module.exports = new URL("bigPicture.bdf23130.png", import.meta.url).toString();

});

parcelRegister("lVpqG", function(module, exports) {
module.exports = new URL("circleCI.a4fabf69.png", import.meta.url).toString();

});

parcelRegister("ahuxB", function(module, exports) {
module.exports = new URL("easyAgile.6a075018.png", import.meta.url).toString();

});

parcelRegister("cAZsm", function(module, exports) {
module.exports = new URL("eazyBI.224ed97d.png", import.meta.url).toString();

});

parcelRegister("drfRw", function(module, exports) {
module.exports = new URL("figma.4fcb09e3.png", import.meta.url).toString();

});

parcelRegister("7oOUa", function(module, exports) {
module.exports = new URL("insightDiscovery.9e6dd8c2.png", import.meta.url).toString();

});

parcelRegister("ca9IK", function(module, exports) {
module.exports = new URL("microsoftTeams.9706d9b4.png", import.meta.url).toString();

});

parcelRegister("e2E0k", function(module, exports) {
module.exports = new URL("powerBI.6fbcc628.png", import.meta.url).toString();

});

parcelRegister("ahIhJ", function(module, exports) {
module.exports = new URL("slack.b2145b58.png", import.meta.url).toString();

});

parcelRegister("gTCqa", function(module, exports) {
module.exports = new URL("timesheet.e35a9455.png", import.meta.url).toString();

});

parcelRegister("1Bgy7", function(module, exports) {
module.exports = new URL("xray.4a45f47c.png", import.meta.url).toString();

});

parcelRegister("iQWdL", function(module, exports) {
module.exports = new URL("zendesk.57b918fc.png", import.meta.url).toString();

});

parcelRegister("a2vyx", function(module, exports) {
module.exports = new URL("zephyrSquad.8de8b15e.png", import.meta.url).toString();

});



parcelRegister("5ZY4v", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24f3a9c4643b405$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ $c24f3a9c4643b405$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    popularApps: {
        "id": "atlassian-navigation.addons.menu.discover-section.popular-apps",
        "defaultMessage": "Popular apps"
    },
    personalisedAppsTitle: {
        "id": "atlassian-navigation.addons.menu.personalised-apps-experiment-enriched-discover.personalised-apps-experiment-discover-section.recommended-apps-title",
        "defaultMessage": "Recommended for your team"
    },
    personalisedAppsText: {
        "id": "atlassian-navigation.addons.menu.personalised-apps-experiment-enriched-discover.personalised-apps-experiment-discover-section.recommended-apps-text",
        "defaultMessage": "Ship faster with marketplace apps that integrate your team\u2019s tools with Jira."
    } /* eslint-enable jira/i18n/id-named-by-package */ ,
    categoryCicd: {
        "id": "atlassian-navigation.addons.menu.discover-section.category-cicd",
        "defaultMessage": "CI/CD"
    },
    categoryDesign: {
        "id": "atlassian-navigation.addons.menu.discover-section.category-design",
        "defaultMessage": "Design"
    },
    categoryTesting: {
        "id": "atlassian-navigation.addons.menu.discover-section.category-testing",
        "defaultMessage": "Testing"
    },
    categoryAssetTracking: {
        "id": "atlassian-navigation.addons.menu.discover-section.category-asset-tracking",
        "defaultMessage": "Asset Tracking"
    },
    categoryAnalytics: {
        "id": "atlassian-navigation.addons.menu.discover-section.category-analytics",
        "defaultMessage": "Analytics"
    },
    categoryProjectManagement: {
        "id": "atlassian-navigation.addons.menu.discover-section.category-project-management",
        "defaultMessage": "Project Management"
    },
    categorySupport: {
        "id": "atlassian-navigation.addons.menu.discover-section.category-support",
        "defaultMessage": "Support"
    }
});

});

parcelRegister("c0qa0", function(module, exports) {

$parcel$export(module.exports, "getTeamAlignedAppList", () => $a3f69ed77d68866c$export$5dbb471c868520b6);

var $75NPy = parcelRequire("75NPy");

var $bNfZA = parcelRequire("bNfZA");
const $a3f69ed77d68866c$var$filterRecommendedIntegrations = (applicableList)=>(0, $bNfZA.INTEGRATIONS).filter((int)=>applicableList.includes(int.key));
const $a3f69ed77d68866c$export$5dbb471c868520b6 = (teamType)=>{
    switch(teamType){
        case (0, $75NPy.PERSONALISED_APPS_TEAM_TYPES).softwareDevelopment:
            // @ts-expect-error - TS2345 - Argument of type 'readonly ["com.atlassian.jira.slack", "msteams-jira", "circleci.jira", "com.tda.timesheet.report", "com.thed.zephyr.je", "com.xpandit.plugins.xray", "com.figma.jira-add-on"]' is not assignable to parameter of type 'string[]'.
            return $a3f69ed77d68866c$var$filterRecommendedIntegrations((0, $bNfZA.SOFTWARE_DEVELOPMENT_TEAM_RECOMMENDED_APPS));
        case (0, $75NPy.PERSONALISED_APPS_TEAM_TYPES).itSupport:
            // @ts-expect-error - TS2345 - Argument of type 'readonly ["com.atlassian.jira.slack", "msteams-jira", "zendesk_for_jira", "com.conelike.amfj", "com.riadalabs.jira.plugins.insight-discovery"]' is not assignable to parameter of type 'string[]'.
            return $a3f69ed77d68866c$var$filterRecommendedIntegrations((0, $bNfZA.IT_SUPPORT_TEAM_RECOMMENDED_APPS));
        default:
            // @ts-expect-error - TS2345 - Argument of type 'readonly ["com.atlassian.jira.slack", "msteams-jira", "com.eazybi.jira.plugins.eazybi-jira", "com.alphaserve.powerbi-connector-jira", "eu.softwareplant.bigpicture", "com.kretar.jira.plugin.user-story-map", "nl.avisi.jira.plugins.relations-for-jira"]' is not assignable to parameter of type 'string[]'.
            return $a3f69ed77d68866c$var$filterRecommendedIntegrations((0, $bNfZA.DEFAULT_TEAM_RECOMMENDED_APPS));
    }
};

});

parcelRegister("8CUCV", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $32cad9571af704b6$export$a06f1c675e846f6f);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $5VB9J = parcelRequire("5VB9J");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7vTKl = parcelRequire("7vTKl");

var $1YbJP = parcelRequire("1YbJP");

var $jxzG5 = parcelRequire("jxzG5");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $bKRo5 = parcelRequire("bKRo5");

var $6ighq = parcelRequire("6ighq");

var $gd0Sp = parcelRequire("gd0Sp");

var $OBq1v = parcelRequire("OBq1v");

var $gJfnZ = parcelRequire("gJfnZ");
const $32cad9571af704b6$var$emceeAppRequestsParams = {
    page: 'app-requests'
};
const $32cad9571af704b6$var$emceeAppPromotionsParams = {
    page: 'promotions'
};
const $32cad9571af704b6$export$a06f1c675e846f6f = ({ onUpdateIsFooterVisible: onUpdateIsFooterVisible, testIdPrefix: testIdPrefix, isFedrampEnvironment: isFedrampEnvironment })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = tenantContext;
    const [{ promise: promise, hasFetchedOnce: hasFetchedOnce, items: items }] = (0, $5VB9J.useAddon)();
    // Do not show Footer menu if in FedRamp environemnt
    if (isFedrampEnvironment) return null;
    if (promise && !hasFetchedOnce) throw promise;
    const { url: findAppsUrl } = items.find((item)=>item.id === (0, $7vTKl.ADDON_ID).DISCOVER) || {};
    let position = 0;
    if (!findAppsUrl && !isAdmin && !isSiteAdmin) onUpdateIsFooterVisible && onUpdateIsFooterVisible(false);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'appsNavigationMenuItem',
            isAdmin: Boolean(isSiteAdmin),
            menuItemId: 'newApps',
            menuItemType: 'action',
            position: position++
        },
        href: "/jira/marketplace/discover?source=apps-menu",
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-explore-new-apps')
    }, formatMessage((0, $gJfnZ.default).exploreApps)), (isAdmin || isSiteAdmin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'appsNavigationMenuItem',
            isAdmin: isSiteAdmin,
            menuItemId: 'manageApps',
            menuItemType: 'action',
            position: position++
        },
        href: "/plugins/servlet/upm",
        iconAfter: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $eI5EY.fg)('enable-app-update-lozenge') && tenantContext?.appUpdatesAvailable && tenantContext.appUpdatesAvailable > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, `${tenantContext.appUpdatesAvailable > 9 ? '9+' : tenantContext.appUpdatesAvailable} ${formatMessage((0, $gJfnZ.default).appUpdates, {
            apps: tenantContext.appUpdatesAvailable
        })}`) : null,
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-manage-apps'),
        to: (0, $bKRo5.manageAppsRoute)
    }, formatMessage((0, $gJfnZ.default).manageApps)), (0, $1ybV0.ff)('enduser-emcee-discover') && isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'appsNavigationMenuItem',
            isAdmin: isSiteAdmin,
            menuItemId: 'appRequests',
            menuItemType: 'action',
            position: position++
        },
        href: (0, $jxzG5.getAppRequestsLink)(),
        params: $32cad9571af704b6$var$emceeAppRequestsParams,
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-app-requests'),
        to: (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? (0, $6ighq.appRequestRoute) : (0, $bKRo5.emceeAppRoute)
    }, formatMessage((0, $gJfnZ.default).appRequests)), (0, $1ybV0.ff)('enable-app-promotions-emcee-apps-dropdown') && isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'appsNavigationMenuItem',
            isAdmin: isSiteAdmin,
            menuItemId: 'appPromotions',
            menuItemType: 'action',
            position: position++
        },
        href: (0, $jxzG5.getManagePromotionsLink)(),
        params: $32cad9571af704b6$var$emceeAppPromotionsParams,
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-app-promotions'),
        to: (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? (0, $6ighq.promotionsRoute) : (0, $bKRo5.emceeAppRoute)
    }, formatMessage((0, $gJfnZ.default).appPromotions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "appsMenuFooterSection",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};

});
parcelRegister("jxzG5", function(module, exports) {

$parcel$export(module.exports, "getEmceeDiscoverLink", () => $20f94d12e4a0a9d7$export$f26dabf284aefb17);
$parcel$export(module.exports, "getEmceeAppListingLink", () => $20f94d12e4a0a9d7$export$eb09695b9e9f6a3);
$parcel$export(module.exports, "getAppRequestsLink", () => $20f94d12e4a0a9d7$export$7ab8c48f9081e976);
$parcel$export(module.exports, "getManagePromotionsLink", () => $20f94d12e4a0a9d7$export$350ca33eed6a2742);

var $1ybV0 = parcelRequire("1ybV0");
const $20f94d12e4a0a9d7$var$sanitiseParams = (params)=>params ? Object.entries(params).reduce((res, [key, value])=>{
        if (value) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'EmceeQueryParams | JiraQueryParams'.
        res[key] = params[key];
        return res;
    }, {}) : {};
const $20f94d12e4a0a9d7$var$addQueryParamsToLink = (params, link)=>{
    // @ts-expect-error - TS2345 - Argument of type 'EmceeQueryParams | JiraQueryParams | null | undefined' is not assignable to parameter of type 'EmceeQueryParams | JiraQueryParams | undefined'.
    const queryParams = $20f94d12e4a0a9d7$var$sanitiseParams(params);
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${link}?${queryString}` : link;
};
const $20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl = (connectUrlDiscoverVariant = 'ENDUSER_DISCOVER', jiraQueryParams)=>{
    let connectDiscoverUrl = `/plugins/servlet/ac/com.atlassian.jira.emcee/${connectUrlDiscoverVariant === 'DISCOVER' ? 'discover' : 'enduser-discover'}`;
    if (jiraQueryParams) connectDiscoverUrl = $20f94d12e4a0a9d7$var$addQueryParamsToLink(jiraQueryParams, connectDiscoverUrl);
    return connectDiscoverUrl;
};
const $20f94d12e4a0a9d7$export$f26dabf284aefb17 = (params, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/discover' : $20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant);
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};
const $20f94d12e4a0a9d7$export$eb09695b9e9f6a3 = (appKey, params, jiraQueryParams, connectUrlDiscoverVariant = 'ENDUSER_DISCOVER')=>(0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? $20f94d12e4a0a9d7$var$addQueryParamsToLink({
        ...jiraQueryParams,
        ...params
    }, `/jira/marketplace/discover/app/${appKey}`) : $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, `${$20f94d12e4a0a9d7$var$resolveConnectDiscoverUrl(connectUrlDiscoverVariant, // @ts-expect-error - TS2345 - Argument of type 'JiraQueryParams | null | undefined' is not assignable to parameter of type 'JiraQueryParams | undefined'.
    jiraQueryParams)}#!/discover/app/${appKey}`);
const $20f94d12e4a0a9d7$export$7ab8c48f9081e976 = (params)=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/app-requests' : '/plugins/servlet/ac/com.atlassian.jira.emcee/app-requests';
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};
const $20f94d12e4a0a9d7$export$350ca33eed6a2742 = (params)=>{
    const link = (0, $1ybV0.ff)('marketplace.emcee.native.spa.enable') ? '/jira/marketplace/manage/promotions' : '/plugins/servlet/ac/com.atlassian.jira.emcee/promotions';
    return $20f94d12e4a0a9d7$var$addQueryParamsToLink(params, link);
};

});

parcelRegister("bKRo5", function(module, exports) {

$parcel$export(module.exports, "emceeAppRoute", () => $d35d370905e3d2b9$export$5149e7851c6c4f53);
$parcel$export(module.exports, "manageAppsRoute", () => $d35d370905e3d2b9$export$d5409be3b4016aab);

var $exb0h = parcelRequire("exb0h");
const $d35d370905e3d2b9$export$5149e7851c6c4f53 = {
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE),
    path: '/plugins/servlet/ac/com.atlassian.jira.emcee:environment(.?[\\w.]*)?/:page'
};
const $d35d370905e3d2b9$export$d5409be3b4016aab = {
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_MANAGE_APPS),
    path: '/plugins/servlet/upm'
};

});

parcelRegister("6ighq", function(module, exports) {

$parcel$export(module.exports, "findAppsRoute", () => $756f1f926c86d910$export$e264ef643451c60a);
$parcel$export(module.exports, "appRequestRoute", () => $756f1f926c86d910$export$e5429b8cad3b4991);
$parcel$export(module.exports, "promotionsRoute", () => $756f1f926c86d910$export$45df65bfacbf9a2a);

var $exb0h = parcelRequire("exb0h");
const $756f1f926c86d910$export$e264ef643451c60a = {
    group: (0, $exb0h.ROUTE_GROUPS_MARKETPLACE),
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_INDEX),
    path: '/jira/marketplace'
};
const $756f1f926c86d910$export$e5429b8cad3b4991 = {
    group: (0, $exb0h.ROUTE_GROUPS_MARKETPLACE),
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_APP_REQUESTS),
    path: '/jira/marketplace/manage/app-requests'
};
const $756f1f926c86d910$export$45df65bfacbf9a2a = {
    group: (0, $exb0h.ROUTE_GROUPS_MARKETPLACE),
    name: (0, $exb0h.ROUTE_NAMES_MARKETPLACE_PROMOTIONS),
    path: '/jira/marketplace/manage/promotions'
};

});

parcelRegister("gJfnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5288fe77e7073769$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5288fe77e7073769$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    findApps: {
        "id": "atlassian-navigation.addons.menu.footer.find-apps",
        "defaultMessage": "Find new apps"
    },
    manageApps: {
        "id": "atlassian-navigation.addons.menu.footer.manage-apps",
        "defaultMessage": "Manage your apps"
    },
    appRequests: {
        "id": "atlassian-navigation.addons.menu.footer.app-requests",
        "defaultMessage": "View app requests"
    },
    appPromotions: {
        "id": "atlassian-navigation.addons.menu.footer.app-promotions",
        "defaultMessage": "Promotions"
    } /* eslint-disable jira/i18n/id-named-by-package */ ,
    exploreApps: {
        "id": "atlassian-navigation.addons.menu.personalised-apps-experiment-enriched-footer.personalised-apps-experiment-footer-section.recommended-explore-apps",
        "defaultMessage": "Explore more apps"
    } /* eslint-enable jira/i18n/id-named-by-package */ ,
    appUpdates: {
        "id": "atlassian-navigation.addons.menu.footer.app-updates",
        "defaultMessage": "{apps, plural, one {update} other {updates}}"
    }
});

});




parcelRegister("2xkfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $84db7d9ab966695a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $84db7d9ab966695a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    apps: {
        "id": "atlassian-navigation.addons.apps",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("9Z519", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $7fae4abccfff5911$export$9923361bd43fa030);

var $eUqFw = parcelRequire("eUqFw");

var $lC4HR = parcelRequire("lC4HR");

var $7vTKl = parcelRequire("7vTKl");

var $3BTZc = parcelRequire("3BTZc");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $gvn5f = parcelRequire("gvn5f");
const $7fae4abccfff5911$var$AppSwitcher = ({ AppSwitcherIntegration: AppSwitcherIntegration = (0, $lC4HR.AppSwitcher), useTopMenus: useTopMenus = (0, $3BTZc.useTopMenus), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $gvn5f.useNavigationItemAnalytics) })=>{
    const [isOpen, { on: openMenu, off: closeMenu }] = useTopMenus((0, $7vTKl.MENU_ID).APP_SWITCHER);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).APP_SWITCHER
    });
    const onOpen = (0, $eUqFw.useCallback)(()=>{
        openMenu();
        triggerAnalytics();
    }, [
        openMenu,
        triggerAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AppSwitcherIntegration, {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: closeMenu
    });
};
const $7fae4abccfff5911$export$9923361bd43fa030 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).APP_SWITCHER
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fae4abccfff5911$var$AppSwitcher, props));

});
parcelRegister("lC4HR", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $4f811455af10b19c$export$9923361bd43fa030);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $6zVSA = parcelRequire("6zVSA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4f811455af10b19c$var$LazyAppSwitcher = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("b62zq")).then((module)=>module.AppSwitcher), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation-switcher-integration/src/main.tsx"
});
const $4f811455af10b19c$export$9923361bd43fa030 = (props)=>{
    const handleMouseEnter = (0, $eUqFw.useCallback)(()=>{
        $4f811455af10b19c$var$LazyAppSwitcher.preload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "app-switcher.integration.async",
        packageName: "NavigationIntegrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy-app-switcher",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zVSA.AppSwitcherLight), null)
    }, props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f811455af10b19c$var$LazyAppSwitcher, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zVSA.AppSwitcherLight), {
        onOpen: props.onOpen,
        onMouseEnter: handleMouseEnter
    })));
};

});
parcelRegister("6zVSA", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherLight", () => $9a5962ab3553cd50$export$3787c612f09492c8);

var $eUqFw = parcelRequire("eUqFw");

var $eYynb = parcelRequire("eYynb");

var $6JrXy = parcelRequire("6JrXy");

var $6FP8W = parcelRequire("6FP8W");
const $9a5962ab3553cd50$export$3787c612f09492c8 = ({ onOpen: onOpen, onMouseEnter: onMouseEnter })=>{
    if (false) {
        if ((0, $6FP8W.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6JrXy.Nav4SkeletonSwitcherButton), {
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6JrXy.SkeletonSwitcherButton), {
            label: ""
        });
    }
    if ((0, $6FP8W.getWillShowNav4)()) // @ts-expect-error - TS2741 - Property 'tooltip' is missing in type '{ onClick: (() => void) | undefined; }' but required in type 'BaseIconButtonProps'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYynb.AppSwitcherNav4), {
        onClick: onOpen,
        onMouseEnter: onMouseEnter
    });
    // @ts-expect-error - TS2741 - Property 'tooltip' is missing in type '{ onClick: (() => void) | undefined; }' but required in type 'BaseIconButtonProps'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYynb.AppSwitcher), {
        onClick: onOpen,
        onMouseEnter: onMouseEnter
    });
};

});

parcelRegister("b62zq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("7DSUk")
]).then(()=>parcelRequire('c4rGD'));

});



parcelRegister("1jLSB", function(module, exports) {

$parcel$export(module.exports, "ConversationAssistant", () => $fa294db43f384b78$export$9777b121d71c4de1);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");

var $RA7i2 = parcelRequire("RA7i2");

var $itKco = parcelRequire("itKco");

var $aS5EA = parcelRequire("aS5EA");

var $gmooP = parcelRequire("gmooP");


var $bUi2Q = parcelRequire("bUi2Q");

var $3BTZc = parcelRequire("3BTZc");

var $6FP8W = parcelRequire("6FP8W");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $grsJA = parcelRequire("grsJA");

var $dWLk9 = parcelRequire("dWLk9");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");
const $fa294db43f384b78$var$ConversationAssistantButton = ()=>{
    const [_topMenusValue, { off: closeAllMenus }] = (0, $3BTZc.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $bUi2Q.useActiveRightSidebarState)() || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const isActive = panelId === (0, $d3227e938619716f$export$dffb4ed44e20ea9a) && !isCollapsed;
    const onButtonClickOld = (0, $eUqFw.useCallback)(()=>{
        if (isActive) {
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'navigationItem'
            }), 'aiMate', {
                opened: isCollapsed
            });
            closeCurrentRightSidebar();
        } else openRightSidebar((0, $d3227e938619716f$export$dffb4ed44e20ea9a), (0, $d3227e938619716f$export$64aee74ba59709e5), false, true);
        closeAllMenus();
    }, [
        closeAllMenus,
        closeCurrentRightSidebar,
        createAnalyticsEvent,
        isActive,
        isCollapsed,
        openRightSidebar
    ]);
    const onButtonClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'aiMate', {
            opened: !isActive
        });
        isActive ? closeCurrentRightSidebar() : openRightSidebar((0, $d3227e938619716f$export$dffb4ed44e20ea9a), (0, $d3227e938619716f$export$64aee74ba59709e5), false, true);
        closeAllMenus();
    }, [
        isActive,
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        createAnalyticsEvent
    ]);
    const buttonRender = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        paddingInlineStart: (0, $6FP8W.getWillShowNav4)() ? undefined : 'space.050',
        testId: "atlassian-navigation.ui.conversation-assistant.app-navigation-ai-mate",
        role: // This element is a direct descendant of the top nav actions list, so needs the listitem role.
        // While the button is internally wrapped in a listitem, screen readers do not pick this up due to multiple wrapper elements.
        (0, $6FP8W.getWillShowNav4)() ? 'listitem' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmooP.ConversationAssistantButton), {
        onClick: (0, $6FP8W.getWillShowNav4)() ? onButtonClick : onButtonClickOld,
        isActive: isActive,
        siteId: cloudId,
        productKey: "jira"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aS5EA.ChatContextSubscriber), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RA7i2.ChatOpenerSubscriber), {
        onTriggerOpeningChat: ()=>{
            if (!isActive) openRightSidebar((0, $d3227e938619716f$export$dffb4ed44e20ea9a), (0, $d3227e938619716f$export$64aee74ba59709e5), false, true);
        }
    }));
};
const $fa294db43f384b78$export$9777b121d71c4de1 = ()=>{
    const { data: data } = (0, $grsJA.useRovoEntitlementResource)();
    const shouldShowConversationAssistantButton = data?.isRovoEnabled ?? false;
    const buttonRender = shouldShowConversationAssistantButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fa294db43f384b78$var$ConversationAssistantButton, null) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $5kDtB.NAVIGATION_ITEM_ID).CONVERSATION_ASSISTANT
    }, buttonRender, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $itKco.RovoEntitlementSetter), {
        isRovoEnabled: shouldShowConversationAssistantButton
    }));
};

});
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $d3227e938619716f$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $d3227e938619716f$export$64aee74ba59709e5 = 439; // px
const $d3227e938619716f$export$1c07393c5bb1bc27 = 439; // px
const $d3227e938619716f$export$aa3478deee7adbeb = 350; // px
const $d3227e938619716f$export$21e515a86cd1733b = 'Chat';


parcelRegister("5JiCQ", function(module, exports) {

$parcel$export(module.exports, "Create", () => $1ef8d7125c1ba47e$export$8ade6fcbf3a7de5d);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $bvJ6X = parcelRequire("bvJ6X");

var $kAq8l = parcelRequire("kAq8l");


var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $98Kfy = parcelRequire("98Kfy");

var $1YbJP = parcelRequire("1YbJP");

var $1MRnf = parcelRequire("1MRnf");

var $ctR9z = parcelRequire("ctR9z");

var $ellXt = parcelRequire("ellXt");

var $la1Rb = parcelRequire("la1Rb");

var $6yplV = parcelRequire("6yplV");

var $lB25E = parcelRequire("lB25E");

var $5kDtB = parcelRequire("5kDtB");

var $6WbCX = parcelRequire("6WbCX");

var $grCEQ = parcelRequire("grCEQ");

var $gvn5f = parcelRequire("gvn5f");

var $7DoMb = parcelRequire("7DoMb");

var $bNeIj = parcelRequire("bNeIj");

var $iWROx = parcelRequire("iWROx");
const $1ef8d7125c1ba47e$var$testId = (0, $1YbJP.testIdGenerate)('create');
const $1ef8d7125c1ba47e$var$noop = ()=>undefined;
const $1ef8d7125c1ba47e$var$Create = ({ AkCreate: AkCreate = (0, $6WbCX.Create), NudgeTooltip: NudgeTooltip = (0, $la1Rb.NavigationCreateIssueButtonWrapperNudgeAsync), onCreateClick: onCreateClick = (0, $bvJ6X.default), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $gvn5f.useNavigationItemAnalytics), useIsInitialLoadLegacyIssueCreate: // @ts-expect-error - TS2339 - Property 'useIsInitialLoadLegacyIssueCreate' does not exist on type 'CreateProps'.
useIsInitialLoadLegacyIssueCreate = (0, $kAq8l.useIsInitialLoadLegacyIssueCreate) })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    (0, $98Kfy.useInitializePersistentIssueCreateModalView)();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).CREATE
    });
    const [{ isInitialLoad: isInitialLoad }, actions] = useIsInitialLoadLegacyIssueCreate();
    let currentIssueCreateVisibility = null;
    const gicOptInStateOverridden = (0, $eUqFw.useRef)(false);
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    if ((0, $1ybV0.ff)('project.config.pce.modern.global-issue-create')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data, update: update } = (0, $lB25E.useResource)((0, $ellXt.gicOptInStatusResources));
        if (isAnonymous && !gicOptInStateOverridden.current) {
            update(()=>({
                    gicOptInStatus: {
                        isEnabled: true
                    }
                }));
            gicOptInStateOverridden.current = true;
        }
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const onClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        if ((0, $1ybV0.ff)('project.config.pce.modern.global-issue-create')) {
            if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) {
                    (0, $7DoMb.GlobalIssueCreateFromTopNav).abort({
                        force: true
                    });
                    (0, $7DoMb.GlobalIssueCreateFromTopNav).start();
                    (0, $7DoMb.GlobalIssueCreateFromTopNav).addMetadata({
                        inputDelay: Math.round(performance.now() - e.timeStamp)
                    });
                    const nextState = {
                        disableCreationSuccessFlag: (0, $iWROx.shouldDisableGICFlagCreation)(),
                        triggerPointKey: (0, $1MRnf.GENERIC_GLOBAL_CREATE_BUTTON)
                    };
                    openIssueCreateModal(nextState);
                } else {
                    onCreateClick({
                        isInitialLoad: isInitialLoad,
                        triggerSource: (0, $491012546836012a$export$d983e94cf86f65d)
                    });
                    if (isInitialLoad) actions.clearInitialLoaded();
                }
            } else (0, $gUUjF.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            onCreateClick({
                isInitialLoad: isInitialLoad,
                triggerSource: (0, $491012546836012a$export$d983e94cf86f65d)
            });
            if (isInitialLoad) actions.clearInitialLoaded();
        }
        triggerAnalytics();
    }, [
        actions,
        currentIssueCreateVisibility,
        isInitialLoad,
        onCreateClick,
        openIssueCreateModal,
        triggerAnalytics
    ]);
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AkCreate, {
        onClick: onClick,
        text: formatMessage((0, $bNeIj.default).create),
        testId: $1ef8d7125c1ba47e$var$testId,
        label: formatMessage((0, $bNeIj.default).createButtonAriaLabel)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AkCreate, {
        onClick: $1ef8d7125c1ba47e$var$noop,
        text: formatMessage((0, $bNeIj.default).create),
        testId: $1ef8d7125c1ba47e$var$testId,
        label: formatMessage((0, $bNeIj.default).createButtonAriaLabel)
    });
};
const $1ef8d7125c1ba47e$export$8ade6fcbf3a7de5d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $5kDtB.NAVIGATION_ITEM_ID).CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ef8d7125c1ba47e$var$Create, props));

});
parcelRegister("bvJ6X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a8d85aebfa17569$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");

var $1ybV0 = parcelRequire("1ybV0");

var $1Ph9z = parcelRequire("1Ph9z");

var $8m3xX = parcelRequire("8m3xX");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3a8d85aebfa17569$export$2e2bcd8739ae039 = ({ timeout: timeout, tentatives: tentatives, isInitialLoad: // isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
isInitialLoad, triggerSource: triggerSource, showModern: showModern } = {})=>{
    (0, $8m3xX.sendStartMarkForLegacyIssueCreate)({
        isInitialLoad: isInitialLoad,
        triggerSource: triggerSource
    });
    (0, $1Ph9z.initForgeBridge)();
    // eslint-disable-next-line jira/wrm/no-load-bridge
    return (0, $2BvS3.loadBridge)({
        name: 'quick-edit/init/create-dialogs',
        wrmKeys: [
            'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs'
        ],
        timeout: timeout,
        tentatives: tentatives
    }).then((api)=>{
        if ((0, $1ybV0.ff)('project.config.pce.modern.global-issue-create.trigger')) {
            if (showModern === true) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.hideLoadingIndicator(false);
            else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            api.showCreateDialog({
                showModern: showModern
            });
        } else // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        api.showCreateDialog({});
        (0, $8m3xX.sendEndMarkForLegacyIssueCreate)({
            isInitialLoad: isInitialLoad
        });
    });
};

});
parcelRegister("1Ph9z", function(module, exports) {

$parcel$export(module.exports, "initForgeBridge", () => $0c9c0b19b2b0ff3b$export$8e110dda7ad69e5a);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");

var $e91YZ = parcelRequire("e91YZ");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $2Rqjr = parcelRequire("2Rqjr");

var $hsX10 = parcelRequire("hsX10");

var $cSfWg = parcelRequire("cSfWg");

var $2jpBk = parcelRequire("2jpBk");
const $0c9c0b19b2b0ff3b$var$loadModulesV1 = async (dataClassification = null)=>{
    const { cloudId: cloudId, activationId: activationId, locale: locale } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const modulesToFetch = [
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE),
        (0, $2Rqjr.WORKFLOW_CONDITION_MODULE),
        (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE)
    ];
    const contextIds = (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x') ? [
        `ari:cloud:jira:${cloudId}:workspace/${activationId}`
    ] : undefined;
    const { extensions: extensions } = await (0, $hsX10.default)(cloudId, modulesToFetch, dataClassification, undefined, (0, $2Rqjr.SOURCE_LEGACY), contextIds, locale);
    const customFields = extensions.jiraCustomField;
    const customFieldTypes = extensions.jiraCustomFieldType;
    const workflowValidators = extensions.jiraWorkflowValidator;
    const workflowConditions = extensions.jiraWorkflowCondition || [];
    const workflowPostFunctions = extensions.jiraWorkflowPostFunction || [];
    return {
        customFields: customFields,
        customFieldTypes: customFieldTypes,
        workflowValidators: workflowValidators,
        workflowConditions: workflowConditions,
        workflowPostFunctions: workflowPostFunctions
    };
};
const $0c9c0b19b2b0ff3b$var$loadModulesV2 = async ()=>{
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const extensions = await (0, $cSfWg.fetchModules)({
        cloudId: cloudId,
        context: {},
        includeHidden: false,
        types: [
            (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE),
            (0, $2Rqjr.WORKFLOW_CONDITION_MODULE),
            (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE)
        ],
        source: (0, $2Rqjr.SOURCE_LEGACY)
    });
    return {
        workflowValidators: extensions[0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE],
        workflowConditions: extensions[0, $2Rqjr.WORKFLOW_CONDITION_MODULE],
        workflowPostFunctions: extensions[0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE],
        // return empty values so monolith code doesn't throw errors
        customFields: [],
        customFieldTypes: []
    };
};
const $0c9c0b19b2b0ff3b$export$8e110dda7ad69e5a = async ()=>{
    const components = {
        customField: (0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules') ? undefined : (0, $2jpBk.customField),
        workflowValidator: $2jpBk.workflowValidator,
        workflowCondition: $2jpBk.workflowCondition,
        workflowPostFunction: $2jpBk.workflowPostFunction
    };
    /* eslint-disable jira/wrm/no-load-bridge */ const loadModules = (0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules') ? $0c9c0b19b2b0ff3b$var$loadModulesV2 : $0c9c0b19b2b0ff3b$var$loadModulesV1;
    const [modules, bridge] = await Promise.all([
        loadModules(),
        (0, $2BvS3.loadBridge)({
            name: 'jira/forge/bridge',
            wrmKeys: 'wrc!com.atlassian.jira.jira-atlaskit-plugin:forge-bridge'
        }).catch((e)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('forge.legacy.bridge', 'Cannot load the bridge', e);
            return e;
        })
    ]);
    // modules contains all modules data
    // components contains modules to render
    // loadModules method can be invoked with data classification to get the filtered modules by access narrowing
    /* eslint-enable jira/wrm/no-load-bridge */ const API = {
        modules: modules,
        components: components,
        loadModules: loadModules
    };
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    bridge(API);
};

});
parcelRegister("2jpBk", function(module, exports) {

$parcel$export(module.exports, "customField", () => $862ab2c37c653be2$export$82c8c2cee582a640);
$parcel$export(module.exports, "workflowCondition", () => $862ab2c37c653be2$export$8fe15afd9a3cb1e7);
$parcel$export(module.exports, "workflowPostFunction", () => $862ab2c37c653be2$export$f7a58b73e10db093);
$parcel$export(module.exports, "workflowValidator", () => $862ab2c37c653be2$export$75e1428e5ba72a);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $49235 = parcelRequire("49235");

var $hYKgv = parcelRequire("hYKgv");

var $gG6DD = parcelRequire("gG6DD");

var $gAaaZ = parcelRequire("gAaaZ");

var $31gDV = parcelRequire("31gDV");
const $862ab2c37c653be2$export$82c8c2cee582a640 = {
    renderView: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYKgv.CustomField), props), container);
        return container;
    },
    renderEditView: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYKgv.CustomFieldEdit), props), container);
        return container;
    }
};
const $862ab2c37c653be2$export$8fe15afd9a3cb1e7 = {
    renderView: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gG6DD.WorkflowConditionView), props)), container);
        return container;
    },
    renderCreate: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gG6DD.WorkflowConditionCreate), props)), container);
        return container;
    },
    renderEdit: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gG6DD.WorkflowConditionEdit), props)), container);
        return container;
    }
};
const $862ab2c37c653be2$export$f7a58b73e10db093 = {
    renderView: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAaaZ.WorkflowPostFunctionView), props)), container);
        return container;
    },
    renderCreate: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAaaZ.WorkflowPostFunctionCreate), props)), container);
        return container;
    },
    renderEdit: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAaaZ.WorkflowPostFunctionEdit), props)), container);
        return container;
    }
};
const $862ab2c37c653be2$export$75e1428e5ba72a = {
    renderView: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31gDV.WorkflowValidatorView), props)), container);
        return container;
    },
    renderCreate: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31gDV.WorkflowValidatorCreate), props)), container);
        return container;
    },
    renderEdit: (props)=>{
        const container = document.createElement('div');
        (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31gDV.WorkflowValidatorEdit), props)), container);
        return container;
    }
};

});
parcelRegister("hYKgv", function(module, exports) {

$parcel$export(module.exports, "CustomField", () => $c7576677d58b0b16$export$9639a5943929d469);
$parcel$export(module.exports, "CustomFieldEdit", () => $c7576677d58b0b16$export$5de2ecfed36387cf);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $5syGA = parcelRequire("5syGA");

var $elbiT = parcelRequire("elbiT");

var $3zABe = parcelRequire("3zABe");

var $fe3vy = parcelRequire("fe3vy");
const $c7576677d58b0b16$export$9639a5943929d469 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elbiT.ViewAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fe3vy.AsyncCustomField), props));
const $c7576677d58b0b16$var$CustomFieldEditView = (props)=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(true);
    const { onCancel: onCancel, onSave: onSave } = props;
    const onCancelCallback = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
        onCancel && onCancel();
    }, [
        onCancel
    ]);
    const onSaveCallback = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
    (e)=>{
        setIsOpen(false);
        return onSave(e);
    }, [
        onSave
    ]);
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3zABe.AsyncCustomFieldEdit), {
        ...props,
        onCancel: onCancelCallback,
        onSave: onSaveCallback
    }) : null;
};
const $c7576677d58b0b16$export$5de2ecfed36387cf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elbiT.EditAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7576677d58b0b16$var$CustomFieldEditView, props));

});
parcelRegister("elbiT", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $4ecd31271e5beb2f$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $4ecd31271e5beb2f$export$947ae3996b2bc000);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $4ecd31271e5beb2f$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $4ecd31271e5beb2f$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
        ...props
    });

});

parcelRegister("3zABe", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomFieldEdit", () => $c7a0c627b293f096$export$61f4a77d813bf4b4);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $1boRu = parcelRequire("1boRu");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");

var $2Rqjr = parcelRequire("2Rqjr");

var $gamHX = parcelRequire("gamHX");

var $2vJHJ = parcelRequire("2vJHJ");

var $gGtKh = parcelRequire("gGtKh");

var $gWRle = parcelRequire("gWRle");

var $6v4tG = parcelRequire("6v4tG");

const $c7a0c627b293f096$var$getModule = ()=>(0, $d6g7g.measureInitialPageLoadAsyncResourcesTiming)((0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START, (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END, ()=>(parcelRequire("iv4aQ")));

const $c7a0c627b293f096$var$getForgeExtensionModule = ()=>(0, $d6g7g.measureInitialPageLoadAsyncResourcesTiming)((0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START, (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END, ()=>(parcelRequire("cecKP")));
const $c7a0c627b293f096$export$55429035358dd625 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$c7a0c627b293f096$var$getModule().then((module)=>module.CustomFieldEdit), {
    ssr: false
}));
const $c7a0c627b293f096$export$6eef71e05c3af990 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$c7a0c627b293f096$var$getForgeExtensionModule().then((module)=>module.CustomFieldEdit), {
    ssr: false
}));
const $c7a0c627b293f096$export$5ffe94eb10d5f1f4 = ({ onSave: onSave, onCancel: onCancel, onConfirm: onConfirm, onError: onError, onRender: onRender, ...restProps })=>{
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const extensionDataValue = (0, $eUqFw.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldType: extensionData.fieldType,
            fieldId: extensionData.fieldId,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
        };
    }, [
        extension.type,
        extensionData
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>({
            module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload
    ]);
    const submit = (0, $eUqFw.useCallback)(({ data: fieldValue })=>(0, $6v4tG.onCustomFieldSubmit)(fieldValue, onSave, onConfirm, showFlag), // todo SMT-491 onConfirm, onSave (fieldId) was changing every time component tree was changed by Bento issue view.
    // root cause - Bento's connect-field is creating onConfirm function and fieldId every time. More in mentioned ticket
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        showFlag
    ]);
    const close = onCancel;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const bridge = (0, $eUqFw.useMemo)(()=>({
            submit: submit,
            close: close
        }), [
        submit,
        close
    ]);
    if (((0, $2vJHJ.isNativeUiExtension)(extension, (0, $2Rqjr.ENTRY_POINT_EDIT)) || (0, $2vJHJ.isCustomUIExtension)(extension, (0, $2Rqjr.ENTRY_POINT_EDIT))) && // https://switcheroo.atlassian.com/ui/gates/cd39682c-bc5b-4f4b-af87-f25672cfc326
    (0, $eI5EY.fg)('jira_new_ui_kit_renderer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWRle.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-field-edit",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7a0c627b293f096$export$6eef71e05c3af990, {
        ...restProps,
        ...extraProps,
        onError: onError,
        onRender: onRender,
        onCancel: onCancel,
        submit: submit,
        bridge: bridge
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWRle.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-field-edit",
        fallback: null
    }, (0, $2vJHJ.isCustomUIExtension)(extension, (0, $2Rqjr.ENTRY_POINT_EDIT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gamHX.LazyModalIframe), {
        ...restProps,
        ...extraProps,
        bridge: bridge,
        onClose: onCancel,
        onLoad: onRender
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7a0c627b293f096$export$55429035358dd625, {
        ...restProps,
        ...extraProps,
        onError: onError,
        onRender: onRender,
        onCancel: onCancel,
        submit: submit,
        bridge: bridge
    })));
};
const $c7a0c627b293f096$export$61f4a77d813bf4b4 = $c7a0c627b293f096$export$5ffe94eb10d5f1f4;

});
parcelRegister("gamHX", function(module, exports) {

$parcel$export(module.exports, "LazyIframe", () => $06c11067a462069c$export$808646051d5a3908);
$parcel$export(module.exports, "LazyModalIframe", () => $06c11067a462069c$export$f35ac420e260eb7);

var $7rh0R = parcelRequire("7rh0R");

var $1boRu = parcelRequire("1boRu");

const $06c11067a462069c$var$getModule = ()=>(parcelRequire("bFjel"));
const $06c11067a462069c$export$808646051d5a3908 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$06c11067a462069c$var$getModule().then((module)=>module.IframeRenderer), {
    ssr: false
}));
const $06c11067a462069c$export$f35ac420e260eb7 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazy)(()=>$06c11067a462069c$var$getModule().then((module)=>module.ModalIframeRenderer), {}));

});
parcelRegister("bFjel", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8ficv")
]).then(()=>parcelRequire('kq5KC'));

});


parcelRegister("gWRle", function(module, exports) {

$parcel$export(module.exports, "StopSubmitPropagation", () => $1ee7d0bd2c357478$export$238f56c0891e9254);

var $eUqFw = parcelRequire("eUqFw");
const $1ee7d0bd2c357478$export$e6dfd72ab29f8598 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper",
        onSubmit: props.onSubmit
    }, props.children);
const $1ee7d0bd2c357478$export$238f56c0891e9254 = ({ children: children })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ee7d0bd2c357478$export$e6dfd72ab29f8598, {
        onSubmit: handleSubmit
    }, children);
};

});

parcelRegister("6v4tG", function(module, exports) {

$parcel$export(module.exports, "onCustomFieldSubmit", () => $f97e0cf7837f4451$export$fc8c2ed652969e74);

var $7byHA = parcelRequire("7byHA");

var $k9lIU = parcelRequire("k9lIU");
const $f97e0cf7837f4451$export$fc8c2ed652969e74 = (fieldValue, onSave, onConfirm, showFlag)=>onSave(fieldValue).then((response)=>{
        if (response == null) return;
        // The error is handled in the catch block
        if ('error' in response) {
            if (response.error) throw response.error;
        } else onConfirm(response.data);
    }).catch((error)=>{
        showFlag((0, $k9lIU.default)(error));
        // Custom UI depends on this error to get know whether the form was successfully submitted or not
        if ((0, $7byHA.isValidationError)(error)) throw error;
        throw Error(`Unable to save custom field, error: ${error.message}`);
    });

});
parcelRegister("k9lIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38e26aef80874b3$export$2e2bcd8739ae039);

var $7byHA = parcelRequire("7byHA");

var $e4byB = parcelRequire("e4byB");

var $gYPHE = parcelRequire("gYPHE");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a38e26aef80874b3$export$2e2bcd8739ae039 = (error)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $7byHA.isValidationError)(error) ? (0, $gYPHE.default)(error.errors) : (0, $e4byB.default)();

});
parcelRegister("e4byB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b05c03b9263b7a0c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $b05c03b9263b7a0c$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.generic-error.title",
        "defaultMessage": "We were unable to edit this custom field. Please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b05c03b9263b7a0c$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $b05c03b9263b7a0c$var$messages.title,
        isAutoDismiss: false
    });

});

parcelRegister("gYPHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbc09c79bc08bf01$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $dbc09c79bc08bf01$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.validation-error.title",
        "defaultMessage": "Validation error"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dbc09c79bc08bf01$export$2e2bcd8739ae039 = (errors)=>({
        type: 'error',
        title: $dbc09c79bc08bf01$var$messages.title,
        description: errors.map(({ error: error })=>error).join(', '),
        isAutoDismiss: false
    });

});



parcelRegister("iv4aQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("7pzTP")
]).then(()=>parcelRequire('hd1cG'));

});

parcelRegister("cecKP", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("iY1OF")
]).then(()=>parcelRequire('2HLDo'));

});


parcelRegister("fe3vy", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomField", () => $553f56b38256a231$export$3d94b128d17ce776);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $eI5EY = parcelRequire("eI5EY");

var $1boRu = parcelRequire("1boRu");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $gGtKh = parcelRequire("gGtKh");

var $8Nthx = parcelRequire("8Nthx");

const $553f56b38256a231$var$getModule = ()=>(0, $d6g7g.measureInitialPageLoadAsyncResourcesTiming)((0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START, (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END, ()=>(parcelRequire("dGv1A")));

const $553f56b38256a231$var$getForgeExtensionModule = ()=>(0, $d6g7g.measureInitialPageLoadAsyncResourcesTiming)((0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START, (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END, ()=>(parcelRequire("bAXwJ")));
const $553f56b38256a231$var$skeletonConfig = [
    {
        width: 100
    }
];
const $553f56b38256a231$export$2a6d819caf09da30 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$553f56b38256a231$var$getModule().then((module)=>module.CustomField), {
    ssr: false
}));
const $553f56b38256a231$export$a64ace77e0f13482 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$553f56b38256a231$var$getForgeExtensionModule().then((module)=>module.CustomField), {
    ssr: false
}));
const $553f56b38256a231$export$ffc72ef953e96226 = (props)=>{
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = props;
    const loadingComponent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
            skeletonConfig: $553f56b38256a231$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $eUqFw.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldType: extensionData.fieldType,
            fieldId: extensionData.fieldId,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext
        };
        return {
            ...preparedExtensionData,
            type: extension.type
        };
    }, [
        extension.type,
        extensionData
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    if (((0, $2vJHJ.isNativeUiExtension)(extension) || (0, $2vJHJ.isCustomUIExtension)(extension)) && // https://switcheroo.atlassian.com/ui/gates/cd39682c-bc5b-4f4b-af87-f25672cfc326
    (0, $eI5EY.fg)('jira_new_ui_kit_renderer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-field-renderer",
        fallback: loadingComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($553f56b38256a231$export$a64ace77e0f13482, {
        ...props,
        ...extraProps
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-field-renderer",
        fallback: loadingComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($553f56b38256a231$export$2a6d819caf09da30, {
        ...props,
        ...extraProps
    }));
};
const $553f56b38256a231$export$3d94b128d17ce776 = $553f56b38256a231$export$ffc72ef953e96226;

});
parcelRegister("8Nthx", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $fb59735ddb4a6800$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonLayout", () => $fb59735ddb4a6800$export$af3ba02ef74c9bdf);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $fb59735ddb4a6800$export$69f3c7f0b2b87aa2 = [];
const $fb59735ddb4a6800$export$8f31e4c4a37b8e9c = ({ skeletonConfig: skeletonConfig = $fb59735ddb4a6800$export$69f3c7f0b2b87aa2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, skeletonConfig.map(({ width: width }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb59735ddb4a6800$var$ForgeSkeleton, {
            "data-testId": `forgeskeleton-${index}`,
            key: index,
            width: width
        })));
const $fb59735ddb4a6800$export$af3ba02ef74c9bdf = ({ children: children, layout: layout })=>{
    if (!layout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "forge-ui-async.common.ui.skeleton.box",
        xcss: $fb59735ddb4a6800$var$layoutStyles
    }, children);
};
const $fb59735ddb4a6800$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fb59735ddb4a6800$var$ForgeSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1y04s53": (0, $9t7rW.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mcm _4t3ipxbi _19pkpxbi _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk",
            __cmplp.className
        ])
    });
});
const $fb59735ddb4a6800$var$layoutStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});

});

parcelRegister("dGv1A", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("auozo")
]).then(()=>parcelRequire('j34Xs'));

});

parcelRegister("bAXwJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("d8wlD")
]).then(()=>parcelRequire('1EREJ'));

});



parcelRegister("gG6DD", function(module, exports) {

$parcel$export(module.exports, "WorkflowConditionCreate", () => $8e25faacecab1b95$export$7c5d91d150cf4af1);
$parcel$export(module.exports, "WorkflowConditionEdit", () => $8e25faacecab1b95$export$be9207c31b4d0498);
$parcel$export(module.exports, "WorkflowConditionView", () => $8e25faacecab1b95$export$2dda4bec0d23d56e);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $5syGA = parcelRequire("5syGA");

var $e7yHI = parcelRequire("e7yHI");

var $1qYPC = parcelRequire("1qYPC");
const $8e25faacecab1b95$export$7c5d91d150cf4af1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7yHI.CreateAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1qYPC.AsyncWorkflowConditionCreateEdit), {
        ...props,
        entryPoint: "create"
    }));
const $8e25faacecab1b95$export$be9207c31b4d0498 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7yHI.EditAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1qYPC.AsyncWorkflowConditionCreateEdit), {
        ...props,
        entryPoint: "edit"
    }));
const $8e25faacecab1b95$export$2dda4bec0d23d56e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7yHI.ViewAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1qYPC.AsyncWorkflowConditionView), {
        ...props,
        entryPoint: "view"
    }));

});
parcelRegister("e7yHI", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $e2df79b3ee094df3$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $e2df79b3ee094df3$export$947ae3996b2bc000);
$parcel$export(module.exports, "CreateAnalyticsWrapper", () => $e2df79b3ee094df3$export$92d71027daa95c83);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $e2df79b3ee094df3$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_CONDITION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_VIEW),
        ...props
    });
const $e2df79b3ee094df3$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_CONDITION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
        ...props
    });
const $e2df79b3ee094df3$export$92d71027daa95c83 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_CONDITION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_CREATE),
        ...props
    });

});

parcelRegister("1qYPC", function(module, exports) {

$parcel$export(module.exports, "AsyncWorkflowConditionCreateEdit", () => $68dd1043a4c856ca$export$6006938a750a95cf);
$parcel$export(module.exports, "AsyncWorkflowConditionView", () => $68dd1043a4c856ca$export$f52818748d92f596);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $eyvXg = parcelRequire("eyvXg");
const $68dd1043a4c856ca$export$f05650047f36f873 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowCreateEdit), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_CONDITION_MODULE)
    });
const $68dd1043a4c856ca$export$d15747c9ea39b63 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowView), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_CONDITION_MODULE)
    });
const $68dd1043a4c856ca$export$6006938a750a95cf = $68dd1043a4c856ca$export$f05650047f36f873;
const $68dd1043a4c856ca$export$f52818748d92f596 = $68dd1043a4c856ca$export$d15747c9ea39b63;

});
parcelRegister("eyvXg", function(module, exports) {

$parcel$export(module.exports, "LazyWorkflowView", () => $107d0cd08592bd4f$export$6d3477ca54d81ef7);
$parcel$export(module.exports, "LazyWorkflowCreateEdit", () => $107d0cd08592bd4f$export$b714d2a79a4b7082);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $eI5EY = parcelRequire("eI5EY");

var $1boRu = parcelRequire("1boRu");

var $gamHX = parcelRequire("gamHX");

var $2vJHJ = parcelRequire("2vJHJ");

var $gGtKh = parcelRequire("gGtKh");

var $8Nthx = parcelRequire("8Nthx");
const $107d0cd08592bd4f$var$skeletonConfig = [
    {
        width: 100
    },
    {
        width: 75
    }
];

const $107d0cd08592bd4f$var$getModule = ()=>(parcelRequire("gm4Lg"));
const $107d0cd08592bd4f$export$7ef2c8aa7b731b0c = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$107d0cd08592bd4f$var$getModule().then((module)=>module.ForgeUIExtension), {
    ssr: false
}));
const $107d0cd08592bd4f$export$6d3477ca54d81ef7 = (props)=>{
    const { entryPoint: entryPoint, extension: extension, extensionData: extensionData, module: module, ...restProps } = props;
    const loadingComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
        skeletonConfig: $107d0cd08592bd4f$var$skeletonConfig
    });
    const extraProps = {
        entryPoint: entryPoint,
        extension: extension,
        loadingComponent: loadingComponent,
        module: module,
        extensionData: {
            ...extensionData,
            type: module,
            entryPoint: entryPoint
        }
    };
    // https://switcheroo.atlassian.com/ui/gates/cd39682c-bc5b-4f4b-af87-f25672cfc326
    if ((0, $eI5EY.fg)('jira_new_ui_kit_renderer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "workflow-view",
        fallback: loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension, entryPoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($107d0cd08592bd4f$export$7ef2c8aa7b731b0c, {
        ...restProps,
        ...extraProps
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "workflow-view",
        fallback: loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension, entryPoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gamHX.LazyIframe), {
        ...restProps,
        ...extraProps
    }));
};
const $107d0cd08592bd4f$export$b714d2a79a4b7082 = (props)=>{
    const { entryPoint: entryPoint, extension: extension, extensionData: extensionData, module: module, onSetConfigurationCallback: onSetConfigurationCallback, ...restProps } = props;
    const loadingComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
        skeletonConfig: $107d0cd08592bd4f$var$skeletonConfig
    });
    const extraProps = {
        entryPoint: entryPoint,
        extension: extension,
        loadingComponent: loadingComponent,
        module: module,
        extensionData: {
            ...extensionData,
            type: module,
            entryPoint: entryPoint
        }
    };
    const setWorkflowRuleConfigurationCallback = (0, $eUqFw.useCallback)((param)=>{
        if (!onSetConfigurationCallback) return;
        const { onConfigure: onConfigure } = param?.data || {};
        const callbackType = typeof onConfigure;
        if (callbackType !== 'function') throw new Error('Invalid "onConfigure" callback - function expected');
        onSetConfigurationCallback(async ()=>{
            const config = await onConfigure();
            return config;
        });
    }, [
        onSetConfigurationCallback
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customBridgeMethods = (0, $eUqFw.useMemo)(()=>({
            setWorkflowRuleConfigurationCallback: setWorkflowRuleConfigurationCallback
        }), [
        setWorkflowRuleConfigurationCallback
    ]);
    // https://switcheroo.atlassian.com/ui/gates/cd39682c-bc5b-4f4b-af87-f25672cfc326
    if ((0, $eI5EY.fg)('jira_new_ui_kit_renderer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "workflow-create-edit",
        fallback: loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension, entryPoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($107d0cd08592bd4f$export$7ef2c8aa7b731b0c, {
        ...restProps,
        ...extraProps,
        customBridgeMethods: customBridgeMethods
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "workflow-create-edit",
        fallback: loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension, entryPoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gamHX.LazyIframe), {
        ...restProps,
        ...extraProps,
        customBridgeMethods: customBridgeMethods
    }));
};

});
parcelRegister("gm4Lg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("eNmuD"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2WHXG")
]).then(()=>parcelRequire('eXv55'));

});




parcelRegister("gAaaZ", function(module, exports) {

$parcel$export(module.exports, "WorkflowPostFunctionCreate", () => $57840d66a281508b$export$9c721b17de78c59f);
$parcel$export(module.exports, "WorkflowPostFunctionEdit", () => $57840d66a281508b$export$45d016d27d63575f);
$parcel$export(module.exports, "WorkflowPostFunctionView", () => $57840d66a281508b$export$d9daa48ae954d3b8);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $5syGA = parcelRequire("5syGA");

var $1ApHa = parcelRequire("1ApHa");

var $eA1dC = parcelRequire("eA1dC");
const $57840d66a281508b$export$9c721b17de78c59f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ApHa.CreateAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eA1dC.AsyncWorkflowPostFunctionCreateEdit), {
        ...props,
        entryPoint: "create"
    }));
const $57840d66a281508b$export$45d016d27d63575f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ApHa.EditAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eA1dC.AsyncWorkflowPostFunctionCreateEdit), {
        ...props,
        entryPoint: "edit"
    }));
const $57840d66a281508b$export$d9daa48ae954d3b8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ApHa.ViewAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eA1dC.AsyncWorkflowPostFunctionView), {
        ...props,
        entryPoint: "view"
    }));

});
parcelRegister("1ApHa", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $fc439fd6fb003a44$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $fc439fd6fb003a44$export$947ae3996b2bc000);
$parcel$export(module.exports, "CreateAnalyticsWrapper", () => $fc439fd6fb003a44$export$92d71027daa95c83);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $fc439fd6fb003a44$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_VIEW),
        ...props
    });
const $fc439fd6fb003a44$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
        ...props
    });
const $fc439fd6fb003a44$export$92d71027daa95c83 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_CREATE),
        ...props
    });

});

parcelRegister("eA1dC", function(module, exports) {

$parcel$export(module.exports, "AsyncWorkflowPostFunctionCreateEdit", () => $c967688d5042f915$export$cfa61e5559ea0dce);
$parcel$export(module.exports, "AsyncWorkflowPostFunctionView", () => $c967688d5042f915$export$87ba64d38cfeb16a);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $eyvXg = parcelRequire("eyvXg");
const $c967688d5042f915$export$86604dfb04526e1a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowCreateEdit), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE)
    });
const $c967688d5042f915$export$db5b75fe29c72654 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowView), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_POST_FUNCTION_MODULE)
    });
const $c967688d5042f915$export$cfa61e5559ea0dce = $c967688d5042f915$export$86604dfb04526e1a;
const $c967688d5042f915$export$87ba64d38cfeb16a = $c967688d5042f915$export$db5b75fe29c72654;

});


parcelRegister("31gDV", function(module, exports) {

$parcel$export(module.exports, "WorkflowValidatorCreate", () => $84ab2903f04f3ca0$export$b131ee6ae33375f7);
$parcel$export(module.exports, "WorkflowValidatorEdit", () => $84ab2903f04f3ca0$export$295e28146293a786);
$parcel$export(module.exports, "WorkflowValidatorView", () => $84ab2903f04f3ca0$export$8a0a1dfbf1819d74);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $5syGA = parcelRequire("5syGA");

var $bfPrz = parcelRequire("bfPrz");

var $dU2pm = parcelRequire("dU2pm");
const $84ab2903f04f3ca0$export$b131ee6ae33375f7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfPrz.CreateAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dU2pm.AsyncWorkflowValidatorCreateEdit), {
        ...props,
        entryPoint: "create"
    }));
const $84ab2903f04f3ca0$export$295e28146293a786 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfPrz.EditAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dU2pm.AsyncWorkflowValidatorCreateEdit), {
        ...props,
        entryPoint: "edit"
    }));
const $84ab2903f04f3ca0$export$8a0a1dfbf1819d74 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bfPrz.ViewAnalyticsWrapper), {
        attributes: {
            ...props.analyticsAttributes,
            ...(0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
        },
        shouldFireInitializedEvent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dU2pm.AsyncWorkflowValidatorView), {
        ...props,
        entryPoint: "view"
    }));

});
parcelRegister("bfPrz", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $76d2ae7b878c8c9b$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $76d2ae7b878c8c9b$export$947ae3996b2bc000);
$parcel$export(module.exports, "CreateAnalyticsWrapper", () => $76d2ae7b878c8c9b$export$92d71027daa95c83);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $76d2ae7b878c8c9b$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_VIEW),
        ...props
    });
const $76d2ae7b878c8c9b$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
        ...props
    });
const $76d2ae7b878c8c9b$export$92d71027daa95c83 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_CREATE),
        ...props
    });

});

parcelRegister("dU2pm", function(module, exports) {

$parcel$export(module.exports, "AsyncWorkflowValidatorCreateEdit", () => $fca447d3566778cb$export$54de7ff67b273896);
$parcel$export(module.exports, "AsyncWorkflowValidatorView", () => $fca447d3566778cb$export$9b5553aeb9e69415);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $eyvXg = parcelRequire("eyvXg");
const $fca447d3566778cb$export$b86c3ac240c092a8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowCreateEdit), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE)
    });
const $fca447d3566778cb$export$7547b0d39a9ad099 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eyvXg.LazyWorkflowView), {
        ...props,
        module: (0, $2Rqjr.WORKFLOW_VALIDATOR_MODULE)
    });
const $fca447d3566778cb$export$54de7ff67b273896 = $fca447d3566778cb$export$b86c3ac240c092a8;
const $fca447d3566778cb$export$9b5553aeb9e69415 = $fca447d3566778cb$export$7547b0d39a9ad099;

});




parcelRegister("8m3xX", function(module, exports) {

$parcel$export(module.exports, "sendStartMarkForLegacyIssueCreate", () => $4157e2b9a99a5048$export$7dbcbf47a4e0e00f);
$parcel$export(module.exports, "sendEndMarkForLegacyIssueCreate", () => $4157e2b9a99a5048$export$b5c5d408bb7fd104);

var $7pmxV = parcelRequire("7pmxV");

var $iLDke = parcelRequire("iLDke");
const $4157e2b9a99a5048$export$7dbcbf47a4e0e00f = ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    if (typeof isInitialLoad === 'boolean' && triggerSource !== undefined) {
        if (isInitialLoad) (0, $iLDke.legacyIssueCreateInitialRenderInteraction).start();
        else (0, $iLDke.legacyIssueCreateTransitionInteraction).start();
        (0, $iLDke.legacyIssueCreateCombinedInteraction).start();
    }
};
const $4157e2b9a99a5048$export$b5c5d408bb7fd104 = async ({ isInitialLoad: isInitialLoad, triggerSource: triggerSource })=>{
    const Events = await (0, $7pmxV.apiReady)();
    const onCreateIssueDialogRendered = ()=>{
        if (typeof isInitialLoad === 'boolean') {
            if (isInitialLoad) (0, $iLDke.legacyIssueCreateInitialRenderInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            else (0, $iLDke.legacyIssueCreateTransitionInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
            (0, $iLDke.legacyIssueCreateCombinedInteraction).stop({
                customData: {
                    triggerSource: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'CustomValue'.
                    triggerSource,
                    isGICPrefetchEnabled: true
                }
            });
        }
        Events.unbind('createIssueDialogRendered', onCreateIssueDialogRendered);
    };
    Events.bind('createIssueDialogRendered', onCreateIssueDialogRendered);
};

});
parcelRegister("7pmxV", function(module, exports) {

$parcel$export(module.exports, "apiReady", () => $255e282260d8623a$export$330fb1a04c974aad);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
let $255e282260d8623a$var$currentBridge;
const $255e282260d8623a$export$330fb1a04c974aad = async ()=>{
    if ($255e282260d8623a$var$currentBridge) return $255e282260d8623a$var$currentBridge;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/wrm/no-load-bridge
    const Events = await (0, $2BvS3.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $255e282260d8623a$var$currentBridge = Events;
    return Events;
};

});

parcelRegister("iLDke", function(module, exports) {

$parcel$export(module.exports, "legacyIssueCreateInitialRenderInteraction", () => $c60cfd887c71503f$export$2bc24132dfd54487);
$parcel$export(module.exports, "legacyIssueCreateTransitionInteraction", () => $c60cfd887c71503f$export$ba0054dee3105c90);
$parcel$export(module.exports, "legacyIssueCreateCombinedInteraction", () => $c60cfd887c71503f$export$52353a8848646ccd);

var $lNfG4 = parcelRequire("lNfG4");
const $c60cfd887c71503f$export$2bc24132dfd54487 = (0, $lNfG4.metrics).interaction({
    key: 'legacy-issue-create.initial-render'
});
const $c60cfd887c71503f$export$ba0054dee3105c90 = (0, $lNfG4.metrics).interaction({
    key: 'legacy-issue-create.transition'
});
const $c60cfd887c71503f$export$52353a8848646ccd = (0, $lNfG4.metrics).interaction({
    key: 'legacy-issue-create.combined'
});

});



parcelRegister("kAq8l", function(module, exports) {

$parcel$export(module.exports, "useIsInitialLoadLegacyIssueCreate", () => $3f7e29f0e68b4115$export$8a73e89ffc4b9342);

var $WBLbN = parcelRequire("WBLbN");
const $3f7e29f0e68b4115$var$initialState = {
    isInitialLoad: true
};
const $3f7e29f0e68b4115$export$e324594224ef24da = {
    clearInitialLoaded: ()=>({ setState: setState, getState: getState })=>{
            if (getState().isInitialLoad) setState({
                isInitialLoad: false
            });
        }
};
const $3f7e29f0e68b4115$var$store = (0, $WBLbN.createStore)({
    name: 'is-initial-load-create-issue-legacy',
    initialState: $3f7e29f0e68b4115$var$initialState,
    actions: $3f7e29f0e68b4115$export$e324594224ef24da
});
const $3f7e29f0e68b4115$export$8a73e89ffc4b9342 = (0, $WBLbN.createHook)($3f7e29f0e68b4115$var$store);

});

const $491012546836012a$export$d983e94cf86f65d = 'global-create-button';
const $491012546836012a$export$7e22286cafe320a7 = 'keyboard-shortcut';

parcelRegister("98Kfy", function(module, exports) {

$parcel$export(module.exports, "useInitializePersistentIssueCreateModalView", () => $9b8038c58e37e9fd$export$9086117e14a55509);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $ctR9z = parcelRequire("ctR9z");

var $bNe1g = parcelRequire("bNe1g");

var $aONhl = parcelRequire("aONhl");
const $9b8038c58e37e9fd$export$9086117e14a55509 = ()=>{
    const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight }, { setShouldPushMiniModalDiscoverability: setShouldPushMiniModalDiscoverability, setPersistentModalView: setPersistentModalView }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const hasUserSeenMiniModal = (0, $eUqFw.useRef)(false);
    const isJSM = projectContext?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
    const { data: resource } = (0, $aONhl.usePersistentIssueCreateModalViewResource)();
    /**
	 * It only handles the initialization part as after the modal is opened the persistentModalView
	 * would be handled by the `actions` of `useTriggerIssueCreateModal`.
	 */ (0, $eUqFw.useEffect)(()=>{
        setPersistentModalView(resource?.view || 'modal');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * JSM has opted out so we update the `shouldPushMiniModalDiscoverability` on every project change
	 * until the discoverability push has been done, meaning that the user has seen the mini modal being
	 * shown as the default modal.
	 *
	 * If the user has seen the mini modal from discoverability push (hasUserSeenMiniModal) or
	 * dismiss its nudge (isDiscoPushComplete), shouldPushMiniModalDiscoverability should never be true again.
	 */ (0, $eUqFw.useEffect)(()=>{
        if (resource?.isDiscoPushComplete || hasUserSeenMiniModal.current) setShouldPushMiniModalDiscoverability(false);
        else setShouldPushMiniModalDiscoverability(!isJSM);
    }, [
        resource?.isDiscoPushComplete,
        setShouldPushMiniModalDiscoverability,
        isJSM
    ]);
    /**
	 * `shouldShowMiniModalSpotlight` can be used to determine if user has seen the mini modal
	 * as it is only set `onModalOpen`, which means, if it is true, the modal is opened with mini view
	 * and the user will see it.
	 */ (0, $eUqFw.useEffect)(()=>{
        if (shouldShowMiniModalSpotlight && !hasUserSeenMiniModal.current) hasUserSeenMiniModal.current = true;
    }, [
        shouldShowMiniModalSpotlight
    ]);
    return null;
};

});
parcelRegister("ctR9z", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $bd445758cecbab8c$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $bd445758cecbab8c$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $bd445758cecbab8c$export$558a195c5bfe3787);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $dfh7z = parcelRequire("dfh7z");

var $dEMIg = parcelRequire("dEMIg");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ellXt = parcelRequire("ellXt");

var $lB25E = parcelRequire("lB25E");

var $WBLbN = parcelRequire("WBLbN");

var $1MRnf = parcelRequire("1MRnf");

var $4SS5k = parcelRequire("4SS5k");

var $dgsxZ = parcelRequire("dgsxZ");
const $bd445758cecbab8c$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $1MRnf.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {}
};
const $bd445758cecbab8c$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $dgsxZ.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $dgsxZ.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $bd445758cecbab8c$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $dgsxZ.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $dfh7z.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $bd445758cecbab8c$var$store = (0, $WBLbN.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $bd445758cecbab8c$export$d4c72bab9d6cc13a,
    actions: $bd445758cecbab8c$export$e324594224ef24da
});
const $bd445758cecbab8c$var$useTriggerIssueCreateModalState = (0, $WBLbN.createStateHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$var$useTriggerIssueCreateModalActions = (0, $WBLbN.createActionsHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$export$71e0eb7b8a91a156 = ()=>{
    const createState = $bd445758cecbab8c$var$useTriggerIssueCreateModalState();
    const createActions = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $bd445758cecbab8c$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $4SS5k.useSitePickerContext)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId && (0, $eI5EY.fg)('jira_ai_issue_create_site_user_preference')) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $bd445758cecbab8c$export$4c674fe824b8f278 = (0, $WBLbN.createSubscriber)($bd445758cecbab8c$var$store);
function $bd445758cecbab8c$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $bd445758cecbab8c$export$71e0eb7b8a91a156();
        const { data: data } = (0, $lB25E.useResource)((0, $ellXt.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("dfh7z", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $5fd686e53a19cbe0$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $5fd686e53a19cbe0$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $5fd686e53a19cbe0$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $5fd686e53a19cbe0$export$b2d8f8edec75f571);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $5fd686e53a19cbe0$export$cd75c112ac11a83b = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $5fd686e53a19cbe0$export$e890e797a25e655c = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5fd686e53a19cbe0$export$70208657c8d471a7 = new (0, $kDfSL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $5fd686e53a19cbe0$export$b2d8f8edec75f571 = new (0, $kDfSL.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("1MRnf", function(module, exports) {

$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $33ffe55cb7bcdadc$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $33ffe55cb7bcdadc$export$c78d329777576aa0);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $33ffe55cb7bcdadc$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $33ffe55cb7bcdadc$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $33ffe55cb7bcdadc$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $33ffe55cb7bcdadc$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $33ffe55cb7bcdadc$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $33ffe55cb7bcdadc$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $33ffe55cb7bcdadc$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $33ffe55cb7bcdadc$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $33ffe55cb7bcdadc$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $33ffe55cb7bcdadc$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $33ffe55cb7bcdadc$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $33ffe55cb7bcdadc$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $33ffe55cb7bcdadc$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $33ffe55cb7bcdadc$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $33ffe55cb7bcdadc$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $33ffe55cb7bcdadc$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $33ffe55cb7bcdadc$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $33ffe55cb7bcdadc$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $33ffe55cb7bcdadc$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $33ffe55cb7bcdadc$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $33ffe55cb7bcdadc$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $33ffe55cb7bcdadc$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $33ffe55cb7bcdadc$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $33ffe55cb7bcdadc$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $33ffe55cb7bcdadc$export$32648b574a536c8b);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $33ffe55cb7bcdadc$export$c0e2ab74dfaa67cc);
const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $33ffe55cb7bcdadc$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $33ffe55cb7bcdadc$export$f352408886aa304b = 'connect-app-ecosystem';
const $33ffe55cb7bcdadc$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};

});

parcelRegister("4SS5k", function(module, exports) {

$parcel$export(module.exports, "useSitePickerContext", () => $fda55b41d7d37cf0$export$f8b5aae013e4cf77);

var $WBLbN = parcelRequire("WBLbN");
const $fda55b41d7d37cf0$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $fda55b41d7d37cf0$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $fda55b41d7d37cf0$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $fda55b41d7d37cf0$export$d4c72bab9d6cc13a,
    actions: $fda55b41d7d37cf0$export$e324594224ef24da
});
const $fda55b41d7d37cf0$export$f8b5aae013e4cf77 = (0, $WBLbN.createHook)($fda55b41d7d37cf0$export$6f57813fe9f31bf9);

});

parcelRegister("dgsxZ", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $b8d8e5356c7976a6$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $b8d8e5356c7976a6$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $b8d8e5356c7976a6$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $b8d8e5356c7976a6$export$720579602bb055a2);

var $dfh7z = parcelRequire("dfh7z");

var $fqKjL = parcelRequire("fqKjL");

var $hBkQt = parcelRequire("hBkQt");

var $75e8i = parcelRequire("75e8i");
const $b8d8e5356c7976a6$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $dfh7z.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $75e8i.default)('global-issue.create-modal-subsequent');
    else (0, $75e8i.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $hBkQt.startGlobalIssueCreateTTIWithAdjustments)();
};
const $b8d8e5356c7976a6$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $b8d8e5356c7976a6$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $b8d8e5356c7976a6$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("fqKjL", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $de2993c8c3fea479$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $de2993c8c3fea479$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $de2993c8c3fea479$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $de2993c8c3fea479$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $de2993c8c3fea479$export$c1592e4d8d98963e);

var $lNfG4 = parcelRequire("lNfG4");
const $de2993c8c3fea479$export$5a01a7fa84b239c8 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $de2993c8c3fea479$export$c50ad3c31b6fcfc6 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $de2993c8c3fea479$export$4b2382574525bb0f = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $de2993c8c3fea479$export$7839bdaa2f6a2385 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $de2993c8c3fea479$export$c1592e4d8d98963e = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("hBkQt", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $362542d6dd943f24$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $362542d6dd943f24$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $362542d6dd943f24$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $362542d6dd943f24$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $362542d6dd943f24$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $362542d6dd943f24$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $362542d6dd943f24$export$9f3d6f17e1da7874 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $362542d6dd943f24$export$457c9fb71ad5b3a9 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.start();
};
const $362542d6dd943f24$export$ef664dac649a716c = ()=>$362542d6dd943f24$export$9f3d6f17e1da7874.mark('gic-tti');
const $362542d6dd943f24$export$30ca4c461fab486c = (customData)=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $362542d6dd943f24$export$27f2445288b528c = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.cancel();
};
const $362542d6dd943f24$export$7a2709fc1e33401a = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $362542d6dd943f24$export$cf3893335c93e33b = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $362542d6dd943f24$export$d86f4868694f2aa7 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [];

});




parcelRegister("aONhl", function(module, exports) {

$parcel$export(module.exports, "usePersistentIssueCreateModalViewResource", () => $9e2a84bf0e5d8f6a$export$20dbed3226e737bc);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

var $lB25E = parcelRequire("lB25E");


var $fKYF0 = parcelRequire("fKYF0");
const $9e2a84bf0e5d8f6a$export$20dbed3226e737bc = ()=>{
    const { data: data, update: update } = (0, $lB25E.useResource)((0, $fKYF0.persistentIssueCreateModalViewResource));
    const updateView = (0, $eUqFw.useCallback)(async (view)=>{
        try {
            await (0, $cm5m0.userPreferenceAPI).set((0, $9cf0ecd2babadcc5$export$15187a597cef02df), view);
            update((state)=>({
                    ...state,
                    view: view
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'persistentIssueCreateModalViewState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    const updateIsDiscoPushComplete = (0, $eUqFw.useCallback)(async (isDiscoPushComplete = true)=>{
        try {
            await (0, $cm5m0.userPreferenceAPI).set((0, $9cf0ecd2babadcc5$export$8977f91a75d8d265), isDiscoPushComplete);
            update((state)=>({
                    ...state,
                    isDiscoPushComplete: isDiscoPushComplete
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'miniModalDiscoverabilityPushState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    return {
        data: data,
        updateView: updateView,
        updateIsDiscoPushComplete: updateIsDiscoPushComplete
    };
};

});
const $9cf0ecd2babadcc5$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $9cf0ecd2babadcc5$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $9cf0ecd2babadcc5$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';



parcelRegister("la1Rb", function(module, exports) {

$parcel$export(module.exports, "NavigationCreateIssueButtonWrapperNudgeAsync", () => $8a299d777f4a1bc8$export$fc0840474cb1fce9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");

var $4LQ2W = parcelRequire("4LQ2W");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8a299d777f4a1bc8$var$NavigationCreateIssueButtonLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("4vlVb")).then((exportedModule)=>exportedModule.NavigationCreateIssueButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-create-issue/index.tsx"
});
const $8a299d777f4a1bc8$export$fc0840474cb1fce9 = ({ children: children })=>{
    const shouldShowNudge = (0, $4LQ2W.useCanShowQuickstartNudge)();
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $8379f5d78bf6fb5a$export$aba87e019f5ccb8d),
        fallback: children,
        attributes: {
            nudgeId: (0, $8379f5d78bf6fb5a$export$aba87e019f5ccb8d)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-navigation-create-issue-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8a299d777f4a1bc8$var$NavigationCreateIssueButtonLazy, {
        nudgeId: (0, $8379f5d78bf6fb5a$export$aba87e019f5ccb8d)
    }, children)));
};

});
parcelRegister("4LQ2W", function(module, exports) {

$parcel$export(module.exports, "useCanShowQuickstartNudge", () => $afc2b9f6db507620$export$b687eb4905cdc15a);

var $gNXC6 = parcelRequire("gNXC6");
const $afc2b9f6db507620$export$b687eb4905cdc15a = ()=>{
    const [{ hasOpened: hasOpened }] = (0, $gNXC6.useHasOpened)();
    return hasOpened;
};

});

parcelRegister("4vlVb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c41xB").then(()=>parcelRequire('3tORd'));

});


parcelRegister("6WbCX", function(module, exports) {

$parcel$export(module.exports, "Create", () => $0ac499790854bce1$export$8ade6fcbf3a7de5d);

var $eUqFw = parcelRequire("eUqFw");

var $5wXIr = parcelRequire("5wXIr");

var $ctSbD = parcelRequire("ctSbD");

var $6zOB7 = parcelRequire("6zOB7");

var $cS2gQ = parcelRequire("cS2gQ");

var $bgNoL = parcelRequire("bgNoL");

var $jFPBh = parcelRequire("jFPBh");

var $6FP8W = parcelRequire("6FP8W");

var $grIru = parcelRequire("grIru");
const $0ac499790854bce1$export$8ade6fcbf3a7de5d = (props)=>{
    if (false) {
        if ((0, $6FP8W.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            appearance: "primary",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cS2gQ))),
            testId: props.testId
        }, props.text);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctSbD.SkeletonCreateButton), {
            text: props.text,
            testId: props.testId
        });
    }
    if ((0, $6FP8W.getWillShowNav4)()) {
        const { onClick: onClick, text: text } = props;
        // This id is required to ensure pollinator tests work between Nav3 and Nav4
        const TEST_ID = 'atlassian-navigation--create-button';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jFPBh.SpotlightTarget), {
            name: (0, $bgNoL.GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grIru.CreateButton), {
            onClick: onClick,
            testId: TEST_ID
        }, text));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wXIr.Create), props);
};

});
parcelRegister("jFPBh", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $022d6d24d0c2da0b$export$e29577842f211e22);

var $eUqFw = parcelRequire("eUqFw");

var $ltfxy = parcelRequire("ltfxy");

var $16WDb = parcelRequire("16WDb");
const $022d6d24d0c2da0b$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $022d6d24d0c2da0b$export$e29577842f211e22 = (0, $16WDb.withNestingOptimisation)($022d6d24d0c2da0b$var$SpotlightTargetWrapper);

});
parcelRegister("16WDb", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $6f4a5382247c5f3b$export$ee1cb2a8280d8710);

var $eUqFw = parcelRequire("eUqFw");

var $cgrgx = parcelRequire("cgrgx");

var $knPb9 = parcelRequire("knPb9");
const $6f4a5382247c5f3b$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $cgrgx.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $knPb9.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});



parcelRegister("7DoMb", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueCreateFromTopNav", () => $d97045ca0aba8293$export$177dc7755a3f80f2);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
var $6coAu = parcelRequire("6coAu");
const $d97045ca0aba8293$export$177dc7755a3f80f2 = new (0, $kDfSL.UFOExperience)('global-issue-create-from-top-nav', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    until: (0, $6coAu.untilAll)([
        {
            category: 'global-issue-create.create-issue'
        }
    ])
});
const $d97045ca0aba8293$export$2b83859c1548ffb5 = new (0, $kDfSL.UFOExperience)('projects-menu-dropdown.recommendation-selector', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $d97045ca0aba8293$export$a784c5bbb21ea554 = new (0, $kDfSL.UFOExperience)('projects-menu-dropdown.load-jpd-recommendation', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $d97045ca0aba8293$export$901fa2452d4f9051 = new (0, $kDfSL.UFOExperience)('projects-menu-dropdown.load-jwm-sample-project-recommendation', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("bNeIj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0f9ac2e4b40e594$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d0f9ac2e4b40e594$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    create: {
        "id": "atlassian-navigation.create.create",
        "defaultMessage": "Create"
    },
    createButtonAriaLabel: {
        "id": "atlassian-navigation.create.create-button-aria-label",
        "defaultMessage": "Create issue"
    }
});

});

parcelRegister("iWROx", function(module, exports) {

$parcel$export(module.exports, "shouldDisableGICFlagCreation", () => $9ccdc81e691603ef$export$fc4d210bb6a1528a);

var $5kDtB = parcelRequire("5kDtB");
const $9ccdc81e691603ef$export$fc4d210bb6a1528a = ()=>(0, $5kDtB.JSW_TMP_BACKLOG_BOARD_REGEXP).test(window.location.pathname);

});


parcelRegister("9CrZ4", function(module, exports) {

$parcel$export(module.exports, "Dashboards", () => $55bb30086585c588$export$dd47e695f88fad71);

var $eUqFw = parcelRequire("eUqFw");

var $bDhRl = parcelRequire("bDhRl");

var $arAkG = parcelRequire("arAkG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7vTKl = parcelRequire("7vTKl");

var $gGJaE = parcelRequire("gGJaE");

var $6yplV = parcelRequire("6yplV");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $olGf9 = parcelRequire("olGf9");

var $5H3md = parcelRequire("5H3md");

var $bAd0L = parcelRequire("bAd0L");

var $1MVFJ = parcelRequire("1MVFJ");

var $efO5T = parcelRequire("efO5T");
const $55bb30086585c588$var$DashboardsAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $olGf9.MenuTrigger), {
        href: "/jira/dashboards",
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).DASHBOARDS
    }, formatMessage((0, $efO5T.default).dashboards));
};
const $55bb30086585c588$var$DashboardsLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteDashboards: loadFavorite }] = (0, $arAkG.useFavoriteDashboards)();
    const [, { loadRecentDashboards: loadRecent }] = (0, $gGJaE.useRecentDashboards)();
    const onStart = (0, $bDhRl.useExperienceStart)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $5kDtB.NAVIGATION_ITEM_ID).DASHBOARDS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $eUqFw.useCallback)(()=>{
        onStart();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $5kDtB.DEFAULT_LOAD_COUNT_RECENT));
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $5kDtB.DEFAULT_LOAD_COUNT_FAV));
    }, [
        hasFetchedOnceFavorites,
        loadFavorite,
        loadRecent,
        onStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5H3md.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bAd0L.Popup), {
        menuId: (0, $7vTKl.MENU_ID).DASHBOARDS,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).DASHBOARDS,
        Menu: (0, $1MVFJ.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $efO5T.default).dashboards)
    }, formatMessage((0, $efO5T.default).dashboards)));
};
const $55bb30086585c588$var$Dashboards = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55bb30086585c588$var$DashboardsAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55bb30086585c588$var$DashboardsLoggedIn, null);
};
const $55bb30086585c588$export$dd47e695f88fad71 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).DASHBOARDS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($55bb30086585c588$var$Dashboards, null));

});
parcelRegister("5H3md", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1e0a25c7b04f3d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $eb1e0a25c7b04f3d$var$PopupBoxWrapper = ({ children: children })=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $eb1e0a25c7b04f3d$var$popupBoxWrapperStyles
    }, children);
    // Wraped children in <></> to avoid returning undefined
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $eb1e0a25c7b04f3d$var$popupBoxWrapperStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    height: '100%'
});
var $eb1e0a25c7b04f3d$export$2e2bcd8739ae039 = $eb1e0a25c7b04f3d$var$PopupBoxWrapper;

});

parcelRegister("1MVFJ", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $47ad6cc828cee786$export$d9b273488cd8ce6f);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");

var $jasPp = parcelRequire("jasPp");

var $0cdA8 = parcelRequire("0cdA8");

var $4qhD6 = parcelRequire("4qhD6");

var $arAkG = parcelRequire("arAkG");

var $7vTKl = parcelRequire("7vTKl");

var $1YbJP = parcelRequire("1YbJP");

var $gGtKh = parcelRequire("gGtKh");

var $5kDtB = parcelRequire("5kDtB");

var $7VDWq = parcelRequire("7VDWq");

var $gIh7l = parcelRequire("gIh7l");

var $j5uqN = parcelRequire("j5uqN");

var $43NDK = parcelRequire("43NDK");

var $lghx1 = parcelRequire("lghx1");

var $cg6jV = parcelRequire("cg6jV");

var $hsM4u = parcelRequire("hsM4u");

var $7PpAn = parcelRequire("7PpAn");

var $3WBRl = parcelRequire("3WBRl");
const $47ad6cc828cee786$var$EVENT_DATA = {
    id: (0, $7vTKl.MENU_ID).DASHBOARDS
};
const $47ad6cc828cee786$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix })=>{
    const [, { loadFavoriteDashboards: loadFavorite }] = (0, $arAkG.useFavoriteDashboards)();
    const onFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $eUqFw.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $5kDtB.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    const testIdContent = (0, $1YbJP.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $1YbJP.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7VDWq.MenuError), {
            testIdPrefix: testIdContent
        }), [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIh7l.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).DASHBOARDS,
        packageName: (0, $5kDtB.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $47ad6cc828cee786$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jasPp.AuthenticationErrorBoundary), {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lghx1.Empty), {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "navigation-apps-dashboards-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j5uqN.MenuSkeletonContent), {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7PpAn.LoadStatus), {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cg6jV.FavoriteContent), {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3WBRl.RecentContent), {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "navigation-apps-dashboards-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43NDK.MenuSkeletonFooter), {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7PpAn.LoadStatus), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hsM4u.Footer), {
        testIdPrefix: testIdFooter
    }))));
};

});
parcelRegister("lghx1", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $f2928f5bbf2f3492$export$1f74963c34e8bfec);

var $eUqFw = parcelRequire("eUqFw");

var $1Yimi = parcelRequire("1Yimi");

var $fDZ6r = parcelRequire("fDZ6r");

var $arAkG = parcelRequire("arAkG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $gGJaE = parcelRequire("gGJaE");

var $6yplV = parcelRequire("6yplV");

var $5kDtB = parcelRequire("5kDtB");

var $hhftg = parcelRequire("hhftg");

var $1MAQq = parcelRequire("1MAQq");

var $kQ1wU = parcelRequire("kQ1wU");

var $7hv5v = parcelRequire("7hv5v");
const $f2928f5bbf2f3492$var$learnMoreHref = 'https://confluence.atlassian.com/jiracorecloud/configuring-dashboards-765593585.html';
const $f2928f5bbf2f3492$export$1f74963c34e8bfec = ({ children: children, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const onSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $7hv5v.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: $f2928f5bbf2f3492$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $7hv5v.default).learnMore))));
    const [{ hasSuccessOnce: hasSuccessOnceFavorite, isFetching: isFetchingFavorite, fetchError: fetchErrorFavorite }] = (0, $arAkG.useFavoriteDashboards)();
    const [{ hasSuccessOnce: hasSuccessOnceRecent, isFetching: isFetchingRecent, fetchError: fetchErrorRecent }] = (0, $gGJaE.useRecentDashboards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $1MAQq.useDashboardNavItems)();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    const shouldShowEmptyForAnonymous = isAnonymous;
    (0, $eUqFw.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'empty');
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhftg.MenuInfo), {
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($kQ1wU))),
        testId: testId,
        text: text
    });
};

});
parcelRegister("1MAQq", function(module, exports) {

$parcel$export(module.exports, "useBoardNavItems", () => $08078ef8854f4ae2$export$cad67ea3bdbadd5e);
$parcel$export(module.exports, "useDashboardNavItems", () => $08078ef8854f4ae2$export$eb662c364f65f2a5);
$parcel$export(module.exports, "useFilterNavItems", () => $08078ef8854f4ae2$export$b00ea32725560f5d);
$parcel$export(module.exports, "usePlanNavItems", () => $08078ef8854f4ae2$export$8448c28cc43804d4);
$parcel$export(module.exports, "useProjectNavItems", () => $08078ef8854f4ae2$export$4a9469e6b2e4297c);
$parcel$export(module.exports, "useRecentNavItems", () => $08078ef8854f4ae2$export$5cfe5f7fc9ab5417);
$parcel$export(module.exports, "useQueueNavItems", () => $08078ef8854f4ae2$export$7723949d2540d672);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $arAkG = parcelRequire("arAkG");

var $dQZ5c = parcelRequire("dQZ5c");

var $j67d5 = parcelRequire("j67d5");

var $gGJaE = parcelRequire("gGJaE");
const $08078ef8854f4ae2$var$getFavouriteAndRecentItems = (recentItems, favoriteItems, changedItems)=>{
    const mapChangedItems = (item)=>{
        const changedItem = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(changedItems, item.id);
        return changedItem ? {
            ...item,
            favourite: changedItem.value
        } : item;
    };
    const updatedFavorites = favoriteItems ? favoriteItems.map(mapChangedItems) : [];
    const updatedRecents = recentItems ? recentItems.map(mapChangedItems) : [];
    // this logic relies on the fact that we defer update favorites store on dropdown close
    // so we can assume that favorites list always affects recent list
    const favoritesIds = updatedFavorites.map((item)=>item.id);
    const filteredRecents = updatedRecents.filter((item)=>!favoritesIds.includes(Number(item.id)));
    return {
        favoriteItems: updatedFavorites,
        recentItems: filteredRecents
    };
};
const $08078ef8854f4ae2$var$getFilteredViewedItems = (viewedItems, // @ts-expect-error - TS2304 - Cannot find name 'IssueItem'.
workedOnItems)=>viewedItems?.filter((viewedItem)=>!workedOnItems?.some(// @ts-expect-error - TS2304 - Cannot find name 'IssueItem'.
        (workedOnItem)=>parseInt(workedOnItem.localResourceId, 10) === viewedItem.id && workedOnItem.type === viewedItem.type)) || [];
const $08078ef8854f4ae2$export$cad67ea3bdbadd5e = ()=>{
    const { changeFavorite: changeFavorite, items: { boards: changedItems } } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    const [recentData] = (0, $gGJaE.useRecentBoards)();
    const [favoriteData] = (0, $arAkG.useFavoriteBoards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $eUqFw.useMemo)(()=>$08078ef8854f4ae2$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $08078ef8854f4ae2$export$eb662c364f65f2a5 = ()=>{
    const { changeFavorite: changeFavorite, items: { dashboards: changedItems } } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    const [recentData] = (0, $gGJaE.useRecentDashboards)();
    const [favoriteData] = (0, $arAkG.useFavoriteDashboards)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $eUqFw.useMemo)(()=>$08078ef8854f4ae2$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $08078ef8854f4ae2$export$b00ea32725560f5d = ()=>{
    const { changeFavorite: changeFavorite, items: { filters: changedItems } } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    const [recentData] = (0, $gGJaE.useRecentFilters)();
    const [favoriteData] = (0, $arAkG.useFavoriteFilters)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $eUqFw.useMemo)(()=>$08078ef8854f4ae2$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $08078ef8854f4ae2$export$8448c28cc43804d4 = ()=>{
    const { changeFavorite: changeFavorite, items: { plans: changedItems } } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    const [{ items: items }] = (0, $j67d5.usePlansItems)();
    const [favoriteData] = (0, $arAkG.useFavoritePlans)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $eUqFw.useMemo)(()=>{
        const recentPlans = items?.recent ? items.recent.map(// the id is a concatenation of planId and scenarioId...
        // we need to strip the scenario so we just have the plan id
        (plan)=>({
                ...plan,
                id: plan.id.toString().split('|')[0]
            })) : [];
        return $08078ef8854f4ae2$var$getFavouriteAndRecentItems(recentPlans, favoriteData.items, changedItems);
    }, [
        items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $08078ef8854f4ae2$export$4a9469e6b2e4297c = ()=>{
    const { changeFavorite: changeFavorite, items: { projects: changedItems } } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    const [recentData] = (0, $gGJaE.useRecentProjects)();
    const [favoriteData] = (0, $arAkG.useFavoriteProjects)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $eUqFw.useMemo)(()=>$08078ef8854f4ae2$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};
const $08078ef8854f4ae2$export$5cfe5f7fc9ab5417 = ()=>{
    const [viewedData] = (0, $gGJaE.useRecentAllSingleList)();
    const [workedOnData] = (0, $gGJaE.useWorkedOnAllSingleList)();
    const viewedItems = (0, $eUqFw.useMemo)(()=>$08078ef8854f4ae2$var$getFilteredViewedItems(viewedData.items, workedOnData.items), [
        viewedData.items,
        workedOnData.items
    ]);
    return {
        workedOnItems: workedOnData.items || [],
        viewedItems: viewedItems
    };
};
const $08078ef8854f4ae2$export$7723949d2540d672 = ()=>{
    const { changeFavorite: changeFavorite, items: { queues: changedItems } } = (0, $eUqFw.useContext)((0, $dQZ5c.FavoriteChangeContext));
    const [recentData] = (0, $gGJaE.useRecentQueues)();
    const [favoriteData] = (0, $arAkG.useFavoriteQueues)();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = (0, $eUqFw.useMemo)(()=>$08078ef8854f4ae2$var$getFavouriteAndRecentItems(recentData.items, favoriteData.items, changedItems), [
        recentData.items,
        favoriteData.items,
        changedItems
    ]);
    return {
        changeFavorite: changeFavorite,
        changedItems: // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
        changedItems,
        favoriteItems: favoriteItems,
        recentItems: recentItems
    };
};

});
parcelRegister("j67d5", function(module, exports) {

$parcel$export(module.exports, "usePlansItems", () => $be19608a77c2b55a$export$9386de9ff002702a);

var $2zniw = parcelRequire("2zniw");

var $6vrw7 = parcelRequire("6vrw7");

var $WBLbN = parcelRequire("WBLbN");
const $be19608a77c2b55a$var$handleFetch = ()=>async ({ setState: setState, getState: getState })=>{
        const { fetchPlansItems: fetchPlansItems, baseUrl: baseUrl, isFetching: isFetching } = getState();
        if (!isFetching) try {
            const promise = fetchPlansItems(baseUrl);
            setState({
                isFetching: true,
                fetchError: null,
                promise: promise
            });
            const items = await promise;
            setState({
                items: items,
                hasFetchedOnce: true,
                hasSuccessOnce: true,
                isFetching: false,
                fetchError: null,
                promise: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (fetchError) {
            setState({
                ...getState(),
                fetchError: fetchError,
                hasFetchedOnce: true,
                isFetching: false,
                promise: null
            });
        }
    };
const $be19608a77c2b55a$var$actions = {
    load: ()=>async ({ dispatch: dispatch })=>{
            const promise = dispatch($be19608a77c2b55a$var$handleFetch());
            await promise;
        }
};
const $be19608a77c2b55a$export$b0dd7d935d0978a4 = ({ storeName: storeName = 'plans-item-store', fetchPlansItems: fetchPlansItems })=>{
    const initialState = {
        baseUrl: (0, $6vrw7.toBaseUrl)(''),
        fetchPlansItems: fetchPlansItems,
        hasFetchedOnce: false,
        hasSuccessOnce: false,
        items: null,
        fetchError: null,
        promise: null,
        isFetching: false
    };
    const Store = (0, $WBLbN.createStore)({
        name: storeName,
        actions: $be19608a77c2b55a$var$actions,
        initialState: initialState
    });
    const selector = ({ items: items, hasFetchedOnce: hasFetchedOnce, fetchError: fetchError, promise: promise, hasSuccessOnce: hasSuccessOnce, isFetching: isFetching })=>({
            items: items,
            hasFetchedOnce: hasFetchedOnce,
            hasSuccessOnce: hasSuccessOnce,
            fetchError: fetchError,
            promise: promise,
            isFetching: isFetching
        });
    const usePlansItems = (0, $WBLbN.createHook)(Store, {
        selector: selector
    });
    return {
        usePlansItems: usePlansItems
    };
};
const { usePlansItems: $be19608a77c2b55a$export$9386de9ff002702a } = $be19608a77c2b55a$export$b0dd7d935d0978a4({
    fetchPlansItems: (0, $2zniw.fetchPlansItems)
});

});
parcelRegister("2zniw", function(module, exports) {

$parcel$export(module.exports, "fetchPlansItems", () => $60516206d57201d0$export$ae5884604a8ac77b);

var $fVqUX = parcelRequire("fVqUX");

var $6vrw7 = parcelRequire("6vrw7");

const $60516206d57201d0$var$handleError = (error)=>{
    throw error;
};
const $60516206d57201d0$var$transformResult = ({ isVisible: isVisible, staticLinks: staticLinks, recentPlans: recentPlans = [] })=>{
    const recentItems = recentPlans.map(({ planId: planId, scenarioId: scenarioId, title: title, url: url })=>({
            id: `${planId}|${scenarioId}`,
            title: title || '',
            url: url,
            type: (0, $0e036566397b8f78$export$eebccb886b064713)
        }));
    return {
        isVisible: isVisible,
        recent: recentItems,
        links: staticLinks
    };
};
const $60516206d57201d0$export$ae5884604a8ac77b = async (baseUrl = (0, $6vrw7.toBaseUrl)(''))=>{
    const url = `${baseUrl}/rest/jpo/1.0/navigation`;
    try {
        const response = await fetch(url, (0, $fVqUX.default));
        if (response.ok) {
            const result = await response.json();
            return $60516206d57201d0$var$transformResult(result);
        }
        return $60516206d57201d0$var$handleError(new Error(response.statusText));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return $60516206d57201d0$var$handleError(error);
    }
};

});



parcelRegister("kQ1wU", function(module, exports) {
module.exports = new URL("dashboards-empty.ed2e5362.svg", import.meta.url).toString();

});

parcelRegister("7hv5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7283078176c4c2e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7283078176c4c2e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.dashboards.menu.empty.empty-text",
        "defaultMessage": "Create a dashboard to track the status of your projects."
    },
    learnMore: {
        "id": "atlassian-navigation.dashboards.menu.empty.learn-more",
        "defaultMessage": "More about dashboards"
    },
    emptyImg: {
        "id": "atlassian-navigation.dashboards.menu.empty.empty-img",
        "defaultMessage": "An image showing that the apps dropdown menu is empty"
    }
});

});


parcelRegister("cg6jV", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $2c3740b89a1bcae0$export$297af018011b145a);

var $eUqFw = parcelRequire("eUqFw");

var $hXGRB = parcelRequire("hXGRB");

var $5wpwq = parcelRequire("5wpwq");

var $jrdvV = parcelRequire("jrdvV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $lMin2 = parcelRequire("lMin2");

var $5kDtB = parcelRequire("5kDtB");

var $ba6Jq = parcelRequire("ba6Jq");

var $OBq1v = parcelRequire("OBq1v");

var $ctol0 = parcelRequire("ctol0");

var $1MAQq = parcelRequire("1MAQq");

var $7YV1L = parcelRequire("7YV1L");
const $2c3740b89a1bcae0$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $1MAQq.useDashboardNavItems)();
    const itemsToShow = (0, $eUqFw.useMemo)(()=>favoriteItems.slice(0, (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items-starred');
    const dashboardsUrl = '/jira/dashboards?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        testId: (0, $1YbJP.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $7YV1L.default).starred)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
            analytics: {
                actionSubjectId: 'dashboardsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hXGRB))), {
                label: "dashboard"
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ba6Jq.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $jrdvV.DASHBOARDS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $1YbJP.testIdConcat)(testId, `item-${idx}`),
            to: (0, $lMin2.dashboardViewRoute),
            params: {
                dashboardId: String(id)
            }
        }, title);
    }), favoriteItems.length >= (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctol0.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV)
        },
        href: dashboardsUrl,
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-view-all'),
        to: dashboardsUrl
    })) : null;
};

});
parcelRegister("lMin2", function(module, exports) {

$parcel$export(module.exports, "dashboardRoute", () => $9167559284392d0a$export$3bf0ecb39349b6ef);
$parcel$export(module.exports, "selectedDashboardRoute", () => $9167559284392d0a$export$b32070ee9554c3fb);
$parcel$export(module.exports, "dashboardEditRoute", () => $9167559284392d0a$export$b6e00d2cd7369fbd);
$parcel$export(module.exports, "dashboardWallboardRoute", () => $9167559284392d0a$export$eaa33c953ab9ca63);
$parcel$export(module.exports, "dashboardViewRoute", () => $9167559284392d0a$export$24f1b2ff97b9d3e6);
$parcel$export(module.exports, "dashboardViewEmbedRoute", () => $9167559284392d0a$export$258b5e3f294617d2);
$parcel$export(module.exports, "systemDashboardEditRoute", () => $9167559284392d0a$export$7367fb465296c7dd);

var $exb0h = parcelRequire("exb0h");
const $9167559284392d0a$export$3bf0ecb39349b6ef = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD),
    path: '/secure/Dashboard.jspa'
};
const $9167559284392d0a$export$b32070ee9554c3fb = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD_SELECTED),
    path: '/secure/Dashboard.jspa',
    query: [
        'selectPageId'
    ]
};
const $9167559284392d0a$export$b6e00d2cd7369fbd = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD_EDIT),
    path: '/jira/dashboards/:dashboardId(\\d+)/edit',
    query: [
        'maximized?'
    ],
    exact: true
};
const $9167559284392d0a$export$eaa33c953ab9ca63 = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD_WALLBOARD),
    path: '/jira/dashboards/wallboard',
    query: [
        'dashboardId',
        'cyclePeriod?',
        'transitionFx?',
        'random?'
    ],
    exact: true
};
const $9167559284392d0a$export$24f1b2ff97b9d3e6 = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD_VIEW),
    path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
    query: [
        'maximized?'
    ],
    exact: true
};
const $9167559284392d0a$export$258b5e3f294617d2 = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARD_VIEW_EMBED),
    path: '/jira/dashboards/:dashboardId(\\d+)/embed',
    query: [],
    exact: true
};
const $9167559284392d0a$export$7367fb465296c7dd = {
    group: (0, $exb0h.ROUTE_GROUPS_DASHBOARD),
    name: (0, $exb0h.ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT),
    path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
    query: [
        'maximized?'
    ]
};

});

parcelRegister("ba6Jq", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $a304e6028c459ac1$export$8d5dab2ad1e19ea0);

var $eUqFw = parcelRequire("eUqFw");

var $cTgSO = parcelRequire("cTgSO");

var $ktkCe = parcelRequire("ktkCe");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $a304e6028c459ac1$export$8d5dab2ad1e19ea0 = ({ beforeEntityId: // @ts-expect-error - TS2339 - Property 'beforeEntityId' does not exist on type 'FavoriteButtonProps'.
beforeEntityId, beforeEntityType: // @ts-expect-error - TS2339 - Property 'beforeEntityType' does not exist on type 'FavoriteButtonProps'.
beforeEntityType, id: id, isFavorite: isFavorite, favoriteItemName: favoriteItemName, isPending: isPending, menuItemType: menuItemType, onChangeFavorite: onChangeFavorite, type: type })=>{
    const { isVisible: isVisible } = (0, $cTgSO.useOverflowStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const contextualAnalyticsDataAttributes = (0, $eUqFw.useMemo)(()=>({
            isInMore: !isVisible,
            menuType: type,
            menuItemType: menuItemType
        }), [
        isVisible,
        menuItemType,
        type
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        const beforeEntity = beforeEntityId != null && beforeEntityType != null ? {
            beforeEntity: {
                id: beforeEntityId,
                type: beforeEntityType
            }
        } : undefined;
        onChangeFavorite({
            id: id,
            value: !isFavorite,
            type: type,
            ...beforeEntity
        });
        const actionSubject = type.slice(0, type.length - 1); // remove "s" from type ("projects" -> "project", etc)
        const action = isFavorite ? 'unstarred' : 'starred';
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, id);
    }, [
        beforeEntityId,
        beforeEntityType,
        createAnalyticsEvent,
        id,
        isFavorite,
        onChangeFavorite,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: contextualAnalyticsDataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ktkCe.default), {
        isSmall: true,
        isShownInList: true,
        isFavorite: isFavorite,
        favoriteItemName: favoriteItemName,
        pending: isPending,
        onClick: onClick
    }));
};

});
parcelRegister("ktkCe", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $3e4b24f33924a6f9$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $3e4b24f33924a6f9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $23Ou2 = parcelRequire("23Ou2");

var $7jsaI = parcelRequire("7jsaI");

var $daM3L = parcelRequire("daM3L");

var $hlWtt = parcelRequire("hlWtt");

var $8L5aC = parcelRequire("8L5aC");

var $cc1Cw = parcelRequire("cc1Cw");

var $2eG9N = parcelRequire("2eG9N");

var $8un0w = parcelRequire("8un0w");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $giAhk = parcelRequire("giAhk");

var $8rQuz = parcelRequire("8rQuz");

var $apShl = parcelRequire("apShl");

var $ivkNG = parcelRequire("ivkNG");
const $3e4b24f33924a6f9$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $3e4b24f33924a6f9$export$f8ad2acf0ec4860f extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $3e4b24f33924a6f9$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$export$db65185b5889c83, {
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': $3e4b24f33924a6f9$var$SKELETON_TEST_ID
            } : {
                'data-test-id': $3e4b24f33924a6f9$var$SKELETON_TEST_ID
            },
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const sizeProps = isSmall ? {
            size: 'small'
        } : {};
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': iconWrapperTestId
            } : {
                'data-test-id': iconWrapperTestId
            },
            isSmall: isSmall
        }, isFavorite ? // @ts-expect-error - TS2769 - No overload matches this call. | TS2769 - No overload matches this call.
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlWtt))), {
            ...sizeProps,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') && {
                label: formatMessage((0, $ivkNG.default).removeFromStarred)
            }
        }) : // @ts-expect-error - TS2769 - No overload matches this call. | TS2769 - No overload matches this call.
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daM3L))), {
            ...sizeProps,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') && {
                label: formatMessage((0, $ivkNG.default).addToStarred)
            }
        }));
        const renderIcon = ()=>{
            let label = '';
            if ((0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts')) {
                if (isFavorite) label = formatMessage((0, $ivkNG.default).removeFromStarred);
                else label = formatMessage((0, $ivkNG.default).addToStarred);
            }
            let StarIconComponent;
            if (isSmall) StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($8L5aC))) : (0, (/*@__PURE__*/$parcel$interopDefault($cc1Cw)));
            else StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($23Ou2))) : (0, (/*@__PURE__*/$parcel$interopDefault($7jsaI)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': iconWrapperTestId
            } : {
                'data-test-id': iconWrapperTestId
            },
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $ivkNG.default).removeFromStarred) : formatMessage((0, $ivkNG.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $ivkNG.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $ivkNG.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }, (0, $8rQuz.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isAnimating: false
        };
        this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        };
        this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $3e4b24f33924a6f9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $giAhk.injectIntlV2))($3e4b24f33924a6f9$export$f8ad2acf0ec4860f);
const $3e4b24f33924a6f9$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e4b24f33924a6f9$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBase = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseNew, $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $3e4b24f33924a6f9$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isFavorite ? "_syaz2kyj" : "_syaz2u25",
            __cmplp.isFavorite ? "_30l31ebw" : "_30l3w9a8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e4b24f33924a6f9$export$db65185b5889c83 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8un0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $da3e17e369dbbaa5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $etqm0 = parcelRequire("etqm0");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $da3e17e369dbbaa5$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eUqFw.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $da3e17e369dbbaa5$export$2e2bcd8739ae039 = $da3e17e369dbbaa5$var$fireWithUIAnalytics;

});

parcelRegister("ivkNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d79b2c2cf8a78bb3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d79b2c2cf8a78bb3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});



parcelRegister("ctol0", function(module, exports) {

$parcel$export(module.exports, "MenuItemViewAll", () => $630e545d37e8e9c4$export$2d5ce40137c4f96d);

var $eUqFw = parcelRequire("eUqFw");

var $8GAdb = parcelRequire("8GAdb");


var $5JgJ2 = parcelRequire("5JgJ2");

var $OBq1v = parcelRequire("OBq1v");

var $1GNBd = parcelRequire("1GNBd");
const $630e545d37e8e9c4$var$viewAllCssFn = ()=>({
        '&, &:hover, &:focus, & span': {
            color: `var(--ds-link, ${(0, $73a5c9d720aa66e1$exports).B400})`,
            textDecoration: 'none'
        },
        '&:active': {
            color: `var(--ds-link-pressed, ${(0, $73a5c9d720aa66e1$exports).B400})`,
            textDecoration: 'none'
        }
    });
const $630e545d37e8e9c4$export$2d5ce40137c4f96d = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        ...props,
        target: "_blank",
        cssFn: $630e545d37e8e9c4$var$viewAllCssFn,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8GAdb))), {
            label: formatMessage((0, $1GNBd.default).viewAllStarred)
        })
    }, formatMessage((0, $1GNBd.default).viewAllStarred));
};

});
parcelRegister("1GNBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef5081ab3c61307c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ef5081ab3c61307c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewAllStarred: {
        "id": "atlassian-navigation.common.menu.view-all.view-all-starred",
        "defaultMessage": "View all starred"
    }
});

});


parcelRegister("7YV1L", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1636e6f5d9baf0b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c1636e6f5d9baf0b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    starred: {
        "id": "atlassian-navigation.dashboards.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("hsM4u", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $cb04b79e5173518f$export$a06f1c675e846f6f);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $bLGeo = parcelRequire("bLGeo");

var $6yplV = parcelRequire("6yplV");

var $OBq1v = parcelRequire("OBq1v");

var $03N20 = parcelRequire("03N20");

var $lUbso = parcelRequire("lUbso");
const $cb04b79e5173518f$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items');
    const dashboardsUrl = '/jira/dashboards';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: dashboardsUrl,
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-view-all'),
        to: (0, $bLGeo.dashboardsDirectoryRoute)
    }, formatMessage((0, $lUbso.default).viewAll)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $03N20.CreateButton), {
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-create')
    }));
};

});
parcelRegister("bLGeo", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $f1b3b12941e660c6$export$41bba408475cab16);
$parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", () => $f1b3b12941e660c6$export$b96f6fb3c35a6fe5);

var $exb0h = parcelRequire("exb0h");
const $f1b3b12941e660c6$export$41bba408475cab16 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
    path: '/jira/dashboards'
};
const $f1b3b12941e660c6$export$b96f6fb3c35a6fe5 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
    path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
};

});

parcelRegister("03N20", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $99ce01f0d5e1c7ca$export$6d3c345ce7c38fd9);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4HwSc = parcelRequire("4HwSc");

var $5kDtB = parcelRequire("5kDtB");

var $OBq1v = parcelRequire("OBq1v");

var $38wiD = parcelRequire("38wiD");
const $99ce01f0d5e1c7ca$export$6d3c345ce7c38fd9 = ({ testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { on: modalOpen }] = (0, $4HwSc.useSwitchModals)((0, $5kDtB.MODAL_ID).DASHBOARD_CREATE);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'dashboardsNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        onClick: modalOpen,
        testId: testId
    }, formatMessage((0, $38wiD.default).createButton));
};

});
parcelRegister("4HwSc", function(module, exports) {

$parcel$export(module.exports, "useSwitchModals", () => $219a1920f5678086$export$5ed4b99cbad4ebd6);

var $7qgRx = parcelRequire("7qgRx");
const { useSwitch: $219a1920f5678086$var$useSwitch } = (0, $7qgRx.createSwitchController)('jira-switch-modals');
const $219a1920f5678086$export$5ed4b99cbad4ebd6 = $219a1920f5678086$var$useSwitch;

});

parcelRegister("38wiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ae4dff98337876$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f2ae4dff98337876$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createButton: {
        "id": "atlassian-navigation.dashboards.menu.footer.create-button.create-button",
        "defaultMessage": "Create dashboard"
    },
    notAllowed: {
        "id": "atlassian-navigation.dashboards.menu.footer.create-button.not-allowed",
        "defaultMessage": "You must be logged in to create dashboards"
    }
});

});


parcelRegister("lUbso", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdab63b50c7dae6d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bdab63b50c7dae6d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewAll: {
        "id": "atlassian-navigation.dashboards.menu.footer.view-all",
        "defaultMessage": "View all dashboards"
    }
});

});


parcelRegister("7PpAn", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $5c7d611ea29305df$export$c7df4a3f1b89de01);

var $eUqFw = parcelRequire("eUqFw");

var $arAkG = parcelRequire("arAkG");

var $gGJaE = parcelRequire("gGJaE");

var $efkaq = parcelRequire("efkaq");
const $5c7d611ea29305df$export$c7df4a3f1b89de01 = ({ shouldThrowError: shouldThrowError = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $efkaq.LoadStatus), {
        shouldThrowError: shouldThrowError,
        useProvider: (0, $arAkG.useFavoriteDashboards)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $efkaq.LoadStatus), {
        shouldThrowError: shouldThrowError,
        useProvider: (0, $gGJaE.useRecentDashboards)
    }));

});
parcelRegister("efkaq", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $a25251e4a36cbd15$export$c7df4a3f1b89de01);
const $a25251e4a36cbd15$export$c7df4a3f1b89de01 = ({ useProvider: useProvider, shouldThrowError: shouldThrowError = false })=>{
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const [{ fetchError: fetchError, isFetching: isFetching = false, promise: promise, hasSuccessOnce: hasSuccessOnce = false } = {}] = useProvider();
    if (fetchError != null && shouldThrowError && !hasSuccessOnce) throw fetchError;
    if (isFetching && !hasSuccessOnce) throw promise;
    return null;
};

});


parcelRegister("3WBRl", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $be8d3a08154120bb$export$a2873dc4e96d8e90);

var $eUqFw = parcelRequire("eUqFw");

var $hXGRB = parcelRequire("hXGRB");

var $5wpwq = parcelRequire("5wpwq");

var $jrdvV = parcelRequire("jrdvV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3rqlh = parcelRequire("3rqlh");

var $1YbJP = parcelRequire("1YbJP");

var $lMin2 = parcelRequire("lMin2");

var $5kDtB = parcelRequire("5kDtB");

var $ba6Jq = parcelRequire("ba6Jq");

var $OBq1v = parcelRequire("OBq1v");

var $1MAQq = parcelRequire("1MAQq");

var $7YFaK = parcelRequire("7YFaK");
const $be8d3a08154120bb$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $1MAQq.useDashboardNavItems)();
    const itemsToShow = (0, $eUqFw.useMemo)(()=>recentItems.slice(0, (0, $5kDtB.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        testId: (0, $1YbJP.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $7YFaK.default).recent)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $3rqlh.getBeforeEntity)(favoriteItems);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
            analytics: {
                actionSubjectId: 'dashboardsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hXGRB))), {
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ba6Jq.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $jrdvV.DASHBOARDS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $1YbJP.testIdConcat)(testId, `item-${idx}`),
            to: (0, $lMin2.dashboardViewRoute),
            params: {
                dashboardId: String(id)
            }
        }, title);
    })) : null;
};

});
parcelRegister("7YFaK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ace09a2358bc0ad2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ace09a2358bc0ad2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    recent: {
        "id": "atlassian-navigation.dashboards.menu.recent-content.recent",
        "defaultMessage": "Recent"
    },
    viewAll: {
        "id": "atlassian-navigation.dashboards.menu.recent-content.view-all",
        "defaultMessage": "View all recent"
    }
});

});



parcelRegister("efO5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $722b391217babb0b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $722b391217babb0b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dashboards: {
        "id": "atlassian-navigation.dashboards.dashboards",
        "defaultMessage": "Dashboards"
    }
});

});


parcelRegister("9BFwJ", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $02c4221c6c975dfc$export$92a576f896a9bf72);

var $eUqFw = parcelRequire("eUqFw");

var $bDhRl = parcelRequire("bDhRl");

var $arAkG = parcelRequire("arAkG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7vTKl = parcelRequire("7vTKl");

var $gGJaE = parcelRequire("gGJaE");

var $6yplV = parcelRequire("6yplV");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $olGf9 = parcelRequire("olGf9");

var $5H3md = parcelRequire("5H3md");

var $bAd0L = parcelRequire("bAd0L");

var $fyI2J = parcelRequire("fyI2J");

var $l7yVC = parcelRequire("l7yVC");
const $02c4221c6c975dfc$var$FiltersAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $olGf9.MenuTrigger), {
        href: "/jira/filters?searchName=&Search=Search&filterView=search",
        menuId: (0, $7vTKl.MENU_ID).FILTERS,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).FILTERS
    }, formatMessage((0, $l7yVC.default).filters));
};
const $02c4221c6c975dfc$var$FiltersLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteFilters: loadFavorite }] = (0, $arAkG.useFavoriteFilters)();
    const [, { loadRecentFilters: loadRecent }] = (0, $gGJaE.useRecentFilters)();
    const onStart = (0, $bDhRl.useExperienceStart)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $5kDtB.NAVIGATION_ITEM_ID).FILTERS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $eUqFw.useCallback)(()=>{
        onStart();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $5kDtB.DEFAULT_LOAD_COUNT_RECENT));
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $5kDtB.DEFAULT_LOAD_COUNT_FAV));
    }, [
        hasFetchedOnceFavorites,
        loadFavorite,
        loadRecent,
        onStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5H3md.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bAd0L.Popup), {
        menuId: (0, $7vTKl.MENU_ID).FILTERS,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).FILTERS,
        Menu: (0, $fyI2J.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $l7yVC.default).filters)
    }, formatMessage((0, $l7yVC.default).filters)));
};
const $02c4221c6c975dfc$var$FiltersWithAuth = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c4221c6c975dfc$var$FiltersAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c4221c6c975dfc$var$FiltersLoggedIn, null);
};
const $02c4221c6c975dfc$export$92a576f896a9bf72 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).FILTERS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c4221c6c975dfc$var$FiltersWithAuth, null));

});
parcelRegister("fyI2J", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $68cb3c98f1b29bd5$export$d9b273488cd8ce6f);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");

var $jasPp = parcelRequire("jasPp");

var $0cdA8 = parcelRequire("0cdA8");

var $4qhD6 = parcelRequire("4qhD6");

var $arAkG = parcelRequire("arAkG");

var $7vTKl = parcelRequire("7vTKl");

var $1YbJP = parcelRequire("1YbJP");

var $gGtKh = parcelRequire("gGtKh");

var $5kDtB = parcelRequire("5kDtB");

var $7VDWq = parcelRequire("7VDWq");

var $gIh7l = parcelRequire("gIh7l");

var $j5uqN = parcelRequire("j5uqN");

var $43NDK = parcelRequire("43NDK");

var $30EuL = parcelRequire("30EuL");

var $4bzGh = parcelRequire("4bzGh");

var $2cp2y = parcelRequire("2cp2y");

var $9HJSY = parcelRequire("9HJSY");

var $23TVs = parcelRequire("23TVs");
const $68cb3c98f1b29bd5$var$EVENT_DATA = {
    id: (0, $7vTKl.MENU_ID).FILTERS
};
const $68cb3c98f1b29bd5$export$d9b273488cd8ce6f = ({ AuthenticationErrorBoundary: AuthenticationErrorBoundary = (0, $jasPp.AuthenticationErrorBoundary), Empty: Empty = (0, $30EuL.Empty), Error: Error = (0, $7VDWq.MenuError), FavoriteContent: FavoriteContent = (0, $4bzGh.FavoriteContent), Footer: Footer = (0, $2cp2y.Footer), JSErrorBoundary: JSErrorBoundary = (0, $0cdA8.JSErrorBoundary), Layout: Layout = (0, $gIh7l.MenuLayout), LoadStatus: LoadStatus = (0, $9HJSY.LoadStatus), RecentContent: RecentContent = (0, $23TVs.RecentContent), Section: Section = (0, $8BKky.default), SkeletonContent: SkeletonContent = (0, $j5uqN.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $43NDK.MenuSkeletonFooter), testIdPrefix: testIdPrefix, useExperienceFail: useExperienceFail = (0, $4qhD6.useExperienceFail), useFavorite: useFavorite = (0, $arAkG.useFavoriteFilters) })=>{
    const [, { loadFavoriteFilters: loadFavorite }] = useFavorite();
    const onFail = useExperienceFail({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $eUqFw.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $5kDtB.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    const testIdContent = (0, $1YbJP.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $1YbJP.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Error, {
            testIdPrefix: testIdContent
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(JSErrorBoundary, {
        id: (0, $7vTKl.MENU_ID).FILTERS,
        packageName: (0, $5kDtB.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $68cb3c98f1b29bd5$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AuthenticationErrorBoundary, {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Empty, {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "atlassian-navigation-filters-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonContent, {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FavoriteContent, {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RecentContent, {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "atlassian-navigation-filters-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonFooter, {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Footer, {
        testIdPrefix: testIdFooter
    }))));
};

});
parcelRegister("30EuL", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $8ff6d82236e9f750$export$1f74963c34e8bfec);

var $eUqFw = parcelRequire("eUqFw");

var $1Yimi = parcelRequire("1Yimi");

var $fDZ6r = parcelRequire("fDZ6r");

var $arAkG = parcelRequire("arAkG");

var $4ksts = parcelRequire("4ksts");

var $1YbJP = parcelRequire("1YbJP");

var $gGJaE = parcelRequire("gGJaE");

var $6yplV = parcelRequire("6yplV");

var $5kDtB = parcelRequire("5kDtB");

var $hhftg = parcelRequire("hhftg");

var $1MAQq = parcelRequire("1MAQq");

var $lhp1l = parcelRequire("lhp1l");

var $kUhsD = parcelRequire("kUhsD");
const $8ff6d82236e9f750$var$learnMoreHref = 'https://confluence.atlassian.com/jirasoftwarecloud/searching-for-issues-764478280.html#Searchingforissues-SearchallofJira';
const $8ff6d82236e9f750$export$1f74963c34e8bfec = ({ MenuInfo: MenuInfo = (0, $hhftg.MenuInfo), children: children, testIdPrefix: testIdPrefix, useExperienceSuccess: useExperienceSuccess = (0, $fDZ6r.useExperienceSuccess), useFavorite: useFavorite = (0, $arAkG.useFavoriteFilters), useIntl: useIntl = (0, $4ksts.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $6yplV.useIsAnonymous), useItems: useItems = (0, $1MAQq.useFilterNavItems), useRecent: useRecent = (0, $gGJaE.useRecentFilters) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const onSuccess = useExperienceSuccess({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $kUhsD.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: $8ff6d82236e9f750$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $kUhsD.default).learnMore))));
    const [{ isFetching: isFetchingFavorite, hasSuccessOnce: hasSuccessOnceFavorite, fetchError: fetchErrorFavorite }] = useFavorite();
    const [{ isFetching: isFetchingRecent, hasSuccessOnce: hasSuccessOnceRecent, fetchError: fetchErrorRecent }] = useRecent();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = useItems();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    const shouldShowEmptyForAnonymous = isAnonymous;
    (0, $eUqFw.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'empty');
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuInfo, {
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($lhp1l))),
        testId: testId,
        text: text
    });
};

});
parcelRegister("lhp1l", function(module, exports) {
module.exports = new URL("filter-empty.4c92f05b.svg", import.meta.url).toString();

});

parcelRegister("kUhsD", function(module, exports) {

$parcel$export(module.exports, "default", () => $919090b9c22b3c02$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $919090b9c22b3c02$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.filters.menu.empty.empty-text",
        "defaultMessage": "Search for issues across all projects and save them as filters."
    },
    learnMore: {
        "id": "atlassian-navigation.filters.menu.empty.learn-more",
        "defaultMessage": "Learn more"
    },
    emptyImg: {
        "id": "atlassian-navigation.filters.menu.empty.empty-img",
        "defaultMessage": "An image showing that the apps dropdown menu is empty"
    }
});

});


parcelRegister("4bzGh", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $6950d900e1527910$export$297af018011b145a);

var $eUqFw = parcelRequire("eUqFw");

var $4ki2H = parcelRequire("4ki2H");

var $5wpwq = parcelRequire("5wpwq");

var $jrdvV = parcelRequire("jrdvV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k1Gwk = parcelRequire("k1Gwk");

var $1YbJP = parcelRequire("1YbJP");

var $LSeRk = parcelRequire("LSeRk");

var $5kDtB = parcelRequire("5kDtB");

var $ba6Jq = parcelRequire("ba6Jq");

var $OBq1v = parcelRequire("OBq1v");

var $cwU5v = parcelRequire("cwU5v");

var $ctol0 = parcelRequire("ctol0");

var $1MAQq = parcelRequire("1MAQq");

var $6m81L = parcelRequire("6m81L");
const $6950d900e1527910$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $1MAQq.useFilterNavItems)();
    const itemsToShow = (0, $eUqFw.useMemo)(()=>favoriteItems.slice(0, (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items-starred');
    const filtersUrl = '/jira/filters?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        testId: (0, $1YbJP.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $6m81L.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const filterParams = {
            issueKey: ''
        };
        const filterQuery = {
            filter: String(id)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $6m81L.default).starred)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
            analytics: {
                actionSubjectId: 'filtersNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ki2H))), {
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ba6Jq.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $jrdvV.FILTERS_ITEM_TYPE)
            }),
            params: filterParams,
            query: filterQuery,
            testId: (0, $1YbJP.testIdConcat)(testId, `item-${idx}`),
            to: (0, $LSeRk.globalIssueNavigatorRoute),
            onClick: (0, $k1Gwk.handleGinSPAClick)
        }, title));
    })), favoriteItems.length >= (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctol0.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV)
        },
        href: filtersUrl,
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-view-all'),
        to: filtersUrl
    })) : null;
};

});
parcelRegister("k1Gwk", function(module, exports) {

$parcel$export(module.exports, "handleGinSPAClick", () => $a65fc66c59a7c333$export$f74673b086629362);
const $a65fc66c59a7c333$export$f74673b086629362 = (e)=>{
    const href = // @ts-expect-error - TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'. | TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'.
    typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
    const openInNewTab = // @ts-expect-error - TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'.
    e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button != null && e.button === 1;
    if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
    if (window.JIRA?.Issues?.Application) {
        e.preventDefault();
        window.JIRA.Issues.Application.execute('navigation:navigateToUrl', href, {
            forceRefresh: true,
            checkPermission: true,
            replace: false,
            reset: true,
            routerEvent: true
        });
    }
};

});

parcelRegister("LSeRk", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRoute", () => $02ff176d6c4428e4$export$f4c8e8bc55cd2008);
$parcel$export(module.exports, "globalIssueNavigatorBrowseRoute", () => $02ff176d6c4428e4$export$c1b37e392499fccf);
$parcel$export(module.exports, "globalIssueNavigatorRedirectRoute", () => $02ff176d6c4428e4$export$b2cd2888fd62d62e);

var $exb0h = parcelRequire("exb0h");
const $02ff176d6c4428e4$export$f4c8e8bc55cd2008 = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_GIN),
    path: '/issues/:issueKey(.*)?',
    apdexIgnoreParams: [
        'issueKey'
    ]
};
const $02ff176d6c4428e4$export$c1b37e392499fccf = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_GIN_ISSUE),
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};
const $02ff176d6c4428e4$export$b2cd2888fd62d62e = {
    name: (0, $exb0h.ROUTE_NAMES_LEGACY_GIN_QUICKSEARCH),
    path: '/secure/QuickSearch.jspa',
    query: [
        'searchString'
    ]
};

});

parcelRegister("6m81L", function(module, exports) {

$parcel$export(module.exports, "default", () => $60d92cc669b843c8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $60d92cc669b843c8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    starred: {
        "id": "atlassian-navigation.filters.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("2cp2y", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $3b60923b0364823b$export$a06f1c675e846f6f);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $1cmFR = parcelRequire("1cmFR");

var $OBq1v = parcelRequire("OBq1v");

var $fS2B1 = parcelRequire("fS2B1");
const $3b60923b0364823b$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: "/jira/filters?searchName=&Search=Search&filterView=search",
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-view-all'),
        to: (0, $1cmFR.filtersDirectoryRoute)
    }, formatMessage((0, $fS2B1.default).viewAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'filtersNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        href: `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`,
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-create')
    }, formatMessage((0, $fS2B1.default).viewAllIssues)));
};

});
parcelRegister("1cmFR", function(module, exports) {

$parcel$export(module.exports, "filtersDirectoryRoute", () => $c5d476788b048c23$export$6350f52c8b40042d);
$parcel$export(module.exports, "filtersDirectoryRedirectRoute", () => $c5d476788b048c23$export$f4f86e1ddc30a625);
$parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", () => $c5d476788b048c23$export$50796f2aecd63181);

var $exb0h = parcelRequire("exb0h");
const $c5d476788b048c23$export$6350f52c8b40042d = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY),
    path: '/jira/filters'
};
const $c5d476788b048c23$export$f4f86e1ddc30a625 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY)}-redirect`,
    path: '/ManageFilters.jspa'
};
const $c5d476788b048c23$export$50796f2aecd63181 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY_SECURE)}-redirect`,
    path: '/secure/ManageFilters.jspa'
};

});

parcelRegister("fS2B1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffc11b2f55deb80e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ffc11b2f55deb80e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewAllIssues: {
        "id": "atlassian-navigation.filters.menu.footer.view-all-issues",
        "defaultMessage": "View all issues"
    },
    viewAll: {
        "id": "atlassian-navigation.filters.menu.footer.view-all",
        "defaultMessage": "View all filters"
    }
});

});


parcelRegister("9HJSY", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $19187c12c4c3e0ad$export$c7df4a3f1b89de01);

var $eUqFw = parcelRequire("eUqFw");

var $arAkG = parcelRequire("arAkG");

var $gGJaE = parcelRequire("gGJaE");

var $efkaq = parcelRequire("efkaq");
const $19187c12c4c3e0ad$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $efkaq.LoadStatus), shouldThrowError: shouldThrowError = false, useFavorite: useFavorite = (0, $arAkG.useFavoriteFilters), useRecent: useRecent = (0, $gGJaE.useRecentFilters) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useFavorite
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useRecent
    }));

});

parcelRegister("23TVs", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $5abfa6db9e1d725c$export$a2873dc4e96d8e90);

var $eUqFw = parcelRequire("eUqFw");

var $4ki2H = parcelRequire("4ki2H");

var $5wpwq = parcelRequire("5wpwq");

var $jrdvV = parcelRequire("jrdvV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k1Gwk = parcelRequire("k1Gwk");

var $3rqlh = parcelRequire("3rqlh");

var $1YbJP = parcelRequire("1YbJP");

var $LSeRk = parcelRequire("LSeRk");

var $5kDtB = parcelRequire("5kDtB");

var $ba6Jq = parcelRequire("ba6Jq");

var $OBq1v = parcelRequire("OBq1v");

var $cwU5v = parcelRequire("cwU5v");

var $1MAQq = parcelRequire("1MAQq");

var $8CFGJ = parcelRequire("8CFGJ");
const $5abfa6db9e1d725c$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $1MAQq.useFilterNavItems)();
    const itemsToShow = (0, $eUqFw.useMemo)(()=>recentItems.slice(0, (0, $5kDtB.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        testId: (0, $1YbJP.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $8CFGJ.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $3rqlh.getBeforeEntity)(favoriteItems);
        const filterParams = {
            issueKey: ''
        };
        const filterQuery = {
            filter: String(id)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $8CFGJ.default).recent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
            analytics: {
                actionSubjectId: 'filtersNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ki2H))), {
                label: ""
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ba6Jq.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $jrdvV.FILTERS_ITEM_TYPE)
            }),
            params: filterParams,
            query: filterQuery,
            testId: (0, $1YbJP.testIdConcat)(testId, `item-${idx}`),
            to: (0, $LSeRk.globalIssueNavigatorRoute),
            onClick: (0, $k1Gwk.handleGinSPAClick)
        }, title));
    }))) : null;
};

});
parcelRegister("8CFGJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aafbd5b3010bc26$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8aafbd5b3010bc26$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    recent: {
        "id": "atlassian-navigation.filters.menu.recent-content.recent",
        "defaultMessage": "Recent"
    }
});

});



parcelRegister("l7yVC", function(module, exports) {

$parcel$export(module.exports, "default", () => $61756fbd1ecb31ce$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $61756fbd1ecb31ce$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filters: {
        "id": "atlassian-navigation.filters.filters",
        "defaultMessage": "Filters"
    }
});

});


parcelRegister("d6qhr", function(module, exports) {

$parcel$export(module.exports, "Help", () => $66c01996877c87bf$export$1be7516c0280bee8);

var $eUqFw = parcelRequire("eUqFw");

var $55pTl = parcelRequire("55pTl");

var $7rh0R = parcelRequire("7rh0R");

var $cEaY5 = parcelRequire("cEaY5");

var $ltfxy = parcelRequire("ltfxy");

var $XHGTv = parcelRequire("XHGTv");

var $3MV1G = parcelRequire("3MV1G");

var $kwMhr = parcelRequire("kwMhr");

var $9EHc8 = parcelRequire("9EHc8");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bUi2Q = parcelRequire("bUi2Q");

var $7vTKl = parcelRequire("7vTKl");

var $3BTZc = parcelRequire("3BTZc");

var $1YbJP = parcelRequire("1YbJP");

var $gGtKh = parcelRequire("gGtKh");

var $hzcvF = parcelRequire("hzcvF");

var $SEaoU = parcelRequire("SEaoU");

var $6yplV = parcelRequire("6yplV");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $kJ2sY = parcelRequire("kJ2sY");

var $huD75 = parcelRequire("huD75");

var $gvn5f = parcelRequire("gvn5f");

var $dqcyj = parcelRequire("dqcyj");

var $8IIoH = parcelRequire("8IIoH");

var $kvXhB = parcelRequire("kvXhB");
const $66c01996877c87bf$export$e29577842f211e22 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $66c01996877c87bf$var$LazyBadge = (0, $7rh0R.lazy)(()=>(parcelRequire("1tVAU")).then((module)=>module.Badge), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/help/badge/index.tsx"
});
const $66c01996877c87bf$var$Badge = (props)=>{
    if ((0, $eI5EY.fg)('ttvc_global_navigation_improvement')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dqcyj.Badge), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $5kDtB.NAVIGATION_ITEM_ID).HELP_BADGE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy-badge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($66c01996877c87bf$var$LazyBadge, props)));
};
const $66c01996877c87bf$var$SpotlightTargetComponent = ({ children: children })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($66c01996877c87bf$export$e29577842f211e22, {
        name: (0, $5kDtB.HELP_SPOTLIGHT_KEY)
    }, children), (0, $eI5EY.fg)('add_engagement_spotlight_to_navbar_button') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        name: (0, $5kDtB.HELP_SPOTLIGHT_KEY)
    }));
const $66c01996877c87bf$var$Help = ()=>{
    const [{ data: projectData }] = (0, $SEaoU.useContainerContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = (0, $3BTZc.useTopMenus)((0, $7vTKl.MENU_ID).HELP);
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const [topMenusValue, { off: closeAllMenus }] = (0, $3BTZc.useTopMenus)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const { releaseNotesNotifications: releaseNotesNotifications, setReleaseNotesNotifications: setReleaseNotesNotifications } = (0, $huD75.useHelpButtonState)();
    const isIPH = (0, $1ybV0.ff)('iph.enabled');
    const helpButtonRef = (0, $eUqFw.useRef)(null);
    let isProjectSimplified = false;
    if (projectData && 'project' in projectData && projectData.project) isProjectSimplified = projectData.project.isSimplified;
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const attributes = isIPH ? {
        helpPanelVersion: (0, $f2Poq.HELP_PANEL_VERSION),
        helpPanelType: 'inProductHelp',
        nextGenProject: isProjectSimplified
    } : {
        helpPanelType: 'dropdown',
        nextGenProject: isProjectSimplified
    };
    const triggerAnalytics = (0, $gvn5f.useNavigationItemAnalytics)({
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).HELP
    });
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const currentRightSidebarState = (0, $bUi2Q.useActiveRightSidebarState)();
    const isHelpPanelOpenedPreviously = (0, $hzcvF.usePrevious)(currentRightSidebarState);
    const testIdPrefix = (0, $1YbJP.testIdGenerate)('secondary-actions', 'help');
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
            application: null,
            analyticsSource: "atlassian-navigation",
            experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU),
            experienceId: (0, $5kDtB.NAVIGATION_ITEM_ID).HELP,
            edition: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
            location: "atlassian-navigation--secondary-actions--help--menu-popup",
            parentProviders: null,
            failureEventAttributes: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8IIoH.Menu), {
            testIdPrefix: testIdPrefix
        }))), [
        testIdPrefix
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (isIPH) {
            if (currentRightSidebarState && currentRightSidebarState.panelId === (0, $f2Poq.HELP_PANEL_ID) && !currentRightSidebarState.isCollapsed) closeCurrentRightSidebar();
            else openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
            closeAllMenus();
            setNavigationData({
                articleId: {
                    id: '',
                    type: (0, $cEaY5.ARTICLE_TYPE).HELP_ARTICLE
                },
                history: []
            });
        } else toggleMenu();
        // Shows if the help panel is currently open or closed
        const isPanelOpen = currentRightSidebarState?.panelId === (0, $f2Poq.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed;
        triggerAnalytics({
            ...attributes,
            ...(0, $XHGTv.getBooleanFF)('platform.navigation-help-opened-closed-indicator_b9xbt') ? // Negating the current state of the panel to show if the panel is being opened or closed
            {
                isOpened: !isPanelOpen
            } : {}
        });
    }, [
        isIPH,
        triggerAnalytics,
        attributes,
        currentRightSidebarState,
        closeAllMenus,
        setNavigationData,
        closeCurrentRightSidebar,
        openRightSidebar,
        toggleMenu
    ]);
    const badge = (0, $eUqFw.useCallback)(()=>{
        if (isAnonymous) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($66c01996877c87bf$var$Badge, {
            isNotificationCleared: releaseNotesNotifications === 0
        });
    }, [
        isAnonymous,
        releaseNotesNotifications
    ]);
    const TriggerComponent = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": (0, $1YbJP.testIdConcat)(testIdPrefix, 'menu-trigger')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($66c01996877c87bf$var$SpotlightTargetComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ2sY.Help), {
            ...triggerProps,
            isSelected: isMenuOpen,
            badge: badge,
            onClick: onClick,
            tooltip: formatMessage((0, $kvXhB.default).tooltip),
            label: formatMessage((0, $kvXhB.default).label),
            ref: helpButtonRef
        }))), [
        testIdPrefix,
        isMenuOpen,
        badge,
        onClick,
        formatMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!currentRightSidebarState?.isCollapsed && releaseNotesNotifications !== 0) setReleaseNotesNotifications(0);
    }, [
        releaseNotesNotifications,
        setReleaseNotesNotifications,
        currentRightSidebarState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isIPH) {
            if (currentRightSidebarState?.panelId === (0, $f2Poq.HELP_PANEL_ID) && !currentRightSidebarState?.isCollapsed) openMenu();
            else {
                closeMenu();
                if (isHelpPanelOpenedPreviously?.panelId === (0, $f2Poq.HELP_PANEL_ID) && !currentRightSidebarState) requestAnimationFrame(()=>helpButtonRef.current?.focus());
            }
        }
    }, [
        closeMenu,
        currentRightSidebarState,
        isHelpPanelOpenedPreviously,
        isIPH,
        openMenu,
        topMenusValue
    ]);
    if (false || isIPH) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TriggerComponent, {
        "aria-expanded": false,
        "aria-haspopup": !isIPH
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        content: content,
        placement: "bottom-end",
        isOpen: isMenuOpen,
        onClose: closeMenu,
        trigger: TriggerComponent
    });
};
const $66c01996877c87bf$export$1be7516c0280bee8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $5kDtB.NAVIGATION_ITEM_ID).HELP
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($66c01996877c87bf$var$Help, null));

});
parcelRegister("kJ2sY", function(module, exports) {

$parcel$export(module.exports, "Help", () => $78a943df1142ce3b$export$1be7516c0280bee8);

var $eUqFw = parcelRequire("eUqFw");

var $8YHhh = parcelRequire("8YHhh");

var $lUkcz = parcelRequire("lUkcz");

var $6FP8W = parcelRequire("6FP8W");

var $dB8Wo = parcelRequire("dB8Wo");
const $78a943df1142ce3b$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    if (false) {
        if ((0, $6FP8W.getWillShowNav4)()) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUkcz.Nav4SkeletonHelpButton), {
            label: props.tooltip
        });
        // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUkcz.SkeletonHelpButton), {
            label: props.tooltip
        });
    }
    if ((0, $6FP8W.getWillShowNav4)()) {
        const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dB8Wo.Help), {
            badge: badge,
            label: label,
            onClick: onClick,
            isSelected: isSelected
        });
    }
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8YHhh.Help), buttonProps);
});

});

parcelRegister("huD75", function(module, exports) {

$parcel$export(module.exports, "useHelpButtonState", () => $fd2c5bbe83246674$export$e3d3de46b23d1ede);

var $eUqFw = parcelRequire("eUqFw");

var $dxcfv = parcelRequire("dxcfv");

var $04RLb = parcelRequire("04RLb");
const $fd2c5bbe83246674$export$53f45136e435c2fd = 'help_button_ui_state';
const $fd2c5bbe83246674$export$e3d3de46b23d1ede = ()=>{
    const [releaseNotesNotifications, setReleaseNotesNotifications] = (0, $eUqFw.useState)(null);
    const [userReleaseNotesNotifications, setUserReleaseNotesNotifications] = (0, $eUqFw.useState)(null);
    const accountId = (0, $dxcfv.useAccountId)();
    const updateData = (0, $eUqFw.useCallback)(()=>{
        if (userReleaseNotesNotifications !== null) {
            const newReleaseNotesNotificationsValue = userReleaseNotesNotifications !== undefined ? userReleaseNotesNotifications : 100;
            if (releaseNotesNotifications !== null) {
                if (userReleaseNotesNotifications !== releaseNotesNotifications) {
                    const remoteData = {
                        helpPanelMenu: {
                            releaseNotesNotifications: releaseNotesNotifications
                        }
                    };
                    (0, $04RLb.updateHelpButtonState)(accountId, remoteData);
                }
            } else setReleaseNotesNotifications(newReleaseNotesNotificationsValue);
        }
    }, [
        accountId,
        releaseNotesNotifications,
        userReleaseNotesNotifications
    ]);
    const restoreReleaseNotesNotifications = (0, $eUqFw.useCallback)(async ()=>{
        if (accountId) {
            const userPropertiesHelpButtonValue = await (0, $04RLb.getHelpButtonState)(accountId);
            setUserReleaseNotesNotifications(userPropertiesHelpButtonValue?.releaseNotesNotifications);
        } else setUserReleaseNotesNotifications(0);
    }, [
        accountId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (userReleaseNotesNotifications === null) restoreReleaseNotesNotifications();
        else updateData();
    }, [
        userReleaseNotesNotifications,
        restoreReleaseNotesNotifications,
        updateData
    ]);
    return {
        releaseNotesNotifications: releaseNotesNotifications,
        setReleaseNotesNotifications: setReleaseNotesNotifications
    };
};

});
parcelRegister("04RLb", function(module, exports) {

$parcel$export(module.exports, "updateHelpButtonState", () => $7b2736cdd4c2175f$export$c70764abdc0ffd52);
$parcel$export(module.exports, "getHelpButtonState", () => $7b2736cdd4c2175f$export$9716b2ae6c8887b0);

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

const $7b2736cdd4c2175f$export$c70764abdc0ffd52 = async (accountId, data)=>{
    if (accountId !== null) try {
        await (0, $48bs8.setUserProperties)(accountId, (0, $54e8b0e50a23a6f4$export$53f45136e435c2fd), JSON.stringify(data));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            error: e,
            meta: {
                id: 'updateServerHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
};
const $7b2736cdd4c2175f$export$9716b2ae6c8887b0 = async (accountId)=>{
    try {
        // @ts-expect-error - Property 'helpPanelMenu' does not exist on type 'unknown'.
        const { helpPanelMenu: userPropertiesHelpButtonValue } = await (0, $48bs8.getUserProperty)(accountId, (0, $54e8b0e50a23a6f4$export$53f45136e435c2fd));
        return userPropertiesHelpButtonValue;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            error: e,
            meta: {
                id: 'getHelpButtonState',
                packageName: 'jiraAtlassianNavigation',
                teamName: 'navigation'
            }
        });
    }
    return null;
};

});
const $54e8b0e50a23a6f4$export$53f45136e435c2fd = 'help_button_ui_state';



parcelRegister("dqcyj", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $cad6fc6e2666bf9e$export$37acb3580601e69a);

var $eUqFw = parcelRequire("eUqFw");

var $fcmS9 = parcelRequire("fcmS9");

var $1zRTT = parcelRequire("1zRTT");

var $fN0nH = parcelRequire("fN0nH");
class $cad6fc6e2666bf9e$var$MockNotificationLogClient extends (0, $fcmS9.NotificationLogClient) {
    constructor(countValue){
        super('', '');
        this.count = 0;
        this.count = countValue;
    }
    countUnseenNotifications() {
        return Promise.resolve({
            count: this.count
        });
    }
}
const $cad6fc6e2666bf9e$var$emptyClient = new $cad6fc6e2666bf9e$var$MockNotificationLogClient(0);
const $cad6fc6e2666bf9e$export$32bd6ac078326cec = async (isNotificationCleared)=>{
    const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $1zRTT.useHelpPanel)();
    const notificationLogProvider = (0, $eUqFw.useMemo)(()=>new $cad6fc6e2666bf9e$var$MockNotificationLogClient(releaseNotesNotifications), [
        releaseNotesNotifications
    ]);
    const result = await Promise.resolve(isNotificationCleared || false || releaseNotesNotifications === 0 ? $cad6fc6e2666bf9e$var$emptyClient : notificationLogProvider);
    return result;
};
const $cad6fc6e2666bf9e$export$37acb3580601e69a = ({ isNotificationCleared: isNotificationCleared })=>{
    const [notifications, setNotifications] = (0, $eUqFw.useState)(0);
    const notificationLogProvider = $cad6fc6e2666bf9e$export$32bd6ac078326cec(isNotificationCleared);
    (0, $eUqFw.useEffect)(()=>{
        const initNotifications = async ()=>{
            const result = await notificationLogProvider;
            setNotifications(result.count);
        };
        initNotifications();
    }, [
        notificationLogProvider
    ]);
    return notifications > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fN0nH.LazyNotifications), {
        max: 3,
        appearance: "primary"
    }, notifications) : null;
};

});
parcelRegister("fN0nH", function(module, exports) {

$parcel$export(module.exports, "LazyNotifications", () => $1b85335a2cc30572$export$eebecbd0322becdd);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $5kDtB = parcelRequire("5kDtB");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1b85335a2cc30572$var$Notifications = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7CYJZ")), {
    ssr: false,
    moduleId: "../platform/packages/design-system/badge/src/index.tsx"
});
const $1b85335a2cc30572$export$eebecbd0322becdd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "help.atlaskit-badge",
        packageName: (0, $5kDtB.PACKAGE_NAME),
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy-notification-badge",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b85335a2cc30572$var$Notifications, props)));

});
parcelRegister("7CYJZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aVfoO").then(()=>parcelRequire('8KefA'));

});



parcelRegister("8IIoH", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $09dfceb0ddc88eea$export$d9b273488cd8ce6f);

var $eUqFw = parcelRequire("eUqFw");

var $5wpwq = parcelRequire("5wpwq");
var $8BKky = parcelRequire("8BKky");

var $1c02D = parcelRequire("1c02D");

var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $10fdS = parcelRequire("10fdS");

var $SEaoU = parcelRequire("SEaoU");

var $4HwSc = parcelRequire("4HwSc");

var $c7H0g = parcelRequire("c7H0g");

var $6yplV = parcelRequire("6yplV");

var $1R3n5 = parcelRequire("1R3n5");

var $bLRqM = parcelRequire("bLRqM");

var $5kDtB = parcelRequire("5kDtB");

var $OBq1v = parcelRequire("OBq1v");

var $gIh7l = parcelRequire("gIh7l");

var $krqXt = parcelRequire("krqXt");
const $09dfceb0ddc88eea$var$PLATFORM_FEEDBACK_GROUP_ID = 'jira-platform-general';
const $09dfceb0ddc88eea$var$unknownAttributeValue = 'unknown';
const $09dfceb0ddc88eea$var$docsUrlMap = {
    software: 'https://confluence.atlassian.com/jirasoftwarecloud/',
    serviceDesk: 'https://confluence.atlassian.com/servicedeskcloud/',
    core: 'https://confluence.atlassian.com/jiracorecloud/',
    jira: 'https://confluence.atlassian.com/alldoc/',
    // POL-1811 JPD temporary docs url, to be replaced once available
    'product-discovery': 'https://confluence.atlassian.com/alldoc/'
};
const $09dfceb0ddc88eea$var$GET_JIRA_MOBILE_APP_PAGE = 'https://www.atlassian.com/software/jira/mobile-app?source=jira-help';
const $09dfceb0ddc88eea$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const productName = (0, $bLRqM.useProductName)();
    const [, { on: openKeyboardShortcuts }] = (0, $4HwSc.useSwitchModals)((0, $5kDtB.MODAL_ID).KEYBOARD_SHORTCUTS);
    let position = 0;
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'menu-popup');
    const route = (0, $10fdS.useCurrentRoute)();
    const [{ data: projectData }] = (0, $SEaoU.useContainerContext)();
    const routeGroup = route.group ?? $09dfceb0ddc88eea$var$unknownAttributeValue;
    const routeName = route.name ?? $09dfceb0ddc88eea$var$unknownAttributeValue;
    let projectType = $09dfceb0ddc88eea$var$unknownAttributeValue;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (projectData && projectData.project) // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    projectType = projectData.project.type;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIh7l.MenuLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        testId: (0, $1YbJP.testIdConcat)(testId, 'help', 'heading')
    }, formatMessage((0, $krqXt.default).headingHelp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'helpNavigationMenuItem',
            menuItemId: 'atlassian-documentation',
            menuItemType: 'help',
            position: position++
        },
        href: $09dfceb0ddc88eea$var$docsUrlMap[productName],
        target: "_blank",
        testId: (0, $1YbJP.testIdConcat)(testId, 'help', 'item-atlassian-documentation')
    }, formatMessage((0, $krqXt.default).atlassianDocumentation)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'helpNavigationMenuItem',
            menuItemId: 'atlassian-community',
            menuItemType: 'help',
            position: position++
        },
        href: "https://community.atlassian.com",
        target: "_blank",
        testId: (0, $1YbJP.testIdConcat)(testId, 'help', 'item-atlassian-community')
    }, formatMessage((0, $krqXt.default).atlassianCommunity)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'helpNavigationMenuItem',
            menuItemId: 'whats-new',
            menuItemType: 'help',
            position: position++
        },
        href: "https://confluence.atlassian.com/pages/viewrecentblogposts.action?key=Cloud",
        target: "_blank",
        testId: (0, $1YbJP.testIdConcat)(testId, 'help', 'item-whats-new')
    }, formatMessage((0, $krqXt.default).whatsNew)), isAdmin || isSiteAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'helpNavigationMenuItem',
            menuItemId: 'raise-a-bug',
            menuItemType: 'help',
            position: position++
        },
        href: "https://support.atlassian.com/contact/",
        target: "_blank",
        testId: (0, $1YbJP.testIdConcat)(testId, 'help', 'item-raise-a-bug')
    }, formatMessage((0, $krqXt.default).raiseABug)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $irg9D.FeedbackActionsSubscriber), null, (__, { openFeedbackCollector: openFeedbackCollector })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
            analytics: {
                actionSubjectId: 'helpNavigationMenuItem',
                menuItemId: 'feedback',
                menuItemType: 'help',
                position: position++
            },
            onClick: ()=>{
                openFeedbackCollector({
                    entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_PLATFORM),
                    feedbackGroupId: $09dfceb0ddc88eea$var$PLATFORM_FEEDBACK_GROUP_ID,
                    additionalFields: [
                        {
                            id: 'route-name',
                            value: routeName
                        },
                        {
                            id: 'route-group',
                            value: routeGroup
                        },
                        {
                            id: 'project-type',
                            value: projectType
                        }
                    ]
                });
            },
            testId: (0, $1YbJP.testIdConcat)(testId, 'help', 'item-feedback')
        }, formatMessage((0, $krqXt.default).giveFeedback))), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'helpNavigationMenuItem',
            menuItemId: 'get-mobile',
            menuItemType: 'help',
            position: position++
        },
        testId: (0, $1YbJP.testIdConcat)(testId, 'help', 'item-get-mobile'),
        href: $09dfceb0ddc88eea$var$GET_JIRA_MOBILE_APP_PAGE,
        target: "_blank"
    }, formatMessage((0, $krqXt.default).getMobile)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'helpNavigationMenuItem',
            menuItemId: 'keyboard-shortcuts',
            menuItemType: 'help',
            position: position++
        },
        onClick: openKeyboardShortcuts,
        testId: (0, $1YbJP.testIdConcat)(testId, 'help', 'item-keyboard-shortcuts')
    }, formatMessage((0, $krqXt.default).keyboardShortcuts)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        testId: (0, $1YbJP.testIdConcat)(testId, 'legal', 'heading')
    }, formatMessage((0, $krqXt.default).headingLegal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'helpNavigationMenuItem',
            menuItemId: 'terms-of-use',
            menuItemType: 'legal',
            position: 0
        },
        href: "https://www.atlassian.com/legal/customer-agreement",
        target: "_blank",
        testId: (0, $1YbJP.testIdConcat)(testId, 'legal', 'item-terms-of-use')
    }, formatMessage((0, $krqXt.default).termsOfUse)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'helpNavigationMenuItem',
            menuItemId: 'privacy-policy',
            menuItemType: 'legal',
            position: 1
        },
        href: "https://www.atlassian.com/legal/privacy-policy",
        target: "_blank",
        testId: (0, $1YbJP.testIdConcat)(testId, 'legal', 'item-privacy-policy')
    }, formatMessage((0, $krqXt.default).privacyPolicy)))));
};

});
parcelRegister("bLRqM", function(module, exports) {

$parcel$export(module.exports, "useProductName", () => $d4884beae1c0d8a6$export$dde400a84de238be);

var $fz8wa = parcelRequire("fz8wa");

var $2ptIc = parcelRequire("2ptIc");
const $d4884beae1c0d8a6$export$dde400a84de238be = ()=>{
    const appPermissions = (0, $fz8wa.useApplicationPermissions)();
    return (0, $2ptIc.getProductName)(appPermissions);
};

});
parcelRegister("2ptIc", function(module, exports) {

$parcel$export(module.exports, "getProductName", () => $6dd1594c688fc918$export$aa3f36fe5dd1f237);
const $6dd1594c688fc918$export$aa3f36fe5dd1f237 = (permissions)=>{
    const { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess, hasProductDiscoveryAccess: hasProductDiscoveryAccess } = permissions;
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProductName'.
    return ([
        {
            condition: hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'software'
        },
        {
            condition: hasServiceDeskAccess && !hasSoftwareAccess && !hasProductDiscoveryAccess,
            value: 'serviceDesk'
        },
        {
            condition: hasCoreAccess && !hasSoftwareAccess && !hasServiceDeskAccess && !hasProductDiscoveryAccess,
            value: 'core'
        },
        {
            condition: hasProductDiscoveryAccess && !hasSoftwareAccess && !hasServiceDeskAccess,
            value: 'product-discovery'
        }
    ].find((item)=>item.condition) || {
        value: 'jira'
    }).value;
};

});


parcelRegister("krqXt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97d11cbf4802955$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a97d11cbf4802955$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    headingHelp: {
        "id": "atlassian-navigation.help.menu.heading-help",
        "defaultMessage": "Help"
    },
    headingLegal: {
        "id": "atlassian-navigation.help.menu.heading-legal",
        "defaultMessage": "Legal"
    },
    atlassianCommunity: {
        "id": "atlassian-navigation.help.menu.atlassian-community",
        "defaultMessage": "Atlassian Community"
    },
    atlassianDocumentation: {
        "id": "atlassian-navigation.help.menu.atlassian-documentation",
        "defaultMessage": "Atlassian Documentation"
    },
    whatsNew: {
        "id": "atlassian-navigation.help.menu.whats-new",
        "defaultMessage": "What's New"
    },
    privacyPolicy: {
        "id": "atlassian-navigation.help.menu.privacy-policy",
        "defaultMessage": "Privacy policy"
    },
    termsOfUse: {
        "id": "atlassian-navigation.help.menu.terms-of-use",
        "defaultMessage": "Terms of use"
    },
    getMobile: {
        "id": "atlassian-navigation.help.menu.get-mobile",
        "defaultMessage": "Get Jira Mobile"
    },
    aboutJira: {
        "id": "atlassian-navigation.help.menu.about-jira",
        "defaultMessage": "About Jira"
    },
    keyboardShortcuts: {
        "id": "atlassian-navigation.help.menu.keyboard-shortcuts",
        "defaultMessage": "Keyboard shortcuts"
    },
    giveFeedback: {
        "id": "atlassian-navigation.help.menu.give-feedback",
        "defaultMessage": "Give feedback"
    },
    raiseABug: {
        "id": "atlassian-navigation.help.menu.raise-a-bug",
        "defaultMessage": "Raise a bug"
    }
});

});


parcelRegister("kvXhB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f55f9d711e0e8694$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f55f9d711e0e8694$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.help.tooltip",
        "defaultMessage": "Help"
    },
    label: {
        "id": "atlassian-navigation.help.label",
        "defaultMessage": "Help"
    }
});

});

parcelRegister("1tVAU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fw38u").then(()=>parcelRequire('ee5E2'));

});


parcelRegister("cExDy", function(module, exports) {

$parcel$export(module.exports, "InitialDataLoader", () => $5fdc5b10ef05779f$export$867ec025b81eadf3);

var $eUqFw = parcelRequire("eUqFw");

var $5VB9J = parcelRequire("5VB9J");

var $gevkZ = parcelRequire("gevkZ");

var $arAkG = parcelRequire("arAkG");


var $1ybV0 = parcelRequire("1ybV0");

var $3UtNf = parcelRequire("3UtNf");

var $b8yDh = parcelRequire("b8yDh");

var $gGJaE = parcelRequire("gGJaE");

var $epT40 = parcelRequire("epT40");

var $dxcfv = parcelRequire("dxcfv");

var $4rWQe = parcelRequire("4rWQe");

var $dWLk9 = parcelRequire("dWLk9");

var $4xHig = parcelRequire("4xHig");
const $5fdc5b10ef05779f$export$867ec025b81eadf3 = ()=>{
    const [, { loadRecentAll: loadRecentAll }] = (0, $gGJaE.useRecentActions)();
    const [, { loadFavoriteAll: loadFavoriteAll }] = (0, $arAkG.useFavoriteActions)();
    const [, { fetchCreateProjectPermission: fetchCreateProjectPermission }] = (0, $b8yDh.useCreateProjectPermissionActions)();
    const [, { load: loadForgeItem }] = (0, $3UtNf.useForgeGlobalItems)();
    const [, { load: loadAddons }] = (0, $5VB9J.useAddon)();
    const [, { fetchTraits: fetchTraits }] = (0, $gevkZ.usePersonalizationProvider)();
    const hasFetchedAll = (0, $eUqFw.useRef)(false);
    const [{ hasLoaded: hasLoaded }] = (0, $epT40.default)();
    const [hasTimedOut, setHasTimedOut] = (0, $eUqFw.useState)(false);
    const accountId = (0, $dxcfv.useAccountId)();
    const activationId = (0, $4rWQe.useActivationId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const locale = (0, $4xHig.useLocale)();
    (0, $eUqFw.useEffect)(()=>{
        if ((hasLoaded || hasTimedOut) && !hasFetchedAll.current) {
            loadRecentAll();
            loadFavoriteAll((0, $f611712f945be48f$export$ea341e6cc435ed40));
            if ((0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x')) loadForgeItem({
                cloudId: cloudId,
                activationId: activationId,
                locale: locale
            });
            else loadForgeItem({
                cloudId: cloudId,
                locale: locale
            });
            fetchCreateProjectPermission();
            loadAddons();
            hasFetchedAll.current = true;
        }
    }, [
        hasLoaded,
        hasTimedOut,
        hasFetchedAll,
        loadRecentAll,
        loadFavoriteAll,
        fetchCreateProjectPermission,
        loadForgeItem,
        loadAddons,
        accountId,
        fetchTraits,
        cloudId,
        activationId,
        locale
    ]);
    // given not all pages use SpaStateReady yet, we fallback to timeout
    // so we preload nav items anyway after some time
    (0, $eUqFw.useEffect)(()=>{
        let t;
        if (!hasLoaded) t = setTimeout(()=>setHasTimedOut(true), 10000);
        return ()=>clearTimeout(t);
    }, [
        hasLoaded,
        setHasTimedOut
    ]);
    return null;
};

});
parcelRegister("gevkZ", function(module, exports) {

$parcel$export(module.exports, "usePersonalizationProvider", () => $20675be4a24b6070$export$816e978a144775ee);

var $WBLbN = parcelRequire("WBLbN");

var $lJL6U = parcelRequire("lJL6U");
const $20675be4a24b6070$var$store = (0, $WBLbN.createStore)({
    name: 'create-project-permissions',
    initialState: {
        traits: [],
        siteTraits: [],
        isFetching: false,
        fetchError: null,
        promise: null,
        hasFetchedOnce: false,
        hasSuccessOnce: false
    },
    actions: $lJL6U.actions
});
const $20675be4a24b6070$export$816e978a144775ee = (0, $WBLbN.createHook)($20675be4a24b6070$var$store);

});
parcelRegister("lJL6U", function(module, exports) {

$parcel$export(module.exports, "actions", () => $85d896d441f261fe$export$e324594224ef24da);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

const $85d896d441f261fe$var$performGetRequestForTraits = async (url)=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(url);
        if (response?.attributes) return {
            data: response.attributes,
            error: null
        };
        throw Error('response is not defined or null');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'jwmSampleProjectService',
                packageName: (0, $e7dc13e82257c9b0$export$b8b9d90f9e5bd72b),
                teamName: 'jira-werewolves'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            data: [],
            error: error
        };
    }
};
const $85d896d441f261fe$export$820a550ad3fb8364 = (cloudId, atlassianAccountId)=>async ({ setState: setState, getState: getState })=>{
        const { isFetching: isFetching } = getState();
        if (!isFetching) {
            setState({
                isFetching: true,
                fetchError: null
            });
            const siteTraitUrl = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
            const siteUserTraitUrl = `${siteTraitUrl}/user/${atlassianAccountId}`;
            const [{ data: listofSiteUserTraits, error: errorOnSiteUser }, { data: listofSiteTraits, error: errorOnSite }] = await Promise.all([
                $85d896d441f261fe$var$performGetRequestForTraits(siteUserTraitUrl),
                $85d896d441f261fe$var$performGetRequestForTraits(siteTraitUrl)
            ]);
            const errors = errorOnSiteUser || errorOnSite;
            setState({
                traits: listofSiteUserTraits,
                siteTraits: listofSiteTraits,
                isFetching: false,
                fetchError: errors,
                hasFetchedOnce: true,
                ...errors ? {} : {
                    hasSuccessOnce: true
                }
            });
        }
    };
const $85d896d441f261fe$export$e324594224ef24da = {
    fetchTraits: (cloudId, atlassianAccountId)=>async ({ setState: setState, dispatch: dispatch })=>{
            const promise = dispatch($85d896d441f261fe$export$820a550ad3fb8364(cloudId, atlassianAccountId));
            setState({
                isFetching: true,
                promise: promise
            });
        }
};

});
const $e7dc13e82257c9b0$export$b8b9d90f9e5bd72b = 'jira-business.sample-project';
const $e7dc13e82257c9b0$export$ba541fd402eb5f6f = 'jwm-sample-project-experiment';
const $e7dc13e82257c9b0$export$f7109619a5e9e0d6 = 'jwmSampleProjectExperiment';
const $e7dc13e82257c9b0$export$529244c5c5612bf2 = 'jwmSampleProjectCreateFailure';
const $e7dc13e82257c9b0$export$a1a2e9d60f36ed80 = 'jira_software_ui_moon_experiment_create_jwm_sample_experiment_project_dismissed_first';
const $e7dc13e82257c9b0$export$fc53f723f5163588 = 'jira_software_ui_moon_experiment_create_jwm_sample_experiment_project_created_first';
const $e7dc13e82257c9b0$export$ce71307e913afd12 = 'jira-core_business_project_created_first';
const $e7dc13e82257c9b0$export$a92ddfff80995acf = 'jira_screen_viewed_jwmsampleprojectexperimentdropdown_first';
const $e7dc13e82257c9b0$export$9365f74cb008dc7c = 'brain_jsw_to_jwm_implicit_site_boolean';
const $e7dc13e82257c9b0$export$142f18c04fa33074 = 'export-issues-xflow-modal';
const $e7dc13e82257c9b0$export$2667e34461b211df = 'invite-business-teams-modal';
const $e7dc13e82257c9b0$export$63fbd2796586b8eb = 'projects-menu-existing-users';
const $e7dc13e82257c9b0$export$d25895a47354c866 = 'projects-menu-new-users';
const $e7dc13e82257c9b0$export$b807b84bb648264b = 'onboarding-checklist';
const $e7dc13e82257c9b0$export$bf3fe75eb774ca83 = 'projects-jwm-empty-list';
const $e7dc13e82257c9b0$export$df59c204c3152280 = 'issue-links-on-jsw-board-cards';




parcelRegister("cMiL9", function(module, exports) {

$parcel$export(module.exports, "useShowAssets", () => $8b5cc9146ae9db55$export$6d1797fe1bb33b7a);
$parcel$export(module.exports, "Insight", () => $8b5cc9146ae9db55$export$f9e7e087e1968b4a);

var $eUqFw = parcelRequire("eUqFw");

var $kqyUv = parcelRequire("kqyUv");

var $0cdA8 = parcelRequire("0cdA8");

var $eI5EY = parcelRequire("eI5EY");

var $7vTKl = parcelRequire("7vTKl");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8PehF = parcelRequire("8PehF");

var $aeCba = parcelRequire("aeCba");

var $dxcfv = parcelRequire("dxcfv");

var $gd0Sp = parcelRequire("gd0Sp");

var $grCEQ = parcelRequire("grCEQ");

var $5H3md = parcelRequire("5H3md");

var $5L4J3 = parcelRequire("5L4J3");
const $8b5cc9146ae9db55$export$6d1797fe1bb33b7a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    if ((0, $8PehF.isCMDBEnabledInEnvironment)()) {
        if (isJSMUser) return true;
    }
    return false;
};
const $8b5cc9146ae9db55$var$Insight = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isPremiumUser = (0, $aeCba.isLicensedPremiumUser)(tenantContext);
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "InsightNavMenu",
        packageName: "jiraAtlassianNavigation",
        fallback: "unmount"
    }, !isPremiumUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqyUv.CmdbUpsellPageContainer), {
        isGlobal: true,
        atlassianAccountId: tenantContext.atlassianAccountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqyUv.CmdbUpsellPageStoreSubscriber), null, ({ userHasDismissed: userHasDismissed })=>{
        const showUpsell = userHasDismissed === false && isJSMUser;
        if (showUpsell) // fire analytics event only for non-premium users that haven't dimissed the Assets upsell page button.
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
            isSiteAdmin: tenantContext.isSiteAdmin
        });
        return showUpsell && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L4J3.InsightMenuItem), null);
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L4J3.InsightMenuItem), null));
};
const $8b5cc9146ae9db55$var$NewInsight = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { appPermissions: appPermissions } = tenantContext;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isPremiumUser = (0, $aeCba.isLicensedPremiumUser)(tenantContext);
    const isJSMUser = appPermissions.hasServiceDeskAccess;
    const [hasDismissed] = (0, $kqyUv.useUserHasDismissed)();
    const showUpsell = hasDismissed === false && isJSMUser;
    (0, $eUqFw.useEffect)(()=>{
        if (!isPremiumUser && showUpsell) // fire analytics event only for non-premium users that haven't dimissed the Assets upsell page button.
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
            serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
            isSiteAdmin: tenantContext.isSiteAdmin
        });
    }, [
        createAnalyticsEvent,
        isPremiumUser,
        showUpsell,
        tenantContext.appEditions?.serviceDesk,
        tenantContext.isSiteAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "InsightNavMenu",
        packageName: "jiraAtlassianNavigation",
        fallback: "unmount"
    }, !isPremiumUser && showUpsell || isPremiumUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L4J3.InsightMenuItem), null) : null);
};
const $8b5cc9146ae9db55$export$f9e7e087e1968b4a = ()=>{
    const atlassianAccountId = (0, $dxcfv.useAccountId)();
    if ((0, $eI5EY.fg)('ttvc_global_navigation_improvement_batch_2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).INSIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kqyUv.CmdbUpsellPageContainer), {
        isGlobal: true,
        atlassianAccountId: atlassianAccountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5H3md.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b5cc9146ae9db55$var$NewInsight, null))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).INSIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5H3md.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b5cc9146ae9db55$var$Insight, null)));
};

});
parcelRegister("kqyUv", function(module, exports) {

$parcel$export(module.exports, "CmdbUpsellPageContainer", () => $fbc52b430c766582$export$185a1503ee62245e);
$parcel$export(module.exports, "useUserHasDismissed", () => $fbc52b430c766582$export$168f6ca47f2dd0d7);
$parcel$export(module.exports, "useCmdbUpsellPageStoreActions", () => $fbc52b430c766582$export$7bdf1f3cf5d7163b);
$parcel$export(module.exports, "CmdbUpsellPageStoreSubscriber", () => $fbc52b430c766582$export$d766ac3cb3a067c0);

var $WBLbN = parcelRequire("WBLbN");

var $cFKmK = parcelRequire("cFKmK");
var $4RqMc = parcelRequire("4RqMc");
const $fbc52b430c766582$export$185a1503ee62245e = (0, $WBLbN.createContainer)();
const $fbc52b430c766582$var$initialState = {
    userHasDismissed: undefined
};
const $fbc52b430c766582$var$store = (0, $WBLbN.createStore)({
    initialState: $fbc52b430c766582$var$initialState,
    actions: $cFKmK,
    containedBy: $fbc52b430c766582$export$185a1503ee62245e,
    handlers: {
        onInit: $4RqMc.fetchInitialState
    }
});
const $fbc52b430c766582$export$168f6ca47f2dd0d7 = (0, $WBLbN.createHook)($fbc52b430c766582$var$store, {
    selector: (state)=>state.userHasDismissed
});
const $fbc52b430c766582$export$81f35d374558f538 = (0, $WBLbN.createHook)($fbc52b430c766582$var$store);
const $fbc52b430c766582$export$7bdf1f3cf5d7163b = (0, $WBLbN.createActionsHook)($fbc52b430c766582$var$store);
const $fbc52b430c766582$export$d766ac3cb3a067c0 = (0, $WBLbN.createSubscriber)($fbc52b430c766582$var$store);

});
parcelRegister("cFKmK", function(module, exports) {

$parcel$export(module.exports, "fetchInitialState", () => (parcelRequire("4RqMc")).fetchInitialState);
$parcel$export(module.exports, "toggleShowPage", () => (parcelRequire("diPb2")).toggleShowPage);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $4RqMc = parcelRequire("4RqMc");

var $diPb2 = parcelRequire("diPb2");

});
parcelRegister("4RqMc", function(module, exports) {

$parcel$export(module.exports, "fetchInitialState", () => $ccbb8e39231ccb9b$export$84ded0ac7058ab7a);

var $3vuPi = parcelRequire("3vuPi");
const $ccbb8e39231ccb9b$export$84ded0ac7058ab7a = ()=>async ({ setState: setState, getState: getState }, { atlassianAccountId: atlassianAccountId })=>{
        if (getState().userHasDismissed === undefined) {
            const userHasDismissed = await (0, $3vuPi.fetchHasDismissedProperty)(atlassianAccountId);
            setState({
                userHasDismissed: userHasDismissed
            });
        }
    };

});
parcelRegister("3vuPi", function(module, exports) {

$parcel$export(module.exports, "fetchHasDismissedProperty", () => $cab3a50fa06deaa2$export$872c472220985d8b);

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $eZfBZ = parcelRequire("eZfBZ");

const $cab3a50fa06deaa2$export$872c472220985d8b = async (atlassianAccountId)=>{
    const meta = {
        id: 'fetchUpsellDismissedProperty',
        packageName: 'jiraCmdbUpsellPage'
    };
    if (atlassianAccountId === null) {
        const error = new Error('atlassianAccountId is null');
        (0, $guiFP.default)({
            error: error,
            meta: meta
        });
        return false;
    }
    try {
        await (0, $48bs8.getUserProperty)(atlassianAccountId, (0, $bd5aab2c001ca9ef$export$38c3dc12cf3da533));
        return true;
    } catch (error) {
        if (error instanceof (0, $7byHA.default) && error.statusCode === 404) // don't capture analytics for this error as this is expected when a user has dimissed
        return false;
        (0, $eZfBZ.fireJsonOnlyErrorAnalytics)({
            error: error,
            meta: meta
        });
        return false;
    }
};

});
parcelRegister("eZfBZ", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_CONTEXTS", () => $6d93f232242cadb5$export$ca021921d5c56515);
$parcel$export(module.exports, "ttiRecommendedSlo", () => $6d93f232242cadb5$export$dc391c7d81907d3a);
$parcel$export(module.exports, "trackJsdFetchErrors", () => $6d93f232242cadb5$export$ebdbd98df5a27905);
$parcel$export(module.exports, "fireJsonOnlyErrorAnalytics", () => $6d93f232242cadb5$export$32233c6edb041cf2);

var $guiFP = parcelRequire("guiFP");

var $fV97Z = parcelRequire("fV97Z");
const $6d93f232242cadb5$export$ca021921d5c56515 = {
    AUTOMATION_SETTINGS: 'AutomationSettings',
    KNOWLEDGE: 'Knowledge',
    QUEUES: 'Queues',
    CSAT: 'Csat'
};
const $6d93f232242cadb5$export$cca3c4e11cb0a5ce = 1000;
const $6d93f232242cadb5$export$dc391c7d81907d3a = 4000;
const $6d93f232242cadb5$export$ebdbd98df5a27905 = async (payload)=>{
    const { error: error, attributes: attributes } = payload;
    if (error instanceof (0, $fV97Z.JsdFetchError)) {
        const { reasonKey: reasonKey } = error;
        (0, $guiFP.trackFetchErrors)({
            ...payload,
            attributes: {
                ...attributes,
                reasonKey: reasonKey
            }
        });
        return;
    }
    (0, $guiFP.trackFetchErrors)(payload);
};
function $6d93f232242cadb5$export$32233c6edb041cf2({ error: error, ...rest }) {
    let useError = false;
    if (error instanceof Error) try {
        JSON.parse(error.message);
        useError = true;
    } catch (e) {
        useError = false;
    }
    (0, $guiFP.default)({
        error: error instanceof Error && useError ? error : undefined,
        ...rest
    });
}

});
parcelRegister("fV97Z", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $c9869c00ba1fbd5b$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performGetRequest", () => $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $c9869c00ba1fbd5b$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $c9869c00ba1fbd5b$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $c9869c00ba1fbd5b$export$8ef51cba9d28f819);

var $8blac = parcelRequire("8blac");

var $kkgbD = parcelRequire("kkgbD");

var $fVqUX = parcelRequire("fVqUX");


var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");
const $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY = 'validation.error';
class $c9869c00ba1fbd5b$export$fee0012ae6cb3438 extends (0, $7byHA.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(response)) this.response = response;
    }
}
const $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $c9869c00ba1fbd5b$var$putOptions = {
    ...(0, $fVqUX.default),
    method: 'PUT'
};
const $c9869c00ba1fbd5b$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
const $c9869c00ba1fbd5b$var$deleteOptions = {
    ...(0, $fVqUX.default),
    method: 'DELETE'
};
const $c9869c00ba1fbd5b$var$patchOptions = {
    ...(0, $fVqUX.default),
    method: 'PATCH'
};
const $c9869c00ba1fbd5b$var$processResponse = async (response)=>{
    if ((0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $c9869c00ba1fbd5b$var$VALIDATION_ERROR_KEY) throw (0, $lRmyA.transformValidationErrorFromServer)(jsonResponse);
        const message = $c9869c00ba1fbd5b$var$transformMessageErrorsFromServer(errors);
        throw new $c9869c00ba1fbd5b$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
    }
    if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $c9869c00ba1fbd5b$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $fVqUX.default),
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$putOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$postOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$deleteOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);
const $c9869c00ba1fbd5b$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$c9869c00ba1fbd5b$var$patchOptions,
        ...options
    }).then($c9869c00ba1fbd5b$var$processResponse);

});


const $bd5aab2c001ca9ef$export$38c3dc12cf3da533 = 'jsm-cmdb-upsell-page-dismissed';



parcelRegister("diPb2", function(module, exports) {

$parcel$export(module.exports, "toggleShowPage", () => $e088f2149693c01c$export$76132886e83e1a9a);

var $3Hizk = parcelRequire("3Hizk");

var $5F2EY = parcelRequire("5F2EY");
const $e088f2149693c01c$export$76132886e83e1a9a = ()=>async ({ getState: getState, dispatch: dispatch })=>{
        const { userHasDismissed: userHasDismissed } = getState();
        if (userHasDismissed) dispatch((0, $5F2EY.enablePage)());
        else if (userHasDismissed === false) dispatch((0, $3Hizk.dismissPage)());
    };

});
parcelRegister("3Hizk", function(module, exports) {

$parcel$export(module.exports, "dismissPage", () => $5b76fda35c631d6f$export$b6e8cf6e649eeb96);

var $48bs8 = parcelRequire("48bs8");

var $eZfBZ = parcelRequire("eZfBZ");

const $5b76fda35c631d6f$export$b6e8cf6e649eeb96 = ()=>async ({ setState: setState }, { atlassianAccountId: atlassianAccountId })=>{
        // Optimistically hide Assets from the navigation bar immediately
        setState({
            userHasDismissed: true
        });
        try {
            // The specific value being set doesn't matter as long as the property *has* been set
            atlassianAccountId && await (0, $48bs8.setUserProperties)(atlassianAccountId, (0, $bd5aab2c001ca9ef$export$38c3dc12cf3da533), '1');
        } catch (error) {
            // When setting the user property fails, we still want to hide Assets from the navigation bar
            (0, $eZfBZ.fireJsonOnlyErrorAnalytics)({
                error: error,
                meta: {
                    id: 'fetchUpsellDismissedProperty',
                    packageName: 'jiraCmdbUpsellPage'
                }
            });
        }
    };

});

parcelRegister("5F2EY", function(module, exports) {

$parcel$export(module.exports, "enablePage", () => $3b4690274cea56a1$export$d904731aa3799771);

var $guiFP = parcelRequire("guiFP");


var $4NIHX = parcelRequire("4NIHX");
const $3b4690274cea56a1$export$d904731aa3799771 = ()=>async ({ setState: setState }, { atlassianAccountId: atlassianAccountId })=>{
        // Optimistically show Assets in the navigation bar immediately
        setState({
            userHasDismissed: false
        });
        try {
            atlassianAccountId && await (0, $4NIHX.deleteUserProperties)('', atlassianAccountId, (0, $bd5aab2c001ca9ef$export$38c3dc12cf3da533));
        } catch (error) {
            (0, $guiFP.default)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'fetchUpsellEnabledProperty',
                    packageName: 'jiraCmdbUpsellPage'
                }
            });
        }
    };

});
parcelRegister("4NIHX", function(module, exports) {

$parcel$export(module.exports, "deleteUserProperties", () => $1edff3203043a6ba$export$3de6197fc2f24c03);

var $axhXb = parcelRequire("axhXb");

var $48bs8 = parcelRequire("48bs8");
const $1edff3203043a6ba$export$3de6197fc2f24c03 = async (baseUrl, accountId, propertyKey)=>fetch((0, $48bs8.getUserPropertiesUrl)(accountId, propertyKey), {
        ...(0, $axhXb.default),
        method: 'DELETE'
    });

});





parcelRegister("5L4J3", function(module, exports) {

$parcel$export(module.exports, "InsightMenuItem", () => $859047073d6058a5$export$eb258e2cec2937f9);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7vTKl = parcelRequire("7vTKl");

var $272oI = parcelRequire("272oI");

var $gd0Sp = parcelRequire("gd0Sp");

var $5kDtB = parcelRequire("5kDtB");

var $olGf9 = parcelRequire("olGf9");

var $hQC6F = parcelRequire("hQC6F");
const $859047073d6058a5$export$eb258e2cec2937f9 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isSiteAdmin: isSiteAdmin, appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $olGf9.MenuTrigger), {
        href: (0, $272oI.getLandingPageUrl)(),
        menuId: (0, $7vTKl.MENU_ID).INSIGHT,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).INSIGHT,
        analyticsAttributes: {
            isSiteAdmin: isSiteAdmin,
            serviceDeskEdition: appEditions?.serviceDesk
        }
    }, formatMessage((0, $hQC6F.default).titleCmdbAssets));
};

});
parcelRegister("272oI", function(module, exports) {

$parcel$export(module.exports, "isInsightRoute", () => $1ee561ab017acd59$export$296d80f3ce129968);
$parcel$export(module.exports, "getCreateServiceUrl", () => $1ee561ab017acd59$export$1f9b8b558a361aaf);
$parcel$export(module.exports, "getRootPath", () => $1ee561ab017acd59$export$5413f45d031c7806);
$parcel$export(module.exports, "getLandingPageUrl", () => $1ee561ab017acd59$export$9366da5a373815e5);
$parcel$export(module.exports, "getGlobalConfigUrl", () => $1ee561ab017acd59$export$20fd4a0aec335970);
$parcel$export(module.exports, "getDataManagerUrl", () => $1ee561ab017acd59$export$c9b27b0d2e19d52f);
$parcel$export(module.exports, "getDataManagerAdaptersUrl", () => $1ee561ab017acd59$export$cd6b35373ba077a);
$parcel$export(module.exports, "getAssetsReportsUrl", () => $1ee561ab017acd59$export$c1909404b7ea317f);
$parcel$export(module.exports, "createObjectSchemasUrl", () => $1ee561ab017acd59$export$c48ea1282c74411e);
$parcel$export(module.exports, "createObjectSchemaUrl", () => $1ee561ab017acd59$export$3a0332e980fe56cf);
$parcel$export(module.exports, "createObjectTypeUrl", () => $1ee561ab017acd59$export$cfefb90cfb86b528);
$parcel$export(module.exports, "createObjectSchemaConfigUrl", () => $1ee561ab017acd59$export$f02479149ce3cac7);
$parcel$export(module.exports, "createObjectDetailUrl", () => $1ee561ab017acd59$export$51e4229f2c7d3866);
$parcel$export(module.exports, "createObjectTypeSettingsUrl", () => $1ee561ab017acd59$export$4b4b7d2c3df4fa58);
$parcel$export(module.exports, "createObjectTypeListWithObjectSelectedUrl", () => $1ee561ab017acd59$export$c1790fa8f0d8e89a);
$parcel$export(module.exports, "getFeatureUsagePageUrl", () => $1ee561ab017acd59$export$5ba89eed0cf60033);
$parcel$export(module.exports, "getFeatureUsageVirtualAgentPageUrl", () => $1ee561ab017acd59$export$415502b49e27270d);

var $7lEPK = parcelRequire("7lEPK");
const $1ee561ab017acd59$export$ee637ecb2dfa4f6a = '/jira/servicedesk/service-modal';
const $1ee561ab017acd59$export$c90f45511b7ccc85 = '/jira/servicedesk/assets';
const $1ee561ab017acd59$export$6d7574dbda22cf7 = '/jira/servicedesk/insight';
const $1ee561ab017acd59$export$296d80f3ce129968 = (pathname)=>pathname.includes($1ee561ab017acd59$export$6d7574dbda22cf7);
const $1ee561ab017acd59$export$1f9b8b558a361aaf = ()=>$1ee561ab017acd59$export$ee637ecb2dfa4f6a;
const $1ee561ab017acd59$export$5413f45d031c7806 = ()=>$1ee561ab017acd59$export$c90f45511b7ccc85;
const $1ee561ab017acd59$export$9366da5a373815e5 = ()=>$1ee561ab017acd59$export$5413f45d031c7806();
const $1ee561ab017acd59$export$20fd4a0aec335970 = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/configure/global`;
const $1ee561ab017acd59$export$c9b27b0d2e19d52f = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/data-manager/`;
const $1ee561ab017acd59$export$cd6b35373ba077a = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/data-manager/adapters/`;
const $1ee561ab017acd59$export$c1909404b7ea317f = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/reports`;
const $1ee561ab017acd59$export$c48ea1282c74411e = ()=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/object-schemas`;
const $1ee561ab017acd59$export$3a0332e980fe56cf = (objectSchemaId)=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/object-schema/${objectSchemaId}`;
const $1ee561ab017acd59$export$cfefb90cfb86b528 = (objectSchemaId, objectTypeId)=>`${$1ee561ab017acd59$export$3a0332e980fe56cf(objectSchemaId)}?${(0, $7lEPK.SCHEMA_PAGE_QUERY_PARAMS).objectTypeId}=${objectTypeId}`;
const $1ee561ab017acd59$export$f02479149ce3cac7 = (objectSchemaId)=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/configure/object-schema/${objectSchemaId}`;
const $1ee561ab017acd59$export$51e4229f2c7d3866 = (objectId)=>`${$1ee561ab017acd59$export$c90f45511b7ccc85}/object/${objectId}`;
const $1ee561ab017acd59$export$4b4b7d2c3df4fa58 = (objectTypeId)=>`${$1ee561ab017acd59$export$5413f45d031c7806()}/configure/object-type/${objectTypeId}`;
const $1ee561ab017acd59$export$c1790fa8f0d8e89a = (objectSchemaId, objectTypeId, objectId)=>`${$1ee561ab017acd59$export$cfefb90cfb86b528(objectSchemaId, objectTypeId)}&view=list&objectId=${objectId}`;
const $1ee561ab017acd59$export$5ba89eed0cf60033 = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=assets${showChangeLimitModal ? '&changeLimit=true' : ''}`;
const $1ee561ab017acd59$export$415502b49e27270d = ({ showChangeLimitModal: showChangeLimitModal } = {})=>`/jira/settings/products/servicedesk/feature-usage?feature=virtual-agent${showChangeLimitModal ? '&changeLimit=true' : ''}`;

});
parcelRegister("7lEPK", function(module, exports) {

$parcel$export(module.exports, "SCHEMA_PAGE_QUERY_PARAMS", () => $77a5b92f13f64b9e$export$a73deb42718b5c4);
$parcel$export(module.exports, "useUpdateQueryParams", () => $77a5b92f13f64b9e$export$e66acc5f4583ce1c);
$parcel$export(module.exports, "useObjectTypeIdQueryParam", () => $77a5b92f13f64b9e$export$f5a33d51dd6de08);
$parcel$export(module.exports, "useObjectIdQueryParam", () => $77a5b92f13f64b9e$export$a6e3187c87554a1e);
$parcel$export(module.exports, "useSchemaViewModeQueryParam", () => $77a5b92f13f64b9e$export$6abda0ad26022eff);
$parcel$export(module.exports, "useObjectViewModeQueryParam", () => $77a5b92f13f64b9e$export$1927b50f7d074492);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $aSJew = parcelRequire("aSJew");

var $lB25E = parcelRequire("lB25E");
const $77a5b92f13f64b9e$export$a73deb42718b5c4 = {
    // Values are 'object' or 'attribute'
    schemaMode: 'mode',
    // Values are 'list' or undefined
    objectViewMode: 'view',
    // Both of these params are supported to set the object type ID. 'typeId' is preferred and is the one that is updated.
    // 'objecttypeid' is only used on initial load to support customers who have bookmarked this URL.
    objectTypeId: 'typeId',
    fallbackObjectTypeId: 'objecttypeid',
    objectId: 'objectId'
};
const $77a5b92f13f64b9e$export$e66acc5f4583ce1c = ()=>{
    const { push: push } = (0, $lB25E.useRouterActions)();
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const updateQueryParams = (0, $eUqFw.useCallback)((queryParams = {})=>{
        const { pathname: pathname, search: search } = location;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedQueryParams = {};
        Object.keys(queryParams).forEach((key)=>{
            updatedQueryParams[key] = queryParams[key] ?? undefined;
        });
        return `${pathname}?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search),
            ...updatedQueryParams
        })}`;
    }, [
        location
    ]);
    const pushRouterAction = (0, $eUqFw.useCallback)((path)=>{
        push(path);
    }, [
        push
    ]);
    return [
        {
            updateQueryParams: updateQueryParams,
            pushRouterAction: pushRouterAction
        }
    ];
};
const $77a5b92f13f64b9e$export$f5a33d51dd6de08 = ()=>{
    const [objectTypeId, setObjectTypeId] = (0, $lB25E.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.objectTypeId);
    const [fallbackObjectTypeId, setFallbackObjectTypeId] = (0, $lB25E.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.fallbackObjectTypeId);
    (0, $eUqFw.useEffect)(()=>{
        if (fallbackObjectTypeId !== undefined) {
            setObjectTypeId((0, $aSJew.toCmdbObjectTypeId)(fallbackObjectTypeId), 'replace');
            setFallbackObjectTypeId(undefined, 'replace');
        }
    }, [
        fallbackObjectTypeId,
        setObjectTypeId,
        setFallbackObjectTypeId
    ]);
    const nullableMain = objectTypeId !== undefined ? (0, $aSJew.toCmdbObjectTypeId)(objectTypeId) : null;
    const nullableFallback = fallbackObjectTypeId !== undefined ? (0, $aSJew.toCmdbObjectTypeId)(fallbackObjectTypeId) : null;
    const setter = (newObjectTypeId, updateType)=>{
        setObjectTypeId(newObjectTypeId !== null ? newObjectTypeId : undefined, updateType);
    };
    return [
        nullableMain !== null ? nullableMain : nullableFallback,
        setter
    ];
};
const $77a5b92f13f64b9e$export$a6e3187c87554a1e = ()=>{
    const [objectId, setObjectId] = (0, $lB25E.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.objectId);
    const nullableObjectId = objectId !== undefined ? (0, $aSJew.toCmdbObjectId)(objectId) : null;
    const setter = (newObjectId, updateType)=>{
        setObjectId(newObjectId !== null ? newObjectId : undefined, updateType);
    };
    return [
        nullableObjectId,
        setter
    ];
};
const $77a5b92f13f64b9e$export$6abda0ad26022eff = ()=>{
    const [rawParamValue, setSchemaMode] = (0, $lB25E.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.schemaMode);
    const schemaMode = rawParamValue === 'attribute' ? 'attribute' : 'object';
    return [
        schemaMode,
        setSchemaMode
    ];
};
const $77a5b92f13f64b9e$export$1927b50f7d074492 = ()=>{
    const [rawParamValue, setObjectViewMode] = (0, $lB25E.useQueryParam)($77a5b92f13f64b9e$export$a73deb42718b5c4.objectViewMode);
    const objectViewMode = rawParamValue === 'list' ? 'list' : 'details';
    const setter = (newValue, updateMode)=>{
        setObjectViewMode(newValue === 'list' ? 'list' : undefined, updateMode);
    };
    return [
        objectViewMode,
        setter
    ];
};

});


parcelRegister("hQC6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0eb358ea5310548$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f0eb358ea5310548$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    titleCmdbAssets: {
        "id": "atlassian-navigation.insight.title-cmdb-assets",
        "defaultMessage": "Assets"
    }
});

});



parcelRegister("2kyZF", function(module, exports) {

$parcel$export(module.exports, "Integrations", () => $05a6b939333d90b0$export$99d02219d259eb94);

var $eUqFw = parcelRequire("eUqFw");

var $k8K2e = parcelRequire("k8K2e");

var $e5T0Q = parcelRequire("e5T0Q");

var $8ZaIx = parcelRequire("8ZaIx");

var $jQ4nC = parcelRequire("jQ4nC");
const $05a6b939333d90b0$export$99d02219d259eb94 = ()=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZaIx.KeyboardShortcuts), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e5T0Q.IssueViewModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQ4nC.Projects), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k8K2e.Dashboards), null));
    return null;
};

});
parcelRegister("k8K2e", function(module, exports) {

$parcel$export(module.exports, "Dashboards", () => $0fbce7f2c1b2efbc$export$dd47e695f88fad71);

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $umZWz = parcelRequire("umZWz");

var $10fdS = parcelRequire("10fdS");

var $4HwSc = parcelRequire("4HwSc");

var $6yplV = parcelRequire("6yplV");

var $lB25E = parcelRequire("lB25E");

var $5kDtB = parcelRequire("5kDtB");

var $9xxrv = parcelRequire("9xxrv");
const $0fbce7f2c1b2efbc$export$dd47e695f88fad71 = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const [isOpen, { off: modalClose }] = (0, $4HwSc.useSwitchModals)((0, $5kDtB.MODAL_ID).DASHBOARD_CREATE);
    const { path: path } = (0, $10fdS.useRouteByName)((0, $exb0h.ROUTE_NAMES_DASHBOARD_EDIT)) ?? {};
    const { push: push } = (0, $lB25E.useRouterActions)();
    const onSuccess = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7031 - Binding element 'id' implicitly has an 'any' type.
    (_, { id: id })=>{
        path && push((0, $lB25E.generatePath)(path, {
            dashboardId: id
        }));
        modalClose();
    }, [
        modalClose,
        path,
        push
    ]);
    if (isAnonymous) return null;
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9xxrv.Absolute), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $umZWz.default), {
        onSuccess: onSuccess,
        onCancel: modalClose
    })) : null;
};

});
parcelRegister("umZWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d5ee99119d0ae6$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $62d5ee99119d0ae6$var$AsyncCreateDashboardModal = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("i09U6")), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/create-dashboard-modal/src/index.tsx"
});
const $62d5ee99119d0ae6$var$AsyncCreateDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "create-dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62d5ee99119d0ae6$var$AsyncCreateDashboardModal, props));
var $62d5ee99119d0ae6$export$2e2bcd8739ae039 = $62d5ee99119d0ae6$var$AsyncCreateDashboardModalContainer;

});
parcelRegister("i09U6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("aElWm")
]).then(()=>parcelRequire('5U3RQ'));

});


parcelRegister("9xxrv", function(module, exports) {

$parcel$export(module.exports, "Absolute", () => $cb590ee654753bc2$export$fa7a3a6ce2191e98);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $cb590ee654753bc2$export$fa7a3a6ce2191e98 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("e5T0Q", function(module, exports) {

$parcel$export(module.exports, "IssueViewModal", () => $fb346243eb99c94a$export$e6a284da53c503a6);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $cyVXS = parcelRequire("cyVXS");

var $TqPUf = parcelRequire("TqPUf");

var $gGtKh = parcelRequire("gGtKh");

var $6vrw7 = parcelRequire("6vrw7");

const $fb346243eb99c94a$export$b61e79ae300e872f = (0, $7rh0R.lazy)(()=>(parcelRequire("2P20B")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
const $fb346243eb99c94a$export$e6a284da53c503a6 = ()=>{
    const [{ isModalOpen: isModalOpen, issueKey: issueKey, onClose: onClose, packageName: packageName, analyticsSource: analyticsSource }] = (0, $TqPUf.useTriggerIssueViewModal)();
    return isModalOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        packageName: packageName,
        id: "issue-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "modal-issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb346243eb99c94a$export$b61e79ae300e872f, {
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'AnalyticsSource'.
        analyticsSource: analyticsSource,
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        onClose: onClose
    }))) : null;
};

});
parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $fee69 = parcelRequire("fee69");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});

parcelRegister("TqPUf", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueViewModal", () => $89527c043faf31a0$export$fb8fdfbeb70f910c);

var $jG2Eu = parcelRequire("jG2Eu");

var $WBLbN = parcelRequire("WBLbN");
const $89527c043faf31a0$export$d4c72bab9d6cc13a = {
    isModalOpen: false,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    issueKey: '',
    packageName: '',
    analyticsSource: ''
};
const $89527c043faf31a0$export$e324594224ef24da = {
    openIssueViewModal: (nextState)=>({ setState: setState })=>{
            setState({
                ...$89527c043faf31a0$export$d4c72bab9d6cc13a,
                ...nextState,
                isModalOpen: true
            });
        },
    closeIssueViewModal: ()=>({ setState: setState })=>{
            setState({
                ...$89527c043faf31a0$export$d4c72bab9d6cc13a,
                isModalOpen: false
            });
        }
};
const $89527c043faf31a0$var$store = (0, $WBLbN.createStore)({
    name: 'issue-view.controllers.open-issue-view-modal',
    initialState: $89527c043faf31a0$export$d4c72bab9d6cc13a,
    actions: $89527c043faf31a0$export$e324594224ef24da
});
const $89527c043faf31a0$export$fb8fdfbeb70f910c = (0, $WBLbN.createHook)($89527c043faf31a0$var$store);

});

parcelRegister("2P20B", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("aTMMU")
]).then(()=>parcelRequire('kjWxV'));

});


parcelRegister("8ZaIx", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcuts", () => $eae8a00bde49bcf7$export$5176144edf2bef2b);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $bvJ6X = parcelRequire("bvJ6X");

var $kAq8l = parcelRequire("kAq8l");


var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $8WvKy = parcelRequire("8WvKy");

var $bUi2Q = parcelRequire("bUi2Q");

var $7vTKl = parcelRequire("7vTKl");

var $3BTZc = parcelRequire("3BTZc");

var $1MRnf = parcelRequire("1MRnf");

var $ctR9z = parcelRequire("ctR9z");

var $gGtKh = parcelRequire("gGtKh");

var $ellXt = parcelRequire("ellXt");

var $lB25E = parcelRequire("lB25E");

var $5kDtB = parcelRequire("5kDtB");
const $eae8a00bde49bcf7$export$5176144edf2bef2b = ()=>{
    const [, { on: on }] = (0, $3BTZc.useTopMenus)((0, $7vTKl.MENU_ID).SEARCH);
    const [, { off: closeAllMenus }] = (0, $3BTZc.useTopMenus)();
    const { openRightSidebar: openRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const rightSidebarState = (0, $bUi2Q.useActiveRightSidebarState)();
    const [{ isInitialLoad: isInitialLoad }, actions] = (0, $kAq8l.useIsInitialLoadLegacyIssueCreate)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const isInitialLoadRef = (0, $eUqFw.useRef)(false);
    isInitialLoadRef.current = isInitialLoad;
    const openSearch = (0, $eUqFw.useCallback)(()=>requestAnimationFrame(()=>{
            on();
        }), [
        on
    ]);
    let currentIssueCreateVisibility = null;
    if ((0, $1ybV0.ff)('project.config.pce.modern.global-issue-create')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data } = (0, $lB25E.useResource)((0, $ellXt.gicOptInStatusResources));
        currentIssueCreateVisibility = data && data?.gicOptInStatus;
    }
    const openIssueCreate = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('project.config.pce.modern.global-issue-create')) {
            if (currentIssueCreateVisibility !== null) {
                if (currentIssueCreateVisibility.isEnabled) openIssueCreateModal({
                    triggerPointKey: (0, $1MRnf.GENERIC_KEYBOARD_SHORTCUT)
                });
                else {
                    (0, $bvJ6X.default)({
                        isInitialLoad: isInitialLoadRef.current,
                        triggerSource: (0, $491012546836012a$export$7e22286cafe320a7)
                    });
                    if (isInitialLoadRef.current) actions.clearInitialLoaded();
                }
            } else (0, $gUUjF.default).safeErrorWithoutCustomerData('global-issue-create', 'visibility data is still getting downloaded');
        } else {
            (0, $bvJ6X.default)({
                isInitialLoad: isInitialLoadRef.current,
                triggerSource: (0, $491012546836012a$export$7e22286cafe320a7)
            });
            if (isInitialLoadRef.current) actions.clearInitialLoaded();
        }
    }, [
        actions,
        currentIssueCreateVisibility,
        openIssueCreateModal
    ]);
    const toggleHelpPanel = (0, $eUqFw.useCallback)(()=>{
        if ((0, $1ybV0.ff)('iph.enabled')) {
            closeAllMenus();
            if (!rightSidebarState?.isCollapsed && rightSidebarState?.panelId === (0, $f2Poq.HELP_PANEL_ID)) closeCurrentRightSidebar();
            else openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH));
        }
    }, [
        closeAllMenus,
        closeCurrentRightSidebar,
        openRightSidebar,
        rightSidebarState?.isCollapsed,
        rightSidebarState?.panelId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "integrations.keyboard-shortcuts",
        packageName: (0, $5kDtB.PACKAGE_NAME),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy-shortcuts",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WvKy.KeyboardShortcuts), {
        showIssueCreate: openIssueCreate,
        showSearch: openSearch,
        toggleHelpPanel: toggleHelpPanel,
        shouldUseHelpShortcut: (0, $1ybV0.ff)('iph.enabled')
    })));
};

});
parcelRegister("8WvKy", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcuts", () => $e1eb339ad29960d4$export$5176144edf2bef2b);

var $7rh0R = parcelRequire("7rh0R");

const $e1eb339ad29960d4$export$5176144edf2bef2b = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("f8ghb")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/keyboard-shortcuts/src/view/index.tsx"
});

});
parcelRegister("f8ghb", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("3Nrvr")
]).then(()=>parcelRequire('3KGVP'));

});



parcelRegister("jQ4nC", function(module, exports) {

$parcel$export(module.exports, "Projects", () => $71b359bb74a97532$export$ca6fbb51b35e375c);

var $eUqFw = parcelRequire("eUqFw");

var $b8yDh = parcelRequire("b8yDh");

var $lbttE = parcelRequire("lbttE");

var $4HwSc = parcelRequire("4HwSc");

var $5kDtB = parcelRequire("5kDtB");
const $71b359bb74a97532$export$90cfe4f15bb50f58 = ({ open: open, close: close, setOnCloseCallback: setOnCloseCallback })=>{
    const [{ canCreateClassicProject: canCreateClassicProject }] = (0, $b8yDh.useCreateProjectPermission)();
    (0, $eUqFw.useEffect)(()=>{
        open && open({
            source: 'navigationNext',
            isNextGen: !canCreateClassicProject
        });
        setOnCloseCallback && setOnCloseCallback(close);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    return null;
};
const $71b359bb74a97532$export$ca6fbb51b35e375c = ()=>{
    const [isProjectCreateDrawerOpen, { off: closeProjectCreateDrawer }] = (0, $4HwSc.useSwitchModals)((0, $5kDtB.MODAL_ID).PROJECT_CREATE);
    if (!isProjectCreateDrawerOpen) return null;
    // ProjectCreateDrawerProvider is in page container/navigaiton
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbttE.ProjectCreateDrawerConsumer), null, ({ methods: { open: open, setOnCloseCallback: setOnCloseCallback } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($71b359bb74a97532$export$90cfe4f15bb50f58, {
            open: open,
            close: closeProjectCreateDrawer,
            setOnCloseCallback: setOnCloseCallback
        }));
};

});


parcelRegister("hsLTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f428ef71d8f7aeb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6f428ef71d8f7aeb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    topNav: {
        "id": "atlassian-navigation.top-nav",
        "defaultMessage": "Primary"
    },
    more: {
        "id": "atlassian-navigation.more",
        "defaultMessage": "More"
    }
});

});

parcelRegister("1kNcY", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $0622a09612767c8a$export$36ba2f559d49a8f6);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $3MV1G = parcelRequire("3MV1G");

var $2aBcM = parcelRequire("2aBcM");

var $0cdA8 = parcelRequire("0cdA8");

var $bDhRl = parcelRequire("bDhRl");

var $eI5EY = parcelRequire("eI5EY");

var $4ksts = parcelRequire("4ksts");

var $7vTKl = parcelRequire("7vTKl");

var $3BTZc = parcelRequire("3BTZc");

var $1YbJP = parcelRequire("1YbJP");

var $gGtKh = parcelRequire("gGtKh");

var $dWLk9 = parcelRequire("dWLk9");

var $6yplV = parcelRequire("6yplV");

var $gd0Sp = parcelRequire("gd0Sp");

var $jUPmn = parcelRequire("jUPmn");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $c61cd = parcelRequire("c61cd");

var $gvn5f = parcelRequire("gvn5f");

var $fJrXw = parcelRequire("fJrXw");


var $jVYY6 = parcelRequire("jVYY6");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0622a09612767c8a$var$BadgeDI = (0, $7rh0R.lazy)(()=>(parcelRequire("bj7XE")).then(({ Badge: Badge })=>Badge), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/badge/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0622a09612767c8a$var$MenuDI = (0, $7rh0R.lazy)(()=>(parcelRequire("eSC8h")).then(({ Menu: Menu })=>Menu), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/notifications/menu/index.tsx"
});
const $0622a09612767c8a$var$Notifications = ({ Badge: Badge = $0622a09612767c8a$var$BadgeDI, ErrorBoundary: ErrorBoundary = (0, $0cdA8.JSErrorBoundary), Icon: Icon = (0, $c61cd.Notification), Menu: Menu = $0622a09612767c8a$var$MenuDI, NotificationContentFrame: NotificationContentFrame = $0622a09612767c8a$var$NotificationContentFrameDI, Popup: Popup = (0, $3MV1G.default), useExperienceStart: useExperienceStart = (0, $bDhRl.useExperienceStart), useIntl: useIntl = (0, $4ksts.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $6yplV.useIsAnonymous), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $gvn5f.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $3BTZc.useTopMenus) })=>{
    const testIdPrefix = (0, $1YbJP.testIdGenerate)('secondary-actions', 'notifications');
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const [isNotificationCleared, setIsNotificationCleared] = (0, $eUqFw.useState)(false);
    const [notificationCount, setNotificationCount] = (0, $eUqFw.useState)(0);
    const handleCountUpdate = (0, $eUqFw.useCallback)((newCount)=>{
        setNotificationCount(newCount);
    }, []);
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu, on: openMenu }] = useTopMenus((0, $7vTKl.MENU_ID).NOTIFICATIONS);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).NOTIFICATIONS
    });
    const onStart = useExperienceStart({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $5kDtB.NAVIGATION_ITEM_ID).NOTIFICATIONS,
        analyticsSource: 'atlassian-navigation'
    });
    const cloudId = (0, $dWLk9.useCloudId)();
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const { triggerNotificationBellPartyNudgeExperiment: triggerNotificationBellPartyNudgeExperiment } = (0, $jUPmn.useThirdPartyNudgeExperiment)(cloudId, atlassianAccountId);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (isMenuOpen) performance.clearMarks('notification.list.render.start');
        else performance.mark('notification.list.render.start');
        onStart();
        toggleMenu();
        triggerAnalytics();
        setIsNotificationCleared(true);
        triggerNotificationBellPartyNudgeExperiment();
    }, [
        isMenuOpen,
        onStart,
        toggleMenu,
        triggerAnalytics,
        triggerNotificationBellPartyNudgeExperiment
    ]);
    const handleNotificationIconHover = ()=>{
        $0622a09612767c8a$var$MenuDI.preload();
    };
    (0, $fJrXw.useRegisterNotificationsInCommandPalette)(onClick);
    const content = (0, $eUqFw.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NotificationContentFrame, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorBoundary, {
            id: "notifications.list.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "notification-menu-native",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Menu, {
            scheduleUpdate: update,
            testIdPrefix: testIdPrefix
        })))), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdPrefix
    ]);
    const badge = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorBoundary, {
            id: "notifications.badge.async",
            packageName: "AtlassianNavigation",
            teamName: "navigation",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "badge",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Badge, {
            isNotificationCleared: isNotificationCleared,
            setIsNotificationCleared: setIsNotificationCleared,
            isNotificationDrawerOpen: isMenuOpen,
            ...(0, $eI5EY.fg)('header_content_not_accessible_for_screen_reader') && {
                onNotificationCountChange: handleCountUpdate
            }
        }))), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isNotificationCleared,
        isMenuOpen
    ]);
    const badgeEmpty = (0, $eUqFw.useCallback)(()=>null, []);
    const notificationsLabel = notificationCount < (0, $b9ec89df7cdd9ba3$export$14c62ba6f49b806f) ? formatMessage((0, $jVYY6.default).label, {
        count: notificationCount
    }) : formatMessage((0, $jVYY6.default).overNineNotifications);
    const trigger = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'triggerProps' implicitly has an 'any' type.
    (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": (0, $1YbJP.testIdConcat)(testIdPrefix, 'menu-trigger')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            ...triggerProps,
            badge: badge,
            isSelected: isMenuOpen,
            onClick: onClick,
            onMouseEnter: handleNotificationIconHover,
            tooltip: formatMessage((0, $jVYY6.default).tooltip),
            label: (0, $eI5EY.fg)('header_content_not_accessible_for_screen_reader') ? notificationsLabel : formatMessage((0, $jVYY6.default).oldLabel),
            onViewRequests: openMenu
        })), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        badge,
        isMenuOpen,
        onClick,
        formatMessage,
        testIdPrefix,
        notificationCount
    ]);
    if (isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        badge: badgeEmpty,
        tooltip: formatMessage((0, $jVYY6.default).tooltip)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: trigger
    });
};
const $0622a09612767c8a$export$36ba2f559d49a8f6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $5kDtB.NAVIGATION_ITEM_ID).NOTIFICATIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2aBcM.UsingNotificationsToImproveAdminApprovalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0622a09612767c8a$var$Notifications, props)));
const $0622a09612767c8a$var$NotificationContentFrameDI = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1w2c _4t3i54ef _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2aBcM", function(module, exports) {

$parcel$export(module.exports, "CoordinationStopProvider", () => $9e31a8278adc75cc$export$83d026e3dd5706d);
$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalProvider", () => $9e31a8278adc75cc$export$a5554f3421878be1);
$parcel$export(module.exports, "useUsingNotificationsToImproveAdminApprovalContext", () => $9e31a8278adc75cc$export$3e450d633150d6ca);

var $eUqFw = parcelRequire("eUqFw");

var $aZaPn = parcelRequire("aZaPn");

var $gd0Sp = parcelRequire("gd0Sp");

const $9e31a8278adc75cc$var$TouchpointContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    hasSpotlightBeenShown: true,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    markSpotlightAsShown: ()=>{}
});
const $9e31a8278adc75cc$var$localStorage = (0, $aZaPn.createLocalStorageProvider)((0, $b21572a54e963d3c$export$67a034c701fa7ff6));
const $9e31a8278adc75cc$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $9e31a8278adc75cc$export$a5554f3421878be1 = ({ children: children })=>{
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const [hasSpotlightBeenShown, setHasSpotlightBeenShown] = (0, $eUqFw.useState)(true);
    const spotlightLocalStorageKey = `${(0, $b21572a54e963d3c$export$7a86d77850136bf4)}_${cloudId}_${atlassianAccountId}`;
    (0, $eUqFw.useEffect)(()=>{
        setHasSpotlightBeenShown($9e31a8278adc75cc$var$localStorage.get(spotlightLocalStorageKey) || false);
    }, [
        spotlightLocalStorageKey
    ]);
    const markSpotlightAsShown = (0, $eUqFw.useCallback)(()=>{
        $9e31a8278adc75cc$var$localStorage.set(spotlightLocalStorageKey, true);
        setHasSpotlightBeenShown(true);
    }, [
        setHasSpotlightBeenShown,
        spotlightLocalStorageKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e31a8278adc75cc$var$TouchpointContext.Provider, {
        value: {
            hasSpotlightBeenShown: hasSpotlightBeenShown,
            markSpotlightAsShown: markSpotlightAsShown
        }
    }, children);
};
const $9e31a8278adc75cc$export$3e450d633150d6ca = ()=>(0, $eUqFw.useContext)($9e31a8278adc75cc$var$TouchpointContext);

});
const $b21572a54e963d3c$export$67a034c701fa7ff6 = 'uniapa';
const $b21572a54e963d3c$export$7a86d77850136bf4 = 'has-spotlight-been-shown';
const $b21572a54e963d3c$export$d2ea4f931a71a509 = 'jira-admin-product-request-spotlight';


parcelRegister("jUPmn", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyNudgeExperiment", () => $b60be4e9037cc02c$export$7eb4430a3f41a22a);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $4S3bk = parcelRequire("4S3bk");

var $bi10L = parcelRequire("bi10L");

var $cEwHS = parcelRequire("cEwHS");

var $n8dVT = parcelRequire("n8dVT");

var $f4pAb = parcelRequire("f4pAb");

var $65mYQ = parcelRequire("65mYQ");
const $b60be4e9037cc02c$export$7eb4430a3f41a22a = (cloudId, atlassianAccountId)=>{
    const { showThirdPartyNudgeFlag: showThirdPartyNudgeFlag } = (0, $65mYQ.useThirdPartyNudgeFlag)({
        cloudId: cloudId
    });
    const { fetchAllTraits: fetchAllTraits } = (0, $cEwHS.usePersonalization)();
    const triggerIssueCommentThirdPartyNudgeExperiment = (0, $eUqFw.useCallback)(async ()=>{
        const traits = await fetchAllTraits(cloudId, atlassianAccountId);
        if (!traits) return;
        // If the data is loading, return early, don't fire a feature exposure. A re-render should occur when the data is loaded.
        // If the user has dismissed the nudge, return early, don't fire a feature exposure.
        // If the user is on an active tenant and is not active themselves, show the nudge. Otherwise don't show the nudge since it may not be relevant.
        // If no trait is found, assume inactive.
        // Beware: active traits can be 0 which is considered falsey. Hence the undefined check here.
        const isEligibleForMsteams = (0, $f4pAb.isTenantActiveOnMsteams)(traits) && !(0, $f4pAb.isUserActiveOnMsteams)(traits);
        const isEligibleForSlack = (0, $f4pAb.isTenantActiveOnSlack)(traits) && !(0, $f4pAb.isUserActiveOnSlack)(traits);
        const hasSeenOtherThirdPartyNudges = (0, $f4pAb.hasSeenIssuesViewNudge)(traits) || (0, $f4pAb.hasSeenNotificationBellNudge)(traits) || (0, $f4pAb.hasSeenIssueWatchNudge)(traits) || (0, $f4pAb.hasSeenNotificationsNudge)(traits);
        const hasAlreadySeen = traits[0, $4S3bk.DISMISSED_TRAIT_NAME] || (0, $bi10L.getHasSeenNudge)();
        if (hasAlreadySeen || !isEligibleForMsteams && !isEligibleForSlack || hasSeenOtherThirdPartyNudges) return;
        const [expConfig, fireFeatureExposure] = (0, $79xbN.UNSAFE_noExposureExp)('third_party_app_nudge_on_after_jira_comment');
        // Only fire feature exposure if all eligibility requirements have been met.
        // Fire exposure for control and variation.
        fireFeatureExposure();
        // Users in control should not see the nudge.
        if (expConfig.get('cohort', 'not-enrolled') !== 'variation') return;
        const experimentType = 'JSW_COMMENT';
        if (isEligibleForSlack && isEligibleForMsteams) showThirdPartyNudgeFlag({
            variant: 'both',
            experimentType: experimentType
        });
        else if (isEligibleForSlack) showThirdPartyNudgeFlag({
            variant: 'slack',
            experimentType: experimentType
        });
        else showThirdPartyNudgeFlag({
            variant: 'msteams',
            experimentType: experimentType
        });
    }, [
        fetchAllTraits,
        cloudId,
        atlassianAccountId,
        showThirdPartyNudgeFlag
    ]);
    const triggerNotificationBellPartyNudgeExperiment = (0, $eUqFw.useCallback)(async ()=>{
        const traits = await fetchAllTraits(cloudId, atlassianAccountId, (0, $4S3bk.ExperimentType).NOTIFICATION_BELL);
        if (!traits) return;
        const isSlackOrTeamsActiveUser = (0, $f4pAb.isUserActiveOnMsteams)(traits) || (0, $f4pAb.isUserActiveOnSlack)(traits);
        const isNewJiraActiveUser = (0, $f4pAb.isNewJiraUser)(traits);
        if (isSlackOrTeamsActiveUser || isNewJiraActiveUser) return;
        const hasSeenOtherThirdPartyNudges = (0, $f4pAb.hasSeenIssuesViewNudge)(traits) || (0, $f4pAb.hasSeenIssueCommentNudge)(traits) || (0, $f4pAb.hasSeenIssueWatchNudge)(traits);
        const hasAlreadySeen = traits[0, $4S3bk.NOTIFICATION_BELL_TRAIT_NAME] || (0, $n8dVT.getNotificationNudgeState)();
        if (hasAlreadySeen || hasSeenOtherThirdPartyNudges || !(0, $79xbN.expValEquals)('third_party_app_notification_bell_nudge', 'cohort', 'variation')) return;
        const isEligibleForMsteams = (0, $f4pAb.isTenantActiveOnMsteams)(traits);
        const isEligibleForSlack = (0, $f4pAb.isTenantActiveOnSlack)(traits);
        const experimentType = 'NOTIFICATION_BELL';
        if (isEligibleForMsteams) showThirdPartyNudgeFlag({
            variant: 'msteams',
            experimentType: experimentType
        });
        else if (isEligibleForSlack) showThirdPartyNudgeFlag({
            variant: 'slack',
            experimentType: experimentType
        });
        else showThirdPartyNudgeFlag({
            variant: 'both',
            experimentType: experimentType
        });
    }, [
        fetchAllTraits,
        cloudId,
        atlassianAccountId,
        showThirdPartyNudgeFlag
    ]);
    const shouldThirdPartySpotlightAppear = (0, $eUqFw.useCallback)(async ()=>{
        const traits = await fetchAllTraits(cloudId, atlassianAccountId, (0, $4S3bk.ExperimentType).ISSUES_VIEW);
        if (!traits) return false;
        const isTenantActive = (0, $f4pAb.isTenantActiveOnMsteams)(traits);
        const hasSeenOtherThirdPartyNudges = (0, $f4pAb.hasSeenIssueCommentNudge)(traits) || (0, $f4pAb.hasSeenNotificationBellNudge)(traits) || (0, $f4pAb.hasSeenIssueWatchNudge)(traits) || (0, $f4pAb.hasSeenNotificationsNudge)(traits);
        const hasAlreadySeen = traits[0, $4S3bk.MSTEAMS_ISSUES_VIEW_TRAIT_NAME] || (0, $n8dVT.getIssuesViewNudgeState)();
        const isEligibleUser = isTenantActive && !hasSeenOtherThirdPartyNudges && !hasAlreadySeen;
        return isEligibleUser ? (0, $79xbN.expValEquals)('third_party_app_nudge_on_issues_view', 'cohort', 'variation') : false;
    }, [
        fetchAllTraits,
        cloudId,
        atlassianAccountId
    ]);
    return {
        triggerIssueCommentThirdPartyNudgeExperiment: triggerIssueCommentThirdPartyNudgeExperiment,
        triggerNotificationBellPartyNudgeExperiment: triggerNotificationBellPartyNudgeExperiment,
        shouldThirdPartySpotlightAppear: shouldThirdPartySpotlightAppear
    };
};

});
parcelRegister("4S3bk", function(module, exports) {

$parcel$export(module.exports, "TEAMS_APP_ID", () => $361d14552780f320$export$b476a840a5a09155);
$parcel$export(module.exports, "DAYS_BEFORE_INACTIVE_TENANT", () => $361d14552780f320$export$6036aa9230bfb3f5);
$parcel$export(module.exports, "DAYS_BEFORE_INACTIVE_USER", () => $361d14552780f320$export$f40e5c9c7b60d068);
$parcel$export(module.exports, "DAYS_SINCE_LAST_NUDGE", () => $361d14552780f320$export$dcb82abacceefba4);
$parcel$export(module.exports, "DAYS_SINCE_FIRST_LOGIN", () => $361d14552780f320$export$59c38436864bd283);
$parcel$export(module.exports, "DAYS_SINCE_SNOOZE", () => $361d14552780f320$export$e1ac23c8732476f9);
$parcel$export(module.exports, "ExperimentType", () => $361d14552780f320$export$8c84b4abfb7bd268);
$parcel$export(module.exports, "TeamsDeepLinkSource", () => $361d14552780f320$export$484de43fbd2571f8);
$parcel$export(module.exports, "PERSONALIZATION_URL", () => $361d14552780f320$export$28fb02d117a2ff8e);
$parcel$export(module.exports, "MSTEAMS_TENANT_TRAIT_NAME", () => $361d14552780f320$export$397d375b795e7497);
$parcel$export(module.exports, "SLACK_TENANT_TRAIT_NAME", () => $361d14552780f320$export$50e919bd161b2fec);
$parcel$export(module.exports, "MSTEAMS_USER_TRAIT_NAME", () => $361d14552780f320$export$37885255b1d60364);
$parcel$export(module.exports, "SLACK_USER_TRAIT_NAME", () => $361d14552780f320$export$c7104391aaa79daf);
$parcel$export(module.exports, "DISMISSED_TRAIT_NAME", () => $361d14552780f320$export$e74cbf9e9a309f73);
$parcel$export(module.exports, "MSTEAMS_ISSUES_VIEW_TRAIT_NAME", () => $361d14552780f320$export$b71e0b7cb09921c2);
$parcel$export(module.exports, "NOTIFICATION_BELL_TRAIT_NAME", () => $361d14552780f320$export$502bf89fef175ff2);
$parcel$export(module.exports, "JIRA_FIRST_ACTIVE_TRAIT", () => $361d14552780f320$export$1fd159178045a2ee);
$parcel$export(module.exports, "ISSUE_WATCH_NUDGE_TRAIT_NAME", () => $361d14552780f320$export$df79c140709c5b63);
$parcel$export(module.exports, "DISMISS_NOTIFICATION_NUDGE_TRAIT_NAME", () => $361d14552780f320$export$754c4ccd15771179);
$parcel$export(module.exports, "NOTIFICATION_NUDGE_SEEN_TRAIT_NAME", () => $361d14552780f320$export$8a776f794abbea4d);
$parcel$export(module.exports, "SNOOZE_NOTIFICATION_NUDGE_TRAIT_NAME", () => $361d14552780f320$export$bc9288faa3badc99);
const $361d14552780f320$export$b476a840a5a09155 = 'aa183fd9-7104-46c4-af9f-9ee9b81d717e';
const $361d14552780f320$export$6036aa9230bfb3f5 = 180;
const $361d14552780f320$export$f40e5c9c7b60d068 = 150;
const $361d14552780f320$export$dcb82abacceefba4 = 90;
const $361d14552780f320$export$59c38436864bd283 = 7;
const $361d14552780f320$export$e1ac23c8732476f9 = 7;
const $361d14552780f320$export$8c84b4abfb7bd268 = {
    JSW_COMMENT: 'thirdPartyNudgeAfterComment',
    ISSUES_VIEW: 'thirdPartyNudgeIssueView',
    NOTIFICATION_BELL: 'thirdPartyNotificationBellNudge',
    ISSUES_WATCH: 'thirdPartyNudgeIssueWatch',
    NOTIFICATIONS_SECTION: 'thirdPartyNotificationsSectionNudge'
};
const $361d14552780f320$export$484de43fbd2571f8 = {
    JSW_COMMENT: 'third-party-nudge-jsw-comment',
    ISSUE_WATCH: 'third-party-nudge-issue-watch',
    ISSUES_VIEW: 'third-party-nudge-issue-view',
    NOTIFICATION_BELL: 'third-party-nudge-notification-bell'
};
const $361d14552780f320$export$28fb02d117a2ff8e = '/gateway/api/tap-delivery/api/v3/personalization';
const $361d14552780f320$export$397d375b795e7497 = 'jira_msteams_v2_track_days_since_tenant_last_active';
const $361d14552780f320$export$50e919bd161b2fec = 'external_product_integrations_track_jira_slack_days_since_tenant_last_active';
const $361d14552780f320$export$37885255b1d60364 = 'jira_msteams_v2_track_days_since_user_last_active';
const $361d14552780f320$export$c7104391aaa79daf = 'external_product_integrations_track_jira_slack_days_since_user_last_active';
const $361d14552780f320$export$e74cbf9e9a309f73 = 'jira_screen_viewed_thirdpartynudgescreen_first_time';
const $361d14552780f320$export$b71e0b7cb09921c2 = 'jira_screen_viewed_issuesnavigatorthirdpartynudgescreen_last_time';
const $361d14552780f320$export$502bf89fef175ff2 = 'jira_screen_viewed_notificationbellthirdpartynudgescreen_last_time';
const $361d14552780f320$export$1fd159178045a2ee = 'jira_first_active';
const $361d14552780f320$export$df79c140709c5b63 = 'jira_screen_viewed_issuewatchthirdpartynudgescreen_last_time';
const $361d14552780f320$export$754c4ccd15771179 = 'jira_ui_button_clicked_notificationsthirdpartynudgedismiss_first_time';
const $361d14552780f320$export$8a776f794abbea4d = 'jira_screen_viewed_notificationsectionthirdpartynudgescreen_last_time';
const $361d14552780f320$export$bc9288faa3badc99 = 'jira_ui_button_clicked_notificationsthirdpartynudgesnooze_last_time';
const $361d14552780f320$export$74c724bfd2fb2795 = 'https://www.atlassian.com/legal/privacy-policy';

});

parcelRegister("bi10L", function(module, exports) {

$parcel$export(module.exports, "setHasSeenNudge", () => $303fd84bc9e3396a$export$797f6da9750e4260);
$parcel$export(module.exports, "getHasSeenNudge", () => $303fd84bc9e3396a$export$c034158c5a3998dd);

var $aZaPn = parcelRequire("aZaPn");
const $303fd84bc9e3396a$var$store = (0, $aZaPn.createLocalStorageProvider)('third-party-nudge');
const $303fd84bc9e3396a$var$HAS_SEEN_NUDGE_KEY = 'has-seen-nudge';
const $303fd84bc9e3396a$export$797f6da9750e4260 = ()=>{
    $303fd84bc9e3396a$var$store.set($303fd84bc9e3396a$var$HAS_SEEN_NUDGE_KEY, true);
};
const $303fd84bc9e3396a$export$c034158c5a3998dd = ()=>$303fd84bc9e3396a$var$store.get($303fd84bc9e3396a$var$HAS_SEEN_NUDGE_KEY) || false;

});

parcelRegister("cEwHS", function(module, exports) {

$parcel$export(module.exports, "usePersonalization", () => $00d79e020b8b55ea$export$9543f8d9a80ddfb0);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4S3bk = parcelRequire("4S3bk");
const $00d79e020b8b55ea$var$getTraitValue = (traitName, traits)=>{
    if (!traits || !traits.attributes || traits.attributes.length === 0) return;
    const matches = traits.attributes.filter((attribute)=>attribute.name === traitName);
    if (matches.length === 0) return;
    return matches[0];
};
const $00d79e020b8b55ea$export$9543f8d9a80ddfb0 = ()=>{
    const [isInitialized, setIsInitialized] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [traits, setTraits] = (0, $eUqFw.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireFetchEvent = (0, $eUqFw.useCallback)((action, scope, experimentType, detail)=>{
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
            type: 'sendOperationalEvent'
        }), `fetchTraits ${action}`, {
            experiment: experimentType,
            scope: scope,
            detail: detail
        });
    }, [
        createAnalyticsEvent
    ]);
    const fetchSiteUserTraits = (0, $eUqFw.useCallback)(async (cloudId, atlassianAccountId, experimentType = (0, $4S3bk.ExperimentType).JSW_COMMENT)=>{
        try {
            const result = await fetch(`${(0, $4S3bk.PERSONALIZATION_URL)}/site/${cloudId}/user/${atlassianAccountId}`);
            if (result.status !== 200) {
                fireFetchEvent('failed', 'SITE_USER', result.statusText);
                return;
            }
            const json = await result.json();
            const dismissedTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.DISMISSED_TRAIT_NAME), json);
            const msteamsIssuesViewTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.MSTEAMS_ISSUES_VIEW_TRAIT_NAME), json);
            const notificationBellTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.NOTIFICATION_BELL_TRAIT_NAME), json);
            const jiraFirstActiveTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.JIRA_FIRST_ACTIVE_TRAIT), json);
            const issueWatchNudgeTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.ISSUE_WATCH_NUDGE_TRAIT_NAME), json);
            const dismissedNotificationNudgeTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.DISMISS_NOTIFICATION_NUDGE_TRAIT_NAME), json);
            const notificationsNudgeSeenTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.NOTIFICATION_NUDGE_SEEN_TRAIT_NAME), json);
            const snoozeNotificationNudgeTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.SNOOZE_NOTIFICATION_NUDGE_TRAIT_NAME), json);
            fireFetchEvent('succeeded', 'SITE_USER', experimentType);
            return {
                ...dismissedTrait ? {
                    [(0, $4S3bk.DISMISSED_TRAIT_NAME)]: dismissedTrait.value
                } : {},
                ...msteamsIssuesViewTrait ? {
                    [(0, $4S3bk.MSTEAMS_ISSUES_VIEW_TRAIT_NAME)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    msteamsIssuesViewTrait.value
                } : {},
                ...notificationBellTrait ? {
                    [(0, $4S3bk.NOTIFICATION_BELL_TRAIT_NAME)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    notificationBellTrait.value
                } : {},
                ...jiraFirstActiveTrait ? {
                    [(0, $4S3bk.JIRA_FIRST_ACTIVE_TRAIT)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    jiraFirstActiveTrait.value
                } : {},
                ...issueWatchNudgeTrait ? {
                    [(0, $4S3bk.ISSUE_WATCH_NUDGE_TRAIT_NAME)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    issueWatchNudgeTrait.value
                } : {},
                ...dismissedNotificationNudgeTrait ? {
                    [(0, $4S3bk.DISMISS_NOTIFICATION_NUDGE_TRAIT_NAME)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    dismissedNotificationNudgeTrait.value
                } : {},
                ...notificationsNudgeSeenTrait ? {
                    [(0, $4S3bk.NOTIFICATION_NUDGE_SEEN_TRAIT_NAME)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    notificationsNudgeSeenTrait.value
                } : {},
                ...snoozeNotificationNudgeTrait ? {
                    [(0, $4S3bk.SNOOZE_NOTIFICATION_NUDGE_TRAIT_NAME)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    snoozeNotificationNudgeTrait.value
                } : {}
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            fireFetchEvent('failed', 'SITE_USER', error.message);
        }
    }, [
        fireFetchEvent
    ]);
    const fetchSiteTraits = (0, $eUqFw.useCallback)(async (cloudId, experimentType = (0, $4S3bk.ExperimentType).JSW_COMMENT)=>{
        try {
            const result = await fetch(`${(0, $4S3bk.PERSONALIZATION_URL)}/site/${cloudId}`);
            if (result.status !== 200) {
                fireFetchEvent('failed', 'SITE', result.statusText);
                return;
            }
            const json = await result.json();
            const msteamsTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.MSTEAMS_TENANT_TRAIT_NAME), json);
            const slackTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.SLACK_TENANT_TRAIT_NAME), json);
            fireFetchEvent('succeeded', 'SITE', experimentType);
            return {
                ...msteamsTrait ? {
                    [(0, $4S3bk.MSTEAMS_TENANT_TRAIT_NAME)]: msteamsTrait.value
                } : {},
                ...slackTrait ? {
                    [(0, $4S3bk.SLACK_TENANT_TRAIT_NAME)]: slackTrait.value
                } : {}
            };
        } catch (error) {
            if (error instanceof Error) fireFetchEvent('failed', 'SITE', error.message);
        }
    }, [
        fireFetchEvent
    ]);
    const fetchUserTraits = (0, $eUqFw.useCallback)(async (atlassianAccountId, experimentType = (0, $4S3bk.ExperimentType).JSW_COMMENT)=>{
        try {
            const result = await fetch(`${(0, $4S3bk.PERSONALIZATION_URL)}/user/${atlassianAccountId}`);
            if (result.status !== 200) {
                fireFetchEvent('failed', 'USER', result.statusText);
                return;
            }
            const json = await result.json();
            const msteamsTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.MSTEAMS_USER_TRAIT_NAME), json);
            const slackTrait = $00d79e020b8b55ea$var$getTraitValue((0, $4S3bk.SLACK_USER_TRAIT_NAME), json);
            fireFetchEvent('succeeded', 'USER', experimentType);
            return {
                ...msteamsTrait ? {
                    [(0, $4S3bk.MSTEAMS_USER_TRAIT_NAME)]: msteamsTrait.value
                } : {},
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ...slackTrait ? {
                    [(0, $4S3bk.SLACK_USER_TRAIT_NAME)]: slackTrait.value
                } : {}
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            fireFetchEvent('failed', 'USER', error.message);
        }
    }, [
        fireFetchEvent
    ]);
    const getTraitPromises = (0, $eUqFw.useCallback)((isInitial, experimentType, cloudId, atlassianAccountId)=>{
        // Always fetch site user traits. If the user has dismissed the nudge, we need to know.
        if (isInitial) return [
            fetchSiteUserTraits(cloudId, atlassianAccountId)
        ];
        const siteAndSiteUserPromises = [
            fetchSiteUserTraits(cloudId, atlassianAccountId),
            fetchSiteTraits(cloudId)
        ];
        switch(experimentType){
            case (0, $4S3bk.ExperimentType).ISSUES_VIEW:
                return siteAndSiteUserPromises;
            case (0, $4S3bk.ExperimentType).JSW_COMMENT:
            case (0, $4S3bk.ExperimentType).NOTIFICATION_BELL:
            case (0, $4S3bk.ExperimentType).NOTIFICATIONS_SECTION:
            default:
                return [
                    ...siteAndSiteUserPromises,
                    fetchUserTraits(atlassianAccountId)
                ];
        }
    }, [
        fetchSiteUserTraits,
        fetchSiteTraits,
        fetchUserTraits
    ]);
    const fetchAllTraits = (0, $eUqFw.useCallback)(async (cloudId, atlassianAccountId, experimentType = (0, $4S3bk.ExperimentType).JSW_COMMENT)=>{
        if (!cloudId || !atlassianAccountId) {
            fireFetchEvent('failed', 'MISSING_PARAMS', experimentType);
            return;
        }
        setIsLoading(true);
        const promises = getTraitPromises(isInitialized, experimentType, cloudId, atlassianAccountId);
        const results = await Promise.allSettled(promises);
        if (results.some((result)=>result.status === 'rejected')) {
            setIsLoading(false);
            return;
        }
        const result = results.reduce((acc, current)=>{
            if (current.status === 'fulfilled') return Object.assign(current.value || {}, acc);
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {});
        setTraits((prevState = {})=>Object.assign(prevState, result));
        setIsLoading(false);
        setIsInitialized(true);
        return Object.assign(traits || {}, result);
    }, [
        fireFetchEvent,
        isInitialized,
        traits,
        getTraitPromises
    ]);
    const value = (0, $eUqFw.useMemo)(()=>({
            isInitialized: isInitialized,
            isLoading: isLoading,
            traits: traits,
            fetchAllTraits: fetchAllTraits
        }), [
        isInitialized,
        isLoading,
        traits,
        fetchAllTraits
    ]);
    return value;
};

});

parcelRegister("n8dVT", function(module, exports) {

$parcel$export(module.exports, "setIssuesViewNudgeState", () => $4e04e97bd4182ed5$export$4dd07317d9b5915f);
$parcel$export(module.exports, "setIssueWatchNudgeState", () => $4e04e97bd4182ed5$export$4161efedb3ca161f);
$parcel$export(module.exports, "setNotificationBellNudgeState", () => $4e04e97bd4182ed5$export$aef9ea27a6e27c31);
$parcel$export(module.exports, "getIssuesViewNudgeState", () => $4e04e97bd4182ed5$export$b8723210651350d);
$parcel$export(module.exports, "getNotificationNudgeState", () => $4e04e97bd4182ed5$export$d18d4819029516b1);
$parcel$export(module.exports, "getIssueWatchNudgeState", () => $4e04e97bd4182ed5$export$6d279fc1eb9dc70);

var $89bO2 = parcelRequire("89bO2");
const $4e04e97bd4182ed5$var$store = (0, $89bO2.createSessionStorageProvider)('third-party-nudge');
const $4e04e97bd4182ed5$var$ISSUES_VIEW_NUDGE_KEY = 'issues-view-nudge-date';
const $4e04e97bd4182ed5$var$NOTIFICATION_BELL_NUDGE_KEY = 'notification-bell-nudge-state';
const $4e04e97bd4182ed5$var$NOTIFICATION_SECTION_NUDGE_KEY = 'notification-section-nudge-state';
const $4e04e97bd4182ed5$var$ISSUE_WATCH_NUDGE_KEY = 'issues-watch-nudge-state';
const $4e04e97bd4182ed5$export$4dd07317d9b5915f = ()=>{
    $4e04e97bd4182ed5$var$store.set($4e04e97bd4182ed5$var$ISSUES_VIEW_NUDGE_KEY, true);
};
const $4e04e97bd4182ed5$export$4161efedb3ca161f = ()=>{
    $4e04e97bd4182ed5$var$store.set($4e04e97bd4182ed5$var$ISSUE_WATCH_NUDGE_KEY, true);
};
const $4e04e97bd4182ed5$export$aef9ea27a6e27c31 = ()=>{
    $4e04e97bd4182ed5$var$store.set($4e04e97bd4182ed5$var$NOTIFICATION_BELL_NUDGE_KEY, true);
};
const $4e04e97bd4182ed5$export$57dbaa6dfc748e05 = ()=>{
    $4e04e97bd4182ed5$var$store.set($4e04e97bd4182ed5$var$NOTIFICATION_SECTION_NUDGE_KEY, true);
};
const $4e04e97bd4182ed5$export$b8723210651350d = ()=>$4e04e97bd4182ed5$var$store.get($4e04e97bd4182ed5$var$ISSUES_VIEW_NUDGE_KEY) || false;
const $4e04e97bd4182ed5$export$d18d4819029516b1 = ()=>$4e04e97bd4182ed5$var$store.get($4e04e97bd4182ed5$var$NOTIFICATION_BELL_NUDGE_KEY) || false;
const $4e04e97bd4182ed5$export$6d279fc1eb9dc70 = ()=>$4e04e97bd4182ed5$var$store.get($4e04e97bd4182ed5$var$ISSUE_WATCH_NUDGE_KEY) || false;
const $4e04e97bd4182ed5$export$144ea8a31358efd9 = ()=>$4e04e97bd4182ed5$var$store.get($4e04e97bd4182ed5$var$NOTIFICATION_SECTION_NUDGE_KEY) || false;

});

parcelRegister("f4pAb", function(module, exports) {

$parcel$export(module.exports, "generateFlagId", () => $a54e9f88c64fae74$export$1df20ac41cb2fa5d);
$parcel$export(module.exports, "openTeamsDeepLink", () => $a54e9f88c64fae74$export$e2c30e91aca3a244);
$parcel$export(module.exports, "isTenantActiveOnSlack", () => $a54e9f88c64fae74$export$4fb47bd72bea8fe1);
$parcel$export(module.exports, "isUserActiveOnSlack", () => $a54e9f88c64fae74$export$2799d7aad9ba8075);
$parcel$export(module.exports, "isTenantActiveOnMsteams", () => $a54e9f88c64fae74$export$9fac56e1e8bde50);
$parcel$export(module.exports, "isUserActiveOnMsteams", () => $a54e9f88c64fae74$export$7b9993195fbe5513);
$parcel$export(module.exports, "isNewJiraUser", () => $a54e9f88c64fae74$export$7e6bdbcd458053e6);
$parcel$export(module.exports, "hasSeenIssueCommentNudge", () => $a54e9f88c64fae74$export$99f6be9c2e86203);
$parcel$export(module.exports, "hasSeenNotificationsNudge", () => $a54e9f88c64fae74$export$3e53111ce9af6aaa);
$parcel$export(module.exports, "hasSeenIssuesViewNudge", () => $a54e9f88c64fae74$export$37dfb59b6b607265);
$parcel$export(module.exports, "hasSeenNotificationBellNudge", () => $a54e9f88c64fae74$export$c83d8ad295a13c63);
$parcel$export(module.exports, "hasSeenIssueWatchNudge", () => $a54e9f88c64fae74$export$be43d47447236517);

var $d2wNG = parcelRequire("d2wNG");

var $4S3bk = parcelRequire("4S3bk");
let $a54e9f88c64fae74$var$flagId = 0;
const $a54e9f88c64fae74$export$1df20ac41cb2fa5d = ()=>String($a54e9f88c64fae74$var$flagId++);
const $a54e9f88c64fae74$export$1c49788f82ee9446 = (source)=>`https://teams.microsoft.com/l/app/${0, $4S3bk.TEAMS_APP_ID}?source=${source}`;
const $a54e9f88c64fae74$export$e2c30e91aca3a244 = (source = (0, $4S3bk.TeamsDeepLinkSource).JSW_COMMENT)=>{
    window.open($a54e9f88c64fae74$export$1c49788f82ee9446(source), '_blank', 'noopener, noreferrer');
};
const $a54e9f88c64fae74$export$4fb47bd72bea8fe1 = (traits)=>traits[0, $4S3bk.SLACK_TENANT_TRAIT_NAME] !== undefined && traits[0, $4S3bk.SLACK_TENANT_TRAIT_NAME] <= (0, $4S3bk.DAYS_BEFORE_INACTIVE_TENANT);
const $a54e9f88c64fae74$export$2799d7aad9ba8075 = (traits)=>traits[0, $4S3bk.SLACK_USER_TRAIT_NAME] !== undefined && traits[0, $4S3bk.SLACK_USER_TRAIT_NAME] <= (0, $4S3bk.DAYS_BEFORE_INACTIVE_USER);
const $a54e9f88c64fae74$export$9fac56e1e8bde50 = (traits)=>traits[0, $4S3bk.MSTEAMS_TENANT_TRAIT_NAME] !== undefined && traits[0, $4S3bk.MSTEAMS_TENANT_TRAIT_NAME] <= (0, $4S3bk.DAYS_BEFORE_INACTIVE_TENANT);
const $a54e9f88c64fae74$export$7b9993195fbe5513 = (traits)=>traits[0, $4S3bk.MSTEAMS_USER_TRAIT_NAME] !== undefined && traits[0, $4S3bk.MSTEAMS_USER_TRAIT_NAME] <= (0, $4S3bk.DAYS_BEFORE_INACTIVE_USER);
const $a54e9f88c64fae74$export$7e6bdbcd458053e6 = (traits)=>{
    const firstJiraActiveTraitValue = traits[0, $4S3bk.JIRA_FIRST_ACTIVE_TRAIT];
    return firstJiraActiveTraitValue !== undefined && (0, $d2wNG.default)(new Date(), new Date(firstJiraActiveTraitValue)) < (0, $4S3bk.DAYS_SINCE_FIRST_LOGIN);
};
const $a54e9f88c64fae74$export$99f6be9c2e86203 = (traits)=>{
    const dismissedTraitValue = traits[0, $4S3bk.DISMISSED_TRAIT_NAME];
    return dismissedTraitValue !== undefined && (0, $d2wNG.default)(new Date(), new Date(dismissedTraitValue)) < (0, $4S3bk.DAYS_SINCE_LAST_NUDGE);
};
const $a54e9f88c64fae74$export$3e53111ce9af6aaa = (traits)=>{
    const notificationsNudgeSeenTraitValue = traits[0, $4S3bk.NOTIFICATION_NUDGE_SEEN_TRAIT_NAME];
    return notificationsNudgeSeenTraitValue !== undefined && (0, $d2wNG.default)(new Date(), new Date(notificationsNudgeSeenTraitValue)) < (0, $4S3bk.DAYS_SINCE_LAST_NUDGE);
};
const $a54e9f88c64fae74$export$37dfb59b6b607265 = (traits)=>{
    const issuesViewTraitValue = traits[0, $4S3bk.MSTEAMS_ISSUES_VIEW_TRAIT_NAME];
    return issuesViewTraitValue !== undefined && (0, $d2wNG.default)(new Date(), new Date(issuesViewTraitValue)) < (0, $4S3bk.DAYS_SINCE_LAST_NUDGE);
};
const $a54e9f88c64fae74$export$c83d8ad295a13c63 = (traits)=>{
    const notificationBellTraitValue = traits[0, $4S3bk.NOTIFICATION_BELL_TRAIT_NAME];
    return notificationBellTraitValue !== undefined && (0, $d2wNG.default)(new Date(), new Date(notificationBellTraitValue)) < (0, $4S3bk.DAYS_SINCE_LAST_NUDGE);
};
const $a54e9f88c64fae74$export$be43d47447236517 = (traits)=>{
    const issuesWatchNudgeTraitValue = traits[0, $4S3bk.ISSUE_WATCH_NUDGE_TRAIT_NAME];
    return issuesWatchNudgeTraitValue !== undefined && (0, $d2wNG.default)(new Date(), new Date(issuesWatchNudgeTraitValue)) < (0, $4S3bk.DAYS_SINCE_LAST_NUDGE);
};
const $a54e9f88c64fae74$export$c65a6a099e4e7540 = (traits)=>{
    const isDismissed = traits[0, $4S3bk.DISMISS_NOTIFICATION_NUDGE_TRAIT_NAME];
    return isDismissed !== undefined;
};
const $a54e9f88c64fae74$export$db96ffd460de2f3c = (traits)=>{
    const snoozedTraitValue = traits[0, $4S3bk.SNOOZE_NOTIFICATION_NUDGE_TRAIT_NAME];
    return snoozedTraitValue !== undefined && (0, $d2wNG.default)(new Date(), new Date(snoozedTraitValue)) < (0, $4S3bk.DAYS_SINCE_SNOOZE);
};

});

parcelRegister("65mYQ", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyNudgeFlag", () => $76d2b218e05d3d4f$export$4fda1972e27def44);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
var $k8Qyf = parcelRequire("k8Qyf");

var $f4pAb = parcelRequire("f4pAb");

var $fvlJy = parcelRequire("fvlJy");
const $76d2b218e05d3d4f$export$4fda1972e27def44 = ({ cloudId: cloudId })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    const showThirdPartyNudgeFlag = (0, $eUqFw.useCallback)(({ variant: variant, experimentType: experimentType })=>{
        const flagId = `third-party-nudge-flag-${(0, $f4pAb.generateFlagId)()}`;
        const doDismissFlag = ()=>{
            dismissFlag((0, $8vPhU.dismissFlag)(flagId));
        };
        const flagProps = {
            id: flagId,
            cloudId: cloudId,
            variant: variant,
            onDismiss: doDismissFlag
        };
        showFlag({
            id: flagId,
            render: (props)=>experimentType === 'NOTIFICATION_BELL' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fvlJy.ThirdPartyNotificationBellFlag), {
                    ...props,
                    ...flagProps
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fvlJy.ThirdPartyIssueCommentFlag), {
                    ...props,
                    ...flagProps
                })
        });
    }, [
        cloudId,
        dismissFlag,
        showFlag
    ]);
    return {
        showThirdPartyNudgeFlag: showThirdPartyNudgeFlag
    };
};

});
parcelRegister("fvlJy", function(module, exports) {

$parcel$export(module.exports, "ThirdPartyIssueCommentFlag", () => $11682305421c1f66$export$c4e74f7f67cd16b2);
$parcel$export(module.exports, "ThirdPartyNotificationBellFlag", () => $11682305421c1f66$export$e1f14322b5e8104c);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JCC2 = parcelRequire("5JCC2");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $4S3bk = parcelRequire("4S3bk");

var $bi10L = parcelRequire("bi10L");

var $n8dVT = parcelRequire("n8dVT");

var $f4pAb = parcelRequire("f4pAb");

var $gypOP = parcelRequire("gypOP");

var $13E5S = parcelRequire("13E5S");

var $7n2zl = parcelRequire("7n2zl");

var $63JIe = parcelRequire("63JIe");

var $dmJS7 = parcelRequire("dmJS7");

var $eLu8C = parcelRequire("eLu8C");

var $5JM1u = parcelRequire("5JM1u");

var $dYiWN = parcelRequire("dYiWN");

var $a2Cyi = parcelRequire("a2Cyi");
const $11682305421c1f66$export$c4e74f7f67cd16b2 = ({ cloudId: cloudId, variant: variant, onDismiss: onDismiss })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $bi10L.setHasSeenNudge)();
    }, []);
    const slackService = (0, $eUqFw.useMemo)(()=>(0, $5JCC2.slackServiceFactory)(cloudId, 'jira', createAnalyticsEvent), [
        cloudId,
        createAnalyticsEvent
    ]);
    const handleConnectSlackButtonClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'thirdPartyConnect', {
            thirdPartyApp: 'slack',
            trigger: 'after-issue-comment'
        }); // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        slackService.getConsent(()=>{});
    }, [
        createAnalyticsEvent,
        slackService
    ]);
    const handleConnectTeamsButtonClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'thirdPartyConnect', {
            thirdPartyApp: 'msteams',
            trigger: 'after-issue-comment'
        });
        (0, $f4pAb.openTeamsDeepLink)();
    }, [
        createAnalyticsEvent
    ]);
    const handleDismissButtonClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'thirdPartyNudgeJswComment', {
            suggestedThirdPartyApps: variant === 'both' ? [
                'slack',
                'msteams'
            ] : [
                variant
            ],
            trigger: 'after-issue-comment'
        });
        onDismiss();
    }, [
        createAnalyticsEvent,
        onDismiss,
        variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "thirdPartyNudge",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            suggestedThirdPartyApps: variant === 'both' ? [
                'slack',
                'msteams'
            ] : [
                variant
            ],
            trigger: 'after-issue-comment'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7n2zl.NudgeFlag), {
        onDismiss: handleDismissButtonClick
    }, variant === 'slack' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dYiWN.SlackSplash), null), variant === 'msteams' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a2Cyi.TeamsSplash), null), variant === 'both' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $63JIe.BothSplash), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$FlagBodyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$FlagBodyContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$FlagHeader, null, formatMessage((0, $13E5S.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$FlagDescription, null, variant === 'slack' && formatMessage((0, $13E5S.messages).descriptionSlack), variant === 'msteams' && formatMessage((0, $13E5S.messages).descriptionTeams), variant === 'both' && formatMessage((0, $13E5S.messages).descriptionBoth))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$CtaWrapper, null, variant === 'slack' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        testId: "third-party-nudge.ui.third-party-nudge-flag.connect-slack-button",
        onClick: handleConnectSlackButtonClick
    }, formatMessage((0, $13E5S.messages).connectSlackButton)), variant === 'msteams' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        testId: "third-party-nudge.ui.third-party-nudge-flag.find-out-more-button",
        onClick: handleConnectTeamsButtonClick
    }, formatMessage((0, $13E5S.messages).findOutMoreButton)), variant === 'both' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$ConnectIntegrationsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$ConnectIntegrationsHeader, null, formatMessage((0, $13E5S.messages).connectHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$IntegrationButtonsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gypOP.SlackConnectButton), {
        onClick: handleConnectSlackButtonClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gypOP.MicrosoftTeamsConnectButton), {
        onClick: handleConnectTeamsButtonClick
    })))))));
};
const $11682305421c1f66$export$e1f14322b5e8104c = ({ cloudId: cloudId, variant: variant, onDismiss: onDismiss })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        (0, $n8dVT.setNotificationBellNudgeState)();
    }, []);
    const slackService = (0, $eUqFw.useMemo)(()=>(0, $5JCC2.slackServiceFactory)(cloudId, 'jira', createAnalyticsEvent), [
        cloudId,
        createAnalyticsEvent
    ]);
    const handleConnectSlackButtonClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'notificationBellThirdPartyConnect', {
            thirdPartyApp: 'slack',
            trigger: 'notification-bell'
        }); // eslint-disable-next-line @typescript-eslint/no-empty-function
        slackService.getConsent(()=>{});
    }, [
        createAnalyticsEvent,
        slackService
    ]);
    const handleConnectTeamsButtonClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'notificationBellThirdPartyConnect', {
            thirdPartyApp: 'msteams',
            trigger: 'notification-bell'
        });
        (0, $f4pAb.openTeamsDeepLink)((0, $4S3bk.TeamsDeepLinkSource).NOTIFICATION_BELL);
    }, [
        createAnalyticsEvent
    ]);
    const handleDismissButtonClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'notificationBellThirdPartyDismiss', {
            suggestedThirdPartyApps: variant === 'both' ? [
                'slack',
                'msteams'
            ] : [
                variant
            ],
            trigger: 'notification-bell'
        });
        onDismiss();
    }, [
        createAnalyticsEvent,
        onDismiss,
        variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "notificationBellThirdPartyNudge",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            suggestedThirdPartyApps: variant === 'both' ? [
                'slack',
                'msteams'
            ] : [
                variant
            ],
            trigger: 'notification-bell'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7n2zl.NudgeFlag), {
        onDismiss: handleDismissButtonClick
    }, variant === 'slack' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eLu8C.NotificationBellSlackSplash), null), variant === 'msteams' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5JM1u.NotificationBellTeamsSplash), null), variant === 'both' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dmJS7.NotificationBellBothSplash), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$FlagBodyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$FlagBodyContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$FlagHeader, null, variant === 'slack' && formatMessage((0, $13E5S.messages).notificationBellSlackTitle), variant === 'msteams' && formatMessage((0, $13E5S.messages).notificationBellTeamsTitle), variant === 'both' && formatMessage((0, $13E5S.messages).notificationBellBothTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$FlagDescription, null, formatMessage((0, $13E5S.messages).notificationBellDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$CtaWrapper, null, variant === 'slack' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        testId: "third-party-nudge.ui.third-party-nudge-flag.slack-connect-button",
        onClick: handleConnectSlackButtonClick
    }, formatMessage((0, $13E5S.messages).notificationBellConnectSlackButton)), variant === 'msteams' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        testId: "third-party-nudge.ui.third-party-nudge-flag.teams-connect-button",
        onClick: handleConnectTeamsButtonClick
    }, formatMessage((0, $13E5S.messages).notificationBellConnectTeamsButton)), variant === 'both' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$ConnectIntegrationsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$ConnectIntegrationsHeader, null, formatMessage((0, $13E5S.messages).notificationBellConnectHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11682305421c1f66$var$IntegrationButtonsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gypOP.SlackConnectButton), {
        onClick: handleConnectSlackButtonClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gypOP.MicrosoftTeamsConnectButton), {
        onClick: handleConnectTeamsButtonClick
    })))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11682305421c1f66$var$ConnectIntegrationsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11682305421c1f66$var$FlagBodyContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11682305421c1f66$var$FlagHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81bk4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11682305421c1f66$var$FlagDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11682305421c1f66$var$ConnectIntegrationsHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c816g6 _syaz1wmz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11682305421c1f66$var$IntegrationButtonsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11682305421c1f66$var$FlagBodyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41ejb _1e0c1txw _2lx21bp4 _zulp1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11682305421c1f66$var$CtaWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gypOP", function(module, exports) {

$parcel$export(module.exports, "MicrosoftTeamsConnectButton", () => $4182b8abe28f8f6e$export$42e6beee2a04510d);
$parcel$export(module.exports, "SlackConnectButton", () => $4182b8abe28f8f6e$export$f0b644c6caf8e113);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $iFmgL = parcelRequire("iFmgL");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $7SL8T = parcelRequire("7SL8T");

var $8r2v9 = parcelRequire("8r2v9");

var $cW8Hb = parcelRequire("cW8Hb");

var $dqk5f = parcelRequire("dqk5f");
const $4182b8abe28f8f6e$export$42e6beee2a04510d = ({ onClick: onClick })=>{
    const useConsolidatedAssets = (0, $1ybV0.ff)('groot_jfe_assets_consolidation');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4182b8abe28f8f6e$var$IntegrationButton, {
        testId: "third-party-nudge.ui.third-party-nudge-flag.connect-button.both-find-out-more-button",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4182b8abe28f8f6e$var$IntegrationButtonContent, null, useConsolidatedAssets ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4182b8abe28f8f6e$var$teamsLogoWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7SL8T.default), {
        secondaryColor: "currentColor",
        label: "Teams icon"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dqk5f))),
        alt: "Teams icon",
        width: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4182b8abe28f8f6e$var$IntegrationName, null, "Microsoft Teams")));
};
const $4182b8abe28f8f6e$export$f0b644c6caf8e113 = ({ onClick: onClick })=>{
    const useConsolidatedAssets = (0, $1ybV0.ff)('groot_jfe_assets_consolidation');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4182b8abe28f8f6e$var$IntegrationButton, {
        testId: "third-party-nudge.ui.third-party-nudge-flag.connect-button.both-connect-slack-button",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4182b8abe28f8f6e$var$IntegrationButtonContent, null, useConsolidatedAssets ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4182b8abe28f8f6e$var$SlackLogoWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8r2v9.default), {
        label: "Slack icon"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cW8Hb))),
        alt: "Slack icon",
        width: 16
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4182b8abe28f8f6e$var$IntegrationName, null, "Slack")));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4182b8abe28f8f6e$var$IntegrationName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _1wybutpp",
            __cmplp.className
        ])
    });
});
const $4182b8abe28f8f6e$var$IntegrationButtonContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});
const $4182b8abe28f8f6e$var$IntegrationButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $4182b8abe28f8f6e$var$teamsLogoWrapperStyles = (0, $1ZAYh.xcss)({
    width: '16px',
    height: '20px',
    display: 'flex',
    marginLeft: 'space.negative.050',
    marginRight: 'space.050'
});
const $4182b8abe28f8f6e$var$SlackLogoWrapperStyles = (0, $1ZAYh.xcss)({
    width: '20px',
    height: '20px',
    display: 'flex'
});

});
parcelRegister("7SL8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc335f1adedbdc82$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $fc335f1adedbdc82$var$MSTeamsLogo = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "24",
        width: "24",
        viewBox: "-334 -518 2897 3110",
        "data-testid": props['data-testid']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1554.637 777.5h575.713c54.391 0 98.483 44.092 98.483 98.483v524.398c0 199.901-162.051 361.952-361.952 361.952h-1.711c-199.901.028-361.975-162-362.004-361.901V828.971c.001-28.427 23.045-51.471 51.471-51.471z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "233.25",
        cy: "440.583",
        cx: "1943.75",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "336.917",
        cy: "336.917",
        cx: "1218.083",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1667.323 777.5H717.01c-53.743 1.33-96.257 45.931-95.01 99.676v598.105c-7.505 322.519 247.657 590.16 570.167 598.053 322.51-7.893 577.671-275.534 570.167-598.053V877.176c1.245-53.745-41.268-98.346-95.011-99.676z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1244 777.5v838.145c-.258 38.435-23.549 72.964-59.09 87.598a91.856 91.856 0 01-35.765 7.257H667.613c-6.738-17.105-12.958-34.21-18.142-51.833a631.287 631.287 0 01-27.472-183.49V877.02c-1.246-53.659 41.198-98.19 94.855-99.52z",
        opacity: ".1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1192.167 777.5v889.978a91.802 91.802 0 01-7.257 35.765c-14.634 35.541-49.163 58.833-87.598 59.09H691.975c-8.812-17.105-17.105-34.21-24.362-51.833-7.257-17.623-12.958-34.21-18.142-51.833a631.282 631.282 0 01-27.472-183.49V877.02c-1.246-53.659 41.198-98.19 94.855-99.52z",
        opacity: ".2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1192.167 777.5v786.312c-.395 52.223-42.632 94.46-94.855 94.855h-447.84A631.282 631.282 0 01622 1475.177V877.02c-1.246-53.659 41.198-98.19 94.855-99.52z",
        opacity: ".2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1140.333 777.5v786.312c-.395 52.223-42.632 94.46-94.855 94.855H649.472A631.282 631.282 0 01622 1475.177V877.02c-1.246-53.659 41.198-98.19 94.855-99.52z",
        opacity: ".2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1244 509.522v163.275c-8.812.518-17.105 1.037-25.917 1.037-8.812 0-17.105-.518-25.917-1.037a284.472 284.472 0 01-51.833-8.293c-104.963-24.857-191.679-98.469-233.25-198.003a288.02 288.02 0 01-16.587-51.833h258.648c52.305.198 94.657 42.549 94.856 94.854z",
        opacity: ".1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1192.167 561.355v111.442a284.472 284.472 0 01-51.833-8.293c-104.963-24.857-191.679-98.469-233.25-198.003h190.228c52.304.198 94.656 42.55 94.855 94.854z",
        opacity: ".2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1192.167 561.355v111.442a284.472 284.472 0 01-51.833-8.293c-104.963-24.857-191.679-98.469-233.25-198.003h190.228c52.304.198 94.656 42.55 94.855 94.854z",
        opacity: ".2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1140.333 561.355v103.148c-104.963-24.857-191.679-98.469-233.25-198.003h138.395c52.305.199 94.656 42.551 94.855 94.855z",
        opacity: ".2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        gradientTransform: "matrix(1 0 0 -1 0 2075.333)",
        y2: "394.261",
        x2: "942.234",
        y1: "1683.073",
        x1: "198.099",
        gradientUnits: "userSpaceOnUse",
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        "stop-color": "#5a62c3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: ".5",
        "stop-color": "#4d55bd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        "stop-color": "#3940ab"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.01 466.5h950.312c52.473 0 95.01 42.538 95.01 95.01v950.312c0 52.473-42.538 95.01-95.01 95.01H95.01c-52.473 0-95.01-42.538-95.01-95.01V561.51c0-52.472 42.538-95.01 95.01-95.01z",
        fill: "#444cb5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M820.211 828.193h-189.97v517.297h-121.03V828.193H320.123V727.844h500.088z",
        fill: "#FFF"
    }));
const $fc335f1adedbdc82$var$MSTeamsLogomark = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        ...props,
        glyph: $fc335f1adedbdc82$var$MSTeamsLogo
    });
var $fc335f1adedbdc82$export$2e2bcd8739ae039 = $fc335f1adedbdc82$var$MSTeamsLogomark;

});

parcelRegister("8r2v9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d31c6170cbca3c4$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $4d31c6170cbca3c4$var$SlackLogo = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Page-1",
        stroke: "none",
        "stroke-width": "1",
        fill: "none",
        "fill-rule": "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Slack-Mark-Copy",
        transform: "translate(3.000000, 3.000000)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        transform: "translate(0.000000, 9.420114)",
        fill: "#E01E5A"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M3.84042615,1.92021308 C3.84042615,2.95305496 2.99669617,3.79678495 1.96385428,3.79678495 C0.931012401,3.79678495 0.0872824126,2.95305496 0.0872824126,1.92021308 C0.0872824126,0.887371195 0.931012401,0.0436412063 1.96385428,0.0436412063 L3.84042615,0.0436412063 L3.84042615,1.92021308 Z",
        id: "Path"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.78598562,1.92021308 C4.78598562,0.887371195 5.62971561,0.0436412063 6.6625575,0.0436412063 C7.69539938,0.0436412063 8.53912937,0.887371195 8.53912937,1.92021308 L8.53912937,6.61891629 C8.53912937,7.65175817 7.69539938,8.49548816 6.6625575,8.49548816 C5.62971561,8.49548816 4.78598562,7.65175817 4.78598562,6.61891629 L4.78598562,1.92021308 Z",
        id: "Path"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "#36C5F0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.6625575,3.84042615 C5.62971561,3.84042615 4.78598562,2.99669617 4.78598562,1.96385428 C4.78598562,0.931012401 5.62971561,0.0872824126 6.6625575,0.0872824126 C7.69539938,0.0872824126 8.53912937,0.931012401 8.53912937,1.96385428 L8.53912937,3.84042615 L6.6625575,3.84042615 Z",
        id: "Path"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.6625575,4.78598562 C7.69539938,4.78598562 8.53912937,5.62971561 8.53912937,6.6625575 C8.53912937,7.69539938 7.69539938,8.53912937 6.6625575,8.53912937 L1.96385428,8.53912937 C0.931012401,8.53912937 0.0872824126,7.69539938 0.0872824126,6.6625575 C0.0872824126,5.62971561 0.931012401,4.78598562 1.96385428,4.78598562 L6.6625575,4.78598562 Z",
        id: "Path"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        transform: "translate(9.420114, 0.000000)",
        fill: "#2EB67D"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.74234442,6.6625575 C4.74234442,5.62971561 5.58607441,4.78598562 6.61891629,4.78598562 C7.65175817,4.78598562 8.49548816,5.62971561 8.49548816,6.6625575 C8.49548816,7.69539938 7.65175817,8.53912937 6.61891629,8.53912937 L4.74234442,8.53912937 L4.74234442,6.6625575 Z",
        id: "Path"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M3.79678495,6.6625575 C3.79678495,7.69539938 2.95305496,8.53912937 1.92021308,8.53912937 C0.887371195,8.53912937 0.0436412063,7.69539938 0.0436412063,6.6625575 L0.0436412063,1.96385428 C0.0436412063,0.931012401 0.887371195,0.0872824126 1.92021308,0.0872824126 C2.95305496,0.0872824126 3.79678495,0.931012401 3.79678495,1.96385428 L3.79678495,6.6625575 Z",
        id: "Path"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        transform: "translate(9.420114, 9.420114)",
        fill: "#ECB22E"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1.92021308,4.74234442 C2.95305496,4.74234442 3.79678495,5.58607441 3.79678495,6.61891629 C3.79678495,7.65175817 2.95305496,8.49548816 1.92021308,8.49548816 C0.887371195,8.49548816 0.0436412063,7.65175817 0.0436412063,6.61891629 L0.0436412063,4.74234442 L1.92021308,4.74234442 Z",
        id: "Path"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M1.92021308,3.79678495 C0.887371195,3.79678495 0.0436412063,2.95305496 0.0436412063,1.92021308 C0.0436412063,0.887371195 0.887371195,0.0436412063 1.92021308,0.0436412063 L6.61891629,0.0436412063 C7.65175817,0.0436412063 8.49548816,0.887371195 8.49548816,1.92021308 C8.49548816,2.95305496 7.65175817,3.79678495 6.61891629,3.79678495 L1.92021308,3.79678495 Z",
        id: "Path"
    }))))));
const $4d31c6170cbca3c4$var$SlackLogomark = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        ...props,
        glyph: $4d31c6170cbca3c4$var$SlackLogo
    });
var $4d31c6170cbca3c4$export$2e2bcd8739ae039 = $4d31c6170cbca3c4$var$SlackLogomark;

});

parcelRegister("cW8Hb", function(module, exports) {
module.exports = new URL("slack.26cbe450.svg", import.meta.url).toString();

});

parcelRegister("dqk5f", function(module, exports) {
module.exports = new URL("teams.b0e5e774.svg", import.meta.url).toString();

});


parcelRegister("13E5S", function(module, exports) {

$parcel$export(module.exports, "messages", () => $054e0700aec57954$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $054e0700aec57954$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "third-party-nudge.third-party-nudge-flag.title",
        "defaultMessage": "Stay updated on your work"
    },
    descriptionSlack: {
        "id": "third-party-nudge.third-party-nudge-flag.description-slack",
        "defaultMessage": "Get real-time updates in Slack where your team can quickly see and respond to project needs."
    },
    descriptionTeams: {
        "id": "third-party-nudge.third-party-nudge-flag.description-teams",
        "defaultMessage": "Get real-time updates in Microsoft Teams where your team can quickly see and respond to project needs."
    },
    descriptionBoth: {
        "id": "third-party-nudge.third-party-nudge-flag.description-both",
        "defaultMessage": "Get real-time updates in your chat tool where your team can quickly see and respond to project needs."
    },
    findOutMoreButton: {
        "id": "third-party-nudge.third-party-nudge-flag.find-out-more-button",
        "defaultMessage": "Find out more"
    },
    connectSlackButton: {
        "id": "third-party-nudge.third-party-nudge-flag.connect-slack-button",
        "defaultMessage": "Connect Slack"
    },
    connectHeader: {
        "id": "third-party-nudge.third-party-nudge-flag.connect-header",
        "defaultMessage": "Connect"
    },
    notificationBellTeamsTitle: {
        "id": "third-party-nudge.third-party-nudge-flag.notification-bell-teams-title",
        "defaultMessage": "Get personal notifications in Teams"
    },
    notificationBellSlackTitle: {
        "id": "third-party-nudge.third-party-nudge-flag.notification-bell-slack-title",
        "defaultMessage": "Get personal notifications in Slack"
    },
    notificationBellBothTitle: {
        "id": "third-party-nudge.third-party-nudge-flag.notification-bell-both-title",
        "defaultMessage": "Get instant personal notifications"
    },
    notificationBellDescription: {
        "id": "third-party-nudge.third-party-nudge-flag.notification-bell-description",
        "defaultMessage": "Stay on top of your work and respond to project needs in real time with custom, personal notifications."
    },
    notificationBellConnectTeamsButton: {
        "id": "third-party-nudge.third-party-nudge-flag.notification-bell-connect-teams-button",
        "defaultMessage": "Connect Microsoft Teams"
    },
    notificationBellConnectSlackButton: {
        "id": "third-party-nudge.third-party-nudge-flag.notification-bell-connect-slack-button",
        "defaultMessage": "Connect Slack"
    },
    notificationBellConnectHeader: {
        "id": "third-party-nudge.third-party-nudge-flag.notification-bell-connect-header",
        "defaultMessage": "Connect now"
    }
});

});

parcelRegister("7n2zl", function(module, exports) {

$parcel$export(module.exports, "NudgeFlag", () => $9f594b82402d0390$export$967cf9dd5e24152);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8xkEh = parcelRequire("8xkEh");
const $9f594b82402d0390$export$967cf9dd5e24152 = ({ onDismiss: onDismiss, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9f594b82402d0390$var$FlagWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9f594b82402d0390$var$DismissButton, {
        "data-testid": "third-party-nudge.ui.third-party-nudge-flag.nudge-flag.dismiss-button",
        onClick: onDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8xkEh))), {
        label: "Dismiss icon",
        color: "var(--ds-text-inverse, #FFFFFF)",
        LEGACY_size: "small",
        LEGACY_primaryColor: "var(--ds-text-inverse, white)"
    })), children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f594b82402d0390$var$FlagWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1rpp _16qs1lil _2rko1y44 _kqswh2mm _bfhk1j9a",
            __cmplp.className
        ])
    });
});
const $9f594b82402d0390$var$DismissButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iu2gc _1xi2u2gc _1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1ejb _4t3i1ejb _11q7glyw _syaz1kw7 _19itglyw _1yt4ze3t _11c81kw7 _80omtlke _12ji1r31 _1qu21kw7 _12y31o36",
            __cmplp.className
        ])
    });
});

});

parcelRegister("63JIe", function(module, exports) {

$parcel$export(module.exports, "BothSplash", () => $605d6b323b3e014b$export$149b071b87f1d588);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6HZPP = parcelRequire("6HZPP");
const $605d6b323b3e014b$export$149b071b87f1d588 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($605d6b323b3e014b$var$BothSplashWrapper, {
        "data-testid": "third-party-nudge.ui.third-party-nudge-flag.splashes.both-splash.both-splash-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "412",
        height: "128",
        viewBox: "0 0 412 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H408C410.209 0 412 1.79086 412 4V128H0V4Z",
        fill: "url(#paint0_linear_914_2570)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter0_dd_914_2570)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "47",
        y: "18.0001",
        width: "42",
        height: "42",
        rx: "4",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_914_2570)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M68.42 34.6669C70.582 34.6669 72.3347 32.9692 72.3347 30.8749C72.3347 28.7807 70.582 27.083 68.42 27.083C66.258 27.083 64.5054 28.7807 64.5054 30.8749C64.5054 32.9692 66.258 34.6669 68.42 34.6669Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.1",
        d: "M68.1405 31.6876H64.595L64.6126 31.7632L64.6143 31.7697L64.6327 31.8396C64.8903 32.7859 65.5154 33.5992 66.3774 34.1097C67.2394 34.6203 68.2717 34.7885 69.2587 34.5793V32.7707C69.2578 32.4837 69.1397 32.2087 68.9302 32.0058C68.7207 31.8029 68.4368 31.6885 68.1405 31.6876Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M67.3021 32.5001H64.8831C65.2005 33.1485 65.7015 33.6963 66.3276 34.0799C66.9537 34.4635 67.6794 34.6671 68.4202 34.6671V33.5832C68.4194 33.2962 68.3013 33.0212 68.0918 32.8183C67.8823 32.6154 67.5984 32.501 67.3021 32.5001Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M77.2273 34.9376C78.8487 34.9376 80.1631 33.6644 80.1631 32.0939C80.1631 30.5233 78.8487 29.2501 77.2273 29.2501C75.6059 29.2501 74.2915 30.5233 74.2915 32.0939C74.2915 33.6644 75.6059 34.9376 77.2273 34.9376Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M79.7439 35.7501H73.1501C73.0077 35.7501 72.8712 35.8049 72.7705 35.9024C72.6698 35.9999 72.6133 36.1322 72.6133 36.2701V42.8595C72.5951 43.8132 72.9157 44.7439 73.5215 45.4959C74.1273 46.2479 74.9814 46.7755 75.9408 46.9902C76.5518 47.1144 77.1838 47.1051 77.7906 46.9628C78.3975 46.8206 78.9639 46.5491 79.4487 46.168C79.9336 45.7869 80.3246 45.3059 80.5933 44.76C80.862 44.2141 81.0016 43.617 81.002 43.0122V36.9689C81.002 36.6456 80.8695 36.3356 80.6335 36.1071C80.3976 35.8785 80.0775 35.7501 79.7439 35.7501Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M75.1306 36.9689V44.6876C75.1315 46.1181 74.6448 47.5088 73.7463 48.6439C72.8477 49.7791 71.5874 50.5952 70.1611 50.9656C68.7347 51.336 67.222 51.24 65.8577 50.6925C64.4934 50.145 63.3539 49.1766 62.6159 47.9376C62.4544 47.6778 62.3142 47.4061 62.1965 47.1251C62.0867 46.8602 61.9942 46.5888 61.9197 46.3126C61.7814 45.7813 61.7109 45.2356 61.71 44.6876V36.9689C61.7097 36.8088 61.7421 36.6502 61.8053 36.5022C61.8684 36.3543 61.9611 36.2198 62.078 36.1066C62.1949 35.9934 62.3337 35.9036 62.4864 35.8425C62.6392 35.7813 62.8029 35.7499 62.9682 35.7501H73.8725C74.0377 35.7499 74.2015 35.7813 74.3542 35.8425C74.507 35.9036 74.6457 35.9934 74.7626 36.1066C74.8795 36.2198 74.9722 36.3543 75.0353 36.5022C75.0985 36.6502 75.1309 36.8088 75.1306 36.9689Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M67.3021 32.5001H64.8831C65.2005 33.1485 65.7015 33.6963 66.3276 34.0799C66.9537 34.4635 67.6794 34.6671 68.4202 34.6671V33.5832C68.4194 33.2962 68.3013 33.0212 68.0918 32.8183C67.8823 32.6154 67.5984 32.501 67.3021 32.5001Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.1",
        d: "M69.2591 35.7501V46.0445C69.2591 46.2894 69.1726 46.527 69.0139 46.7177C68.8552 46.9083 68.6339 47.0407 68.3867 47.0926C68.3078 47.1154 68.2258 47.1263 68.1435 47.1251H62.1965C62.0867 46.8602 61.9942 46.5888 61.9197 46.3126C61.7814 45.7813 61.7109 45.2356 61.71 44.6876V36.9689C61.7097 36.8088 61.7421 36.6502 61.8053 36.5022C61.8684 36.3543 61.9611 36.2198 62.078 36.1066C62.1949 35.9934 62.3337 35.9036 62.4864 35.8425C62.6392 35.7813 62.8029 35.7499 62.9682 35.7501H69.2591Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M68.4203 35.7501V46.857C68.4215 46.9367 68.4102 47.0162 68.3867 47.0926C68.3331 47.332 68.1965 47.5463 67.9997 47.7001C67.8028 47.8538 67.5576 47.9376 67.3047 47.9376H62.6159C62.4544 47.6778 62.3142 47.4061 62.1965 47.1251C62.0867 46.8602 61.9942 46.5888 61.9197 46.3126C61.7814 45.7813 61.7109 45.2356 61.71 44.6876V36.9689C61.7097 36.8088 61.7421 36.6502 61.8053 36.5022C61.8684 36.3543 61.9611 36.2198 62.078 36.1066C62.1949 35.9934 62.3337 35.9036 62.4864 35.8425C62.6392 35.7813 62.8029 35.7499 62.9682 35.7501H68.4203Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M68.4203 35.7501V45.232C68.419 45.5182 68.301 45.7923 68.0921 45.9947C67.8832 46.1971 67.6002 46.3113 67.3047 46.3126H61.9197C61.7814 45.7813 61.7109 45.2356 61.71 44.6876V36.9689C61.7097 36.8088 61.7421 36.6502 61.8053 36.5022C61.8684 36.3543 61.9611 36.2198 62.078 36.1066C62.1949 35.9934 62.3337 35.9036 62.4864 35.8425C62.6392 35.7813 62.8029 35.7499 62.9682 35.7501H68.4203Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M62.9682 35.7501C62.8029 35.7499 62.6392 35.7813 62.4864 35.8425C62.3337 35.9036 62.1949 35.9934 62.078 36.1066C61.9611 36.2198 61.8684 36.3543 61.8053 36.5022C61.7421 36.6502 61.7097 36.8088 61.71 36.9689V44.6876C61.7109 45.2356 61.7814 45.7813 61.9197 46.3126H66.4659C66.7614 46.3113 67.0444 46.1971 67.2533 45.9947C67.4622 45.7923 67.5802 45.5182 67.5815 45.232V35.7501H62.9682Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M55.2788 32.5001H66.4632C66.7598 32.5001 67.0442 32.6142 67.2538 32.8173C67.4635 33.0205 67.5813 33.2959 67.5813 33.5832V44.4171C67.5813 44.7043 67.4635 44.9798 67.2538 45.1829C67.0442 45.386 66.7598 45.5001 66.4632 45.5001H55.2788C54.9822 45.5001 54.6978 45.386 54.4881 45.1829C54.2784 44.9798 54.1606 44.7043 54.1606 44.4171V33.5832C54.1606 33.2959 54.2784 33.0205 54.4881 32.8173C54.6978 32.6142 54.9822 32.5001 55.2788 32.5001Z",
        fill: "#4B53BC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M64.2093 36.542H61.7013V43.0583H60.0556V36.542H57.5325V34.9414H64.2093V36.542Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "47",
        y: "68.0001",
        width: "42",
        height: "42",
        rx: "3.18898",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M60.4623 92.4304C60.4623 93.9336 59.2343 95.1616 57.731 95.1616C56.2278 95.1616 54.9998 93.9336 54.9998 92.4304C54.9998 90.9271 56.2278 89.6991 57.731 89.6991H60.4623V92.4304Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M61.8376 92.4305C61.8376 90.9272 63.0657 89.6992 64.5689 89.6992C66.0722 89.6992 67.3002 90.9272 67.3002 92.4305V99.2692C67.3002 100.772 66.0722 102 64.5689 102C63.0657 102 61.8376 100.772 61.8376 99.2692V92.4305Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M64.5689 81.4625C63.0657 81.4625 61.8376 80.2345 61.8376 78.7313C61.8376 77.228 63.0657 76 64.5689 76C66.0722 76 67.3002 77.228 67.3002 78.7313V81.4625H64.5689Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M64.5697 82.8386C66.073 82.8386 67.301 84.0666 67.301 85.5699C67.301 87.0731 66.073 88.3011 64.5697 88.3011H57.731C56.2278 88.3011 54.9998 87.0731 54.9998 85.5699C54.9998 84.0666 56.2278 82.8386 57.731 82.8386H64.5697Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M75.5364 85.5699C75.5364 84.0666 76.7644 82.8386 78.2676 82.8386C79.7709 82.8386 80.9989 84.0666 80.9989 85.5699C80.9989 87.0731 79.7709 88.3011 78.2676 88.3011H75.5364V85.5699Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M74.161 85.57C74.161 87.0732 72.933 88.3013 71.4297 88.3013C69.9265 88.3013 68.6985 87.0732 68.6985 85.57V78.7313C68.6985 77.228 69.9265 76 71.4297 76C72.933 76 74.161 77.228 74.161 78.7313V85.57Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M71.4295 96.538C72.9328 96.538 74.1608 97.766 74.1608 99.2692C74.1608 100.772 72.9328 102 71.4295 102C69.9262 102 68.6982 100.772 68.6982 99.2692V96.538H71.4295Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M71.4297 95.1616C69.9265 95.1616 68.6985 93.9336 68.6985 92.4304C68.6985 90.9271 69.9265 89.6991 71.4297 89.6991H78.2685C79.7717 89.6991 80.9997 90.9271 80.9997 92.4304C80.9997 93.9336 79.7717 95.1616 78.2685 95.1616H71.4297Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M101 28.0001C101 25.791 102.791 24.0001 105 24.0001H361C363.209 24.0001 365 25.791 365 28.0001V100C365 102.209 363.209 104 361 104H105C102.791 104 101 102.209 101 100V28.0001Z",
        fill: "white",
        fillOpacity: "0.98"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#091E42",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "600",
        letterSpacing: "0em"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "113",
        y: "45.1993"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $6HZPP.messages).slackExampleTitle,
        values: {
            tag: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
                    fill: "#0055CC",
                    xmlSpace: "preserve",
                    fontSize: "9",
                    fontWeight: "600",
                    letterSpacing: "0em"
                }, chunks)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "113",
        y: "54.0001",
        width: "210",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "113",
        y: "66.0001",
        width: "91",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "207",
        y: "66.0001",
        width: "91",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "113.3",
        y: "80.3001",
        width: "61.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#B3B9C4",
        strokeWidth: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "123.26",
        y: "91.1993"
    }, formatMessage((0, $6HZPP.messages).integrationExampleCommentButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "181.893",
        y: "80.3001",
        width: "60.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#B3B9C4",
        strokeWidth: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "191.414",
        y: "91.1993"
    }, formatMessage((0, $6HZPP.messages).integrationExampleEditIssueButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_dd_914_2570",
        x: "35",
        y: "6",
        width: "342",
        height: "116",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.56 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_914_2570"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_914_2570",
        result: "effect2_dropShadow_914_2570"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_914_2570",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear_914_2570",
        x1: "408.5",
        y1: "3.50001",
        x2: "0.106745",
        y2: "128.349",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.0974484",
        stopColor: "#042C86"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.920861",
        stopColor: "#0744A2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_914_2570"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "27.3",
        height: "26",
        fill: "white",
        transform: "translate(54 26.0001)"
    })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $605d6b323b3e014b$var$BothSplashWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1qr7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6HZPP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a312ba9e89ec316c$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a312ba9e89ec316c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    teamsExampleTitle: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.teams-example-title",
        "defaultMessage": "Mike commented on an issue"
    },
    slackExampleIntegrationName: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.slack-example-integration-name",
        "defaultMessage": "Jira Cloud"
    },
    slackExampleTitle: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.slack-example-title",
        "defaultMessage": "<tag>@mike</tag> assigned an issue to you"
    },
    bothExampleTitle: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.both-example-title",
        "defaultMessage": "<tag>@mike</tag> mentioned you in a comment"
    },
    integrationExampleCommentButton: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.integration-example-comment-button",
        "defaultMessage": "Comment"
    },
    integrationExampleEditIssueButton: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.integration-example-edit-issue-button",
        "defaultMessage": "Edit issue"
    },
    integrationExampleOpenInJiraButton: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.integration-example-open-in-jira-button",
        "defaultMessage": "Open in Jira"
    }
});

});


parcelRegister("dmJS7", function(module, exports) {

$parcel$export(module.exports, "NotificationBellBothSplash", () => $e79184ced17aa7c8$export$647bdb139f429977);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $9pweC = parcelRequire("9pweC");
const $e79184ced17aa7c8$export$647bdb139f429977 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "third-party-nudge.ui.third-party-nudge-flag.splashes.notification-bell-splashes.both-splash",
        className: (0, $7JEyt.default)([
            "_4t3i1qr7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "412",
        height: "128",
        viewBox: "0 0 412 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H408C410.209 0 412 1.79086 412 4V128H0V4Z",
        fill: "url(#paint0_linear_2726_7335)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter0_dd_2726_7335)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "47",
        y: "18.0001",
        width: "42",
        height: "42",
        rx: "4",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        "clip-path": "url(#clip0_2726_7335)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M68.42 34.6669C70.582 34.6669 72.3346 32.9692 72.3346 30.875C72.3346 28.7807 70.582 27.083 68.42 27.083C66.258 27.083 64.5053 28.7807 64.5053 30.875C64.5053 32.9692 66.258 34.6669 68.42 34.6669Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.1",
        d: "M68.1404 31.6876H64.5948L64.6125 31.7632L64.6141 31.7697L64.6326 31.8396C64.8902 32.7859 65.5153 33.5992 66.3773 34.1098C67.2393 34.6203 68.2715 34.7885 69.2585 34.5793V32.7707C69.2577 32.4837 69.1396 32.2087 68.9301 32.0058C68.7206 31.8029 68.4367 31.6885 68.1404 31.6876Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M67.3021 32.5001H64.883C65.2005 33.1485 65.7014 33.6963 66.3275 34.0799C66.9537 34.4635 67.6793 34.6671 68.4202 34.6671V33.5832C68.4193 33.2962 68.3012 33.0212 68.0917 32.8183C67.8822 32.6154 67.5983 32.501 67.3021 32.5001Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M77.2273 34.9376C78.8487 34.9376 80.1631 33.6644 80.1631 32.0939C80.1631 30.5233 78.8487 29.2501 77.2273 29.2501C75.6059 29.2501 74.2915 30.5233 74.2915 32.0939C74.2915 33.6644 75.6059 34.9376 77.2273 34.9376Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M79.7439 35.7501H73.1501C73.0077 35.7501 72.8712 35.8049 72.7705 35.9024C72.6698 36 72.6133 36.1322 72.6133 36.2701V42.8595C72.5951 43.8132 72.9157 44.7439 73.5215 45.4959C74.1273 46.2479 74.9814 46.7755 75.9408 46.9903C76.5518 47.1145 77.1838 47.1051 77.7906 46.9629C78.3975 46.8206 78.9639 46.5491 79.4487 46.168C79.9336 45.787 80.3246 45.306 80.5933 44.76C80.862 44.2141 81.0016 43.617 81.002 43.0123V36.9689C81.002 36.6457 80.8695 36.3357 80.6335 36.1071C80.3976 35.8785 80.0775 35.7501 79.7439 35.7501Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M75.1305 36.9689V44.6876C75.1313 46.1181 74.6447 47.5088 73.7461 48.6439C72.8476 49.7791 71.5873 50.5952 70.1609 50.9656C68.7346 51.336 67.2219 51.24 65.8576 50.6925C64.4933 50.145 63.3537 49.1766 62.6157 47.9376C62.4543 47.6778 62.3141 47.4061 62.1963 47.1251C62.0866 46.8602 61.9941 46.5888 61.9195 46.3126C61.7813 45.7813 61.7108 45.2356 61.7098 44.6876V36.9689C61.7096 36.8088 61.742 36.6502 61.8052 36.5022C61.8683 36.3543 61.961 36.2198 62.0779 36.1066C62.1947 35.9934 62.3335 35.9036 62.4863 35.8425C62.639 35.7813 62.8027 35.7499 62.968 35.7501H73.8723C74.0376 35.7499 74.2013 35.7813 74.3541 35.8425C74.5068 35.9036 74.6456 35.9934 74.7625 36.1066C74.8794 36.2198 74.972 36.3543 75.0352 36.5022C75.0983 36.6502 75.1307 36.8088 75.1305 36.9689Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M67.3021 32.5001H64.883C65.2005 33.1485 65.7014 33.6963 66.3275 34.0799C66.9537 34.4635 67.6793 34.6671 68.4202 34.6671V33.5832C68.4193 33.2962 68.3012 33.0212 68.0917 32.8183C67.8822 32.6154 67.5983 32.501 67.3021 32.5001Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.1",
        d: "M69.259 35.7501V46.0445C69.259 46.2894 69.1724 46.527 69.0137 46.7177C68.855 46.9084 68.6337 47.0407 68.3866 47.0926C68.3077 47.1154 68.2257 47.1263 68.1434 47.1251H62.1963C62.0866 46.8602 61.9941 46.5888 61.9195 46.3126C61.7813 45.7813 61.7108 45.2356 61.7098 44.6876V36.9689C61.7096 36.8088 61.742 36.6502 61.8052 36.5022C61.8683 36.3543 61.961 36.2198 62.0779 36.1066C62.1947 35.9934 62.3335 35.9036 62.4863 35.8425C62.639 35.7813 62.8027 35.7499 62.968 35.7501H69.259Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M68.4202 35.7501V46.857C68.4214 46.9367 68.4101 47.0162 68.3866 47.0926C68.333 47.332 68.1964 47.5464 67.9995 47.7001C67.8027 47.8538 67.5574 47.9376 67.3046 47.9376H62.6157C62.4543 47.6778 62.3141 47.4061 62.1963 47.1251C62.0866 46.8602 61.9941 46.5888 61.9195 46.3126C61.7813 45.7813 61.7108 45.2356 61.7098 44.6876V36.9689C61.7096 36.8088 61.742 36.6502 61.8052 36.5022C61.8683 36.3543 61.961 36.2198 62.0779 36.1066C62.1947 35.9934 62.3335 35.9036 62.4863 35.8425C62.639 35.7813 62.8027 35.7499 62.968 35.7501H68.4202Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M68.4202 35.7501V45.232C68.4189 45.5182 68.3009 45.7923 68.092 45.9947C67.883 46.1971 67.6001 46.3114 67.3046 46.3126H61.9195C61.7813 45.7813 61.7108 45.2356 61.7098 44.6876V36.9689C61.7096 36.8088 61.742 36.6502 61.8052 36.5022C61.8683 36.3543 61.961 36.2198 62.0779 36.1066C62.1947 35.9934 62.3335 35.9036 62.4863 35.8425C62.639 35.7813 62.8027 35.7499 62.968 35.7501H68.4202Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M62.968 35.7501C62.8027 35.7499 62.639 35.7813 62.4863 35.8425C62.3335 35.9036 62.1947 35.9934 62.0779 36.1066C61.961 36.2198 61.8683 36.3543 61.8052 36.5022C61.742 36.6502 61.7096 36.8088 61.7098 36.9689V44.6876C61.7108 45.2356 61.7813 45.7813 61.9195 46.3126H66.4658C66.7613 46.3114 67.0442 46.1971 67.2532 45.9947C67.4621 45.7923 67.5801 45.5182 67.5814 45.232V35.7501H62.968Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M55.2787 32.5001H66.4632C66.7597 32.5001 67.0441 32.6142 67.2538 32.8174C67.4635 33.0205 67.5813 33.296 67.5813 33.5832V44.4171C67.5813 44.7043 67.4635 44.9798 67.2538 45.1829C67.0441 45.386 66.7597 45.5001 66.4632 45.5001H55.2787C54.9822 45.5001 54.6978 45.386 54.4881 45.1829C54.2784 44.9798 54.1606 44.7043 54.1606 44.4171V33.5832C54.1606 33.296 54.2784 33.0205 54.4881 32.8174C54.6978 32.6142 54.9822 32.5001 55.2787 32.5001Z",
        fill: "#4B53BC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M64.2092 36.5421H61.7012V43.0583H60.0555V36.5421H57.5324V34.9414H64.2092V36.5421Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "47",
        y: "68.0001",
        width: "42",
        height: "42",
        rx: "3.18898",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M60.4623 92.4303C60.4623 93.9336 59.2343 95.1616 57.7311 95.1616C56.2278 95.1616 54.9998 93.9336 54.9998 92.4303C54.9998 90.9271 56.2278 89.6991 57.7311 89.6991H60.4623V92.4303Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M61.8377 92.4304C61.8377 90.9271 63.0657 89.6991 64.569 89.6991C66.0722 89.6991 67.3002 90.9271 67.3002 92.4304V99.2691C67.3002 100.772 66.0722 102 64.569 102C63.0657 102 61.8377 100.772 61.8377 99.2691V92.4304Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M64.569 81.4625C63.0658 81.4625 61.8378 80.2345 61.8378 78.7312C61.8378 77.228 63.0658 76 64.569 76C66.0723 76 67.3003 77.228 67.3003 78.7312V81.4625H64.569Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M64.5698 82.8386C66.0731 82.8386 67.3011 84.0666 67.3011 85.5699C67.3011 87.0731 66.0731 88.3011 64.5698 88.3011H57.7311C56.2278 88.3011 54.9998 87.0731 54.9998 85.5699C54.9998 84.0666 56.2278 82.8386 57.7311 82.8386H64.5698Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M75.5365 85.5698C75.5365 84.0666 76.7645 82.8386 78.2678 82.8386C79.771 82.8386 80.999 84.0666 80.999 85.5698C80.999 87.0731 79.771 88.3011 78.2678 88.3011H75.5365V85.5698Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M74.1611 85.57C74.1611 87.0732 72.9331 88.3012 71.4299 88.3012C69.9266 88.3012 68.6986 87.0732 68.6986 85.57V78.7312C68.6986 77.228 69.9266 76 71.4299 76C72.9331 76 74.1611 77.228 74.1611 78.7312V85.57Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M71.4297 96.538C72.933 96.538 74.161 97.766 74.161 99.2692C74.161 100.772 72.933 102 71.4297 102C69.9265 102 68.6985 100.772 68.6985 99.2692V96.538H71.4297Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M71.4299 95.1616C69.9266 95.1616 68.6986 93.9336 68.6986 92.4303C68.6986 90.9271 69.9266 89.6991 71.4299 89.6991H78.2686C79.7719 89.6991 80.9999 90.9271 80.9999 92.4303C80.9999 93.9336 79.7719 95.1616 78.2686 95.1616H71.4299Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M101 28.0001C101 25.791 102.791 24.0001 105 24.0001H361C363.209 24.0001 365 25.791 365 28.0001V100C365 102.209 363.209 104 361 104H105C102.791 104 101 102.209 101 100V28.0001Z",
        fill: "white",
        "fill-opacity": "0.98"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#091E42",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "600",
        letterSpacing: "0em"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "113",
        y: "45.1993"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $9pweC.messages).bothNudgeTitle,
        values: {
            tag: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
                    fill: "#0055CC",
                    xmlSpace: "preserve",
                    fontSize: "9",
                    fontWeight: "600",
                    letterSpacing: "0em"
                }, chunks)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "113",
        y: "54.0001",
        width: "210",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "113",
        y: "66.0001",
        width: "91",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "207",
        y: "66.0001",
        width: "91",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "113.3",
        y: "80.3001",
        width: "61.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#B3B9C4",
        "stroke-width": "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        "white-space": "pre",
        "font-size": "9",
        "letter-spacing": "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "123.26",
        y: "91.1994"
    }, formatMessage((0, $9pweC.messages).nudgeCommentButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "181.892",
        y: "80.3001",
        width: "60.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#B3B9C4",
        "stroke-width": "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        "white-space": "pre",
        "font-size": "9",
        "letter-spacing": "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "191.414",
        y: "91.1994"
    }, formatMessage((0, $9pweC.messages).nudgeEditIssueButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "249.485",
        y: "80.3001",
        width: "70.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#B3B9C4",
        "stroke-width": "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        "white-space": "pre",
        "font-size": "9",
        "letter-spacing": "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "259.007",
        y: "91.1994"
    }, formatMessage((0, $9pweC.messages).nudgeOpenInJiraButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_dd_2726_7335",
        x: "39",
        y: "10",
        width: "334",
        height: "108",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.16 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2726_7335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.12 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_2726_7335",
        result: "effect2_dropShadow_2726_7335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_2726_7335",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear_2726_7335",
        x1: "408.5",
        y1: "3.50001",
        x2: "0.106745",
        y2: "128.349",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.0974484",
        "stop-color": "#B4E3FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.920861",
        "stop-color": "#F6F7FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_2726_7335"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "27.3",
        height: "26",
        fill: "white",
        transform: "translate(54 26.0001)"
    })))));
};
const $e79184ced17aa7c8$var$BothSplashStyles = null;

});
parcelRegister("9pweC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5c98e718625a87fa$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $5c98e718625a87fa$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    slackIntegrationName: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.notification-bell-splashes.slack-integration-name",
        "defaultMessage": "Jira Cloud"
    },
    teamsNudgeTitle: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.notification-bell-splashes.teams-nudge-title",
        "defaultMessage": "Mike commented on an issue"
    },
    slackNudgeTitle: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.notification-bell-splashes.slack-nudge-title",
        "defaultMessage": "<tag>@mike</tag> assigned an issue to you"
    },
    bothNudgeTitle: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.notification-bell-splashes.both-nudge-title",
        "defaultMessage": "<tag>@mike</tag> mentioned you in a comment"
    },
    nudgeCommentButton: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.notification-bell-splashes.nudge-comment-button",
        "defaultMessage": "Comment"
    },
    nudgeEditIssueButton: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.notification-bell-splashes.nudge-edit-issue-button",
        "defaultMessage": "Edit issue"
    },
    nudgeOpenInJiraButton: {
        "id": "third-party-nudge.third-party-nudge-flag.splashes.notification-bell-splashes.nudge-open-in-jira-button",
        "defaultMessage": "Open in Jira"
    }
});

});


parcelRegister("eLu8C", function(module, exports) {

$parcel$export(module.exports, "NotificationBellSlackSplash", () => $4079ecffe7e239a1$export$b815853e36ed5a84);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $9pweC = parcelRequire("9pweC");
const $4079ecffe7e239a1$export$b815853e36ed5a84 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "third-party-nudge.ui.third-party-nudge-flag.splashes.notification-bell-splashes.slack-splash",
        className: (0, $7JEyt.default)([
            "_4t3i1qr7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "412",
        height: "128",
        viewBox: "0 0 412 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H408C410.209 0 412 1.79086 412 4V128H0V4Z",
        fill: "url(#paint0_linear_2726_7334)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter0_dd_2726_7334)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M99 22.47C99 21.1059 100.106 20 101.47 20H364.53C365.894 20 367 21.1059 367 22.47V105C367 107.209 365.209 109 363 109H103C100.791 109 99 107.209 99 105V22.47Z",
        fill: "white",
        "fill-opacity": "0.98"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(111 28)",
        fill: "white",
        "fill-opacity": "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M131.846 30.25H122.543C122.543 32.4958 124.425 34.3238 126.737 34.3238H128.458V35.9168C128.458 38.1626 130.34 39.9906 132.652 39.9906V31.0334C132.652 30.5895 132.303 30.25 131.846 30.25Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M127.248 34.7416H117.945C117.945 36.9874 119.827 38.8154 122.14 38.8154H123.86V40.4345C123.86 42.6803 125.742 44.5083 128.055 44.5083V35.525C128.055 35.1072 127.705 34.7416 127.248 34.7416Z",
        fill: "url(#paint1_linear_2726_7334)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M122.651 39.2594H113.348C113.348 41.5052 115.23 43.3332 117.542 43.3332H119.263V44.9262C119.263 47.172 121.145 49 123.457 49V40.0428C123.457 39.5989 123.081 39.2594 122.651 39.2594Z",
        fill: "url(#paint2_linear_2726_7334)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#091E42",
        xmlSpace: "preserve",
        "white-space": "pre",
        "font-size": "8",
        "font-weight": "bold",
        "letter-spacing": "0em"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "138",
        y: "35.8438"
    }, formatMessage((0, $9pweC.messages).slackIntegrationName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#091E42",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "600",
        letterSpacing: "0em"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "138",
        y: "51.87"
    }, "\uD83D\uDD14")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#091E42",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "600",
        letterSpacing: "0em"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "150",
        y: "50.6992"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $9pweC.messages).slackNudgeTitle,
        values: {
            tag: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
                    fill: "#0055CC",
                    xmlSpace: "preserve",
                    fontSize: "9",
                    fontWeight: "600",
                    letterSpacing: "0em"
                }, chunks)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M142 75C142 76.1046 141.105 77 140 77C138.895 77 138 76.1046 138 75L138 60C138 58.8954 138.895 58 140 58C141.105 58 142 58.8954 142 60L142 75Z",
        fill: "#2F78FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "150",
        y: "58.4999",
        width: "181",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "150",
        y: "70.5002",
        width: "72",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "70.5002",
        width: "72",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "137.3",
        y: "85.3",
        width: "61.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#B3B9C4",
        "stroke-width": "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        "white-space": "pre",
        "font-size": "9",
        "letter-spacing": "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "147.26",
        y: "96.1992"
    }, formatMessage((0, $9pweC.messages).nudgeCommentButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "205.892",
        y: "85.3",
        width: "60.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#B3B9C4",
        "stroke-width": "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        "white-space": "pre",
        "font-size": "9",
        "letter-spacing": "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "215.414",
        y: "96.1992"
    }, formatMessage((0, $9pweC.messages).nudgeEditIssueButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "273.485",
        y: "85.3",
        width: "70.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#B3B9C4",
        "stroke-width": "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        "white-space": "pre",
        "font-size": "9",
        "letter-spacing": "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "282.992",
        y: "96.1992"
    }, formatMessage((0, $9pweC.messages).nudgeOpenInJiraButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "45",
        y: "20",
        width: "42",
        height: "42",
        rx: "4",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M58.4623 44.4302C58.4623 45.9334 57.2343 47.1614 55.7311 47.1614C54.2278 47.1614 52.9998 45.9334 52.9998 44.4302C52.9998 42.9269 54.2278 41.6989 55.7311 41.6989H58.4623V44.4302Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M59.8377 44.4303C59.8377 42.927 61.0657 41.699 62.569 41.699C64.0722 41.699 65.3002 42.927 65.3002 44.4303V51.269C65.3002 52.7722 64.0722 54.0002 62.569 54.0002C61.0657 54.0002 59.8377 52.7722 59.8377 51.269V44.4303Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M62.569 33.4624C61.0658 33.4624 59.8378 32.2344 59.8378 30.7311C59.8378 29.2279 61.0658 27.9999 62.569 27.9999C64.0723 27.9999 65.3003 29.2279 65.3003 30.7311V33.4624H62.569Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M62.5698 34.8385C64.0731 34.8385 65.3011 36.0665 65.3011 37.5697C65.3011 39.073 64.0731 40.301 62.5698 40.301H55.7311C54.2278 40.301 52.9998 39.073 52.9998 37.5697C52.9998 36.0665 54.2278 34.8385 55.7311 34.8385H62.5698Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M73.5365 37.5697C73.5365 36.0664 74.7645 34.8384 76.2678 34.8384C77.771 34.8384 78.999 36.0664 78.999 37.5697C78.999 39.0729 77.771 40.3009 76.2678 40.3009H73.5365V37.5697Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M72.1611 37.5698C72.1611 39.0731 70.9331 40.3011 69.4299 40.3011C67.9266 40.3011 66.6986 39.0731 66.6986 37.5698V30.7311C66.6986 29.2279 67.9266 27.9999 69.4299 27.9999C70.9331 27.9999 72.1611 29.2279 72.1611 30.7311V37.5698Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M69.4297 48.5378C70.933 48.5378 72.161 49.7658 72.161 51.2691C72.161 52.7723 70.933 54.0003 69.4297 54.0003C67.9265 54.0003 66.6985 52.7723 66.6985 51.2691V48.5378H69.4297Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M69.4299 47.1614C67.9266 47.1614 66.6986 45.9334 66.6986 44.4302C66.6986 42.9269 67.9266 41.6989 69.4299 41.6989H76.2686C77.7719 41.6989 78.9999 42.9269 78.9999 44.4302C78.9999 45.9334 77.7719 47.1614 76.2686 47.1614H69.4299Z",
        fill: "#ECB22E"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_dd_2726_7334",
        x: "37",
        y: "12",
        width: "338",
        height: "105",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.16 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2726_7334"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.12 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_2726_7334",
        result: "effect2_dropShadow_2726_7334"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_2726_7334",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear_2726_7334",
        x1: "408.5",
        y1: "3.50001",
        x2: "0.106745",
        y2: "128.349",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.0974484",
        "stop-color": "#B4E3FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.920861",
        "stop-color": "#F6F7FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint1_linear_2726_7334",
        x1: "127.857",
        y1: "34.7642",
        x2: "124.02",
        y2: "38.8376",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.176",
        "stop-color": "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        "stop-color": "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint2_linear_2726_7334",
        x1: "123.518",
        y1: "39.2894",
        x2: "119.074",
        y2: "43.7406",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.176",
        "stop-color": "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        "stop-color": "#2684FF"
    })))));
};
const $4079ecffe7e239a1$var$SlackSplashStyles = null;

});

parcelRegister("5JM1u", function(module, exports) {

$parcel$export(module.exports, "NotificationBellTeamsSplash", () => $9f46861b31af8160$export$a3eacc2159f7bab8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9pweC = parcelRequire("9pweC");
const $9f46861b31af8160$export$a3eacc2159f7bab8 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "third-party-nudge.ui.third-party-nudge-flag.splashes.notification-bell-splashes.teams-splash",
        className: (0, $7JEyt.default)([
            "_4t3i1qr7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "412",
        height: "128",
        viewBox: "0 0 412 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H408C410.209 0 412 1.79086 412 4V128H0V4Z",
        fill: "url(#paint0_linear_2726_7333)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter0_dd_2726_7333)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.98"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M112 26.4701C112 25.106 113.106 24.0001 114.47 24.0001H357.53C358.894 24.0001 360 25.106 360 26.4701V100C360 102.209 358.209 104 356 104H116C113.791 104 112 102.209 112 100V26.4701Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#091E42",
        xmlSpace: "preserve",
        "white-space": "pre",
        "font-size": "9",
        "letter-spacing": "0em"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "124",
        y: "45.1994"
    }, formatMessage((0, $9pweC.messages).teamsNudgeTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "124",
        y: "54",
        width: "210",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "124",
        y: "66",
        width: "91",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "218",
        y: "66",
        width: "91",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "124.3",
        y: "80.3001",
        width: "61.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#DFD8FD",
        "stroke-width": "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#5E4DB2",
        xmlSpace: "preserve",
        "white-space": "pre",
        "font-size": "9",
        "letter-spacing": "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "134.26",
        y: "91.1994"
    }, formatMessage((0, $9pweC.messages).nudgeCommentButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "192.892",
        y: "80.3001",
        width: "60.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#DFD8FD",
        "stroke-width": "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#5E4DB2",
        xmlSpace: "preserve",
        "white-space": "pre",
        "font-size": "9",
        "letter-spacing": "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "202.414",
        y: "91.1994"
    }, formatMessage((0, $9pweC.messages).nudgeEditIssueButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "260.485",
        y: "80.3001",
        width: "70.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#DFD8FD",
        "stroke-width": "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#5E4DB2",
        xmlSpace: "preserve",
        "white-space": "pre",
        "font-size": "9",
        "letter-spacing": "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "269.992",
        y: "91.1994"
    }, formatMessage((0, $9pweC.messages).nudgeOpenInJiraButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "58",
        y: "28",
        width: "42",
        height: "42",
        rx: "4",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        "clip-path": "url(#clip0_2726_7333)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M79.42 44.6668C81.582 44.6668 83.3346 42.9691 83.3346 40.8749C83.3346 38.7806 81.582 37.0829 79.42 37.0829C77.258 37.0829 75.5053 38.7806 75.5053 40.8749C75.5053 42.9691 77.258 44.6668 79.42 44.6668Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.1",
        d: "M79.1404 41.6875H75.5948L75.6125 41.7631L75.6141 41.7696L75.6326 41.8395C75.8902 42.7858 76.5153 43.5991 77.3773 44.1096C78.2393 44.6202 79.2715 44.7884 80.2585 44.5792V42.7706C80.2577 42.4836 80.1396 42.2086 79.9301 42.0057C79.7206 41.8028 79.4367 41.6884 79.1404 41.6875Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M78.3021 42.5H75.883C76.2005 43.1484 76.7014 43.6962 77.3275 44.0798C77.9537 44.4634 78.6793 44.667 79.4202 44.667V43.5831C79.4193 43.2961 79.3012 43.0211 79.0917 42.8182C78.8822 42.6153 78.5983 42.5009 78.3021 42.5Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.2273 44.9375C89.8487 44.9375 91.1631 43.6643 91.1631 42.0938C91.1631 40.5232 89.8487 39.25 88.2273 39.25C86.6059 39.25 85.2915 40.5232 85.2915 42.0938C85.2915 43.6643 86.6059 44.9375 88.2273 44.9375Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M90.7439 45.75H84.1501C84.0077 45.75 83.8712 45.8048 83.7705 45.9023C83.6698 45.9998 83.6133 46.1321 83.6133 46.27V52.8594C83.5951 53.8131 83.9157 54.7438 84.5215 55.4958C85.1273 56.2478 85.9814 56.7754 86.9408 56.9901C87.5518 57.1143 88.1838 57.105 88.7906 56.9627C89.3975 56.8205 89.9639 56.549 90.4487 56.1679C90.9336 55.7868 91.3246 55.3058 91.5933 54.7599C91.862 54.214 92.0016 53.6169 92.002 53.0121V46.9688C92.002 46.6455 91.8695 46.3355 91.6335 46.107C91.3976 45.8784 91.0775 45.75 90.7439 45.75Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M86.1305 46.9688V54.6875C86.1313 56.118 85.6447 57.5087 84.7461 58.6438C83.8476 59.779 82.5873 60.5951 81.1609 60.9655C79.7346 61.3359 78.2219 61.2399 76.8576 60.6924C75.4933 60.1449 74.3537 59.1765 73.6157 57.9375C73.4543 57.6777 73.3141 57.406 73.1963 57.125C73.0866 56.8601 72.9941 56.5887 72.9195 56.3125C72.7813 55.7812 72.7108 55.2355 72.7098 54.6875V46.9688C72.7096 46.8087 72.742 46.6501 72.8052 46.5021C72.8683 46.3542 72.961 46.2197 73.0779 46.1065C73.1947 45.9933 73.3335 45.9035 73.4863 45.8424C73.639 45.7812 73.8027 45.7498 73.968 45.75H84.8723C85.0376 45.7498 85.2013 45.7812 85.3541 45.8424C85.5068 45.9035 85.6456 45.9933 85.7625 46.1065C85.8794 46.2197 85.972 46.3542 86.0352 46.5021C86.0983 46.6501 86.1307 46.8087 86.1305 46.9688Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M78.3021 42.5H75.883C76.2005 43.1484 76.7014 43.6962 77.3275 44.0798C77.9537 44.4634 78.6793 44.667 79.4202 44.667V43.5831C79.4193 43.2961 79.3012 43.0211 79.0917 42.8182C78.8822 42.6153 78.5983 42.5009 78.3021 42.5Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.1",
        d: "M80.259 45.75V56.0444C80.259 56.2893 80.1724 56.5269 80.0137 56.7176C79.855 56.9082 79.6337 57.0406 79.3866 57.0925C79.3077 57.1153 79.2257 57.1262 79.1434 57.125H73.1963C73.0866 56.8601 72.9941 56.5887 72.9195 56.3125C72.7813 55.7812 72.7108 55.2355 72.7098 54.6875V46.9688C72.7096 46.8087 72.742 46.6501 72.8052 46.5021C72.8683 46.3542 72.961 46.2197 73.0779 46.1065C73.1947 45.9933 73.3335 45.9035 73.4863 45.8424C73.639 45.7812 73.8027 45.7498 73.968 45.75H80.259Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M79.4202 45.75V56.8569C79.4214 56.9366 79.4101 57.0161 79.3866 57.0925C79.333 57.3319 79.1964 57.5462 78.9995 57.7C78.8027 57.8537 78.5574 57.9375 78.3046 57.9375H73.6157C73.4543 57.6777 73.3141 57.406 73.1963 57.125C73.0866 56.8601 72.9941 56.5887 72.9195 56.3125C72.7813 55.7812 72.7108 55.2355 72.7098 54.6875V46.9688C72.7096 46.8087 72.742 46.6501 72.8052 46.5021C72.8683 46.3542 72.961 46.2197 73.0779 46.1065C73.1947 45.9933 73.3335 45.9035 73.4863 45.8424C73.639 45.7812 73.8027 45.7498 73.968 45.75H79.4202Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M79.4202 45.75V55.2319C79.4189 55.5181 79.3009 55.7922 79.092 55.9946C78.883 56.197 78.6001 56.3112 78.3046 56.3125H72.9195C72.7813 55.7812 72.7108 55.2355 72.7098 54.6875V46.9688C72.7096 46.8087 72.742 46.6501 72.8052 46.5021C72.8683 46.3542 72.961 46.2197 73.0779 46.1065C73.1947 45.9933 73.3335 45.9035 73.4863 45.8424C73.639 45.7812 73.8027 45.7498 73.968 45.75H79.4202Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M73.968 45.75C73.8027 45.7498 73.639 45.7812 73.4863 45.8424C73.3335 45.9035 73.1947 45.9933 73.0779 46.1065C72.961 46.2197 72.8683 46.3542 72.8052 46.5021C72.742 46.6501 72.7096 46.8087 72.7098 46.9688V54.6875C72.7108 55.2355 72.7813 55.7812 72.9195 56.3125H77.4658C77.7613 56.3112 78.0442 56.197 78.2532 55.9946C78.4621 55.7922 78.5801 55.5181 78.5814 55.2319V45.75H73.968Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M66.2787 42.5H77.4632C77.7597 42.5 78.0441 42.6141 78.2538 42.8172C78.4635 43.0204 78.5813 43.2958 78.5813 43.5831V54.417C78.5813 54.7042 78.4635 54.9797 78.2538 55.1828C78.0441 55.3859 77.7597 55.5 77.4632 55.5H66.2787C65.9822 55.5 65.6978 55.3859 65.4881 55.1828C65.2784 54.9797 65.1606 54.7042 65.1606 54.417V43.5831C65.1606 43.2958 65.2784 43.0204 65.4881 42.8172C65.6978 42.6141 65.9822 42.5 66.2787 42.5Z",
        fill: "#4B53BC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M75.2092 46.5419H72.7012V53.0582H71.0555V46.5419H68.5324V44.9413H75.2092V46.5419Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M357.527 24C358.893 24 360 25.1073 360 26.4731L360 28L112 28L112 26.4731C112 25.1073 113.107 24 114.473 24L357.527 24Z",
        fill: "#505AC6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_dd_2726_7333",
        x: "50",
        y: "16",
        width: "318",
        height: "96.0001",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        "flood-opacity": "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.16 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2726_7333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.12 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_2726_7333",
        result: "effect2_dropShadow_2726_7333"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_2726_7333",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear_2726_7333",
        x1: "408.5",
        y1: "3.50001",
        x2: "0.106745",
        y2: "128.349",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.0974484",
        "stop-color": "#C6E8FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.920861",
        "stop-color": "#F6F7FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_2726_7333"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "65",
        y: "36",
        width: "27.3",
        height: "26",
        fill: "white"
    })))));
};
const $9f46861b31af8160$var$TeamsSplashStyles = null;

});

parcelRegister("dYiWN", function(module, exports) {

$parcel$export(module.exports, "SlackSplash", () => $53d53f52e8f9e8a6$export$82a1eb5d90727e6c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6HZPP = parcelRequire("6HZPP");
const $53d53f52e8f9e8a6$export$82a1eb5d90727e6c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($53d53f52e8f9e8a6$var$SlackSplashWrapper, {
        "data-testid": "third-party-nudge.ui.third-party-nudge-flag.splashes.slack-splash.slack-splash-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "412",
        height: "128",
        viewBox: "0 0 412 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H408C410.209 0 412 1.79086 412 4V128H0V4Z",
        fill: "url(#paint0_linear_914_2569)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter0_dd_914_2569)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M99 22.47C99 21.1059 100.106 20 101.47 20H364.53C365.894 20 367 21.1059 367 22.47V105C367 107.209 365.209 109 363 109H103C100.791 109 99 107.209 99 105V22.47Z",
        fill: "white",
        fillOpacity: "0.98"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(111 28)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M131.846 30.25H122.543C122.543 32.4958 124.425 34.3238 126.737 34.3238H128.458V35.9168C128.458 38.1626 130.34 39.9906 132.652 39.9906V31.0334C132.652 30.5895 132.303 30.25 131.846 30.25Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M127.248 34.7416H117.945C117.945 36.9875 119.827 38.8155 122.14 38.8155H123.86V40.4345C123.86 42.6804 125.742 44.5084 128.055 44.5084V35.5251C128.055 35.1072 127.705 34.7416 127.248 34.7416Z",
        fill: "url(#paint1_linear_914_2569)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M122.65 39.2594H113.348C113.348 41.5052 115.23 43.3332 117.542 43.3332H119.263V44.9262C119.263 47.172 121.145 49 123.457 49V40.0428C123.457 39.5989 123.081 39.2594 122.65 39.2594Z",
        fill: "url(#paint2_linear_914_2569)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#091E42",
        xmlSpace: "preserve",
        fontSize: "8",
        fontWeight: "bold",
        letterSpacing: "0em"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "138",
        y: "35.8438"
    }, formatMessage((0, $6HZPP.messages).slackExampleIntegrationName))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#091E42",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "600",
        letterSpacing: "0em"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "138",
        y: "51.87"
    }, "\uD83D\uDD14")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#091E42",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "600",
        letterSpacing: "0em"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "150",
        y: "50.6992"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $6HZPP.messages).slackExampleTitle,
        values: {
            tag: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
                    fill: "#0055CC",
                    xmlSpace: "preserve",
                    fontSize: "9",
                    fontWeight: "600",
                    letterSpacing: "0em"
                }, chunks)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M142 75C142 76.1046 141.105 77 140 77C138.895 77 138 76.1046 138 75L138 60C138 58.8954 138.895 58 140 58C141.105 58 142 58.8954 142 60L142 75Z",
        fill: "#2F78FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "150",
        y: "58.4999",
        width: "181",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "150",
        y: "70.5002",
        width: "72",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "70.5002",
        width: "72",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "137.3",
        y: "85.3",
        width: "61.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#B3B9C4",
        strokeWidth: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "147.26",
        y: "96.1992"
    }, formatMessage((0, $6HZPP.messages).integrationExampleCommentButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "205.893",
        y: "85.3",
        width: "60.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#B3B9C4",
        strokeWidth: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "215.414",
        y: "96.1992"
    }, formatMessage((0, $6HZPP.messages).integrationExampleEditIssueButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "273.485",
        y: "85.3",
        width: "70.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#B3B9C4",
        strokeWidth: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "282.992",
        y: "96.1992"
    }, formatMessage((0, $6HZPP.messages).integrationExampleOpenInJiraButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "45",
        y: "20",
        width: "42",
        height: "42",
        rx: "4",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M58.4623 44.4302C58.4623 45.9334 57.2343 47.1614 55.731 47.1614C54.2278 47.1614 52.9998 45.9334 52.9998 44.4302C52.9998 42.9269 54.2278 41.6989 55.731 41.6989H58.4623V44.4302Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M59.8376 44.4302C59.8376 42.927 61.0657 41.699 62.5689 41.699C64.0722 41.699 65.3002 42.927 65.3002 44.4302V51.269C65.3002 52.7722 64.0722 54.0002 62.5689 54.0002C61.0657 54.0002 59.8376 52.7722 59.8376 51.269V44.4302Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M62.5689 33.4624C61.0657 33.4624 59.8376 32.2344 59.8376 30.7311C59.8376 29.2279 61.0657 27.9999 62.5689 27.9999C64.0722 27.9999 65.3002 29.2279 65.3002 30.7311V33.4624H62.5689Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M62.5697 34.8384C64.073 34.8384 65.301 36.0664 65.301 37.5697C65.301 39.0729 64.073 40.301 62.5697 40.301H55.731C54.2278 40.301 52.9998 39.0729 52.9998 37.5697C52.9998 36.0664 54.2278 34.8384 55.731 34.8384H62.5697Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M73.5364 37.5697C73.5364 36.0664 74.7644 34.8384 76.2676 34.8384C77.7709 34.8384 78.9989 36.0664 78.9989 37.5697C78.9989 39.0729 77.7709 40.301 76.2676 40.301H73.5364V37.5697Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M72.161 37.5699C72.161 39.0731 70.933 40.3011 69.4297 40.3011C67.9265 40.3011 66.6985 39.0731 66.6985 37.5699V30.7311C66.6985 29.2279 67.9265 27.9999 69.4297 27.9999C70.933 27.9999 72.161 29.2279 72.161 30.7311V37.5699Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M69.4295 48.5378C70.9328 48.5378 72.1608 49.7658 72.1608 51.2691C72.1608 52.7724 70.9328 54.0004 69.4295 54.0004C67.9262 54.0004 66.6982 52.7724 66.6982 51.2691V48.5378H69.4295Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M69.4297 47.1614C67.9265 47.1614 66.6985 45.9334 66.6985 44.4302C66.6985 42.9269 67.9265 41.6989 69.4297 41.6989H76.2685C77.7717 41.6989 78.9997 42.9269 78.9997 44.4302C78.9997 45.9334 77.7717 47.1614 76.2685 47.1614H69.4297Z",
        fill: "#ECB22E"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_dd_914_2569",
        x: "33",
        y: "8",
        width: "346",
        height: "113",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.56 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_914_2569"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_914_2569",
        result: "effect2_dropShadow_914_2569"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_914_2569",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear_914_2569",
        x1: "408.5",
        y1: "3.50001",
        x2: "0.106745",
        y2: "128.349",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.0974484",
        stopColor: "#042C86"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.920861",
        stopColor: "#0744A2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint1_linear_914_2569",
        x1: "127.857",
        y1: "34.7642",
        x2: "124.02",
        y2: "38.8376",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.176",
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint2_linear_914_2569",
        x1: "123.518",
        y1: "39.2894",
        x2: "119.074",
        y2: "43.7406",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.176",
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53d53f52e8f9e8a6$var$SlackSplashWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1qr7",
            __cmplp.className
        ])
    });
});

});

parcelRegister("a2Cyi", function(module, exports) {

$parcel$export(module.exports, "TeamsSplash", () => $6490deb057295e9e$export$ff18071b37ad7926);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6HZPP = parcelRequire("6HZPP");
const $6490deb057295e9e$export$ff18071b37ad7926 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6490deb057295e9e$var$TeamsSplashWrapper, {
        "data-testid": "third-party-nudge.ui.third-party-nudge-flag.splashes.teams-splash.teams-splash-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "412",
        height: "128",
        viewBox: "0 0 412 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H408C410.209 0 412 1.79086 412 4V128H0V4Z",
        fill: "url(#paint0_linear_914_2408)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter0_dd_914_2408)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.98"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M112 26.4701C112 25.106 113.106 24.0001 114.47 24.0001H357.53C358.894 24.0001 360 25.106 360 26.4701V100C360 102.209 358.209 104 356 104H116C113.791 104 112 102.209 112 100V26.4701Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#091E42",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "600",
        letterSpacing: "0em"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "124",
        y: "45.1993"
    }, formatMessage((0, $6HZPP.messages).teamsExampleTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "124",
        y: "54",
        width: "210",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "124",
        y: "66",
        width: "91",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "218",
        y: "66",
        width: "91",
        height: "6",
        rx: "3",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "124.3",
        y: "80.3001",
        width: "61.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#DFD8FD",
        strokeWidth: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#5E4DB2",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "134.26",
        y: "91.1993"
    }, formatMessage((0, $6HZPP.messages).integrationExampleCommentButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "192.893",
        y: "80.3001",
        width: "60.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#DFD8FD",
        strokeWidth: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#5E4DB2",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "202.414",
        y: "91.1993"
    }, formatMessage((0, $6HZPP.messages).integrationExampleEditIssueButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "260.485",
        y: "80.3001",
        width: "70.9924",
        height: "15.4",
        rx: "1.48113",
        stroke: "#DFD8FD",
        strokeWidth: "0.6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#5E4DB2",
        xmlSpace: "preserve",
        fontSize: "9",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "269.992",
        y: "91.1993"
    }, formatMessage((0, $6HZPP.messages).integrationExampleOpenInJiraButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "58",
        y: "28",
        width: "42",
        height: "42",
        rx: "4",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_914_2408)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M79.42 44.6668C81.582 44.6668 83.3347 42.9691 83.3347 40.8748C83.3347 38.7806 81.582 37.0829 79.42 37.0829C77.258 37.0829 75.5054 38.7806 75.5054 40.8748C75.5054 42.9691 77.258 44.6668 79.42 44.6668Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.1",
        d: "M79.1405 41.6875H75.595L75.6126 41.7631L75.6143 41.7696L75.6327 41.8394C75.8903 42.7858 76.5154 43.5991 77.3774 44.1096C78.2394 44.6201 79.2717 44.7884 80.2587 44.5792V42.7706C80.2578 42.4836 80.1397 42.2086 79.9302 42.0057C79.7207 41.8027 79.4368 41.6884 79.1405 41.6875Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M78.3021 42.5H75.8831C76.2005 43.1484 76.7015 43.6962 77.3276 44.0798C77.9537 44.4634 78.6794 44.667 79.4202 44.6669V43.5831C79.4194 43.2961 79.3013 43.0211 79.0918 42.8182C78.8823 42.6152 78.5984 42.5009 78.3021 42.5Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M88.2273 44.9375C89.8487 44.9375 91.1631 43.6643 91.1631 42.0938C91.1631 40.5232 89.8487 39.25 88.2273 39.25C86.6059 39.25 85.2915 40.5232 85.2915 42.0938C85.2915 43.6643 86.6059 44.9375 88.2273 44.9375Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M90.7439 45.75H84.1501C84.0077 45.75 83.8712 45.8048 83.7705 45.9023C83.6698 45.9998 83.6133 46.1321 83.6133 46.27V52.8594C83.5951 53.813 83.9157 54.7438 84.5215 55.4958C85.1273 56.2478 85.9814 56.7753 86.9408 56.9901C87.5518 57.1143 88.1838 57.105 88.7906 56.9627C89.3975 56.8205 89.9639 56.5489 90.4487 56.1679C90.9336 55.7868 91.3246 55.3058 91.5933 54.7599C91.862 54.214 92.0016 53.6169 92.002 53.0121V46.9688C92.002 46.6455 91.8695 46.3355 91.6335 46.107C91.3976 45.8784 91.0775 45.75 90.7439 45.75Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M86.1306 46.9688V54.6875C86.1315 56.1179 85.6448 57.5087 84.7463 58.6438C83.8477 59.779 82.5874 60.5951 81.1611 60.9655C79.7347 61.3359 78.222 61.2399 76.8577 60.6924C75.4934 60.1449 74.3539 59.1765 73.6159 57.9375C73.4544 57.6776 73.3142 57.406 73.1965 57.125C73.0867 56.8601 72.9942 56.5887 72.9197 56.3125C72.7814 55.7812 72.7109 55.2354 72.71 54.6875V46.9688C72.7097 46.8086 72.7421 46.6501 72.8053 46.5021C72.8684 46.3541 72.9611 46.2197 73.078 46.1065C73.1949 45.9933 73.3337 45.9035 73.4864 45.8423C73.6392 45.7812 73.8029 45.7498 73.9682 45.75H84.8725C85.0377 45.7498 85.2015 45.7812 85.3542 45.8423C85.507 45.9035 85.6457 45.9933 85.7626 46.1065C85.8795 46.2197 85.9722 46.3541 86.0353 46.5021C86.0985 46.6501 86.1309 46.8086 86.1306 46.9688Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M78.3021 42.5H75.8831C76.2005 43.1484 76.7015 43.6962 77.3276 44.0798C77.9537 44.4634 78.6794 44.667 79.4202 44.6669V43.5831C79.4194 43.2961 79.3013 43.0211 79.0918 42.8182C78.8823 42.6152 78.5984 42.5009 78.3021 42.5Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.1",
        d: "M80.2591 45.75V56.0444C80.2591 56.2893 80.1726 56.5269 80.0139 56.7175C79.8552 56.9082 79.6339 57.0405 79.3867 57.0925C79.3078 57.1152 79.2258 57.1262 79.1435 57.125H73.1965C73.0867 56.8601 72.9942 56.5887 72.9197 56.3125C72.7814 55.7812 72.7109 55.2354 72.71 54.6875V46.9688C72.7097 46.8086 72.7421 46.6501 72.8053 46.5021C72.8684 46.3541 72.9611 46.2197 73.078 46.1065C73.1949 45.9933 73.3337 45.9035 73.4864 45.8423C73.6392 45.7812 73.8029 45.7498 73.9682 45.75H80.2591Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M79.4203 45.75V56.8569C79.4215 56.9366 79.4102 57.0161 79.3867 57.0925C79.3331 57.3319 79.1965 57.5462 78.9997 57.7C78.8028 57.8537 78.5576 57.9375 78.3047 57.9375H73.6159C73.4544 57.6776 73.3142 57.406 73.1965 57.125C73.0867 56.8601 72.9942 56.5887 72.9197 56.3125C72.7814 55.7812 72.7109 55.2354 72.71 54.6875V46.9688C72.7097 46.8086 72.7421 46.6501 72.8053 46.5021C72.8684 46.3541 72.9611 46.2197 73.078 46.1065C73.1949 45.9933 73.3337 45.9035 73.4864 45.8423C73.6392 45.7812 73.8029 45.7498 73.9682 45.75H79.4203Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M79.4203 45.75V55.2319C79.419 55.5181 79.301 55.7922 79.0921 55.9946C78.8832 56.197 78.6002 56.3112 78.3047 56.3125H72.9197C72.7814 55.7812 72.7109 55.2354 72.71 54.6875V46.9688C72.7097 46.8086 72.7421 46.6501 72.8053 46.5021C72.8684 46.3541 72.9611 46.2197 73.078 46.1065C73.1949 45.9933 73.3337 45.9035 73.4864 45.8423C73.6392 45.7812 73.8029 45.7498 73.9682 45.75H79.4203Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.2",
        d: "M73.9682 45.75C73.8029 45.7498 73.6392 45.7812 73.4864 45.8423C73.3337 45.9035 73.1949 45.9933 73.078 46.1065C72.9611 46.2197 72.8684 46.3541 72.8053 46.5021C72.7421 46.6501 72.7097 46.8086 72.71 46.9688V54.6875C72.7109 55.2354 72.7814 55.7812 72.9197 56.3125H77.4659C77.7614 56.3112 78.0444 56.197 78.2533 55.9946C78.4622 55.7922 78.5802 55.5181 78.5815 55.2319V45.75H73.9682Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M66.2788 42.5H77.4632C77.7598 42.5 78.0442 42.6141 78.2538 42.8172C78.4635 43.0203 78.5813 43.2958 78.5813 43.5831V54.4169C78.5813 54.7042 78.4635 54.9797 78.2538 55.1828C78.0442 55.3859 77.7598 55.5 77.4632 55.5H66.2788C65.9822 55.5 65.6978 55.3859 65.4881 55.1828C65.2784 54.9797 65.1606 54.7042 65.1606 54.4169V43.5831C65.1606 43.2958 65.2784 43.0203 65.4881 42.8172C65.6978 42.6141 65.9822 42.5 66.2788 42.5Z",
        fill: "#4B53BC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M75.2093 46.5419H72.7013V53.0582H71.0556V46.5419H68.5325V44.9413H75.2093V46.5419Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M357.527 24C358.893 24 360 25.1073 360 26.4731L360 28L112 28L112 26.4731C112 25.1072 113.107 24 114.473 24L357.527 24Z",
        fill: "#505AC6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_dd_914_2408",
        x: "46",
        y: "12",
        width: "326",
        height: "104",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.56 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_914_2408"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_914_2408",
        result: "effect2_dropShadow_914_2408"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_914_2408",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear_914_2408",
        x1: "408.5",
        y1: "3.50001",
        x2: "0.106745",
        y2: "128.349",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.0974484",
        stopColor: "#042C86"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.920861",
        stopColor: "#0744A2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_914_2408"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "65",
        y: "36",
        width: "27.3",
        height: "26",
        fill: "white"
    })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6490deb057295e9e$var$TeamsSplashWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1qr7",
            __cmplp.className
        ])
    });
});

});




parcelRegister("c61cd", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $28fcda42efa1a4e5$export$14834abbfce3b8cd);

var $eUqFw = parcelRequire("eUqFw");

var $9KTWV = parcelRequire("9KTWV");

var $lys1A = parcelRequire("lys1A");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");
var $7zpSo = parcelRequire("7zpSo");


var $2aBcM = parcelRequire("2aBcM");

var $gwDQb = parcelRequire("gwDQb");

var $5ge6s = parcelRequire("5ge6s");

var $6FP8W = parcelRequire("6FP8W");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $8uqT0 = parcelRequire("8uqT0");
// Should this live in the migration layer (@atlassian/jira-navigation-system) instead?
const $28fcda42efa1a4e5$var$renderNotifications = (props, ref)=>{
    const { onViewRequests: onViewRequests, ...notificationProps } = props;
    if ((0, $6FP8W.getWillShowNav4)()) {
        const { badge: badge, onClick: onClick, isSelected: isSelected, label: label } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uqT0.Notifications), {
            badge: badge,
            label: label,
            onClick: onClick,
            isSelected: isSelected,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- PLEASE FIX - ENABLING FLAT LINT CONFIG
            ref: ref
        });
    }
    const buttonProps = {
        ...notificationProps,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9KTWV.Notifications), buttonProps);
};
const $28fcda42efa1a4e5$export$14834abbfce3b8cd = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { markSpotlightAsShown: markSpotlightAsShown, hasSpotlightBeenShown: hasSpotlightBeenShown } = (0, $2aBcM.useUsingNotificationsToImproveAdminApprovalContext)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eUqFw.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    if (false) {
        if ((0, $6FP8W.getWillShowNav4)()) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lys1A.Nav4SkeletonNotificationButton), {
            label: props.tooltip
        });
        // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lys1A.SkeletonNotificationButton), {
            label: props.tooltip
        });
    }
    const { onViewRequests: onViewRequests, ...notificationProps } = props;
    /**
	 * Send analytics event when user clicks "Close" or "View requests" button on the request spotlight
	 * Event registry - https://data-portal.internal.atlassian.com/analytics/registry/52348
	 * @param {"close"|"viewRequests"} buttonType
	 */ const handleSendAnalyticsEventForClickRequestSpotlightButton = (buttonType)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'requestSpotlightButton', {
            buttonType: buttonType,
            isSiteAdmin: isSiteAdmin
        });
    };
    const shouldShowRequestsSpotlight = isSiteAdmin && !hasSpotlightBeenShown;
    if (!shouldShowRequestsSpotlight) return $28fcda42efa1a4e5$var$renderNotifications(notificationProps, ref);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "admin-request-spotlight"
    }, $28fcda42efa1a4e5$var$renderNotifications(notificationProps, ref)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ge6s.default), {
        messageId: (0, $b21572a54e963d3c$export$d2ea4f931a71a509),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2aBcM.CoordinationStopProvider), null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwDQb.UsingNotificationsToImproveAdminApprovalSpotlight), {
            onViewRequests: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                onViewRequests && onViewRequests();
                handleSendAnalyticsEventForClickRequestSpotlightButton('viewRequests');
                stop && stop();
            },
            onClose: ()=>{
                setIsSpotlightActive(false);
                markSpotlightAsShown();
                handleSendAnalyticsEventForClickRequestSpotlightButton('close');
                stop && stop();
            }
        })))));
});

});
parcelRegister("gwDQb", function(module, exports) {

$parcel$export(module.exports, "UsingNotificationsToImproveAdminApprovalSpotlight", () => $71be9b71e39cb00a$export$aa9f9fc1c08b114f);

var $eUqFw = parcelRequire("eUqFw");


var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $ap7vt = parcelRequire("ap7vt");

var $gd0Sp = parcelRequire("gd0Sp");

var $aGcSy = parcelRequire("aGcSy");
const $71be9b71e39cb00a$export$aa9f9fc1c08b114f = ({ onViewRequests: onViewRequests, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926),
        sourceName: "requestSpotlight",
        attributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ap7vt.JiraSpotlight), {
        actions: [
            {
                onClick: onViewRequests,
                text: formatMessage((0, $aGcSy.default).uniapaSpotlightViewRequestsButtonText)
            },
            {
                onClick: onClose,
                text: formatMessage((0, $aGcSy.default).uniapaSpotlightCloseButtonText),
                appearance: 'subtle'
            }
        ],
        target: "admin-request-spotlight",
        key: "admin-request-spotlight",
        targetRadius: 100,
        dialogPlacement: "bottom right",
        dialogWidth: 275,
        targetBgColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
        messageId: "cross-flow-using-notifications-to-improve-admin-approval.ui.jira-spotlight.admin-request-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $aGcSy.default).uniapaSpotlightNotificationText))));
};

});
parcelRegister("ap7vt", function(module, exports) {

$parcel$export(module.exports, "JiraSpotlight", () => $9dba2f07cab8d82f$export$e209c6be9ab8c4f4);

var $eUqFw = parcelRequire("eUqFw");

var $hJJD2 = parcelRequire("hJJD2");

var $jGBLd = parcelRequire("jGBLd");

var $eI5EY = parcelRequire("eI5EY");

var $i6lq0 = parcelRequire("i6lq0");
const $9dba2f07cab8d82f$export$e209c6be9ab8c4f4 = (props)=>{
    if ((0, $jGBLd.shouldBeChoreographed)(props) && (0, $eI5EY.fg)('spotlight_conversion_to_choreographer_spotlight')) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6lq0.ChoreographerSpotlight), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), rest);
};

});
parcelRegister("jGBLd", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $38eaf8660dcaa871$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $38eaf8660dcaa871$export$e2cf19200849be9e);

var $1C9jQ = parcelRequire("1C9jQ");

var $EbGpR = parcelRequire("EbGpR");
function $38eaf8660dcaa871$export$a8ba9111c7eec9ac(props) {
    return !!props?.messageType && (0, $EbGpR.IntegratedChoreographerMessageTypesEnum).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.messageType);
}
function $38eaf8660dcaa871$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $1C9jQ.envType).DEV;
        case 'staging':
            return (0, $1C9jQ.envType).STAGING;
        case 'prod':
            return (0, $1C9jQ.envType).PROD;
        default:
            return (0, $1C9jQ.envType).LOCAL;
    }
}

});
parcelRegister("EbGpR", function(module, exports) {

$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0);
const $e5c6b031155cf9c2$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0 = [
    $e5c6b031155cf9c2$export$94e85cf3348f045a.ENGAGEMENT,
    $e5c6b031155cf9c2$export$94e85cf3348f045a.MARKETING
];

});


parcelRegister("i6lq0", function(module, exports) {

$parcel$export(module.exports, "ChoreographerSpotlight", () => $b80fd2570c4b1abe$export$e01943d134357d00);
// eslint-disable-next-line jira/import/no-restricted-import

var $hJJD2 = parcelRequire("hJJD2");

var $kytz8 = parcelRequire("kytz8");
const $b80fd2570c4b1abe$export$e01943d134357d00 = (0, $kytz8.withChoreographedRender)((0, $hJJD2.default));

});
parcelRegister("kytz8", function(module, exports) {

$parcel$export(module.exports, "withChoreographedRender", () => $d60c6f7c92c4fa11$export$c1160fdac17030e);

var $eUqFw = parcelRequire("eUqFw");

var $6uNFR = parcelRequire("6uNFR");
function $d60c6f7c92c4fa11$export$c1160fdac17030e(Component, options) {
    function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
        const shouldRender = (0, $6uNFR.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props);
        if (options && options.toggleableProp) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const toggleableComponentProps = {
                ...props,
                [options.toggleableProp]: false
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, toggleableComponentProps);
        }
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    return ChoreographedComponent;
}

});
parcelRegister("6uNFR", function(module, exports) {

$parcel$export(module.exports, "getPendoPlugin", () => $dbff780bfca374d0$export$3d3a86b2d636214b);
$parcel$export(module.exports, "useChoreographer", () => $dbff780bfca374d0$export$9f0e2488ffd90f11);
$parcel$export(module.exports, "ChoreographedStatusContext", () => $dbff780bfca374d0$export$3ff96dbefca6b00d);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $dbff780bfca374d0$export$2eb1efa814fe4a);
$parcel$export(module.exports, "useChoreographedRender", () => $dbff780bfca374d0$export$2cfd68294be82811);

var $eUqFw = parcelRequire("eUqFw");

var $5xY1g = parcelRequire("5xY1g");
var $awwEG = parcelRequire("awwEG");
var $67SDP = parcelRequire("67SDP");

var $6rW04 = parcelRequire("6rW04");

var $38OPi = parcelRequire("38OPi");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $dbff780bfca374d0$var$environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment')) ?? 'prod';
const $dbff780bfca374d0$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                startMessage: ()=>Promise.resolve(''),
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                stopMessage: ()=>{}
            })
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $5xY1g.choreographerFactory)((0, $67SDP.ProductIds).JIRA, $dbff780bfca374d0$var$environment);
};
let $dbff780bfca374d0$var$pendoPlugin;
function $dbff780bfca374d0$export$3d3a86b2d636214b(env) {
    if (!$dbff780bfca374d0$var$pendoPlugin) $dbff780bfca374d0$var$pendoPlugin = new (0, $awwEG.PendoChoreographerPlugin)(env, {
        sourceProductId: (0, $67SDP.ProductIds).JIRA
    });
    return $dbff780bfca374d0$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const { useChoreographer: $dbff780bfca374d0$export$9f0e2488ffd90f11 } = $dbff780bfca374d0$var$createChoreographerFactory();
const $dbff780bfca374d0$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $dbff780bfca374d0$export$2eb1efa814fe4a = ()=>(0, $eUqFw.useContext)($dbff780bfca374d0$export$3ff96dbefca6b00d);
const $dbff780bfca374d0$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $dbff780bfca374d0$export$2eb1efa814fe4a();
    const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $dbff780bfca374d0$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};

});




parcelRegister("aGcSy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dca69ef80f665549$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dca69ef80f665549$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    uniapaSpotlightNotificationText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text",
        "defaultMessage": "When someone in your team requests a new product you'll get a notification here now."
    },
    uniapaSpotlightCloseButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-close-button-text",
        "defaultMessage": "Close"
    },
    uniapaSpotlightViewRequestsButtonText: {
        "id": "cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-view-requests-button-text",
        "defaultMessage": "View requests"
    }
});

});


parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1C9jQ = parcelRequire("1C9jQ");

var $xMKqn = parcelRequire("xMKqn");
var $DEVKo = parcelRequire("DEVKo");

var $67SDP = parcelRequire("67SDP");

var $hS6Nu = parcelRequire("hS6Nu");

var $6uNFR = parcelRequire("6uNFR");

var $jGBLd = parcelRequire("jGBLd");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");

var $38OPi = parcelRequire("38OPi");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $DEVKo.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $1C9jQ.envType).PROD;
            if (env === 'staging') return (0, $1C9jQ.envType).STAGING;
            return (0, $1C9jQ.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $jGBLd.shouldBeChoreographed)({
            messageType: messageType
        }) && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $67SDP.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $67SDP.MessageDeliveryStatus).STARTED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $67SDP.MessageDeliveryStatus).STOPPED : (0, $67SDP.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6uNFR.useChoreographedStatusContext)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hS6Nu.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xMKqn.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});
parcelRegister("hS6Nu", function(module, exports) {

$parcel$export(module.exports, "ChoreographerContextProvider", () => $ea4a43adc0d84a49$export$c3226151caaf2fbf);

var $eUqFw = parcelRequire("eUqFw");

var $6uNFR = parcelRequire("6uNFR");
const $ea4a43adc0d84a49$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $ea4a43adc0d84a49$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $6uNFR.useChoreographedStatusContext)();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6uNFR.ChoreographedStatusContext).Provider, {
        value: $ea4a43adc0d84a49$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};

});



parcelRegister("fJrXw", function(module, exports) {

$parcel$export(module.exports, "useRegisterNotificationsInCommandPalette", () => $e5d27ecf10c78215$export$1859b18f10ade54c);

var $eUqFw = parcelRequire("eUqFw");

var $a10lp = parcelRequire("a10lp");

var $9zALC = parcelRequire("9zALC");

var $jmejm = parcelRequire("jmejm");

var $gfXKy = parcelRequire("gfXKy");

var $fmmnJ = parcelRequire("fmmnJ");

var $gjNh9 = parcelRequire("gjNh9");

var $6jiFZ = parcelRequire("6jiFZ");

var $5JgJ2 = parcelRequire("5JgJ2");


var $eFWnt = parcelRequire("eFWnt");
const $e5d27ecf10c78215$export$1859b18f10ade54c = (onClick)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const commands = [
        {
            id: (0, $faa6a29e0647159b$export$e0226a83abddbd07),
            name: formatMessage((0, $eFWnt.messages).checkNotifications),
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: onClick
            },
            keywords: getKeywords('checkNotificationsSynonyms'),
            section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).quickActions,
            priority: (0, $jmejm.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).checkNotifications,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a10lp))), {
                        label: formatMessage((0, $eFWnt.messages).checkNotifications)
                    })
            },
            analytics: {
                action: 'checkNotifications'
            }
        }
    ];
    (0, $gjNh9.useRegisterCommands)((0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).CHECK_NOTIFICATIONS, commands);
};

});
parcelRegister("9zALC", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $8bee8fa7684ab6e5$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $8bee8fa7684ab6e5$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $8bee8fa7684ab6e5$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $8bee8fa7684ab6e5$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $8bee8fa7684ab6e5$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $8bee8fa7684ab6e5$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $8bee8fa7684ab6e5$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $8bee8fa7684ab6e5$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $8bee8fa7684ab6e5$export$16b06d29ef8f802b;
(function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
})($8bee8fa7684ab6e5$export$16b06d29ef8f802b || ($8bee8fa7684ab6e5$export$16b06d29ef8f802b = {}));
const $8bee8fa7684ab6e5$export$156ebd2354e25466 = 'issueActions';
const $8bee8fa7684ab6e5$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $8bee8fa7684ab6e5$export$9f646ab88e1d2b14 = 'commandPalette';
var $8bee8fa7684ab6e5$export$abf26cc5daebd2c8;
(function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
})($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 || ($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 = {}));
var $8bee8fa7684ab6e5$export$12514ca8899b0521;
(function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
})($8bee8fa7684ab6e5$export$12514ca8899b0521 || ($8bee8fa7684ab6e5$export$12514ca8899b0521 = {}));
var $8bee8fa7684ab6e5$export$5fa0bcf59f933c21;
(function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
})($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 || ($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 = {}));
var $8bee8fa7684ab6e5$export$7d9743be0b7d862f;
(function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
})($8bee8fa7684ab6e5$export$7d9743be0b7d862f || ($8bee8fa7684ab6e5$export$7d9743be0b7d862f = {}));
var $8bee8fa7684ab6e5$export$b4e1633c86db2b70;
(function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
})($8bee8fa7684ab6e5$export$b4e1633c86db2b70 || ($8bee8fa7684ab6e5$export$b4e1633c86db2b70 = {}));
var $8bee8fa7684ab6e5$export$5e5a87aac5d9771f;
(function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
})($8bee8fa7684ab6e5$export$5e5a87aac5d9771f || ($8bee8fa7684ab6e5$export$5e5a87aac5d9771f = {}));

});

parcelRegister("jmejm", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $008cf4f8cce3a652$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $008cf4f8cce3a652$export$5ea2dca0a260365d;
(function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
})($008cf4f8cce3a652$export$5ea2dca0a260365d || ($008cf4f8cce3a652$export$5ea2dca0a260365d = {}));

});

parcelRegister("gfXKy", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $59897234799b31c8$export$4d8fe3ef6385358);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3iBHM = parcelRequire("3iBHM");
const $59897234799b31c8$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getKeywords = (0, $eUqFw.useCallback)((keywordGroup)=>(0, $3iBHM.messages)[keywordGroup] ? formatMessage((0, $3iBHM.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("3iBHM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f74b9c3b50ad31d$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $2f74b9c3b50ad31d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    }
});

});


parcelRegister("fmmnJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $2688cae36ed8d4f6$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $2688cae36ed8d4f6$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $2688cae36ed8d4f6$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $2688cae36ed8d4f6$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $2688cae36ed8d4f6$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.COPY_URL,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.DESCRIPTION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.LOG_WORK,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PARENT,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_ADD,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_SEARCH,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.SHORTCUTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STATUS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STORY_POINTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.THEME_MODE,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    }
};

});

parcelRegister("gjNh9", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommands", () => $5aa93b9a91fcbcd2$export$3f626f8a5dbc29e4);

var $fqCN8 = parcelRequire("fqCN8");
const $5aa93b9a91fcbcd2$export$3f626f8a5dbc29e4 = (0, $fqCN8.useRegisterCommandsWithRegistry);

});
parcelRegister("fqCN8", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $f1b669646bbb8295$export$8a824ae164ff968d);

var $eUqFw = parcelRequire("eUqFw");

var $7Xm2s = parcelRequire("7Xm2s");
function $f1b669646bbb8295$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $7Xm2s.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $eUqFw.useRef)(commands);
    (0, $eUqFw.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("7Xm2s", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $ed5a0599e1840fb5$export$880fc01e31710b27);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
function $ed5a0599e1840fb5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $gCtL7.useActionsCommandPalette)();
    const subscribe = (0, $eUqFw.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});



const $faa6a29e0647159b$export$e0226a83abddbd07 = 'check-notifications';

parcelRegister("eFWnt", function(module, exports) {

$parcel$export(module.exports, "messages", () => $11c2fd0a2e4db322$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $11c2fd0a2e4db322$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    checkNotifications: {
        "id": "atlassian-navigation.notifications.command-palette.check-notifications",
        "defaultMessage": "Check notifications"
    }
});

});


const $b9ec89df7cdd9ba3$export$14c62ba6f49b806f = 9;

parcelRegister("jVYY6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5787cad0756fd075$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5787cad0756fd075$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.notifications.tooltip",
        "defaultMessage": "Notifications"
    },
    oldLabel: {
        "id": "atlassian-navigation.notifications.old-label",
        "defaultMessage": "Notifications"
    },
    label: {
        "id": "atlassian-navigation.notifications.label",
        "defaultMessage": "{count, plural, =0{ Notifications} one{{count, number} Notification} other{{count, number} Notifications}}"
    },
    overNineNotifications: {
        "id": "atlassian-navigation.notifications.over-nine-notifications",
        "defaultMessage": "Over 9 Notifications"
    }
});

});

parcelRegister("bj7XE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("eBzTn")
]).then(()=>parcelRequire('9zLfI'));

});

parcelRegister("eSC8h", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("by58u")
]).then(()=>parcelRequire('37ScP'));

});


parcelRegister("4l7on", function(module, exports) {

$parcel$export(module.exports, "People", () => $71c16dc3a3f74590$export$8d3edc4d62e152ad);

var $eUqFw = parcelRequire("eUqFw");

var $ao10V = parcelRequire("ao10V");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $45GTD = parcelRequire("45GTD");

var $3eEIW = parcelRequire("3eEIW");

var $6pKAO = parcelRequire("6pKAO");
const $71c16dc3a3f74590$export$8d3edc4d62e152ad = ()=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    return(// this won't have any effect on those using the old people-menu except it will still cache
    // the remotely configured result for when they are rolled out to the new version
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $45GTD.PeopleAndTeamsConfigurationProvider), {
        product: "jira",
        locale: (0, $ao10V.default)(locale)
    }, (0, $eI5EY.fg)('ttvc_global_navigation_improvement') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6pKAO.People), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3eEIW.PeopleMenu), null)));
};

});
parcelRegister("3eEIW", function(module, exports) {

$parcel$export(module.exports, "PeopleMenu", () => $c63dd0d22efc6116$export$a3e97c2386ac2a97);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $5kDtB = parcelRequire("5kDtB");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c63dd0d22efc6116$var$LazyMenuWithConfiguration = (0, $7rh0R.lazy)(()=>Promise.resolve((parcelRequire("6pKAO"))).then(({ People: People })=>People), {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/people/menu-with-configuration/index.tsx"
});
const $c63dd0d22efc6116$export$a3e97c2386ac2a97 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "people-menu-dropdown-menu",
        packageName: (0, $5kDtB.PACKAGE_NAME),
        teamName: "navigation",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy-people-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c63dd0d22efc6116$var$LazyMenuWithConfiguration, null)));

});
parcelRegister("6pKAO", function(module, exports) {

$parcel$export(module.exports, "People", () => $366c58be1cf242b2$export$8d3edc4d62e152ad);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $d2wNG = parcelRequire("d2wNG");

var $cTgSO = parcelRequire("cTgSO");

var $7ZwLV = parcelRequire("7ZwLV");
var $enb7h = parcelRequire("enb7h");

var $aZaPn = parcelRequire("aZaPn");

var $1zdJL = parcelRequire("1zdJL");

var $gevkZ = parcelRequire("gevkZ");

var $7ZZxN = parcelRequire("7ZZxN");

var $1Iui1 = parcelRequire("1Iui1");

var $3q7Yq = parcelRequire("3q7Yq");

var $6j4bv = parcelRequire("6j4bv");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $82rJa = parcelRequire("82rJa");

var $iFLJg = parcelRequire("iFLJg");

var $7vTKl = parcelRequire("7vTKl");

var $3BTZc = parcelRequire("3BTZc");

var $2futN = parcelRequire("2futN");


var $RZsVl = parcelRequire("RZsVl");

var $71CzX = parcelRequire("71CzX");

var $10fdS = parcelRequire("10fdS");

var $cWiVr = parcelRequire("cWiVr");

var $jD3pk = parcelRequire("jD3pk");

var $6WXNs = parcelRequire("6WXNs");

var $105cx = parcelRequire("105cx");

var $8ZFO4 = parcelRequire("8ZFO4");

var $3K78m = parcelRequire("3K78m");

var $gNXC6 = parcelRequire("gNXC6");

var $21Sgb = parcelRequire("21Sgb");

var $6yplV = parcelRequire("6yplV");

var $gd0Sp = parcelRequire("gd0Sp");

var $bB06Z = parcelRequire("bB06Z");

var $lB25E = parcelRequire("lB25E");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $olGf9 = parcelRequire("olGf9");

var $5ZWbT = parcelRequire("5ZWbT");

var $iRTpS = parcelRequire("iRTpS");

var $69xWj = parcelRequire("69xWj");

var $gvn5f = parcelRequire("gvn5f");

var $eXtUa = parcelRequire("eXtUa");

var $5Jczu = parcelRequire("5Jczu");

var $d5ydC = parcelRequire("d5ydC");
const $366c58be1cf242b2$var$getInviteThirdPartyTeamsExperiment = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('confluence.frontend.growth.invite-3rd-party-teams', (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.VARIATION)
    ]);
const $366c58be1cf242b2$var$STORAGE_KEY = 'jwm.invite-business-teams-modal-viwed-timestamp';
const $366c58be1cf242b2$var$SITE_USER_TRAIT_HAS_VIEW_EXPERIMENT = 'jira_screen_viewed_invitebusinessteamsmodal_first';
const $366c58be1cf242b2$var$STORAGE_PROVIDER_KEY = 'jira_invite-business-teams-modal';
const $366c58be1cf242b2$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)($366c58be1cf242b2$var$STORAGE_PROVIDER_KEY);
const $366c58be1cf242b2$var$PeopleMenuDropdown = ()=>{
    const [inviteBusinessTeamsModalData, setInviteBusinessTeamsModalData] = (0, $eUqFw.useState)({
        isOpen: false,
        userCounts: 0
    });
    const [isMenuOpen, { off: closeMenu, on: openMenu }] = (0, $3BTZc.useTopMenus)((0, $7vTKl.MENU_ID).PEOPLE);
    const baseUrl = '';
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const isHighlighted = (0, $69xWj.useMenuHighlighted)((0, $7vTKl.MENU_ID).PEOPLE);
    const triggerAnalytics = (0, $gvn5f.useNavigationItemAnalytics)({
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).PEOPLE
    });
    const [isEventFromSpotlightTour] = (0, $iRTpS.useFromSpotlightTour)('spotlight');
    const checkUsersGroupPermission = (0, $eXtUa.useBrowseUsersGroupsPermissions)();
    const checkUsersGroupPermissionNext = (0, $eXtUa.useBrowseUsersGroupsPermissionsNext)(isMenuOpen);
    const isEnabledForTailoredOnboardingM2 = (0, $eI5EY.fg)('jira_tailored_onboarding_jtbd_feature_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $RZsVl.useIsTailoredOnboardingM2ForQuickstartEnabled)() : false;
    const addFlag = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Gz4Lz.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'warning') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'error') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
    const pushRoute = (0, $eUqFw.useCallback)((url)=>push(`${baseUrl}${url}`), [
        baseUrl,
        push
    ]);
    const peopleMenuWrapperRef = (0, $105cx.useRegisterNudgeTarget)((0, $8379f5d78bf6fb5a$export$77bc79debbf5c069), true).ref;
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    const projectTeamAccessData = (0, $5Jczu.useTPAExperiment)();
    const teamCreateDialogProps = (0, $eUqFw.useMemo)(()=>{
        const dialogProps = {
            currentUser: {
                id: user.accountId || '',
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                email: user.emailAddress !== undefined ? user.emailAddress : '',
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user?.avatarUrls ? user.avatarUrls['16x16'] : '',
                nickname: user?.userFullname
            },
            enableMembershipSettingsChoice: true,
            projectTeamAccess: projectTeamAccessData
        };
        dialogProps.onClose = ()=>{
            if (peopleMenuWrapperRef?.current) requestAnimationFrame(()=>{
                peopleMenuWrapperRef?.current?.querySelector('button')?.focus();
            });
        };
        return dialogProps;
    // the peopleMenuWrapperRef doesn't change as the condition if FG is static
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projectTeamAccessData,
        user
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // close menu when transitioning to other pages.
        if (!(0, $eI5EY.fg)('dont-auto-close-people-menu')) closeMenu();
        // close menu on unmount
        return ()=>{
            if (!(0, $eI5EY.fg)('dont-auto-close-people-menu')) closeMenu();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route
    ]);
    const { data: projectSidebarNavigationData } = (0, $2futN.useProjectSidebarNavigation)();
    const subProduct = (0, $iFLJg.projectTypeToSubProduct)(projectSidebarNavigationData?.projectType);
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId, appEditions: { software: software } } = (0, $gd0Sp.useTenantContext)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const invitePeopleExperimentalFeatures = (0, $eUqFw.useMemo)(()=>({
            inviteThirdPartyTeams: $366c58be1cf242b2$var$getInviteThirdPartyTeamsExperiment(),
            displayInfiSpotlight: (0, $1ybV0.ff)('confluence.frontend.growth.display-infi-spotlight')
        }), []);
    const continueUrl = window.location.href;
    const entryPoint = (0, $6j4bv.useEntryPoint)((0, $1zdJL.inviteBusinessTeamsModalEntryPoint), {});
    const [{ traits: traits }] = (0, $gevkZ.usePersonalizationProvider)();
    const firstActivationDateMs = (0, $21Sgb.useFirstActivationDateMs)();
    const storedValue = $366c58be1cf242b2$export$c2ed3351cac403d1.get($366c58be1cf242b2$var$STORAGE_KEY);
    const isSoftwareProject = subProduct === (0, $7ZZxN.SOFTWARE_PROJECT);
    const isValidAppEdition = software === (0, $6WXNs.FREE_EDITION) || software === (0, $6WXNs.STANDARD_EDITION);
    const isValidSiteAge = firstActivationDateMs && (0, $d2wNG.default)(new Date(), firstActivationDateMs) > 28;
    const hasDismissedInviteBefore = storedValue || traits.some((trait)=>trait.name === $366c58be1cf242b2$var$SITE_USER_TRAIT_HAS_VIEW_EXPERIMENT);
    const showModal = Boolean(isSoftwareProject && isValidAppEdition && isValidSiteAge && !hasDismissedInviteBefore);
    const { openModal: openModal } = (0, $enb7h.useInvitePeopleModal)({
        continueUrl: continueUrl,
        enableThirdParty: true,
        experimentalFeatures: invitePeopleExperimentalFeatures,
        orgId: orgId,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleMenu',
        subProduct: subProduct,
        experimental_applicationEdition: software,
        navigation: {
            directoryContextEntryPoint: '/jira'
        },
        onSubmit: async (data)=>{
            const { inviteUsersResponse: inviteUsersResponse } = await data.defaultOnSubmit();
            // Handle invite business team modal experiment
            if (showModal) {
                const invitedJswUsers = (0, $d5ydC.getInvitedJswUsers)(inviteUsersResponse);
                const invitedJswUserCount = invitedJswUsers.length;
                // make sure we only display our modal when invites are JSW
                if (invitedJswUserCount > 0) {
                    setInviteBusinessTeamsModalData({
                        isOpen: true,
                        userCounts: invitedJswUserCount
                    });
                    // Make sure user only see the dialog once, and avoid loading traits everytime when user invites a person
                    $366c58be1cf242b2$export$c2ed3351cac403d1.set($366c58be1cf242b2$var$STORAGE_KEY, String(new Date()));
                    entryPoint.entryPointActions.load();
                }
            }
        },
        // this is used to handle `add more people` button clicked, we need to hide invite business team modal
        ...showModal ? {
            experimental_onReopenHandler: ()=>{
                openModal();
                setInviteBusinessTeamsModalData({
                    isOpen: false,
                    userCounts: 0
                });
            }
        } : {}
    });
    const invitePeopleHandlers = (0, $eUqFw.useMemo)(()=>({
            handleClick: openModal
        }), [
        openModal
    ]);
    if (!atlassianAccountId) return null;
    const renderPeopleMenu = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bB06Z.default), {
            shouldRenderToParent: true,
            product: "jira",
            cloudId: cloudId,
            userId: atlassianAccountId,
            isBrowseUsersEnabled: (0, $eI5EY.fg)('dont-auto-close-people-menu') ? checkUsersGroupPermissionNext : checkUsersGroupPermission,
            // allow PeopleMenu to do transitions to in-product People Directory
            pushRoute: pushRoute,
            isHighlighted: isHighlighted,
            // @ts-expect-error - TS2322 - Type '({ appearance, ...flagProps }: { [x: string]: any; appearance: any; }) => void' is not assignable to type '(flag: Flag) => void'.
            addFlag: addFlag,
            onClick: triggerAnalytics,
            // manage open state
            isOpen: isMenuOpen,
            onOpen: openMenu,
            onClose: isEventFromSpotlightTour ? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) : closeMenu,
            customChevronIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $olGf9.ChevronRightIcon), null),
            enablePreFetchingByHovering: false,
            subProduct: subProduct,
            isSSR: false,
            orgId: orgId ?? undefined,
            teamCreateDialogProps: teamCreateDialogProps,
            invitePeopleHandlers: invitePeopleHandlers,
            isSectionList: true
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).PEOPLE,
        packageName: (0, $5kDtB.PACKAGE_NAME),
        fallback: "unmount",
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$export$5d16118c15d58d20, {
        ref: peopleMenuWrapperRef,
        "data-testid": `menu-${(0, $5kDtB.NAVIGATION_ITEM_ID).PEOPLE}-wrapper`
    }, ((0, $71CzX.isUserEnrolledInTailoredOnboardingExperiment)() || isEnabledForTailoredOnboardingM2) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZFO4.InviteTeamNudgeAsync), null), (0, $eI5EY.fg)('ttvc_global_navigation_improvement') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bB06Z.default), {
        shouldRenderToParent: true,
        product: "jira",
        cloudId: cloudId,
        userId: atlassianAccountId,
        isBrowseUsersEnabled: (0, $eI5EY.fg)('dont-auto-close-people-menu') ? checkUsersGroupPermissionNext : checkUsersGroupPermission,
        // allow PeopleMenu to do transitions to in-product People Directory
        pushRoute: pushRoute,
        isHighlighted: isHighlighted,
        // @ts-expect-error - TS2322 - Type '({ appearance, ...flagProps }: { [x: string]: any; appearance: any; }) => void' is not assignable to type '(flag: Flag) => void'.
        addFlag: addFlag,
        onClick: triggerAnalytics,
        // manage open state
        isOpen: isMenuOpen,
        onOpen: openMenu,
        onClose: isEventFromSpotlightTour ? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) : closeMenu,
        customChevronIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $olGf9.ChevronRightIcon), null),
        enablePreFetchingByHovering: false,
        subProduct: subProduct,
        isSSR: false,
        orgId: orgId ?? undefined,
        teamCreateDialogProps: teamCreateDialogProps,
        invitePeopleHandlers: invitePeopleHandlers,
        isSectionList: true
    }) : renderPeopleMenu()), inviteBusinessTeamsModalData.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPoint.entryPointReferenceSubject,
        id: "invite-business-teams-modal",
        packageName: "jira-business.invite-business-teams",
        teamName: "jira-werewolves",
        runtimeProps: {
            userCounts: inviteBusinessTeamsModalData.userCounts,
            onClose: ()=>{
                setInviteBusinessTeamsModalData({
                    isOpen: false,
                    userCounts: 0
                });
            }
        },
        entryPointActions: entryPoint.entryPointActions
    }));
};
const $366c58be1cf242b2$var$PeopleWithAuth = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { isVisible: isVisible } = (0, $cTgSO.useOverflowStatus)();
    const [{ hasOpened: shouldShowNudge }] = (0, $gNXC6.useHasOpened)();
    if (isAnonymous) return null;
    if (!false) {
        if ((0, $eI5EY.fg)('ttvc_global_navigation_improvement')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "navigation.people-menu.with-nudgetooltip",
            packageName: (0, $5kDtB.PACKAGE_NAME),
            fallback: "unmount",
            teamName: "navigation"
        }, shouldShowNudge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3K78m.NavigationPeopleNavItemWrapperNudgeAsync), {
            isInsideMenu: !isVisible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZWbT.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZwLV.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$var$PeopleMenuDropdown, null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZWbT.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZwLV.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$var$PeopleMenuDropdown, null))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "navigation.people-menu.with-nudgetooltip",
            packageName: (0, $5kDtB.PACKAGE_NAME),
            fallback: "unmount",
            teamName: "navigation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3K78m.NavigationPeopleNavItemWrapperNudgeAsync), {
            isInsideMenu: !isVisible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZWbT.FullHeightTextColorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZwLV.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$var$PeopleMenuDropdown, null)))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$var$PeopleMenuDropdown, null);
};
const $366c58be1cf242b2$export$8d3edc4d62e152ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).PEOPLE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($366c58be1cf242b2$var$PeopleWithAuth, null));
const $366c58be1cf242b2$export$5d16118c15d58d20 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i1osq _16jlkb7n _shj5kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1zdJL", function(module, exports) {

$parcel$export(module.exports, "inviteBusinessTeamsModalEntryPoint", () => $11c2946ac665e539$export$f4db71d255c0573);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $11c2946ac665e539$export$f4db71d255c0573 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("182oc")).then((module)=>module.InviteBusinessTeamsModal), {
        moduleId: "c8fe5655"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("182oc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("kZ6X3")
]).then(()=>parcelRequire('af3H7'));

});


parcelRegister("3Y2Y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $23cb4ade2efc0679$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$23cb4ade2efc0679$export$2e2bcd8739ae039 = (0, $kQ0RL.ErrorFlag);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("5eqyk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cCYJs")
]).then(()=>parcelRequire('kbpOk'));

});

parcelRegister("eWPgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hkLGi").then(()=>parcelRequire('jkRT2'));

});



parcelRegister("Gz4Lz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1273ecbdbcfe24cd$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$1273ecbdbcfe24cd$export$2e2bcd8739ae039 = (0, $kQ0RL.SuccessFlag);

});

parcelRegister("82rJa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8bd85b08cb5610$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$9c8bd85b08cb5610$export$2e2bcd8739ae039 = (0, $kQ0RL.WarningFlag);

});

parcelRegister("iFLJg", function(module, exports) {

$parcel$export(module.exports, "stripUrlToIssueKey", () => $068703c2c99fc355$export$1f3c6284caef177b);
$parcel$export(module.exports, "useInvitePeopleFlags", () => $068703c2c99fc355$export$ab5fb7206b83c9ad);
$parcel$export(module.exports, "projectTypeToSubProduct", () => $068703c2c99fc355$export$3500077858760067);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $90ffs = parcelRequire("90ffs");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $82rJa = parcelRequire("82rJa");
const $068703c2c99fc355$var$ISSUE_KEY_REGEXP = /(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $068703c2c99fc355$export$1f3c6284caef177b = (candidateUrl)=>{
    const match = candidateUrl.match($068703c2c99fc355$var$ISSUE_KEY_REGEXP);
    return match && match[1];
};
const $068703c2c99fc355$export$ab5fb7206b83c9ad = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const addFlag = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        let FlagComponent = (0, $90ffs.default);
        // eslint-disable-next-line default-case
        switch(appearance){
            case 'success':
            case 'normal':
                FlagComponent = (0, $Gz4Lz.default);
                break;
            case 'warning':
                FlagComponent = (0, $82rJa.default);
                break;
            case 'error':
                FlagComponent = (0, $3Y2Y8.default);
                break;
        }
        // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagComponent, {
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    return {
        addFlag: addFlag
    };
};
const $068703c2c99fc355$export$3500077858760067 = (projectType)=>{
    switch(projectType){
        case 'jira_software':
            return 'software';
        case 'jira_service_management':
            return 'servicedesk';
        case 'jira_work_management':
            return 'core';
        case 'jira_product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};

});
parcelRegister("90ffs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b69c2b71403c7d4$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$8b69c2b71403c7d4$export$2e2bcd8739ae039 = (0, $kQ0RL.InfoFlag);

});


parcelRegister("RZsVl", function(module, exports) {

$parcel$export(module.exports, "usePersonalisationActions", () => $c3486dd8f5cb43fa$export$5b1d43353c334c00);
$parcel$export(module.exports, "useCommonEligibilityConditionsForJtbdOnboarding", () => $c3486dd8f5cb43fa$export$c89644b13b6e777f);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationAttributes", () => $c3486dd8f5cb43fa$export$9aad8798ea46e07f);
$parcel$export(module.exports, "useTailoredOnboardingPersonalisationM2", () => $c3486dd8f5cb43fa$export$5875295cb096b1f2);
$parcel$export(module.exports, "useIsTailoredOnboardingM2ForQuickstartEnabled", () => $c3486dd8f5cb43fa$export$6bc15f8ade1cf36);
$parcel$export(module.exports, "useFireExposureForTailoredOnboardingM2ForQuickstart", () => $c3486dd8f5cb43fa$export$369994803661d31);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $1R3n5 = parcelRequire("1R3n5");

var $WBLbN = parcelRequire("WBLbN");

var $3dMdu = parcelRequire("3dMdu");

var $d4w6a = parcelRequire("d4w6a");

var $2vErl = parcelRequire("2vErl");

var $l1u3T = parcelRequire("l1u3T");
const $c3486dd8f5cb43fa$var$store = (0, $WBLbN.createStore)({
    name: 'jira-onboarding-personalisation',
    initialState: (0, $3dMdu.initialCachedEndpointState),
    actions: $d4w6a.actions
});
const $c3486dd8f5cb43fa$export$5b1d43353c334c00 = (0, $WBLbN.createActionsHook)($c3486dd8f5cb43fa$var$store);
const $c3486dd8f5cb43fa$export$31a443426d101362 = (0, $WBLbN.createHook)($c3486dd8f5cb43fa$var$store);
const $c3486dd8f5cb43fa$export$c89644b13b6e777f = ()=>{
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    return isSiteAdmin && (0, $eI5EY.fg)('jira_tailored_onboarding_jtbd_feature_gate');
};
const $c3486dd8f5cb43fa$export$6f87e1662a24f8b9 = ({ isEligible: isEligible, experienceTypes: experienceTypes, additionalParameters: additionalParameters })=>{
    const [{ fetchedOnce: fetchedOnce, isFetching: isFetching, data: data }, { fetchOnboardingPersonalisation: fetchOnboardingPersonalisation }] = $c3486dd8f5cb43fa$export$31a443426d101362();
    (0, $eUqFw.useEffect)(()=>{
        if (isEligible && !fetchedOnce && !isFetching && data === undefined) fetchOnboardingPersonalisation({
            experienceTypes: experienceTypes,
            additionalParameters: additionalParameters
        });
    }, [
        additionalParameters,
        data,
        experienceTypes,
        fetchOnboardingPersonalisation,
        fetchedOnce,
        isEligible,
        isFetching
    ]);
    if (!isEligible) // If not eligible, no fetching is done. Data is ready to be read
    return {
        data: undefined,
        isReady: true
    };
    return {
        data: data,
        isReady: fetchedOnce && !isFetching
    };
};
const $c3486dd8f5cb43fa$export$9aad8798ea46e07f = ()=>{
    const isEligibleForTailoredOnboardingM2 = $c3486dd8f5cb43fa$export$c89644b13b6e777f();
    const { data: personalisationData, isReady: personalisationDataIsReady } = $c3486dd8f5cb43fa$export$6f87e1662a24f8b9({
        isEligible: isEligibleForTailoredOnboardingM2
    });
    return {
        personalisationDataIsReady: personalisationDataIsReady,
        teamType: personalisationData?.matched.variants.find((variant)=>variant.startsWith('teamType.'))?.replace('teamType.', ''),
        jtbd: personalisationData?.matched.variants.filter((variant)=>variant.startsWith('jtbd.option_')).map((option)=>option.replace('jtbd.option_', '')).join(',')
    };
};
const $c3486dd8f5cb43fa$export$5875295cb096b1f2 = ({ isEligible: isEligible, additionalParameters: additionalParameters })=>{
    const hasSentErrorOnce = (0, $eUqFw.useRef)(false);
    const { data: data, isReady: isReady } = $c3486dd8f5cb43fa$export$6f87e1662a24f8b9({
        isEligible: isEligible,
        experienceTypes: [
            'QUICKSTART',
            'TEMPLATE',
            'LANDING_PAGE'
        ],
        additionalParameters: additionalParameters
    });
    try {
        const conditionalProjectType = `projectType.${additionalParameters?.projectType}`;
        // If projectType is not given as parameter, ignore restriction to match on projectType
        const isMatchingProjectType = Boolean(!additionalParameters?.projectType || data?.matched.variants.some((variant)=>variant === conditionalProjectType));
        const isMatchingTeamType = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('teamType.') && (0, $2vErl.ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            variant.split('.')[1])));
        const isMatchingJtbd = Boolean(data?.matched.variants.some((variant)=>variant.startsWith('jtbd')));
        const matched = Boolean(data && isMatchingJtbd && isMatchingProjectType && isMatchingTeamType);
        return {
            isReady: isReady,
            data: {
                matched: matched,
                matchedVariants: {
                    projectType: isMatchingProjectType,
                    tt: isMatchingTeamType,
                    jtbd: isMatchingJtbd
                },
                QUICKSTART: matched && data ? data.experience.QUICKSTART : [],
                TEMPLATE: matched && data ? data.experience.TEMPLATE?.[0] : undefined,
                LANDING_PAGE: matched && data ? data.experience.LANDING_PAGE?.[0] : undefined
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!hasSentErrorOnce.current) (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'useTailoredOnboardingPersonalisationM2',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        hasSentErrorOnce.current = true;
    }
    return {
        isReady: isReady,
        data: {
            matched: false,
            matchedVariants: {
                jtbd: false,
                tt: false,
                projectType: false
            },
            QUICKSTART: [],
            TEMPLATE: undefined,
            LANDING_PAGE: undefined
        }
    };
};
const $c3486dd8f5cb43fa$export$6bc15f8ade1cf36 = ()=>{
    const isEligibleForJtbdOnboarding = $c3486dd8f5cb43fa$export$c89644b13b6e777f();
    const isEnabled = (0, $l1u3T.isTailoredOnboardingM2ExperimentFlagEnabled)();
    const { isReady: personalisationDataIsReady, data: personalisationData } = $c3486dd8f5cb43fa$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding,
        additionalParameters: {
            projectType: (0, $7ZZxN.CORE_PROJECT)
        }
    });
    return Boolean(personalisationDataIsReady && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0 && isEnabled);
};
const $c3486dd8f5cb43fa$export$369994803661d31 = ({ projectType: projectType })=>{
    const fgAddExposure = (0, $eI5EY.fg)('tailored_onboarding_m2_content_exposure_adjust');
    const isEligibleForJtbdOnboarding = $c3486dd8f5cb43fa$export$c89644b13b6e777f();
    const { isReady: personalisationDataIsReady, data: personalisationData } = $c3486dd8f5cb43fa$export$5875295cb096b1f2({
        isEligible: isEligibleForJtbdOnboarding && fgAddExposure,
        additionalParameters: {
            projectType: (0, $7ZZxN.CORE_PROJECT)
        }
    });
    if (fgAddExposure && projectType === (0, $7ZZxN.CORE_PROJECT) && personalisationDataIsReady && personalisationData.matched && personalisationData.QUICKSTART && personalisationData.QUICKSTART?.length > 0) (0, $79xbN.expVal)('jira_tailored_onboarding_jtbd', 'isEnabled', false);
};

});
parcelRegister("d4w6a", function(module, exports) {

$parcel$export(module.exports, "actions", () => $220ef4c26e2d16b0$export$e324594224ef24da);

var $879e1 = parcelRequire("879e1");

var $5kFcG = parcelRequire("5kFcG");
const $220ef4c26e2d16b0$var$fetchOnboardingPersonalisation = (0, $879e1.cachedEndpointCall)((args)=>(0, $5kFcG.fetchOnboardingPersonalisationWithRethrow)(args));
const $220ef4c26e2d16b0$var$trackPersonalisationAction = ({ additionalParameters: additionalParameters })=>()=>(0, $5kFcG.trackPersonalisation)({
            additionalParameters: additionalParameters
        });
const $220ef4c26e2d16b0$export$e324594224ef24da = {
    fetchOnboardingPersonalisation: $220ef4c26e2d16b0$var$fetchOnboardingPersonalisation,
    trackPersonalisation: $220ef4c26e2d16b0$var$trackPersonalisationAction
};

});
parcelRegister("5kFcG", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingPersonalisationWithRethrow", () => $3e8409fd087376e0$export$6bc39428b6510a7c);
$parcel$export(module.exports, "trackPersonalisation", () => $3e8409fd087376e0$export$9835c32b78102887);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gs0Be = parcelRequire("gs0Be");
const $3e8409fd087376e0$var$PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/experience';
const $3e8409fd087376e0$var$TRACK_PERSONALISATION_ENDPOINT = '/rest/personalisation/v1/track';
const $3e8409fd087376e0$var$responseHasAllRequestedExperienceTypes = ({ response: response, requestedExperienceTypes: requestedExperienceTypes })=>requestedExperienceTypes.every((requestedExperienceType)=>response.experience[requestedExperienceType]);
const $3e8409fd087376e0$export$6bc39428b6510a7c = async ({ experienceTypes: experienceTypes = [
    'QUICKSTART',
    'TEMPLATE',
    'LANDING_PAGE'
], additionalParameters: additionalParameters })=>{
    try {
        const localStorageOnboardingPersonalisationResponse = (0, $gs0Be.getLocalStorageOnboardingPersonalisationResponse)();
        if (localStorageOnboardingPersonalisationResponse && $3e8409fd087376e0$var$responseHasAllRequestedExperienceTypes({
            response: localStorageOnboardingPersonalisationResponse,
            requestedExperienceTypes: experienceTypes
        })) return localStorageOnboardingPersonalisationResponse;
        const response = await (0, $lRmyA.performPostRequestWithRetry)($3e8409fd087376e0$var$PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                experienceTypes: experienceTypes,
                additionalParameters: additionalParameters
            })
        });
        if (response) {
            const mergedResponse = {
                experience: {
                    ...localStorageOnboardingPersonalisationResponse?.experience,
                    ...response.experience
                },
                matched: response.matched
            };
            (0, $gs0Be.setLocalStorageOnboardingPersonalisationResponse)(mergedResponse);
            return mergedResponse;
        }
        throw new Error('response from OnboardingPersonalisation is falsy');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'fetchOnboardingPersonalisationWithRethrow',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $3e8409fd087376e0$export$9835c32b78102887 = ({ additionalParameters: additionalParameters })=>{
    try {
        (0, $lRmyA.performPostRequestWithRetry)($3e8409fd087376e0$var$TRACK_PERSONALISATION_ENDPOINT, {
            body: JSON.stringify({
                additionalParameters: additionalParameters
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'trackOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("gs0Be", function(module, exports) {

$parcel$export(module.exports, "getLocalStorageOnboardingPersonalisationResponse", () => $37ad103b17c04430$export$e9fb5b94c03fa495);
$parcel$export(module.exports, "setLocalStorageOnboardingPersonalisationResponse", () => $37ad103b17c04430$export$dda9cd59669fc243);

var $aZaPn = parcelRequire("aZaPn");

var $guiFP = parcelRequire("guiFP");
const $37ad103b17c04430$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE = 'response';
const $37ad103b17c04430$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jira-onboarding-personalisation');
const $37ad103b17c04430$export$e9fb5b94c03fa495 = ()=>{
    try {
        return $37ad103b17c04430$var$localStorage.get($37ad103b17c04430$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPersonalisation',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
};
const $37ad103b17c04430$export$dda9cd59669fc243 = (response)=>{
    try {
        $37ad103b17c04430$var$localStorage.set($37ad103b17c04430$var$LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE, response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPersonalisationResponse',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});



parcelRegister("2vErl", function(module, exports) {

$parcel$export(module.exports, "ELIGIBLE_TEAM_TYPES_M2_FULL_NOTATION", () => $e5c071bf4b0b6576$export$1d38dc41bb005254);

var $4MMft = parcelRequire("4MMft");
const $e5c071bf4b0b6576$export$1d38dc41bb005254 = [
    (0, $4MMft.USER_SEGMENTATION_TEAM_TYPE_MARKETING),
    (0, $4MMft.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS)
];

});
parcelRegister("4MMft", function(module, exports) {

$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_MARKETING", () => $bea62c923aa19b28$export$e4824f74b9879164);
$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_OPERATIONS", () => $bea62c923aa19b28$export$4f3cb0844009af52);
$parcel$export(module.exports, "userBelongsToBusinessUserSegCategory", () => $bea62c923aa19b28$export$517f94ab07724226);

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");
// Roles defined in user segmentation
const $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER = 'designer';
const $bea62c923aa19b28$export$572242e58bd07594 = 'customer-service';
const $bea62c923aa19b28$export$d7de553940261eba = 'it-support';
const $bea62c923aa19b28$export$4c29d0d04c15e55d = 'human-resources';
const $bea62c923aa19b28$export$3950f7f841bf94b6 = 'finance';
const $bea62c923aa19b28$export$881249b988b6030f = 'legal';
const $bea62c923aa19b28$export$e4824f74b9879164 = 'marketing';
const $bea62c923aa19b28$export$4f3cb0844009af52 = 'operations';
const $bea62c923aa19b28$export$1a65d50c4a641bb4 = 'sales';
const $bea62c923aa19b28$export$b8b1ac856ba1434b = 'software-development';
// Unique identifier used where all roles in a team type are eligible
const $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE = 'all-roles-eligible';
const $bea62c923aa19b28$export$2f3f9640393bd078 = 'unknown';
const $bea62c923aa19b28$export$4c9a72dac5ce80ae = '';
// @ts-expect-error - It seems to be missing some translations (for all-roles-eligible).
const $bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING = {
    [$bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
        'Designer',
        'Disainer',
        "Dise\xf1ador",
        'Formgivare',
        "Nh\xe0 thi\u1EBFt k\u1EBF",
        'Projektant',
        'Suunnittelija',
        "Tasar\u0131mc\u0131",
        "Tervez\u0151",
        "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
        "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "\u30C7\u30B6\u30A4\u30CA\u30FC",
        "\u8A2D\u8A08\u5E2B",
        "\u8BBE\u8BA1\u5E08",
        "\uB514\uC790\uC774\uB108"
    ],
    [$bea62c923aa19b28$export$572242e58bd07594]: [
        'Asiakaspalvelu',
        'Atendimento ao cliente',
        'Customer Service',
        "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
        'Klantenservice',
        'Klienditeenindus',
        'Kundenservice',
        'Kundeservice',
        'Kundservice',
        "M\xfc\u015Fteri Hizmetleri",
        "Obs\u0142uga klienta",
        "Service \xe0 la client\xe8le",
        "Servicio de atenci\xf3n al cliente",
        'Servizio clienti',
        "Servi\xe7o de apoio ao cliente",
        "Z\xe1kaznick\xfd servis",
        "Z\xe1kazn\xedcky servis",
        "\xdcgyf\xe9lszolg\xe1lati",
        "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
        "\u5BA2\u6237\u670D\u52A1",
        "\u9867\u5BA2\u670D\u52D9",
        "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
    ],
    [$bea62c923aa19b28$export$d7de553940261eba]: [
        'Assistenza IT',
        "BT Deste\u011Fi",
        "H\u1ED7 tr\u1EE3 CNTT",
        'IT',
        'IT Support',
        'IT podpora',
        "IT \u30B5\u30DD\u30FC\u30C8",
        "IT \u652F\u6301",
        "IT \u652F\u63F4",
        "IT \uC9C0\uC6D0",
        'IT_Support',
        "IT_st\xf8tte",
        'IT_support',
        'IT_tugi',
        'IT_tuki',
        "Informatikai t\xe1mogat\xe1si",
        'Soporte de TI',
        'Suporte de TI',
        "Support\xa0IT",
        'Wsparcie IT',
        "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
        "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
    ],
    [$bea62c923aa19b28$export$3950f7f841bf94b6]: [
        'Ekonomi',
        'Finance',
        'Financeiro',
        'Financie',
        'Finans',
        'Finanse',
        'Finants',
        'Finanza',
        'Finanzas',
        'Finanzen',
        "Finan\xe7as",
        "P\xe9nz\xfcgyi",
        'Rahoitus',
        "T\xe0i ch\xednh",
        "\xd8konomi",
        "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
        "\u8CA1\u52D9",
        "\u91D1\u878D",
        "\uC7AC\uBB34"
    ],
    [$bea62c923aa19b28$export$4c29d0d04c15e55d]: [
        'HR',
        "Henkil\xf6st\xf6hallinto",
        'Human Resources',
        'Human resources',
        'human-resources',
        "Lidsk\xe9 zdroje",
        'Menneskelige ressourcer',
        "Nh\xe2n s\u1EF1",
        'Personal',
        "Personalfr\xe5gor",
        'RH',
        'Recursos Humanos',
        'Recursos humanos',
        'Risorse umane',
        "Szem\xe9lyzeti",
        'Zasoby ludzkie',
        "\u0130nsan Kaynaklar\u0131",
        "\u013Dudsk\xe9 zdroje",
        "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
        "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
        "\u4EBA\u4E8B",
        "\u4EBA\u529B\u8CC7\u6E90",
        "\u4EBA\u529B\u8D44\u6E90",
        "\uC778\uC0AC"
    ],
    [$bea62c923aa19b28$export$881249b988b6030f]: [
        "Departamento jur\xeddico",
        'Hukuk',
        'Jogi',
        'Jura',
        'Juridik',
        'Juridisk',
        "Jur\xeddico",
        'Legal',
        'Legale',
        'Oikeudelliset asiat',
        "Ph\xe1p l\xfd",
        'Prawo',
        "Pr\xe1vne oddelenie",
        "Pr\xe1vn\xed odd\u011Blen\xed",
        'Rechtliches',
        'Service juridique',
        "\xd5igus",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
        "\u6CD5\u52D9",
        "\u6CD5\u5F8B",
        "\uBC95\uB960"
    ],
    [$bea62c923aa19b28$export$e4824f74b9879164]: [
        "Markedsf\xf8ring",
        'Marketing',
        'Markkinointi',
        "Marknadsf\xf6ring",
        'Pazarlama',
        "Ti\u1EBFp th\u1ECB",
        'Turundus',
        "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
        "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
        "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
        "\u8425\u9500",
        "\u884C\u92B7",
        "\uB9C8\uCF00\uD305"
    ],
    [$bea62c923aa19b28$export$4f3cb0844009af52]: [
        'Drift',
        'Haldus',
        'Operacional',
        'Operaciones',
        'Operacje',
        'Operasyonlar',
        'Operations',
        'Operativer Betrieb',
        'Operazioni',
        "Opera\xe7\xf5es",
        "Op\xe9rations",
        "Prev\xe1dzka",
        'Provoz',
        'Toiminnot',
        "V\u1EADn h\xe0nh",
        "\xdczemeltet\xe9si",
        "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
        "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "\u71DF\u904B",
        "\u8FD0\u8425",
        "\uC6B4\uC601"
    ],
    [$bea62c923aa19b28$export$1a65d50c4a641bb4]: [
        "B\xe1n h\xe0ng",
        "F\xf6rs\xe4ljning",
        'Myynti',
        "M\xfc\xfck",
        'Predaj',
        'Prodej',
        'Sales',
        'Salg',
        "Sat\u0131\u015F",
        "Sprzeda\u017C",
        'Vendas',
        'Vendite',
        'Ventas',
        'Ventes',
        'Vertrieb',
        "\xc9rt\xe9kes\xedt\xe9si",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
        "\u30BB\u30FC\u30EB\u30B9",
        "\u92B7\u552E",
        "\u9500\u552E",
        "\uC601\uC5C5"
    ],
    [$bea62c923aa19b28$export$b8b1ac856ba1434b]: [
        'Desarrollo de software',
        'Desenvolvimento de software',
        "D\xe9veloppement logiciel",
        'Ohjelmistokehitys',
        "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
        'Programutveckling',
        'Programvareutvikling',
        'Software Development',
        'Softwareentwicklung',
        'Softwareontwikkeling',
        'Softwareudvikling',
        'Sviluppo software',
        "Szoftverfejleszt\u0151",
        'Tarkvaraarendus',
        'Tworzenie oprogramowania',
        "V\xfdvoj softv\xe9ru",
        "V\xfdvoj softwaru",
        "Yaz\u0131l\u0131m Geli\u015Ftirme",
        "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
        "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
        "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
        "\u8EDF\u9AD4\u958B\u767C",
        "\u8F6F\u4EF6\u5F00\u53D1",
        "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
    ]
};
const $bea62c923aa19b28$var$BUSINESS_TEAM_TYPES = [
    $bea62c923aa19b28$export$4c29d0d04c15e55d,
    $bea62c923aa19b28$export$3950f7f841bf94b6,
    $bea62c923aa19b28$export$881249b988b6030f,
    $bea62c923aa19b28$export$e4824f74b9879164,
    $bea62c923aa19b28$export$4f3cb0844009af52,
    $bea62c923aa19b28$export$1a65d50c4a641bb4,
    $bea62c923aa19b28$export$b8b1ac856ba1434b
];
const $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE = {
    [$bea62c923aa19b28$export$4c29d0d04c15e55d]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$3950f7f841bf94b6]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$881249b988b6030f]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$e4824f74b9879164]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$4f3cb0844009af52]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$1a65d50c4a641bb4]: [
        $bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE
    ],
    [$bea62c923aa19b28$export$b8b1ac856ba1434b]: [
        $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER
    ]
};
const $bea62c923aa19b28$var$getNormalizedEntryNew = (userSegValue)=>{
    const lowerCaseUserSegValue = userSegValue.toLowerCase();
    return Object.entries($bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, translatedValues])=>translatedValues.map((v)=>v.toLowerCase()).includes(lowerCaseUserSegValue));
};
const $bea62c923aa19b28$var$getNormalizedEntry = (value)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries($bea62c923aa19b28$var$USER_SEGMENTATION_CLIENT_MAPPING).find(([, translatedValues])=>translatedValues.includes(value));
const $bea62c923aa19b28$export$d0bc507f0556398 = (value)=>{
    if (value === '') return $bea62c923aa19b28$export$4c9a72dac5ce80ae;
    const normalizedEntry = (0, $1ybV0.ff)('use-upaas-to-display-template-picker-if-user-seg-is-unknown') ? $bea62c923aa19b28$var$getNormalizedEntryNew(value) : $bea62c923aa19b28$var$getNormalizedEntry(value);
    return normalizedEntry !== undefined ? normalizedEntry[0] : $bea62c923aa19b28$export$2f3f9640393bd078;
};
class $bea62c923aa19b28$var$SkipSentryError extends Error {
    constructor(message){
        super(message);
        this.skipSentry = true;
    }
}
const $bea62c923aa19b28$var$fireAnalyticsError = ({ id: id, field: field, error: error, unMatchedValue: unMatchedValue })=>{
    (0, $guiFP.default)({
        meta: {
            id: id,
            packageName: 'jiraOnboardingCore'
        },
        attributes: {
            field: field,
            unMatchedValue: unMatchedValue
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $bea62c923aa19b28$export$af8a28b856b3556f = (teamType)=>{
    if (!teamType) return false;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'isInSoftwareTeam',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    return normalizedTeamType === $bea62c923aa19b28$export$b8b1ac856ba1434b;
};
const $bea62c923aa19b28$export$517f94ab07724226 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $bea62c923aa19b28$export$d0bc507f0556398(role);
    if (normalizedRole === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToBusinessUserSegCategory',
        field: 'role',
        error: new $bea62c923aa19b28$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'UserSegmentationTeamTypes'.
    const isTeamTypeEligible = $bea62c923aa19b28$var$BUSINESS_TEAM_TYPES.includes(normalizedTeamType);
    const isRoleEligible = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes($bea62c923aa19b28$var$ALL_ROLES_ELIGIBLE) || // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<UserSegmentationTeamTypes, UserSegmentationRoleTypes[]>>'.
    $bea62c923aa19b28$var$BUSINESS_ROLES_PER_TEAM_TYPE[normalizedTeamType]?.includes(normalizedRole);
    return isTeamTypeEligible && isRoleEligible;
};
const $bea62c923aa19b28$export$6710e0127706b297 = (userAccountData)=>{
    const { teamType: teamType = '', role: role = '' } = userAccountData;
    const normalizedTeamType = $bea62c923aa19b28$export$d0bc507f0556398(teamType);
    if (normalizedTeamType === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'teamType',
        error: new $bea62c923aa19b28$var$SkipSentryError('teamType mapping is not found'),
        unMatchedValue: teamType
    });
    const normalizedRole = $bea62c923aa19b28$export$d0bc507f0556398(role);
    if (normalizedRole === $bea62c923aa19b28$export$2f3f9640393bd078) $bea62c923aa19b28$var$fireAnalyticsError({
        id: 'userBelongsToSoftwareUserSegCategory',
        field: 'role',
        error: new $bea62c923aa19b28$var$SkipSentryError('role mapping is not found'),
        unMatchedValue: role
    });
    const isTeamTypeEligible = normalizedTeamType === $bea62c923aa19b28$export$b8b1ac856ba1434b;
    const isRoleEligible = normalizedRole !== $bea62c923aa19b28$var$USER_SEGMENTATION_ROLE_DESIGNER;
    return isTeamTypeEligible && isRoleEligible;
};

});


parcelRegister("l1u3T", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingM2ExperimentFlagEnabled", () => $e0f085336195173f$export$4f4879e3b4202c87);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");
const $e0f085336195173f$export$4f4879e3b4202c87 = ()=>{
    const defaultValue = (0, $eI5EY.fg)('tailored_onboarding_m2_content_exposure_adjust') ? undefined : false;
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_tailored_onboarding_jtbd');
    return expConfig.get('isEnabled', defaultValue);
};

});


parcelRegister("105cx", function(module, exports) {

$parcel$export(module.exports, "useRegisterNudgeTarget", () => $4897a924f3a2c5b3$export$eb8a96124d659f2d);
$parcel$export(module.exports, "PortalledNudge", () => $4897a924f3a2c5b3$export$74f8d45d75dfda4f);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $9WJJx = parcelRequire("9WJJx");
/**
 * This class tracks nudge target HTML DOM elements by ID.
 * It also tracks subscribers to updates of these elements.
 */ class $4897a924f3a2c5b3$var$NudgeController {
    static{
        /**
	 * Singleton instance of this class.
	 * Alternatively multiple instances would be created and passed through context.
	 */ this.instance = new $4897a924f3a2c5b3$var$NudgeController();
    }
    /**
	 * Register the HTML DOM node for an ID
	 */ registerNudgeTarget(id, ref) {
        this.nudgeTargetsMap.set(id, ref);
        this.notifySubscribers(id);
        // Return a cleanup function that will remove this ID from the map
        return ()=>{
            this.nudgeTargetsMap.delete(id);
        };
    }
    /**
	 * Subscribe to updates to a certain DOM node
	 */ subscribe(id, callback) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.push(callback);
        this.subscribers.set(id, subscribers);
        // Return a cleanup function that will remove this callback from the list of subscribers
        return ()=>{
            const subscribersOnCleanup = this.subscribers.get(id) ?? [];
            this.subscribers.set(id, subscribersOnCleanup.filter((cb)=>cb !== callback));
        };
    }
    /**
	 * Notify subscribers that the HTML DOM node for an ID has been updated.
	 */ notifySubscribers(id) {
        const subscribers = this.subscribers.get(id) ?? [];
        subscribers.forEach((subscriber)=>{
            subscriber();
        });
    }
    constructor(){
        this.nudgeTargetsMap = new Map();
        this.subscribers = new Map();
    }
}
/**
 * Return the singleton controller
 */ const $4897a924f3a2c5b3$var$useNudgeController = ()=>$4897a924f3a2c5b3$var$NudgeController.instance;
const $4897a924f3a2c5b3$export$eb8a96124d659f2d = (id, shouldRegister = true)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (shouldRegister) {
            const unregister = controller.registerNudgeTarget(id, ref);
            return ()=>{
                unregister();
            };
        }
    }, [
        controller,
        id,
        shouldRegister
    ]);
    return {
        ref: ref
    };
};
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $4897a924f3a2c5b3$var$useHasNudgeTargetNode = (id)=>{
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const [hasRefValue, setHasRefValue] = (0, $eUqFw.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $4897a924f3a2c5b3$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $eUqFw.useState)(null);
    const frameId = (0, $eUqFw.useRef)(null);
    const controller = $4897a924f3a2c5b3$var$useNudgeController();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $4897a924f3a2c5b3$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            nudgeContainer.current = document.createElement('div');
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $4897a924f3a2c5b3$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $4897a924f3a2c5b3$var$usePortalContainer();
    const hasRefValue = $4897a924f3a2c5b3$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $4897a924f3a2c5b3$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $eUqFw.useRef)(innerRectangle);
    const spotlightRef = (0, $eUqFw.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $eUqFw.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9WJJx.NudgeSpotlight), {
        ...props,
        ref: spotlightRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: innerRectangle.height,
            width: innerRectangle.width
        }
    }))), nudgeContainer.current);
};

});

parcelRegister("8ZFO4", function(module, exports) {

$parcel$export(module.exports, "InviteTeamNudgeAsync", () => $77203fa7077d439b$export$a4b4061b22dbc897);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");


var $5cLMB = parcelRequire("5cLMB");


var $fSS7i = parcelRequire("fSS7i");
const $77203fa7077d439b$var$runtimeProps = {};
const $77203fa7077d439b$var$entryPointParams = {};
const $77203fa7077d439b$export$a4b4061b22dbc897 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $fSS7i.inviteTeamNudgeEntryPoint), $77203fa7077d439b$var$entryPointParams);
    const [nudgeStep] = (0, $5cLMB.useNudgeStep)();
    const [hasNudgeActive] = (0, $5cLMB.useHasNudgeActive)();
    const firstLoadRef = (0, $eUqFw.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $8379f5d78bf6fb5a$export$77bc79debbf5c069)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$3bc551fe07069f89),
        packageName: "jiraInviteTeamOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $77203fa7077d439b$var$runtimeProps
    });
};

});
const $99a775c02d636a41$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $99a775c02d636a41$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $99a775c02d636a41$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $99a775c02d636a41$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $99a775c02d636a41$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $99a775c02d636a41$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $99a775c02d636a41$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $99a775c02d636a41$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $99a775c02d636a41$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $99a775c02d636a41$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $99a775c02d636a41$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $99a775c02d636a41$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $99a775c02d636a41$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $99a775c02d636a41$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $99a775c02d636a41$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $99a775c02d636a41$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $99a775c02d636a41$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $99a775c02d636a41$export$4d6567e7ee0281bf = 'asyncManageProjectsNudge';
const $99a775c02d636a41$export$f8bf435a6066832c = 'button clicked';
const $99a775c02d636a41$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $99a775c02d636a41$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $99a775c02d636a41$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $99a775c02d636a41$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $99a775c02d636a41$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $99a775c02d636a41$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $99a775c02d636a41$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $99a775c02d636a41$export$5908fa8acd2c0739 = 'filterListNudge';
const $99a775c02d636a41$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $99a775c02d636a41$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $99a775c02d636a41$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $99a775c02d636a41$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $99a775c02d636a41$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $99a775c02d636a41$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $99a775c02d636a41$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $99a775c02d636a41$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $99a775c02d636a41$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $99a775c02d636a41$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $99a775c02d636a41$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $99a775c02d636a41$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $99a775c02d636a41$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $99a775c02d636a41$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $99a775c02d636a41$export$a1be34032ee24f78 = 'shareProjectNudge';
const $99a775c02d636a41$export$29fe6611cc093756 = 'summaryTabNudge';
const $99a775c02d636a41$export$f107c06c0830f09d = 'reportsTabNudge';
const $99a775c02d636a41$export$9749a972a54ad7ba = 'boardContainerNudge';

parcelRegister("fSS7i", function(module, exports) {

$parcel$export(module.exports, "inviteTeamNudgeEntryPoint", () => $7ee3503d9bc55fd6$export$ff76bc343b4103b1);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $7ee3503d9bc55fd6$export$ff76bc343b4103b1 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("llBoV")), {
        moduleId: "4ca4d8af"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("llBoV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8nQSH").then(()=>parcelRequire('c1S71'));

});



parcelRegister("3K78m", function(module, exports) {

$parcel$export(module.exports, "NavigationPeopleNavItemWrapperNudgeAsync", () => $e174e45e15d1fc02$export$57ea67608b7cb448);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e174e45e15d1fc02$var$NavigationPeopleNavItemLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("3HpRq")).then((exportedModule)=>exportedModule.NavigationPeopleNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-people/index.tsx"
});
const $e174e45e15d1fc02$export$57ea67608b7cb448 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $8379f5d78bf6fb5a$export$b74a8fdb2c75b869),
        fallback: children,
        attributes: {
            nudgeId: (0, $8379f5d78bf6fb5a$export$b74a8fdb2c75b869)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "navigation-people-nav-item-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e174e45e15d1fc02$var$NavigationPeopleNavItemLazy, {
        nudgeId: (0, $8379f5d78bf6fb5a$export$b74a8fdb2c75b869),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("3HpRq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2IDHF").then(()=>parcelRequire('b4FpA'));

});


parcelRegister("eXtUa", function(module, exports) {

$parcel$export(module.exports, "useBrowseUsersGroupsPermissionsNext", () => $ac7fdc7a19db38ab$export$f16858a6f1359756);
$parcel$export(module.exports, "useBrowseUsersGroupsPermissions", () => $ac7fdc7a19db38ab$export$c12f7f185a3a245f);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $h3mHU = parcelRequire("h3mHU");
const $ac7fdc7a19db38ab$var$deferredPromise = ()=>{
    const deferred = {
        resolve: undefined,
        reject: undefined
    };
    const promise = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        // @ts-expect-error - TS2322 - Type '(result: boolean) => void' is not assignable to type 'undefined'.
        deferred.resolve = (result)=>{
            resolve(result);
        };
        // @ts-expect-error - TS2322 - Type '(error?: any) => void' is not assignable to type 'undefined'.
        deferred.reject = reject;
    });
    return {
        promise: promise,
        ...deferred
    };
};
class $ac7fdc7a19db38ab$var$BrowseUsersGroupsCacheClient {
    fetch() {
        const requestUrl = '/rest/internal/latest/userPermission/browseUsersGroups';
        if (this.promise !== null) return this.promise;
        this.promise = (0, $lRmyA.performGetRequest)(requestUrl);
        return this.promise;
    }
    constructor(){
        this.promise = null;
    }
}
const $ac7fdc7a19db38ab$var$client = new $ac7fdc7a19db38ab$var$BrowseUsersGroupsCacheClient();
const $ac7fdc7a19db38ab$export$f16858a6f1359756 = (force)=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [{ promise: promise, resolve: resolve, reject: reject }] = (0, $eUqFw.useState)($ac7fdc7a19db38ab$var$deferredPromise());
    (0, $eUqFw.useEffect)(()=>{
        if ((isReady || force) && (0, $eI5EY.fg)('dont-auto-close-people-menu')) $ac7fdc7a19db38ab$var$client.fetch().then(resolve).catch(reject);
    }, [
        isReady,
        reject,
        resolve,
        force
    ]);
    return (0, $eUqFw.useCallback)(()=>promise, [
        promise
    ]);
};
const $ac7fdc7a19db38ab$export$c12f7f185a3a245f = ()=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [{ promise: promise, resolve: resolve, reject: reject }] = (0, $eUqFw.useState)($ac7fdc7a19db38ab$var$deferredPromise());
    (0, $eUqFw.useEffect)(()=>{
        if (isReady && !(0, $eI5EY.fg)('dont-auto-close-people-menu')) {
            const requestUrl = '/rest/internal/latest/userPermission/browseUsersGroups';
            (0, $lRmyA.performGetRequest)(requestUrl).then(resolve).catch(reject);
        }
    }, [
        isReady,
        reject,
        resolve
    ]);
    return (0, $eUqFw.useCallback)(()=>promise, [
        promise
    ]);
};

});

parcelRegister("5Jczu", function(module, exports) {

$parcel$export(module.exports, "useTPAExperiment", () => $420f50728b605a4b$export$f72f7a0d0e0f9566);

var $eUqFw = parcelRequire("eUqFw");

var $hzKLE = parcelRequire("hzKLE");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $420f50728b605a4b$export$f72f7a0d0e0f9566 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { value: value, explanation: explanation } = (0, $hzKLE.getFeatureFlagClient)().getFlagEvaluation('confluence.frontend.growth.team-product-access', {
        default: false
    });
    const reason = explanation?.kind ?? '';
    return (0, $eUqFw.useMemo)(()=>({
            enabled: value,
            reason: reason,
            fireFeatureExposed: ()=>{
                const event = createAnalyticsEvent({});
                const cohort = value ? 'variation' : 'not-enrolled';
                event.context.push({
                    source: 'team-create-dialog',
                    tags: [
                        'people-teams'
                    ]
                });
                (0, $jMP2a.fireTrackAnalytics)(event, 'feature exposed', {
                    flagKey: 'confluence.frontend.growth.team-product-access',
                    cohort: !value && reason === 'RULE_MATCH' ? 'control' : cohort,
                    value: value,
                    reason: reason
                });
            },
            growthHoldoutCohort: 'variation'
        }), [
        createAnalyticsEvent,
        reason,
        value
    ]);
};

});

parcelRegister("d5ydC", function(module, exports) {

$parcel$export(module.exports, "getInvitedJswUsers", () => $0e33ff918f2f84dc$export$4b81d3bf9fd2c126);

var $guiFP = parcelRequire("guiFP");


var $huI7r = parcelRequire("huI7r");

const $0e33ff918f2f84dc$export$4b81d3bf9fd2c126 = (inviteUsersResponse)=>{
    try {
        if (inviteUsersResponse.status === 'fulfilled' && inviteUsersResponse.value.responseStatus === 'success' && 'invited' in inviteUsersResponse.value.response) {
            const invitedUsers = inviteUsersResponse.value.response.invited;
            return invitedUsers.filter((invitedUser)=>{
                const productInvites = Object.keys(invitedUser.results);
                return productInvites.some((invite)=>{
                    const ari = (0, $huI7r.toAri)(invite);
                    return ari ? (0, $huI7r.getAriConfig)(ari).resourceOwner === (0, $2edfd53057852e41$export$1346c9aa3cbb477d) && invitedUser.results[invite] === 'INVITED' : false;
                });
            });
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $guiFP.default)({
            error: e,
            meta: {
                id: 'getInvitedJswUsers',
                packageName: (0, $556d3824e23bb4a1$export$b8b9d90f9e5bd72b),
                teamName: 'growth-tako'
            }
        });
    }
    return [];
};

});




parcelRegister("h3RP9", function(module, exports) {

$parcel$export(module.exports, "Plans", () => $aea57f55d8da60da$export$fa027c23da0a12ea);
$parcel$export(module.exports, "OpenOverflowMenuForPlansSpotlightObserver", () => $aea57f55d8da60da$export$c741bc6980da6a32);

var $eUqFw = parcelRequire("eUqFw");

var $cTgSO = parcelRequire("cTgSO");

var $arAkG = parcelRequire("arAkG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7vTKl = parcelRequire("7vTKl");

var $7dRgX = parcelRequire("7dRgX");

var $5cLMB = parcelRequire("5cLMB");

var $j67d5 = parcelRequire("j67d5");

var $hawmT = parcelRequire("hawmT");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $5H3md = parcelRequire("5H3md");

var $bAd0L = parcelRequire("bAd0L");

var $lH99V = parcelRequire("lH99V");

var $hWWq9 = parcelRequire("hWWq9");

var $lPdxt = parcelRequire("lPdxt");

var $caEIA = parcelRequire("caEIA");
const $aea57f55d8da60da$var$PlansDropdown = ()=>{
    const [isPlansVisible] = (0, $hawmT.useNavigationPlansVisibility)();
    const [{ hasFetchedOnce: hasFetchedOncePlans }, { loadFavoritePlans: loadFavorite }] = (0, $arAkG.useFavoritePlans)();
    const [{ hasSuccessOnce: hasSuccessOnce }, { load: load }] = (0, $j67d5.usePlansItems)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isStandardOrFree = (0, $lH99V.useIsStandardOrFreeJSW)();
    // Initialise items data
    (0, $eUqFw.useEffect)(()=>{
        !hasSuccessOnce && !isStandardOrFree && isPlansVisible && load();
    }, [
        hasSuccessOnce,
        load,
        isPlansVisible,
        isStandardOrFree
    ]);
    // Keep items data fresh
    const onBeforeMenuOpen = (0, $eUqFw.useCallback)(()=>{
        if (!isStandardOrFree) {
            load();
            if (!hasFetchedOncePlans) loadFavorite((0, $5kDtB.DEFAULT_LOAD_COUNT_FAV));
        }
    }, // We dont care about hasFetchedOncePlans, it will generate a new call back which then closes the popup
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        load,
        loadFavorite
    ]);
    if (!isPlansVisible) return null;
    /**
   * Cannot do <Popup ... MenuTrigger={MenuTrigger} /> because
   * Popup passes exact common MenuTrigger props which doesn't have DI components
   * that makes Flow complains about props passing to customized MenuTrigger
   * */ // @ts-expect-error - TS2322 - Type '((instance: unknown) => void) | MutableRefObject<unknown> | null' is not assignable to type 'Ref<MenuTriggerProps> | undefined'.
    // FIXME: Navigation should fix that by extracting the forwarded component
    // eslint-disable-next-line react/no-unstable-nested-components
    const FinalMenuTrigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hWWq9.MenuTrigger), {
            ...props,
            ref: ref
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5H3md.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bAd0L.Popup), {
        menuId: (0, $7vTKl.MENU_ID).PLANS,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).PLANS,
        Menu: (0, $lPdxt.default),
        // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'ComponentType<MenuTriggerProps> | undefined'.
        MenuTrigger: FinalMenuTrigger,
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $caEIA.default).plans)
    }, formatMessage((0, $caEIA.default).plans)));
};
const $aea57f55d8da60da$export$fa027c23da0a12ea = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).PLANS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aea57f55d8da60da$var$PlansDropdown, null));
const $aea57f55d8da60da$export$c741bc6980da6a32 = ()=>{
    const [isPlansVisible] = (0, $hawmT.useNavigationPlansVisibility)();
    const [shouldShow] = (0, $5cLMB.useShouldShowNudge)({
        itemNames: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK)
        ]
    });
    const WRAPPER_UID = 'plans-spotlight-target-wrapper';
    const spotlightVisible = !false && document.querySelector(`[data-uid="${WRAPPER_UID}"]`) != null;
    const { openOverflowMenu: openOverflowMenu } = (0, $cTgSO.useOverflowStatus)();
    (0, $eUqFw.useEffect)(()=>{
        isPlansVisible && shouldShow && !spotlightVisible && openOverflowMenu();
    }, [
        isPlansVisible,
        openOverflowMenu,
        shouldShow,
        spotlightVisible
    ]);
    return null;
};

});
parcelRegister("lH99V", function(module, exports) {

$parcel$export(module.exports, "useIsStandardOrFreeJSW", () => $480371a2427929f1$export$5edaea31b41b30b);

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
const $480371a2427929f1$export$a2bbf41e67157372 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    const jswEdition = appEditions ? (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $6WXNs.STANDARD_EDITION);
};
const $480371a2427929f1$export$a55cc88b2381611c = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    const jswEdition = appEditions ? (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $6WXNs.FREE_EDITION);
};
const $480371a2427929f1$export$5edaea31b41b30b = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    const jswEdition = appEditions ? (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions) : undefined;
    return jswEdition === (0, $6WXNs.STANDARD_EDITION) || jswEdition === (0, $6WXNs.FREE_EDITION);
};

});

parcelRegister("hWWq9", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $fb09da40c35ad9ea$export$27d2ad3c5815583e);

var $eUqFw = parcelRequire("eUqFw");

var $olGf9 = parcelRequire("olGf9");

var $918P7 = parcelRequire("918P7");
const $fb09da40c35ad9ea$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $918P7.MenuTrigger), {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $olGf9.MenuTrigger), {
        ...props,
        ref: ref
    });
});

});
parcelRegister("918P7", function(module, exports) {

$parcel$export(module.exports, "MenuTrigger", () => $8f349fc88a6283b5$export$27d2ad3c5815583e);

var $eUqFw = parcelRequire("eUqFw");

var $55pTl = parcelRequire("55pTl");

var $cTgSO = parcelRequire("cTgSO");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $7vTKl = parcelRequire("7vTKl");

var $3BTZc = parcelRequire("3BTZc");

var $7dRgX = parcelRequire("7dRgX");

var $5cLMB = parcelRequire("5cLMB");

var $j67d5 = parcelRequire("j67d5");

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $4LQ2W = parcelRequire("4LQ2W");

var $4RZTD = parcelRequire("4RZTD");

var $ab6rA = parcelRequire("ab6rA");

var $olGf9 = parcelRequire("olGf9");

var $5ZWbT = parcelRequire("5ZWbT");
const $8f349fc88a6283b5$var$WRAPPER_UID = 'plans-spotlight-target-wrapper';
const $8f349fc88a6283b5$var$useDelayedSpotlight = ()=>{
    const [ready, setSpotlightReady] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>setSpotlightReady(true), 100);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return ready;
};
const $8f349fc88a6283b5$var$useWrapper = ()=>{
    const ref = (0, $eUqFw.useRef)(null);
    return {
        ref: ref
    };
};
const $8f349fc88a6283b5$var$state = {
    hasSpotlightShown: false,
    hasSpotlightDone: false
};
/**
 * The spotlight is forced closed on any click (outside of the menu), which is unexpected behavior
 * This hook will try to re-open the "More" dropdown when the "Plans" is unmounted until the user
 * clicks "Done" on the spotlight
 */ const $8f349fc88a6283b5$var$useSpotlightForceOpen = ()=>{
    const { isVisible: isVisible, openOverflowMenu: openOverflowMenu } = (0, $cTgSO.useOverflowStatus)();
    const isDropdownItem = !isVisible;
    (0, $eUqFw.useLayoutEffect)(()=>()=>{
            const updateState = ()=>{
                /**
				 * The actual wrapper is supposed to be unmounted, so, if there is
				 * another wrapper element, it must be the cloned one on the spotlight
				 */ const spotlightVisible = document.querySelector(`[data-uid="${$8f349fc88a6283b5$var$WRAPPER_UID}"]`) != null;
                /**
				 * The dropdown menu is required to remaining openned after clicking Done on the
				 * spotlight. So openOverflowMenu() will be called until state.hasSpotlightDone is true.
				 */ $8f349fc88a6283b5$var$state.hasSpotlightShown = $8f349fc88a6283b5$var$state.hasSpotlightShown || spotlightVisible;
                if (isDropdownItem && spotlightVisible && $8f349fc88a6283b5$var$state.hasSpotlightShown && !$8f349fc88a6283b5$var$state.hasSpotlightDone) openOverflowMenu();
                if ($8f349fc88a6283b5$var$state.hasSpotlightShown && !spotlightVisible) $8f349fc88a6283b5$var$state.hasSpotlightDone = true;
            };
            queueMicrotask(updateState);
        }, [
        isDropdownItem,
        openOverflowMenu
    ]);
};
const $8f349fc88a6283b5$export$56d544c4f479b7fb = ({ children: children, isVisible: isVisible })=>{
    const shouldShowNudge = (0, $4LQ2W.useCanShowQuickstartNudge)();
    return shouldShowNudge && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RZTD.NavigationPlansNavItemWrapperNudgeAsync), {
        isInsideMenu: !isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZWbT.FullHeightTextColorWrapper), null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $8f349fc88a6283b5$var$planOnboardingNudgeProps = !false ? {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
} : {};
const $8f349fc88a6283b5$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, triggerRef)=>{
    const wrapper = $8f349fc88a6283b5$var$useWrapper();
    const ready = $8f349fc88a6283b5$var$useDelayedSpotlight();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const jswEdition = appEditions ? (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), appEditions) : undefined;
    const [shouldShow] = (0, $5cLMB.useShouldShowNudge)({
        itemNames: [
            (0, $7dRgX.ADVANCED_ROADMAPS_TASK)
        ]
    });
    $8f349fc88a6283b5$var$useSpotlightForceOpen();
    const { isVisible: isVisible } = (0, $cTgSO.useOverflowStatus)();
    const [{ items: items }] = (0, $j67d5.usePlansItems)();
    const analyticsAttributes = {
        isAbleToCreateSamplePlan: !!items?.links?.createSamplePlan?.isVisible,
        ...jswEdition ? {
            jswEdition: jswEdition
        } : {}
    };
    const [isMenuOpen, { toggle: toggleMenu }] = (0, $3BTZc.useTopMenus)((0, $7vTKl.MENU_ID).PLANS);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldShow && !isMenuOpen) toggleMenu();
    }, [
        isMenuOpen,
        shouldShow,
        toggleMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        backgroundColor: "color.background.neutral.subtle",
        xcss: $8f349fc88a6283b5$var$triggerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "nav-advanced-roadmaps-plans-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        "data-uid": $8f349fc88a6283b5$var$WRAPPER_UID,
        ref: wrapper.ref,
        backgroundColor: "color.background.neutral.subtle",
        xcss: $8f349fc88a6283b5$var$triggerWrapperStyles,
        ...$8f349fc88a6283b5$var$planOnboardingNudgeProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f349fc88a6283b5$export$56d544c4f479b7fb, {
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $olGf9.MenuTrigger), {
        ref: triggerRef,
        analyticsAttributes: analyticsAttributes,
        ...props
    })))), ready && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        engagementId: "nav-advanced-roadmaps-plans-spotlight"
    })));
});
const $8f349fc88a6283b5$var$triggerWrapperStyles = (0, $1ZAYh.xcss)({
    height: '100%',
    display: 'flex',
    flexGrow: 1
});

});
parcelRegister("4RZTD", function(module, exports) {

$parcel$export(module.exports, "NavigationPlansNavItemWrapperNudgeAsync", () => $f34ba548404c3285$export$e2e248a8ac2b2891);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f34ba548404c3285$var$NavigationPlansNavItemLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("3gJqA")).then((exportedModule)=>exportedModule.NavigationPlansNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-plans/index.tsx"
});
const $f34ba548404c3285$export$e2e248a8ac2b2891 = ({ children: children, isInsideMenu: isInsideMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $8379f5d78bf6fb5a$export$46d9a3d441dfd22b),
        fallback: children,
        attributes: {
            nudgeId: (0, $8379f5d78bf6fb5a$export$46d9a3d441dfd22b)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-navigation-plans-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f34ba548404c3285$var$NavigationPlansNavItemLazy, {
        nudgeId: (0, $8379f5d78bf6fb5a$export$46d9a3d441dfd22b),
        isInsideMenu: isInsideMenu
    }, children)));

});
parcelRegister("3gJqA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iS6GR").then(()=>parcelRequire('l3717'));

});




parcelRegister("lPdxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa3a503ec4ad9cd7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");

var $lpndH = parcelRequire("lpndH");

var $fR7xb = parcelRequire("fR7xb");

var $kwMhr = parcelRequire("kwMhr");

var $0cdA8 = parcelRequire("0cdA8");

var $arAkG = parcelRequire("arAkG");

var $7vTKl = parcelRequire("7vTKl");

var $1YbJP = parcelRequire("1YbJP");

var $gGtKh = parcelRequire("gGtKh");

var $5kDtB = parcelRequire("5kDtB");

var $7VDWq = parcelRequire("7VDWq");

var $gIh7l = parcelRequire("gIh7l");

var $j5uqN = parcelRequire("j5uqN");

var $43NDK = parcelRequire("43NDK");

var $lH99V = parcelRequire("lH99V");

var $bGTXT = parcelRequire("bGTXT");

var $fLoH2 = parcelRequire("fLoH2");

var $2gCsN = parcelRequire("2gCsN");

var $6Jfez = parcelRequire("6Jfez");

var $a5Xcg = parcelRequire("a5Xcg");

var $biciv = parcelRequire("biciv");
const $fa3a503ec4ad9cd7$var$EVENT_DATA = {
    id: (0, $7vTKl.MENU_ID).PLANS
};
const $fa3a503ec4ad9cd7$var$Menu = ({ ActionFooter: ActionFooter = (0, $bGTXT.ActionFooter), AdminFooter: AdminFooter = (0, $fLoH2.AdminFooter), Content: Content = (0, $2gCsN.default), FavoriteContent: // @ts-expect-error - TS2339 - Property 'FavoriteContent' does not exist on type 'MenuProps'.
FavoriteContent = (0, $6Jfez.FavoriteContent), Error: Error = (0, $7VDWq.MenuError), JSErrorBoundary: JSErrorBoundary = (0, $0cdA8.JSErrorBoundary), Layout: Layout = (0, $gIh7l.MenuLayout), LoadStatus: LoadStatus = (0, $a5Xcg.LoadStatus), Section: Section = (0, $8BKky.default), SkeletonContent: SkeletonContent = (0, $j5uqN.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $43NDK.MenuSkeletonFooter), ViewExperienceSuccessTracker: ViewExperienceSuccessTracker = (0, $kwMhr.ExperienceSuccessTracker), testIdPrefix: testIdPrefix, useFavorite: // @ts-expect-error - TS2339 - Property 'useFavorite' does not exist on type 'MenuProps'.
useFavorite = (0, $arAkG.useFavoritePlans) })=>{
    const [, { loadFavoritePlans: loadFavorite }] = useFavorite();
    const contentTestId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'content');
    const actionFooterTestId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'action-footer');
    const adminFooterTestId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'admin-footer');
    const isStandardOrFree = (0, $lH99V.useIsStandardOrFreeJSW)();
    const { isSpotlightVisible: isSpotlightVisible } = (0, $lpndH.usePloverviewsSpotlightState)();
    const errorFallback = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Error, {
            testIdPrefix: contentTestId
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentTestId
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            !isStandardOrFree && loadFavorite((0, $5kDtB.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite,
        isStandardOrFree
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(JSErrorBoundary, {
        id: (0, $7vTKl.MENU_ID).PLANS,
        packageName: (0, $5kDtB.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $fa3a503ec4ad9cd7$var$EVENT_DATA
    }, isStandardOrFree ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $biciv.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "plans-menu-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonContent, {
            testIdPrefix: contentTestId
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewExperienceSuccessTracker, {
        location: "atlassian-navigation--primary-actions--plans--menu-popup--content",
        failureEventAttributes: null,
        parentProviders: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FavoriteContent, {
        testIdPrefix: contentTestId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Content, {
        testIdPrefix: contentTestId
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "plans-menu-footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonFooter, {
            testIdPrefix: contentTestId
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ActionFooter, {
        testIdPrefix: actionFooterTestId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AdminFooter, {
        testIdPrefix: adminFooterTestId
    }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "nav-plans-menu"
    }, content, isSpotlightVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fR7xb.AsyncPlansOnboarding), null)));
};
var $fa3a503ec4ad9cd7$export$2e2bcd8739ae039 = $fa3a503ec4ad9cd7$var$Menu;

});
parcelRegister("lpndH", function(module, exports) {

$parcel$export(module.exports, "usePloverviewsSpotlightActions", () => $b0ac2da9f0e9edaa$export$81d754ec95525914);
$parcel$export(module.exports, "usePloverviewsSpotlightState", () => $b0ac2da9f0e9edaa$export$7bfe2272006c8b13);
$parcel$export(module.exports, "useShowPloverviewsSpotlight", () => $b0ac2da9f0e9edaa$export$26a833a9dcbf492a);

var $eUqFw = parcelRequire("eUqFw");

var $7vTKl = parcelRequire("7vTKl");

var $3BTZc = parcelRequire("3BTZc");

var $WBLbN = parcelRequire("WBLbN");
const $b0ac2da9f0e9edaa$var$PloverviewsSpotlightStore = (0, $WBLbN.createStore)({
    initialState: {
        isSpotlightVisible: false
    },
    actions: {
        showSpotlight: ()=>({ setState: setState })=>{
                setState({
                    isSpotlightVisible: true
                });
            },
        hideSpotlight: ()=>({ setState: setState })=>{
                setState({
                    isSpotlightVisible: false
                });
            }
    },
    name: 'PloverviewsSpotlightStore'
});
const $b0ac2da9f0e9edaa$export$81d754ec95525914 = (0, $WBLbN.createActionsHook)($b0ac2da9f0e9edaa$var$PloverviewsSpotlightStore);
const $b0ac2da9f0e9edaa$export$7bfe2272006c8b13 = (0, $WBLbN.createStateHook)($b0ac2da9f0e9edaa$var$PloverviewsSpotlightStore);
const $b0ac2da9f0e9edaa$export$26a833a9dcbf492a = ()=>{
    const [_, { on: openPlansMenu }] = (0, $3BTZc.useTopMenus)((0, $7vTKl.MENU_ID).PLANS);
    const { showSpotlight: showSpotlight } = $b0ac2da9f0e9edaa$export$81d754ec95525914();
    return (0, $eUqFw.useCallback)(()=>{
        openPlansMenu();
        showSpotlight();
    }, [
        openPlansMenu,
        showSpotlight
    ]);
};

});

parcelRegister("fR7xb", function(module, exports) {

$parcel$export(module.exports, "AsyncPlansOnboarding", () => $0a0f63a817240345$export$95374682e859aeb9);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $dhu6u = parcelRequire("dhu6u");
const $0a0f63a817240345$var$runtimeProps = {};
const $0a0f63a817240345$var$entryPointParams = {};
const $0a0f63a817240345$export$95374682e859aeb9 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $dhu6u.plansOnboardingEntrypoint), $0a0f63a817240345$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "overviews-plans-onboarding-spotlight",
        packageName: "jiraBusinessOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $0a0f63a817240345$var$runtimeProps
    });
};

});
parcelRegister("dhu6u", function(module, exports) {

$parcel$export(module.exports, "plansOnboardingEntrypoint", () => $e16371fd1a1a14af$export$416070deed84cd30);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $e16371fd1a1a14af$export$416070deed84cd30 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("eaIDq")).then((module)=>module.PlansOnboarding), {
        moduleId: "d53e714d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eaIDq", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dfBYz").then(()=>parcelRequire('cpyUX'));

});



parcelRegister("bGTXT", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $87539e389167e362$export$2d2b754ac238f9aa);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $j67d5 = parcelRequire("j67d5");

var $26yXe = parcelRequire("26yXe");

var $d0QLq = parcelRequire("d0QLq");

var $gN61g = parcelRequire("gN61g");

var $MK1Fw = parcelRequire("MK1Fw");

var $aF38d = parcelRequire("aF38d");
const $87539e389167e362$export$2d2b754ac238f9aa = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ items: items }] = (0, $j67d5.usePlansItems)();
    const isPlanListEmpty = (0, $aF38d.useIsPlanListEmpty)();
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'action-footer');
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $26yXe.useCreateNewPlanWizardDrawer)();
    const [, { open: openCreateSamplePlanModal }] = (0, $d0QLq.useCreateSamplePlan)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer
    ]);
    if (!items || !items.links) return null;
    const { links: links } = items;
    const { manageTeams: manageTeams, managePlans: managePlans, createPlan: createPlan, createSamplePlan: createSamplePlan } = links;
    // Delete manageTeams.isVisible and the corresponding menuItem when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
    const isAnyItemVisible = manageTeams.isVisible || managePlans.isVisible || createPlan.isVisible;
    if (!isAnyItemVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gN61g.MenuItem), {
        ...links.manageTeams,
        title: formatMessage((0, $MK1Fw.default).manageTeams),
        testIdPrefix: testIdPrefix
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gN61g.MenuItem), {
        ...links.managePlans,
        title: formatMessage((0, $MK1Fw.default).managePlans),
        testIdPrefix: testIdPrefix
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gN61g.MenuItem), {
        id: links.createPlan.id,
        isVisible: links.createPlan.isVisible && !isPlanListEmpty,
        title: formatMessage((0, $MK1Fw.default).createPlan),
        testIdPrefix: testIdPrefix,
        onClick: onClick
    }), createSamplePlan && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gN61g.MenuItem), {
        id: createSamplePlan.id,
        isVisible: createSamplePlan.isVisible && !isPlanListEmpty,
        title: formatMessage((0, $MK1Fw.default).createDemoPlan),
        testIdPrefix: testIdPrefix,
        onClick: openCreateSamplePlanModal
    }));
};

});
parcelRegister("26yXe", function(module, exports) {

$parcel$export(module.exports, "useCreateNewPlanWizardDrawer", () => $fce0b5f5d60fb0be$export$f3e7d3fc94eda89a);
$parcel$export(module.exports, "useImportedMessagesForLocale", () => $fce0b5f5d60fb0be$export$52303468eeac3ad0);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $WBLbN = parcelRequire("WBLbN");

var $75e8i = parcelRequire("75e8i");
const $fce0b5f5d60fb0be$var$CONTROLLER_NAME = 'create-new-plan-wizard-drawer';
const $fce0b5f5d60fb0be$var$initialState = {
    isOpen: false,
    plan: undefined
};
const $fce0b5f5d60fb0be$var$Store = (0, $WBLbN.createStore)({
    name: $fce0b5f5d60fb0be$var$CONTROLLER_NAME,
    initialState: $fce0b5f5d60fb0be$var$initialState,
    actions: {
        openDrawer: (plan)=>{
            if ((0, $eI5EY.fg)('add_analytic_to_create_plan')) (0, $75e8i.default)('arj-create-plan-wizard-drawer');
            return ({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan
                });
        },
        closeDrawer: ()=>({ setState: setState })=>setState({
                    isOpen: false,
                    plan: undefined
                })
    }
});
const $fce0b5f5d60fb0be$export$f3e7d3fc94eda89a = (0, $WBLbN.createHook)($fce0b5f5d60fb0be$var$Store);
const $fce0b5f5d60fb0be$export$9ec7b5762fb72de2 = (0, $WBLbN.createContainer)($fce0b5f5d60fb0be$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen, plan: plan })=>{
            setState({
                isOpen: isOpen,
                plan: plan
            });
        }
});
const $fce0b5f5d60fb0be$var$EXCLUDED_I18N_FILES = [
    'index',
    'languages',
    'en'
];
const $fce0b5f5d60fb0be$var$FALLBACK_INTL_MESSAGES = Object.freeze({});

const $fce0b5f5d60fb0be$export$19442c17ab279a67 = async (rawlocale = 'en')=>{
    // Filter out country code as the AFE i18n does not use them e.g en => en-US
    const locale = rawlocale.split('-')[0];
    if (!locale || $fce0b5f5d60fb0be$var$EXCLUDED_I18N_FILES.includes(locale)) return {
        default: $fce0b5f5d60fb0be$var$FALLBACK_INTL_MESSAGES
    };
    try {
        {
            // eslint-disable-next-line jira/import/webpack-magic-comment-entries
            const i18nModule = await (parcelRequire("eDlKe"));
            const result = i18nModule[locale]();
            return result;
        }
        // eslint-disable-next-line jira/import/webpack-magic-comment-entries
        const result = await import(`@atlassian/jira-portfolio-plan-wizard/dist/cjs/i18n/${locale}`);
        return result;
    } catch  {
        return {
            default: $fce0b5f5d60fb0be$var$FALLBACK_INTL_MESSAGES
        };
    }
};
const $fce0b5f5d60fb0be$export$52303468eeac3ad0 = ()=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    const [state, setState] = (0, $eUqFw.useState)({
        locale: locale,
        loading: true,
        intlMessages: undefined
    });
    (0, $eUqFw.useEffect)(()=>{
        let mounted = true;
        const load = async ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: true
                }));
            const { default: intlMessages } = await $fce0b5f5d60fb0be$export$19442c17ab279a67(locale);
            if (!mounted) return;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: false,
                    intlMessages: intlMessages
                }));
        };
        load();
        return ()=>{
            mounted = false;
        };
    }, [
        locale
    ]);
    return state;
};

});
parcelRegister("eDlKe", function(module, exports) {
module.exports = {};

});


parcelRegister("d0QLq", function(module, exports) {

$parcel$export(module.exports, "useCreateSamplePlan", () => $941848b62f4a3507$export$53d6fde96f096b86);
$parcel$export(module.exports, "CreateSamplePlanProvider", () => $941848b62f4a3507$export$88b99aa46c223622);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $WBLbN = parcelRequire("WBLbN");

var $iG4Rs = parcelRequire("iG4Rs");

var $crTvr = parcelRequire("crTvr");
const $941848b62f4a3507$var$CONTROLLER_NAME = 'create-sample-plan';
const $941848b62f4a3507$var$initialState = {
    /**
	 * This field controls modal dismissible status
	 */ isOpen: false,
    /**
	 * This field is only used to redirect the user to plan page if the modal is not closed.
	 */ planId: null,
    /**
	 * This field is used to detect the correct redirection creation session,
	 * without this field, we don't know which creation session needs to be redirected
	 * e.g. the user started multiple sample creation and stays on the last one - in this case,
	 * only the last creation needs to be redirected.
	 */ taskId: null,
    /**
	 * Progress of the ongoing task
	 */ progressPercentage: null,
    /**
	 * Once this field has been set to `true`, we'll know we can call the actions returned
	 * by our useCreateSamplePlan hook.
	 */ hasBeenInitialised: false
};
const $941848b62f4a3507$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            const nextState = (({ hasBeenInitialised: hasBeenInitialised, ...rest })=>rest)($941848b62f4a3507$var$initialState);
            setState(nextState);
        },
    setPlanId: (planId)=>({ setState: setState })=>{
            setState({
                planId: planId
            });
        },
    setTaskId: (taskId)=>({ setState: setState })=>{
            setState({
                taskId: taskId
            });
        },
    setProgressPercentage: (progressPercentage)=>({ setState: setState })=>{
            setState({
                progressPercentage: progressPercentage
            });
        },
    submitSamplePlan: ({ planName: planName, flags: { success: SuccessFlag, error: ErrorFlag } })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { showFlag: showFlag, redirectToPlan: redirectToPlan, leadAccountId: leadAccountId })=>{
            try {
                const taskId = await (0, $crTvr.createSamplePlanAsync)({
                    body: JSON.stringify({
                        title: planName,
                        leadAccountId: leadAccountId
                    })
                });
                setState({
                    taskId: taskId
                });
                const response = await (0, $crTvr.pollCreateSamplePlan)(taskId, (progressPercentage)=>{
                    const { taskId: latestTaskId } = getState();
                    // progressPercentage should reflect the progress of the most recent taskId
                    // If they don't match, skip updating
                    if (taskId !== latestTaskId) return;
                    setState({
                        progressPercentage: progressPercentage
                    });
                });
                const { plan: plan } = response.samplePlan;
                const currentState = getState();
                // We only want to redirect them if the taskId for the current modal is the same as the one for this request
                // Else it might belong to a previous modal
                if (currentState.isOpen && taskId === currentState.taskId) {
                    redirectToPlan(plan.id);
                    dispatch($941848b62f4a3507$var$actions.close());
                } else {
                    const flagId = (0, $iG4Rs.CREATE_SUCCESS_FLAG_ID) + plan.id;
                    showFlag({
                        id: flagId,
                        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SuccessFlag, {
                                id: flagId,
                                planName: plan.name,
                                planId: plan.id
                            })
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                // we only want to track errors unrelated to user settings
                if (!(0, $iG4Rs.USER_SETTINGS_ERRORS).includes(err.message)) (0, $guiFP.default)({
                    error: err,
                    meta: {
                        id: `${(0, $iG4Rs.ERROR_REPORTING_PACKAGE)}SubmitFailed`,
                        packageName: (0, $iG4Rs.ERROR_REPORTING_PACKAGE),
                        teamName: (0, $iG4Rs.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const props = {
                    id: (0, $iG4Rs.CREATE_ERROR_FLAG_ID),
                    errorCode: err.message
                };
                showFlag({
                    id: (0, $iG4Rs.CREATE_ERROR_FLAG_ID),
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorFlag, props)
                });
                dispatch($941848b62f4a3507$var$actions.close());
            }
        }
};
const $941848b62f4a3507$var$Store = (0, $WBLbN.createStore)({
    name: $941848b62f4a3507$var$CONTROLLER_NAME,
    initialState: $941848b62f4a3507$var$initialState,
    actions: $941848b62f4a3507$var$actions
});
const $941848b62f4a3507$export$53d6fde96f096b86 = (0, $WBLbN.createHook)($941848b62f4a3507$var$Store);
const $941848b62f4a3507$export$88b99aa46c223622 = (0, $WBLbN.createContainer)($941848b62f4a3507$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen = false })=>{
            setState({
                isOpen: isOpen,
                hasBeenInitialised: true
            });
        }
});

});
parcelRegister("iG4Rs", function(module, exports) {

$parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", () => $849ca60c037bd134$export$f27a837467ec20e5);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $849ca60c037bd134$export$cfeee2ee86ead336);
$parcel$export(module.exports, "MAX_PLAN_NAME_LENGTH", () => $849ca60c037bd134$export$62da4a2465b3b309);
$parcel$export(module.exports, "CREATE_SUCCESS_FLAG_ID", () => $849ca60c037bd134$export$d526356745046017);
$parcel$export(module.exports, "CREATE_ERROR_FLAG_ID", () => $849ca60c037bd134$export$abd17266df221a92);
$parcel$export(module.exports, "UNKNOWN_EXCEPTION", () => $849ca60c037bd134$export$cfba07bc71f884c1);
$parcel$export(module.exports, "USER_SETTINGS_ERRORS", () => $849ca60c037bd134$export$4a3e779cd3c10125);
$parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING", () => $849ca60c037bd134$export$91ec80863c2c2030);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING", () => $849ca60c037bd134$export$c43e20911e13ca0);
$parcel$export(module.exports, "ERROR_LINK_MAPPING", () => $849ca60c037bd134$export$2c5a783ab3215ce1);

var $2mX4j = parcelRequire("2mX4j");
const $849ca60c037bd134$export$f27a837467ec20e5 = 'jiraPortfolio3CreateSamplePlan';
const $849ca60c037bd134$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $849ca60c037bd134$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact';
const $849ca60c037bd134$export$af6d68522cb370b8 = 'https://support.atlassian.com/jira-software-cloud/docs/view-a-sample-advanced-roadmaps-plan/';
const $849ca60c037bd134$export$62da4a2465b3b309 = 255;
const $849ca60c037bd134$export$d526356745046017 = 'samplePlanCreatedSuccessfully';
const $849ca60c037bd134$export$abd17266df221a92 = 'samplePlanError';
const $849ca60c037bd134$export$e6515d2009b1dba7 = 'REQUIRED_FIELDS_CONFIGURED_ON_ISSUE';
const $849ca60c037bd134$export$80ecb4d853a9f09b = 'EMPTY_ISSUE_LINKS';
const $849ca60c037bd134$export$f31def2c4daaefc0 = 'NO_BROWSE_PROJECTS_PERMISSION';
const $849ca60c037bd134$export$530d46555d7ccbb = 'NO_CREATE_ISSUES_PERMISSION';
const $849ca60c037bd134$export$8c852ea52ca9ebe = 'NO_TRANSITION_ISSUES_PERMISSION';
const $849ca60c037bd134$export$855d898b7009ad1c = 'NO_EDIT_ISSUES_PERMISSION';
const $849ca60c037bd134$export$5c8703f47a29c462 = 'WATCHING_DISABLED';
const $849ca60c037bd134$export$cfba07bc71f884c1 = 'UNKNOWN_EXCEPTION';
const $849ca60c037bd134$export$4a3e779cd3c10125 = [
    $849ca60c037bd134$export$e6515d2009b1dba7,
    $849ca60c037bd134$export$80ecb4d853a9f09b,
    $849ca60c037bd134$export$f31def2c4daaefc0,
    $849ca60c037bd134$export$530d46555d7ccbb,
    $849ca60c037bd134$export$8c852ea52ca9ebe,
    $849ca60c037bd134$export$855d898b7009ad1c,
    $849ca60c037bd134$export$5c8703f47a29c462
];
const $849ca60c037bd134$export$91ec80863c2c2030 = {
    [$849ca60c037bd134$export$e6515d2009b1dba7]: (0, $2mX4j.default).configurationErrorTitle,
    [$849ca60c037bd134$export$80ecb4d853a9f09b]: (0, $2mX4j.default).configurationErrorTitle,
    [$849ca60c037bd134$export$f31def2c4daaefc0]: (0, $2mX4j.default).permissionErrorTitle,
    [$849ca60c037bd134$export$530d46555d7ccbb]: (0, $2mX4j.default).permissionErrorTitle,
    [$849ca60c037bd134$export$8c852ea52ca9ebe]: (0, $2mX4j.default).permissionErrorTitle,
    [$849ca60c037bd134$export$855d898b7009ad1c]: (0, $2mX4j.default).permissionErrorTitle,
    [$849ca60c037bd134$export$5c8703f47a29c462]: (0, $2mX4j.default).configurationErrorTitle,
    [$849ca60c037bd134$export$cfba07bc71f884c1]: (0, $2mX4j.default).tryAgainErrorTitle
};
const $849ca60c037bd134$export$c43e20911e13ca0 = {
    [$849ca60c037bd134$export$e6515d2009b1dba7]: (0, $2mX4j.default).requiredFieldsConfiguredOnIssueError,
    [$849ca60c037bd134$export$80ecb4d853a9f09b]: (0, $2mX4j.default).emptyIssueLinksError,
    [$849ca60c037bd134$export$f31def2c4daaefc0]: (0, $2mX4j.default).noBrowseProjectsPermissionError,
    [$849ca60c037bd134$export$530d46555d7ccbb]: (0, $2mX4j.default).noCreateIssuesPermissionError,
    [$849ca60c037bd134$export$8c852ea52ca9ebe]: (0, $2mX4j.default).noTransitionIssuesPermissionError,
    [$849ca60c037bd134$export$855d898b7009ad1c]: (0, $2mX4j.default).noEditIssuesPermissionError,
    [$849ca60c037bd134$export$5c8703f47a29c462]: (0, $2mX4j.default).watchingDisabledError,
    [$849ca60c037bd134$export$cfba07bc71f884c1]: (0, $2mX4j.default).unknownExceptionError
};
const $849ca60c037bd134$export$2c5a783ab3215ce1 = {
    [$849ca60c037bd134$export$e6515d2009b1dba7]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$80ecb4d853a9f09b]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$f31def2c4daaefc0]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$530d46555d7ccbb]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$8c852ea52ca9ebe]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$855d898b7009ad1c]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$5c8703f47a29c462]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$cfba07bc71f884c1]: {
        text: (0, $2mX4j.default).contactSupport,
        href: $849ca60c037bd134$export$2c16bd1d8b68b11f
    }
};

});
parcelRegister("2mX4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $80fbe5208791cbaa$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $80fbe5208791cbaa$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    configurationErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.configuration-error-title",
        "defaultMessage": "Your demo plan couldn't be created because of a configuration error"
    },
    permissionErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.permission-error-title",
        "defaultMessage": "Your demo plan couldn't be created because you\u2019re missing a required permission"
    },
    tryAgainErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.try-again-error-title",
        "defaultMessage": "Try to create your demo plan again"
    },
    requiredFieldsConfiguredOnIssueError: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error",
        "defaultMessage": "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    emptyIssueLinksError: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error",
        "defaultMessage": "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
    },
    noBrowseProjectsPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
    },
    noCreateIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledError: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error",
        "defaultMessage": "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
    },
    unknownExceptionError: {
        "id": "portfolio-3-create-sample-plan.common.unknown-exception-error",
        "defaultMessage": "Your demo plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
    },
    learnMore: {
        "id": "portfolio-3-create-sample-plan.common.learn-more",
        "defaultMessage": "Learn more"
    },
    contactSupport: {
        "id": "portfolio-3-create-sample-plan.common.contact-support",
        "defaultMessage": "Contact Atlassian support"
    }
});

});


parcelRegister("crTvr", function(module, exports) {

$parcel$export(module.exports, "createSamplePlanAsync", () => $35743bfccad6aca6$export$fed9130b90cf6213);
$parcel$export(module.exports, "pollCreateSamplePlan", () => $35743bfccad6aca6$export$5d240a69af545c0d);
/**
 * Consider moving into service
 */ 
var $guiFP = parcelRequire("guiFP");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");

var $iG4Rs = parcelRequire("iG4Rs");
const $35743bfccad6aca6$var$throwIfNotOk = async (response)=>{
    if (response.ok) return response;
    if (response.status === 500) throw new (0, $7byHA.default)(response.status, (0, $iG4Rs.UNKNOWN_EXCEPTION), response.headers.get((0, $88Osm.TRACE_ID_HEADER)) ?? undefined, response);
};
const $35743bfccad6aca6$var$throwIfFailed = (result)=>{
    if (result.samplePlan && !result.samplePlan.success) throw new Error(result.samplePlan.error);
};
const $35743bfccad6aca6$var$delay = (ms = 3000)=>new Promise((res)=>setTimeout(res, ms));
const $35743bfccad6aca6$export$fed9130b90cf6213 = async (data)=>{
    const response = await (0, $lRmyA.performPostRequest)('/rest/jpo/1.0/plans/sampleplan/async', data);
    const { taskId: taskId } = response;
    if (!taskId) throw new Error('Invalid response from createSamplePlan');
    return taskId;
};
const $35743bfccad6aca6$export$5d240a69af545c0d = async (taskId, onUpdate)=>{
    const url = `/rest/jpo/1.0/plans/sampleplan/async/${taskId}`;
    try {
        const response = await fetch(url);
        await $35743bfccad6aca6$var$throwIfNotOk(response);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const raw = await response.json();
        $35743bfccad6aca6$var$throwIfFailed(raw);
        onUpdate(raw.progressPercent);
        if (raw.done) return raw;
        await $35743bfccad6aca6$var$delay();
        return $35743bfccad6aca6$export$5d240a69af545c0d(taskId, onUpdate);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // we only want to track errors unrelated to user settings
        if (!(0, $iG4Rs.USER_SETTINGS_ERRORS).includes(error.message)) (0, $guiFP.default)({
            meta: {
                id: `${(0, $iG4Rs.ERROR_REPORTING_PACKAGE)}PollingFailed`,
                packageName: (0, $iG4Rs.ERROR_REPORTING_PACKAGE),
                teamName: (0, $iG4Rs.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: 'Polling create sample plan failed'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("gN61g", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $893a2b94c09ac6d7$export$2ce376c2cc3355c8);

var $eUqFw = parcelRequire("eUqFw");

var $1YbJP = parcelRequire("1YbJP");

var $OBq1v = parcelRequire("OBq1v");
const $893a2b94c09ac6d7$export$2ce376c2cc3355c8 = ({ id: id, url: url, title: title, isVisible: isVisible, onClick: onClick, testIdPrefix: testIdPrefix })=>isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'plansNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'action'
        },
        href: url,
        key: id,
        onClick: onClick,
        testId: (0, $1YbJP.testIdConcat)(testIdPrefix, `item-${id}`)
    }, title) : null;

});

parcelRegister("MK1Fw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f1c1f2ff5d9c15$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b8f1c1f2ff5d9c15$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    // Delete the manageTeams message when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
    manageTeams: {
        "id": "atlassian-navigation.plans.menu.action-footer.manage-teams",
        "defaultMessage": "View shared teams"
    },
    managePlans: {
        "id": "atlassian-navigation.plans.menu.action-footer.manage-plans",
        "defaultMessage": "View all plans"
    },
    createPlan: {
        "id": "atlassian-navigation.plans.menu.action-footer.create-plan",
        "defaultMessage": "Create plan"
    },
    createDemoPlan: {
        "id": "atlassian-navigation.plans.menu.action-footer.create-demo-plan",
        "defaultMessage": "Create demo plan"
    }
});

});

parcelRegister("aF38d", function(module, exports) {

$parcel$export(module.exports, "useIsPlanListEmpty", () => $5f91366ecd2d5f69$export$5b132e35e5bd9b74);

var $1MAQq = parcelRequire("1MAQq");
const $5f91366ecd2d5f69$export$5b132e35e5bd9b74 = ()=>{
    const { recentItems: recentItems, favoriteItems: favoriteItems } = (0, $1MAQq.usePlanNavItems)();
    const hasRecentItems = recentItems && recentItems.length > 0;
    const hasFavoriteItems = favoriteItems && favoriteItems.length > 0;
    return !(hasRecentItems || hasFavoriteItems);
};

});


parcelRegister("fLoH2", function(module, exports) {

$parcel$export(module.exports, "AdminFooter", () => $10ca2607e3bf4b16$export$d7aa9aad32d41ef6);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $j67d5 = parcelRequire("j67d5");

var $OBq1v = parcelRequire("OBq1v");

var $f08Z7 = parcelRequire("f08Z7");
const $10ca2607e3bf4b16$export$d7aa9aad32d41ef6 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ items: items }] = (0, $j67d5.usePlansItems)();
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'admin-footer');
    if (!items || !items.links) return null;
    const { links: { settings: { id: id, isVisible: isVisible } } } = items;
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: true,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'planSettingsNavigationMenuItem',
            menuItemId: id,
            menuItemType: 'action'
        },
        href: "/jira/plans/settings/permissions",
        key: id,
        testId: (0, $1YbJP.testIdConcat)(testId, `item-${id}`)
    }, formatMessage((0, $f08Z7.default).settings)));
};

});
parcelRegister("f08Z7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb734e453e4449c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9fb734e453e4449c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    settings: {
        "id": "atlassian-navigation.plans.menu.admin-footer.settings",
        "defaultMessage": "Settings"
    }
});

});


parcelRegister("2gCsN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8908a7744b24839c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wpwq = parcelRequire("5wpwq");

var $jrdvV = parcelRequire("jrdvV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3rqlh = parcelRequire("3rqlh");

var $1YbJP = parcelRequire("1YbJP");

var $ba6Jq = parcelRequire("ba6Jq");

var $OBq1v = parcelRequire("OBq1v");

var $1MAQq = parcelRequire("1MAQq");

var $hoA4E = parcelRequire("hoA4E");

var $glucv = parcelRequire("glucv");
// request to include icon in atlaskit
// https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7743
// https://jdog.jira-dev.com/browse/JPO-18296
const $8908a7744b24839c$var$IconPlans = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: 24,
        width: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "var(--ds-icon, #42526E)",
        d: "M10 8a1 1 0 000 2h4a1 1 0 100-2h-4zM10 12a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM10 14a1 1 0 100 2h2a1 1 0 100-2h-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "var(--ds-icon, #42526E)",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 012-2h4a2 2 0 012 2h1a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h1zm6 3a2 2 0 001.732-1H17v12H7V6h1.268A2 2 0 0010 7h4zm0-3h-4v1h4V4z",
        clipRule: "evenodd"
    }));
const $8908a7744b24839c$var$Content = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $1MAQq.usePlanNavItems)();
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items');
    const hasRecentItems = recentItems && recentItems.length > 0;
    const hasFavoriteItems = favoriteItems && favoriteItems.length > 0;
    if (!hasRecentItems && !hasFavoriteItems) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hoA4E.default), {
        testIdPrefix: (0, $1YbJP.testIdConcat)(testIdPrefix, 'empty')
    });
    return hasRecentItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        testId: (0, $1YbJP.testIdConcat)(testIdPrefix, 'heading')
    }, formatMessage((0, $glucv.default).recent)), recentItems.map((item, index)=>{
        const { id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $3rqlh.getBeforeEntity)(favoriteItems);
        const itemTitle = title || formatMessage((0, $glucv.default).untitledPlan);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
            analytics: {
                actionSubjectId: 'plansNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: index
            },
            href: item.url,
            key: item.id,
            testId: (0, $1YbJP.testIdConcat)(testIdPrefix, `item-${index}`),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8908a7744b24839c$var$IconPlans, null),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ba6Jq.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: itemTitle,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $jrdvV.PLANS_ITEM_TYPE)
            })
        }, itemTitle);
    })) : null;
};
var $8908a7744b24839c$export$2e2bcd8739ae039 = $8908a7744b24839c$var$Content;

});
parcelRegister("hoA4E", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d25c3c0b55c4fa5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8uD7Y = parcelRequire("8uD7Y");

var $1YbJP = parcelRequire("1YbJP");

var $j67d5 = parcelRequire("j67d5");

var $26yXe = parcelRequire("26yXe");

var $d0QLq = parcelRequire("d0QLq");

var $jMP2a = parcelRequire("jMP2a");

var $hhftg = parcelRequire("hhftg");

var $2Tf2A = parcelRequire("2Tf2A");

var $5nnF4 = parcelRequire("5nnF4");
const $6d25c3c0b55c4fa5$var$EmptyWithCTAs = ({ testIdPrefix: testIdPrefix })=>{
    const [{ items: items }] = (0, $j67d5.usePlansItems)();
    const [, { openDrawer: openCreateNewPlanWizardDrawer }] = (0, $26yXe.useCreateNewPlanWizardDrawer)();
    const [, { open: openCreateSamplePlanModal }] = (0, $d0QLq.useCreateSamplePlan)();
    const handleRequestCreateSamplePlan = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'navigationCreateSamplePlan');
        openCreateSamplePlanModal();
    }, [
        openCreateSamplePlanModal
    ]);
    const handleRequestCreatePlan = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'navigationCreatePlan');
        openCreateNewPlanWizardDrawer();
    }, [
        openCreateNewPlanWizardDrawer
    ]);
    const createPlan = items?.links?.createPlan;
    const createSamplePlan = items?.links?.createSamplePlan;
    const hasButtons = Boolean(createPlan?.isVisible || createSamplePlan?.isVisible);
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5nnF4.default).plansText)), hasButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6d25c3c0b55c4fa5$var$buttonGroupStyles
    }, createSamplePlan?.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: handleRequestCreateSamplePlan
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5nnF4.default).createDemoPlan)), createPlan?.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: handleRequestCreatePlan
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5nnF4.default).createPlan))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hhftg.MenuInfo), {
        imgAltText: "",
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($2Tf2A))),
        testId: (0, $1YbJP.testIdConcat)(testIdPrefix, 'empty'),
        text: text
    });
};
var $6d25c3c0b55c4fa5$export$2e2bcd8739ae039 = $6d25c3c0b55c4fa5$var$EmptyWithCTAs;
const $6d25c3c0b55c4fa5$var$buttonGroupStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.200',
    display: 'flex',
    gap: 'space.100',
    justifyContent: 'center'
});

});
parcelRegister("2Tf2A", function(module, exports) {
module.exports = new URL("plans-empty.7a647633.svg", import.meta.url).toString();

});

parcelRegister("5nnF4", function(module, exports) {

$parcel$export(module.exports, "default", () => $229dc0788b6f51bd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $229dc0788b6f51bd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    plansText: {
        "id": "atlassian-navigation.plans.menu.content.empty.plans-text",
        "defaultMessage": "Create up-to-date plans from multiple teams and projects."
    },
    createPlan: {
        "id": "atlassian-navigation.plans.menu.content.empty.create-plan",
        "defaultMessage": "Create plan"
    },
    createDemoPlan: {
        "id": "atlassian-navigation.plans.menu.content.empty.create-demo-plan",
        "defaultMessage": "Create demo plan"
    },
    learnMore: {
        "id": "atlassian-navigation.plans.menu.content.empty.learn-more",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("glucv", function(module, exports) {

$parcel$export(module.exports, "default", () => $725dad5843503c70$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $725dad5843503c70$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    recent: {
        "id": "atlassian-navigation.plans.menu.content.recent",
        "defaultMessage": "Recent"
    },
    untitledPlan: {
        "id": "atlassian-navigation.plans.menu.content.untitled-plan",
        "defaultMessage": "Untitled plan"
    }
});

});


parcelRegister("6Jfez", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $04687d23ad5fb17f$export$297af018011b145a);

var $eUqFw = parcelRequire("eUqFw");

var $5wpwq = parcelRequire("5wpwq");

var $jrdvV = parcelRequire("jrdvV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $jsQSa = parcelRequire("jsQSa");

var $5kDtB = parcelRequire("5kDtB");

var $ba6Jq = parcelRequire("ba6Jq");

var $OBq1v = parcelRequire("OBq1v");

var $ctol0 = parcelRequire("ctol0");

var $1MAQq = parcelRequire("1MAQq");

var $dGQ35 = parcelRequire("dGQ35");
// request to include icon in atlaskit
// https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7743
// https://jdog.jira-dev.com/browse/JPO-18296
const $04687d23ad5fb17f$var$IconPlans = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        height: 24,
        width: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "var(--ds-icon, #42526E)",
        d: "M10 8a1 1 0 000 2h4a1 1 0 100-2h-4zM10 12a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM10 14a1 1 0 100 2h2a1 1 0 100-2h-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "var(--ds-icon, #42526E)",
        fillRule: "evenodd",
        d: "M8 4a2 2 0 012-2h4a2 2 0 012 2h1a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h1zm6 3a2 2 0 001.732-1H17v12H7V6h1.268A2 2 0 0010 7h4zm0-3h-4v1h4V4z",
        clipRule: "evenodd"
    }));
const $04687d23ad5fb17f$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $1MAQq.usePlanNavItems)();
    const itemsToShow = (0, $eUqFw.useMemo)(()=>favoriteItems.slice(0, (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items-starred');
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testId": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        testId: (0, $1YbJP.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $dGQ35.default).starred)), itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const itemTitle = title || formatMessage((0, $dGQ35.default).untitledPlan);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
            analytics: {
                actionSubjectId: 'plansNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04687d23ad5fb17f$var$IconPlans, null),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ba6Jq.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: itemTitle,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $jrdvV.PLANS_ITEM_TYPE)
            }),
            key: id,
            testId: (0, $1YbJP.testIdConcat)(testId, `item-${idx}`)
        }, itemTitle);
    }), favoriteItems.length >= (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctol0.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'plansNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV)
        },
        href: "/jira/plans",
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-view-all'),
        to: (0, $jsQSa.plansDirectoryRoute)
    })) : null;
};

});
parcelRegister("jsQSa", function(module, exports) {

$parcel$export(module.exports, "plansDirectoryRoute", () => $31385c3fefa30f13$export$143b4a1ef2ffc051);

var $exb0h = parcelRequire("exb0h");
const $31385c3fefa30f13$export$143b4a1ef2ffc051 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_PLANS_DIRECTORY),
    path: '/jira/plans'
};

});

parcelRegister("dGQ35", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c415a5e2d90c945$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9c415a5e2d90c945$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    starred: {
        "id": "atlassian-navigation.plans.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    },
    untitledPlan: {
        "id": "atlassian-navigation.plans.menu.favorite-content.untitled-plan",
        "defaultMessage": "Untitled plan"
    }
});

});


parcelRegister("a5Xcg", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $e296025def70941f$export$c7df4a3f1b89de01);

var $eUqFw = parcelRequire("eUqFw");

var $j67d5 = parcelRequire("j67d5");

var $efkaq = parcelRequire("efkaq");
const $e296025def70941f$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $efkaq.LoadStatus), usePlansItems: usePlansItems = (0, $j67d5.usePlansItems), shouldThrowError: shouldThrowError = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: usePlansItems
    });

});

parcelRegister("biciv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b163cc91524c8adc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $hI5oG = parcelRequire("hI5oG");

var $1n6uL = parcelRequire("1n6uL");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");


var $4q38b = parcelRequire("4q38b");

var $2WRQ2 = parcelRequire("2WRQ2");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8QAaY = parcelRequire("8QAaY");

var $jMP2a = parcelRequire("jMP2a");

var $5kDtB = parcelRequire("5kDtB");

var $cfpxp = parcelRequire("cfpxp");

var $gkBIS = parcelRequire("gkBIS");
const $b163cc91524c8adc$var$LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/guides/advanced-roadmaps/overview#what-are-advanced-roadmaps';
// Statsig experiment `plans_menu_try_it_free_one_stop_shop_modal`
// the control cohort will be shown the modal, whereas the test cohort will be redirected to the billing page instead.
// if the check errors for whatever reason, we still want to show the modal, hence why it defaults to true
const $b163cc91524c8adc$var$PremiumFeatureGate = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const { data: { premiumTrialUpgradeLink: premiumTrialUpgradeLink } } = (0, $79xbN.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? {
        data: {
            premiumTrialUpgradeLink: undefined
        }
    } : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $2WRQ2.useJswPremiumTrialUpgradeLink)({
        caller: (0, $5kDtB.PACKAGE_NAME)
    });
    const onStartTrialClick = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'navigationUpgradeToPremiumFromPlansMenu');
    };
    const onLearnMoreClick = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'navigationLearnMoreAboutPremiumFromPlansMenu');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b163cc91524c8adc$var$MenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b163cc91524c8adc$var$MenuHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfpxp.FeatureGateLogo), {
        alt: formatMessage((0, $gkBIS.default).imageAlt),
        colorMode: colorMode
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b163cc91524c8adc$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small",
        as: "h3"
    }, formatMessage((0, $gkBIS.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b163cc91524c8adc$var$contentDescriptionStyles
    }, formatMessage((0, $gkBIS.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b163cc91524c8adc$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b163cc91524c8adc$var$LearnMoreButton, {
        appearance: "link",
        href: $b163cc91524c8adc$var$LEARN_MORE_LINK,
        target: "_blank",
        onClick: onLearnMoreClick
    }, formatMessage((0, $gkBIS.default).learnMoreLink)), (0, $79xbN.expVal)('plans_menu_try_it_free_one_stop_shop_modal', 'isOneStopShopModalEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b163cc91524c8adc$var$TryPremiumButton, {
        onClick: onStartTrialClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1n6uL))), {
            size: "small",
            label: formatMessage((0, $gkBIS.default).imageAlt),
            primaryColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`
        })
    }, formatMessage((0, $gkBIS.default).startTrialButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b163cc91524c8adc$var$TryPremiumButtonDirectLink, {
        href: premiumTrialUpgradeLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1n6uL))), {
            size: "small",
            label: formatMessage((0, $gkBIS.default).imageAlt),
            primaryColor: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`
        })
    }, formatMessage((0, $gkBIS.default).startTrialButton))));
};
var $b163cc91524c8adc$export$2e2bcd8739ae039 = $b163cc91524c8adc$var$PremiumFeatureGate;
const $b163cc91524c8adc$var$TryPremiumButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8QAaY.PremiumUpgradeModalEntryPointButton), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    fontSize: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $b163cc91524c8adc$var$TryPremiumButtonDirectLink = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    fontSize: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    });
const $b163cc91524c8adc$var$LearnMoreButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ...props,
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    maxWidth: '250px',
                    marginRight: "var(--ds-space-200, 16px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b163cc91524c8adc$var$MenuContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vchhusvi _2rko1b66 _19itoyrj _11q717kt _qjkjusvi _1y1m18uv _p12f1l5c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b163cc91524c8adc$var$MenuHeaderContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7gup1 _4t3il1r9 _2rko1xsr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b163cc91524c8adc$var$ContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41ejb _11q7vuon",
            __cmplp.className
        ])
    });
});
const $b163cc91524c8adc$var$contentDescriptionStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b163cc91524c8adc$var$FooterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4gqct _11q7vuon _2rko4dok _1e0c1txw _4cvr1h6o _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2WRQ2", function(module, exports) {

$parcel$export(module.exports, "useJswPremiumTrialUpgradeLink", () => $281c6a0a6180b860$export$645eda3f5f2163ec);

var $7ZZxN = parcelRequire("7ZZxN");


var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

var $7Vcf5 = parcelRequire("7Vcf5");
const $281c6a0a6180b860$export$645eda3f5f2163ec = ({ deepLink: deepLink = true, skip: skip = false, caller: caller })=>{
    const { productEntitlementDetails: productEntitlementDetails } = (0, $gd0Sp.useTenantContext)();
    const jswEntitlement = productEntitlementDetails?.[0, $2edfd53057852e41$export$1346c9aa3cbb477d];
    const isJswUsingCcp = jswEntitlement?.billingSourceSystem === 'CCP';
    const { data: data, ...rest } = (0, $7Vcf5.useGetBillingPageUrl)({
        isUsingCcp: isJswUsingCcp,
        editionToUpgradeTo: deepLink ? (0, $6WXNs.PREMIUM_EDITION) : undefined,
        caller: caller,
        skip: skip,
        subProduct: (0, $7ZZxN.SOFTWARE_PROJECT)
    });
    return {
        data: {
            premiumTrialUpgradeLink: data.billingPageUrl
        },
        ...rest
    };
};

});
parcelRegister("7Vcf5", function(module, exports) {

$parcel$export(module.exports, "useGetBillingPageUrl", () => $bc3a92a0ff10234e$export$7b1495b7581dcd01);

var $eUqFw = parcelRequire("eUqFw");

var $3svxt = parcelRequire("3svxt");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jD3pk = parcelRequire("jD3pk");


var $6WXNs = parcelRequire("6WXNs");

var $dWlsy = parcelRequire("dWlsy");

var $gd0Sp = parcelRequire("gd0Sp");

var $f6rOi = parcelRequire("f6rOi");

var $cOq17 = parcelRequire("cOq17");

var $67MTZ = parcelRequire("67MTZ");

var $a6wc8 = parcelRequire("a6wc8");
const $bc3a92a0ff10234e$export$7b1495b7581dcd01 = ({ isUsingCcp: isUsingCcp, editionToUpgradeTo: editionToUpgradeTo, caller: caller, skip: skip = false, subProduct: subProduct, onError: onError })=>{
    const [billingPageUrl, setBillingPageUrl] = (0, $eUqFw.useState)();
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const contextSubProduct = (0, $dWlsy.useSubProduct)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const subProductToUse = subProduct || contextSubProduct;
    (0, $eUqFw.useEffect)(()=>{
        if (skip) return;
        const loadBillingInfo = async ()=>{
            try {
                const explicitlyLicensedProducts = (0, $3svxt.default)(tenantContext);
                const productKey = (0, $a6wc8.getProductKey)(subProductToUse, explicitlyLicensedProducts);
                const referrerKey = (0, $cOq17.getProductReferrerKey)(productKey);
                // The product key as used by Commerce.
                // JPD product key as used by Commerce does not include .ondemand
                const commerceProductKey = productKey === (0, $2edfd53057852e41$export$202f50ee62667e32) ? productKey : `${productKey}.ondemand`;
                const entitlementId = productKey ? tenantContext.productEntitlementDetails?.[productKey]?.entitlementId : null;
                if (isUsingCcp) {
                    if (!entitlementId) {
                        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'RetrieveEntitlementId failed', {
                            caller: caller,
                            productKey: productKey,
                            productEntitlementDetails: JSON.stringify(tenantContext.productEntitlementDetails),
                            subProduct: subProductToUse
                        });
                        throw new Error('Empty entitlement ID');
                    }
                    const ccpTransactionAccountId = await (0, $cOq17.getCcpTransactionAccountId)(entitlementId);
                    // List of valid referrer values
                    // https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan#How-to-use-this-deeplink%3F
                    const ccpBaseUrl = `${(0, $67MTZ.getAdminBaseUrl)()}/billing/o/${orgId}/${ccpTransactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=${referrerKey}&enableMpucup=true`;
                    switch(editionToUpgradeTo){
                        case 0, $6WXNs.STANDARD_EDITION:
                        case 0, $6WXNs.PREMIUM_EDITION:
                            setBillingPageUrl(`${ccpBaseUrl}&offeringName=${(0, $f6rOi.EDITION_KEY)[editionToUpgradeTo]}`);
                            break;
                        default:
                            setBillingPageUrl(ccpBaseUrl);
                    }
                } else // HAMS Billing System
                switch(editionToUpgradeTo){
                    case 0, $6WXNs.STANDARD_EDITION:
                    case 0, $6WXNs.PREMIUM_EDITION:
                        setBillingPageUrl(`${(0, $67MTZ.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}/${(0, $f6rOi.EDITION_KEY)[editionToUpgradeTo]}`);
                        break;
                    default:
                        setBillingPageUrl(`${(0, $67MTZ.getAdminBaseUrl)()}/s/${tenantContext.cloudId}/billing/applications/change-edition/${commerceProductKey}`);
                }
            } catch (e) {
                setError(e);
                if (onError && e instanceof Error) onError(e);
            } finally{
                setLoading(false);
            }
        };
        loadBillingInfo();
    }, [
        caller,
        createAnalyticsEvent,
        editionToUpgradeTo,
        isUsingCcp,
        onError,
        orgId,
        skip,
        subProduct,
        subProductToUse,
        tenantContext,
        tenantContext.cloudId
    ]);
    return {
        data: {
            billingPageUrl: billingPageUrl
        },
        loading: loading,
        error: error
    };
};

});
parcelRegister("f6rOi", function(module, exports) {

$parcel$export(module.exports, "EDITION_KEY", () => $c9221171ce881ddd$export$d73720c31c622c1f);

var $6WXNs = parcelRequire("6WXNs");
const $c9221171ce881ddd$export$d73720c31c622c1f = {
    STANDARD_EDITION: (0, $6WXNs.STANDARD_EDITION_KEY),
    PREMIUM_EDITION: (0, $6WXNs.PREMIUM_EDITION_KEY)
};
const $c9221171ce881ddd$export$5b7423264d48ab04 = 'not-enrolled';
const $c9221171ce881ddd$export$fa04ad826acc90da = 'variation';

});

parcelRegister("cOq17", function(module, exports) {

$parcel$export(module.exports, "getProductReferrerKey", () => $4b02692cfbe23722$export$b4fb3304d5d8fc5f);
$parcel$export(module.exports, "getCcpTransactionAccountId", () => $4b02692cfbe23722$export$5186b9d213f626fd);

var $2OdyW = parcelRequire("2OdyW");

const $4b02692cfbe23722$export$b4fb3304d5d8fc5f = (productKey)=>{
    if (productKey === (0, $2edfd53057852e41$export$1346c9aa3cbb477d)) return 'jsw';
    if (productKey === (0, $2edfd53057852e41$export$c8c1c8c3f8ddba61)) return 'jsm';
    if (productKey === (0, $2edfd53057852e41$export$202f50ee62667e32)) return 'jpd';
    if (productKey === (0, $2edfd53057852e41$export$db515c8cec1e6f79)) return 'jwm';
    return null;
};
const $4b02692cfbe23722$export$5186b9d213f626fd = async (entitlementId)=>{
    const entitlementDetails = await (0, $2OdyW.default)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`);
    if (!entitlementDetails?.transactionAccountId) // TODO: Handle errors properly
    throw Error('Could not get transactionAccountId');
    return (entitlementDetails ?? {}).transactionAccountId;
};

});



parcelRegister("8QAaY", function(module, exports) {

$parcel$export(module.exports, "PremiumUpgradeModalEntryPointButton", () => $a12ef27b30dc8d09$export$9901be7804227da7);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $l3Qg0 = parcelRequire("l3Qg0");

var $3q7Yq = parcelRequire("3q7Yq");

var $6j4bv = parcelRequire("6j4bv");

var $6PHwo = parcelRequire("6PHwo");
const $a12ef27b30dc8d09$var$entryPointParams = {};
const $a12ef27b30dc8d09$export$9901be7804227da7 = (buttonProps)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $6PHwo.entryPointPremiumUpgradeModal), $a12ef27b30dc8d09$var$entryPointParams);
    const buttonTrigger = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ...buttonProps,
        ref: buttonTrigger
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira-premium-upgrade-modal",
        packageName: "jiraPremiumUpgradeModal",
        errorFallback: "flag",
        runtimeProps: {
            onClose: entryPointActions.unload
        },
        entryPointActions: entryPointActions
    }));
};

});
parcelRegister("6PHwo", function(module, exports) {

$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $4cf7dc0dcae42bfd$export$7116d5b1a93db8d6);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $4cf7dc0dcae42bfd$export$7116d5b1a93db8d6 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("hRdNK")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
        moduleId: "1102b440"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hRdNK", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("896rB")
]).then(()=>parcelRequire('6l8MW'));

});



parcelRegister("cfpxp", function(module, exports) {

$parcel$export(module.exports, "FeatureGateLogo", () => $e52ca274e32a4c1d$export$83d4ce06fb8c3c0);

var $eUqFw = parcelRequire("eUqFw");

var $iFmgL = parcelRequire("iFmgL");

var $hIX4j = parcelRequire("hIX4j");

var $h2TQ6 = parcelRequire("h2TQ6");
const $e52ca274e32a4c1d$export$83d4ce06fb8c3c0 = ({ colorMode: colorMode, alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
        src: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($hIX4j))) : (0, (/*@__PURE__*/$parcel$interopDefault($h2TQ6))),
        alt: alt
    });

});
parcelRegister("hIX4j", function(module, exports) {
module.exports = new URL("plans-standard-dark.fce82c99.svg", import.meta.url).toString();

});

parcelRegister("h2TQ6", function(module, exports) {
module.exports = new URL("plans-standard-light.fde35b0d.svg", import.meta.url).toString();

});


parcelRegister("gkBIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8302d811c347f6d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e8302d811c347f6d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.title",
        "defaultMessage": "Unlock advanced planning tools"
    },
    imageAlt: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.image-alt",
        "defaultMessage": "Upgrade to Jira Premium"
    },
    description: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.description",
        "defaultMessage": "Boost agility with capacity planning, dependency mapping, and more. Try Jira Premium's high-level cross-team planning tools."
    },
    learnMoreLink: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.learn-more-link",
        "defaultMessage": "Read the guide"
    },
    startTrialButton: {
        "id": "atlassian-navigation.plans.menu.premium-feature-gate.start-trial-button",
        "defaultMessage": "Try it free"
    }
});

});



parcelRegister("caEIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $30712e701ed1911e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $30712e701ed1911e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    plans: {
        "id": "atlassian-navigation.plans.plans",
        "defaultMessage": "Plans"
    }
});

});


parcelRegister("6jYFH", function(module, exports) {

$parcel$export(module.exports, "ProductHome", () => $f3997930f8d68638$export$32d61f70e04b6020);

var $eUqFw = parcelRequire("eUqFw");

var $510qR = parcelRequire("510qR");
var $jHY0C = parcelRequire("jHY0C");

var $77CtJ = parcelRequire("77CtJ");
var $82CV1 = parcelRequire("82CV1");
var $d3fGG = parcelRequire("d3fGG");
var $lkO3b = parcelRequire("lkO3b");
var $ecIoc = parcelRequire("ecIoc");
var $kGoGz = parcelRequire("kGoGz");

var $1YbJP = parcelRequire("1YbJP");

var $6FP8W = parcelRequire("6FP8W");

var $bLRqM = parcelRequire("bLRqM");

var $fLqV8 = parcelRequire("fLqV8");

var $lB25E = parcelRequire("lB25E");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $eXNjU = parcelRequire("eXNjU");

var $gvn5f = parcelRequire("gvn5f");

var $9EOl4 = parcelRequire("9EOl4");
const $f3997930f8d68638$export$6d49a893c897b0cc = {
    jira: {
        icon: (0, $77CtJ.JiraIcon),
        logo: (0, $82CV1.JiraLogo)
    },
    serviceDesk: {
        icon: (0, $ecIoc.JiraServiceManagementIcon),
        logo: (0, $kGoGz.JiraServiceManagementLogo)
    },
    'product-discovery': {
        icon: (0, $d3fGG.JiraProductDiscoveryIcon),
        logo: (0, $lkO3b.JiraProductDiscoveryLogo)
    }
};
const $f3997930f8d68638$var$testIdPrefix = (0, $1YbJP.testIdGenerate)('product-home-');
const $f3997930f8d68638$var$getProductIconAndLogo = (productName)=>{
    if (productName === 'core' || productName === 'software') return $f3997930f8d68638$export$6d49a893c897b0cc.jira;
    return $f3997930f8d68638$export$6d49a893c897b0cc[productName];
};
const $f3997930f8d68638$var$ProductHome = ({ AkCustomProductHome: AkCustomProductHome = (0, $510qR.default), AkProductHome: AkProductHome = (0, $jHY0C.default), useCustomLogo: useCustomLogo = (0, $eXNjU.useCustomLogo), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $gvn5f.useNavigationItemAnalytics), useProductName: useProductName = (0, $bLRqM.useProductName), useRouterActions: useRouterActions = (0, $lB25E.useRouterActions), useSiteTitle: useSiteTitle = (0, $9EOl4.useSiteTitle) })=>{
    const logoUrl = useCustomLogo();
    const productName = useProductName();
    const siteTitleData = useSiteTitle();
    const siteTitle = siteTitleData.shouldShow && siteTitleData.value || undefined;
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).LOGO
    });
    const { push: push } = useRouterActions();
    const homeUrl = '/jira';
    const navigateToHome = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'ev' implicitly has an 'any' type.
    (ev)=>{
        triggerAnalytics();
        if (ev.ctrlKey || ev.metaKey) return;
        ev.preventDefault();
        push(homeUrl);
    }, [
        triggerAnalytics,
        push,
        homeUrl
    ]);
    if (logoUrl) return(// @ts-expect-error - TS2739 - Type '{ iconUrl: string; logoUrl: string; href: string; onClick: (ev: any) => void; siteTitle: string | undefined; testId: string | undefined; }' is missing the following properties from type 'CustomProductHomeProps': iconAlt, logoAlt
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AkCustomProductHome, {
        iconUrl: logoUrl,
        logoUrl: logoUrl,
        href: homeUrl,
        onClick: navigateToHome,
        siteTitle: siteTitle,
        testId: $f3997930f8d68638$var$testIdPrefix
    }));
    if ((0, $6FP8W.getWillShowNav4)()) {
        const { icon: MobileLogo, logo: Logo } = $f3997930f8d68638$var$getProductIconAndLogo(productName);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fLqV8.NavLogo), {
            label: "Jira",
            icon: MobileLogo,
            logo: Logo,
            href: homeUrl,
            onClick: navigateToHome
        });
    }
    const { icon: icon, logo: logo } = $f3997930f8d68638$var$getProductIconAndLogo(productName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AkProductHome, {
        icon: icon,
        logo: logo,
        href: homeUrl,
        onClick: navigateToHome,
        siteTitle: siteTitle,
        testId: $f3997930f8d68638$var$testIdPrefix
    });
};
const $f3997930f8d68638$export$32d61f70e04b6020 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $5kDtB.NAVIGATION_ITEM_ID).HOME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f3997930f8d68638$var$ProductHome, props));

});
parcelRegister("eXNjU", function(module, exports) {

$parcel$export(module.exports, "useCustomLogo", () => $8ea5354f4b60a536$export$9891fb86d6b41647);

var $eUqFw = parcelRequire("eUqFw");

var $6rW04 = parcelRequire("6rW04");
const $8ea5354f4b60a536$export$9891fb86d6b41647 = ()=>(0, $eUqFw.useMemo)(()=>(0, $6rW04.default)('ajs-lf-top-adg3-logourl'), []);

});

parcelRegister("9EOl4", function(module, exports) {

$parcel$export(module.exports, "useSiteTitle", () => $2dd6049e2d426090$export$3e157e0d79928990);

var $eUqFw = parcelRequire("eUqFw");

var $6rW04 = parcelRequire("6rW04");
const $2dd6049e2d426090$export$3e157e0d79928990 = ()=>(0, $eUqFw.useMemo)(()=>({
            shouldShow: (0, $6rW04.default)('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            value: (0, $6rW04.default)('ajs-app-title')
        }), []);

});


parcelRegister("4nWiP", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $5488cefaac7645bc$export$5120f2d0b8d4cab8);

var $eUqFw = parcelRequire("eUqFw");

var $55pTl = parcelRequire("55pTl");

var $fMzYK = parcelRequire("fMzYK");

var $iJlfe = parcelRequire("iJlfe");

var $ltfxy = parcelRequire("ltfxy");

var $3MV1G = parcelRequire("3MV1G");

var $fyk0U = parcelRequire("fyk0U");

var $bDhRl = parcelRequire("bDhRl");

var $4ksts = parcelRequire("4ksts");

var $7vTKl = parcelRequire("7vTKl");

var $3BTZc = parcelRequire("3BTZc");

var $1YbJP = parcelRequire("1YbJP");


var $5cLMB = parcelRequire("5cLMB");

var $cWiVr = parcelRequire("cWiVr");

var $hb3Di = parcelRequire("hb3Di");

var $k7xrR = parcelRequire("k7xrR");

var $g2nu2 = parcelRequire("g2nu2");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $gvn5f = parcelRequire("gvn5f");

var $8VBzm = parcelRequire("8VBzm");

var $dMdFy = parcelRequire("dMdFy");

var $2P9B5 = parcelRequire("2P9B5");
const $5488cefaac7645bc$var$SpotlightTargetDI = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $5488cefaac7645bc$var$handleMouseEnter = ()=>{
    (0, $g2nu2.LazyOpenMenuItem).preload();
    (0, $k7xrR.NavigationProfileNavItemWrapperNudgeLazy).preload();
};
const $5488cefaac7645bc$var$Profile = ({ AkProfile: AkProfile = (0, $fMzYK.Profile), Avatar: Avatar = (0, $iJlfe.default), Menu: Menu = (0, $dMdFy.Menu), Popup: Popup = (0, $3MV1G.default), SpotlightTarget: SpotlightTarget = $5488cefaac7645bc$var$SpotlightTargetDI, useCurrentUser: useCurrentUser = (0, $cWiVr.useCurrentUser), useExperienceStart: useExperienceStart = (0, $bDhRl.useExperienceStart), useIntl: useIntl = (0, $4ksts.useIntlV2), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $gvn5f.useNavigationItemAnalytics), useTopMenus: useTopMenus = (0, $3BTZc.useTopMenus), useUserBoardId: useUserBoardId = (0, $8VBzm.useUserBoardId) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const [isMenuOpen, { toggle: toggleMenu, off: closeMenu }] = useTopMenus((0, $7vTKl.MENU_ID).PROFILE);
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).PROFILE
    });
    const { data: { user: user } } = useCurrentUser();
    const onStart = useExperienceStart({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $5kDtB.NAVIGATION_ITEM_ID).PROFILE,
        analyticsSource: 'atlassian-navigation'
    });
    const [nudgeStep] = (0, $5cLMB.useNudgeStep)();
    const [hasNudgeActive] = (0, $5cLMB.useHasNudgeActive)();
    const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(isMenuOpen);
    const testIdPrefix = (0, $1YbJP.testIdGenerate)('secondary-actions', 'profile');
    const [userTraits, { setUserTraits: setUserTraits }] = (0, $fyk0U.useUserTraits)();
    const fetchUserTraits = (0, $fyk0U.useFetchUserTraitsOld)();
    const setUserTraitsIfNotAvailable = (0, $eUqFw.useCallback)(async ()=>{
        if (user.isAnonymous) return;
        if (!userTraits?.attributes?.length && userTraits?.attributes !== null) {
            const newTraits = await fetchUserTraits();
            // We must explicitly check for false because fetchUserTraits returns "false" when pending, and "null" when traits are empty.
            if (newTraits !== false) setUserTraits(newTraits);
        }
    }, [
        user.isAnonymous,
        userTraits?.attributes,
        fetchUserTraits,
        setUserTraits
    ]);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        onStart();
        toggleMenu();
        triggerAnalytics();
    }, [
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Menu, {
            userBoardId: userBoardId,
            userBoardOwnerAccountId: userBoardOwnerAccountId,
            testIdPrefix: testIdPrefix
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        userBoardId,
        userBoardOwnerAccountId,
        testIdPrefix
    ]);
    const Trigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": (0, $1YbJP.testIdConcat)(testIdPrefix, 'menu-trigger'),
            onMouseOver: setUserTraitsIfNotAvailable,
            onFocus: setUserTraitsIfNotAvailable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hb3Di.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: (0, $8379f5d78bf6fb5a$export$7aa8bceae32c7862) === nudgeStep && hasNudgeActive,
            Wrapper: (0, $k7xrR.NavigationProfileNavItemWrapperNudgeAsync)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AkProfile, {
            ...triggerProps,
            icon: // NOTE: This SpotlightTarget can be used throughout Jira not just within
            // the current package. They're often used for onboarding or changeboarding
            // experiences and allow an Atlaskit spotlight to be attached to page elements.
            // If you need to change this, make sure you check where the target ID is being used
            // and contact the relevant team as necessary. This Sourcegraph link should help :)
            // http://go/src/PROFILE_SPOTLIGHT_KEY
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SpotlightTarget, {
                name: (0, $5kDtB.PROFILE_SPOTLIGHT_KEY)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Avatar, {
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                src: user.avatarUrls ? user.avatarUrls['48x48'] : undefined,
                size: "small",
                borderColor: "transparent"
            })),
            isSelected: isMenuOpen,
            onClick: onClick,
            tooltip: formatMessage((0, $2P9B5.default).tooltip),
            onMouseEnter: $5488cefaac7645bc$var$handleMouseEnter,
            "aria-label": formatMessage((0, $2P9B5.default).tooltip),
            id: "atlassian-navigation.ui.profile.icon"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
            engagementId: (0, $5kDtB.PROFILE_SPOTLIGHT_KEY)
        })), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        formatMessage,
        isMenuOpen,
        onClick,
        testIdPrefix,
        user,
        nudgeStep,
        hasNudgeActive
    ]);
    if (user.isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Popup, {
        content: content,
        isOpen: isMenuOpen,
        onClose: closeMenu,
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: Trigger,
        label: formatMessage((0, $2P9B5.default).tooltip),
        role: "menu"
    });
};
const $5488cefaac7645bc$export$5120f2d0b8d4cab8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $5kDtB.NAVIGATION_ITEM_ID).PROFILE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5488cefaac7645bc$var$Profile, props));

});
parcelRegister("fyk0U", function(module, exports) {

$parcel$export(module.exports, "useFetchUserTraitsOld", () => $8dca86bbd49a57d4$export$d5a27009aa54a078);
$parcel$export(module.exports, "useUserTraits", () => $8dca86bbd49a57d4$export$49363c8b904e0dc7);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $dxcfv = parcelRequire("dxcfv");

var $dWLk9 = parcelRequire("dWLk9");

var $WBLbN = parcelRequire("WBLbN");
const $8dca86bbd49a57d4$var$setUserTraits = (newTraits)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        setState({
            ...currentUserTraits,
            attributes: newTraits
        });
    };
const $8dca86bbd49a57d4$var$addUserTrait = (trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        if (currentUserTraits.attributes?.some((t)=>t.name === trait.name)) return;
        setState({
            attributes: currentUserTraits.attributes?.concat(trait) ?? [
                trait
            ]
        });
    };
const $8dca86bbd49a57d4$var$fetchUserTraits = (cloudId, accountId)=>async ({ getState: getState, setState: setState })=>{
        if (!accountId) return null;
        const state = getState();
        if (state.attributes !== null) return;
        const getUserTraits = async ()=>{
            try {
                const userTraitsData = await (0, $lRmyA.performGetRequest)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`);
                return userTraitsData?.attributes ?? [];
            } catch  {
                return null;
            }
        };
        const userTraits = await getUserTraits();
        setState({
            attributes: userTraits
        });
    };
const $8dca86bbd49a57d4$var$actions = {
    setUserTraits: $8dca86bbd49a57d4$var$setUserTraits,
    fetchUserTraits: $8dca86bbd49a57d4$var$fetchUserTraits,
    addUserTrait: $8dca86bbd49a57d4$var$addUserTrait
};
const $8dca86bbd49a57d4$var$initialState = {
    attributes: null
};
const $8dca86bbd49a57d4$export$d5a27009aa54a078 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const accountId = (0, $dxcfv.useAccountId)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    return (0, $eUqFw.useCallback)(async ()=>{
        if (!accountId) return null;
        const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const getUserTraits = async ()=>{
            try {
                setLoading(true);
                const userTraitsData = await (0, $lRmyA.performGetRequest)(url);
                // If a user has no attributes on their account, return null so we know
                // not to keep trying to fetch data.
                return !userTraitsData?.attributes?.length ? null : userTraitsData?.attributes;
            } catch  {
                return null;
            } finally{
                setLoading(false);
            }
        };
        if (!loading) {
            const userTraits = await getUserTraits();
            return userTraits;
        }
        return false;
    }, [
        accountId,
        cloudId,
        loading
    ]);
};
const $8dca86bbd49a57d4$export$6e688ed53ae076d5 = (0, $WBLbN.createStore)({
    initialState: $8dca86bbd49a57d4$var$initialState,
    actions: $8dca86bbd49a57d4$var$actions,
    name: 'UserTraits'
});
const $8dca86bbd49a57d4$export$49363c8b904e0dc7 = (0, $WBLbN.createHook)($8dca86bbd49a57d4$export$6e688ed53ae076d5);
const $8dca86bbd49a57d4$export$4f249a943026a90b = (0, $WBLbN.createActionsHook)($8dca86bbd49a57d4$export$6e688ed53ae076d5);

});

parcelRegister("hb3Di", function(module, exports) {

$parcel$export(module.exports, "ConditionalNudgeWrapper", () => $a40d8b671c4ac5be$export$56d544c4f479b7fb);

var $eUqFw = parcelRequire("eUqFw");
const $a40d8b671c4ac5be$export$56d544c4f479b7fb = ({ children: children, Wrapper: Wrapper, conditionsToApplyWrapper: conditionsToApplyWrapper, ...restProps })=>{
    if (conditionsToApplyWrapper && !false && children !== null && children !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, restProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};

});

parcelRegister("k7xrR", function(module, exports) {

$parcel$export(module.exports, "NavigationProfileNavItemWrapperNudgeLazy", () => $9430983971978867$export$3651b15d92c1c280);
$parcel$export(module.exports, "NavigationProfileNavItemWrapperNudgeAsync", () => $9430983971978867$export$deb2cae843941204);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");

const $9430983971978867$export$3651b15d92c1c280 = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("kvPuQ")).then((exportedModule)=>exportedModule.NavigationProfileNavItemWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/navigation-profile/index.tsx"
});
const $9430983971978867$export$deb2cae843941204 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: "asyncProfileNudge",
        fallback: children,
        attributes: {
            NAVIGATION_APPS_PROFILE_ITEM_NUDGE_ID: $8379f5d78bf6fb5a$export$7aa8bceae32c7862
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "navigation-profile-nav-item-wrapper-nudge-lazy",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9430983971978867$export$3651b15d92c1c280, {
        nudgeId: (0, $8379f5d78bf6fb5a$export$7aa8bceae32c7862)
    }, children)));
$9430983971978867$export$deb2cae843941204.displayName = 'NavigationProfileNavItemWrapperNudgeAsync';

});
parcelRegister("kvPuQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gUBS6").then(()=>parcelRequire('6KIlt'));

});


parcelRegister("g2nu2", function(module, exports) {

$parcel$export(module.exports, "JswOnboardingChecklist", () => $5e91aaf674af65c8$export$aea93106aaeec3fc);
$parcel$export(module.exports, "JswOnboardingButton", () => $5e91aaf674af65c8$export$c0cbc1198da400db);
$parcel$export(module.exports, "LazyOpenMenuItem", () => $5e91aaf674af65c8$export$e6a8d3e2a6acc946);
$parcel$export(module.exports, "OpenMenuItem", () => $5e91aaf674af65c8$export$67c4b22563f33286);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $eI5EY = parcelRequire("eI5EY");

var $2cb5E = parcelRequire("2cb5E");

var $hZz63 = parcelRequire("hZz63");

var $7Aqzu = parcelRequire("7Aqzu");

var $gGtKh = parcelRequire("gGtKh");

var $jK1pm = parcelRequire("jK1pm");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $5e91aaf674af65c8$var$LazyChecklist = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("fAL00")).then(({ JswOnboardingChecklistNext: JswOnboardingChecklistNext })=>JswOnboardingChecklistNext), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-checklist-next/src/ui/onboarding-checklist/index.tsx"
});
const $5e91aaf674af65c8$var$FallbackChecklist = ()=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $hZz63.qsChecklistAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $5e91aaf674af65c8$export$aea93106aaeec3fc = ()=>(0, $eI5EY.fg)('jsw_onboarding_reactufo_qs') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "quickstart"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $7Aqzu.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-checklist-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e91aaf674af65c8$var$FallbackChecklist, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e91aaf674af65c8$var$LazyChecklist, null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncChecklistComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $7Aqzu.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-checklist-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e91aaf674af65c8$var$FallbackChecklist, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e91aaf674af65c8$var$LazyChecklist, null)));

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $5e91aaf674af65c8$var$LazyOpenButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("6zHdi")).then(({ JswOnboardingButtonNext: JswOnboardingButtonNext })=>JswOnboardingButtonNext), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-quickstart/src/ui/onboarding-button/index.tsx"
});
const $5e91aaf674af65c8$var$FallbackButton = ()=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $hZz63.qsButtonAutoLoadTime).start();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $5e91aaf674af65c8$export$c0cbc1198da400db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncChecklistButtonComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $7Aqzu.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-checklist-button-new",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e91aaf674af65c8$var$FallbackButton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e91aaf674af65c8$var$LazyOpenButton, null)));

const $5e91aaf674af65c8$export$e6a8d3e2a6acc946 = (0, $7rh0R.lazy)(()=>(parcelRequire("d4WH8")).then(({ OpenMenuItem: OpenMenuItem })=>{
        (0, $hZz63.openMenuItemLoadTime).mark((0, $2cb5E.PERFORMANCE_MARK).BUNDLE_LOAD_END);
        return OpenMenuItem;
    }), {
    moduleId: "./src/packages/software/onboarding-quickstart/src/ui/open-menu-item/index.tsx"
});
const $5e91aaf674af65c8$var$SubmitOpenMenuItemLoadStart = ()=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $hZz63.openMenuItemLoadTime).start();
        (0, $hZz63.openMenuItemLoadTime).mark((0, $2cb5E.PERFORMANCE_MARK).BUNDLE_LOAD_START);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $5e91aaf674af65c8$export$67c4b22563f33286 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncOpenMenuItemComponent",
        packageName: "jiraSoftwareOnboardingQuickstart",
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $7Aqzu.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-checklist-open-menu-item",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e91aaf674af65c8$var$SubmitOpenMenuItemLoadStart, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e91aaf674af65c8$export$e6a8d3e2a6acc946, props)));

});
parcelRegister("hZz63", function(module, exports) {

$parcel$export(module.exports, "isMetricRunning", () => $2244d1322d99ed76$export$5c2d3e87043198cf);
$parcel$export(module.exports, "openMenuItemLoadTime", () => $2244d1322d99ed76$export$9aef270bc11ae96b);
$parcel$export(module.exports, "qsButtonAutoLoadTime", () => $2244d1322d99ed76$export$844f48c93ed69757);
$parcel$export(module.exports, "qsChecklistAutoLoadTime", () => $2244d1322d99ed76$export$c501d2dfab0e9e45);
$parcel$export(module.exports, "qsChecklistMinimiseInteraction", () => $2244d1322d99ed76$export$ac78fba7425e64da);
$parcel$export(module.exports, "qsChecklistDismissInteraction", () => $2244d1322d99ed76$export$494d4094aaa2bc4d);
$parcel$export(module.exports, "qsButtonOpenInteraction", () => $2244d1322d99ed76$export$da7d38041ee220c8);
$parcel$export(module.exports, "qsButtonDismissInteraction", () => $2244d1322d99ed76$export$ce2841e9d619cdfd);
// @ts-expect-error - TS2305 - Module '"@atlassian/browser-metrics"' has no exported member 'BaseMetric'.

var $lNfG4 = parcelRequire("lNfG4");

var $2cb5E = parcelRequire("2cb5E");
const $2244d1322d99ed76$export$5c2d3e87043198cf = (metric)=>metric?.state === 'started';
const $2244d1322d99ed76$export$9aef270bc11ae96b = (0, $lNfG4.metrics).custom({
    key: `${(0, $2cb5E.PERFORMANCE_METRIC_PREFIX)}.open.menu-item.load`,
    timings: [
        {
            key: (0, $2cb5E.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $2cb5E.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $2244d1322d99ed76$export$844f48c93ed69757 = (0, $lNfG4.metrics).custom({
    key: `${(0, $2cb5E.PERFORMANCE_METRIC_PREFIX)}.button.load`,
    timings: [
        {
            key: (0, $2cb5E.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $2cb5E.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $2244d1322d99ed76$export$c501d2dfab0e9e45 = (0, $lNfG4.metrics).custom({
    key: `${(0, $2cb5E.PERFORMANCE_METRIC_PREFIX)}.checklist.load`,
    timings: [
        {
            key: (0, $2cb5E.PERFORMANCE_MARK).BUNDLE_LOAD_START,
            endMark: (0, $2cb5E.PERFORMANCE_MARK).BUNDLE_LOAD_END
        }
    ]
});
const $2244d1322d99ed76$export$ac78fba7425e64da = (0, $lNfG4.metrics).interaction({
    key: `${(0, $2cb5E.PERFORMANCE_METRIC_PREFIX)}.checklist.minimize`
});
const $2244d1322d99ed76$export$494d4094aaa2bc4d = (0, $lNfG4.metrics).interaction({
    key: `${(0, $2cb5E.PERFORMANCE_METRIC_PREFIX)}.checklist.dismiss`
});
const $2244d1322d99ed76$export$da7d38041ee220c8 = (0, $lNfG4.metrics).interaction({
    key: `${(0, $2cb5E.PERFORMANCE_METRIC_PREFIX)}.button.open`
});
const $2244d1322d99ed76$export$ce2841e9d619cdfd = (0, $lNfG4.metrics).interaction({
    key: `${(0, $2cb5E.PERFORMANCE_METRIC_PREFIX)}.button.dismiss`
});

});

parcelRegister("fAL00", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("kSF1O")
]).then(()=>parcelRequire('kjqDp'));

});

parcelRegister("6zHdi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hi2po")
]).then(()=>parcelRequire('kXLXT'));

});

parcelRegister("d4WH8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("ffhIR")
]).then(()=>parcelRequire('XHryo'));

});


parcelRegister("8VBzm", function(module, exports) {

$parcel$export(module.exports, "useUserBoardId", () => $cf88dd17b1b4ece4$export$e6e895063f36c814);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $h3mHU = parcelRequire("h3mHU");
const $cf88dd17b1b4ece4$export$e6e895063f36c814 = (shouldRun)=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [userBoard, setUserBoard] = (0, $eUqFw.useState)(null);
    const shouldFetch = shouldRun || isReady;
    (0, $eUqFw.useEffect)(()=>{
        if (!shouldFetch || userBoard) return;
        setUserBoard(null);
        const requestUrl = '/rest/greenhopper/1.0/rapidviews/recent?maxResults=1&userBoard=true';
        (0, $lRmyA.performGetRequest)(requestUrl).then((result)=>{
            const [board] = result.views;
            if (board) setUserBoard(board);
        }).catch(()=>{
        // user board fetch failed, ignore
        });
    }, [
        shouldFetch,
        userBoard,
        setUserBoard
    ]);
    return userBoard && userBoard.location ? [
        userBoard.id,
        userBoard.location.accountId
    ] : [
        null,
        null
    ];
};

});

parcelRegister("dMdFy", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $36bcc4c2ecd08c8e$export$d9b273488cd8ce6f);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $55pTl = parcelRequire("55pTl");

var $ffiyv = parcelRequire("ffiyv");

var $5wpwq = parcelRequire("5wpwq");
var $8BKky = parcelRequire("8BKky");

var $ltfxy = parcelRequire("ltfxy");

var $fyk0U = parcelRequire("fyk0U");

var $7ZZxN = parcelRequire("7ZZxN");

var $fDZ6r = parcelRequire("fDZ6r");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3rqlh = parcelRequire("3rqlh");

var $1YbJP = parcelRequire("1YbJP");

var $iJPUk = parcelRequire("iJPUk");

var $cWiVr = parcelRequire("cWiVr");

var $bNe1g = parcelRequire("bNe1g");

var $1TkEB = parcelRequire("1TkEB");

var $7lcEz = parcelRequire("7lcEz");

var $eaP1H = parcelRequire("eaP1H");


var $IdJ4Z = parcelRequire("IdJ4Z");

var $g2nu2 = parcelRequire("g2nu2");

var $dxcfv = parcelRequire("dxcfv");

var $5kDtB = parcelRequire("5kDtB");

var $OBq1v = parcelRequire("OBq1v");

var $gIh7l = parcelRequire("gIh7l");

var $cwU5v = parcelRequire("cwU5v");

var $4jPhe = parcelRequire("4jPhe");

var $bydlk = parcelRequire("bydlk");

var $hKhBW = parcelRequire("hKhBW");

var $10Vi3 = parcelRequire("10Vi3");

var $kTkui = parcelRequire("kTkui");
const $36bcc4c2ecd08c8e$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix, userBoardId: userBoardId, userBoardOwnerAccountId: userBoardOwnerAccountId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    const accountId = (0, $dxcfv.useAccountId)();
    const profileLink = (0, $3rqlh.useProfileLink)();
    const onSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $eUqFw.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const profileParams = {
        subPath: accountId
    };
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdContent = (0, $1YbJP.testIdConcat)(testId, 'content');
    const testIdFooter = (0, $1YbJP.testIdConcat)(testId, 'footer');
    const [upgradeEditionMenuShown, setUpgradeEditionMenuShown] = (0, $eUqFw.useState)(false);
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const [{ data: jsmOnboardingData }, { fetchOnboardingType: fetchOnboardingType }] = (0, $IdJ4Z.useJsmOnboardingType)();
    (0, $eUqFw.useEffect)(()=>{
        fetchOnboardingType(projectContextData?.projectId, projectContextData?.projectType);
    }, [
        fetchOnboardingType,
        projectContextData?.projectId,
        projectContextData?.projectType
    ]);
    const showInJwmProjects = projectContextData?.projectType === (0, $7ZZxN.CORE_PROJECT);
    const showInSoftwareProjects = projectContextData?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    const showInJsmProjects = projectContextData?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) && jsmOnboardingData?.onboardingType === (0, $65199d54bd54a583$export$6f454e69bce3a691);
    let yourBoardsRoute;
    let yourBoardsParams;
    let yourBoardsQuery;
    if (userBoardId != null) {
        yourBoardsRoute = (0, $eaP1H.userBoardRoute);
        yourBoardsParams = {
            accountId: userBoardOwnerAccountId,
            boardId: String(userBoardId)
        };
    }
    const boardOffset = userBoardId == null ? -1 : 0;
    const notificationOffset = !(0, $1ybV0.ff)('sea-1973-notifications-hub') ? -1 : 0;
    const [userTraits] = (0, $fyk0U.useUserTraits)();
    const showNotificationsNewLozenge = (0, $eUqFw.useMemo)(()=>{
        const accountCreationDate = userTraits?.attributes?.find((trait)=>trait?.name === 'jira_first_active')?.value;
        const aWeekAgo = new Date(Date.now() - 604800000);
        let isNewUser = false;
        if (accountCreationDate && typeof accountCreationDate === 'string') isNewUser = new Date(accountCreationDate) > aWeekAgo;
        return !isNewUser;
    }, [
        userTraits
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // feature flag to check if the notifications hub is enabled
        if ((0, $1ybV0.ff)('sea-1973-notifications-hub')) // The Spotlight components listen to the resize event to
        // update their positioning. This will fix Spotlights pulse overlap
        // that are shown on Menu items. Without this the pulse are located
        /// at incorrect position.
        setTimeout(()=>{
            window.dispatchEvent(new Event('resize'));
        }, 0);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId,
        role: "dialog",
        "aria-labelledby": "atlassian-navigation-account-dialog-heading",
        className: (0, $7JEyt.default)([
            "_syaz1fxt"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIh7l.MenuLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        "data-testid": (0, $1YbJP.testIdConcat)(testIdContent, 'account')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        id: "atlassian-navigation-account-dialog-heading",
        testId: (0, $1YbJP.testIdConcat)(testIdContent, 'account', 'heading')
    }, formatMessage((0, $hKhBW.default).account)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jPhe.AccountDetails // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    ), {
        email: user.emailAddress || '',
        userFullname: user.userFullname,
        avatarSrc: user.avatarUrls ? user.avatarUrls['32x32'] : undefined,
        testId: (0, $1YbJP.testIdConcat)(testIdContent, 'account')
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: upgradeEditionMenuShown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kTkui.UpgradeEditionMenuItem), {
        setUpgradeEditionMenuShown: setUpgradeEditionMenuShown
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: upgradeEditionMenuShown || !upgradeEditionMenuShown,
        testId: testIdContent
    }, (showInJwmProjects || showInSoftwareProjects || showInJsmProjects) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g2nu2.OpenMenuItem), {
        MenuItem: (0, $OBq1v.MenuItem)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": (0, $1YbJP.testIdConcat)(testIdContent, 'jira')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        testId: (0, $1YbJP.testIdConcat)(testIdContent, 'jira', 'heading')
    }, formatMessage((0, $hKhBW.default).jira)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
        ariaLabel: formatMessage((0, $hKhBW.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'profile',
            menuItemType: 'jira',
            position: 0
        },
        href: profileLink,
        params: profileParams,
        testId: (0, $1YbJP.testIdConcat)(testIdContent, 'jira', 'item-profile'),
        to: (0, $1TkEB.peopleProfilesRoute)
    }, formatMessage((0, $hKhBW.default).profile))), userBoardId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
        ariaLabel: formatMessage((0, $hKhBW.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'your-boards',
            menuItemType: 'jira',
            position: 1
        },
        href: `/jira/people/${String(userBoardOwnerAccountId)}/boards/${userBoardId}`,
        params: yourBoardsParams,
        query: yourBoardsQuery,
        testId: (0, $1YbJP.testIdConcat)(testIdContent, 'jira', 'item-your-boards'),
        to: yourBoardsRoute
    }, formatMessage((0, $hKhBW.default).yourBoards))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
        ariaLabel: formatMessage((0, $hKhBW.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'personal-settings',
            menuItemType: 'jira',
            position: 2 + boardOffset
        },
        href: (0, $iJPUk.getGeneralPersonalSettingsPath)(),
        testId: (0, $1YbJP.testIdConcat)(testIdContent, 'jira', 'item-personal-settings'),
        to: (0, $7lcEz.getGeneralPersonalSettingsRouteForLink)()
    }, formatMessage((0, $hKhBW.default).personalSettings))), (0, $1ybV0.ff)('sea-1973-notifications-hub') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
        ariaLabel: formatMessage((0, $hKhBW.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "notifications-menu-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'notifications',
            menuItemType: 'jira',
            position: 3 + boardOffset
        },
        href: (0, $iJPUk.getNotificationsPersonalSettingsPath)(),
        testId: (0, $1YbJP.testIdConcat)(testIdContent, 'jira', 'item-notifications'),
        to: (0, $7lcEz.getNotificationsPersonalSettingsRouteForLink)(),
        iconAfter: showNotificationsNewLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $hKhBW.default).new)) : null
    }, formatMessage((0, $hKhBW.default).notifications)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55pTl.EngagementSpotlight), {
        engagementId: "notifications-menu-spotlight"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
        ariaLabel: formatMessage((0, $hKhBW.default).jira)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $10Vi3.default), {
        testId: (0, $1YbJP.testIdConcat)(testIdContent, 'jira', 'item-theme'),
        itemPosition: 4 + boardOffset + notificationOffset
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bydlk.ExtraItems), {
        startPosition: 5 + boardOffset + notificationOffset,
        testIdPrefix: testIdContent,
        itemAriaLabel: formatMessage((0, $hKhBW.default).jira)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: true,
        testId: testIdFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": (0, $1YbJP.testIdConcat)(testIdFooter, 'items')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'logout',
            menuItemType: 'action',
            position: 0
        },
        href: "/logout",
        testId: (0, $1YbJP.testIdConcat)(testIdFooter, 'items', 'item-log-out')
    }, formatMessage((0, $hKhBW.default).logout))))));
};
const $36bcc4c2ecd08c8e$var$styles = null;

});
parcelRegister("iJPUk", function(module, exports) {

$parcel$export(module.exports, "LEGACY_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$b468ccdb67523656);
$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $97f48d3f13d5b88e$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $97f48d3f13d5b88e$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $97f48d3f13d5b88e$export$64a672523a583594);

var $1ybV0 = parcelRequire("1ybV0");
const $97f48d3f13d5b88e$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $97f48d3f13d5b88e$export$a974f4af282a75ba = '/jira/settings/personal';
const $97f48d3f13d5b88e$export$693b70d1bcef8627 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/general`;
const $97f48d3f13d5b88e$export$21946ea4c58fd4c9 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/notifications`;
const $97f48d3f13d5b88e$export$2321c59d517801c8 = `${$97f48d3f13d5b88e$export$a974f4af282a75ba}/alert-notifications`;
function $97f48d3f13d5b88e$export$db9e3ccc1e5e3317() {
    return (0, $1ybV0.ff)('sea-1973-personal-settings-sidebar') ? $97f48d3f13d5b88e$export$693b70d1bcef8627 : $97f48d3f13d5b88e$export$b468ccdb67523656;
}
function $97f48d3f13d5b88e$export$88a45ae8c4b1c664() {
    return (0, $1ybV0.ff)('sea-1973-personal-settings-sidebar') ? $97f48d3f13d5b88e$export$2321c59d517801c8 : $97f48d3f13d5b88e$export$b468ccdb67523656;
}
function $97f48d3f13d5b88e$export$64a672523a583594() {
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) {
        if ((0, $1ybV0.ff)('sea-1973-notifications-hub')) return $97f48d3f13d5b88e$export$21946ea4c58fd4c9;
        return $97f48d3f13d5b88e$export$693b70d1bcef8627;
    }
    return $97f48d3f13d5b88e$export$b468ccdb67523656;
}

});

parcelRegister("1TkEB", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesRoute", () => $f2e324964119b6ad$export$1338132568be849);

var $exb0h = parcelRequire("exb0h");
const $f2e324964119b6ad$export$1338132568be849 = {
    group: (0, $exb0h.ROUTE_GROUPS_PEOPLE_PROFILES),
    name: (0, $exb0h.ROUTE_NAMES_PEOPLE_INDEX),
    path: '/jira/people/:subPath?'
};

});

parcelRegister("7lcEz", function(module, exports) {

$parcel$export(module.exports, "legacyPersonalSettingsRoute", () => $e67c038bcafcb183$export$dd556eb586bb36b8);
$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $e67c038bcafcb183$export$7a6c9715a86f906b);
$parcel$export(module.exports, "notificationsPersonalSettingsRoute", () => $e67c038bcafcb183$export$55ab09b9d6beb8be);
$parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", () => $e67c038bcafcb183$export$68ebdd4eccb7b383);
$parcel$export(module.exports, "getGeneralPersonalSettingsRouteForLink", () => $e67c038bcafcb183$export$cbf079e07fb96768);
$parcel$export(module.exports, "getNotificationsPersonalSettingsRouteForLink", () => $e67c038bcafcb183$export$9b4c78a3c84b549f);

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $iJPUk = parcelRequire("iJPUk");

var $kZJn3 = parcelRequire("kZJn3");
const $e67c038bcafcb183$export$dd556eb586bb36b8 = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS),
    path: (0, $iJPUk.LEGACY_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$7a6c9715a86f906b = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL),
    path: (0, $iJPUk.GENERAL_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$55ab09b9d6beb8be = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS),
    path: (0, $iJPUk.NOTIFICATIONS_PERSONAL_SETTINGS_PATH),
    skeleton: (0, $kZJn3.PersonalSettingsNotificationsAppSkeleton)
};
const $e67c038bcafcb183$export$68ebdd4eccb7b383 = {
    group: (0, $exb0h.ROUTE_GROUPS_PERSONAL_SETTINGS),
    name: (0, $exb0h.ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS),
    path: (0, $iJPUk.OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH)
};
const $e67c038bcafcb183$export$cbf079e07fb96768 = ()=>{
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) return $e67c038bcafcb183$export$7a6c9715a86f906b;
    return $e67c038bcafcb183$export$dd556eb586bb36b8;
};
const $e67c038bcafcb183$export$9b4c78a3c84b549f = ()=>{
    if ((0, $1ybV0.ff)('sea-1973-personal-settings-sidebar')) {
        if ((0, $1ybV0.ff)('sea-1973-notifications-hub')) return $e67c038bcafcb183$export$55ab09b9d6beb8be;
        return $e67c038bcafcb183$export$7a6c9715a86f906b;
    }
    return $e67c038bcafcb183$export$dd556eb586bb36b8;
};

});
parcelRegister("kZJn3", function(module, exports) {

$parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", () => $0cfb08a5fcfb6db6$export$b542eb2d3193b983);
$parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", () => $0cfb08a5fcfb6db6$export$d58f6bbbc1838cb2);
$parcel$export(module.exports, "MimetypeSelectSkeleton", () => $0cfb08a5fcfb6db6$export$46fc11a564484c9c);
$parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", () => $0cfb08a5fcfb6db6$export$8cb773cb6fc17338);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8ICxF = parcelRequire("8ICxF");

var $cxmEy = parcelRequire("cxmEy");

var $iWH0v = parcelRequire("iWH0v");

var $cSzcb = parcelRequire("cSzcb");

var $fAR4b = parcelRequire("fAR4b");
const $0cfb08a5fcfb6db6$var$maxWidthCssStyles = null;
const $0cfb08a5fcfb6db6$var$customCssStyles = null;
const $0cfb08a5fcfb6db6$export$b542eb2d3193b983 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cSzcb))),
        className: (0, $7JEyt.default)([
            "_p12f8stt _19pkidpf _2hwx1wug _otyridpf _18u01wug"
        ])
    });
const $0cfb08a5fcfb6db6$export$d58f6bbbc1838cb2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cxmEy))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
const $0cfb08a5fcfb6db6$export$46fc11a564484c9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iWH0v))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
const $0cfb08a5fcfb6db6$export$8cb773cb6fc17338 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0cfb08a5fcfb6db6$var$SkeletonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fAR4b))),
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0cfb08a5fcfb6db6$var$SkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71ldgin _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cxmEy", function(module, exports) {
module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();

});

parcelRegister("iWH0v", function(module, exports) {
module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();

});

parcelRegister("cSzcb", function(module, exports) {
module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();

});

parcelRegister("fAR4b", function(module, exports) {
module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();

});



const $65199d54bd54a583$export$6f454e69bce3a691 = 'business';
const $65199d54bd54a583$export$e6952b12ade67489 = 'default';

parcelRegister("IdJ4Z", function(module, exports) {

$parcel$export(module.exports, "useJsmOnboardingType", () => $44b40c173b99e384$export$5daaa68c3a578af9);

var $WBLbN = parcelRequire("WBLbN");

var $5cwB2 = parcelRequire("5cwB2");
const $44b40c173b99e384$export$d4c72bab9d6cc13a = {
    projectId: undefined,
    data: undefined,
    error: undefined,
    isLoading: false
};
const $44b40c173b99e384$var$Store = (0, $WBLbN.createStore)({
    initialState: $44b40c173b99e384$export$d4c72bab9d6cc13a,
    actions: $5cwB2.actions,
    name: 'JSMOnboardingType'
});
const $44b40c173b99e384$export$5daaa68c3a578af9 = (0, $WBLbN.createHook)($44b40c173b99e384$var$Store);

});
parcelRegister("5cwB2", function(module, exports) {

$parcel$export(module.exports, "actions", () => $fefc512f14b5da6b$export$e324594224ef24da);

var $9HBM3 = parcelRequire("9HBM3");
const $fefc512f14b5da6b$export$e324594224ef24da = {
    fetchOnboardingType: $9HBM3.fetchOnboardingType
};

});
parcelRegister("9HBM3", function(module, exports) {

$parcel$export(module.exports, "fetchOnboardingType", () => $8248c0ec122e2236$export$ea62467635172b55);

var $7ZZxN = parcelRequire("7ZZxN");

var $2OdyW = parcelRequire("2OdyW");
const $8248c0ec122e2236$var$getOnboardingTypeUrl = (projectId)=>`/rest/servicedesk/onboarding/1/onboarding-type/project/${projectId}`;
const $8248c0ec122e2236$export$ea62467635172b55 = (projectId, projectType)=>async ({ getState: getState, setState: setState })=>{
        if (!projectId || projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT)) return;
        const { data: data, isLoading: isLoading, projectId: oldProjectId } = getState();
        if (projectId !== oldProjectId) setState({
            data: undefined,
            projectId: undefined
        });
        if (data || isLoading) return;
        setState({
            projectId: projectId,
            isLoading: true,
            error: undefined
        });
        try {
            const onboardingTypeResponse = await (0, $2OdyW.default)($8248c0ec122e2236$var$getOnboardingTypeUrl(String(projectId)));
            setState({
                isLoading: false,
                data: onboardingTypeResponse
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isLoading: false,
                error: error
            });
        }
    };

});



parcelRegister("4jPhe", function(module, exports) {

$parcel$export(module.exports, "AccountDetails", () => $5295475d1fe2f392$export$66e04d0aacdb3b2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $23NQ5 = parcelRequire("23NQ5");

var $bo4OB = parcelRequire("bo4OB");


var $5JgJ2 = parcelRequire("5JgJ2");

var $3rqlh = parcelRequire("3rqlh");

var $1YbJP = parcelRequire("1YbJP");

var $OBq1v = parcelRequire("OBq1v");

var $cwU5v = parcelRequire("cwU5v");

var $atU8h = parcelRequire("atU8h");
const $5295475d1fe2f392$export$66e04d0aacdb3b2 = ({ email: email, userFullname: userFullname, avatarSrc: avatarSrc, testId: testId })=>{
    const atlassianSettingsLink = (0, $3rqlh.useAtlassianPersonalSettingsLink)(email);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5295475d1fe2f392$export$8f1912fff52a55aa, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5295475d1fe2f392$export$33e9904f45a9e453, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5295475d1fe2f392$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5295475d1fe2f392$export$e0d971bef63c8b8f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5295475d1fe2f392$export$101fbca3a406e1fd, null, userFullname), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("small", null, email)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'profileNavigationMenuItem',
            menuItemId: 'manage-account',
            menuItemType: 'account',
            position: 1
        },
        href: atlassianSettingsLink,
        testId: (0, $1YbJP.testIdConcat)(testId, 'manage-account'),
        target: "_blank",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            size: "small",
            primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`,
            label: ""
        })
    }, formatMessage((0, $atU8h.default).manageAccount)))));
};
const $5295475d1fe2f392$export$8f1912fff52a55aa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $bo4OB.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_lcxvglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5295475d1fe2f392$export$33e9904f45a9e453 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $5295475d1fe2f392$export$f7513421c53ce141 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $5295475d1fe2f392$export$101fbca3a406e1fd = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4gktf",
            __cmplp.className
        ])
    });
});
const $5295475d1fe2f392$export$e0d971bef63c8b8f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx29ee3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("atU8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b44fccb345a7aab$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3b44fccb345a7aab$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    manageAccount: {
        "id": "atlassian-navigation.profile.menu.account-details.manage-account",
        "defaultMessage": "Manage account"
    }
});

});


parcelRegister("bydlk", function(module, exports) {

$parcel$export(module.exports, "ExtraItems", () => $341375ea313f4b53$export$56021421a935c353);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $1YbJP = parcelRequire("1YbJP");

var $9CFDS = parcelRequire("9CFDS");

var $lB25E = parcelRequire("lB25E");

var $OBq1v = parcelRequire("OBq1v");

var $cwU5v = parcelRequire("cwU5v");
const $341375ea313f4b53$var$useConnectItems = ()=>{
    const { data: resourceData, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)((0, $9CFDS.navigationSidebarGlobalResource));
    const data = resourceData?.response;
    (0, $eUqFw.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return data ? (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'global.profile.items', []).filter((item)=>![
            'view_profile',
            'log_out'
        ].includes(item.id)) : [];
};
const $341375ea313f4b53$export$56021421a935c353 = ({ startPosition: startPosition, testIdPrefix: testIdPrefix, itemAriaLabel: itemAriaLabel })=>{
    const connectItems = $341375ea313f4b53$var$useConnectItems();
    if (!connectItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, connectItems.map((item, idx)=>{
        // @ts-expect-error - TS2339 - Property 'styleClass' does not exist on type '{ id: string; name: string; url: string; }'.
        const className = item.styleClass;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
            key: item.url,
            ariaLabel: itemAriaLabel || ''
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
            analytics: {
                actionSubjectId: 'profileNavigationMenuItem',
                menuItemId: item.id,
                menuItemType: 'jira',
                position: startPosition + idx
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: item.url,
            testId: (0, $1YbJP.testIdConcat)(testIdPrefix, `item-addon-${idx}`)
        }, item.name));
    }));
};

});

parcelRegister("hKhBW", function(module, exports) {

$parcel$export(module.exports, "default", () => $733bd1d60fa2f21b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $733bd1d60fa2f21b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    giveFeedback: {
        "id": "atlassian-navigation.profile.menu.give-feedback",
        "defaultMessage": "Give us feedback"
    },
    yourBoards: {
        "id": "atlassian-navigation.profile.menu.your-boards",
        "defaultMessage": "Your boards"
    },
    new: {
        "id": "atlassian-navigation.profile.menu.new",
        "defaultMessage": "new"
    },
    personalSettings: {
        "id": "atlassian-navigation.profile.menu.personal-settings",
        "defaultMessage": "Personal settings"
    },
    logout: {
        "id": "atlassian-navigation.profile.menu.logout",
        "defaultMessage": "Log out"
    },
    jira: {
        "id": "atlassian-navigation.profile.menu.jira",
        "defaultMessage": "Jira"
    },
    account: {
        "id": "atlassian-navigation.profile.menu.account",
        "defaultMessage": "Account"
    },
    profile: {
        "id": "atlassian-navigation.profile.menu.profile",
        "defaultMessage": "Profile"
    },
    notifications: {
        "id": "atlassian-navigation.profile.menu.notifications",
        "defaultMessage": "Notifications"
    }
});

});

parcelRegister("10Vi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $186b132f00e3a81d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $iiA4n = parcelRequire("iiA4n");

const $186b132f00e3a81d$export$31f1740ae531af94 = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("dvRxf")), {
    moduleId: "./src/packages/navigation-apps/theme-switcher-menu/src/index.tsx"
});
const $186b132f00e3a81d$var$AsyncThemeSwitcherItem = ({ testId: testId, itemPosition: itemPosition })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "nav-theme-options-list-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iiA4n.default), {
            testId: testId,
            itemPosition: itemPosition,
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($186b132f00e3a81d$export$31f1740ae531af94, {
        renderTriggerButton: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iiA4n.default), {
                testId: testId,
                itemPosition: itemPosition,
                ...props
            })
    }));
var $186b132f00e3a81d$export$2e2bcd8739ae039 = $186b132f00e3a81d$var$AsyncThemeSwitcherItem;

});
parcelRegister("iiA4n", function(module, exports) {

$parcel$export(module.exports, "default", () => $c00b92b11cdf2efd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $dtaN9 = parcelRequire("dtaN9");

var $bULPy = parcelRequire("bULPy");


var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $17n7v = parcelRequire("17n7v");
const $c00b92b11cdf2efd$var$TriggerButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ testId: testId, itemPosition: itemPosition, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ...rest,
        // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
        ref: ref,
        onClick: (e)=>{
            e.stopPropagation();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'navigationMenuItem'
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'profileNavigationMenuItem', {
                menuItemId: 'theme',
                menuItemType: 'jira',
                position: itemPosition
            });
        },
        testId: testId,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`,
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c00b92b11cdf2efd$var$Text, null, formatMessage((0, $17n7v.default).text)));
});
var $c00b92b11cdf2efd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $c00b92b11cdf2efd$var$TriggerButton;
const $c00b92b11cdf2efd$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("17n7v", function(module, exports) {

$parcel$export(module.exports, "default", () => $65dcac77525238a4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $65dcac77525238a4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    text: {
        "id": "atlassian-navigation.profile.menu.theme-switcher-item.trigger-button.text",
        "defaultMessage": "Theme"
    }
});

});


parcelRegister("dvRxf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("6uqbo")
]).then(()=>parcelRequire('7lkyQ'));

});


parcelRegister("kTkui", function(module, exports) {

$parcel$export(module.exports, "UpgradeEditionMenuItem", () => $1559e14dfb4b82b9$export$30403e009ec5f9cd);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $23NQ5 = parcelRequire("23NQ5");

var $ffiyv = parcelRequire("ffiyv");

var $5wpwq = parcelRequire("5wpwq");


var $kDzFH = parcelRequire("kDzFH");

var $3svxt = parcelRequire("3svxt");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $4ksts = parcelRequire("4ksts");

var $cPEpP = parcelRequire("cPEpP");

var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $bFzGY = parcelRequire("bFzGY");

var $6WXNs = parcelRequire("6WXNs");

var $dWlsy = parcelRequire("dWlsy");

var $gd0Sp = parcelRequire("gd0Sp");

var $hsBoj = parcelRequire("hsBoj");

var $lkWwU = parcelRequire("lkWwU");

var $OBq1v = parcelRequire("OBq1v");

var $cwU5v = parcelRequire("cwU5v");


var $7cmVk = parcelRequire("7cmVk");
const $1559e14dfb4b82b9$export$4a94253c58c6e2cb = ({ product: product })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const productEdition = product ? (0, $kDzFH.getProductEdition)(product, tenantContext) : (0, $6WXNs.FREE_EDITION);
    const trialLength = (0, $hsBoj.getTrialLength)(productEdition, (0, $6WXNs.STANDARD_EDITION));
    const freeEditionMenuItemInfo = (0, $7cmVk.getFreeEditionMenuItem)((0, $4ksts.useIntlV2), trialLength);
    const [, { mountUpflowModal: mountUpflowModal }] = (0, $lkWwU.useUpflowModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        eventName: (0, $753ba657a51f7cd1$export$23de212b4b92e749),
        attributes: {
            currentEdition: productEdition,
            growthFeature: (0, $753ba657a51f7cd1$export$2c864ccb7debe0d4),
            touchpointId: freeEditionMenuItemInfo.touchpointId,
            flowId: freeEditionMenuItemInfo.flowId,
            isHideJpdFromUpgradeEditionMenuItemEnabled: (0, $1ybV0.ff)('jsw.onboarding.rollout.kuro-2792'),
            computedProduct: product
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), null, freeEditionMenuItemInfo.heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'persistentUpgradeNavigationMenuItem',
            menuItemId: freeEditionMenuItemInfo.touchpointId,
            menuItemType: 'action',
            position: 0
        },
        onClick: ()=>{
            const analyticEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, (0, $753ba657a51f7cd1$export$2b421d13e998fdbb), {
                currentEdition: productEdition,
                growthFeature: (0, $753ba657a51f7cd1$export$2c864ccb7debe0d4),
                touchpointId: freeEditionMenuItemInfo.touchpointId,
                flowId: freeEditionMenuItemInfo.flowId,
                isHideJpdFromUpgradeEditionMenuItemEnabled: (0, $1ybV0.ff)('jsw.onboarding.rollout.kuro-2792'),
                computedProduct: product
            });
            if (product && freeEditionMenuItemInfo.displayUpflowModal === true) mountUpflowModal({
                targetEdition: (0, $6WXNs.STANDARD_EDITION),
                product: product,
                flow: (0, $753ba657a51f7cd1$export$195e756c24f2ef95),
                touchpointId: freeEditionMenuItemInfo.touchpointId
            });
        },
        href: (0, $7cmVk.getHref)(freeEditionMenuItemInfo, product),
        target: product ? undefined : '_blank',
        iconAfter: product ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            size: "small",
            primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`,
            label: ""
        })
    }, freeEditionMenuItemInfo.content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1559e14dfb4b82b9$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: freeEditionMenuItemInfo.lozengeAppearance,
        isBold: true
    }, freeEditionMenuItemInfo.tagContent, ' '))))));
};
const $1559e14dfb4b82b9$export$8889c148dcb864da = ({ setUpgradeEditionMenuShown: setUpgradeEditionMenuShown })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const explicitlyLicensedProducts = (0, $3svxt.default)(tenantContext);
    const subProduct = (0, $dWlsy.useSubProduct)();
    const { isSiteAdmin: isSiteAdmin } = tenantContext;
    const product = (0, $7cmVk.getJiraProductKey)(subProduct, explicitlyLicensedProducts);
    if (!(0, $7cmVk.shouldRenderMenuItem)(isSiteAdmin, product, explicitlyLicensedProducts, tenantContext)) {
        setUpgradeEditionMenuShown(false);
        return null;
    } // Add separator bar in the menu
    setUpgradeEditionMenuShown(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $753ba657a51f7cd1$export$5fa54bc771a7eb8f),
        packageName: (0, $753ba657a51f7cd1$export$b8b9d90f9e5bd72b),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1559e14dfb4b82b9$export$4a94253c58c6e2cb, {
        product: product
    }));
};
const $1559e14dfb4b82b9$export$43b64e0d428ff93d = ({ setUpgradeEditionMenuShown: setUpgradeEditionMenuShown })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: projectData, loading: projectDataLoading } = (0, $cPEpP.useProject)();
    if (projectDataLoading) return null;
    const { isSiteAdmin: isSiteAdmin } = tenantContext;
    const explicitlyLicensedProducts = (0, $3svxt.default)(tenantContext);
    const applicationKey = (0, $7cmVk.getActivePageApplicationKey)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    projectData?.type, explicitlyLicensedProducts);
    if (!(0, $7cmVk.shouldRenderMenuItem)(isSiteAdmin, applicationKey, explicitlyLicensedProducts, tenantContext)) {
        setUpgradeEditionMenuShown(false);
        return null;
    } // Add separator bar in the menu
    setUpgradeEditionMenuShown(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $753ba657a51f7cd1$export$5fa54bc771a7eb8f),
        packageName: (0, $753ba657a51f7cd1$export$b8b9d90f9e5bd72b),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1559e14dfb4b82b9$export$4a94253c58c6e2cb, {
        product: applicationKey
    }));
};
const $1559e14dfb4b82b9$export$30403e009ec5f9cd = (0, $bAQOb.componentWithFF)('jsw.onboarding.rollout.kuro-2792', $1559e14dfb4b82b9$export$43b64e0d428ff93d, $1559e14dfb4b82b9$export$8889c148dcb864da); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1559e14dfb4b82b9$var$LozengeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kDzFH", function(module, exports) {

$parcel$export(module.exports, "getProductEdition", () => $f3ca75df413b6183$export$53e066a63a960439);

const $f3ca75df413b6183$export$53e066a63a960439 = (product, tenantContext)=>{
    if (product === (0, $2edfd53057852e41$export$1346c9aa3cbb477d)) return tenantContext.appEditions.software;
    if (product === (0, $2edfd53057852e41$export$c8c1c8c3f8ddba61)) return tenantContext.appEditions.serviceDesk;
    return tenantContext.appEditions.core;
};

});

parcelRegister("bAQOb", function(module, exports) {

$parcel$export(module.exports, "componentWithFF", () => $a2b6ad64f224d7cd$export$377d327ec8da8be);

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");
const $a2b6ad64f224d7cd$export$377d327ec8da8be = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)(featureFlagName), ComponentTrue, ComponentFalse);

});

parcelRegister("hsBoj", function(module, exports) {

$parcel$export(module.exports, "getTrialLength", () => $2421475aad184296$export$23d271f9e8cb9c4);

var $6WXNs = parcelRequire("6WXNs");

const $2421475aad184296$export$23d271f9e8cb9c4 = (currentEdition, targetEdition)=>{
    if (currentEdition === (0, $6WXNs.FREE_EDITION) && targetEdition === (0, $6WXNs.STANDARD_EDITION)) return 0, $6705c77069c290bf$export$b7a3952d12e24333;
    return 0, $6705c77069c290bf$export$940ef4a039f45970;
};

});
const $6705c77069c290bf$export$b7a3952d12e24333 = 14;
const $6705c77069c290bf$export$940ef4a039f45970 = 30;


parcelRegister("lkWwU", function(module, exports) {

$parcel$export(module.exports, "useUpflowModal", () => $6c104b62a30eb483$export$7025cc2729b71e44);

var $6WXNs = parcelRequire("6WXNs");

var $WBLbN = parcelRequire("WBLbN");

const $6c104b62a30eb483$var$initialState = {
    renderUpflowModal: false,
    product: 'jira-software',
    touchpointId: '',
    flow: 'learn-more',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{},
    targetEdition: (0, $6WXNs.FREE_EDITION)
};
const $6c104b62a30eb483$var$actions = {
    mountUpflowModal: ({ targetEdition: targetEdition, product: product, flow: flow, touchpointId: touchpointId, subRoute: subRoute, onClose: onClose, onOpen: onOpen })=>({ setState: setState })=>{
            setState({
                targetEdition: targetEdition,
                product: product,
                flow: flow,
                touchpointId: touchpointId,
                subRoute: subRoute,
                onClose: onClose,
                onOpen: onOpen,
                renderUpflowModal: true
            });
        },
    unMountUpflowModal: ()=>({ setState: setState })=>{
            setState({
                renderUpflowModal: false
            });
        }
};
const $6c104b62a30eb483$var$Store = (0, $WBLbN.createStore)({
    name: (0, $d44c5d835865cf92$export$675a4427bf3750a2),
    initialState: $6c104b62a30eb483$var$initialState,
    actions: $6c104b62a30eb483$var$actions
});
const $6c104b62a30eb483$export$6d73384be122c2dd = (0, $WBLbN.createSubscriber)($6c104b62a30eb483$var$Store);
const $6c104b62a30eb483$export$e672be732bd57171 = (0, $WBLbN.createContainer)($6c104b62a30eb483$var$Store);
const $6c104b62a30eb483$export$7025cc2729b71e44 = (0, $WBLbN.createHook)($6c104b62a30eb483$var$Store);

});
const $d44c5d835865cf92$export$675a4427bf3750a2 = 'upflow-modal-store';


const $753ba657a51f7cd1$export$ad9850d60736acbb = 'jira-software';
const $753ba657a51f7cd1$export$195e756c24f2ef95 = 'persistent-upgrade';
const $753ba657a51f7cd1$export$2c864ccb7debe0d4 = 'persistentUpgrade';
const $753ba657a51f7cd1$export$b8b9d90f9e5bd72b = 'persistentUpgrade';
const $753ba657a51f7cd1$export$5fa54bc771a7eb8f = 'persistentUpgradeMenu';
const $753ba657a51f7cd1$export$2b421d13e998fdbb = 'persistentUpgradeMenu clicked';
const $753ba657a51f7cd1$export$23de212b4b92e749 = 'persistentUpgradeMenu viewed';

parcelRegister("7cmVk", function(module, exports) {

$parcel$export(module.exports, "shouldRenderMenuItem", () => $58bbfc573a224c1b$export$6335c904eace2f3);
$parcel$export(module.exports, "getFreeEditionMenuItem", () => $58bbfc573a224c1b$export$cce6104d08ee5a15);
$parcel$export(module.exports, "getJiraProductKey", () => $58bbfc573a224c1b$export$636823a5af1468e4);
$parcel$export(module.exports, "getActivePageApplicationKey", () => $58bbfc573a224c1b$export$44df08af6d5522d3);
$parcel$export(module.exports, "getHref", () => $58bbfc573a224c1b$export$81842c1ae19d378b);

var $7ZZxN = parcelRequire("7ZZxN");

var $kDzFH = parcelRequire("kDzFH");


var $6WXNs = parcelRequire("6WXNs");

var $3TN2n = parcelRequire("3TN2n");
const $58bbfc573a224c1b$var$isFreeEdition = (product, tenantContext)=>{
    const productEdition = (0, $kDzFH.getProductEdition)(product, tenantContext);
    return productEdition === (0, $6WXNs.FREE_EDITION);
};
const $58bbfc573a224c1b$var$productIsJSMOrJSW = (product)=>product === (0, $2edfd53057852e41$export$1346c9aa3cbb477d) || product === (0, $2edfd53057852e41$export$c8c1c8c3f8ddba61);
const $58bbfc573a224c1b$var$hasFreeJSMOrJSW = (explicitlyLicensedProducts, tenantContext)=>explicitlyLicensedProducts.some((product)=>$58bbfc573a224c1b$var$productIsJSMOrJSW(product) && $58bbfc573a224c1b$var$isFreeEdition(product, tenantContext));
const $58bbfc573a224c1b$export$6335c904eace2f3 = (isSiteAdmin, product, explicitlyLicensedProducts, tenantContext)=>{
    if (!isSiteAdmin) return false;
    if (!product) // If we're on a product-agnostic page (e.g "Your Work") we can still render the menu item
    // as long as there is a free JSM or JSW. The menu item will link to the "Manage Subscriptions" page.
    return $58bbfc573a224c1b$var$hasFreeJSMOrJSW(explicitlyLicensedProducts, tenantContext);
    // If we're in JSM or JSW Free, render the menu item.
    if (product && $58bbfc573a224c1b$var$productIsJSMOrJSW(product)) return $58bbfc573a224c1b$var$isFreeEdition(product, tenantContext);
    return false;
};
const $58bbfc573a224c1b$export$cce6104d08ee5a15 = (intl, trialLength)=>({
        heading: intl().formatMessage((0, $3TN2n.default).upgrade),
        content: intl().formatMessage((0, $3TN2n.default).tryStandardPlan),
        tagContent: intl().formatMessage((0, $3TN2n.default).trialPeriod, {
            trialLength: trialLength
        }),
        lozengeAppearance: 'inprogress',
        touchpointId: 'preTrialMenu',
        flowId: 'upgradeFlow',
        displayUpflowModal: true
    });
const $58bbfc573a224c1b$export$636823a5af1468e4 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $2edfd53057852e41$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61;
    if (subProduct === 'core') return 0, $2edfd53057852e41$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work"
    // In there is only one licensed product, we can infer what the user is using
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};
const $58bbfc573a224c1b$export$b6487772e5a4e151 = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 0, $2edfd53057852e41$export$1346c9aa3cbb477d;
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61;
        case 0, $7ZZxN.CORE_PROJECT:
            return 0, $2edfd53057852e41$export$db515c8cec1e6f79;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return 0, $2edfd53057852e41$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $58bbfc573a224c1b$export$44df08af6d5522d3 = (projectType, explicitlyLicensedProducts)=>{
    const applicationKey = $58bbfc573a224c1b$export$b6487772e5a4e151(projectType);
    if (applicationKey !== null) return applicationKey;
    // If applicationKey is null, we may be on a product-agnostic page e.g. "Your Work"
    // In there is only one licensed product, we can infer what the user is using
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};
const $58bbfc573a224c1b$export$81842c1ae19d378b = (freeEditionMenuItemInfo, product)=>{
    if (!product) return '/admin/billing/applications';
    return freeEditionMenuItemInfo.href ? freeEditionMenuItemInfo.href(freeEditionMenuItemInfo.touchpointId) : '';
};

});
parcelRegister("3TN2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $196094cd0b554a70$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $196094cd0b554a70$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    upgrade: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.upgrade",
        "defaultMessage": "upgrade"
    },
    tryStandardPlan: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.try-standard-plan",
        "defaultMessage": "Try the Standard plan"
    },
    trialPeriod: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.trial-period",
        "defaultMessage": "free {trialLength}-day trial"
    }
});

});




parcelRegister("2P9B5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2dc16f4b3e962b3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e2dc16f4b3e962b3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "atlassian-navigation.profile.tooltip",
        "defaultMessage": "Your profile and settings"
    }
});

});


parcelRegister("BS0xO", function(module, exports) {

$parcel$export(module.exports, "Projects", () => $69daeb50d9fbdd94$export$ca6fbb51b35e375c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $kh69L = parcelRequire("kh69L");

var $aYr7q = parcelRequire("aYr7q");

var $1NbhG = parcelRequire("1NbhG");

var $bDhRl = parcelRequire("bDhRl");

var $arAkG = parcelRequire("arAkG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $b8yDh = parcelRequire("b8yDh");

var $7vTKl = parcelRequire("7vTKl");

var $71CzX = parcelRequire("71CzX");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gGJaE = parcelRequire("gGJaE");

var $kS8l2 = parcelRequire("kS8l2");

var $hb3Di = parcelRequire("hb3Di");

var $jAsMI = parcelRequire("jAsMI");

var $dxcfv = parcelRequire("dxcfv");

var $ab6rA = parcelRequire("ab6rA");

var $6yplV = parcelRequire("6yplV");

var $4xHig = parcelRequire("4xHig");

var $gd0Sp = parcelRequire("gd0Sp");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $olGf9 = parcelRequire("olGf9");

var $bAd0L = parcelRequire("bAd0L");

var $hjjUy = parcelRequire("hjjUy");

var $6yD1B = parcelRequire("6yD1B");
const $69daeb50d9fbdd94$var$ProjectsAnonymous = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const baseUrl = '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $olGf9.MenuTrigger), {
        href: `${baseUrl}/jira/projects`,
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).PROJECTS
    }, formatMessage((0, $6yD1B.default).projects));
};
const $69daeb50d9fbdd94$var$ProjectsLoggedIn = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const locale = (0, $4xHig.useLocale)();
    const accountId = (0, $dxcfv.useAccountId)();
    const { cloudId: cloudId, licensedProducts: licensedProducts, firstActivationDateMs: firstActivationDateMs, areProductSuggestionsEnabled: areProductSuggestionsEnabled } = (0, $gd0Sp.useTenantContext)();
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    const [{ hasFetchedOnce: hasFetchedOnceFavorites }, { loadFavoriteProjects: loadFavorite }] = (0, $arAkG.useFavoriteProjects)();
    const [, { loadRecentProjects: loadRecent }] = (0, $gGJaE.useRecentProjects)();
    const [, { loadRecommendations: loadRecommendations }] = (0, $kh69L.useProjectMenuRecommendations)();
    const { software: edition } = (0, $ab6rA.useAppEditions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const [{ hasSuccessOnce: hasFetchedCreateProjectPermissions, canCreateProject: canCreateProject }] = (0, $b8yDh.useCreateProjectPermission)();
    const onStart = (0, $bDhRl.useExperienceStart)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $5kDtB.NAVIGATION_ITEM_ID).PROJECTS,
        analyticsSource: 'atlassian-navigation'
    });
    const onBeforeMenuOpen = (0, $eUqFw.useCallback)(()=>{
        onStart();
        (0, $aYr7q.projectsMenuDropdownRecommendationSelector).start();
        // refresh recents on open to add recently visited pages
        loadRecent((0, $5kDtB.DEFAULT_LOAD_COUNT_RECENT));
        if (accountId) {
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown viewed', 'projectsMenuDropdown');
            if (hasFetchedCreateProjectPermissions) loadRecommendations((0, $1NbhG.recommendations), {
                locale: locale,
                cloudId: cloudId,
                accountId: accountId,
                licensedProducts: licensedProducts,
                edition: edition,
                firstActivationDateMs: firstActivationDateMs,
                areProductSuggestionsEnabled: areProductSuggestionsEnabled,
                environment: environment,
                canCreateProject: canCreateProject
            }, createAnalyticsEvent({}));
        }
        // load favourites only if not loaded already (optimisation to reduce requests)
        if (!hasFetchedOnceFavorites) loadFavorite((0, $5kDtB.DEFAULT_LOAD_COUNT_FAV));
    }, [
        onStart,
        loadRecent,
        accountId,
        hasFetchedOnceFavorites,
        loadFavorite,
        createAnalyticsEvent,
        hasFetchedCreateProjectPermissions,
        loadRecommendations,
        locale,
        cloudId,
        licensedProducts,
        edition,
        firstActivationDateMs,
        areProductSuggestionsEnabled,
        environment,
        canCreateProject
    ]);
    const onRef = (0, $eUqFw.useCallback)((ref)=>{
        // We want the last of these nodes, but can spotlight as a fallback any intermediaries
        // It may cause the spotlight border to be bigger than intended (around the entire block element)
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const refToFirstChild = ref && ref.firstChild;
        const refToFirstGrandchild = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refToFirstChild && refToFirstChild.firstChild;
        const refToFirstGreatGrandchild = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refToFirstGrandchild && refToFirstGrandchild.firstChild;
        register(`NAVIGATION_${(0, $7vTKl.MENU_ID).PROJECTS}`, refToFirstGreatGrandchild || refToFirstGrandchild || refToFirstChild || ref);
    }, [
        register
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69daeb50d9fbdd94$export$e6dfd72ab29f8598, {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hb3Di.ConditionalNudgeWrapper), {
        conditionsToApplyWrapper: (0, $71CzX.isUserEnrolledInTailoredOnboardingExperiment)(),
        Wrapper: (0, $jAsMI.ManageProjectsNudgeAsync)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bAd0L.Popup), {
        menuId: (0, $7vTKl.MENU_ID).PROJECTS,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).PROJECTS,
        Menu: (0, $hjjUy.Menu),
        onBeforeMenuOpen: onBeforeMenuOpen,
        label: formatMessage((0, $6yD1B.default).projects)
    }, formatMessage((0, $6yD1B.default).projects))));
};
const $69daeb50d9fbdd94$var$ProjectWithAuth = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69daeb50d9fbdd94$var$ProjectsAnonymous, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69daeb50d9fbdd94$var$ProjectsLoggedIn, null);
};
const $69daeb50d9fbdd94$export$ca6fbb51b35e375c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).PROJECTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69daeb50d9fbdd94$var$ProjectWithAuth, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $69daeb50d9fbdd94$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _4t3i1osq _ae4v1h6o _11l41osq",
            false && "_1kibidpf _1laeidpf _1f5yidpf _kq8jidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kS8l2", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $450c796f66462b96$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $450c796f66462b96$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $450c796f66462b96$export$6b4b878b04fd3017);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");
const $450c796f66462b96$var$store = (0, $WBLbN.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $450c796f66462b96$export$4beaa3baa53198e4 = (0, $WBLbN.createContainer)($450c796f66462b96$var$store);
const $450c796f66462b96$var$useGlobalRefStateSelector = (0, $WBLbN.createStateHook)($450c796f66462b96$var$store, {
    selector: (state, key)=>state[key]
});
const $450c796f66462b96$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $450c796f66462b96$var$useGlobalRefStateSelector(key)
    ];
const $450c796f66462b96$export$3c6c6911d09d7d8a = (0, $WBLbN.createHook)($450c796f66462b96$var$store, {
    selector: null
});
const $450c796f66462b96$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $450c796f66462b96$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});

parcelRegister("jAsMI", function(module, exports) {

$parcel$export(module.exports, "ManageProjectsNudgeAsync", () => $b4411a4ff1667e9a$export$7e3b51e48486c85e);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");



var $105cx = parcelRequire("105cx");

var $4rAiR = parcelRequire("4rAiR");
const $b4411a4ff1667e9a$var$runtimeProps = {};
const $b4411a4ff1667e9a$var$entryPointParams = {};
const $b4411a4ff1667e9a$export$7e3b51e48486c85e = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $4rAiR.manageProjectsNudgeEntryPoint), $b4411a4ff1667e9a$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: manageProjectsNudgeRef } = (0, $105cx.useRegisterNudgeTarget)((0, $8379f5d78bf6fb5a$export$73278890f736ee6f), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ref: manageProjectsNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: (0, $99a775c02d636a41$export$4d6567e7ee0281bf),
        packageName: "jiraManageProjectsOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        runtimeProps: $b4411a4ff1667e9a$var$runtimeProps
    }));
};

});
parcelRegister("4rAiR", function(module, exports) {

$parcel$export(module.exports, "manageProjectsNudgeEntryPoint", () => $650f4d1d2e8a74f6$export$cbcb0caf304a7041);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $650f4d1d2e8a74f6$export$cbcb0caf304a7041 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("f9Drn")), {
        moduleId: "6530fbf9"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("f9Drn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("4OF9g").then(()=>parcelRequire('fKVNy'));

});



parcelRegister("hjjUy", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $7966b2e9e4d52b07$export$d9b273488cd8ce6f);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");

var $ltfxy = parcelRequire("ltfxy");

var $1NbhG = parcelRequire("1NbhG");

var $dk4gT = parcelRequire("dk4gT");

var $jasPp = parcelRequire("jasPp");

var $0cdA8 = parcelRequire("0cdA8");

var $4qhD6 = parcelRequire("4qhD6");

var $arAkG = parcelRequire("arAkG");

var $b8yDh = parcelRequire("b8yDh");

var $7vTKl = parcelRequire("7vTKl");

var $1YbJP = parcelRequire("1YbJP");

var $gGtKh = parcelRequire("gGtKh");

var $5kDtB = parcelRequire("5kDtB");

var $7VDWq = parcelRequire("7VDWq");

var $gIh7l = parcelRequire("gIh7l");

var $j5uqN = parcelRequire("j5uqN");

var $43NDK = parcelRequire("43NDK");

var $b3y03 = parcelRequire("b3y03");

var $4NzMQ = parcelRequire("4NzMQ");

var $jzQaS = parcelRequire("jzQaS");

var $72zHm = parcelRequire("72zHm");

var $jO053 = parcelRequire("jO053");
const $7966b2e9e4d52b07$var$EVENT_DATA = {
    id: (0, $7vTKl.MENU_ID).PROJECTS
};
const $7966b2e9e4d52b07$export$d9b273488cd8ce6f = ({ AuthenticationErrorBoundary: AuthenticationErrorBoundary = (0, $jasPp.AuthenticationErrorBoundary), Empty: Empty = (0, $b3y03.Empty), Error: Error = (0, $7VDWq.MenuError), FavoriteContent: FavoriteContent = (0, $4NzMQ.FavoriteContent), Footer: Footer = (0, $jzQaS.Footer), JSErrorBoundary: JSErrorBoundary = (0, $0cdA8.JSErrorBoundary), Layout: Layout = (0, $gIh7l.MenuLayout), LoadStatus: LoadStatus = (0, $72zHm.LoadStatus), RecentContent: RecentContent = (0, $jO053.RecentContent), RecommendationSelector: RecommendationSelector = (0, $dk4gT.RecommendationSelector), recommendations: recommendations = (0, $1NbhG.recommendations), Section: Section = (0, $8BKky.default), SkeletonContent: SkeletonContent = (0, $j5uqN.MenuSkeletonContent), SkeletonFooter: SkeletonFooter = (0, $43NDK.MenuSkeletonFooter), SpotlightTarget: SpotlightTarget = (0, $ltfxy.default), testIdPrefix: testIdPrefix, useCreateProjectPermission: // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly fetchCreateProjectPermission: (baseUrl: string) => Action<State, void, void | Promise<void>>; }>, void>' is not assignable to type 'UseCreateProjectPermissionType'.
useCreateProjectPermission = (0, $b8yDh.useCreateProjectPermission), useExperienceFail: useExperienceFail = (0, $4qhD6.useExperienceFail), useFavorite: useFavorite = (0, $arAkG.useFavoriteProjects) })=>{
    const [, { loadFavoriteProjects: loadFavorite }] = useFavorite();
    const [{ hasFetchedOnce: hasFetchedOncePermissions, isFetching: isFetching }, { fetchCreateProjectPermission: fetchCreateProjectPermission }] = useCreateProjectPermission();
    const onFail = useExperienceFail({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $eUqFw.useEffect)(()=>()=>{
            // Refresh favourites on close to update if user has toggled any item
            loadFavorite((0, $5kDtB.DEFAULT_LOAD_COUNT_FAV));
        }, [
        loadFavorite
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!hasFetchedOncePermissions && !isFetching) fetchCreateProjectPermission();
    }, [
        hasFetchedOncePermissions,
        isFetching,
        fetchCreateProjectPermission
    ]);
    const testIdContent = (0, $1YbJP.testIdConcat)(testIdPrefix, 'content');
    const testIdFooter = (0, $1YbJP.testIdConcat)(testIdPrefix, 'footer');
    const errorFallback = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Error, {
            testIdPrefix: testIdContent
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testIdContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SpotlightTarget, {
        name: (0, $5kDtB.PROJECTS_SPOTLIGHT_KEY)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Layout, {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        isScrollable: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(JSErrorBoundary, {
        id: (0, $7vTKl.MENU_ID).PROJECTS,
        packageName: (0, $5kDtB.PACKAGE_NAME),
        fallback: errorFallback,
        withExperienceTracker: true,
        extraEventData: $7966b2e9e4d52b07$var$EVENT_DATA,
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AuthenticationErrorBoundary, {
        render: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Empty, {
        testIdPrefix: testIdContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonContent, {
            testIdPrefix: testIdContent
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatus, {
        shouldThrowError: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FavoriteContent, {
        testIdPrefix: testIdContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RecentContent, {
        testIdPrefix: testIdContent
    })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(RecommendationSelector, {
        recommendations: recommendations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Section, {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "footer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SkeletonFooter, {
            testIdPrefix: testIdFooter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatus, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Footer, {
        testIdPrefix: testIdFooter
    })))));
};

});
parcelRegister("dk4gT", function(module, exports) {

$parcel$export(module.exports, "RecommendationSelector", () => $a566ad164061bc3f$export$f97cd4c3e697ffee);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $8WuJm = parcelRequire("8WuJm");

var $6Qy8u = parcelRequire("6Qy8u");

var $kh69L = parcelRequire("kh69L");

var $aYr7q = parcelRequire("aYr7q");
const $a566ad164061bc3f$export$f97cd4c3e697ffee = ({ recommendations: recommendations })=>{
    const [state] = (0, $kh69L.useProjectMenuRecommendations)();
    if (state.status !== 'success') return null;
    const selectedRecommendation = recommendations.find((recommendation)=>recommendation.key === state.recommendationKey);
    return selectedRecommendation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: `projects-menu-recommendation.${selectedRecommendation.key}`,
        packageName: "jiraAtlassianNavigationRecommendations",
        onError: ()=>(0, $aYr7q.projectsMenuDropdownRecommendationSelector).failure(),
        fallback: "unmount",
        teamName: "navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            recommendationKey: selectedRecommendation.key
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Qy8u.ExperienceSuccess), {
        experience: (0, $aYr7q.projectsMenuDropdownRecommendationSelector)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(selectedRecommendation.Component, null))) : null;
};

});

parcelRegister("b3y03", function(module, exports) {

$parcel$export(module.exports, "Empty", () => $fd05dcda4080faa0$export$1f74963c34e8bfec);

var $eUqFw = parcelRequire("eUqFw");

var $1Yimi = parcelRequire("1Yimi");

var $fDZ6r = parcelRequire("fDZ6r");

var $arAkG = parcelRequire("arAkG");

var $4ksts = parcelRequire("4ksts");

var $1YbJP = parcelRequire("1YbJP");

var $gGJaE = parcelRequire("gGJaE");

var $6yplV = parcelRequire("6yplV");

var $5kDtB = parcelRequire("5kDtB");

var $hhftg = parcelRequire("hhftg");

var $1MAQq = parcelRequire("1MAQq");

var $5gYj0 = parcelRequire("5gYj0");

var $a9WRu = parcelRequire("a9WRu");
const $fd05dcda4080faa0$var$learnMoreHref = 'https://confluence.atlassian.com/adminjiracloud/creating-editing-deleting-and-hiding-projects-844500729.html';
const $fd05dcda4080faa0$export$1f74963c34e8bfec = ({ MenuInfo: MenuInfo = (0, $hhftg.MenuInfo), children: children, testIdPrefix: testIdPrefix, useExperienceSuccess: useExperienceSuccess = (0, $fDZ6r.useExperienceSuccess), useFavorite: useFavorite = (0, $arAkG.useFavoriteProjects), useIntl: useIntl = (0, $4ksts.useIntlV2), useIsAnonymous: useIsAnonymous = (0, $6yplV.useIsAnonymous), useItems: useItems = (0, $1MAQq.useProjectNavItems), useRecent: useRecent = (0, $gGJaE.useRecentProjects) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = useIsAnonymous();
    const onSuccess = useExperienceSuccess({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    const text = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $a9WRu.default).emptyText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: $fd05dcda4080faa0$var$learnMoreHref,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $a9WRu.default).learnMore))));
    const [{ isFetching: isFetchingFavorite, hasSuccessOnce: hasSuccessOnceFavorite, fetchError: fetchErrorFavorite }] = useFavorite();
    const [{ isFetching: isFetchingRecent, hasSuccessOnce: hasSuccessOnceRecent, fetchError: fetchErrorRecent }] = useRecent();
    const { favoriteItems: favoriteItems, recentItems: recentItems } = useItems();
    const notEmpty = favoriteItems.length || //  should show fav items
    recentItems.length || // should show recent items
    isFetchingFavorite && !hasSuccessOnceFavorite || // should show fav skeleton
    isFetchingRecent && !hasSuccessOnceRecent || // should show recent skeleton
    fetchErrorFavorite || // should show error
    fetchErrorRecent; // should show error
    // it appears that when fetch error get thrown in loadstatus, the promise is still pending here
    // let's take the most simple approach for now
    const shouldShowEmptyForAnonymous = isAnonymous;
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'empty');
    (0, $eUqFw.useEffect)(()=>{
        const isSuccess = hasSuccessOnceFavorite && hasSuccessOnceRecent;
        if (isSuccess) onSuccess();
    }, [
        hasSuccessOnceFavorite,
        hasSuccessOnceRecent,
        onSuccess
    ]);
    return notEmpty && !shouldShowEmptyForAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuInfo, {
        imgAltText: formatMessage((0, $a9WRu.default).emptyImg),
        imgSrc: (0, (/*@__PURE__*/$parcel$interopDefault($5gYj0))),
        imgHeight: 138,
        testId: testId,
        text: text
    });
};

});
parcelRegister("5gYj0", function(module, exports) {
module.exports = new URL("project-empty.0864e274.svg", import.meta.url).toString();

});

parcelRegister("a9WRu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8394754a56df5345$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8394754a56df5345$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyText: {
        "id": "atlassian-navigation.projects.menu.empty.empty-text",
        "defaultMessage": "Make the most of your Atlassian products by extending them with projects."
    },
    learnMore: {
        "id": "atlassian-navigation.projects.menu.empty.learn-more",
        "defaultMessage": "Learn more"
    },
    emptyImg: {
        "id": "atlassian-navigation.projects.menu.empty.empty-img",
        "defaultMessage": "An image showing that the projects dropdown menu is empty"
    }
});

});


parcelRegister("4NzMQ", function(module, exports) {

$parcel$export(module.exports, "FavoriteContent", () => $8dad89e1e645f3c8$export$297af018011b145a);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $5wpwq = parcelRequire("5wpwq");

var $jrdvV = parcelRequire("jrdvV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3rqlh = parcelRequire("3rqlh");

var $1YbJP = parcelRequire("1YbJP");

var $5kDtB = parcelRequire("5kDtB");

var $ba6Jq = parcelRequire("ba6Jq");

var $OBq1v = parcelRequire("OBq1v");

var $cwU5v = parcelRequire("cwU5v");

var $ctol0 = parcelRequire("ctol0");

var $1MAQq = parcelRequire("1MAQq");

var $8rQNt = parcelRequire("8rQNt");
const $8dad89e1e645f3c8$export$297af018011b145a = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $1MAQq.useProjectNavItems)();
    const itemsToShow = (0, $eUqFw.useMemo)(()=>favoriteItems.slice(0, (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV)), [
        favoriteItems
    ]);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items-starred');
    const projectsUrl = '/jira/projects?page=1&sortKey=favourite&sortOrder=DESC';
    return favoriteItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        testId: (0, $1YbJP.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $8rQNt.default).starred)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { params: params, query: query, route: to } = (0, $3rqlh.getLinkFromProject)(item);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $8rQNt.default).starred)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
            analytics: {
                actionSubjectId: 'projectsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'starred',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                appearance: "square",
                size: "small",
                borderColor: "transparent",
                src: item.avatarUrl
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ba6Jq.FavoriteButton), {
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "starred",
                onChangeFavorite: onChangeFavorite,
                type: (0, $jrdvV.PROJECTS_ITEM_TYPE)
            }),
            params: params,
            query: query,
            testId: (0, $1YbJP.testIdConcat)(testId, `item-${idx}`),
            to: to
        }, title));
    })), favoriteItems.length >= (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctol0.MenuItemViewAll), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'viewAll',
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            position: (0, $5kDtB.DEFAULT_LOAD_COUNT_FAV)
        },
        href: projectsUrl,
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-view-all'),
        to: projectsUrl
    })) : null;
};

});
parcelRegister("8rQNt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64a8e6504fbe90a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f64a8e6504fbe90a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    starred: {
        "id": "atlassian-navigation.projects.menu.favorite-content.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("jzQaS", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $4af57338a760f9bf$export$a06f1c675e846f6f);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $b8yDh = parcelRequire("b8yDh");

var $1YbJP = parcelRequire("1YbJP");

var $1iihP = parcelRequire("1iihP");

var $4HwSc = parcelRequire("4HwSc");

var $6yplV = parcelRequire("6yplV");

var $5kDtB = parcelRequire("5kDtB");

var $OBq1v = parcelRequire("OBq1v");

var $krF0o = parcelRequire("krF0o");
const $4af57338a760f9bf$export$a06f1c675e846f6f = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const [, { on: openProjectCreateDrawer }] = (0, $4HwSc.useSwitchModals)((0, $5kDtB.MODAL_ID).PROJECT_CREATE);
    const [{ canCreateProject: canCreateProject }] = (0, $b8yDh.useCreateProjectPermission)();
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'viewAll',
            menuItemType: 'action',
            position: 0
        },
        href: "/jira/projects",
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-view-all'),
        to: (0, $1iihP.projectsDirectoryRoute)
    }, formatMessage((0, $krF0o.default).viewAll)), !isAnonymous && canCreateProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'projectsNavigationMenuItem',
            menuItemId: 'create',
            menuItemType: 'action',
            position: 1
        },
        onClick: openProjectCreateDrawer,
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-create')
    }, formatMessage((0, $krF0o.default).createProject)));
};

});
parcelRegister("1iihP", function(module, exports) {

$parcel$export(module.exports, "projectsDirectoryRoute", () => $24be186849539eb4$export$74114064f06cd71b);
$parcel$export(module.exports, "manageProjectsDirectoryRoute", () => $24be186849539eb4$export$281a4490a0f8fb4c);
$parcel$export(module.exports, "projectsDirectoryRedirectRoute", () => $24be186849539eb4$export$d44f1be3782f0fde);
$parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", () => $24be186849539eb4$export$c713f57300a82898);
$parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", () => $24be186849539eb4$export$dbd3b6c012e8b6dc);
$parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", () => $24be186849539eb4$export$4531e3b2e25fad23);

var $exb0h = parcelRequire("exb0h");
const $24be186849539eb4$export$74114064f06cd71b = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY),
    path: '/jira/projects',
    exact: true
};
const $24be186849539eb4$export$281a4490a0f8fb4c = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE),
    path: '/jira/settings/projects/manage'
};
const $24be186849539eb4$export$d44f1be3782f0fde = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY)}-redirect`,
    path: '/projects',
    exact: true
};
const $24be186849539eb4$export$c713f57300a82898 = {
    group: (0, $exb0h.ROUTE_GROUPS_DIRECTORIES),
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA)}-redirect`,
    path: '/secure/BrowseProjects.jspa'
};
const $24be186849539eb4$export$dbd3b6c012e8b6dc = {
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-redirect`,
    path: '/secure/project/ViewProjects.jspa'
};
const $24be186849539eb4$export$4531e3b2e25fad23 = {
    name: `${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-root-redirect`,
    path: '/jira/settings/projects',
    exact: true
};

});

parcelRegister("krF0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $161a4b1673cce111$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $161a4b1673cce111$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createProject: {
        "id": "atlassian-navigation.projects.menu.footer.create-project",
        "defaultMessage": "Create project"
    },
    viewAll: {
        "id": "atlassian-navigation.projects.menu.footer.view-all",
        "defaultMessage": "View all projects"
    },
    importProject: {
        "id": "atlassian-navigation.projects.menu.footer.import-project",
        "defaultMessage": "Import project"
    }
});

});


parcelRegister("72zHm", function(module, exports) {

$parcel$export(module.exports, "LoadStatus", () => $1618fa711075fd98$export$c7df4a3f1b89de01);

var $eUqFw = parcelRequire("eUqFw");

var $gevkZ = parcelRequire("gevkZ");

var $arAkG = parcelRequire("arAkG");

var $b8yDh = parcelRequire("b8yDh");

var $gGJaE = parcelRequire("gGJaE");

var $efkaq = parcelRequire("efkaq");
const $1618fa711075fd98$export$c7df4a3f1b89de01 = ({ LoadStatusCommon: LoadStatusCommon = (0, $efkaq.LoadStatus), shouldThrowError: shouldThrowError = false, useCreateProjectPermission: // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly fetchCreateProjectPermission: (baseUrl: string) => Action<State, void, void | Promise<void>>; }>, void>' is not assignable to type 'UseCreateProjectPermissionType'.
useCreateProjectPermission = (0, $b8yDh.useCreateProjectPermission), useFavorite: useFavorite = (0, $arAkG.useFavoriteProjects), useRecent: useRecent = (0, $gGJaE.useRecentProjects) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useCreateProjectPermission
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useFavorite
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatusCommon, {
        shouldThrowError: shouldThrowError,
        useProvider: useRecent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadStatusCommon, {
        shouldThrowError: false,
        useProvider: (0, $gevkZ.usePersonalizationProvider)
    }));

});

parcelRegister("jO053", function(module, exports) {

$parcel$export(module.exports, "RecentContent", () => $0340df802d3f1cfe$export$a2873dc4e96d8e90);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $5wpwq = parcelRequire("5wpwq");

var $jrdvV = parcelRequire("jrdvV");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3rqlh = parcelRequire("3rqlh");

var $1YbJP = parcelRequire("1YbJP");

var $5kDtB = parcelRequire("5kDtB");

var $ba6Jq = parcelRequire("ba6Jq");

var $OBq1v = parcelRequire("OBq1v");

var $cwU5v = parcelRequire("cwU5v");

var $1MAQq = parcelRequire("1MAQq");

var $lCQSI = parcelRequire("lCQSI");
const $0340df802d3f1cfe$export$a2873dc4e96d8e90 = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { recentItems: recentItems, favoriteItems: favoriteItems, changeFavorite: onChangeFavorite, changedItems: changedItems } = (0, $1MAQq.useProjectNavItems)();
    const itemsToShow = (0, $eUqFw.useMemo)(()=>recentItems.slice(0, (0, $5kDtB.DEFAULT_LOAD_COUNT_RECENT)), [
        recentItems
    ]);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'items-recent');
    return recentItems.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        testId: (0, $1YbJP.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $lCQSI.default).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, itemsToShow.map((item, idx)=>{
        const { url: url, id: id, favourite: isFavourite, metadata: metadata, title: title } = item;
        const contextItem = changedItems[item.id.toString()];
        const isPending = contextItem && contextItem.pending === true ? contextItem.pending : false;
        const { id: beforeEntityId, type: beforeEntityType } = (0, $3rqlh.getBeforeEntity)(favoriteItems);
        const { params: params, query: query, route: to } = (0, $3rqlh.getLinkFromProject)(item);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
            key: id,
            ariaLabel: formatMessage((0, $lCQSI.default).recent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
            analytics: {
                actionSubjectId: 'projectsNavigationMenuItem',
                menuItemId: id,
                menuItemType: 'recent',
                position: idx,
                starred: Boolean(isFavourite)
            },
            description: metadata,
            href: url,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                appearance: "square",
                size: "small",
                borderColor: "transparent",
                src: item.avatarUrl
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ba6Jq.FavoriteButton), {
                beforeEntityId: beforeEntityId,
                beforeEntityType: beforeEntityType,
                id: String(id),
                isFavorite: Boolean(isFavourite),
                favoriteItemName: title,
                isPending: isPending,
                menuItemType: "recent",
                onChangeFavorite: onChangeFavorite,
                type: (0, $jrdvV.PROJECTS_ITEM_TYPE)
            }),
            params: params,
            query: query,
            testId: (0, $1YbJP.testIdConcat)(testId, `item-${idx}`),
            to: to
        }, title));
    }))) : null;
};

});
parcelRegister("lCQSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc9083743132b5e3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dc9083743132b5e3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    recent: {
        "id": "atlassian-navigation.projects.menu.recent-content.recent",
        "defaultMessage": "Recent"
    }
});

});



parcelRegister("6yD1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $7727ba5de101240a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7727ba5de101240a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projects: {
        "id": "atlassian-navigation.projects.projects",
        "defaultMessage": "Projects"
    }
});

});


parcelRegister("9bisd", function(module, exports) {

$parcel$export(module.exports, "useShowRoadmaps", () => $1554f3f79b1eca93$export$9564042b1b0a7d8f);
$parcel$export(module.exports, "Roadmaps", () => $1554f3f79b1eca93$export$a68bc1ba98e0d580);

var $eUqFw = parcelRequire("eUqFw");

var $OUdnA = parcelRequire("OUdnA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7vTKl = parcelRequire("7vTKl");

var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $olGf9 = parcelRequire("olGf9");

var $7LFfM = parcelRequire("7LFfM");
const $1554f3f79b1eca93$var$JPD_ROADMAPS_PATH = '/jira/polaris/roadmaps';
const $1554f3f79b1eca93$var$useIsJpdPremiumEdition = ()=>{
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const jpdEdition = (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_PRODUCT_DISCOVERY), appEditions);
    return jpdEdition === (0, $6WXNs.toEdition)((0, $6WXNs.PREMIUM_EDITION));
};
const $1554f3f79b1eca93$export$9564042b1b0a7d8f = (0, $OUdnA.functionWithFF)('polaris.show-roadmaps-menu-entry', ()=>{
    const { appPermissions: appPermissions } = (0, $gd0Sp.useTenantContext)();
    const isJpdPremium = $1554f3f79b1eca93$var$useIsJpdPremiumEdition();
    return appPermissions.hasProductDiscoveryAccess && isJpdPremium;
}, ()=>false);
const $1554f3f79b1eca93$export$90296ede40c0af4a = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $olGf9.MenuTrigger), {
        href: $1554f3f79b1eca93$var$JPD_ROADMAPS_PATH,
        menuId: (0, $7vTKl.MENU_ID).ROADMAPS,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).ROADMAPS,
        analyticsAttributes: {
            isSiteAdmin: isSiteAdmin
        }
    }, formatMessage((0, $7LFfM.default).titleJpdRoadmaps));
};
const $1554f3f79b1eca93$export$a68bc1ba98e0d580 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).ROADMAPS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1554f3f79b1eca93$export$90296ede40c0af4a, null));

});
parcelRegister("OUdnA", function(module, exports) {

$parcel$export(module.exports, "functionWithFF", () => $4f946782842d29a3$export$3b8cbae22108d228);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");
const $4f946782842d29a3$export$3b8cbae22108d228 = (featureFlagName, functionTrue, functionFalse)=>(0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)(featureFlagName), functionTrue, functionFalse);

});

parcelRegister("7LFfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0d457c14bab4359$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a0d457c14bab4359$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    titleJpdRoadmaps: {
        "id": "atlassian-navigation.roadmaps.title-jpd-roadmaps",
        "defaultMessage": "Roadmaps"
    }
});

});


parcelRegister("barSP", function(module, exports) {

$parcel$export(module.exports, "NavigationRouterListener", () => $5c87f3e99bdf4d33$export$85575e1c48f0a517);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $5ytNg = parcelRequire("5ytNg");
const $5c87f3e99bdf4d33$export$85575e1c48f0a517 = ()=>{
    const [{ route: route, location: location, match: match }] = (0, $lB25E.useRouter)();
    const onEnd = (0, $5ytNg.useAtlassianNavigationEnd)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        onEnd();
    }, [
        route,
        match,
        location,
        onEnd
    ]);
    return null;
};

});
parcelRegister("5ytNg", function(module, exports) {

$parcel$export(module.exports, "useAtlassianNavigationEnd", () => $f211eff97258cd23$export$4b9602c0fdb8b1bb);

var $eUqFw = parcelRequire("eUqFw");


var $lcJyp = parcelRequire("lcJyp");
const $f211eff97258cd23$export$4b9602c0fdb8b1bb = ()=>{
    const [, { setAppReadyWithAppId: setAppReadyWithAppId }] = (0, $lcJyp.useSpaStateActions)();
    return (0, $eUqFw.useCallback)(()=>{
        setAppReadyWithAppId((0, $9c22638d2f17f9db$export$3a54edb6ba4daa82));
    }, [
        setAppReadyWithAppId
    ]);
};

});
const $9c22638d2f17f9db$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $9c22638d2f17f9db$export$2ee9e5a3556c1e43 = 'SIDEBAR';



parcelRegister("01wSx", function(module, exports) {

$parcel$export(module.exports, "Search", () => $19a5200cd89930fa$export$4b85d3515bd863a5);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $5kDtB = parcelRequire("5kDtB");


var $Ziuer = parcelRequire("Ziuer");

var $1SQjc = parcelRequire("1SQjc");

var $NGkmA = parcelRequire("NGkmA");
const $19a5200cd89930fa$var$LoadingSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $NGkmA.Skeleton), {
        placeholderMessage: (0, $Ziuer.default).interactiveSearchSkeletonPlaceholder,
        advancedSearchUrl: (0, $36489e80ab2d984d$export$55da4d4696d1abff)
    });
const $19a5200cd89930fa$var$SearchDialogMetricStart = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $1SQjc.searchDialogMetric).startFromPageLoad();
        (0, $1SQjc.searchDialogMetric).mark((0, $1SQjc.SEARCH_DIALOG_DOWNLOAD_START_MARK));
    }, []);
    return null;
};
const $19a5200cd89930fa$var$SearchDialogMetricEnd = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $1SQjc.searchDialogMetric).mark((0, $1SQjc.SEARCH_DIALOG_DOWNLOAD_END_MARK));
    }, []);
    return null;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $19a5200cd89930fa$var$LazySearch = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("8q0Ik")).then((m)=>m.Search), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/search/main.tsx"
});
const $19a5200cd89930fa$export$4b85d3515bd863a5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "search",
        packageName: (0, $5kDtB.PACKAGE_NAME),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19a5200cd89930fa$var$SearchDialogMetricStart, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "lazy-search",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19a5200cd89930fa$var$LoadingSkeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19a5200cd89930fa$var$LazySearch, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($19a5200cd89930fa$var$SearchDialogMetricEnd, null)));

});
const $36489e80ab2d984d$export$3ff84684ad8812b0 = 'product-search-dialog';
const $36489e80ab2d984d$export$55da4d4696d1abff = '/secure/QuickSearch.jspa?searchString=';

parcelRegister("Ziuer", function(module, exports) {

$parcel$export(module.exports, "default", () => $2770965ae8eaeb39$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2770965ae8eaeb39$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    updated: {
        "id": "atlassian-navigation.search.updated",
        "defaultMessage": "Updated"
    },
    interactiveSearchSkeletonPlaceholder: {
        "id": "atlassian-navigation.search.interactive-search-skeleton-placeholder",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("1SQjc", function(module, exports) {

$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_START_MARK", () => $1de23a9d7bbd3b44$export$8cd6a987249a6f33);
$parcel$export(module.exports, "SEARCH_DIALOG_DOWNLOAD_END_MARK", () => $1de23a9d7bbd3b44$export$80ab6637ae730993);
$parcel$export(module.exports, "searchDialogMetric", () => $1de23a9d7bbd3b44$export$46d64d80a1040e9b);

var $lNfG4 = parcelRequire("lNfG4");
const $1de23a9d7bbd3b44$var$SEARCH_DIALOG_METRIC_KEY = 'search-dialog';
const $1de23a9d7bbd3b44$export$8cd6a987249a6f33 = 'download-start';
const $1de23a9d7bbd3b44$export$80ab6637ae730993 = 'download-end';
const $1de23a9d7bbd3b44$export$46d64d80a1040e9b = (0, $lNfG4.metrics).pageSegmentLoad({
    key: $1de23a9d7bbd3b44$var$SEARCH_DIALOG_METRIC_KEY,
    timings: [
        {
            key: 'download',
            startMark: $1de23a9d7bbd3b44$export$8cd6a987249a6f33,
            endMark: $1de23a9d7bbd3b44$export$80ab6637ae730993
        }
    ]
});

});

parcelRegister("NGkmA", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $9a6a3f1f0ce04928$export$8f31e4c4a37b8e9c);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

var $6FP8W = parcelRequire("6FP8W");

var $9jxb2 = parcelRequire("9jxb2");

var $lStiz = parcelRequire("lStiz");
const $9a6a3f1f0ce04928$export$8f31e4c4a37b8e9c = ({ ProductSearchInputSkeleton: ProductSearchInputSkeleton = (0, $9jxb2.ProductSearchInputSkeleton), useTheme: useTheme = (0, $lStiz.useTheme), useIntl: useIntl = (0, $4ksts.useIntlV2), placeholderMessage: placeholderMessage, advancedSearchUrl: advancedSearchUrl })=>{
    const theme = useTheme();
    const { formatMessage: formatMessage } = useIntl();
    const skeletonEnabled = (0, $1ybV0.ff)('quick-search.jira.interactive-skeleton');
    const skeletonDialogFeatures = (0, $eUqFw.useMemo)(()=>skeletonEnabled ? {
            interactiveSkeleton: {
                enabled: skeletonEnabled,
                advancedSearchUrl: advancedSearchUrl,
                // @ts-expect-error - TS2345 - Argument of type 'MessageDescriptorV2 | undefined' is not assignable to parameter of type 'MessageDescriptorV2'.
                placeholder: formatMessage(placeholderMessage),
                customScriptDataAttributes: {
                    'data-defer-stop': true
                }
            }
        } : undefined, [
        advancedSearchUrl,
        placeholderMessage,
        skeletonEnabled,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProductSearchInputSkeleton, {
        shouldFillContainer: (0, $6FP8W.getWillShowNav4)(),
        theme: theme && theme.mode && theme.mode.search,
        // @ts-expect-error - TS2322 - Type '{ interactiveSkeleton: { enabled: true; advancedSearchUrl: string | undefined; placeholder: string; customScriptDataAttributes: { 'data-defer-stop': boolean; }; }; } | undefined' is not assignable to type 'ProductInputSearchSkeletonFeatures | undefined'.
        features: skeletonDialogFeatures
    });
};

});

parcelRegister("8q0Ik", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("l5I8d")
]).then(()=>parcelRequire('kTRez'));

});


parcelRegister("7fuB7", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $f887d4138843c971$export$c72f6eaae7b9adff);

var $eUqFw = parcelRequire("eUqFw");

var $jFtVs = parcelRequire("jFtVs");

var $j9fWg = parcelRequire("j9fWg");

var $dW1OX = parcelRequire("dW1OX");

var $3MV1G = parcelRequire("3MV1G");

var $2eG9N = parcelRequire("2eG9N");

var $bDhRl = parcelRequire("bDhRl");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7vTKl = parcelRequire("7vTKl");

var $3BTZc = parcelRequire("3BTZc");

var $1YbJP = parcelRequire("1YbJP");

var $6FP8W = parcelRequire("6FP8W");

var $6yplV = parcelRequire("6yplV");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $dzSJE = parcelRequire("dzSJE");

var $gvn5f = parcelRequire("gvn5f");

var $aBAUC = parcelRequire("aBAUC");

var $bGxhb = parcelRequire("bGxhb");
const $f887d4138843c971$var$SettingsInner = ()=>{
    const [isOpen, { toggle: toggleMenu, off: closeMenu }] = (0, $3BTZc.useTopMenus)((0, $7vTKl.MENU_ID).SETTINGS);
    const triggerAnalytics = (0, $gvn5f.useNavigationItemAnalytics)({
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).SETTINGS
    });
    const onStart = (0, $bDhRl.useExperienceStart)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU),
        experienceId: (0, $5kDtB.NAVIGATION_ITEM_ID).SETTINGS,
        analyticsSource: 'atlassian-navigation'
    });
    const onClick = (0, $eUqFw.useCallback)(()=>{
        onStart();
        toggleMenu();
        triggerAnalytics({
            shownCommandPalettePrompt: true
        });
    }, [
        onStart,
        toggleMenu,
        triggerAnalytics
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const testIdPrefix = (0, $1YbJP.testIdGenerate)('secondary-actions', 'settings');
    // replace this with useId from react 18 when stable
    const id = (0, $jFtVs.useUID)();
    const titleId = `top-navigation-settings-header-${id}-title`;
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBAUC.Menu), {
            testIdPrefix: testIdPrefix,
            titleId: titleId
        }), [
        testIdPrefix,
        titleId
    ]);
    const OldTrigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": (0, $1YbJP.testIdConcat)(testIdPrefix, 'menu-trigger')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dzSJE.Settings), {
            ...triggerProps,
            onClick: onClick,
            tooltip: formatMessage((0, $bGxhb.default).settings),
            isSelected: isOpen
        })), [
        formatMessage,
        isOpen,
        onClick,
        testIdPrefix
    ]);
    const NewTrigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": (0, $1YbJP.testIdConcat)(testIdPrefix, 'menu-trigger')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: formatMessage((0, $bGxhb.default).settings)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dW1OX))),
            onClick: onClick,
            appearance: "subtle",
            label: formatMessage((0, $bGxhb.default).settings),
            isSelected: isOpen
        }))), [
        isOpen,
        formatMessage,
        onClick,
        testIdPrefix
    ]);
    const Trigger = (0, $6FP8W.getWillShowNav4)() ? NewTrigger : OldTrigger;
    if (isAnonymous) return null;
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Trigger, {
        "aria-expanded": false,
        "aria-haspopup": true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        titleId: titleId,
        isOpen: isOpen,
        content: content,
        onClose: closeMenu,
        placement: "bottom-end",
        trigger: Trigger,
        label: formatMessage((0, $bGxhb.default).settings),
        role: "menu"
    });
};
const $f887d4138843c971$export$c72f6eaae7b9adff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $5kDtB.NAVIGATION_ITEM_ID).SETTINGS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f887d4138843c971$var$SettingsInner, null));

});
parcelRegister("dzSJE", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $5938f183d10c94bf$export$c72f6eaae7b9adff);

var $eUqFw = parcelRequire("eUqFw");

var $dCGmR = parcelRequire("dCGmR");

var $8zTJt = parcelRequire("8zTJt");

var $6FP8W = parcelRequire("6FP8W");
const $5938f183d10c94bf$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    if (false) {
        if ((0, $6FP8W.getWillShowNav4)()) // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8zTJt.Nav4SkeletonSettingsButton), {
            label: props.tooltip
        });
        // @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8zTJt.SkeletonSettingsButton), {
            label: props.tooltip
        });
    }
    const buttonProps = {
        ...props,
        ref: ref
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dCGmR.Settings), buttonProps);
});

});

parcelRegister("aBAUC", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $88eab0286b7bb0ae$export$d9b273488cd8ce6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8BKky = parcelRequire("8BKky");
var $lV9rH = parcelRequire("lV9rH");
var $aVkzK = parcelRequire("aVkzK");

var $1tWuI = parcelRequire("1tWuI");

var $fDZ6r = parcelRequire("fDZ6r");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $6FP8W = parcelRequire("6FP8W");

var $fz8wa = parcelRequire("fz8wa");

var $c7H0g = parcelRequire("c7H0g");

var $1R3n5 = parcelRequire("1R3n5");

var $5kDtB = parcelRequire("5kDtB");

var $gIh7l = parcelRequire("gIh7l");

var $eCWeD = parcelRequire("eCWeD");

var $fbcmg = parcelRequire("fbcmg");

var $bGxhb = parcelRequire("bGxhb");

var $4Fddv = parcelRequire("4Fddv");

var $eeaSV = parcelRequire("eeaSV");
const $88eab0286b7bb0ae$export$d9b273488cd8ce6f = ({ testIdPrefix: testIdPrefix, titleId: titleId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const appPermissions = (0, $fz8wa.useApplicationPermissions)();
    const manageUsersPermission = (0, $eCWeD.useManageUsersPermission)();
    const willShowNav4 = (0, $6FP8W.getWillShowNav4)();
    const settingsNavigationItems = (0, $eUqFw.useMemo)(()=>(0, $1tWuI.getGlobalSettingsAdminItems)(formatMessage, appPermissions, {
            isAdmin: isAdmin,
            isSiteAdmin: isSiteAdmin,
            manageUsersPermission: manageUsersPermission
        }, willShowNav4), [
        formatMessage,
        appPermissions,
        isAdmin,
        isSiteAdmin,
        manageUsersPermission,
        willShowNav4
    ]);
    const onSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MENU)
    });
    (0, $eUqFw.useEffect)(()=>{
        onSuccess();
    }, [
        onSuccess
    ]);
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'menu-popup');
    const testIdHeader = (0, $1YbJP.testIdConcat)(testId, 'header');
    if (willShowNav4) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIh7l.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Fddv.Personal), {
        testIdPrefix: testId
    }), settingsNavigationItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbcmg.Home), {
        settingsDrawerItems: settingsNavigationItems,
        testIdPrefix: testId
    }), manageUsersPermission.loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lV9rH.default), {
        testId: `${testId}--loading-skeleton--heading`,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        testId: `${testId}--loading-skeleton--item`,
        isShimmering: true,
        hasIcon: true
    })) : settingsNavigationItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeaSV.Warning), {
        testIdPrefix: testId
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gIh7l.MenuLayout), {
        isWide: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($88eab0286b7bb0ae$var$SettingsTitle, {
        ...testIdHeader != null ? {
            'data-testid': testIdHeader
        } : {},
        id: titleId
    }, formatMessage((0, $bGxhb.default).settings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Fddv.Personal), {
        testIdPrefix: testId
    }), settingsNavigationItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbcmg.Home), {
        settingsDrawerItems: settingsNavigationItems,
        testIdPrefix: testId
    }), manageUsersPermission.loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lV9rH.default), {
        testId: `${testId}--loading-skeleton--heading`,
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
        testId: `${testId}--loading-skeleton--item`,
        isShimmering: true,
        hasIcon: true
    })) : settingsNavigationItems.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeaSV.Warning), {
        testIdPrefix: testId
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88eab0286b7bb0ae$var$SettingsTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybo0gd _vwz44jg8 _1dyzvkfx _1yt4rwue",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1tWuI", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $d6c6325a34d6a2b4$export$be58b4326e23250f);
$parcel$export(module.exports, "getGlobalSettingsAdminItems", () => $d6c6325a34d6a2b4$export$d637bf5a394b4534);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5KEua = parcelRequire("5KEua");

var $jVbWM = parcelRequire("jVbWM");

var $3zPrX = parcelRequire("3zPrX");

var $3vmed = parcelRequire("3vmed");

var $1yh1n = parcelRequire("1yh1n");

var $jomRY = parcelRequire("jomRY");

var $gbbKH = parcelRequire("gbbKH");

var $gib2Q = parcelRequire("gib2Q");

var $oeORR = parcelRequire("oeORR");

var $iFXD5 = parcelRequire("iFXD5");

var $1j9EV = parcelRequire("1j9EV");

var $e5T2d = parcelRequire("e5T2d");

var $6nIG2 = parcelRequire("6nIG2");

var $iwsIy = parcelRequire("iwsIy");

var $5318D = parcelRequire("5318D");

var $23NQ5 = parcelRequire("23NQ5");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $dfBCt = parcelRequire("dfBCt");

var $5t8Df = parcelRequire("5t8Df");

var $igOBb = parcelRequire("igOBb");

var $eI5EY = parcelRequire("eI5EY");

var $jxzG5 = parcelRequire("jxzG5");

var $bKRo5 = parcelRequire("bKRo5");

var $hrxXt = parcelRequire("hrxXt");

var $GQMch = parcelRequire("GQMch");
const $d6c6325a34d6a2b4$var$getApplicationsMenuLink = (appPermissions)=>{
    if (appPermissions.hasSoftwareAccess) return '/jira/settings/products/jira-software-configuration';
    if (appPermissions.hasServiceDeskAccess) return '/jira/settings/products/jira-service-management-configuration';
    return '/plugins/servlet/applinks/listApplicationLinks';
};
const $d6c6325a34d6a2b4$export$f3a5db2467c22913 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5318D))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$3055c15ea575d46c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($oeORR))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$43db94b81c32328a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e5T2d))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$583f26efcd800ae2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6nIG2))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$627b4c7b9568cd5d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXD5))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$4464648b9631e67f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, {
        dark: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$export$7b659dc9c22493b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$be58b4326e23250f, {
        dark: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3zPrX))), {
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1j9EV))),
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $d6c6325a34d6a2b4$var$getAdminSectionOld = (formatMessage, appPermissions)=>({
        id: (0, $hrxXt.JIRA_SETTINGS_SECTION_IDS).SYSTEM_ADMIN,
        type: 'Group',
        hasSeparator: true,
        sideHeading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$export$b79014a8ad5d31bf, {
                "aria-label": formatMessage((0, $igOBb.isMacOs)() ? (0, $GQMch.default).jiraSettingsCommandPaletteMacScreenReader : (0, $GQMch.default).jiraSettingsCommandPaletteOtherScreenReader)
            }, formatMessage((0, $igOBb.isMacOs)() ? (0, $GQMch.default).jiraSettingsCommandPaletteMac : (0, $GQMch.default).jiraSettingsCommandPaletteOther, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                        as: "strong",
                        size: "small",
                        color: "inherit"
                    }, chunks),
                wrapper: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$var$CommandPaletteShortcutsContainer, null, chunks),
                key: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$var$KeyboardShortcut, null, chunks),
                command: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d6c6325a34d6a2b4$var$KeyboardShortcut, {
                        isMeta: true
                    }, chunks)
            })),
        items: [
            {
                goTo: 'root/global-settings/system',
                // sets active navigation 2nd level menu and an active item in navigation menu, via `navApi.setView(goTo)`
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).SYSTEM,
                legacyId: 'admin_system_menu',
                href: '/jira/settings/system/general-configuration',
                text: formatMessage((0, $GQMch.default).system),
                type: 'Item',
                before: $d6c6325a34d6a2b4$export$f3a5db2467c22913
            },
            {
                goTo: 'root/global-settings/applications',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: $d6c6325a34d6a2b4$var$getApplicationsMenuLink(appPermissions),
                text: formatMessage((0, $GQMch.default).applications),
                type: 'Item',
                before: $d6c6325a34d6a2b4$export$3055c15ea575d46c
            },
            {
                goTo: 'root/global-settings/projects',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).MANAGE_PROJECTS,
                legacyId: 'admin_project_menu',
                href: '/jira/settings/projects/manage',
                text: formatMessage((0, $GQMch.default).projects),
                type: 'Item',
                before: $d6c6325a34d6a2b4$export$43db94b81c32328a
            },
            {
                goTo: 'root/global-settings/issues',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).ISSUES,
                legacyId: 'admin_issues_menu',
                href: '/jira/settings/issues/issue-types',
                text: formatMessage((0, $GQMch.default).issues),
                type: 'Item',
                before: $d6c6325a34d6a2b4$export$583f26efcd800ae2
            },
            {
                goTo: 'root/global-settings/addons',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).PLUGINS,
                legacyId: 'admin_plugins_menu',
                href: (0, $jxzG5.getEmceeDiscoverLink)({
                    source: 'side_nav_find_new_addons'
                }),
                text: formatMessage((0, $GQMch.default).addons),
                type: 'Item',
                before: $d6c6325a34d6a2b4$export$627b4c7b9568cd5d
            }
        ]
    });
const $d6c6325a34d6a2b4$var$getAdminSectionNew = (formatMessage, appPermissions)=>({
        id: (0, $hrxXt.JIRA_SETTINGS_SECTION_IDS).SYSTEM_ADMIN,
        type: 'Group',
        hasSeparator: true,
        heading: formatMessage((0, $GQMch.default).jiraAdminSettingsNonFinal),
        items: [
            {
                goTo: 'root/global-settings/system',
                // sets active navigation 2nd level menu and an active item in navigation menu, via `navApi.setView(goTo)`
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).SYSTEM,
                legacyId: 'admin_system_menu',
                href: '/jira/settings/system/general-configuration',
                text: formatMessage((0, $GQMch.default).system),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gbbKH))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $GQMch.default).systemDescriptionNonFinal)
            },
            {
                goTo: 'root/global-settings/applications',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).APPLICATIONS,
                legacyId: 'admin_applications_menu',
                href: $d6c6325a34d6a2b4$var$getApplicationsMenuLink(appPermissions),
                text: formatMessage((0, $GQMch.default).applications),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5KEua))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $GQMch.default).productsDescriptionNonFinal)
            },
            {
                goTo: 'root/global-settings/projects',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).MANAGE_PROJECTS,
                legacyId: 'admin_project_menu',
                href: '/jira/settings/projects/manage',
                text: formatMessage((0, $GQMch.default).projects),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jomRY))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $GQMch.default).projectsDescriptionNonFinal)
            },
            {
                goTo: 'root/global-settings/issues',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).ISSUES,
                legacyId: 'admin_issues_menu',
                href: '/jira/settings/issues/issue-types',
                text: formatMessage((0, $GQMch.default).issues),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3vmed))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $GQMch.default).issuesDescriptionNonFinal)
            },
            {
                goTo: 'root/global-settings/addons',
                id: (0, $hrxXt.ADMIN_SETTINGS_ITEM_IDS).PLUGINS,
                legacyId: 'admin_plugins_menu',
                href: (0, $bKRo5.manageAppsRoute).path,
                text: formatMessage((0, $GQMch.default).addons),
                type: 'Item',
                before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jVbWM))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                description: formatMessage((0, $GQMch.default).appsDescriptionNonFinal)
            },
            {
                id: 'keyboad-shortcut-tip',
                type: 'Content',
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        xcss: $d6c6325a34d6a2b4$var$jiraCommandPalletteTipContainerStyles,
                        "aria-label": formatMessage((0, $igOBb.isMacOs)() ? (0, $GQMch.default).jiraSettingsCommandPaletteMacScreenReader : (0, $GQMch.default).jiraSettingsCommandPaletteOtherScreenReader)
                    }, formatMessage((0, $igOBb.isMacOs)() ? (0, $GQMch.default).jiraSettingsCommandPaletteMac : (0, $GQMch.default).jiraSettingsCommandPaletteOther, {
                        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                                size: "small"
                            }, chunks),
                        wrapper: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                                xcss: $d6c6325a34d6a2b4$var$commandPalleteShortcutStyles
                            }, chunks),
                        key: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                                alignItems: "center",
                                justifyContent: "center",
                                xcss: $d6c6325a34d6a2b4$var$keyboardShortcutStyles
                            }, chunks),
                        command: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
                                alignItems: "center",
                                justifyContent: "center",
                                xcss: $d6c6325a34d6a2b4$var$keyboardShortcutStyles
                            }, chunks)
                    }))
            }
        ]
    });
const $d6c6325a34d6a2b4$export$8c65af5cbebd63ff = (formatMessage, isSiteAdmin, canManageUsers, isHideBillingGlobalSettingForFedrampAdminsEnabled = false)=>({
        id: (0, $hrxXt.JIRA_SETTINGS_SECTION_IDS).SITE_ADMIN,
        heading: formatMessage((0, $GQMch.default).atlassianAdminSettingsNonFinal),
        type: 'Group',
        hasSeparator: false,
        items: [
            ...canManageUsers || isSiteAdmin ? [
                {
                    id: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_IDS).USER_MANAGEMENT,
                    legacyId: 'user_management_section',
                    href: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                    text: formatMessage((0, $GQMch.default).userManagement),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gib2Q))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yh1n))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    target: '_blank',
                    description: formatMessage((0, $GQMch.default).userManagementDescriptionNonFinal)
                }
            ] : [],
            ...isSiteAdmin && !(isHideBillingGlobalSettingForFedrampAdminsEnabled && (0, $dfBCt.isFedRamp)()) ? [
                {
                    id: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_IDS).BILLING,
                    legacyId: 'admin_billing_section',
                    href: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                    text: formatMessage((0, $GQMch.default).billing),
                    type: 'Item',
                    before: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3zPrX))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yh1n))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        }),
                    target: '_blank',
                    description: formatMessage((0, $GQMch.default).billingDescriptionNonFinal)
                }
            ] : []
        ]
    });
const $d6c6325a34d6a2b4$export$ed6905715e0eb76 = (formatMessage, isSiteAdmin, canManageUsers, isHideBillingGlobalSettingForFedrampAdminsEnabled = false)=>({
        id: (0, $hrxXt.JIRA_SETTINGS_SECTION_IDS).SITE_ADMIN,
        type: 'Group',
        hasSeparator: false,
        items: [
            ...canManageUsers || isSiteAdmin ? [
                {
                    id: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_IDS).USER_MANAGEMENT,
                    legacyId: 'user_management_section',
                    href: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                    text: formatMessage((0, $GQMch.default).userManagement),
                    type: 'Item',
                    before: $d6c6325a34d6a2b4$export$4464648b9631e67f,
                    // @ts-expect-error - TS2769 - No overload matches this call.
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                            size: "small"
                        }),
                    target: '_blank'
                }
            ] : [],
            ...isSiteAdmin && !(isHideBillingGlobalSettingForFedrampAdminsEnabled && (0, $dfBCt.isFedRamp)()) ? [
                {
                    id: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_IDS).BILLING,
                    legacyId: 'admin_billing_section',
                    href: (0, $hrxXt.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                    text: formatMessage((0, $GQMch.default).billing),
                    type: 'Item',
                    before: $d6c6325a34d6a2b4$export$7b659dc9c22493b,
                    // @ts-expect-error - TS2769 - No overload matches this call.
                    after: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                            size: "small"
                        }),
                    target: '_blank'
                }
            ] : []
        ]
    });
const $d6c6325a34d6a2b4$export$d637bf5a394b4534 = (formatMessage, appPermissions, userRoles, willShowNav4)=>{
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, manageUsersPermission: manageUsersPermission } = userRoles;
    const result = [];
    if (isAdmin) {
        const getAdminSection = willShowNav4 ? $d6c6325a34d6a2b4$var$getAdminSectionNew : $d6c6325a34d6a2b4$var$getAdminSectionOld;
        result.push(getAdminSection(formatMessage, appPermissions));
    }
    // Adding these items to the end because `manageUsersPermission` may change after the initial
    // render because it is determined by an async API call. It will need to be the responsibility
    // of the consumer to show a loading state if needed.
    if (isSiteAdmin || manageUsersPermission.loading === false && manageUsersPermission.canManageUsers) {
        const getSiteAdminSection = willShowNav4 ? $d6c6325a34d6a2b4$export$8c65af5cbebd63ff : $d6c6325a34d6a2b4$export$ed6905715e0eb76;
        result.push(getSiteAdminSection(formatMessage, userRoles.isSiteAdmin, manageUsersPermission.canManageUsers, // remove prop when cleaning up nin_hide_billing_global_setting_for_fedramp_admins
        (0, $eI5EY.fg)('nin_hide_billing_global_setting_for_fedramp_admins')));
    }
    return result;
};
const $d6c6325a34d6a2b4$export$be58b4326e23250f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { dark: dark, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _1bah1h6o _4t3i1tcg _1bsb1tcg _2rko1l7b",
            __cmplp.dark ? "_11q7gkf6" : "_11q71pom",
            __cmplp.className
        ])
    });
});
const $d6c6325a34d6a2b4$var$CommandPaletteShortcutsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _zulpv77o",
            __cmplp.className
        ])
    });
});
const $d6c6325a34d6a2b4$var$KeyboardShortcut = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $5t8Df.FilledLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1bsb1wug _1ul9dlk8 _4t3idlk8 _16jlidpf _vwz4wk7l _y3gn1h6o _1yt41nxw _vchhusvi _1p1dglyw",
            __cmplp.isMeta ? "_1wyb1bt6" : "_1wybc4v4",
            __cmplp.className
        ])
    });
});
const $d6c6325a34d6a2b4$export$b79014a8ad5d31bf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1 _11c81vlj _syaz1ddj _1p1dglyw",
            __cmplp.className
        ])
    });
});
const $d6c6325a34d6a2b4$var$commandPalleteShortcutStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    gap: 'space.025'
});
const $d6c6325a34d6a2b4$var$jiraCommandPalletteTipContainerStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    marginInlineStart: 'space.200',
    marginBlock: 'space.200',
    color: 'color.text.subtle'
});
const $d6c6325a34d6a2b4$var$keyboardShortcutStyles = (0, $1ZAYh.xcss)({
    minWidth: '14px',
    height: '14px',
    backgroundColor: 'color.background.accent.blue.subtlest',
    color: 'color.text.subtle',
    padding: 'space.025',
    borderRadius: 'border.radius',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("5t8Df", function(module, exports) {

$parcel$export(module.exports, "OutlinedLozenge", () => $cfdd8a3faf592ae6$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $cfdd8a3faf592ae6$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $cfdd8a3faf592ae6$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfdd8a3faf592ae6$var$Lozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2rko1l7b _1o9zidpf _4t3igktf _1bsbgktf _11c8qk37 _vwz41crf _syaz1aqp",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81u0j _k48p1pd9 _1p1dangw _bfhk1j9a _19it1x8r _syazuxqy _vchhusvi",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _11c81u0j _1p1dangw _1pbykb7n _1cs8stnw _1kt9b3bt _1s6k1d2d _154psxj9 _rfx31l7b _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4otz2 _1bsb1ris _11c81oud _vwz4dlk8 _bfhk1yrq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hrxXt", function(module, exports) {

$parcel$export(module.exports, "JIRA_SETTINGS_SECTION_IDS", () => $a88144c18eea020d$export$7266225366740ba0);
$parcel$export(module.exports, "ADMIN_SETTINGS_ITEM_IDS", () => $a88144c18eea020d$export$4718c8ac53a477e1);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_IDS", () => $a88144c18eea020d$export$b23679adb37958a8);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_HREFS", () => $a88144c18eea020d$export$9cc74e3c0b8831f9);
const $a88144c18eea020d$export$7266225366740ba0 = {
    SETTINGS_TITLE: 'settings-title',
    SITE_ADMIN: 'site-admin',
    SYSTEM_ADMIN: 'system-admin',
    TRUSTED_USER: 'trusted-user',
    PERSONAL: 'personal-settings'
};
const $a88144c18eea020d$export$4718c8ac53a477e1 = {
    SYSTEM: 'admin-system-menu',
    APPLICATIONS: 'admin-applications-menu',
    ISSUES: 'admin-issues-menu',
    PLUGINS: 'admin-plugins-menu',
    RECOMMENDATIONS: 'admin-recommendations',
    MANAGE_PROJECTS: 'admin-manage-project-menu'
};
const $a88144c18eea020d$export$b23679adb37958a8 = {
    USER_MANAGEMENT: 'user-management-section',
    BILLING: 'admin-billing-section'
};
const $a88144c18eea020d$export$58a409d1d7fded14 = {
    USER_MANAGEMENT: 'trusted-admin-user-management-section',
    DISCOVER_APPLICATIONS: 'discover-applications-section'
};
const $a88144c18eea020d$export$9cc74e3c0b8831f9 = {
    USER_MANAGEMENT: '/admin/users?referrerName=JIRA',
    BILLING: '/admin/billing-preview?referrerName=JIRA'
};

});

parcelRegister("GQMch", function(module, exports) {

$parcel$export(module.exports, "default", () => $b05caadb2f8bde77$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b05caadb2f8bde77$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    settings: {
        "id": "navigation-next.navigation-views.root.common.settings",
        "defaultMessage": "Jira settings"
    },
    system: {
        "id": "navigation-next.navigation-views.root.global-settings.home.system",
        "defaultMessage": "System"
    },
    applications: {
        "id": "navigation-next.navigation-views.root.global-settings.home.applications",
        "defaultMessage": "Products"
    },
    projects: {
        "id": "navigation-next.navigation-views.root.global-settings.home.projects",
        "defaultMessage": "Projects"
    },
    issues: {
        "id": "navigation-next.navigation-views.root.global-settings.home.issues",
        "defaultMessage": "Issues"
    },
    addons: {
        "id": "navigation-next.navigation-views.root.global-settings.home.addons",
        "defaultMessage": "Apps"
    },
    recommendations: {
        "id": "navigation-next.navigation-views.root.global-settings.home.recommendations",
        "defaultMessage": "Recommendations"
    },
    userManagement: {
        "id": "navigation-next.navigation-views.root.global-settings.home.user-management",
        "defaultMessage": "User management"
    },
    billing: {
        "id": "navigation-next.navigation-views.root.global-settings.home.billing",
        "defaultMessage": "Billing"
    },
    discoverApplications: {
        "id": "navigation-next.navigation-views.root.global-settings.home.discover-applications",
        "defaultMessage": "Discover applications"
    },
    jiraSettingsCommandPaletteMac: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac",
        "defaultMessage": "<strong>Tip:</strong> Try <wrapper><command>\u2318</command><key>K</key></wrapper> to search Jira settings"
    },
    jiraSettingsCommandPaletteOther: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other",
        "defaultMessage": "<strong>Tip:</strong> Try <wrapper><key>Ctrl</key><key>K</key></wrapper> to search Jira settings"
    },
    jiraSettingsCommandPaletteMacScreenReader: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-mac-screen-reader",
        "defaultMessage": "Tip: Try command K to search Jira settings"
    },
    jiraSettingsCommandPaletteOtherScreenReader: {
        "id": "navigation-next.navigation-views.root.global-settings.home.jira-settings-command-palette-other-screen-reader",
        "defaultMessage": "Tip: Try control K to search Jira settings"
    },
    'site-admin': {
        "id": "navigation-apps.settings-drawer.section.site-admin",
        "defaultMessage": "Atlassian admin"
    },
    'system-admin': {
        "id": "navigation-apps.settings-drawer.section.system-admin",
        "defaultMessage": "Jira settings"
    },
    'trusted-user': {
        "id": "navigation-apps.settings-drawer.section.trusted-user",
        "defaultMessage": "Atlassian admin"
    },
    'personal-settings': {
        "id": "navigation-apps.settings-drawer.section.personal-settings",
        "defaultMessage": "Personal settings"
    },
    'admin-system-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-system-menu",
        "defaultMessage": "Manage your general configuration, global permissions, look and feel and more."
    },
    'admin-applications-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-applications-menu",
        "defaultMessage": "Manage your Jira products' settings and integrations."
    },
    'admin-manage-project-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-manage-project-menu",
        "defaultMessage": "Manage your project settings, categories, and more."
    },
    'admin-issues-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-issues-menu",
        "defaultMessage": "Configure your issue types, workflows, screens, custom fields and more."
    },
    'admin-plugins-menu': {
        "id": "navigation-apps.settings-drawer.section.item.admin-plugins-menu",
        "defaultMessage": "Add and manage Jira Marketplace apps."
    },
    'user-management-section': {
        "id": "navigation-apps.settings-drawer.section.item.user-management-section",
        "defaultMessage": "Add users, groups, and manage access requests."
    },
    'admin-billing-section': {
        "id": "navigation-apps.settings-drawer.section.item.admin-billing-section",
        "defaultMessage": "Update your billing details, manage your subscriptions and more."
    },
    'trusted-admin-user-management-section': {
        "id": "navigation-apps.settings-drawer.section.item.trusted-admin-user-management-section",
        "defaultMessage": "Invite users to your site."
    },
    'discover-applications-section': {
        "id": "navigation-apps.settings-drawer.section.item.discover-applications-section",
        "defaultMessage": "Try more Atlassian products."
    },
    // NAV4 Messages
    personalJiraSettingsNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.personal-jira-settings-non-final",
        "defaultMessage": "Personal Jira settings"
    },
    jiraAdminSettingsNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.jira-admin-settings-non-final",
        "defaultMessage": "Jira admin settings"
    },
    systemDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.system-description-non-final",
        "defaultMessage": "Manage general configuration, security, automation, user interface, and more"
    },
    productsDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.products-description-non-final",
        "defaultMessage": "Manage Jira products' access, settings, and integrations"
    },
    projectsDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.projects-description-non-final",
        "defaultMessage": "Manage project settings, categories, and more"
    },
    issuesDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.issues-description-non-final",
        "defaultMessage": "Configure issue types, workflows, screens, fields, and more"
    },
    appsDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.apps-description-non-final",
        "defaultMessage": "Add and manage Jira Marketplace apps and integrations"
    },
    atlassianAdminSettingsNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.atlassian-admin-settings-non-final",
        "defaultMessage": "Atlassian admin settings"
    },
    userManagementDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.user-management-description-non-final",
        "defaultMessage": "Manage users, groups, and access requests"
    },
    billingDescriptionNonFinal: {
        "id": "atlassian-navigation-nav4.common.settings-content.billing-description-non-final",
        "defaultMessage": "Update your billing details, manage subscriptions, and more"
    }
});

});


parcelRegister("eCWeD", function(module, exports) {

$parcel$export(module.exports, "useManageUsersPermission", () => $7c2e0411119ba04c$export$d156f64dc61f3ce9);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jD3pk = parcelRequire("jD3pk");

var $dxcfv = parcelRequire("dxcfv");

var $1R3n5 = parcelRequire("1R3n5");

var $WBLbN = parcelRequire("WBLbN");
const $7c2e0411119ba04c$var$initialState = {
    loading: true,
    canManageUsers: undefined
};
const $7c2e0411119ba04c$var$Store = (0, $WBLbN.createStore)({
    initialState: $7c2e0411119ba04c$var$initialState,
    actions: {
        fetch: ({ orgId: orgId, accountId: accountId, isSiteAdmin: isSiteAdmin })=>async ({ setState: setState, getState: getState })=>{
                if (getState().canManageUsers !== undefined) // Shortcut - Don't fetch again if we already have the data
                return;
                if (accountId == null || orgId == null) {
                    // Shortcut - Anonymous users cannot manage users, and orgId is required
                    setState({
                        loading: false,
                        canManageUsers: false
                    });
                    return;
                }
                if (isSiteAdmin) {
                    // Shortcut - Site admins can manage users
                    setState({
                        loading: false,
                        canManageUsers: true
                    });
                    return;
                }
                setState({
                    loading: true
                });
                try {
                    const { permitted: permitted } = await (0, $lRmyA.performPostRequest)('/gateway/api/permissions/permitted', {
                        body: JSON.stringify({
                            resourceId: `ari:cloud:platform::org/${orgId}`,
                            principalId: `ari:cloud:identity::user/${accountId}`,
                            permissionId: 'manage-users'
                        })
                    });
                    setState({
                        loading: false,
                        canManageUsers: permitted
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // Fail safe - if we can't fetch the data, assume the user can't manage users
                    setState({
                        loading: false,
                        canManageUsers: false
                    });
                    (0, $guiFP.default)({
                        meta: {
                            id: 'fetchManageUsersPermission',
                            packageName: 'jiraAtlassianNavigation',
                            teamName: 'navigation'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
    },
    name: 'ManageUsersPermissionInternal'
});
const $7c2e0411119ba04c$var$useManageUsersPermissionInternal = (0, $WBLbN.createHook)($7c2e0411119ba04c$var$Store);
const $7c2e0411119ba04c$export$d156f64dc61f3ce9 = ()=>{
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const accountId = (0, $dxcfv.useAccountId)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const [state, { fetch: fetch }] = $7c2e0411119ba04c$var$useManageUsersPermissionInternal();
    (0, $eUqFw.useEffect)(()=>{
        fetch({
            accountId: accountId,
            orgId: orgId,
            isSiteAdmin: isSiteAdmin
        });
    }, [
        fetch,
        accountId,
        orgId,
        isSiteAdmin
    ]);
    return state;
};

});

parcelRegister("fbcmg", function(module, exports) {

$parcel$export(module.exports, "Home", () => $460aa7fb31252e9e$export$b94310965bed44e6);

var $eUqFw = parcelRequire("eUqFw");

var $8BKky = parcelRequire("8BKky");

var $GQMch = parcelRequire("GQMch");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $6FP8W = parcelRequire("6FP8W");

var $OBq1v = parcelRequire("OBq1v");

var $cwU5v = parcelRequire("cwU5v");

var $hdrIo = parcelRequire("hdrIo");
const $460aa7fb31252e9e$export$b94310965bed44e6 = ({ messages: messages = (0, $GQMch.default), settingsDrawerItems: settingsDrawerItems, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((0, $6FP8W.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, settingsDrawerItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
            key: group.id,
            testId: (0, $1YbJP.testIdConcat)(testIdPrefix, group.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdrIo.HomeHeading), {
            group: group,
            messages: messages,
            testIdPrefix: testIdPrefix
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, group.items && group.items.map((item, idx)=>{
            if (item.type === 'Content' && item.content) return item.content({
                update: ()=>Promise.resolve(null),
                isOpen: false,
                setInitialFocusRef: ()=>null
            });
            if (item.href === null || item.href === undefined) return null;
            if (item.text === null || item.text === undefined) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
                key: item.id,
                ariaLabel: formatMessage(messages[group.id])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
                analytics: {
                    actionSubjectId: 'settingsNavigationMenuItem',
                    menuItemId: item.id,
                    menuItemType: group.id === 'site-admin' ? 'adminSettings' : 'jiraSettings',
                    position: idx
                },
                iconBefore: item.before ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(item.before, null) : null,
                iconAfter: item.after ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(item.after, {
                    isHover: true
                }) : null,
                href: item.href,
                // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type '(("_self" | "_blank" | "_parent" | "_top") & HTMLAttributeAnchorTarget) | undefined'.
                target: item.target,
                testId: (0, $1YbJP.testIdConcat)(testIdPrefix, group.id, `item-${item.id}`),
                description: item.description || ''
            }, item.text || ''));
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, settingsDrawerItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
            key: group.id,
            testId: (0, $1YbJP.testIdConcat)(testIdPrefix, group.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hdrIo.HomeHeading), {
            group: group,
            messages: messages,
            testIdPrefix: testIdPrefix
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, group.items && group.items.map((item, idx)=>{
            if (item.href === null || item.href === undefined) return null;
            if (item.text === null || item.text === undefined) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
                key: item.id,
                ariaLabel: formatMessage(messages[group.id])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
                analytics: {
                    actionSubjectId: 'settingsNavigationMenuItem',
                    menuItemId: item.id,
                    menuItemType: group.id === 'site-admin' ? 'adminSettings' : 'jiraSettings',
                    position: idx
                },
                iconBefore: item.before ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(item.before, null) : null,
                iconAfter: item.after ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(item.after, {
                    isHover: true
                }) : null,
                href: item.href,
                // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type '(("_self" | "_blank" | "_parent" | "_top") & HTMLAttributeAnchorTarget) | undefined'.
                target: item.target,
                testId: (0, $1YbJP.testIdConcat)(testIdPrefix, group.id, `item-${item.id}`),
                description: messages[item.id] ? formatMessage(messages[item.id]) : undefined
            }, item.text || ''));
        })))));
};

});
parcelRegister("hdrIo", function(module, exports) {

$parcel$export(module.exports, "HomeHeading", () => $c2d5494d20475ee4$export$e2344e30272a44c1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5wpwq = parcelRequire("5wpwq");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1YbJP = parcelRequire("1YbJP");

var $6FP8W = parcelRequire("6FP8W");

const $c2d5494d20475ee4$export$e2344e30272a44c1 = ({ group: group, messages: messages, testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const headingMessage = (0, $eUqFw.useMemo)(()=>formatMessage(messages[group.id]), [
        formatMessage,
        group.id,
        messages
    ]);
    if ((0, $6FP8W.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        "data-testid": (0, $1YbJP.testIdConcat)(testIdPrefix, group.id, 'heading'),
        className: (0, $7JEyt.default)([
            "_11c8qk37 _syaz131l _k48p1pd9 _ahbqpxbi _19pku2gc _otyr12x7"
        ])
    }, group.heading || '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        headingLevel: 3,
        testId: (0, $1YbJP.testIdConcat)(testIdPrefix, group.id, 'heading')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c2d5494d20475ee4$var$HeadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, headingMessage), !!group.sideHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": (0, $ec6875ba06550391$export$f707547fc95f31c2)
    }, group.sideHeading())));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c2d5494d20475ee4$var$HeadingContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $c2d5494d20475ee4$var$sectionHeadingStyles = null;

});
const $ec6875ba06550391$export$f707547fc95f31c2 = 'atlassian-navigation.ui.settings.menu.home.heading.side-heading';



parcelRegister("bGxhb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3414025933f9b5e8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3414025933f9b5e8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    settings: {
        "id": "atlassian-navigation.settings.menu.settings",
        "defaultMessage": "Settings"
    }
});

});

parcelRegister("4Fddv", function(module, exports) {

$parcel$export(module.exports, "Personal", () => $15663aedb89a0aa7$export$3965927bf7a81700);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $6L8Y7 = parcelRequire("6L8Y7");

var $5wwfG = parcelRequire("5wwfG");

var $24y6N = parcelRequire("24y6N");

var $ktq0D = parcelRequire("ktq0D");

var $23NQ5 = parcelRequire("23NQ5");

var $5wpwq = parcelRequire("5wpwq");
var $8BKky = parcelRequire("8BKky");

var $1tWuI = parcelRequire("1tWuI");

var $hrxXt = parcelRequire("hrxXt");

var $GQMch = parcelRequire("GQMch");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3rqlh = parcelRequire("3rqlh");

var $1YbJP = parcelRequire("1YbJP");

var $6FP8W = parcelRequire("6FP8W");

var $iJPUk = parcelRequire("iJPUk");

var $cWiVr = parcelRequire("cWiVr");

var $7lcEz = parcelRequire("7lcEz");

var $OBq1v = parcelRequire("OBq1v");

var $cwU5v = parcelRequire("cwU5v");

var $5XKqM = parcelRequire("5XKqM");
const $15663aedb89a0aa7$export$3965927bf7a81700 = ({ testIdPrefix: testIdPrefix })=>{
    const { data: data } = (0, $cWiVr.useCurrentUser)();
    // @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    const email = data.user?.emailAddress;
    const atlassianPersonalSettingsLink = (0, $3rqlh.useAtlassianPersonalSettingsLink)(email);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'personal-settings');
    if ((0, $6FP8W.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        "data-testid": (0, $1YbJP.testIdConcat)(testId, 'heading'),
        className: (0, $7JEyt.default)([
            "_11c8qk37 _syaz131l _k48p1pd9 _ahbqpxbi _19pku2gc _otyr12x7"
        ])
    }, formatMessage((0, $GQMch.default).personalJiraSettingsNonFinal)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
        ariaLabel: formatMessage((0, $GQMch.default).personalJiraSettingsNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'personal-jira-settings',
            menuItemType: 'personalSettings',
            position: 0
        },
        description: formatMessage((0, $5XKqM.default).generalSettingsDescriptionNonFinal),
        href: (0, $iJPUk.getGeneralPersonalSettingsPath)(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5wwfG))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-personal-jira-settings'),
        to: (0, $7lcEz.getGeneralPersonalSettingsRouteForLink)()
    }, formatMessage((0, $5XKqM.default).generalSettingsLabelNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
        ariaLabel: formatMessage((0, $GQMch.default).personalJiraSettingsNonFinal)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'account-settings',
            menuItemType: 'personalSettings',
            position: 1
        },
        description: formatMessage((0, $5XKqM.default).notificationSettingsDescriptionNonFinal),
        href: "/jira/settings/personal/notifications",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6L8Y7))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-account-settings')
    }, formatMessage((0, $5XKqM.default).notificationSettingsLabelNonFinal)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wpwq.default), {
        headingLevel: 3,
        testId: (0, $1YbJP.testIdConcat)(testId, 'heading')
    }, formatMessage((0, $GQMch.default)[(0, $hrxXt.JIRA_SETTINGS_SECTION_IDS).PERSONAL])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
        ariaLabel: formatMessage((0, $GQMch.default)[(0, $hrxXt.JIRA_SETTINGS_SECTION_IDS).PERSONAL])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'account-settings',
            menuItemType: 'personalSettings',
            position: 0
        },
        description: formatMessage((0, $5XKqM.default).accountSettingsDescription),
        href: atlassianPersonalSettingsLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1tWuI.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24y6N))), {
            size: "small",
            primaryColor: "var(--ds-icon-inverse, #FFFFFF)",
            label: ""
        })),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
            size: "small",
            label: ""
        }),
        target: "_blank",
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-account-settings')
    }, formatMessage((0, $5XKqM.default).accountSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwU5v.MenuListItem), {
        ariaLabel: formatMessage((0, $GQMch.default)[(0, $hrxXt.JIRA_SETTINGS_SECTION_IDS).PERSONAL])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OBq1v.MenuItem), {
        analytics: {
            actionSubjectId: 'settingsNavigationMenuItem',
            menuItemId: 'personal-jira-settings',
            menuItemType: 'personalSettings',
            position: 1
        },
        description: formatMessage((0, $5XKqM.default).personalJiraSettingsDescription),
        href: (0, $iJPUk.getGeneralPersonalSettingsPath)(),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1tWuI.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ktq0D))), {
            size: "small",
            primaryColor: "var(--ds-icon-inverse, #FFFFFF)",
            label: ""
        })),
        testId: (0, $1YbJP.testIdConcat)(testId, 'item-personal-jira-settings'),
        to: (0, $7lcEz.getGeneralPersonalSettingsRouteForLink)()
    }, formatMessage((0, $5XKqM.default).personalJiraSettings)))));
};
const $15663aedb89a0aa7$var$sectionHeadingStyles = null;

});
parcelRegister("5XKqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $05c505574d880b37$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $05c505574d880b37$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    accountSettings: {
        "id": "atlassian-navigation.settings.menu.personal.account-settings",
        "defaultMessage": "Atlassian account settings"
    },
    accountSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.account-settings-description",
        "defaultMessage": "Manage your language, time zone, and other profile information."
    },
    personalJiraSettings: {
        "id": "atlassian-navigation.settings.menu.personal.personal-jira-settings",
        "defaultMessage": "Personal Jira settings"
    },
    personalJiraSettingsDescription: {
        "id": "atlassian-navigation.settings.menu.personal.personal-jira-settings-description",
        "defaultMessage": "Manage your email notifications and other Jira settings."
    },
    // Nav4 Messages
    generalSettingsLabelNonFinal: {
        "id": "atlassian-navigation.settings.menu.personal.general-settings-label-non-final",
        "defaultMessage": "General settings"
    },
    generalSettingsDescriptionNonFinal: {
        "id": "atlassian-navigation.settings.menu.personal.general-settings-description-non-final",
        "defaultMessage": "Manage language, time zone, and other personal preferences"
    },
    notificationSettingsLabelNonFinal: {
        "id": "atlassian-navigation.settings.menu.personal.notification-settings-label-non-final",
        "defaultMessage": "Notification settings"
    },
    notificationSettingsDescriptionNonFinal: {
        "id": "atlassian-navigation.settings.menu.personal.notification-settings-description-non-final",
        "defaultMessage": "Manage email and in-product notifications from Jira"
    }
});

});


parcelRegister("eeaSV", function(module, exports) {

$parcel$export(module.exports, "Warning", () => $3f9ae69911cb5ed8$export$c688898c4e3580ee);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5OdZ3 = parcelRequire("5OdZ3");

var $8BKky = parcelRequire("8BKky");

var $8uD7Y = parcelRequire("8uD7Y");

var $4ksts = parcelRequire("4ksts");

var $1YbJP = parcelRequire("1YbJP");

var $gUs3D = parcelRequire("gUs3D");
const $3f9ae69911cb5ed8$export$c688898c4e3580ee = ({ testIdPrefix: testIdPrefix })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const testId = (0, $1YbJP.testIdConcat)(testIdPrefix, 'warning');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f9ae69911cb5ed8$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $gUs3D.default).noAdminPermissionMessage,
        values: {
            contact: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
                href: "/secure/ContactAdministrators!default.jspa"
            }, formatMessage((0, $gUs3D.default).noAdminPermissionMessageContact))
        }
    })));
};
const $3f9ae69911cb5ed8$export$e6dfd72ab29f8598 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f9ae69911cb5ed8$var$Outer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f9ae69911cb5ed8$var$Inner, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f9ae69911cb5ed8$var$Outer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4ev0u",
            __cmplp.className
        ])
    });
});
const $3f9ae69911cb5ed8$var$Inner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1kdj _bfhk8jms _2rko1l7b _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gUs3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddcf8fe0000ef169$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ddcf8fe0000ef169$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noAdminPermissionMessage: {
        "id": "atlassian-navigation.settings.menu.warning.no-admin-permission-message",
        "defaultMessage": "You do not have access to Jira settings or Atlassian admin, {contact} to grant you access."
    },
    noAdminPermissionMessageContact: {
        "id": "atlassian-navigation.settings.menu.warning.no-admin-permission-message-contact",
        "defaultMessage": "contact your Jira admin"
    }
});

});




parcelRegister("jKLMK", function(module, exports) {

$parcel$export(module.exports, "SignIn", () => $a995f7803ccf1dad$export$b64708c6f1b3ed96);

var $eUqFw = parcelRequire("eUqFw");

var $dxeoe = parcelRequire("dxeoe");

var $8GeQ6 = parcelRequire("8GeQ6");

var $uuI5V = parcelRequire("uuI5V");

var $4ksts = parcelRequire("4ksts");

var $6FP8W = parcelRequire("6FP8W");

var $6yplV = parcelRequire("6yplV");

var $lB25E = parcelRequire("lB25E");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $gvn5f = parcelRequire("gvn5f");

var $arcr2 = parcelRequire("arcr2");

var $aHNCz = parcelRequire("aHNCz");
const $a995f7803ccf1dad$var$SignIn = ({ AkSignIn: AkSignIn = (0, $dxeoe.SignIn), Link: Link = (0, $lB25E.Link), useDestinationParam: useDestinationParam = (0, $aHNCz.useDestinationParam), useIntl: useIntl = (0, $4ksts.useIntlV2), useNavigationItemAnalytics: useNavigationItemAnalytics = (0, $gvn5f.useNavigationItemAnalytics), useIsAnonymous: useIsAnonymous = (0, $6yplV.useIsAnonymous) })=>{
    const destinationParam = useDestinationParam();
    const isAnonymous = useIsAnonymous();
    const { formatMessage: formatMessage } = useIntl();
    const triggerAnalytics = useNavigationItemAnalytics({
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).SIGN_IN
    });
    if (!isAnonymous) return null;
    if ((0, $6FP8W.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8GeQ6.default), {
        href: `/login.jsp?${destinationParam}`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($uuI5V))),
        label: formatMessage((0, $arcr2.default).signIn),
        isTooltipDisabled: false,
        appearance: "subtle",
        // @ts-expect-error - TS2769 - No overload matches this call.
        onClick: triggerAnalytics
    });
    return(// @ts-expect-error - TS2769 - No overload matches this call.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Link, {
        href: `/login.jsp?${destinationParam}`,
        onClick: triggerAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AkSignIn, {
        tooltip: formatMessage((0, $arcr2.default).signIn)
    })));
};
const $a995f7803ccf1dad$export$b64708c6f1b3ed96 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $5kDtB.NAVIGATION_ITEM_ID).SIGN_IN
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a995f7803ccf1dad$var$SignIn, props));

});
parcelRegister("arcr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $02fe0a459af6ff19$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $02fe0a459af6ff19$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    signIn: {
        "id": "atlassian-navigation.sign-in.sign-in",
        "defaultMessage": "Sign in"
    }
});

});

parcelRegister("aHNCz", function(module, exports) {

$parcel$export(module.exports, "useDestinationParam", () => $bb70d82eee9802eb$export$c9c176e0725165cc);

var $3da0c = parcelRequire("3da0c");
const $bb70d82eee9802eb$export$c9c176e0725165cc = ()=>{
    const { href: href = null } = (0, $3da0c.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return `os_destination=${encodedRedirectUrl}`;
    }
    return '';
};

});
parcelRegister("3da0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $156a3428b96ddf9e$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $156a3428b96ddf9e$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});



parcelRegister("8XL09", function(module, exports) {

$parcel$export(module.exports, "YourWorkDropdown", () => $c0e96bcca34c090a$export$3f0b217fc9bdcb2b);

var $eUqFw = parcelRequire("eUqFw");

var $33syn = parcelRequire("33syn");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7vTKl = parcelRequire("7vTKl");

var $dWLk9 = parcelRequire("dWLk9");

var $k7Bof = parcelRequire("k7Bof");

var $5kDtB = parcelRequire("5kDtB");

var $grCEQ = parcelRequire("grCEQ");

var $5H3md = parcelRequire("5H3md");

var $bAd0L = parcelRequire("bAd0L");

var $4S2mM = parcelRequire("4S2mM");

var $6x1nK = parcelRequire("6x1nK");

var $7zthz = parcelRequire("7zthz");
const $c0e96bcca34c090a$var$YourWorkDropdown = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const activityClient = (0, $k7Bof.useActivityClient)('v3', 'jira');
    const cloudId = (0, $dWLk9.useCloudId)();
    if ((0, $1ybV0.ff)('alerts-in-your-work_9l8fa')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $33syn.AlertsStoreContainer), {
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4S2mM.RecentActivityContainer), {
        activityClient: activityClient,
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5H3md.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bAd0L.Popup), {
        menuId: (0, $7vTKl.MENU_ID).HOME,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).HOME,
        Menu: (0, $6x1nK.AsyncMenu),
        label: formatMessage((0, $7zthz.default).title)
    }, formatMessage((0, $7zthz.default).title)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4S2mM.RecentActivityContainer), {
        activityClient: activityClient,
        cloudId: cloudId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5H3md.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bAd0L.Popup), {
        menuId: (0, $7vTKl.MENU_ID).HOME,
        navigationItemId: (0, $5kDtB.NAVIGATION_ITEM_ID).HOME,
        Menu: (0, $6x1nK.AsyncMenu)
    }, formatMessage((0, $7zthz.default).title))));
};
const $c0e96bcca34c090a$export$3f0b217fc9bdcb2b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grCEQ.TopLevelErrorBoundary), {
        id: (0, $7vTKl.MENU_ID).HOME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c0e96bcca34c090a$var$YourWorkDropdown, null));

});
parcelRegister("33syn", function(module, exports) {

$parcel$export(module.exports, "useAlertsStore", () => $a49eb33251e7e88a$export$52a528b1f45cfa42);
$parcel$export(module.exports, "AlertsStoreContainer", () => $a49eb33251e7e88a$export$dac8df4ae2328540);

var $WBLbN = parcelRequire("WBLbN");

var $fciAA = parcelRequire("fciAA");

var $3EEze = parcelRequire("3EEze");
const $a49eb33251e7e88a$export$a2290b0841306a43 = {
    items: null,
    isFetching: false,
    fetchError: null,
    promise: null,
    hasFetchedOnce: false,
    hasSuccessOnce: false,
    totalCount: 0
};
const $a49eb33251e7e88a$export$d4c72bab9d6cc13a = {};
const $a49eb33251e7e88a$var$loadAlerts = ({ searchParams: searchParams, key: key, shouldOverwrite: shouldOverwrite = true })=>async ({ setState: setState, getState: getState }, { cloudId: cloudId })=>{
        if (!cloudId) throw new Error('`cloudId` is required please wrap your component with `AlertsStoreContainer`, and provide the prop.');
        if (!key) throw new Error('`key` is required please provie a unique key for each query.');
        try {
            const promise = (0, $3EEze.fetchAlerts)({
                cloudId: cloudId,
                searchParams: searchParams
            });
            setState({
                ...getState(),
                [key]: {
                    ...$a49eb33251e7e88a$export$a2290b0841306a43,
                    ...getState()[key],
                    isFetching: true,
                    fetchError: null,
                    promise: promise
                }
            });
            const response = await promise;
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const alerts = response?.values ?? null;
            const newItems = shouldOverwrite ? alerts : [
                ...getState()[key]?.items ?? [],
                ...alerts
            ];
            setState({
                ...getState(),
                [key]: {
                    ...getState()[key],
                    items: newItems,
                    totalCount: newItems.length,
                    hasSuccessOnce: true,
                    hasFetchedOnce: true,
                    isFetching: false
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                [key]: {
                    ...$a49eb33251e7e88a$export$a2290b0841306a43,
                    ...getState()[key],
                    fetchError: error,
                    hasFetchedOnce: true,
                    isFetching: false
                }
            });
            throw error;
        }
    };
const $a49eb33251e7e88a$var$removeAlert = ({ alertId: alertId, key: key })=>async ({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            [key]: {
                ...$a49eb33251e7e88a$export$a2290b0841306a43,
                ...getState()[key],
                items: getState()[key]?.items?.filter((alert)=>alert.id !== alertId) ?? []
            }
        });
    };
const $a49eb33251e7e88a$export$e324594224ef24da = {
    loadAlerts: $a49eb33251e7e88a$var$loadAlerts,
    removeAlert: $a49eb33251e7e88a$var$removeAlert
};
const $a49eb33251e7e88a$var$alertsStore = (0, $WBLbN.createStore)({
    name: (0, $fciAA.ALERTS_STORE_NAME),
    actions: $a49eb33251e7e88a$export$e324594224ef24da,
    initialState: $a49eb33251e7e88a$export$d4c72bab9d6cc13a
});
const $a49eb33251e7e88a$export$52a528b1f45cfa42 = (0, $WBLbN.createHook)($a49eb33251e7e88a$var$alertsStore, {
    selector: (state)=>state
});
const $a49eb33251e7e88a$export$dac8df4ae2328540 = (0, $WBLbN.createContainer)($a49eb33251e7e88a$var$alertsStore);

});
parcelRegister("fciAA", function(module, exports) {

$parcel$export(module.exports, "ALERTS_STORE_NAME", () => $cdd2afbeb1eea0fe$export$6793992c0b67d9c9);
$parcel$export(module.exports, "PredefinedQueries", () => $cdd2afbeb1eea0fe$export$ed6721f2880ce367);
const $cdd2afbeb1eea0fe$export$6793992c0b67d9c9 = 'navigation-alerts-store';
const $cdd2afbeb1eea0fe$var$ONLY_MY_SELECTOR_QUERY = '(acknowledgedBy: me OR owner: me OR responders: me)';
const $cdd2afbeb1eea0fe$export$ed6721f2880ce367 = {
    MY_OPEN_ALERTS: `status: open AND acknowledged: false AND snoozed: false AND ${$cdd2afbeb1eea0fe$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_ACKED_ALERTS: `status: open AND acknowledged: true AND ${$cdd2afbeb1eea0fe$var$ONLY_MY_SELECTOR_QUERY}`,
    MY_SNOOZED_ALERTS: `status: open AND acknowledged: false AND snoozed: true AND ${$cdd2afbeb1eea0fe$var$ONLY_MY_SELECTOR_QUERY}`
};

});

parcelRegister("3EEze", function(module, exports) {

$parcel$export(module.exports, "fetchAlerts", () => $f5952ef422336c8b$export$f7b1e2075b3da718);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $3DOEL = parcelRequire("3DOEL");
const $f5952ef422336c8b$export$f7b1e2075b3da718 = async ({ cloudId: cloudId, searchParams: searchParams })=>{
    try {
        const params = new URLSearchParams(searchParams ?? {});
        const result = await (0, $2OdyW.default)(`/gateway/api/jsm/ops/web/${cloudId}/v1/alerts/?${params.toString()}`);
        if (!result) throw Error('Could not retrieve alerts');
        // https://data-portal.internal.atlassian.com/analytics/registry/50237
        (0, $3DOEL.getAnalyticsWebClient)().getInstance().sendOperationalEvent({
            action: 'succeeded',
            actionSubject: 'jiraPlatformServicesAlertsStore.fetchAlerts',
            source: 'alertsStore'
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // https://data-portal.internal.atlassian.com/analytics/registry/50236
        (0, $guiFP.default)({
            meta: {
                id: 'fetchAlerts',
                packageName: 'jiraAlertsStore',
                teamName: 'alexstrasza'
            },
            attributes: {
                error: error,
                searchParams: searchParams
            },
            error: error
        });
        throw error;
    }
};

});


parcelRegister("4S2mM", function(module, exports) {

$parcel$export(module.exports, "RecentActivityContainer", () => $35e1a47c808397b0$export$7143acbf492040ba);
$parcel$export(module.exports, "useRecentActivities", () => $35e1a47c808397b0$export$623d449f25492804);
$parcel$export(module.exports, "useRecentActivitiesActions", () => $35e1a47c808397b0$export$394af696e502ba5d);

var $WBLbN = parcelRequire("WBLbN");

var $bVPuU = parcelRequire("bVPuU");
const $35e1a47c808397b0$var$initialState = {
    items: null,
    fetchError: null,
    hasSuccessOnce: false,
    isFetching: false,
    promise: null
};
const $35e1a47c808397b0$var$store = (0, $WBLbN.createStore)({
    actions: $bVPuU.actions,
    initialState: $35e1a47c808397b0$var$initialState,
    name: 'navigation-your-work-recent-activites'
});
const $35e1a47c808397b0$export$7143acbf492040ba = (0, $WBLbN.createContainer)($35e1a47c808397b0$var$store);
const $35e1a47c808397b0$export$623d449f25492804 = (0, $WBLbN.createHook)($35e1a47c808397b0$var$store);
const $35e1a47c808397b0$export$394af696e502ba5d = (0, $WBLbN.createHook)($35e1a47c808397b0$var$store, {
    selector: null
});

});
parcelRegister("bVPuU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b4373769bc9ce141$export$e324594224ef24da);

var $eI5EY = parcelRequire("eI5EY");
const $b4373769bc9ce141$var$PRODUCTS = [
    'jira'
];
const $b4373769bc9ce141$var$loadRecentActivities = ()=>async ({ setState: setState }, meta)=>{
        setState({
            isFetching: true,
            fetchError: null
        });
        try {
            const filter = (0, $eI5EY.fg)('blu-3344-worked-on-menu-fix') ? {
                limit: 10,
                rootContainerIds: [
                    `ari:cloud:platform::site/${meta.cloudId}`
                ],
                products: $b4373769bc9ce141$var$PRODUCTS
            } : {
                limit: 10,
                rootContainerIds: [
                    `ari:cloud:platform::site/${meta.cloudId}`
                ],
                objectTypes: [
                    'issue'
                ],
                products: $b4373769bc9ce141$var$PRODUCTS
            };
            const promise = meta.activityClient.fetchActivities([
                50,
                125,
                250
            ], filter, [
                'workedOn'
            ]);
            setState({
                promise: promise
            });
            const activityItems = await promise;
            setState({
                hasSuccessOnce: true,
                items: activityItems,
                isFetching: false
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetching: false,
                fetchError: error
            });
        }
    };
const $b4373769bc9ce141$export$e324594224ef24da = {
    loadRecentActivities: $b4373769bc9ce141$var$loadRecentActivities
};

});


parcelRegister("6x1nK", function(module, exports) {

$parcel$export(module.exports, "AsyncMenu", () => $b047ff8e3440da0b$export$81adf29ff528dc9c);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $5kDtB = parcelRequire("5kDtB");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b047ff8e3440da0b$var$LazyMenu = (0, $7rh0R.lazy)(()=>(parcelRequire("gBiUS")).then(({ Menu: Menu })=>Menu), {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/your-work-dropdown/menu/index.tsx"
});
const $b047ff8e3440da0b$export$81adf29ff528dc9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "your-work-dropdown-menu",
        packageName: (0, $5kDtB.PACKAGE_NAME),
        teamName: "navigation",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "your-work-dropdown-menu",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b047ff8e3440da0b$var$LazyMenu, null)));

});
parcelRegister("gBiUS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("2d3kF")
]).then(()=>parcelRequire('8RIAJ'));

});


parcelRegister("7zthz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ee246620958b69$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c2ee246620958b69$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "atlassian-navigation.your-work-dropdown.title",
        "defaultMessage": "Your work"
    }
});

});



// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


//# sourceMappingURL=async-atlassian-navigation.14a22737.js.map
